
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7ea7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7ea7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});
parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRegister("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});

parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("R5nvG", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};

$parcel$export($7e96a608cb33bf79$exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
$parcel$export($7e96a608cb33bf79$exports, "hydrateRoot", () => $7e96a608cb33bf79$export$757ceba2d55c277e, (v) => $7e96a608cb33bf79$export$757ceba2d55c277e = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


/**
 * React Router DOM v6.21.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.21.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



parcelRequire("acw62");

const $ed3c4341f3b46b4a$var$App = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "homePage",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "companyName",
                    children: "Fluid Pass"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: "/events",
                    className: "homeButton",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "custom-btn btn-16 homeButton",
                        children: "Explore Compensations"
                    })
                })
            ]
        })
    });
};
var $ed3c4341f3b46b4a$export$2e2bcd8739ae039 = $ed3c4341f3b46b4a$var$App;



parcelRequire("acw62");


var $e4a8b38104740ea3$exports = {};
$e4a8b38104740ea3$exports = new URL("fluidpasslogo.39e9225e.png", import.meta.url).toString();


const $17c508ec2a7550ef$var$Logo = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "logoContainer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            className: "logoImg",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($e4a8b38104740ea3$exports))),
            alt: "Fluid Pass Logo"
        })
    });
};
var $17c508ec2a7550ef$export$2e2bcd8739ae039 = $17c508ec2a7550ef$var$Logo;




const $b7cbd75a73c77856$var$NavBar = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
        className: "navBar",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
            className: "navBarList",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: "Home"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/events",
                        children: "Events"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/registerevent",
                        children: "Submit Event"
                    })
                })
            ]
        })
    });
};
var $b7cbd75a73c77856$export$2e2bcd8739ae039 = $b7cbd75a73c77856$var$NavBar;


const $2b15df6adfa52e3f$var$Header = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
        className: "headerSection",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17c508ec2a7550ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7cbd75a73c77856$export$2e2bcd8739ae039), {})
        ]
    });
};
var $2b15df6adfa52e3f$export$2e2bcd8739ae039 = $2b15df6adfa52e3f$var$Header;




var $acw62 = parcelRequire("acw62");
var $6c57cc56acea9c6c$exports = {};

$parcel$export($6c57cc56acea9c6c$exports, "logger", () => $6c57cc56acea9c6c$export$af88d00dbe7f521);
$parcel$export($6c57cc56acea9c6c$exports, "Signer", () => $deb85df20e19ba32$export$fdf54fdde81cc9f0);
$parcel$export($6c57cc56acea9c6c$exports, "Wallet", () => $3ff70163f9f2ebd5$export$bcca3ea514774656);
$parcel$export($6c57cc56acea9c6c$exports, "VoidSigner", () => $deb85df20e19ba32$export$7dbc56d9b9612bad);
$parcel$export($6c57cc56acea9c6c$exports, "getDefaultProvider", () => $859153647bbc688f$export$4f77a1d3c1ac6642);
$parcel$export($6c57cc56acea9c6c$exports, "providers", () => $859153647bbc688f$exports);
$parcel$export($6c57cc56acea9c6c$exports, "BaseContract", () => $b84bae218d85c3ca$export$304faa4fc17528db);
$parcel$export($6c57cc56acea9c6c$exports, "Contract", () => $b84bae218d85c3ca$export$8517d80acf00e19a);
$parcel$export($6c57cc56acea9c6c$exports, "ContractFactory", () => $b84bae218d85c3ca$export$505569a6bf584fd9);
$parcel$export($6c57cc56acea9c6c$exports, "BigNumber", () => $0df4577496dcf693$export$d97aa349ed20696);
$parcel$export($6c57cc56acea9c6c$exports, "FixedNumber", () => $bdc30db990c4b693$export$d4693c66c2213e45);
$parcel$export($6c57cc56acea9c6c$exports, "constants", () => $4c29a01839587aec$exports);
$parcel$export($6c57cc56acea9c6c$exports, "errors", () => $97a8d5981d597bb7$export$d4e71bc0b80dc0fb);
$parcel$export($6c57cc56acea9c6c$exports, "utils", () => $0e788201f8a90b1e$exports);
$parcel$export($6c57cc56acea9c6c$exports, "wordlists", () => $c98b8711de347986$export$e8e1b4711c2d1939);
$parcel$export($6c57cc56acea9c6c$exports, "version", () => $9f7bf65ddafc81a6$export$83d89fbfd8236492);
$parcel$export($6c57cc56acea9c6c$exports, "Wordlist", () => $1aa3df27db978ea8$export$4d9531a8ddb0ebca);
const $4b9cd088fca23de9$export$83d89fbfd8236492 = "logger/5.7.0";


"use strict";
let $97a8d5981d597bb7$var$_permanentCensorErrors = false;
let $97a8d5981d597bb7$var$_censorErrors = false;
const $97a8d5981d597bb7$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $97a8d5981d597bb7$var$_logLevel = $97a8d5981d597bb7$var$LogLevels["default"];
let $97a8d5981d597bb7$var$_globalLogger = null;
function $97a8d5981d597bb7$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $97a8d5981d597bb7$var$_normalizeError = $97a8d5981d597bb7$var$_checkNormalize();
var $97a8d5981d597bb7$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($97a8d5981d597bb7$export$243e62d78d3b544d || ($97a8d5981d597bb7$export$243e62d78d3b544d = {}));
var $97a8d5981d597bb7$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($97a8d5981d597bb7$export$d4e71bc0b80dc0fb || ($97a8d5981d597bb7$export$d4e71bc0b80dc0fb = {}));
const $97a8d5981d597bb7$var$HEX = "0123456789abcdef";
class $97a8d5981d597bb7$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($97a8d5981d597bb7$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($97a8d5981d597bb7$var$_logLevel > $97a8d5981d597bb7$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($97a8d5981d597bb7$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $97a8d5981d597bb7$var$HEX[value[i] >> 4];
                        hex += $97a8d5981d597bb7$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($97a8d5981d597bb7$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $97a8d5981d597bb7$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$97a8d5981d597bb7$var$_globalLogger) $97a8d5981d597bb7$var$_globalLogger = new $97a8d5981d597bb7$export$efa9a398d6368992((0, $4b9cd088fca23de9$export$83d89fbfd8236492));
        return $97a8d5981d597bb7$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($97a8d5981d597bb7$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $97a8d5981d597bb7$var$_censorErrors = !!censorship;
        $97a8d5981d597bb7$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $97a8d5981d597bb7$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $97a8d5981d597bb7$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $97a8d5981d597bb7$var$_logLevel = level;
    }
    static from(version) {
        return new $97a8d5981d597bb7$export$efa9a398d6368992(version);
    }
}
$97a8d5981d597bb7$export$efa9a398d6368992.errors = $97a8d5981d597bb7$export$d4e71bc0b80dc0fb;
$97a8d5981d597bb7$export$efa9a398d6368992.levels = $97a8d5981d597bb7$export$243e62d78d3b544d;


const $95fe903f324809f2$export$83d89fbfd8236492 = "bytes/5.7.0";


"use strict";
const $7b88b6e03e4708f2$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $95fe903f324809f2$export$83d89fbfd8236492));
///////////////////////////////
function $7b88b6e03e4708f2$var$isHexable(value) {
    return !!value.toHexString;
}
function $7b88b6e03e4708f2$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $7b88b6e03e4708f2$export$9a14abb1a440cd5e(value) {
    return $7b88b6e03e4708f2$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $7b88b6e03e4708f2$export$c6fabfbfd097fc30(value);
}
function $7b88b6e03e4708f2$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $7b88b6e03e4708f2$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$7b88b6e03e4708f2$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$7b88b6e03e4708f2$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $7b88b6e03e4708f2$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $7b88b6e03e4708f2$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($7b88b6e03e4708f2$var$isHexable(value)) value = value.toHexString();
    if ($7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(result));
    }
    if ($7b88b6e03e4708f2$export$c6fabfbfd097fc30(value)) return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(value));
    return $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $7b88b6e03e4708f2$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$7b88b6e03e4708f2$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $7b88b6e03e4708f2$var$addSlice(result);
}
function $7b88b6e03e4708f2$export$a8f4574d0e56446c(value) {
    let result = $7b88b6e03e4708f2$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d(value, length) {
    value = $7b88b6e03e4708f2$export$3131421a7d01b4fb(value);
    if (value.length > length) $7b88b6e03e4708f2$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $7b88b6e03e4708f2$var$addSlice(result);
}
function $7b88b6e03e4708f2$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $7b88b6e03e4708f2$var$HexCharacters = "0123456789abcdef";
function $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $7b88b6e03e4708f2$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $7b88b6e03e4708f2$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($7b88b6e03e4708f2$var$isHexable(value)) return value.toHexString();
    if ($7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($7b88b6e03e4708f2$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $7b88b6e03e4708f2$var$HexCharacters[(v & 0xf0) >> 4] + $7b88b6e03e4708f2$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $7b88b6e03e4708f2$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(data);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $7b88b6e03e4708f2$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(data);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(data) || data.length % 2) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $7b88b6e03e4708f2$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $7b88b6e03e4708f2$export$6916af760a341dd3(value) {
    const trimmed = $7b88b6e03e4708f2$export$967bc0082a978949($7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $7b88b6e03e4708f2$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value);
    if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $7b88b6e03e4708f2$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $7b88b6e03e4708f2$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $7b88b6e03e4708f2$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($7b88b6e03e4708f2$export$9a14abb1a440cd5e(signature)) {
        let bytes = $7b88b6e03e4708f2$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d($7b88b6e03e4708f2$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result.r)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result.s)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result.s, 32);
        const vs = $7b88b6e03e4708f2$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result._vs)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $7b88b6e03e4708f2$export$71bb9d78a59bbe25(signature) {
    signature = $7b88b6e03e4708f2$export$7fb170f1e457988f(signature);
    return $7b88b6e03e4708f2$export$2b0d6b5fbe698c70($7b88b6e03e4708f2$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}



var $dEXSZ = parcelRequire("dEXSZ");


const $a38aef31efdfa85e$export$83d89fbfd8236492 = "bignumber/5.7.0";


"use strict";
var $0df4577496dcf693$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).BN;
const $0df4577496dcf693$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $a38aef31efdfa85e$export$83d89fbfd8236492));
const $0df4577496dcf693$var$_constructorGuard = {};
const $0df4577496dcf693$var$MAX_SAFE = 0x1fffffffffffff;
function $0df4577496dcf693$export$a3d0a7fa9b65683b(value) {
    return value != null && ($0df4577496dcf693$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value) || typeof value === "bigint" || (0, $7b88b6e03e4708f2$export$c6fabfbfd097fc30)(value));
}
// Only warn about passing 10 into radix once
let $0df4577496dcf693$var$_warnedToStringRadix = false;
class $0df4577496dcf693$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $0df4577496dcf693$var$_constructorGuard) $0df4577496dcf693$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $0df4577496dcf693$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).add($0df4577496dcf693$var$toBN(other)));
    }
    sub(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).sub($0df4577496dcf693$var$toBN(other)));
    }
    div(other) {
        const o = $0df4577496dcf693$export$d97aa349ed20696.from(other);
        if (o.isZero()) $0df4577496dcf693$var$throwFault("division-by-zero", "div");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).div($0df4577496dcf693$var$toBN(other)));
    }
    mul(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).mul($0df4577496dcf693$var$toBN(other)));
    }
    mod(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (value.isNeg()) $0df4577496dcf693$var$throwFault("division-by-zero", "mod");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (value.isNeg()) $0df4577496dcf693$var$throwFault("negative-power", "pow");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("unbound-bitwise-result", "and");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).and(value));
    }
    or(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("unbound-bitwise-result", "or");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("unbound-bitwise-result", "xor");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("negative-width", "mask");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("negative-width", "shl");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("negative-width", "shr");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $0df4577496dcf693$var$toBN(this).eq($0df4577496dcf693$var$toBN(other));
    }
    lt(other) {
        return $0df4577496dcf693$var$toBN(this).lt($0df4577496dcf693$var$toBN(other));
    }
    lte(other) {
        return $0df4577496dcf693$var$toBN(this).lte($0df4577496dcf693$var$toBN(other));
    }
    gt(other) {
        return $0df4577496dcf693$var$toBN(this).gt($0df4577496dcf693$var$toBN(other));
    }
    gte(other) {
        return $0df4577496dcf693$var$toBN(this).gte($0df4577496dcf693$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $0df4577496dcf693$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $0df4577496dcf693$var$toBN(this).toNumber();
        } catch (error) {
            $0df4577496dcf693$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $0df4577496dcf693$var$logger.throwError("this platform does not support BigInt", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$0df4577496dcf693$var$_warnedToStringRadix) {
                    $0df4577496dcf693$var$_warnedToStringRadix = true;
                    $0df4577496dcf693$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $0df4577496dcf693$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
            else $0df4577496dcf693$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $0df4577496dcf693$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $0df4577496dcf693$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $0df4577496dcf693$export$d97aa349ed20696($0df4577496dcf693$var$_constructorGuard, $0df4577496dcf693$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $0df4577496dcf693$export$d97aa349ed20696($0df4577496dcf693$var$_constructorGuard, $0df4577496dcf693$var$toHex(new $0df4577496dcf693$var$BN(value)));
            return $0df4577496dcf693$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $0df4577496dcf693$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $0df4577496dcf693$var$MAX_SAFE || value <= -$0df4577496dcf693$var$MAX_SAFE) $0df4577496dcf693$var$throwFault("overflow", "BigNumber.from", value);
            return $0df4577496dcf693$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $0df4577496dcf693$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $7b88b6e03e4708f2$export$c6fabfbfd097fc30)(anyValue)) return $0df4577496dcf693$export$d97aa349ed20696.from((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $0df4577496dcf693$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(hex) || hex[0] === "-" && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(hex.substring(1))) return $0df4577496dcf693$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $0df4577496dcf693$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $0df4577496dcf693$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $0df4577496dcf693$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $0df4577496dcf693$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $0df4577496dcf693$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $0df4577496dcf693$var$toBigNumber(value) {
    return $0df4577496dcf693$export$d97aa349ed20696.from($0df4577496dcf693$var$toHex(value));
}
function $0df4577496dcf693$var$toBN(value) {
    const hex = $0df4577496dcf693$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $0df4577496dcf693$var$BN("-" + hex.substring(3), 16);
    return new $0df4577496dcf693$var$BN(hex.substring(2), 16);
}
function $0df4577496dcf693$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $0df4577496dcf693$var$logger.throwError(fault, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
function $0df4577496dcf693$export$51e4a08295f7770f(value) {
    return new $0df4577496dcf693$var$BN(value, 36).toString(16);
}
function $0df4577496dcf693$export$1293db5d29c264ff(value) {
    return new $0df4577496dcf693$var$BN(value, 16).toString(36);
}



const $ec235c03b0398629$export$83d89fbfd8236492 = "properties/5.7.0";


"use strict";
var $a463a6b5f08d6875$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $a463a6b5f08d6875$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $ec235c03b0398629$export$83d89fbfd8236492));
function $a463a6b5f08d6875$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $a463a6b5f08d6875$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $a463a6b5f08d6875$export$d503dd157d963b60(object) {
    return $a463a6b5f08d6875$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $a463a6b5f08d6875$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $a463a6b5f08d6875$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $a463a6b5f08d6875$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $a463a6b5f08d6875$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $a463a6b5f08d6875$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $a463a6b5f08d6875$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $a463a6b5f08d6875$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$a463a6b5f08d6875$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $a463a6b5f08d6875$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $a463a6b5f08d6875$var$_deepCopy(object) {
    if ($a463a6b5f08d6875$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$a463a6b5f08d6875$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $a463a6b5f08d6875$export$104236534534f9be(result, key, $a463a6b5f08d6875$export$6c40052bed430212(value));
        }
        return result;
    }
    return $a463a6b5f08d6875$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $a463a6b5f08d6875$export$6c40052bed430212(object) {
    return $a463a6b5f08d6875$var$_deepCopy(object);
}
class $a463a6b5f08d6875$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $a463a6b5f08d6875$export$6c40052bed430212(info[key]);
    }
}



const $7b99b6039539a6c4$export$83d89fbfd8236492 = "abi/5.7.0";


"use strict";
const $2c0f0ed4c5bed241$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
function $2c0f0ed4c5bed241$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $2c0f0ed4c5bed241$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $2c0f0ed4c5bed241$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $2c0f0ed4c5bed241$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $0df4577496dcf693$export$d97aa349ed20696).from(value));
        if (bytes.length > this.wordSize) $2c0f0ed4c5bed241$var$logger.throwError("value out-of-bounds", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $2c0f0ed4c5bed241$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_data", (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "wordSize", wordSize || 32);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_coerceFunc", coerceFunc);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $2c0f0ed4c5bed241$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $2c0f0ed4c5bed241$var$logger.throwError("data out-of-bounds", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $2c0f0ed4c5bed241$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $0df4577496dcf693$export$d97aa349ed20696).from(this.readBytes(this.wordSize));
    }
}



var $140ac3b566c7a94d$exports = {};
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $cfae44f0dfdf62c0$exports === "object" && $cfae44f0dfdf62c0$exports.versions && $cfae44f0dfdf62c0$exports.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && $140ac3b566c7a94d$exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) $140ac3b566c7a94d$exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();



"use strict";
function $1dbc6131e27af3ca$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($140ac3b566c7a94d$exports))).keccak_256((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data));
}


var $6ff2d0f6bfa15181$exports = {};

$parcel$export($6ff2d0f6bfa15181$exports, "encode", () => $6ff2d0f6bfa15181$export$c564cdbbe6da493);
$parcel$export($6ff2d0f6bfa15181$exports, "decode", () => $6ff2d0f6bfa15181$export$2f872c0f2117be69);


const $82765913239667f9$export$83d89fbfd8236492 = "rlp/5.7.0";


"use strict";
const $6ff2d0f6bfa15181$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $82765913239667f9$export$83d89fbfd8236492));
function $6ff2d0f6bfa15181$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $6ff2d0f6bfa15181$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($6ff2d0f6bfa15181$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $6ff2d0f6bfa15181$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $7b88b6e03e4708f2$export$9a14abb1a440cd5e)(object)) $6ff2d0f6bfa15181$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $6ff2d0f6bfa15181$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $6ff2d0f6bfa15181$export$c564cdbbe6da493(object) {
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)($6ff2d0f6bfa15181$var$_encode(object));
}
function $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $6ff2d0f6bfa15181$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $6ff2d0f6bfa15181$var$logger.throwError("child data too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $6ff2d0f6bfa15181$var$_decode(data, offset) {
    if (data.length === 0) $6ff2d0f6bfa15181$var$logger.throwError("data too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data short segment too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data long segment too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data[offset])
    };
}
function $6ff2d0f6bfa15181$export$2f872c0f2117be69(data) {
    const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
    const decoded = $6ff2d0f6bfa15181$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $6ff2d0f6bfa15181$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}



const $f0caac95ce71359f$export$83d89fbfd8236492 = "address/5.7.0";


"use strict";
const $8aee8aee2d40605d$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $f0caac95ce71359f$export$83d89fbfd8236492));
function $8aee8aee2d40605d$var$getChecksumAddress(address) {
    if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(address, 20)) $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $8aee8aee2d40605d$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $8aee8aee2d40605d$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $8aee8aee2d40605d$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$8aee8aee2d40605d$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$8aee8aee2d40605d$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $8aee8aee2d40605d$var$safeDigits = Math.floor($8aee8aee2d40605d$var$log10($8aee8aee2d40605d$var$MAX_SAFE_INTEGER));
function $8aee8aee2d40605d$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $8aee8aee2d40605d$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $8aee8aee2d40605d$var$safeDigits){
        let block = expanded.substring(0, $8aee8aee2d40605d$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $8aee8aee2d40605d$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $8aee8aee2d40605d$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $8aee8aee2d40605d$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $8aee8aee2d40605d$var$ibanChecksum(address)) $8aee8aee2d40605d$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $0df4577496dcf693$export$51e4a08295f7770f)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $8aee8aee2d40605d$var$getChecksumAddress("0x" + result);
    } else $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $8aee8aee2d40605d$export$977e255126d763d6(address) {
    try {
        $8aee8aee2d40605d$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $8aee8aee2d40605d$export$962c4ddada9f668f(address) {
    let base36 = (0, $0df4577496dcf693$export$1293db5d29c264ff)($8aee8aee2d40605d$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $8aee8aee2d40605d$var$ibanChecksum("XE00" + base36) + base36;
}
function $8aee8aee2d40605d$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $8aee8aee2d40605d$export$88411125f012957a(transaction.from);
    } catch (error) {
        $8aee8aee2d40605d$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction.nonce).toHexString()));
    return $8aee8aee2d40605d$export$88411125f012957a((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $6ff2d0f6bfa15181$export$c564cdbbe6da493)([
        from,
        nonce
    ])), 12));
}
function $8aee8aee2d40605d$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(salt) !== 32) $8aee8aee2d40605d$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(initCodeHash) !== 32) $8aee8aee2d40605d$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $8aee8aee2d40605d$export$88411125f012957a((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        "0xff",
        $8aee8aee2d40605d$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}







const $f9bb23bb4b058849$export$83d89fbfd8236492 = "strings/5.7.0";


"use strict";
const $b2a54ce293d87a2e$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $f9bb23bb4b058849$export$83d89fbfd8236492));
var $b2a54ce293d87a2e$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($b2a54ce293d87a2e$export$c6986442964129f5 || ($b2a54ce293d87a2e$export$c6986442964129f5 = {}));
var $b2a54ce293d87a2e$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($b2a54ce293d87a2e$export$c285fa6ac15ff6a6 || ($b2a54ce293d87a2e$export$c285fa6ac15ff6a6 = {}));
function $b2a54ce293d87a2e$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $b2a54ce293d87a2e$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $b2a54ce293d87a2e$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $b2a54ce293d87a2e$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $b2a54ce293d87a2e$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $b2a54ce293d87a2e$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $b2a54ce293d87a2e$var$errorFunc,
    ignore: $b2a54ce293d87a2e$var$ignoreFunc,
    replace: $b2a54ce293d87a2e$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $b2a54ce293d87a2e$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $b2a54ce293d87a2e$export$c6e2180c5bb5bc05.error;
    bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $b2a54ce293d87a2e$export$8feeb310b4b4752f(str, form = $b2a54ce293d87a2e$export$c6986442964129f5.current) {
    if (form != $b2a54ce293d87a2e$export$c6986442964129f5.current) {
        $b2a54ce293d87a2e$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(result);
}
function $b2a54ce293d87a2e$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $b2a54ce293d87a2e$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $b2a54ce293d87a2e$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $b2a54ce293d87a2e$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $b2a54ce293d87a2e$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $b2a54ce293d87a2e$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $b2a54ce293d87a2e$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $b2a54ce293d87a2e$export$7643a1dc2c38d5eb(bytes, onError) {
    return $b2a54ce293d87a2e$export$232e1dab03132235($b2a54ce293d87a2e$var$getUtf8CodePoints(bytes, onError));
}
function $b2a54ce293d87a2e$export$ae470a36a31b28c2(str, form = $b2a54ce293d87a2e$export$c6986442964129f5.current) {
    return $b2a54ce293d87a2e$var$getUtf8CodePoints($b2a54ce293d87a2e$export$8feeb310b4b4752f(str, form));
}


function $7cd0a9996bd6b341$export$d560c7e4a29451c2(text) {
    return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(text));
}












"use strict";
class $22f6893c208a0a4e$export$59dbbded7775bfe7 extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $8aee8aee2d40605d$export$88411125f012957a)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $8aee8aee2d40605d$export$88411125f012957a)((0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(reader.readValue().toHexString(), 20));
    }
}






"use strict";
class $3a25498c1332da4a$export$87c41d1139a03fa2 extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}


"use strict";
const $a30effb870f18115$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
function $a30effb870f18115$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $a30effb870f18115$var$logger.throwError("cannot encode object for signature with missing names", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $a30effb870f18115$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $a30effb870f18115$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $a30effb870f18115$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $2c0f0ed4c5bed241$export$d7a960146e1a269e)(writer.wordSize);
    let dynamicWriter = new (0, $2c0f0ed4c5bed241$export$d7a960146e1a269e)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $a30effb870f18115$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $a30effb870f18115$export$88bc419d2df11f54 extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $a30effb870f18115$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $a30effb870f18115$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $a30effb870f18115$var$logger.throwError("insufficient data length", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $3a25498c1332da4a$export$87c41d1139a03fa2)(this.coder));
        return reader.coerce(this.name, $a30effb870f18115$export$417857010dc9287f(reader, coders));
    }
}



"use strict";
class $394fcd7db865fb3c$export$fe9118d6c093150c extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}




"use strict";
class $6e254db4e73082b7$export$db9eadd8df12ad2e extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $6e254db4e73082b7$export$e5823e9574df18d2 extends $6e254db4e73082b7$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(super.decode(reader)));
    }
}




"use strict";
class $9c7ee045e883fffe$export$7dec9db68e6bcf5a extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(reader.readBytes(this.size)));
    }
}



"use strict";
class $8815781d2f2dcc92$export$70982cadf2d6b4ec extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}




const $c5333cf79421e056$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(-1);
const $c5333cf79421e056$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(0);
const $c5333cf79421e056$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(1);
const $c5333cf79421e056$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(2);
const $c5333cf79421e056$export$c8db55bd7405209e = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("1000000000000000000");
const $c5333cf79421e056$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $c5333cf79421e056$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $c5333cf79421e056$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");



"use strict";
class $f9cce4408e3f228e$export$b934dc8cfe13938c extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $c5333cf79421e056$export$1b53890de5aabdd0).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $c5333cf79421e056$export$9aa05a5866350bcf)).mul((0, $c5333cf79421e056$export$c83ef0909a6ddeec)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $c5333cf79421e056$export$aaef8a3eae948f03)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}




"use strict";
class $90994e88a8e0b05b$export$2d1b854518731426 extends (0, $6e254db4e73082b7$export$db9eadd8df12ad2e) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(value));
    }
    decode(reader) {
        return (0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
}




"use strict";
class $c633d82d9fdfc710$export$e9fceba8f110fea6 extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $a30effb870f18115$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $a30effb870f18115$export$417857010dc9287f)(reader, this.coders));
    }
}






"use strict";
const $871a765ee5e657d2$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
const $871a765ee5e657d2$var$_constructorGuard = {};
let $871a765ee5e657d2$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $871a765ee5e657d2$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $871a765ee5e657d2$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($871a765ee5e657d2$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($871a765ee5e657d2$var$ModifiersNest[name]) return true;
    }
    if ($871a765ee5e657d2$var$ModifiersBytes[name] || name === "payable") $871a765ee5e657d2$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $871a765ee5e657d2$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $871a765ee5e657d2$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $871a765ee5e657d2$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($871a765ee5e657d2$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $871a765ee5e657d2$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($871a765ee5e657d2$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $871a765ee5e657d2$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $871a765ee5e657d2$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($871a765ee5e657d2$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $871a765ee5e657d2$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($871a765ee5e657d2$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $871a765ee5e657d2$var$verifyType(parent.type);
    return parent;
}
function $871a765ee5e657d2$var$populate(object, params) {
    for(let key in params)(0, $a463a6b5f08d6875$export$104236534534f9be)(object, key, params[key]);
}
const $871a765ee5e657d2$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $871a765ee5e657d2$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $871a765ee5e657d2$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $871a765ee5e657d2$var$_constructorGuard) $871a765ee5e657d2$var$logger.throwError("use fromString", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $871a765ee5e657d2$var$populate(this, params);
        let match = this.type.match($871a765ee5e657d2$var$paramTypeArray);
        if (match) $871a765ee5e657d2$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $871a765ee5e657d2$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $871a765ee5e657d2$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $871a765ee5e657d2$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $871a765ee5e657d2$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $871a765ee5e657d2$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $871a765ee5e657d2$export$426dc07f493a4c47($871a765ee5e657d2$var$_constructorGuard, {
            name: value.name || null,
            type: $871a765ee5e657d2$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $871a765ee5e657d2$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($871a765ee5e657d2$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $871a765ee5e657d2$var$parseParams(value, allowIndex) {
    return $871a765ee5e657d2$var$splitNesting(value).map((param)=>$871a765ee5e657d2$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $871a765ee5e657d2$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $871a765ee5e657d2$var$_constructorGuard) $871a765ee5e657d2$var$logger.throwError("use a static from method", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $871a765ee5e657d2$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($871a765ee5e657d2$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $871a765ee5e657d2$export$ffb0004e005737fa.fromString(value);
        return $871a765ee5e657d2$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $871a765ee5e657d2$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $871a765ee5e657d2$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $871a765ee5e657d2$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $871a765ee5e657d2$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $871a765ee5e657d2$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $871a765ee5e657d2$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $871a765ee5e657d2$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $871a765ee5e657d2$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $871a765ee5e657d2$export$958548f08bac2833 extends $871a765ee5e657d2$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $871a765ee5e657d2$export$958548f08bac2833.fromString(value);
        return $871a765ee5e657d2$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $871a765ee5e657d2$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $871a765ee5e657d2$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $871a765ee5e657d2$export$958548f08bac2833($871a765ee5e657d2$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($871a765ee5e657d2$var$regexParen);
        if (!match) $871a765ee5e657d2$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $871a765ee5e657d2$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $871a765ee5e657d2$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $871a765ee5e657d2$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $871a765ee5e657d2$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $871a765ee5e657d2$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $871a765ee5e657d2$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $0df4577496dcf693$export$d97aa349ed20696).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $871a765ee5e657d2$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $871a765ee5e657d2$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $871a765ee5e657d2$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $871a765ee5e657d2$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $871a765ee5e657d2$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $871a765ee5e657d2$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $871a765ee5e657d2$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $871a765ee5e657d2$export$3ac5c9504f801ea4 extends $871a765ee5e657d2$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.sighash) $871a765ee5e657d2$var$logger.throwError("cannot format a constructor for sighash", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromString(value);
        return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $871a765ee5e657d2$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $871a765ee5e657d2$var$verifyState(value);
        if (state.constant) $871a765ee5e657d2$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $0df4577496dcf693$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $871a765ee5e657d2$export$3ac5c9504f801ea4($871a765ee5e657d2$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $871a765ee5e657d2$var$parseGas(value, params);
        let parens = value.match($871a765ee5e657d2$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $871a765ee5e657d2$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $871a765ee5e657d2$var$parseParams(parens[2].trim(), false);
        $871a765ee5e657d2$var$parseModifiers(parens[3].trim(), params);
        return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $871a765ee5e657d2$export$8d576c928b93668f extends $871a765ee5e657d2$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $871a765ee5e657d2$export$8d576c928b93668f.fromString(value);
        return $871a765ee5e657d2$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $871a765ee5e657d2$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $871a765ee5e657d2$var$verifyState(value);
        const params = {
            type: value.type,
            name: $871a765ee5e657d2$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $0df4577496dcf693$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $871a765ee5e657d2$export$8d576c928b93668f($871a765ee5e657d2$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $871a765ee5e657d2$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $871a765ee5e657d2$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($871a765ee5e657d2$var$regexParen);
        if (!parens) $871a765ee5e657d2$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $871a765ee5e657d2$var$verifyIdentifier(params.name);
        params.inputs = $871a765ee5e657d2$var$parseParams(parens[2], false);
        $871a765ee5e657d2$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($871a765ee5e657d2$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $871a765ee5e657d2$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $871a765ee5e657d2$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $871a765ee5e657d2$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $871a765ee5e657d2$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $871a765ee5e657d2$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $871a765ee5e657d2$export$2c42c6d543aa9b59 extends $871a765ee5e657d2$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $871a765ee5e657d2$export$2c42c6d543aa9b59.fromString(value);
        return $871a765ee5e657d2$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $871a765ee5e657d2$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $871a765ee5e657d2$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : []
        };
        return $871a765ee5e657d2$var$checkForbidden(new $871a765ee5e657d2$export$2c42c6d543aa9b59($871a765ee5e657d2$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($871a765ee5e657d2$var$regexParen);
        if (!parens) $871a765ee5e657d2$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $871a765ee5e657d2$var$verifyIdentifier(params.name);
        params.inputs = $871a765ee5e657d2$var$parseParams(parens[2], false);
        return $871a765ee5e657d2$var$checkForbidden($871a765ee5e657d2$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $871a765ee5e657d2$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $871a765ee5e657d2$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $871a765ee5e657d2$var$verifyIdentifier(value) {
    if (!value || !value.match($871a765ee5e657d2$var$regexIdentifier)) $871a765ee5e657d2$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $871a765ee5e657d2$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $871a765ee5e657d2$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $871a765ee5e657d2$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}


"use strict";
const $2f97e4c6f3904f5b$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
const $2f97e4c6f3904f5b$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $2f97e4c6f3904f5b$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $2f97e4c6f3904f5b$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $22f6893c208a0a4e$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $394fcd7db865fb3c$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $90994e88a8e0b05b$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $6e254db4e73082b7$export$e5823e9574df18d2)(param.name);
            case "array":
                return new (0, $a30effb870f18115$export$88bc419d2df11f54)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $c633d82d9fdfc710$export$e9fceba8f110fea6)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $8815781d2f2dcc92$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($2f97e4c6f3904f5b$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $2f97e4c6f3904f5b$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $f9cce4408e3f228e$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($2f97e4c6f3904f5b$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $2f97e4c6f3904f5b$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $9c7ee045e883fffe$export$7dec9db68e6bcf5a)(size, param.name);
        }
        return $2f97e4c6f3904f5b$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $2c0f0ed4c5bed241$export$2f7a2f0e90c07dc4)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $2c0f0ed4c5bed241$export$d7a960146e1a269e)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $871a765ee5e657d2$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $c633d82d9fdfc710$export$e9fceba8f110fea6)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $2f97e4c6f3904f5b$var$logger.throwError("types/values length mismatch", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $871a765ee5e657d2$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $c633d82d9fdfc710$export$e9fceba8f110fea6)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $871a765ee5e657d2$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $c633d82d9fdfc710$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(this._getReader((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data), loose));
    }
}
const $2f97e4c6f3904f5b$export$51d1cfcdb913adff = new $2f97e4c6f3904f5b$export$fe041e1a83d3efc6();






"use strict";
const $ef97d5c3a9a93354$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
class $ef97d5c3a9a93354$export$c2ab6499be98b3c5 extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
}
class $ef97d5c3a9a93354$export$7a3223b0fadb690b extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
}
class $ef97d5c3a9a93354$export$cfba08fc0e40e2ab extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
}
class $ef97d5c3a9a93354$export$8ef99100a3c56f8c extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $ef97d5c3a9a93354$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $ef97d5c3a9a93354$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $ef97d5c3a9a93354$export$48cefb51a4e315b2 {
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "fragments", abi.map((fragment)=>{
            return (0, $871a765ee5e657d2$export$ffb0004e005737fa).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_abiCoder", (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getAbiCoder")());
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "functions", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "errors", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "events", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $ef97d5c3a9a93354$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $ef97d5c3a9a93354$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "deploy", (0, $871a765ee5e657d2$export$3ac5c9504f801ea4).from({
            payable: false,
            type: "constructor"
        }));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $871a765ee5e657d2$export$f010f239efc4d445).full;
        if (format === (0, $871a765ee5e657d2$export$f010f239efc4d445).sighash) $ef97d5c3a9a93354$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $871a765ee5e657d2$export$f010f239efc4d445).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $2f97e4c6f3904f5b$export$51d1cfcdb913adff;
    }
    static getAddress(address) {
        return (0, $8aee8aee2d40605d$export$88411125f012957a)(address);
    }
    static getSighash(fragment) {
        return (0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $ef97d5c3a9a93354$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $871a765ee5e657d2$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $ef97d5c3a9a93354$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $871a765ee5e657d2$export$958548f08bac2833).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $ef97d5c3a9a93354$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $871a765ee5e657d2$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
        if ((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $ef97d5c3a9a93354$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
        if ((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $ef97d5c3a9a93354$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(0, 4));
                    const builtin = $ef97d5c3a9a93354$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return $ef97d5c3a9a93354$var$logger.throwError("call revert exception" + message, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $ef97d5c3a9a93354$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $ef97d5c3a9a93354$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $ef97d5c3a9a93354$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $ef97d5c3a9a93354$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $ef97d5c3a9a93354$var$logger.throwError("fragment/topic mismatch", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $871a765ee5e657d2$export$426dc07f493a4c47).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $ef97d5c3a9a93354$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $ef97d5c3a9a93354$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $ef97d5c3a9a93354$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $ef97d5c3a9a93354$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $ef97d5c3a9a93354$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $ef97d5c3a9a93354$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $ef97d5c3a9a93354$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}






const $794843703201998f$export$83d89fbfd8236492 = "abstract-provider/5.7.0";


"use strict";
var $81658ac0a17fba50$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $81658ac0a17fba50$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $794843703201998f$export$83d89fbfd8236492));
class $81658ac0a17fba50$export$406ece1549ccd00e extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class $81658ac0a17fba50$export$5b2cada8494f9d99 extends $81658ac0a17fba50$export$406ece1549ccd00e {
    constructor(blockHash, expiry){
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(blockHash, 32)) $81658ac0a17fba50$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
}
class $81658ac0a17fba50$export$26bcd61a55716c98 extends $81658ac0a17fba50$export$406ece1549ccd00e {
    constructor(hash, expiry){
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(hash, 32)) $81658ac0a17fba50$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
}
class $81658ac0a17fba50$export$8f8609bfee47c93 extends $81658ac0a17fba50$export$406ece1549ccd00e {
    constructor(beforeHash, afterHash, expiry){
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(beforeHash, 32)) $81658ac0a17fba50$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(afterHash, 32)) $81658ac0a17fba50$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
class $81658ac0a17fba50$export$2881499e37b75b9a {
    constructor(){
        $81658ac0a17fba50$var$logger.checkAbstract(new.target, $81658ac0a17fba50$export$2881499e37b75b9a);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_isProvider", true);
    }
    getFeeData() {
        return $81658ac0a17fba50$var$__awaiter(this, void 0, void 0, function*() {
            const { block: block, gasPrice: gasPrice } = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error)=>{
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                lastBaseFeePerGas = block.baseFeePerGas;
                maxPriorityFeePerGas = (0, $0df4577496dcf693$export$d97aa349ed20696).from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return {
                lastBaseFeePerGas: lastBaseFeePerGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                gasPrice: gasPrice
            };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}




const $1f1ca693564f9708$export$83d89fbfd8236492 = "abstract-signer/5.7.0";


"use strict";
var $deb85df20e19ba32$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $deb85df20e19ba32$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $1f1ca693564f9708$export$83d89fbfd8236492));
const $deb85df20e19ba32$var$allowedTransactionKeys = [
    "accessList",
    "ccipReadEnabled",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
const $deb85df20e19ba32$var$forwardErrors = [
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS,
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NONCE_EXPIRED,
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED
];
class $deb85df20e19ba32$export$fdf54fdde81cc9f0 {
    ///////////////////
    // Sub-classes MUST call super
    constructor(){
        $deb85df20e19ba32$var$logger.checkAbstract(new.target, $deb85df20e19ba32$export$fdf54fdde81cc9f0);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_isSigner", true);
    }
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("estimateGas");
            const tx = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("call");
            const tx = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for(const key in transaction)if ($deb85df20e19ba32$var$allowedTransactionKeys.indexOf(key) === -1) $deb85df20e19ba32$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
        const tx = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(transaction);
        if (tx.from == null) tx.from = this.getAddress();
        else // Make sure any provided address matches this signer
        tx.from = Promise.all([
            Promise.resolve(tx.from),
            this.getAddress()
        ]).then((result)=>{
            if (result[0].toLowerCase() !== result[1].toLowerCase()) $deb85df20e19ba32$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            return result[0];
        });
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            const tx = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to)=>$deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
                        if (to == null) return null;
                        const address = yield this.resolveName(to);
                        if (address == null) $deb85df20e19ba32$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                        return address;
                    }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error)=>{});
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $deb85df20e19ba32$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $deb85df20e19ba32$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            if ((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
            tx.type = 2;
            else if (tx.type === 0 || tx.type === 1) // Explicit Legacy or EIP-2930 transaction
            // Populate missing gasPrice
            {
                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
            } else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        } else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                        }
                    } else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) $deb85df20e19ba32$var$logger.throwError("network does not support EIP-1559", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                            operation: "populateTransaction"
                        });
                        // Populate missing fee data
                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    } else // getFeeData has failed us.
                    $deb85df20e19ba32$var$logger.throwError("failed to get consistent fee data", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: "signer.getFeeData"
                    });
                } else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                }
            }
            if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
            if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch((error)=>{
                if ($deb85df20e19ba32$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                return $deb85df20e19ba32$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
                    error: error,
                    tx: tx
                });
            });
            if (tx.chainId == null) tx.chainId = this.getChainId();
            else tx.chainId = Promise.all([
                Promise.resolve(tx.chainId),
                this.getChainId()
            ]).then((results)=>{
                if (results[1] !== 0 && results[0] !== results[1]) $deb85df20e19ba32$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                return results[0];
            });
            return yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) $deb85df20e19ba32$var$logger.throwError("missing provider", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: operation || "_checkProvider"
        });
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
}
class $deb85df20e19ba32$export$7dbc56d9b9612bad extends $deb85df20e19ba32$export$fdf54fdde81cc9f0 {
    constructor(address, provider){
        super();
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", address);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", provider || null);
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(()=>{
            $deb85df20e19ba32$var$logger.throwError(message, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: operation
            });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new $deb85df20e19ba32$export$7dbc56d9b9612bad(this.address, provider);
    }
}














var $dEXSZ = parcelRequire("dEXSZ");
var $ec7ff5071b027891$exports = {};
var $ec7ff5071b027891$var$hash = $ec7ff5071b027891$exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;


var $63aabbf7dfa8a956$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $63aabbf7dfa8a956$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $63aabbf7dfa8a956$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $63aabbf7dfa8a956$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $63aabbf7dfa8a956$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $63aabbf7dfa8a956$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $63aabbf7dfa8a956$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $63aabbf7dfa8a956$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $63aabbf7dfa8a956$var$minimalisticAssert = $63aabbf7dfa8a956$var$assert;
function $63aabbf7dfa8a956$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$63aabbf7dfa8a956$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $63aabbf7dfa8a956$var$utils_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $63aabbf7dfa8a956$var$utils_1$1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $63aabbf7dfa8a956$var$minimalisticAssert;
    utils.toArray = $63aabbf7dfa8a956$var$utils_1.toArray;
    utils.zero2 = $63aabbf7dfa8a956$var$utils_1.zero2;
    utils.toHex = $63aabbf7dfa8a956$var$utils_1.toHex;
    utils.encode = $63aabbf7dfa8a956$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $63aabbf7dfa8a956$var$getNAF = $63aabbf7dfa8a956$var$utils_1$1.getNAF;
var $63aabbf7dfa8a956$var$getJSF = $63aabbf7dfa8a956$var$utils_1$1.getJSF;
var $63aabbf7dfa8a956$var$assert$1 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $63aabbf7dfa8a956$var$base = $63aabbf7dfa8a956$var$BaseCurve;
$63aabbf7dfa8a956$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$63aabbf7dfa8a956$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$63aabbf7dfa8a956$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $63aabbf7dfa8a956$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $63aabbf7dfa8a956$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$63aabbf7dfa8a956$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $63aabbf7dfa8a956$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $63aabbf7dfa8a956$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$63aabbf7dfa8a956$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $63aabbf7dfa8a956$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $63aabbf7dfa8a956$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $63aabbf7dfa8a956$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $63aabbf7dfa8a956$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$63aabbf7dfa8a956$var$BaseCurve.BasePoint = $63aabbf7dfa8a956$var$BasePoint;
$63aabbf7dfa8a956$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$63aabbf7dfa8a956$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$63aabbf7dfa8a956$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $63aabbf7dfa8a956$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $63aabbf7dfa8a956$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $63aabbf7dfa8a956$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$63aabbf7dfa8a956$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$63aabbf7dfa8a956$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$63aabbf7dfa8a956$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $63aabbf7dfa8a956$var$utils_1$1.encode(this._encode(compact), enc);
};
$63aabbf7dfa8a956$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$63aabbf7dfa8a956$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$63aabbf7dfa8a956$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$63aabbf7dfa8a956$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$63aabbf7dfa8a956$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$63aabbf7dfa8a956$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $63aabbf7dfa8a956$var$inherits_browser = $63aabbf7dfa8a956$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $63aabbf7dfa8a956$var$assert$2 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$ShortCurve(conf) {
    $63aabbf7dfa8a956$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$63aabbf7dfa8a956$var$inherits_browser($63aabbf7dfa8a956$var$ShortCurve, $63aabbf7dfa8a956$var$base);
var $63aabbf7dfa8a956$var$short_1 = $63aabbf7dfa8a956$var$ShortCurve;
$63aabbf7dfa8a956$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $63aabbf7dfa8a956$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$63aabbf7dfa8a956$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$63aabbf7dfa8a956$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $63aabbf7dfa8a956$var$Point(curve, x, y, isRed) {
    $63aabbf7dfa8a956$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$63aabbf7dfa8a956$var$inherits_browser($63aabbf7dfa8a956$var$Point, $63aabbf7dfa8a956$var$base.BasePoint);
$63aabbf7dfa8a956$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $63aabbf7dfa8a956$var$Point(this, x, y, isRed);
};
$63aabbf7dfa8a956$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $63aabbf7dfa8a956$var$Point.fromJSON(this, obj, red);
};
$63aabbf7dfa8a956$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$63aabbf7dfa8a956$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$63aabbf7dfa8a956$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$63aabbf7dfa8a956$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$63aabbf7dfa8a956$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$63aabbf7dfa8a956$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$63aabbf7dfa8a956$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$63aabbf7dfa8a956$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$63aabbf7dfa8a956$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$63aabbf7dfa8a956$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$63aabbf7dfa8a956$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$63aabbf7dfa8a956$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$63aabbf7dfa8a956$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$63aabbf7dfa8a956$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$63aabbf7dfa8a956$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $63aabbf7dfa8a956$var$JPoint(curve, x, y, z) {
    $63aabbf7dfa8a956$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$63aabbf7dfa8a956$var$inherits_browser($63aabbf7dfa8a956$var$JPoint, $63aabbf7dfa8a956$var$base.BasePoint);
$63aabbf7dfa8a956$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $63aabbf7dfa8a956$var$JPoint(this, x, y, z);
};
$63aabbf7dfa8a956$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$63aabbf7dfa8a956$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$63aabbf7dfa8a956$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$63aabbf7dfa8a956$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$63aabbf7dfa8a956$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$63aabbf7dfa8a956$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$63aabbf7dfa8a956$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$63aabbf7dfa8a956$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $63aabbf7dfa8a956$var$curve_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $63aabbf7dfa8a956$var$base;
    curve.short = $63aabbf7dfa8a956$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $63aabbf7dfa8a956$var$curves_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $63aabbf7dfa8a956$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $63aabbf7dfa8a956$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $63aabbf7dfa8a956$var$curve_1.edwards(options);
        else this.curve = new $63aabbf7dfa8a956$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $63aabbf7dfa8a956$var$HmacDRBG(options) {
    if (!(this instanceof $63aabbf7dfa8a956$var$HmacDRBG)) return new $63aabbf7dfa8a956$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $63aabbf7dfa8a956$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $63aabbf7dfa8a956$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $63aabbf7dfa8a956$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $63aabbf7dfa8a956$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $63aabbf7dfa8a956$var$hmacDrbg = $63aabbf7dfa8a956$var$HmacDRBG;
$63aabbf7dfa8a956$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).hmac(this.hash, this.K);
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $63aabbf7dfa8a956$var$utils_1.toArray(entropy, entropyEnc);
    add = $63aabbf7dfa8a956$var$utils_1.toArray(add, addEnc);
    $63aabbf7dfa8a956$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $63aabbf7dfa8a956$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $63aabbf7dfa8a956$var$utils_1.encode(res, enc);
};
"use strict";
var $63aabbf7dfa8a956$var$assert$3 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $63aabbf7dfa8a956$var$key = $63aabbf7dfa8a956$var$KeyPair;
$63aabbf7dfa8a956$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $63aabbf7dfa8a956$var$KeyPair) return pub;
    return new $63aabbf7dfa8a956$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$63aabbf7dfa8a956$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $63aabbf7dfa8a956$var$KeyPair) return priv;
    return new $63aabbf7dfa8a956$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$63aabbf7dfa8a956$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$63aabbf7dfa8a956$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$63aabbf7dfa8a956$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$63aabbf7dfa8a956$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$63aabbf7dfa8a956$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $63aabbf7dfa8a956$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $63aabbf7dfa8a956$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$63aabbf7dfa8a956$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $63aabbf7dfa8a956$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$63aabbf7dfa8a956$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$63aabbf7dfa8a956$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$63aabbf7dfa8a956$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $63aabbf7dfa8a956$var$assert$4 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$Signature(options, enc) {
    if (options instanceof $63aabbf7dfa8a956$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $63aabbf7dfa8a956$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $63aabbf7dfa8a956$var$signature = $63aabbf7dfa8a956$var$Signature;
function $63aabbf7dfa8a956$var$Position() {
    this.place = 0;
}
function $63aabbf7dfa8a956$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $63aabbf7dfa8a956$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$63aabbf7dfa8a956$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $63aabbf7dfa8a956$var$utils_1$1.toArray(data, enc);
    var p = new $63aabbf7dfa8a956$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $63aabbf7dfa8a956$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $63aabbf7dfa8a956$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $63aabbf7dfa8a956$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(s);
    this.recoveryParam = null;
    return true;
};
function $63aabbf7dfa8a956$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$63aabbf7dfa8a956$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $63aabbf7dfa8a956$var$rmPadding(r);
    s = $63aabbf7dfa8a956$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $63aabbf7dfa8a956$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $63aabbf7dfa8a956$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $63aabbf7dfa8a956$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $63aabbf7dfa8a956$var$utils_1$1.encode(res, enc);
};
"use strict";
var $63aabbf7dfa8a956$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $63aabbf7dfa8a956$var$assert$5 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$EC(options) {
    if (!(this instanceof $63aabbf7dfa8a956$var$EC)) return new $63aabbf7dfa8a956$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $63aabbf7dfa8a956$var$assert$5(Object.prototype.hasOwnProperty.call($63aabbf7dfa8a956$var$curves_1, options), "Unknown curve " + options);
        options = $63aabbf7dfa8a956$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $63aabbf7dfa8a956$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $63aabbf7dfa8a956$var$ec = $63aabbf7dfa8a956$var$EC;
$63aabbf7dfa8a956$var$EC.prototype.keyPair = function keyPair(options) {
    return new $63aabbf7dfa8a956$var$key(this, options);
};
$63aabbf7dfa8a956$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $63aabbf7dfa8a956$var$key.fromPrivate(this, priv, enc);
};
$63aabbf7dfa8a956$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $63aabbf7dfa8a956$var$key.fromPublic(this, pub, enc);
};
$63aabbf7dfa8a956$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $63aabbf7dfa8a956$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $63aabbf7dfa8a956$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$63aabbf7dfa8a956$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$63aabbf7dfa8a956$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $63aabbf7dfa8a956$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $63aabbf7dfa8a956$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$63aabbf7dfa8a956$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $63aabbf7dfa8a956$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$63aabbf7dfa8a956$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $63aabbf7dfa8a956$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $63aabbf7dfa8a956$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$63aabbf7dfa8a956$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $63aabbf7dfa8a956$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $63aabbf7dfa8a956$var$elliptic_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $63aabbf7dfa8a956$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $63aabbf7dfa8a956$var$curve_1;
    elliptic.curves = $63aabbf7dfa8a956$var$curves_1;
    // Protocols
    elliptic.ec = $63aabbf7dfa8a956$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $63aabbf7dfa8a956$export$129fe12d32abc311 = $63aabbf7dfa8a956$var$elliptic_1.ec;





const $a512adda7ad1dfdc$export$83d89fbfd8236492 = "signing-key/5.7.0";


"use strict";
const $ff9f75f56da7c459$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $a512adda7ad1dfdc$export$83d89fbfd8236492));
let $ff9f75f56da7c459$var$_curve = null;
function $ff9f75f56da7c459$var$getCurve() {
    if (!$ff9f75f56da7c459$var$_curve) $ff9f75f56da7c459$var$_curve = new (0, $63aabbf7dfa8a956$export$129fe12d32abc311)("secp256k1");
    return $ff9f75f56da7c459$var$_curve;
}
class $ff9f75f56da7c459$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "curve", "secp256k1");
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "privateKey", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(privateKey));
        if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(this.privateKey) !== 32) $ff9f75f56da7c459$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $ff9f75f56da7c459$var$getCurve().keyFromPrivate((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.privateKey));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $ff9f75f56da7c459$var$getCurve().keyFromPublic((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.publicKey));
        const p1 = $ff9f75f56da7c459$var$getCurve().keyFromPublic((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $ff9f75f56da7c459$var$getCurve().keyFromPrivate((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.privateKey));
        const digestBytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(digest);
        if (digestBytes.length !== 32) $ff9f75f56da7c459$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)({
            recoveryParam: signature.recoveryParam,
            r: (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)("0x" + signature.r.toString(16), 32),
            s: (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $ff9f75f56da7c459$var$getCurve().keyFromPrivate((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.privateKey));
        const otherKeyPair = $ff9f75f56da7c459$var$getCurve().keyFromPublic((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)($ff9f75f56da7c459$export$4a89473d39301224(otherKey)));
        return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $ff9f75f56da7c459$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(signature);
    const rs = {
        r: (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(sig.r),
        s: (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(sig.s)
    };
    return "0x" + $ff9f75f56da7c459$var$getCurve().recoverPubKey((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $ff9f75f56da7c459$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(key);
    if (bytes.length === 32) {
        const signingKey = new $ff9f75f56da7c459$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $ff9f75f56da7c459$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $ff9f75f56da7c459$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $ff9f75f56da7c459$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $ff9f75f56da7c459$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}



const $8ffd0867b0da9487$export$83d89fbfd8236492 = "transactions/5.7.0";


"use strict";
const $0a7021bc70fec74d$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $8ffd0867b0da9487$export$83d89fbfd8236492));
var $0a7021bc70fec74d$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($0a7021bc70fec74d$export$80349e05e0724e11 || ($0a7021bc70fec74d$export$80349e05e0724e11 = {}));
///////////////////////////////
function $0a7021bc70fec74d$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $8aee8aee2d40605d$export$88411125f012957a)(value);
}
function $0a7021bc70fec74d$var$handleNumber(value) {
    if (value === "0x") return 0, $c5333cf79421e056$export$aaef8a3eae948f03;
    return (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
}
// Legacy Transaction Fields
const $0a7021bc70fec74d$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $0a7021bc70fec74d$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $0a7021bc70fec74d$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $ff9f75f56da7c459$export$4a89473d39301224)(key);
    return (0, $8aee8aee2d40605d$export$88411125f012957a)((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$15da666eba198c18)(publicKey, 1)), 12));
}
function $0a7021bc70fec74d$export$23cc18f96d8510e2(digest, signature) {
    return $0a7021bc70fec74d$export$e67e2732ba9803f9((0, $ff9f75f56da7c459$export$952dd09fbe0232b7)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(digest), signature));
}
function $0a7021bc70fec74d$var$formatNumber(value, name) {
    const result = (0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toHexString());
    if (result.length > 32) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $0a7021bc70fec74d$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $8aee8aee2d40605d$export$88411125f012957a)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(storageKey) !== 32) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $0a7021bc70fec74d$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $0a7021bc70fec74d$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $0a7021bc70fec74d$var$accessSetify(set[0], set[1]);
        }
        return $0a7021bc70fec74d$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $0a7021bc70fec74d$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $0a7021bc70fec74d$var$formatAccessList(value) {
    return $0a7021bc70fec74d$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $0a7021bc70fec74d$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction.gasPrice);
        const maxFeePerGas = (0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $0a7021bc70fec74d$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $0a7021bc70fec74d$var$formatNumber(transaction.chainId || 0, "chainId"),
        $0a7021bc70fec74d$var$formatNumber(transaction.nonce || 0, "nonce"),
        $0a7021bc70fec74d$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $0a7021bc70fec74d$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $0a7021bc70fec74d$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $8aee8aee2d40605d$export$88411125f012957a)(transaction.to) : "0x",
        $0a7021bc70fec74d$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $0a7021bc70fec74d$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(signature);
        fields.push($0a7021bc70fec74d$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
        "0x02",
        $6ff2d0f6bfa15181$export$c564cdbbe6da493(fields)
    ]);
}
function $0a7021bc70fec74d$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $0a7021bc70fec74d$var$formatNumber(transaction.chainId || 0, "chainId"),
        $0a7021bc70fec74d$var$formatNumber(transaction.nonce || 0, "nonce"),
        $0a7021bc70fec74d$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $0a7021bc70fec74d$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $8aee8aee2d40605d$export$88411125f012957a)(transaction.to) : "0x",
        $0a7021bc70fec74d$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $0a7021bc70fec74d$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(signature);
        fields.push($0a7021bc70fec74d$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
        "0x01",
        $6ff2d0f6bfa15181$export$c564cdbbe6da493(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $0a7021bc70fec74d$var$_serialize(transaction, signature) {
    (0, $a463a6b5f08d6875$export$ae5a316ba623b73a)(transaction, $0a7021bc70fec74d$var$allowedTransactionKeys);
    const raw = [];
    $0a7021bc70fec74d$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(value);
            if (value.length > fieldInfo.maxLength) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $0a7021bc70fec74d$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $7b88b6e03e4708f2$export$9a14abb1a440cd5e)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $6ff2d0f6bfa15181$export$c564cdbbe6da493(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $0a7021bc70fec74d$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $0a7021bc70fec74d$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(v));
    raw.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(sig.r)));
    raw.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(sig.s)));
    return $6ff2d0f6bfa15181$export$c564cdbbe6da493(raw);
}
function $0a7021bc70fec74d$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $0a7021bc70fec74d$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $0a7021bc70fec74d$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $0a7021bc70fec74d$var$_serializeEip2930(transaction, signature);
        case 2:
            return $0a7021bc70fec74d$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $0a7021bc70fec74d$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $0a7021bc70fec74d$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $0a7021bc70fec74d$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $0a7021bc70fec74d$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(fields[1], 32);
    tx.s = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(fields[2], 32);
    try {
        const digest = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(serialize(tx));
        tx.from = $0a7021bc70fec74d$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $0a7021bc70fec74d$var$_parseEip1559(payload) {
    const transaction = $6ff2d0f6bfa15181$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(payload));
    const maxPriorityFeePerGas = $0a7021bc70fec74d$var$handleNumber(transaction[2]);
    const maxFeePerGas = $0a7021bc70fec74d$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $0a7021bc70fec74d$var$handleNumber(transaction[0]).toNumber(),
        nonce: $0a7021bc70fec74d$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $0a7021bc70fec74d$var$handleNumber(transaction[4]),
        to: $0a7021bc70fec74d$var$handleAddress(transaction[5]),
        value: $0a7021bc70fec74d$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $0a7021bc70fec74d$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(payload);
    $0a7021bc70fec74d$var$_parseEipSignature(tx, transaction.slice(9), $0a7021bc70fec74d$var$_serializeEip1559);
    return tx;
}
function $0a7021bc70fec74d$var$_parseEip2930(payload) {
    const transaction = $6ff2d0f6bfa15181$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(payload));
    const tx = {
        type: 1,
        chainId: $0a7021bc70fec74d$var$handleNumber(transaction[0]).toNumber(),
        nonce: $0a7021bc70fec74d$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $0a7021bc70fec74d$var$handleNumber(transaction[2]),
        gasLimit: $0a7021bc70fec74d$var$handleNumber(transaction[3]),
        to: $0a7021bc70fec74d$var$handleAddress(transaction[4]),
        value: $0a7021bc70fec74d$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $0a7021bc70fec74d$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(payload);
    $0a7021bc70fec74d$var$_parseEipSignature(tx, transaction.slice(8), $0a7021bc70fec74d$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $0a7021bc70fec74d$var$_parse(rawTransaction) {
    const transaction = $6ff2d0f6bfa15181$export$2f872c0f2117be69(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $0a7021bc70fec74d$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $0a7021bc70fec74d$var$handleNumber(transaction[1]),
        gasLimit: $0a7021bc70fec74d$var$handleNumber(transaction[2]),
        to: $0a7021bc70fec74d$var$handleAddress(transaction[3]),
        value: $0a7021bc70fec74d$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(transaction[7], 32);
    tx.s = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(transaction[8], 32);
    if ((0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.r).isZero() && (0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)($6ff2d0f6bfa15181$export$c564cdbbe6da493(raw));
        try {
            tx.from = $0a7021bc70fec74d$export$23cc18f96d8510e2(digest, {
                r: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(tx.r),
                s: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $0a7021bc70fec74d$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $0a7021bc70fec74d$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $0a7021bc70fec74d$var$_parseEip2930(payload);
        case 2:
            return $0a7021bc70fec74d$var$_parseEip1559(payload);
        default:
            break;
    }
    return $0a7021bc70fec74d$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}



const $e1c2f54bf01974f7$export$83d89fbfd8236492 = "contracts/5.7.0";


"use strict";
var $b84bae218d85c3ca$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $b84bae218d85c3ca$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $e1c2f54bf01974f7$export$83d89fbfd8236492));
///////////////////////////////
const $b84bae218d85c3ca$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function $b84bae218d85c3ca$var$resolveName(resolver, nameOrPromise) {
    return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
        const name = yield nameOrPromise;
        if (typeof name !== "string") $b84bae218d85c3ca$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
        // If it is already an address, just use it (after adding checksum)
        try {
            return (0, $8aee8aee2d40605d$export$88411125f012957a)(name);
        } catch (error) {}
        if (!resolver) $b84bae218d85c3ca$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "resolveName"
        });
        const address = yield resolver.resolveName(name);
        if (address == null) $b84bae218d85c3ca$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $b84bae218d85c3ca$var$resolveAddresses(resolver, value, paramType) {
    return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
        if (Array.isArray(paramType)) return yield Promise.all(paramType.map((paramType, index)=>{
            return $b84bae218d85c3ca$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
        }));
        if (paramType.type === "address") return yield $b84bae218d85c3ca$var$resolveName(resolver, value);
        if (paramType.type === "tuple") return yield $b84bae218d85c3ca$var$resolveAddresses(resolver, value, paramType.components);
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) return Promise.reject($b84bae218d85c3ca$var$logger.makeError("invalid value for array", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "value",
                value: value
            }));
            return yield Promise.all(value.map((v)=>$b84bae218d85c3ca$var$resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function $b84bae218d85c3ca$var$populateTransaction(contract, fragment, args) {
    return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(args.pop());
        // Make sure the parameter count matches
        $b84bae218d85c3ca$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
            // but we allow overriding "from" if it matches the signer
            overrides.from = (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                override: $b84bae218d85c3ca$var$resolveName(contract.signer, overrides.from),
                signer: contract.signer.getAddress()
            }).then((check)=>$b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
                    if ((0, $8aee8aee2d40605d$export$88411125f012957a)(check.signer) !== check.override) $b84bae218d85c3ca$var$logger.throwError("Contract with a Signer cannot override from", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.from"
                    });
                    return check.override;
                }));
            else overrides.from = contract.signer.getAddress();
        } else if (overrides.from) overrides.from = $b84bae218d85c3ca$var$resolveName(contract.provider, overrides.from);
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
            args: $b84bae218d85c3ca$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (0, $a463a6b5f08d6875$export$d503dd157d963b60)(overrides) || {}
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) tx.nonce = (0, $0df4577496dcf693$export$d97aa349ed20696).from(ro.nonce).toNumber();
        if (ro.gasLimit != null) tx.gasLimit = (0, $0df4577496dcf693$export$d97aa349ed20696).from(ro.gasLimit);
        if (ro.gasPrice != null) tx.gasPrice = (0, $0df4577496dcf693$export$d97aa349ed20696).from(ro.gasPrice);
        if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $0df4577496dcf693$export$d97aa349ed20696).from(ro.maxFeePerGas);
        if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $0df4577496dcf693$export$d97aa349ed20696).from(ro.maxPriorityFeePerGas);
        if (ro.from != null) tx.from = ro.from;
        if (ro.type != null) tx.type = ro.type;
        if (ro.accessList != null) tx.accessList = (0, $0a7021bc70fec74d$export$6c8662b1600dce2)(ro.accessList);
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
            for(let i = 0; i < bytes.length; i++){
                intrinsic += 4;
                if (bytes[i]) intrinsic += 64;
            }
            tx.gasLimit = (0, $0df4577496dcf693$export$d97aa349ed20696).from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = (0, $0df4577496dcf693$export$d97aa349ed20696).from(ro.value);
            if (!roValue.isZero() && !fragment.payable) $b84bae218d85c3ca$var$logger.throwError("non-payable method cannot override value", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: overrides.value
            });
            tx.value = roValue;
        }
        if (ro.customData) tx.customData = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(ro.customData);
        if (ro.ccipReadEnabled) tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key)=>overrides[key] != null);
        if (leftovers.length) $b84bae218d85c3ca$var$logger.throwError(`cannot override ${leftovers.map((l)=>JSON.stringify(l)).join(",")}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "overrides",
            overrides: leftovers
        });
        return tx;
    });
}
function $b84bae218d85c3ca$var$buildPopulate(contract, fragment) {
    return function(...args) {
        return $b84bae218d85c3ca$var$populateTransaction(contract, fragment, args);
    };
}
function $b84bae218d85c3ca$var$buildEstimate(contract, fragment) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
            if (!signerOrProvider) $b84bae218d85c3ca$var$logger.throwError("estimate require a provider or signer", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
            });
            const tx = yield $b84bae218d85c3ca$var$populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function $b84bae218d85c3ca$var$addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations)=>{
        return wait(confirmations).then((receipt)=>{
            receipt.events = receipt.logs.map((log)=>{
                let event = (0, $a463a6b5f08d6875$export$6c40052bed430212)(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics)=>{
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = ()=>{
                    return contract.provider;
                };
                event.getBlock = ()=>{
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = ()=>{
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = ()=>{
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $b84bae218d85c3ca$var$buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                const overrides = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(args.pop());
                if (overrides.blockTag != null) blockTag = yield overrides.blockTag;
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed(blockTag);
            // Call a node and get the result
            const tx = yield $b84bae218d85c3ca$var$populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                return value;
            } catch (error) {
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function $b84bae218d85c3ca$var$buildSend(contract, fragment) {
    return function(...args) {
        return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
            if (!contract.signer) $b84bae218d85c3ca$var$logger.throwError("sending a transaction requires a signer", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
            });
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed();
            const txRequest = yield $b84bae218d85c3ca$var$populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            $b84bae218d85c3ca$var$addContractWait(contract, tx);
            return tx;
        });
    };
}
function $b84bae218d85c3ca$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $b84bae218d85c3ca$var$buildCall(contract, fragment, collapseSimple);
    return $b84bae218d85c3ca$var$buildSend(contract, fragment);
}
function $b84bae218d85c3ca$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic)=>{
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
class $b84bae218d85c3ca$var$RunningEvent {
    constructor(tag, filter){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "tag", tag);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "filter", filter);
        this._listeners = [];
    }
    addListener(listener, once) {
        this._listeners.push({
            listener: listener,
            once: once
        });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item)=>{
            if (done || item.listener !== listener) return true;
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i)=>i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item)=>{
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(()=>{
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !item.once;
        });
        return listenerCount;
    }
    prepareEvent(event) {}
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [
            event
        ];
    }
}
class $b84bae218d85c3ca$var$ErrorRunningEvent extends $b84bae218d85c3ca$var$RunningEvent {
    constructor(){
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class $b84bae218d85c3ca$var$FragmentRunningEvent extends $b84bae218d85c3ca$var$RunningEvent {
    constructor(address, contractInterface, fragment, topics){
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $b84bae218d85c3ca$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        super($b84bae218d85c3ca$var$getEventTag(filter), filter);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", address);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "interface", contractInterface);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "fragment", fragment);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics)=>{
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        } catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = (0, $2c0f0ed4c5bed241$export$5546b9ec21157cc2)(event.args);
        if (errors.length) throw errors[0].error;
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class $b84bae218d85c3ca$var$WildcardRunningEvent extends $b84bae218d85c3ca$var$RunningEvent {
    constructor(address, contractInterface){
        super("*", {
            address: address
        });
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", address);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "interface", contractInterface);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics)=>{
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        } catch (error) {
        // No matching event
        }
    }
}
class $b84bae218d85c3ca$export$304faa4fc17528db {
    constructor(addressOrName, contractInterface, signerOrProvider){
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "interface", (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", null);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "signer", null);
        } else if ((0, $deb85df20e19ba32$export$fdf54fdde81cc9f0).isSigner(signerOrProvider)) {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", signerOrProvider.provider || null);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "signer", signerOrProvider);
        } else if ((0, $81658ac0a17fba50$export$2881499e37b75b9a).isProvider(signerOrProvider)) {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", signerOrProvider);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "signer", null);
        } else $b84bae218d85c3ca$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "callStatic", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "estimateGas", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "functions", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "populateTransaction", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature)=>{
                const event = this.interface.events[eventSignature];
                (0, $a463a6b5f08d6875$export$104236534534f9be)(this.filters, eventSignature, (...args)=>{
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name)=>{
                const filters = uniqueFilters[name];
                if (filters.length === 1) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.filters, name, this.filters[filters[0]]);
                else $b84bae218d85c3ca$var$logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
            });
        }
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_runningEvents", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_wrappedEmits", {});
        if (addressOrName == null) $b84bae218d85c3ca$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", addressOrName);
        if (this.provider) (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "resolvedAddress", $b84bae218d85c3ca$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "resolvedAddress", Promise.resolve((0, $8aee8aee2d40605d$export$88411125f012957a)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $b84bae218d85c3ca$var$logger.throwError("provider is required to use ENS name as contract address", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e)=>{});
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature)=>{
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $b84bae218d85c3ca$var$logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) uniqueNames[`%${name}`] = [];
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this, signature, $b84bae218d85c3ca$var$buildDefault(this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.functions, signature, $b84bae218d85c3ca$var$buildDefault(this, fragment, false));
            if (this.callStatic[signature] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.callStatic, signature, $b84bae218d85c3ca$var$buildCall(this, fragment, true));
            if (this.populateTransaction[signature] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.populateTransaction, signature, $b84bae218d85c3ca$var$buildPopulate(this, fragment));
            if (this.estimateGas[signature] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.estimateGas, signature, $b84bae218d85c3ca$var$buildEstimate(this, fragment));
        });
        Object.keys(uniqueNames).forEach((name)=>{
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this, name, this[signature]);
            } catch (e) {}
            if (this.functions[name] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.functions, name, this.functions[signature]);
            if (this.callStatic[name] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.callStatic, name, this.callStatic[signature]);
            if (this.populateTransaction[name] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.populateTransaction, name, this.populateTransaction[signature]);
            if (this.estimateGas[name] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.estimateGas, name, this.estimateGas[signature]);
        });
    }
    static getContractAddress(transaction) {
        return (0, $8aee8aee2d40605d$export$b7fbffef12272e40)(transaction);
    }
    static getInterface(contractInterface) {
        if ((0, $ef97d5c3a9a93354$export$48cefb51a4e315b2).isInterface(contractInterface)) return contractInterface;
        return new (0, $ef97d5c3a9a93354$export$48cefb51a4e315b2)(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(()=>{
                return this;
            });
            else // @TODO: Once we allow a timeout to be passed in, we will wait
            // up to that many blocks for getCode
            // Otherwise, poll for our code to be deployed
            this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code)=>{
                if (code === "0x") $b84bae218d85c3ca$var$logger.throwError("contract not deployed", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    contractAddress: this.address,
                    operation: "getDeployed"
                });
                return this;
            });
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) $b84bae218d85c3ca$var$logger.throwError("sending a transactions require a signer", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
        });
        const tx = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(overrides || {});
        [
            "from",
            "to"
        ].forEach(function(key) {
            if (tx[key] == null) return;
            $b84bae218d85c3ca$var$logger.throwError("cannot override " + key, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(()=>{
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof signerOrProvider === "string") signerOrProvider = new (0, $deb85df20e19ba32$export$7dbc56d9b9612bad)(signerOrProvider, this.provider);
        const contract = new this.constructor(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) (0, $a463a6b5f08d6875$export$104236534534f9be)(contract, "deployTransaction", this.deployTransaction);
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return (0, $ef97d5c3a9a93354$export$8ef99100a3c56f8c).isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof eventName === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$ErrorRunningEvent());
            // Listen for any event that is registered
            if (eventName === "event") return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$RunningEvent("event", null));
            // Listen for any event
            if (eventName === "*") return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$WildcardRunningEvent(this.address, this.interface));
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            } catch (error) {}
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$RunningEvent($b84bae218d85c3ca$var$getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = (0, $a463a6b5f08d6875$export$6c40052bed430212)(log);
        event.removeListener = ()=>{
            if (!listener) return;
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = ()=>{
            return this.provider.getBlock(log.blockHash);
        };
        event.getTransaction = ()=>{
            return this.provider.getTransaction(log.transactionHash);
        };
        event.getTransactionReceipt = ()=>{
            return this.provider.getTransactionReceipt(log.transactionHash);
        };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) $b84bae218d85c3ca$var$logger.throwError("events require a provider or a signer with a provider", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "once"
        });
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log)=>{
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) try {
                    const args = runningEvent.getEmit(event);
                    this.emit(runningEvent.filter, ...args);
                } catch (error) {
                    event.decodeError = error.error;
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) this.emit("event", event);
                // Emit "error" if there was an error
                if (event.decodeError != null) this.emit("error", event.decodeError, event);
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(runningEvent.filter);
        if (typeof fromBlockOrBlockhash === "string" && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) $b84bae218d85c3ca$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            filter.blockHash = fromBlockOrBlockhash;
        } else {
            filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
            filter.toBlock = toBlock != null ? toBlock : "latest";
        }
        return this.provider.getLogs(filter).then((logs)=>{
            return logs.map((log)=>this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) return false;
        const runningEvent = this._getRunningEvent(eventName);
        const result = runningEvent.run(args) > 0;
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) return 0;
        if (eventName == null) return Object.keys(this._runningEvents).reduce((accum, key)=>{
            return accum + this._runningEvents[key].listenerCount();
        }, 0);
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) return [];
        if (eventName == null) {
            const result = [];
            for(let tag in this._runningEvents)this._runningEvents[tag].listeners().forEach((listener)=>{
                result.push(listener);
            });
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) return this;
        if (eventName == null) {
            for(const tag in this._runningEvents){
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) return this;
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
}
class $b84bae218d85c3ca$export$8517d80acf00e19a extends $b84bae218d85c3ca$export$304faa4fc17528db {
}
class $b84bae218d85c3ca$export$505569a6bf584fd9 {
    constructor(contractInterface, bytecode, signer){
        let bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $7b88b6e03e4708f2$export$c6fabfbfd097fc30)(bytecode)) bytecodeHex = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(bytecodeHex) || bytecodeHex.length % 2) $b84bae218d85c3ca$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $deb85df20e19ba32$export$fdf54fdde81cc9f0).isSigner(signer)) $b84bae218d85c3ca$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "bytecode", bytecodeHex);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "interface", (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getInterface")(contractInterface));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "signer", signer || null);
    }
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
            tx = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(args.pop());
            for(const key in tx){
                if (!$b84bae218d85c3ca$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        [
            "data",
            "from",
            "to"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            $b84bae218d85c3ca$var$logger.throwError("cannot override " + key, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        if (tx.value) {
            const value = (0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) $b84bae218d85c3ca$var$logger.throwError("non-payable constructor cannot override value", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: tx.value
            });
        }
        // Make sure the call matches the constructor signature
        $b84bae218d85c3ca$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
            // Make sure the call matches the constructor signature
            $b84bae218d85c3ca$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield $b84bae218d85c3ca$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "getContractAddress")(tx);
            const contract = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            $b84bae218d85c3ca$var$addContractWait(contract, tx);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return this.constructor.getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new this.constructor(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) $b84bae218d85c3ca$var$logger.throwError("missing compiler output", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.MISSING_ARGUMENT, {
            argument: "compilerOutput"
        });
        if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return $b84bae218d85c3ca$export$8517d80acf00e19a.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return (0, $8aee8aee2d40605d$export$b7fbffef12272e40)(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new $b84bae218d85c3ca$export$8517d80acf00e19a(address, contractInterface, signer);
    }
}






"use strict";
const $bdc30db990c4b693$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $a38aef31efdfa85e$export$83d89fbfd8236492));
const $bdc30db990c4b693$var$_constructorGuard = {};
const $bdc30db990c4b693$var$Zero = (0, $0df4577496dcf693$export$d97aa349ed20696).from(0);
const $bdc30db990c4b693$var$NegativeOne = (0, $0df4577496dcf693$export$d97aa349ed20696).from(-1);
function $bdc30db990c4b693$var$throwFault(message, fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $bdc30db990c4b693$var$logger.throwError(message, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let $bdc30db990c4b693$var$zeros = "0";
while($bdc30db990c4b693$var$zeros.length < 256)$bdc30db990c4b693$var$zeros += $bdc30db990c4b693$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $bdc30db990c4b693$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $0df4577496dcf693$export$d97aa349ed20696).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $bdc30db990c4b693$var$zeros.substring(0, decimals);
    return $bdc30db990c4b693$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $bdc30db990c4b693$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $bdc30db990c4b693$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
    const negative = value.lt($bdc30db990c4b693$var$Zero);
    if (negative) value = value.mul($bdc30db990c4b693$var$NegativeOne);
    let fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $bdc30db990c4b693$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $bdc30db990c4b693$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $bdc30db990c4b693$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    const negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $bdc30db990c4b693$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) $bdc30db990c4b693$var$logger.throwArgumentError("too many decimal points", "value", value);
    let whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $bdc30db990c4b693$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    const wholeValue = (0, $0df4577496dcf693$export$d97aa349ed20696).from(whole);
    const fractionValue = (0, $0df4577496dcf693$export$d97aa349ed20696).from(fraction);
    let wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($bdc30db990c4b693$var$NegativeOne);
    return wei;
}
class $bdc30db990c4b693$export$1f3ec5b8f47ebd4d {
    constructor(constructorGuard, signed, width, decimals){
        if (constructorGuard !== $bdc30db990c4b693$var$_constructorGuard) $bdc30db990c4b693$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $bdc30db990c4b693$var$getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof $bdc30db990c4b693$export$1f3ec5b8f47ebd4d) return value;
        if (typeof value === "number") value = `fixed128x${value}`;
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof value === "string") {
            if (value === "fixed") ;
            else if (value === "ufixed") signed = false;
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) $bdc30db990c4b693$var$logger.throwArgumentError("invalid fixed format", "format", value);
                signed = match[1] !== "u";
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        } else if (value) {
            const check = (key, type, defaultValue)=>{
                if (value[key] == null) return defaultValue;
                if (typeof value[key] !== type) $bdc30db990c4b693$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) $bdc30db990c4b693$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        if (decimals > 80) $bdc30db990c4b693$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        return new $bdc30db990c4b693$export$1f3ec5b8f47ebd4d($bdc30db990c4b693$var$_constructorGuard, signed, width, decimals);
    }
}
class $bdc30db990c4b693$export$d4693c66c2213e45 {
    constructor(constructorGuard, hex, value, format){
        if (constructorGuard !== $bdc30db990c4b693$var$_constructorGuard) $bdc30db990c4b693$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) $bdc30db990c4b693$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = $bdc30db990c4b693$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $bdc30db990c4b693$export$1b039987e86d7269(other._value, other.format.decimals);
        return $bdc30db990c4b693$export$d4693c66c2213e45.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = $bdc30db990c4b693$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $bdc30db990c4b693$export$1b039987e86d7269(other._value, other.format.decimals);
        return $bdc30db990c4b693$export$d4693c66c2213e45.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = $bdc30db990c4b693$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $bdc30db990c4b693$export$1b039987e86d7269(other._value, other.format.decimals);
        return $bdc30db990c4b693$export$d4693c66c2213e45.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = $bdc30db990c4b693$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $bdc30db990c4b693$export$1b039987e86d7269(other._value, other.format.decimals);
        return $bdc30db990c4b693$export$d4693c66c2213e45.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $bdc30db990c4b693$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) result = result.subUnsafe($bdc30db990c4b693$var$ONE.toFormat(result.format));
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $bdc30db990c4b693$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) result = result.addUnsafe($bdc30db990c4b693$var$ONE.toFormat(result.format));
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) decimals = 0;
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        if (decimals < 0 || decimals > 80 || decimals % 1) $bdc30db990c4b693$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        if (comps[1].length <= decimals) return this;
        const factor = $bdc30db990c4b693$export$d4693c66c2213e45.from("1" + $bdc30db990c4b693$var$zeros.substring(0, decimals), this.format);
        const bump = $bdc30db990c4b693$var$BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(width) {
        if (width == null) return this._hex;
        if (width % 8) $bdc30db990c4b693$var$logger.throwArgumentError("invalid byte width", "width", width);
        const hex = (0, $0df4577496dcf693$export$d97aa349ed20696).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(hex, width / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(format) {
        return $bdc30db990c4b693$export$d4693c66c2213e45.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0, $0df4577496dcf693$export$a3d0a7fa9b65683b)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) decimals = 0;
        if (format == null) format = "fixed";
        return $bdc30db990c4b693$export$d4693c66c2213e45.fromString($bdc30db990c4b693$export$cc011b843b5d69f2(value, decimals), $bdc30db990c4b693$export$1f3ec5b8f47ebd4d.from(format));
    }
    static fromString(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $bdc30db990c4b693$export$1f3ec5b8f47ebd4d.from(format);
        const numeric = $bdc30db990c4b693$export$1b039987e86d7269(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt($bdc30db990c4b693$var$Zero)) $bdc30db990c4b693$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
        let hex = null;
        if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
        else {
            hex = numeric.toHexString();
            hex = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(hex, fixedFormat.width / 8);
        }
        const decimal = $bdc30db990c4b693$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $bdc30db990c4b693$export$d4693c66c2213e45($bdc30db990c4b693$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $bdc30db990c4b693$export$1f3ec5b8f47ebd4d.from(format);
        if ((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value).length > fixedFormat.width / 8) throw new Error("overflow");
        let numeric = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
        if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = $bdc30db990c4b693$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $bdc30db990c4b693$export$d4693c66c2213e45($bdc30db990c4b693$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof value === "string") return $bdc30db990c4b693$export$d4693c66c2213e45.fromString(value, format);
        if ((0, $7b88b6e03e4708f2$export$c6fabfbfd097fc30)(value)) return $bdc30db990c4b693$export$d4693c66c2213e45.fromBytes(value, format);
        try {
            return $bdc30db990c4b693$export$d4693c66c2213e45.fromValue(value, 0, format);
        } catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT) throw error;
        }
        return $bdc30db990c4b693$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const $bdc30db990c4b693$var$ONE = $bdc30db990c4b693$export$d4693c66c2213e45.from(1);
const $bdc30db990c4b693$var$BUMP = $bdc30db990c4b693$export$d4693c66c2213e45.from("0.5");













const $389eb7fe008974da$export$83d89fbfd8236492 = "hash/5.7.0";



var $74ec091a01b8d3e1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $74ec091a01b8d3e1$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $389eb7fe008974da$export$83d89fbfd8236492));
const $74ec091a01b8d3e1$var$padding = new Uint8Array(32);
$74ec091a01b8d3e1$var$padding.fill(0);
const $74ec091a01b8d3e1$var$NegativeOne = (0, $0df4577496dcf693$export$d97aa349ed20696).from(-1);
const $74ec091a01b8d3e1$var$Zero = (0, $0df4577496dcf693$export$d97aa349ed20696).from(0);
const $74ec091a01b8d3e1$var$One = (0, $0df4577496dcf693$export$d97aa349ed20696).from(1);
const $74ec091a01b8d3e1$var$MaxUint256 = (0, $0df4577496dcf693$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $74ec091a01b8d3e1$var$hexPadRight(value) {
    const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
        bytes,
        $74ec091a01b8d3e1$var$padding.slice(padOffset)
    ]);
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes);
}
const $74ec091a01b8d3e1$var$hexTrue = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)($74ec091a01b8d3e1$var$One.toHexString(), 32);
const $74ec091a01b8d3e1$var$hexFalse = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)($74ec091a01b8d3e1$var$Zero.toHexString(), 32);
const $74ec091a01b8d3e1$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $74ec091a01b8d3e1$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $74ec091a01b8d3e1$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $74ec091a01b8d3e1$var$domainChecks = {
    name: $74ec091a01b8d3e1$var$checkString("name"),
    version: $74ec091a01b8d3e1$var$checkString("version"),
    chainId: function(value) {
        try {
            return (0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toString();
        } catch (error) {}
        return $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $8aee8aee2d40605d$export$88411125f012957a)(value).toLowerCase();
        } catch (error) {}
        return $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        try {
            const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes);
        } catch (error) {}
        return $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function $74ec091a01b8d3e1$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $74ec091a01b8d3e1$var$logger.throwArgumentError("invalid numeric width", "type", type);
            const boundsUpper = $74ec091a01b8d3e1$var$MaxUint256.mask(signed ? width - 1 : width);
            const boundsLower = signed ? boundsUpper.add($74ec091a01b8d3e1$var$One).mul($74ec091a01b8d3e1$var$NegativeOne) : $74ec091a01b8d3e1$var$Zero;
            return function(value) {
                const v = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $74ec091a01b8d3e1$var$logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) $74ec091a01b8d3e1$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
                if (bytes.length !== width) $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                return $74ec091a01b8d3e1$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $8aee8aee2d40605d$export$88411125f012957a)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $74ec091a01b8d3e1$var$hexFalse : $74ec091a01b8d3e1$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(value);
            };
        case "string":
            return function(value) {
                return (0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(value);
            };
    }
    return null;
}
function $74ec091a01b8d3e1$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $74ec091a01b8d3e1$export$458ab927ae635c3 {
    constructor(types){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "types", Object.freeze((0, $a463a6b5f08d6875$export$6c40052bed430212)(types)));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_encoderCache", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type)=>{
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(const name in types){
            const uniqueNames = {};
            types[name].forEach((field)=>{
                // Check each field has a unique name
                if (uniqueNames[field.name]) $74ec091a01b8d3e1$var$logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $74ec091a01b8d3e1$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $74ec091a01b8d3e1$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $74ec091a01b8d3e1$var$logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n)=>parents[n].length === 0);
        if (primaryTypes.length === 0) $74ec091a01b8d3e1$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $74ec091a01b8d3e1$var$logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $74ec091a01b8d3e1$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach((child)=>{
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype)=>{
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(const name in subtypes){
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = $74ec091a01b8d3e1$var$encodeType(name, types[name]) + st.map((t)=>$74ec091a01b8d3e1$var$encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $74ec091a01b8d3e1$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value)=>{
                if (length >= 0 && value.length !== length) $74ec091a01b8d3e1$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                let result = value.map(subEncoder);
                if (this._types[subtype]) result = result.map((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35));
                return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$6d4b99629b38754a)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(this._types[type]);
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)(values);
            };
        }
        return $74ec091a01b8d3e1$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) $74ec091a01b8d3e1$var$logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $74ec091a01b8d3e1$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) $74ec091a01b8d3e1$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            return value.map((v)=>this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        return $74ec091a01b8d3e1$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new $74ec091a01b8d3e1$export$458ab927ae635c3(types);
    }
    static getPrimaryType(types) {
        return $74ec091a01b8d3e1$export$458ab927ae635c3.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return $74ec091a01b8d3e1$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            const type = $74ec091a01b8d3e1$var$domainFieldTypes[name];
            if (!type) $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $74ec091a01b8d3e1$var$domainFieldNames.indexOf(a.name) - $74ec091a01b8d3e1$var$domainFieldNames.indexOf(b.name);
        });
        return $74ec091a01b8d3e1$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    static encode(domain, types, value) {
        return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
            "0x1901",
            $74ec091a01b8d3e1$export$458ab927ae635c3.hashDomain(domain),
            $74ec091a01b8d3e1$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)($74ec091a01b8d3e1$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return $74ec091a01b8d3e1$var$__awaiter(this, void 0, void 0, function*() {
            // Make a copy to isolate it from the object passed in
            domain = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
            // We are going to use the encoder to visit all the base values
            const encoder = $74ec091a01b8d3e1$export$458ab927ae635c3.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value)=>{
                if (type === "address" && !(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value, 20)) ensCache[value] = "0x";
                return value;
            });
            // Lookup each name
            for(const name in ensCache)ensCache[name] = yield resolveName(name);
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value)=>{
                if (type === "address" && ensCache[value]) return ensCache[value];
                return value;
            });
            return {
                domain: domain,
                value: value
            };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        $74ec091a01b8d3e1$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $74ec091a01b8d3e1$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $74ec091a01b8d3e1$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $74ec091a01b8d3e1$var$domainFieldTypes[name]
            });
        });
        const encoder = $74ec091a01b8d3e1$export$458ab927ae635c3.from(types);
        const typesWithDomain = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(types);
        if (typesWithDomain.EIP712Domain) $74ec091a01b8d3e1$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        else typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof value !== "string") $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid string`, "value", value);
                        return value;
                }
                return $74ec091a01b8d3e1$var$logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}




const $d83cea76876f8e45$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $d83cea76876f8e45$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(message);
    return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)($d83cea76876f8e45$export$1ff3fdc4802a2ba6),
        (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(String(message.length)),
        message
    ]));
}


/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 

class $3fca3a6183b20b71$export$240043ab8e806ec7 {
    constructor(alphabet){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "alphabet", alphabet);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "base", alphabet.length);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_alphabetMap", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    encode(value) {
        let source = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(new Uint8Array(bytes.reverse()));
    }
}
const $3fca3a6183b20b71$export$cfabb2852920f5ec = new $3fca3a6183b20b71$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $3fca3a6183b20b71$export$45a587635c9954b2 = new $3fca3a6183b20b71$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))








var $da90616c06668669$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($da90616c06668669$export$d2a8849cfb277c || ($da90616c06668669$export$d2a8849cfb277c = {}));



const $7c32f9e80a4a2783$export$83d89fbfd8236492 = "sha2/5.7.0";


"use strict";
const $bb82ee6f1acbd7c8$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7c32f9e80a4a2783$export$83d89fbfd8236492));
function $bb82ee6f1acbd7c8$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).ripemd160().update((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).sha256().update((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $bb82ee6f1acbd7c8$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).sha512().update((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $da90616c06668669$export$d2a8849cfb277c)[algorithm]) $bb82ee6f1acbd7c8$var$logger.throwError("unsupported algorithm " + algorithm, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($ec7ff5071b027891$exports)))[algorithm], (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(key)).update((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data)).digest("hex");
}


"use strict";
function $52d8b575085ace3c$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(password);
    salt = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for(let i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(let j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff)(hashAlgorithm, password, U));
            for(let k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(T).slice(0, len), destPos);
    }
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(DK);
}









const $7b1f5e4d32c2ee77$export$83d89fbfd8236492 = "wordlists/5.7.0";


"use strict";
// This gets overridden by rollup
const $1aa3df27db978ea8$var$exportWordlist = false;
const $1aa3df27db978ea8$export$af88d00dbe7f521 = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b1f5e4d32c2ee77$export$83d89fbfd8236492));
class $1aa3df27db978ea8$export$4d9531a8ddb0ebca {
    constructor(locale){
        $1aa3df27db978ea8$export$af88d00dbe7f521.checkAbstract(new.target, $1aa3df27db978ea8$export$4d9531a8ddb0ebca);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "locale", locale);
    }
    // Subclasses may override this
    split(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
    join(words) {
        return words.join(" ");
    }
    static check(wordlist) {
        const words = [];
        for(let i = 0; i < 2048; i++){
            const word = wordlist.getWord(i);
            /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
            words.push(word);
        }
        return (0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(words.join("\n") + "\n");
    }
    static register(lang, name) {
        if (!name) name = lang.locale;
        /* istanbul ignore if */ if ($1aa3df27db978ea8$var$exportWordlist) try {
            const anyGlobal = window;
            if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                if (!anyGlobal._ethers.wordlists[name]) (0, $a463a6b5f08d6875$export$104236534534f9be)(anyGlobal._ethers.wordlists, name, lang);
            }
        } catch (error) {}
    }
}


"use strict";
const $e1c37ee3c90035e1$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let $e1c37ee3c90035e1$var$wordlist = null;
function $e1c37ee3c90035e1$var$loadWords(lang) {
    if ($e1c37ee3c90035e1$var$wordlist != null) return;
    $e1c37ee3c90035e1$var$wordlist = $e1c37ee3c90035e1$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $1aa3df27db978ea8$export$4d9531a8ddb0ebca).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $e1c37ee3c90035e1$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
class $e1c37ee3c90035e1$var$LangEn extends (0, $1aa3df27db978ea8$export$4d9531a8ddb0ebca) {
    constructor(){
        super("en");
    }
    getWord(index) {
        $e1c37ee3c90035e1$var$loadWords(this);
        return $e1c37ee3c90035e1$var$wordlist[index];
    }
    getWordIndex(word) {
        $e1c37ee3c90035e1$var$loadWords(this);
        return $e1c37ee3c90035e1$var$wordlist.indexOf(word);
    }
}
const $e1c37ee3c90035e1$export$a2c9518710cf1f49 = new $e1c37ee3c90035e1$var$LangEn();
(0, $1aa3df27db978ea8$export$4d9531a8ddb0ebca).register($e1c37ee3c90035e1$export$a2c9518710cf1f49);


"use strict";
const $c98b8711de347986$export$e8e1b4711c2d1939 = {
    en: (0, $e1c37ee3c90035e1$export$a2c9518710cf1f49)
};



const $6054160a15387c6c$export$83d89fbfd8236492 = "hdnode/5.7.0";


"use strict";
const $d830e21df8d45279$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $6054160a15387c6c$export$83d89fbfd8236492));
const $d830e21df8d45279$var$N = (0, $0df4577496dcf693$export$d97aa349ed20696).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const $d830e21df8d45279$var$MasterSecret = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)("Bitcoin seed");
const $d830e21df8d45279$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $d830e21df8d45279$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $d830e21df8d45279$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $d830e21df8d45279$var$bytes32(value) {
    return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value), 32);
}
function $d830e21df8d45279$var$base58check(data) {
    return (0, $3fca3a6183b20b71$export$45a587635c9954b2).encode((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        data,
        (0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)(data)), 0, 4)
    ]));
}
function $d830e21df8d45279$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $c98b8711de347986$export$e8e1b4711c2d1939)["en"];
    if (typeof wordlist === "string") {
        const words = (0, $c98b8711de347986$export$e8e1b4711c2d1939)[wordlist];
        if (words == null) $d830e21df8d45279$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
const $d830e21df8d45279$var$_constructorGuard = {};
const $d830e21df8d45279$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
class $d830e21df8d45279$export$b68640c53e22b952 {
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */ constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath){
        /* istanbul ignore if */ if (constructorGuard !== $d830e21df8d45279$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            const signingKey = new (0, $ff9f75f56da7c459$export$21643ca94aed3e83)(privateKey);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "privateKey", signingKey.privateKey);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "privateKey", null);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "publicKey", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(publicKey));
        }
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "parentFingerprint", parentFingerprint);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "fingerprint", (0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $bb82ee6f1acbd7c8$export$d1cea0ee4e3f0d3e)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)(this.publicKey)), 0, 4));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", (0, $0a7021bc70fec74d$export$e67e2732ba9803f9)(this.publicKey));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "chainCode", chainCode);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "index", index);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "mnemonic", null);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "mnemonic", null);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "mnemonic", mnemonicOrPath);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "path", mnemonicOrPath.path);
        }
    }
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) throw new Error("Depth too large!");
        return $d830e21df8d45279$var$base58check((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
            (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(this.depth),
            this.parentFingerprint,
            (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(this.index), 4),
            this.chainCode,
            this.privateKey != null ? (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
                "0x00",
                this.privateKey
            ]) : this.publicKey
        ]));
    }
    neuter() {
        return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
        // Base path
        let path = this.path;
        if (path) path += "/" + (index & ~$d830e21df8d45279$var$HardenedBit);
        const data = new Uint8Array(37);
        if (index & $d830e21df8d45279$var$HardenedBit) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            // Data = 0x00 || ser_256(k_par)
            data.set((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.privateKey), 1);
            // Hardened path
            if (path) path += "'";
        } else // Data = ser_p(point(k_par))
        data.set((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.publicKey));
        // Data += ser_32(i)
        for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
        const I = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff)((0, $da90616c06668669$export$d2a8849cfb277c).sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) ki = $d830e21df8d45279$var$bytes32((0, $0df4577496dcf693$export$d97aa349ed20696).from(IL).add(this.privateKey).mod($d830e21df8d45279$var$N));
        else {
            const ek = new (0, $ff9f75f56da7c459$export$21643ca94aed3e83)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) mnemonicOrPath = Object.freeze({
            phrase: srcMnemonic.phrase,
            path: path,
            locale: srcMnemonic.locale || "en"
        });
        return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, ki, Ki, this.fingerprint, $d830e21df8d45279$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
        if (components[0] === "m") components.shift();
        let result = this;
        for(let i = 0; i < components.length; i++){
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= $d830e21df8d45279$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive($d830e21df8d45279$var$HardenedBit + index);
            } else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= $d830e21df8d45279$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(index);
            } else throw new Error("invalid path component - " + component);
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(seed);
        if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
        const I = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff)((0, $da90616c06668669$export$d2a8849cfb277c).sha512, $d830e21df8d45279$var$MasterSecret, seedArray));
        return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, $d830e21df8d45279$var$bytes32(I.slice(0, 32)), null, "0x00000000", $d830e21df8d45279$var$bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = $d830e21df8d45279$var$getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = $d830e21df8d45279$export$4becd65eb23312e6($d830e21df8d45279$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
        return $d830e21df8d45279$export$b68640c53e22b952._fromSeed($d830e21df8d45279$export$3dee74f1204ab09f(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return $d830e21df8d45279$export$b68640c53e22b952._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = (0, $3fca3a6183b20b71$export$45a587635c9954b2).decode(extendedKey);
        if (bytes.length !== 82 || $d830e21df8d45279$var$base58check(bytes.slice(0, 78)) !== extendedKey) $d830e21df8d45279$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        const depth = bytes[4];
        const parentFingerprint = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(5, 9));
        const index = parseInt((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, null, (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return $d830e21df8d45279$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
}
function $d830e21df8d45279$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    const salt = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)("mnemonic" + password, (0, $b2a54ce293d87a2e$export$c6986442964129f5).NFKD);
    return (0, $52d8b575085ace3c$export$448fa22aedc9dbca)((0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(mnemonic, (0, $b2a54ce293d87a2e$export$c6986442964129f5).NFKD), salt, 2048, 64, "sha512");
}
function $d830e21df8d45279$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $d830e21df8d45279$var$getWordlist(wordlist);
    $d830e21df8d45279$var$logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    const entropy = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = $d830e21df8d45279$var$getUpperMask(checksumBits);
    const checksum = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(entropy.slice(0, entropyBits / 8));
}
function $d830e21df8d45279$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $d830e21df8d45279$var$getWordlist(wordlist);
    entropy = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $d830e21df8d45279$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)(entropy))[0] & $d830e21df8d45279$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
function $d830e21df8d45279$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $d830e21df8d45279$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $d830e21df8d45279$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $d830e21df8d45279$var$HardenedBit || index % 1) $d830e21df8d45279$var$logger.throwArgumentError("invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}






const $d4cbf396701ae91f$export$83d89fbfd8236492 = "random/5.7.0";


"use strict";
const $d0ff10d17aa2d59e$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $d4cbf396701ae91f$export$83d89fbfd8236492));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $d0ff10d17aa2d59e$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $d0ff10d17aa2d59e$var$anyGlobal = $d0ff10d17aa2d59e$var$getGlobal();
let $d0ff10d17aa2d59e$var$crypto = $d0ff10d17aa2d59e$var$anyGlobal.crypto || $d0ff10d17aa2d59e$var$anyGlobal.msCrypto;
if (!$d0ff10d17aa2d59e$var$crypto || !$d0ff10d17aa2d59e$var$crypto.getRandomValues) {
    $d0ff10d17aa2d59e$var$logger.warn("WARNING: Missing strong random number source");
    $d0ff10d17aa2d59e$var$crypto = {
        getRandomValues: function(buffer) {
            return $d0ff10d17aa2d59e$var$logger.throwError("no secure random source avaialble", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $d0ff10d17aa2d59e$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $d0ff10d17aa2d59e$var$logger.throwArgumentError("invalid length", "length", length);
    const result = new Uint8Array(length);
    $d0ff10d17aa2d59e$var$crypto.getRandomValues(result);
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(result);
}



var $df9de36cc74f2de2$exports = {};
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    $df9de36cc74f2de2$exports = aesjs;
})($df9de36cc74f2de2$exports);









const $2b288706101a2813$export$83d89fbfd8236492 = "json-wallets/5.7.0";




"use strict";
function $6180d5962b5fb34a$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(hexString);
}
function $6180d5962b5fb34a$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $6180d5962b5fb34a$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(password, (0, $b2a54ce293d87a2e$export$c6986442964129f5).NFKC);
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(password);
}
function $6180d5962b5fb34a$export$5a5c1dbd910e2c32(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split("/");
    for(let i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for(const key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $6180d5962b5fb34a$export$ec7b18ebad55a3a9(randomBytes) {
    const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}


"use strict";
const $be21d7d825475473$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $2b288706101a2813$export$83d89fbfd8236492));
class $be21d7d825475473$export$93a76d16f88f2b3 extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
function $be21d7d825475473$export$e85a0c9a1067c5d3(json, password) {
    const data = JSON.parse(json);
    password = (0, $6180d5962b5fb34a$export$350bd33120f7413e)(password);
    // Ethereum Address
    const ethaddr = (0, $8aee8aee2d40605d$export$88411125f012957a)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "ethaddr"));
    // Encrypted Seed
    const encseed = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $be21d7d825475473$var$logger.throwArgumentError("invalid encseed", "json", json);
    const key = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $52d8b575085ace3c$export$448fa22aedc9dbca)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).ModeOfOperation.cbc(key, iv);
    const seed = (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).padding.pkcs7.strip((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    const seedHexBytes = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(seedHex);
    const privateKey = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(seedHexBytes);
    return new $be21d7d825475473$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}



"use strict";
function $e21ba517a486d299$export$724d6cf6b9fd8578(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $e21ba517a486d299$export$67dc926b8e68b2d8(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $e21ba517a486d299$export$9a68ee9f8f3afd38(json) {
    if ($e21ba517a486d299$export$724d6cf6b9fd8578(json)) try {
        return (0, $8aee8aee2d40605d$export$88411125f012957a)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($e21ba517a486d299$export$67dc926b8e68b2d8(json)) try {
        return (0, $8aee8aee2d40605d$export$88411125f012957a)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}



var $d60cab1af588cd1e$exports = {};
"use strict";
(function(root) {
    const MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);
        function blocks(p) {
            let off = 0, len = p.length;
            while(len >= 64){
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        let i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);
        let i;
        let dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(let i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(let i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(let i = 0; i < 16; ++i)B[i] += x[i];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(let i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(let i = 0; i < o.length; i++){
            const v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r);
        for(let i = 0; i < B.length; i++){
            const j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);
        const Yi = 32 * r;
        // scratch space
        const x = new Uint32Array(16); // salsa20_8
        const _X = new Uint32Array(16); // blockmix_salsa8
        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        let stop = false;
        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;
        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            let steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        const offset = (2 * r - 1) * 16; // ROMix - 7
                        const j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(let i = 0; i < B.length; i++){
                        b.push(B[i] >> 0 & 0xff);
                        b.push(B[i] >> 8 & 0xff);
                        b.push(B[i] >> 16 & 0xff);
                        b.push(B[i] >> 24 & 0xff);
                    }
                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            const derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof $d60cab1af588cd1e$exports !== "undefined") $d60cab1af588cd1e$exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})($d60cab1af588cd1e$exports);













"use strict";
var $1cdfca8f3ea9db41$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $1cdfca8f3ea9db41$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $2b288706101a2813$export$83d89fbfd8236492));
// Exported Types
function $1cdfca8f3ea9db41$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
class $1cdfca8f3ea9db41$export$cf9dc4fd6dde0315 extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function $1cdfca8f3ea9db41$var$_decrypt(data, key, ciphertext) {
    const cipher = (0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/cipherparams/iv"));
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).ModeOfOperation.ctr(key, counter);
        return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $1cdfca8f3ea9db41$var$_getAccount(data, key) {
    const ciphertext = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/ciphertext"));
    const computedMAC = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    const privateKey = $1cdfca8f3ea9db41$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $1cdfca8f3ea9db41$var$logger.throwError("unsupported cipher", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    const mnemonicKey = key.slice(32, 64);
    const address = (0, $0a7021bc70fec74d$export$e67e2732ba9803f9)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $8aee8aee2d40605d$export$88411125f012957a)(check) !== address) throw new Error("address mismatch");
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).Counter(mnemonicIv);
        const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        const path = (0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "x-ethers/path") || (0, $d830e21df8d45279$export$d48ad89f7e11a603);
        const locale = (0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "x-ethers/locale") || "en";
        const entropy = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = (0, $d830e21df8d45279$export$4becd65eb23312e6)(entropy, locale);
            const node = (0, $d830e21df8d45279$export$b68640c53e22b952).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $1cdfca8f3ea9db41$export$cf9dc4fd6dde0315(account);
}
function $1cdfca8f3ea9db41$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $52d8b575085ace3c$export$448fa22aedc9dbca)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $1cdfca8f3ea9db41$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($1cdfca8f3ea9db41$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $1cdfca8f3ea9db41$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = (0, $6180d5962b5fb34a$export$350bd33120f7413e)(password);
    const kdf = (0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        const throwError = function(name, value) {
            return $1cdfca8f3ea9db41$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/salt"));
            const N = parseInt((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/n"));
            const r = parseInt((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/r"));
            const p = parseInt((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            const dkLen = parseInt((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = (0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            const count = parseInt((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/c"));
            const dkLen = parseInt((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return $1cdfca8f3ea9db41$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $1cdfca8f3ea9db41$export$9bd2c37889ee5e36(json, password) {
    const data = JSON.parse(json);
    const key = $1cdfca8f3ea9db41$var$_computeKdfKey(data, password, $1cdfca8f3ea9db41$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($d60cab1af588cd1e$exports))).syncScrypt);
    return $1cdfca8f3ea9db41$var$_getAccount(data, key);
}
function $1cdfca8f3ea9db41$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $1cdfca8f3ea9db41$var$__awaiter(this, void 0, void 0, function*() {
        const data = JSON.parse(json);
        const key = yield $1cdfca8f3ea9db41$var$_computeKdfKey(data, password, $1cdfca8f3ea9db41$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($d60cab1af588cd1e$exports))).scrypt, progressCallback);
        return $1cdfca8f3ea9db41$var$_getAccount(data, key);
    });
}
function $1cdfca8f3ea9db41$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $8aee8aee2d40605d$export$88411125f012957a)(account.address) !== (0, $0a7021bc70fec74d$export$e67e2732ba9803f9)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($1cdfca8f3ea9db41$var$hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = (0, $d830e21df8d45279$export$b68640c53e22b952).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $d830e21df8d45279$export$d48ad89f7e11a603));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    const privateKey = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(account.privateKey);
    const passwordBytes = (0, $6180d5962b5fb34a$export$350bd33120f7413e)(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if ($1cdfca8f3ea9db41$var$hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $d830e21df8d45279$export$135e090d58b310ca)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $d830e21df8d45279$export$d48ad89f7e11a603);
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    let salt = null;
    if (options.salt) salt = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(options.salt);
    else salt = (0, $d0ff10d17aa2d59e$export$5f828d93ff035aa8)(32);
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $d0ff10d17aa2d59e$export$5f828d93ff035aa8)(16);
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $d0ff10d17aa2d59e$export$5f828d93ff035aa8)(16);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($d60cab1af588cd1e$exports))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key)=>{
        key = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).ModeOfOperation.ctr(derivedKey, counter);
        const ciphertext = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $6180d5962b5fb34a$export$ec7b18ebad55a3a9)(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(iv).substring(2)
                },
                ciphertext: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = (0, $d0ff10d17aa2d59e$export$5f828d93ff035aa8)(16);
            const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).Counter(mnemonicIv);
            const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($df9de36cc74f2de2$exports))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = now.getUTCFullYear() + "-" + (0, $6180d5962b5fb34a$export$67752b99d3bc61c6)(now.getUTCMonth() + 1, 2) + "-" + (0, $6180d5962b5fb34a$export$67752b99d3bc61c6)(now.getUTCDate(), 2) + "T" + (0, $6180d5962b5fb34a$export$67752b99d3bc61c6)(now.getUTCHours(), 2) + "-" + (0, $6180d5962b5fb34a$export$67752b99d3bc61c6)(now.getUTCMinutes(), 2) + "-" + (0, $6180d5962b5fb34a$export$67752b99d3bc61c6)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}


"use strict";
function $ca5238b7fb30f36a$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $e21ba517a486d299$export$724d6cf6b9fd8578)(json)) {
        if (progressCallback) progressCallback(0);
        const account = (0, $be21d7d825475473$export$e85a0c9a1067c5d3)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $e21ba517a486d299$export$67dc926b8e68b2d8)(json)) return (0, $1cdfca8f3ea9db41$export$e85a0c9a1067c5d3)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $ca5238b7fb30f36a$export$7a81c437a678891a(json, password) {
    if ((0, $e21ba517a486d299$export$724d6cf6b9fd8578)(json)) return (0, $be21d7d825475473$export$e85a0c9a1067c5d3)(json, password);
    if ((0, $e21ba517a486d299$export$67dc926b8e68b2d8)(json)) return (0, $1cdfca8f3ea9db41$export$9bd2c37889ee5e36)(json, password);
    throw new Error("invalid JSON wallet");
}




const $e08684831330b7d7$export$83d89fbfd8236492 = "wallet/5.7.0";


"use strict";
var $3ff70163f9f2ebd5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $3ff70163f9f2ebd5$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $e08684831330b7d7$export$83d89fbfd8236492));
function $3ff70163f9f2ebd5$var$isAccount(value) {
    return value != null && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value.privateKey, 32) && value.address != null;
}
function $3ff70163f9f2ebd5$var$hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
class $3ff70163f9f2ebd5$export$bcca3ea514774656 extends (0, $deb85df20e19ba32$export$fdf54fdde81cc9f0) {
    constructor(privateKey, provider){
        super();
        if ($3ff70163f9f2ebd5$var$isAccount(privateKey)) {
            const signingKey = new (0, $ff9f75f56da7c459$export$21643ca94aed3e83)(privateKey.privateKey);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_signingKey", ()=>signingKey);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", (0, $0a7021bc70fec74d$export$e67e2732ba9803f9)(this.publicKey));
            if (this.address !== (0, $8aee8aee2d40605d$export$88411125f012957a)(privateKey.address)) $3ff70163f9f2ebd5$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($3ff70163f9f2ebd5$var$hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_mnemonic", ()=>({
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $d830e21df8d45279$export$d48ad89f7e11a603),
                        locale: srcMnemonic.locale || "en"
                    }));
                const mnemonic = this.mnemonic;
                const node = (0, $d830e21df8d45279$export$b68640c53e22b952).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $0a7021bc70fec74d$export$e67e2732ba9803f9)(node.privateKey) !== this.address) $3ff70163f9f2ebd5$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_mnemonic", ()=>null);
        } else {
            if ((0, $ff9f75f56da7c459$export$21643ca94aed3e83).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $3ff70163f9f2ebd5$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_signingKey", ()=>privateKey);
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                const signingKey = new (0, $ff9f75f56da7c459$export$21643ca94aed3e83)(privateKey);
                (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_signingKey", ()=>signingKey);
            }
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_mnemonic", ()=>null);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", (0, $0a7021bc70fec74d$export$e67e2732ba9803f9)(this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $81658ac0a17fba50$export$2881499e37b75b9a).isProvider(provider)) $3ff70163f9f2ebd5$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", provider || null);
    }
    get mnemonic() {
        return this._mnemonic();
    }
    get privateKey() {
        return this._signingKey().privateKey;
    }
    get publicKey() {
        return this._signingKey().publicKey;
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new $3ff70163f9f2ebd5$export$bcca3ea514774656(this, provider);
    }
    signTransaction(transaction) {
        return (0, $a463a6b5f08d6875$export$d503dd157d963b60)(transaction).then((tx)=>{
            if (tx.from != null) {
                if ((0, $8aee8aee2d40605d$export$88411125f012957a)(tx.from) !== this.address) $3ff70163f9f2ebd5$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                delete tx.from;
            }
            const signature = this._signingKey().signDigest((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $0a7021bc70fec74d$export$dfdc1655ccc5b9cb)(tx)));
            return (0, $0a7021bc70fec74d$export$dfdc1655ccc5b9cb)(tx, signature);
        });
    }
    signMessage(message) {
        return $3ff70163f9f2ebd5$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7b88b6e03e4708f2$export$71bb9d78a59bbe25)(this._signingKey().signDigest((0, $d83cea76876f8e45$export$d4c241cec96564c1)(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return $3ff70163f9f2ebd5$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names
            const populated = yield (0, $74ec091a01b8d3e1$export$458ab927ae635c3).resolveNames(domain, types, value, (name)=>{
                if (this.provider == null) $3ff70163f9f2ebd5$var$logger.throwError("cannot resolve ENS names without a provider", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "resolveName",
                    value: name
                });
                return this.provider.resolveName(name);
            });
            return (0, $7b88b6e03e4708f2$export$71bb9d78a59bbe25)(this._signingKey().signDigest((0, $74ec091a01b8d3e1$export$458ab927ae635c3).hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof options === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
        if (!options) options = {};
        return (0, $1cdfca8f3ea9db41$export$5b0f6292f11d1d18)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */ static createRandom(options) {
        let entropy = (0, $d0ff10d17aa2d59e$export$5f828d93ff035aa8)(16);
        if (!options) options = {};
        if (options.extraEntropy) entropy = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            entropy,
            options.extraEntropy
        ])), 0, 16));
        const mnemonic = (0, $d830e21df8d45279$export$4becd65eb23312e6)(entropy, options.locale);
        return $3ff70163f9f2ebd5$export$bcca3ea514774656.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return (0, $ca5238b7fb30f36a$export$e74fcde37488267a)(json, password, progressCallback).then((account)=>{
            return new $3ff70163f9f2ebd5$export$bcca3ea514774656(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new $3ff70163f9f2ebd5$export$bcca3ea514774656((0, $ca5238b7fb30f36a$export$7a81c437a678891a)(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) path = (0, $d830e21df8d45279$export$d48ad89f7e11a603);
        return new $3ff70163f9f2ebd5$export$bcca3ea514774656((0, $d830e21df8d45279$export$b68640c53e22b952).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
}
function $3ff70163f9f2ebd5$export$228d0e772cc158cb(message, signature) {
    return (0, $0a7021bc70fec74d$export$23cc18f96d8510e2)((0, $d83cea76876f8e45$export$d4c241cec96564c1)(message), signature);
}
function $3ff70163f9f2ebd5$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $0a7021bc70fec74d$export$23cc18f96d8510e2)((0, $74ec091a01b8d3e1$export$458ab927ae635c3).hash(domain, types, value), signature);
}


var $4c29a01839587aec$exports = {};

$parcel$export($4c29a01839587aec$exports, "AddressZero", () => $22c6f0407e5356d6$export$badd13187c087617);
$parcel$export($4c29a01839587aec$exports, "NegativeOne", () => $c5333cf79421e056$export$c83ef0909a6ddeec);
$parcel$export($4c29a01839587aec$exports, "Zero", () => $c5333cf79421e056$export$aaef8a3eae948f03);
$parcel$export($4c29a01839587aec$exports, "One", () => $c5333cf79421e056$export$9aa05a5866350bcf);
$parcel$export($4c29a01839587aec$exports, "Two", () => $c5333cf79421e056$export$9276dd97bf62cc8d);
$parcel$export($4c29a01839587aec$exports, "WeiPerEther", () => $c5333cf79421e056$export$c8db55bd7405209e);
$parcel$export($4c29a01839587aec$exports, "MaxUint256", () => $c5333cf79421e056$export$1b53890de5aabdd0);
$parcel$export($4c29a01839587aec$exports, "MinInt256", () => $c5333cf79421e056$export$963c9b9317b80aaf);
$parcel$export($4c29a01839587aec$exports, "MaxInt256", () => $c5333cf79421e056$export$6f8dbb07ebe6d738);
$parcel$export($4c29a01839587aec$exports, "HashZero", () => $9b26373cc461c855$export$71c2e4e213dcb7f2);
$parcel$export($4c29a01839587aec$exports, "EtherSymbol", () => $deb5368d1753dad5$export$c7e79fcb6f8ac048);
const $22c6f0407e5356d6$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";



const $9b26373cc461c855$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";


// NFKC (composed)             // (decomposed)
const $deb5368d1753dad5$export$c7e79fcb6f8ac048 = "\u039E"; // "\uD835\uDF63";


"use strict";


var $859153647bbc688f$exports = {};

$parcel$export($859153647bbc688f$exports, "getDefaultProvider", () => $859153647bbc688f$export$4f77a1d3c1ac6642);
$parcel$export($859153647bbc688f$exports, "Provider", () => $81658ac0a17fba50$export$2881499e37b75b9a);
$parcel$export($859153647bbc688f$exports, "BaseProvider", () => $43e733c7f2a529c1$export$ff3f6dd83125ac45);
$parcel$export($859153647bbc688f$exports, "Resolver", () => $43e733c7f2a529c1$export$8b4c839865b08288);
$parcel$export($859153647bbc688f$exports, "UrlJsonRpcProvider", () => $8044ebfe209f61e4$export$664128d6239ccf96);
$parcel$export($859153647bbc688f$exports, "FallbackProvider", () => $14eaab77c6d2e466$export$cb1d0beacb55feb7);
$parcel$export($859153647bbc688f$exports, "AlchemyProvider", () => $e94c62bb842b5925$export$999cc40da3fbc6f);
$parcel$export($859153647bbc688f$exports, "AlchemyWebSocketProvider", () => $e94c62bb842b5925$export$f6c13301c7b76371);
$parcel$export($859153647bbc688f$exports, "AnkrProvider", () => $efd7dc521b26566c$export$72783b2aefa72a45);
$parcel$export($859153647bbc688f$exports, "CloudflareProvider", () => $cdd214e3d1599302$export$7113381f8f264fc0);
$parcel$export($859153647bbc688f$exports, "EtherscanProvider", () => $d7687248e25a81ef$export$dd1d942a536c7912);
$parcel$export($859153647bbc688f$exports, "InfuraProvider", () => $1be1b51d2ba5e5c5$export$60ff1a559b5c6ebd);
$parcel$export($859153647bbc688f$exports, "InfuraWebSocketProvider", () => $1be1b51d2ba5e5c5$export$dd168a807d60da4f);
$parcel$export($859153647bbc688f$exports, "JsonRpcProvider", () => $e32f9441afb0a406$export$da28308012bf6748);
$parcel$export($859153647bbc688f$exports, "JsonRpcBatchProvider", () => $a926fa2c67f65d9a$export$5a16092bf20edf97);
$parcel$export($859153647bbc688f$exports, "NodesmithProvider", () => $dcb00489ffa41a84$export$8235cbce3ce273bd);
$parcel$export($859153647bbc688f$exports, "PocketProvider", () => $fbe10c5df3b2b203$export$58bb47e42f6b092e);
$parcel$export($859153647bbc688f$exports, "StaticJsonRpcProvider", () => $8044ebfe209f61e4$export$b3d647c1c29df44d);
$parcel$export($859153647bbc688f$exports, "Web3Provider", () => $c7f9e560d629e6df$export$d05096c9fd9d936d);
$parcel$export($859153647bbc688f$exports, "WebSocketProvider", () => $f2ba8b3ea7dcf3ca$export$bfafe629242f30bd);
$parcel$export($859153647bbc688f$exports, "IpcProvider", () => $9b4b4c9da3406148$export$fbe151f90a1ece01);
$parcel$export($859153647bbc688f$exports, "JsonRpcSigner", () => $e32f9441afb0a406$export$5f7b5fca3508545a);
$parcel$export($859153647bbc688f$exports, "getNetwork", () => $17c84d4c9be9446e$export$7de4970ebfd8206d);
$parcel$export($859153647bbc688f$exports, "isCommunityResource", () => $dc6c759982861e14$export$d93d5f61c2498b6);
$parcel$export($859153647bbc688f$exports, "isCommunityResourcable", () => $dc6c759982861e14$export$3091239f5b20b896);
$parcel$export($859153647bbc688f$exports, "showThrottleMessage", () => $dc6c759982861e14$export$4c41bd49e82e82ab);
$parcel$export($859153647bbc688f$exports, "Formatter", () => $dc6c759982861e14$export$a06636add2a09fd8);


const $5f8483051c1cd7c9$export$83d89fbfd8236492 = "networks/5.7.1";


"use strict";
const $17c84d4c9be9446e$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $5f8483051c1cd7c9$export$83d89fbfd8236492));
function $17c84d4c9be9446e$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $17c84d4c9be9446e$var$ethDefaultProvider(network) {
    const func = function(providers, options) {
        if (options == null) options = {};
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider && options.etherscan !== "-") try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider && options.alchemy !== "-") try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = [
                "goerli",
                "ropsten",
                "rinkeby",
                "sepolia"
            ];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providers.AnkrProvider && options.ankr !== "-") try {
            const skip = [
                "ropsten"
            ];
            const provider = new providers.AnkrProvider(network, options.ankr);
            if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $17c84d4c9be9446e$var$ethDefaultProvider(network);
    };
    return func;
}
function $17c84d4c9be9446e$var$etcDefaultProvider(url, network) {
    const func = function(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $17c84d4c9be9446e$var$etcDefaultProvider(url, network);
    };
    return func;
}
const $17c84d4c9be9446e$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("homestead")
};
const $17c84d4c9be9446e$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("ropsten")
};
const $17c84d4c9be9446e$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $17c84d4c9be9446e$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const $17c84d4c9be9446e$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $17c84d4c9be9446e$var$homestead,
    mainnet: $17c84d4c9be9446e$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $17c84d4c9be9446e$var$ropsten,
    testnet: $17c84d4c9be9446e$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $17c84d4c9be9446e$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $17c84d4c9be9446e$var$classicMordor,
    classicTestnet: $17c84d4c9be9446e$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $17c84d4c9be9446e$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("matic")
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("optimism")
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    "arbitrum-goerli": {
        chainId: 421613,
        name: "arbitrum-goerli"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $17c84d4c9be9446e$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(const name in $17c84d4c9be9446e$var$networks){
            const standard = $17c84d4c9be9446e$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        const standard = $17c84d4c9be9446e$var$networks[network];
        if (standard == null) return null;
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: standard._defaultProvider || null
        };
    }
    const standard = $17c84d4c9be9446e$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof network.chainId !== "number") $17c84d4c9be9446e$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) $17c84d4c9be9446e$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if ($17c84d4c9be9446e$var$isRenetworkable(standard._defaultProvider)) defaultProvider = standard._defaultProvider.renetwork(network);
        else defaultProvider = standard._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: network.ensAddress || standard.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}




"use strict";
function $1d2ab8f2156e640e$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    const data = [];
    for(let i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
}
function $1d2ab8f2156e640e$export$c564cdbbe6da493(data) {
    data = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}











/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ // https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function $a30010648e61cae9$var$flat(array, depth) {
    if (depth == null) depth = 1;
    const result = [];
    const forEach = result.forEach;
    const flatDeep = function(arr, depth) {
        forEach.call(arr, function(val) {
            if (depth > 0 && Array.isArray(val)) flatDeep(val, depth - 1);
            else result.push(val);
        });
    };
    flatDeep(array, depth);
    return result;
}
function $a30010648e61cae9$var$fromEntries(array) {
    const result = {};
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function $a30010648e61cae9$export$956eeed0f8f2ceff(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = Math.pow(2, N);
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
function $a30010648e61cae9$export$2cda812f22276871(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $a30010648e61cae9$export$671d8b4ebc0c42ad(bytes) {
    return $a30010648e61cae9$export$2cda812f22276871($a30010648e61cae9$export$956eeed0f8f2ceff(bytes));
}
function $a30010648e61cae9$export$a785de3a2a8dd1aa(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $a30010648e61cae9$var$read_counts(n, next) {
    let v = Array(n);
    for(let i = 0; i < n; i++)v[i] = 1 + next();
    return v;
}
function $a30010648e61cae9$var$read_ascending(n, next) {
    let v = Array(n);
    for(let i = 0, x = -1; i < n; i++)v[i] = x += 1 + next();
    return v;
}
function $a30010648e61cae9$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $a30010648e61cae9$export$a785de3a2a8dd1aa(next());
    return v;
}
function $a30010648e61cae9$export$9303bf4e1ede4914(next, lookup) {
    let v = $a30010648e61cae9$var$read_ascending(next(), next);
    let n = next();
    let vX = $a30010648e61cae9$var$read_ascending(n, next);
    let vN = $a30010648e61cae9$var$read_counts(n, next);
    for(let i = 0; i < n; i++)for(let j = 0; j < vN[i]; j++)v.push(vX[i] + j);
    return lookup ? v.map((x)=>lookup[x]) : v;
}
function $a30010648e61cae9$export$824d00fb01c38bd9(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($a30010648e61cae9$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($a30010648e61cae9$var$read_replacement_table(w, next));
    }
    return $a30010648e61cae9$var$fromEntries($a30010648e61cae9$var$flat(ret));
}
function $a30010648e61cae9$export$e9011071590ab431(next) {
    let v = [];
    while(true){
        let i = next();
        if (i == 0) break;
        v.push(i);
    }
    return v;
}
function $a30010648e61cae9$var$read_transposed(n, w, next) {
    let m = Array(n).fill(undefined).map(()=>[]);
    for(let i = 0; i < w; i++)$a30010648e61cae9$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
function $a30010648e61cae9$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $a30010648e61cae9$export$e9011071590ab431(next);
    let m = $a30010648e61cae9$var$read_transposed(vN.length, 1 + w, next);
    return $a30010648e61cae9$var$flat(m.map((v, i)=>{
        const x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    }));
}
function $a30010648e61cae9$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $a30010648e61cae9$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $a30010648e61cae9$export$d7b24c6ce369e1b7(next) {
    let sorted = $a30010648e61cae9$export$9303bf4e1ede4914(next).sort((a, b)=>a - b);
    return read();
    function read() {
        let branches = [];
        while(true){
            let keys = $a30010648e61cae9$export$9303bf4e1ede4914(next, sorted);
            if (keys.length == 0) break;
            branches.push({
                set: new Set(keys),
                node: read()
            });
        }
        branches.sort((a, b)=>b.set.size - a.set.size); // sort by likelihood
        let temp = next();
        let valid = temp % 3;
        temp = temp / 3 | 0;
        let fe0f = !!(temp & 1);
        temp >>= 1;
        let save = temp == 1;
        let check = temp == 2;
        return {
            branches: branches,
            valid: valid,
            fe0f: fe0f,
            save: save,
            check: check
        };
    }
}


function $15597a7af7fcc2e4$export$7a171f172be0782e() {
    return (0, $a30010648e61cae9$export$671d8b4ebc0c42ad)((0, $1d2ab8f2156e640e$export$2f872c0f2117be69)("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"));
}



const $8676be15da7193bb$var$r = (0, $15597a7af7fcc2e4$export$7a171f172be0782e)();
// @TODO: This should be lazily loaded
const $8676be15da7193bb$var$VALID = new Set((0, $a30010648e61cae9$export$9303bf4e1ede4914)($8676be15da7193bb$var$r));
const $8676be15da7193bb$var$IGNORED = new Set((0, $a30010648e61cae9$export$9303bf4e1ede4914)($8676be15da7193bb$var$r));
const $8676be15da7193bb$var$MAPPED = (0, $a30010648e61cae9$export$824d00fb01c38bd9)($8676be15da7193bb$var$r);
const $8676be15da7193bb$var$EMOJI_ROOT = (0, $a30010648e61cae9$export$d7b24c6ce369e1b7)($8676be15da7193bb$var$r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
const $8676be15da7193bb$var$HYPHEN = 0x2D;
const $8676be15da7193bb$var$UNDERSCORE = 0x5F;
function $8676be15da7193bb$var$explode_cp(name) {
    return (0, $b2a54ce293d87a2e$export$ae470a36a31b28c2)(name);
}
function $8676be15da7193bb$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != 0xFE0F);
}
function $8676be15da7193bb$export$5252e54b57fcf4fd(name) {
    for (let label of name.split(".")){
        let cps = $8676be15da7193bb$var$explode_cp(label);
        try {
            for(let i = cps.lastIndexOf($8676be15da7193bb$var$UNDERSCORE) - 1; i >= 0; i--){
                if (cps[i] !== $8676be15da7193bb$var$UNDERSCORE) throw new Error(`underscore only allowed at start`);
            }
            if (cps.length >= 4 && cps.every((cp)=>cp < 0x80) && cps[2] === $8676be15da7193bb$var$HYPHEN && cps[3] === $8676be15da7193bb$var$HYPHEN) throw new Error(`invalid label extension`);
        } catch (err) {
            throw new Error(`Invalid label "${label}": ${err.message}`);
        }
    }
    return name;
}
function $8676be15da7193bb$export$499f715881831a51(name) {
    return $8676be15da7193bb$export$5252e54b57fcf4fd($8676be15da7193bb$var$normalize(name, $8676be15da7193bb$var$filter_fe0f));
}
function $8676be15da7193bb$var$normalize(name, emoji_filter) {
    let input = $8676be15da7193bb$var$explode_cp(name).reverse(); // flip for pop
    let output = [];
    while(input.length){
        let emoji = $8676be15da7193bb$var$consume_emoji_reversed(input);
        if (emoji) {
            output.push(...emoji_filter(emoji));
            continue;
        }
        let cp = input.pop();
        if ($8676be15da7193bb$var$VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if ($8676be15da7193bb$var$IGNORED.has(cp)) continue;
        let cps = $8676be15da7193bb$var$MAPPED[cp];
        if (cps) {
            output.push(...cps);
            continue;
        }
        throw new Error(`Disallowed codepoint: 0x${cp.toString(16).toUpperCase()}`);
    }
    return $8676be15da7193bb$export$5252e54b57fcf4fd($8676be15da7193bb$var$nfc(String.fromCodePoint(...output)));
}
function $8676be15da7193bb$var$nfc(s) {
    return s.normalize("NFC");
}
function $8676be15da7193bb$var$consume_emoji_reversed(cps, eaten) {
    var _a;
    let node = $8676be15da7193bb$var$EMOJI_ROOT;
    let emoji;
    let saved;
    let stack = [];
    let pos = cps.length;
    if (eaten) eaten.length = 0; // clear input buffer (if needed)
    while(pos){
        let cp = cps[--pos];
        node = (_a = node.branches.find((x)=>x.set.has(cp))) === null || _a === void 0 ? void 0 : _a.node;
        if (!node) break;
        if (node.save) saved = cp;
        else if (node.check) {
            if (cp === saved) break;
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F) pos--; // consume optional FE0F
        }
        if (node.valid) {
            emoji = stack.slice(); // copy stack
            if (node.valid == 2) emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)
            cps.length = pos; // truncate
        }
    }
    return emoji;
}


const $62768931dfa5f58f$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $389eb7fe008974da$export$83d89fbfd8236492));
const $62768931dfa5f58f$var$Zeros = new Uint8Array(32);
$62768931dfa5f58f$var$Zeros.fill(0);
function $62768931dfa5f58f$var$checkComponent(comp) {
    if (comp.length === 0) throw new Error("invalid ENS name; empty component");
    return comp;
}
function $62768931dfa5f58f$var$ensNameSplit(name) {
    const bytes = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)((0, $8676be15da7193bb$export$499f715881831a51)(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($62768931dfa5f58f$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) throw new Error("invalid ENS name; empty component");
    comps.push($62768931dfa5f58f$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $62768931dfa5f58f$export$5f232fd2f1a1e8ac(name) {
    return $62768931dfa5f58f$var$ensNameSplit(name).map((comp)=>(0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(comp)).join(".");
}
function $62768931dfa5f58f$export$cce2300886e7ace6(name) {
    try {
        return $62768931dfa5f58f$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $62768931dfa5f58f$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $62768931dfa5f58f$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    let result = $62768931dfa5f58f$var$Zeros;
    const comps = $62768931dfa5f58f$var$ensNameSplit(name);
    while(comps.length)result = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        result,
        (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(comps.pop())
    ]));
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(result);
}
function $62768931dfa5f58f$export$6c0a8cdae51cb512(name) {
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)($62768931dfa5f58f$var$ensNameSplit(name).map((comp)=>{
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}











const $42333c997d417afb$export$83d89fbfd8236492 = "web/5.7.1";



"use strict";
var $6dbd18c809d22593$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $6dbd18c809d22593$export$94df0e59ebebf4a7(href, options) {
    return $6dbd18c809d22593$var$__awaiter(this, void 0, void 0, function*() {
        if (options == null) options = {};
        const request = {
            method: options.method || "GET",
            headers: options.headers || {},
            body: options.body || undefined
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        if (options.fetchOptions != null) {
            const opts = options.fetchOptions;
            if (opts.mode) request.mode = opts.mode;
            if (opts.cache) request.cache = opts.cache;
            if (opts.credentials) request.credentials = opts.credentials;
            if (opts.redirect) request.redirect = opts.redirect;
            if (opts.referrer) request.referrer = opts.referrer;
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) response.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        else response.headers.keys().forEach((key)=>{
            headers[key.toLowerCase()] = response.headers.get(key);
        });
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(new Uint8Array(body))
        };
    });
}


"use strict";
var $4d026a5befa5b358$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $4d026a5befa5b358$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $42333c997d417afb$export$83d89fbfd8236492));
function $4d026a5befa5b358$var$staller(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $4d026a5befa5b358$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $7b88b6e03e4708f2$export$9a14abb1a440cd5e)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(value);
        } catch (error) {}
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value);
    }
    return value;
}
function $4d026a5befa5b358$var$unpercent(value) {
    return (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $4d026a5befa5b358$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $4d026a5befa5b358$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $4d026a5befa5b358$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET"
    };
    let allow304 = false;
    let timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $4d026a5befa5b358$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(const key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $4d026a5befa5b358$var$logger.throwError("basic authentication requires a secure https url", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $1d2ab8f2156e640e$export$c564cdbbe6da493)((0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
        if (connection.fetchOptions != null) options.fetchOptions = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(connection.fetchOptions);
    }
    const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    const dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        const response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1] || "text/plain"
            },
            body: dataMatch[2] ? (0, $1d2ab8f2156e640e$export$2f872c0f2117be69)(dataMatch[3]) : $4d026a5befa5b358$var$unpercent(dataMatch[3])
        };
        let result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $4d026a5befa5b358$var$logger.throwError("processing response error", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
            body: $4d026a5befa5b358$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key)=>{
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = function() {
        let timer = null;
        const promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                reject($4d026a5befa5b358$var$logger.makeError("timeout", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.TIMEOUT, {
                    requestBody: $4d026a5befa5b358$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        const cancel = function() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    const runningFetch = function() {
        return $4d026a5befa5b358$var$__awaiter(this, void 0, void 0, function*() {
            for(let attempt = 0; attempt < attemptLimit; attempt++){
                let response = null;
                try {
                    response = yield (0, $6dbd18c809d22593$export$94df0e59ebebf4a7)(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        } else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                                else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling 429");
                                yield $4d026a5befa5b358$var$staller(stall);
                                continue;
                            }
                        }
                    }
                } catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        $4d026a5befa5b358$var$logger.throwError("missing response", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                            requestBody: $4d026a5befa5b358$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) body = null;
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    $4d026a5befa5b358$var$logger.throwError("bad response", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: $4d026a5befa5b358$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        requestBody: $4d026a5befa5b358$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) try {
                    const result = yield processFunc(body, response);
                    runningTimeout.cancel();
                    return result;
                } catch (error) {
                    // Allow the processFunc to trigger a throttle
                    if (error.throttleRetry && attempt < attemptLimit) {
                        let tryAgain = true;
                        if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                        if (tryAgain) {
                            const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                            //console.log("Stalling callback");
                            yield $4d026a5befa5b358$var$staller(timeout);
                            continue;
                        }
                    }
                    runningTimeout.cancel();
                    $4d026a5befa5b358$var$logger.throwError("processing response error", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                        body: $4d026a5befa5b358$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        error: error,
                        requestBody: $4d026a5befa5b358$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return $4d026a5befa5b358$var$logger.throwError("failed response", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                requestBody: $4d026a5befa5b358$var$bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $4d026a5befa5b358$export$6d71b655afe1638d(connection, json, processFunc) {
    let processJsonFunc = (value, response)=>{
        let result = null;
        if (value != null) try {
            result = JSON.parse((0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(value));
        } catch (error) {
            $4d026a5befa5b358$var$logger.throwError("invalid JSON", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(json);
        // Create a connection with the content-type set for JSON
        const updated = typeof connection === "string" ? {
            url: connection
        } : (0, $a463a6b5f08d6875$export$9c13236873b118a5)(connection);
        if (updated.headers) {
            const hasContentType = Object.keys(updated.headers).filter((k)=>k.toLowerCase() === "content-type").length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $4d026a5befa5b358$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $4d026a5befa5b358$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = ()=>{
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(()=>{
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}


var $58c329f65c659a19$exports = {};
"use strict";
var $58c329f65c659a19$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $58c329f65c659a19$var$ALPHABET_MAP = {};
for(var $58c329f65c659a19$var$z = 0; $58c329f65c659a19$var$z < $58c329f65c659a19$var$ALPHABET.length; $58c329f65c659a19$var$z++){
    var $58c329f65c659a19$var$x = $58c329f65c659a19$var$ALPHABET.charAt($58c329f65c659a19$var$z);
    if ($58c329f65c659a19$var$ALPHABET_MAP[$58c329f65c659a19$var$x] !== undefined) throw new TypeError($58c329f65c659a19$var$x + " is ambiguous");
    $58c329f65c659a19$var$ALPHABET_MAP[$58c329f65c659a19$var$x] = $58c329f65c659a19$var$z;
}
function $58c329f65c659a19$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $58c329f65c659a19$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $58c329f65c659a19$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $58c329f65c659a19$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $58c329f65c659a19$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $58c329f65c659a19$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $58c329f65c659a19$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $58c329f65c659a19$var$polymodStep(chk) ^ x;
        result += $58c329f65c659a19$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $58c329f65c659a19$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $58c329f65c659a19$var$ALPHABET.charAt(v);
    }
    return result;
}
function $58c329f65c659a19$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $58c329f65c659a19$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $58c329f65c659a19$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $58c329f65c659a19$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $58c329f65c659a19$var$decodeUnsafe() {
    var res = $58c329f65c659a19$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $58c329f65c659a19$var$decode(str) {
    var res = $58c329f65c659a19$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $58c329f65c659a19$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $58c329f65c659a19$var$toWordsUnsafe(bytes) {
    var res = $58c329f65c659a19$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $58c329f65c659a19$var$toWords(bytes) {
    var res = $58c329f65c659a19$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $58c329f65c659a19$var$fromWordsUnsafe(words) {
    var res = $58c329f65c659a19$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $58c329f65c659a19$var$fromWords(words) {
    var res = $58c329f65c659a19$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
$58c329f65c659a19$exports = {
    decodeUnsafe: $58c329f65c659a19$var$decodeUnsafe,
    decode: $58c329f65c659a19$var$decode,
    encode: $58c329f65c659a19$var$encode,
    toWordsUnsafe: $58c329f65c659a19$var$toWordsUnsafe,
    toWords: $58c329f65c659a19$var$toWords,
    fromWordsUnsafe: $58c329f65c659a19$var$fromWordsUnsafe,
    fromWords: $58c329f65c659a19$var$fromWords
};



const $fd8f67b80e142427$export$83d89fbfd8236492 = "providers/5.7.2";










"use strict";
const $dc6c759982861e14$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
class $dc6c759982861e14$export$a06636add2a09fd8 {
    constructor(){
        this.formats = this.getDefaultFormats();
    }
    getDefaultFormats() {
        const formats = {};
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v)=>{
            return this.data(v, true);
        };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null),
            blockHash: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hash, null),
            blockNumber: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number, null),
            transactionIndex: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number, null),
            confirmations: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.uint256),
            s: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.uint256),
            v: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            creates: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address, null),
            raw: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(data)
        };
        formats.transactionRequest = {
            from: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address),
            nonce: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            gasLimit: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            gasPrice: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            to: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address),
            value: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            data: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(strictData),
            type: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            accessList: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null)
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: $dc6c759982861e14$export$a06636add2a09fd8.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash
        };
        formats.receipt = {
            to: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.address, null),
            from: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.address, null),
            contractAddress: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: $dc6c759982861e14$export$a06636add2a09fd8.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            status: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            type: type
        };
        formats.block = {
            hash: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address),
            extraData: data,
            transactions: $dc6c759982861e14$export$a06636add2a09fd8.allowNull($dc6c759982861e14$export$a06636add2a09fd8.arrayOf(hash)),
            baseFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber)
        };
        formats.blockWithTransactions = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(formats.block);
        formats.blockWithTransactions.transactions = $dc6c759982861e14$export$a06636add2a09fd8.allowNull($dc6c759982861e14$export$a06636add2a09fd8.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            toBlock: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            blockHash: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hash, undefined),
            address: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address, undefined),
            topics: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.topics.bind(this), undefined)
        };
        formats.filterLog = {
            blockNumber: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            blockHash: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hash),
            transactionIndex: number,
            removed: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.boolean.bind(this)),
            address: address,
            data: $dc6c759982861e14$export$a06636add2a09fd8.allowFalsish(data, "0x"),
            topics: $dc6c759982861e14$export$a06636add2a09fd8.arrayOf(hash),
            transactionHash: hash,
            logIndex: number
        };
        return formats;
    }
    accessList(accessList) {
        return (0, $0a7021bc70fec74d$export$6c8662b1600dce2)(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") return 0;
        return (0, $0df4577496dcf693$export$d97aa349ed20696).from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) return 0;
        return (0, $0df4577496dcf693$export$d97aa349ed20696).from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") {
            value = value.toLowerCase();
            if (value === "true") return true;
            if (value === "false") return false;
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof value === "string") {
            if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
            if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value)) return value.toLowerCase();
        }
        return $dc6c759982861e14$var$logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return (0, $8aee8aee2d40605d$export$88411125f012957a)(value);
    }
    callAddress(value) {
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value, 32)) return null;
        const address = (0, $8aee8aee2d40605d$export$88411125f012957a)((0, $7b88b6e03e4708f2$export$15da666eba198c18)(value, 12));
        return address === (0, $22c6f0407e5356d6$export$badd13187c087617) ? null : address;
    }
    contractAddress(value) {
        return (0, $8aee8aee2d40605d$export$b7fbffef12272e40)(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) return "latest";
        if (blockTag === "earliest") return "0x0";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "latest":
            case "pending":
            case "safe":
            case "finalized":
                return blockTag;
        }
        if (typeof blockTag === "number" || (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(blockTag)) return (0, $7b88b6e03e4708f2$export$6916af760a341dd3)(blockTag);
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(result) !== 32) return $dc6c759982861e14$var$logger.throwArgumentError("invalid hash", "value", value);
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) return null;
        const v = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
        try {
            return v.toNumber();
        } catch (error) {}
        return null;
    }
    uint256(value) {
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value)) throw new Error("invalid uint256");
        return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) value.miner = value.author;
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
        const result = $dc6c759982861e14$export$a06636add2a09fd8.check(format, value);
        result._difficulty = difficulty == null ? null : (0, $0df4577496dcf693$export$d97aa349ed20696).from(difficulty);
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && (0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
        // Rename input to data
        if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
        const result = $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(chainId)) chainId = (0, $0df4577496dcf693$export$d97aa349ed20696).from(chainId).toNumber();
            result.chainId = chainId;
        } else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) chainId = transaction.chainId;
            if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(chainId)) chainId = (0, $0df4577496dcf693$export$d97aa349ed20696).from(chainId).toNumber();
            if (typeof chainId !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) chainId = 0;
                chainId = parseInt(chainId);
            }
            if (typeof chainId !== "number") chainId = 0;
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
        return result;
    }
    transaction(value) {
        return (0, $0a7021bc70fec74d$export$98e6a39c04603d36)(value);
    }
    receiptLog(value) {
        return $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = (0, $0df4577496dcf693$export$d97aa349ed20696).from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && result.status !== value) $dc6c759982861e14$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                        root: result.root,
                        status: result.status
                    });
                    result.status = value;
                    delete result.root;
                } else $dc6c759982861e14$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
            } else if (result.root.length !== 66) // Must be a valid bytes32
            $dc6c759982861e14$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
        }
        if (result.status != null) result.byzantium = true;
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) return value.map((v)=>this.topics(v));
        else if (value != null) return this.hash(value, true);
        return null;
    }
    filter(value) {
        return $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.filter, value);
    }
    filterLog(value) {
        return $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for(const key in format)try {
            const value = format[key](object[key]);
            if (value !== undefined) result[key] = value;
        } catch (error) {
            error.checkKey = key;
            error.checkValue = object[key];
            throw error;
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return function(value) {
            if (value == null) return nullValue;
            return format(value);
        };
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return function(value) {
            if (!value) return replaceValue;
            return format(value);
        };
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return function(array) {
            if (!Array.isArray(array)) throw new Error("not an array");
            const result = [];
            array.forEach(function(value) {
                result.push(format(value));
            });
            return result;
        };
    }
}
function $dc6c759982861e14$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $dc6c759982861e14$export$d93d5f61c2498b6(value) {
    return $dc6c759982861e14$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
let $dc6c759982861e14$var$throttleMessage = false;
function $dc6c759982861e14$export$4c41bd49e82e82ab() {
    if ($dc6c759982861e14$var$throttleMessage) return;
    $dc6c759982861e14$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}


"use strict";
var $43e733c7f2a529c1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $43e733c7f2a529c1$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
const $43e733c7f2a529c1$var$MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function $43e733c7f2a529c1$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(topic) !== 32) $43e733c7f2a529c1$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $43e733c7f2a529c1$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map((topic)=>{
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic)=>{
                unique[$43e733c7f2a529c1$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $43e733c7f2a529c1$var$checkTopic(topic);
    }).join("&");
}
function $43e733c7f2a529c1$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map((topic)=>{
        if (topic === "") return [];
        const comps = topic.split("|").map((topic)=>{
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $43e733c7f2a529c1$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $43e733c7f2a529c1$var$serializeTopics(eventName);
    else if ((0, $81658ac0a17fba50$export$406ece1549ccd00e).isForkEvent(eventName)) {
        $43e733c7f2a529c1$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $43e733c7f2a529c1$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $43e733c7f2a529c1$var$getTime() {
    return new Date().getTime();
}
function $43e733c7f2a529c1$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ const $43e733c7f2a529c1$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
class $43e733c7f2a529c1$export$d61e24a684f9e51 {
    constructor(tag, listener, once){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "tag", tag);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "listener", listener);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    get event() {
        switch(this.type){
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") return null;
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") return null;
        const address = comps[1];
        const topics = $43e733c7f2a529c1$var$deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) filter.topics = topics;
        if (address && address !== "*") filter.address = address;
        return filter;
    }
    pollable() {
        return this.tag.indexOf(":") >= 0 || $43e733c7f2a529c1$var$PollableEvents.indexOf(this.tag) >= 0;
    }
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const $43e733c7f2a529c1$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $43e733c7f2a529c1$var$bytes32ify(value) {
    return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $43e733c7f2a529c1$var$base58Encode(data) {
    return (0, $3fca3a6183b20b71$export$45a587635c9954b2).encode((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        data,
        (0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)(data)), 0, 4)
    ]));
}
const $43e733c7f2a529c1$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $43e733c7f2a529c1$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $43e733c7f2a529c1$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $43e733c7f2a529c1$var$_parseString(result, start) {
    try {
        return (0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)($43e733c7f2a529c1$var$_parseBytes(result, start));
    } catch (error) {}
    return null;
}
function $43e733c7f2a529c1$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    const offset = (0, $0df4577496dcf693$export$d97aa349ed20696).from((0, $7b88b6e03e4708f2$export$15da666eba198c18)(result, start, start + 32)).toNumber();
    const length = (0, $0df4577496dcf693$export$d97aa349ed20696).from((0, $7b88b6e03e4708f2$export$15da666eba198c18)(result, offset, offset + 32)).toNumber();
    return (0, $7b88b6e03e4708f2$export$15da666eba198c18)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $43e733c7f2a529c1$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else $43e733c7f2a529c1$var$logger.throwArgumentError("unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function $43e733c7f2a529c1$var$numPad(value) {
    const result = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $43e733c7f2a529c1$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function $43e733c7f2a529c1$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push(null);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(datas[i]);
        // Update the bytes offset
        result[i] = $43e733c7f2a529c1$var$numPad(byteCount);
        // The length and padded value of data
        result.push($43e733c7f2a529c1$var$numPad(data.length));
        result.push($43e733c7f2a529c1$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)(result);
}
class $43e733c7f2a529c1$export$8b4c839865b08288 {
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", provider);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "name", name);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", provider.formatter.address(address));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_resolvedAddress", resolvedAddress);
    }
    supportsWildcard() {
        if (!this._supportsEip2544) // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
        this._supportsEip2544 = this.provider.call({
            to: this.address,
            data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
        }).then((result)=>{
            return (0, $0df4577496dcf693$export$d97aa349ed20696).from(result).eq(1);
        }).catch((error)=>{
            if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION) return false;
            // Rethrow the error: link is down, etc. Let future attempts retry.
            this._supportsEip2544 = null;
            throw error;
        });
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
                    selector,
                    (0, $62768931dfa5f58f$export$91d651ee363e1209)(this.name),
                    parameters || "0x"
                ])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
                    "0x9061b923",
                    $43e733c7f2a529c1$var$encodeBytes([
                        (0, $62768931dfa5f58f$export$6c0a8cdae51cb512)(this.name),
                        tx.data
                    ])
                ]);
            }
            try {
                let result = yield this.provider.call(tx);
                if ((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(result).length % 32 === 4) $43e733c7f2a529c1$var$logger.throwError("resolver threw error", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    transaction: tx,
                    data: result
                });
                if (parseBytes) result = $43e733c7f2a529c1$var$_parseBytes(result, 0);
                return result;
            } catch (error) {
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION) return null;
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._fetch(selector, parameters);
            if (result != null) return $43e733c7f2a529c1$var$_parseBytes(result, 0);
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = $43e733c7f2a529c1$var$coinInfos[String(coinType)];
        if (coinInfo == null) $43e733c7f2a529c1$var$logger.throwError(`unsupported coin type: ${coinType}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: `getAddress(${coinType})`
        });
        if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
        const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $43e733c7f2a529c1$var$base58Encode((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
                    [
                        coinInfo.p2pkh
                    ],
                    "0x" + p2pkh[2]
                ]));
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) return $43e733c7f2a529c1$var$base58Encode((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
                    [
                        coinInfo.p2sh
                    ],
                    "0x" + p2sh[2]
                ]));
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) version = -1;
            } else version = -1;
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = (0, (/*@__PURE__*/$parcel$interopDefault($58c329f65c659a19$exports))).toWords(bytes.slice(2));
                words.unshift(version);
                return (0, (/*@__PURE__*/$parcel$interopDefault($58c329f65c659a19$exports))).encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (coinType == null) coinType = 60;
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) try {
                // keccak256("addr(bytes32)")
                const result = yield this._fetch("0x3b3b57de");
                // No address
                if (result === "0x" || result === (0, $9b26373cc461c855$export$71c2e4e213dcb7f2)) return null;
                return this.provider.formatter.callAddress(result);
            } catch (error) {
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION) return null;
                throw error;
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", $43e733c7f2a529c1$var$bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") return null;
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) $43e733c7f2a529c1$var$logger.throwError(`invalid or unsupported coin data`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`,
                coinType: coinType,
                data: hexBytes
            });
            return address;
        });
    }
    getAvatar() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const linkage = [
                {
                    type: "name",
                    content: this.name
                }
            ];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) return null;
                for(let i = 0; i < $43e733c7f2a529c1$var$matchers.length; i++){
                    const match = avatar.match($43e733c7f2a529c1$var$matchers[i]);
                    if (match == null) continue;
                    const scheme = match[1].toLowerCase();
                    switch(scheme){
                        case "https":
                            linkage.push({
                                type: "url",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "data":
                            linkage.push({
                                type: "data",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "ipfs":
                            linkage.push({
                                type: "ipfs",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: $43e733c7f2a529c1$var$getIpfsLink(avatar)
                            };
                        case "erc721":
                        case "erc1155":
                            {
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                const selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                // The owner of this name
                                const owner = this._resolvedAddress || (yield this.getAddress());
                                const comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return null;
                                const addr = yield this.provider.formatter.address(comps[0]);
                                const tokenId = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $0df4577496dcf693$export$d97aa349ed20696).from(comps[1]).toHexString(), 32);
                                // Check that this account owns the token
                                if (scheme === "erc721") {
                                    // ownerOf(uint256 tokenId)
                                    const tokenOwner = this.provider.formatter.callAddress((yield this.provider.call({
                                        to: addr,
                                        data: (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })));
                                    if (owner !== tokenOwner) return null;
                                    linkage.push({
                                        type: "owner",
                                        content: tokenOwner
                                    });
                                } else if (scheme === "erc1155") {
                                    // balanceOf(address owner, uint256 tokenId)
                                    const balance = (0, $0df4577496dcf693$export$d97aa349ed20696).from((yield this.provider.call({
                                        to: addr,
                                        data: (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
                                            "0x00fdd58e",
                                            (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(owner, 32),
                                            tokenId
                                        ])
                                    })));
                                    if (balance.isZero()) return null;
                                    linkage.push({
                                        type: "balance",
                                        content: balance.toString()
                                    });
                                }
                                // Call the token contract for the metadata URL
                                const tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                let metadataUrl = $43e733c7f2a529c1$var$_parseString((yield this.provider.call(tx)), 0);
                                if (metadataUrl == null) return null;
                                linkage.push({
                                    type: "metadata-url-base",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Transform IPFS metadata links
                                if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $43e733c7f2a529c1$var$getIpfsLink(metadataUrl);
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                // Get the token metadata
                                const metadata = yield (0, $4d026a5befa5b358$export$6d71b655afe1638d)(metadataUrl);
                                if (!metadata) return null;
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                // Pull the image URL out
                                let imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return null;
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    // Transform IPFS link to gateway
                                    const ipfs = imageUrl.match($43e733c7f2a529c1$var$matcherIpfs);
                                    if (ipfs == null) return null;
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $43e733c7f2a529c1$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return {
                                    linkage: linkage,
                                    url: imageUrl
                                };
                            }
                    }
                }
            } catch (error) {}
            return null;
        });
    }
    getContentHash() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") return null;
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) return "ipfs://" + (0, $3fca3a6183b20b71$export$45a587635c9954b2).encode("0x" + ipfs[1]);
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) return "ipns://" + (0, $3fca3a6183b20b71$export$45a587635c9954b2).encode("0x" + ipns[1]);
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === 64) return "bzz://" + swarm[1];
            }
            const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
            if (skynet) {
                if (skynet[1].length === 68) {
                    // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                    const urlSafe = {
                        "=": "",
                        "+": "-",
                        "/": "_"
                    };
                    const hash = (0, $1d2ab8f2156e640e$export$c564cdbbe6da493)("0x" + skynet[1]).replace(/[=+\/]/g, (a)=>urlSafe[a]);
                    return "sia://" + hash;
                }
            }
            return $43e733c7f2a529c1$var$logger.throwError(`invalid or unsupported content hash data`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            // The key encoded as parameter to fetchBytes
            let keyBytes = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
                $43e733c7f2a529c1$var$bytes32ify(64),
                $43e733c7f2a529c1$var$bytes32ify(keyBytes.length),
                keyBytes
            ]);
            // Pad to word-size (32 bytes)
            if (keyBytes.length % 32 !== 0) keyBytes = (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
                keyBytes,
                (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)("0x", 32 - key.length % 32)
            ]);
            const hexBytes = yield this._fetchBytes("0x59d1d43c", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(keyBytes));
            if (hexBytes == null || hexBytes === "0x") return null;
            return (0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(hexBytes);
        });
    }
}
let $43e733c7f2a529c1$var$defaultFormatter = null;
let $43e733c7f2a529c1$var$nextPollId = 1;
class $43e733c7f2a529c1$export$ff3f6dd83125ac45 extends (0, $81658ac0a17fba50$export$2881499e37b75b9a) {
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */ constructor(network){
        super();
        // Events being listened to
        this._events = [];
        this._emitted = {
            block: -2
        };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "anyNetwork", network === "any");
        if (this.anyNetwork) network = this.detectNetwork();
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error)=>{});
            // Trigger initial network setting (async)
            this._ready().catch((error)=>{});
        } else {
            const knownNetwork = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getNetwork")(network);
            if (knownNetwork) {
                (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            } else $43e733c7f2a529c1$var$logger.throwArgumentError("invalid network", "network", network);
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
    _ready() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) try {
                    network = yield this._networkPromise;
                } catch (error) {}
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) network = yield this.detectNetwork();
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) $43e733c7f2a529c1$var$logger.throwError("no network detected", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {});
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) this._network = network;
                    else (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return (0, $4d026a5befa5b358$export$e0c10349b2c5e1d4)(()=>{
            return this._ready().then((network)=>{
                return network;
            }, (error)=>{
                // If the network isn't running yet, we will wait
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if ($43e733c7f2a529c1$var$defaultFormatter == null) $43e733c7f2a529c1$var$defaultFormatter = new (0, $dc6c759982861e14$export$a06636add2a09fd8)();
        return $43e733c7f2a529c1$var$defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return (0, $17c84d4c9be9446e$export$7de4970ebfd8206d)(network == null ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (this.disableCcipRead || urls.length === 0) return null;
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for(let i = 0; i < urls.length; i++){
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
                    data: data,
                    sender: sender
                });
                const result = yield (0, $4d026a5befa5b358$export$6d71b655afe1638d)({
                    url: href,
                    errorPassThrough: true
                }, json, (value, response)=>{
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) return result.data;
                const errorMessage = result.message || "unknown error";
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) return $43e733c7f2a529c1$var$logger.throwError(`response not found during CCIP fetch: ${errorMessage}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    url: url,
                    errorMessage: errorMessage
                });
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return $43e733c7f2a529c1$var$logger.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                urls: urls,
                errorMessages: errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) // While there are pending internal block requests...
            while(this._internalBlockNumber){
                // ..."remember" which fetch we started with
                const internalBlockNumber = this._internalBlockNumber;
                try {
                    // Check the result is not too stale
                    const result = yield internalBlockNumber;
                    if ($43e733c7f2a529c1$var$getTime() - result.respTime <= maxAge) return result.blockNumber;
                    break;
                } catch (error) {
                    // The fetch rejected; if we are the first to get the
                    // rejection, drop through so we replace it with a new
                    // fetch; all others blocked will then get that fetch
                    // which won't match the one they "remembered" and loop
                    if (this._internalBlockNumber === internalBlockNumber) break;
                }
            }
            const reqTime = $43e733c7f2a529c1$var$getTime();
            const checkInternalBlockNumber = (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network)=>null, (error)=>error)
            }).then(({ blockNumber: blockNumber, networkError: networkError })=>{
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
                    throw networkError;
                }
                const respTime = $43e733c7f2a529c1$var$getTime();
                blockNumber = (0, $0df4577496dcf693$export$d97aa349ed20696).from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) blockNumber = this._maxInternalBlockNumber;
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return {
                    blockNumber: blockNumber,
                    reqTime: reqTime,
                    respTime: respTime
                };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error)=>{
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const pollId = $43e733c7f2a529c1$var$nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            } catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
            if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                $43e733c7f2a529c1$var$logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", $43e733c7f2a529c1$var$logger.makeError("network block skew detected", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            } else // Notify all listener for each block that has passed
            for(let i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key)=>{
                    // The block event does not expire
                    if (key === "block") return;
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") return;
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) delete this._emitted[key];
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
            // Find all transaction hashes we are waiting on
            this._events.forEach((event)=>{
                switch(event.type){
                    case "tx":
                        {
                            const hash = event.hash;
                            let runner = this.getTransactionReceipt(hash).then((receipt)=>{
                                if (!receipt || receipt.blockNumber == null) return null;
                                this._emitted["t:" + hash] = receipt.blockNumber;
                                this.emit(hash, receipt);
                                return null;
                            }).catch((error)=>{
                                this.emit("error", error);
                            });
                            runners.push(runner);
                            break;
                        }
                    case "filter":
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // This is the first filter for this event, so we want to
                            // restrict events to events that happened no earlier than now
                            if (event._lastBlockNumber === -2) event._lastBlockNumber = blockNumber - 1;
                            // Filter from the last *known* event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild, since it is quite
                            // likely there just haven't been any events to move the lastBlockNumber.
                            const minFromBlock = filter.toBlock - this._maxFilterBlockRange;
                            if (minFromBlock > filter.fromBlock) filter.fromBlock = minFromBlock;
                            if (filter.fromBlock < 0) filter.fromBlock = 0;
                            const runner = this.getLogs(filter).then((logs)=>{
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) return;
                                logs.forEach((log)=>{
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) event._lastBlockNumber = log.blockNumber;
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error)=>{
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(()=>{
                this.emit("didPoll", pollId);
            }).catch((error)=>{
                this.emit("error", error);
            });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) this.poll();
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            return $43e733c7f2a529c1$var$logger.throwError("provider does not support network detection", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield $43e733c7f2a529c1$var$stall(0);
                    return this._network;
                }
                const error = $43e733c7f2a529c1$var$logger.makeError("underlying network changed", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber)=>{
            this._setFastBlockNumber(blockNumber);
        }, (error)=>{});
        return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
    }
    get polling() {
        return this._poller != null;
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(()=>{
                this.poll();
            }, this.pollingInterval);
            if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(()=>{
                this.poll();
                // We block additional polls until the polling interval
                // is done, to prevent overwhelming the poll function
                this._bootstrapPoll = setTimeout(()=>{
                    // If polling was disabled, something may require a poke
                    // since starting the bootstrap poll and it was disabled
                    if (!this._poller) this.poll();
                    // Clear out the bootstrap so we can do another
                    this._bootstrapPoll = null;
                }, this.pollingInterval);
            }, 0);
        } else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(()=>{
                this.poll();
            }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = $43e733c7f2a529c1$var$getTime();
        // Stale block number, request a newer value
        if (now - this._fastQueryDate > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber)=>{
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) this._fastBlockNumber = blockNumber;
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
        // Update the time we updated the blocknumber
        this._fastQueryDate = $43e733c7f2a529c1$var$getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            return this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) return receipt;
            // Poll until the receipt is good...
            return new Promise((resolve, reject)=>{
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function() {
                    if (done) return true;
                    done = true;
                    cancelFuncs.forEach((func)=>{
                        func();
                    });
                    return false;
                };
                const minedHandler = (receipt)=>{
                    if (receipt.confirmations < confirmations) return;
                    if (alreadyDone()) return;
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(()=>{
                    this.removeListener(transactionHash, minedHandler);
                });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber)=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                            if (done) return;
                            // Wait 1 second; this is only used in the case of a fault, so
                            // we will trade off a little bit of latency for more consistent
                            // results and fewer JSON-RPC calls
                            yield $43e733c7f2a529c1$var$stall(1000);
                            this.getTransactionCount(replaceable.from).then((nonce)=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                                    if (done) return;
                                    if (nonce <= replaceable.nonce) lastBlockNumber = blockNumber;
                                    else {
                                        // First check if the transaction was mined
                                        {
                                            const mined = yield this.getTransaction(transactionHash);
                                            if (mined && mined.blockNumber != null) return;
                                        }
                                        // First time scanning. We start a little earlier for some
                                        // wiggle room here to handle the eventually consistent nature
                                        // of blockchain (e.g. the getTransactionCount was for a
                                        // different block)
                                        if (scannedBlock == null) {
                                            scannedBlock = lastBlockNumber - 3;
                                            if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                        }
                                        while(scannedBlock <= blockNumber){
                                            if (done) return;
                                            const block = yield this.getBlockWithTransactions(scannedBlock);
                                            for(let ti = 0; ti < block.transactions.length; ti++){
                                                const tx = block.transactions[ti];
                                                // Successfully mined!
                                                if (tx.hash === transactionHash) return;
                                                // Matches our transaction from and nonce; its a replacement
                                                if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                                    if (done) return;
                                                    // Get the receipt of the replacement
                                                    const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                                    // Already resolved or rejected (prolly a timeout)
                                                    if (alreadyDone()) return;
                                                    // The reason we were replaced
                                                    let reason = "replaced";
                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                    // Explain why we were replaced
                                                    reject($43e733c7f2a529c1$var$logger.makeError("transaction was replaced", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.TRANSACTION_REPLACED, {
                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                        reason: reason,
                                                        replacement: this._wrapTransaction(tx),
                                                        hash: transactionHash,
                                                        receipt: receipt
                                                    }));
                                                    return;
                                                }
                                            }
                                            scannedBlock++;
                                        }
                                    }
                                    if (done) return;
                                    this.once("block", replaceHandler);
                                }), (error)=>{
                                if (done) return;
                                this.once("block", replaceHandler);
                            });
                        });
                    if (done) return;
                    this.once("block", replaceHandler);
                    cancelFuncs.push(()=>{
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof timeout === "number" && timeout > 0) {
                    const timer = setTimeout(()=>{
                        if (alreadyDone()) return;
                        reject($43e733c7f2a529c1$var$logger.makeError("timeout exceeded", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.TIMEOUT, {
                            timeout: timeout
                        }));
                    }, timeout);
                    if (timer.unref) timer.unref();
                    cancelFuncs.push(()=>{
                        clearTimeout(timer);
                    });
                }
            });
        });
    }
    getBlockNumber() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return (0, $0df4577496dcf693$export$d97aa349ed20696).from(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result: result,
                    error: error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return (0, $0df4577496dcf693$export$d97aa349ed20696).from(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getBalance",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return (0, $0df4577496dcf693$export$d97aa349ed20696).from(result).toNumber();
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getCode",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p)=>(0, $7b88b6e03e4708f2$export$6916af760a341dd3)(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && (0, $7b88b6e03e4708f2$export$13882f896d3c0683)(hash) !== 32) throw new Error("invalid response - sendTransaction");
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) $43e733c7f2a529c1$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {
            expectedHash: tx.hash,
            returnedHash: hash
        });
        result.wait = (confirms, timeout)=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                if (confirms == null) confirms = 1;
                if (timeout == null) timeout = 0;
                // Get the details to detect replacement
                let replacement = undefined;
                if (confirms !== 0 && startBlock != null) replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock: startBlock
                };
                const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
                if (receipt == null && confirms === 0) return null;
                // No longer pending, allow the polling loop to garbage collect this
                this._emitted["t:" + tx.hash] = receipt.blockNumber;
                if (receipt.status === 0) $43e733c7f2a529c1$var$logger.throwError("transaction failed", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
                return receipt;
            });
        return result;
    }
    sendTransaction(signedTransaction) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then((t)=>(0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) tx.confirmations = 0;
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", {
                    signedTransaction: hexTx
                });
                return this._wrapTransaction(tx, hash, blockNumber);
            } catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const values = yield transaction;
            const tx = {};
            [
                "from",
                "to"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? this._getAddress(v) : null);
            });
            [
                "gasLimit",
                "gasPrice",
                "maxFeePerGas",
                "maxPriorityFeePerGas",
                "value"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $0df4577496dcf693$export$d97aa349ed20696).from(v) : null);
            });
            [
                "type"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v != null ? v : null);
            });
            if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
            [
                "data"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(v) : null);
            });
            return this.formatter.transactionRequest((yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)(tx)));
        });
    }
    _getFilter(filter) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            filter = yield filter;
            const result = {};
            if (filter.address != null) result.address = this._getAddress(filter.address);
            [
                "blockHash",
                "topics"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = filter[key];
            });
            [
                "fromBlock",
                "toBlock"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter((yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)(result)));
        });
    }
    _call(transaction, blockTag, attempt) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (attempt >= $43e733c7f2a529c1$var$MAX_CCIP_REDIRECTS) $43e733c7f2a529c1$var$logger.throwError("CCIP read exceeded maximum redirections", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                redirects: attempt,
                transaction: transaction
            });
            const txSender = transaction.to;
            const result = yield this.perform("call", {
                transaction: transaction,
                blockTag: blockTag
            });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (0, $7b88b6e03e4708f2$export$13882f896d3c0683)(result) % 32 === 4) try {
                const data = (0, $7b88b6e03e4708f2$export$15da666eba198c18)(result, 4);
                // Check the sender of the OffchainLookup matches the transaction
                const sender = (0, $7b88b6e03e4708f2$export$15da666eba198c18)(data, 0, 32);
                if (!(0, $0df4577496dcf693$export$d97aa349ed20696).from(sender).eq(txSender)) $43e733c7f2a529c1$var$logger.throwError("CCIP Read sender did not match", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                // Read the URLs from the response
                const urls = [];
                const urlsOffset = (0, $0df4577496dcf693$export$d97aa349ed20696).from((0, $7b88b6e03e4708f2$export$15da666eba198c18)(data, 32, 64)).toNumber();
                const urlsLength = (0, $0df4577496dcf693$export$d97aa349ed20696).from((0, $7b88b6e03e4708f2$export$15da666eba198c18)(data, urlsOffset, urlsOffset + 32)).toNumber();
                const urlsData = (0, $7b88b6e03e4708f2$export$15da666eba198c18)(data, urlsOffset + 32);
                for(let u = 0; u < urlsLength; u++){
                    const url = $43e733c7f2a529c1$var$_parseString(urlsData, u * 32);
                    if (url == null) $43e733c7f2a529c1$var$logger.throwError("CCIP Read contained corrupt URL string", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                        name: "OffchainLookup",
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        transaction: transaction,
                        data: result
                    });
                    urls.push(url);
                }
                // Get the CCIP calldata to forward
                const calldata = $43e733c7f2a529c1$var$_parseBytes(data, 64);
                // Get the callbackSelector (bytes4)
                if (!(0, $0df4577496dcf693$export$d97aa349ed20696).from((0, $7b88b6e03e4708f2$export$15da666eba198c18)(data, 100, 128)).isZero()) $43e733c7f2a529c1$var$logger.throwError("CCIP Read callback selector included junk", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const callbackSelector = (0, $7b88b6e03e4708f2$export$15da666eba198c18)(data, 96, 100);
                // Get the extra data to send back to the contract as context
                const extraData = $43e733c7f2a529c1$var$_parseBytes(data, 128);
                const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                if (ccipResult == null) $43e733c7f2a529c1$var$logger.throwError("CCIP Read disabled or provided no URLs", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const tx = {
                    to: txSender,
                    data: (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
                        callbackSelector,
                        $43e733c7f2a529c1$var$encodeBytes([
                            ccipResult,
                            extraData
                        ])
                    ])
                };
                return this._call(tx, blockTag, attempt + 1);
            } catch (error) {
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR) throw error;
            }
            try {
                return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "call",
                    params: {
                        transaction: transaction,
                        blockTag: blockTag
                    },
                    result: result,
                    error: error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const resolved = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return (0, $0df4577496dcf693$export$d97aa349ed20696).from(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            addressOrName = yield addressOrName;
            if (typeof addressOrName !== "string") $43e733c7f2a529c1$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            const address = yield this.resolveName(addressOrName);
            if (address == null) $43e733c7f2a529c1$var$logger.throwError("ENS name not configured", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: `resolveName(${JSON.stringify(addressOrName)})`
            });
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(blockHashOrBlockTag, 32)) params.blockHash = blockHashOrBlockTag;
            else try {
                params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
            } catch (error) {
                $43e733c7f2a529c1$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
            }
            return (0, $4d026a5befa5b358$export$e0c10349b2c5e1d4)(()=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                    const block = yield this.perform("getBlock", params);
                    // Block was not found
                    if (block == null) {
                        // For blockhashes, if we didn't say it existed, that blockhash may
                        // not exist. If we did see it though, perhaps from a log, we know
                        // it exists, and this node is just not caught up yet.
                        if (params.blockHash != null) {
                            if (this._emitted["b:" + params.blockHash] == null) return null;
                        }
                        // For block tags, if we are asking for a future block, we return null
                        if (params.blockTag != null) {
                            if (blockNumber > this._emitted.block) return null;
                        }
                        // Retry on the next block
                        return undefined;
                    }
                    // Add transactions
                    if (includeTransactions) {
                        let blockNumber = null;
                        for(let i = 0; i < block.transactions.length; i++){
                            const tx = block.transactions[i];
                            if (tx.blockNumber == null) tx.confirmations = 0;
                            else if (tx.confirmations == null) {
                                if (blockNumber == null) blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                                // Add the confirmations using the fast block number (pessimistic)
                                let confirmations = blockNumber - tx.blockNumber + 1;
                                if (confirmations <= 0) confirmations = 1;
                                tx.confirmations = confirmations;
                            }
                        }
                        const blockWithTxs = this.formatter.blockWithTransactions(block);
                        blockWithTxs.transactions = blockWithTxs.transactions.map((tx)=>this._wrapTransaction(tx));
                        return blockWithTxs;
                    }
                    return this.formatter.block(block);
                }), {
                oncePoll: this
            });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, false);
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, true);
    }
    getTransaction(transactionHash) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $4d026a5befa5b358$export$e0c10349b2c5e1d4)(()=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransaction", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    const tx = this.formatter.transactionResponse(result);
                    if (tx.blockNumber == null) tx.confirmations = 0;
                    else if (tx.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - tx.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        tx.confirmations = confirmations;
                    }
                    return this._wrapTransaction(tx);
                }), {
                oncePoll: this
            });
        });
    }
    getTransactionReceipt(transactionHash) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $4d026a5befa5b358$export$e0c10349b2c5e1d4)(()=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransactionReceipt", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    // "geth-etc" returns receipts before they are ready
                    if (result.blockHash == null) return undefined;
                    const receipt = this.formatter.receipt(result);
                    if (receipt.blockNumber == null) receipt.confirmations = 0;
                    else if (receipt.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - receipt.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        receipt.confirmations = confirmations;
                    }
                    return receipt;
                }), {
                oncePoll: this
            });
        });
    }
    getLogs(filter) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                filter: this._getFilter(filter)
            });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log)=>{
                if (log.removed == null) log.removed = false;
            });
            return (0, $dc6c759982861e14$export$a06636add2a09fd8).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            blockTag = yield blockTag;
            if (typeof blockTag === "number" && blockTag < 0) {
                if (blockTag % 1) $43e733c7f2a529c1$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) blockNumber = 0;
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            let currentName = name;
            while(true){
                if (currentName === "" || currentName === ".") return null;
                // Optimization since the eth node cannot change and does
                // not have a wildcard resolver
                if (name !== "eth" && currentName === "eth") return null;
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new $43e733c7f2a529c1$export$8b4c839865b08288(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) return null;
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (operation == null) operation = "ENS";
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) $43e733c7f2a529c1$var$logger.throwError("network does not support ENS", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: operation,
                network: network.name
            });
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: "0x0178b8bf" + (0, $62768931dfa5f58f$export$91d651ee363e1209)(name).substring(2)
                });
                return this.formatter.callAddress(addrData);
            } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            } catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(name)) throw error;
            }
            if (typeof name !== "string") $43e733c7f2a529c1$var$logger.throwArgumentError("invalid ENS name", "name", name);
            // Get the addr from the resolver
            const resolver = yield this.getResolver(name);
            if (!resolver) return null;
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) return null;
            // keccak("name(bytes32)")
            const name = $43e733c7f2a529c1$var$_parseString((yield this.call({
                to: resolverAddr,
                data: "0x691f3431" + (0, $62768931dfa5f58f$export$91d651ee363e1209)(node).substring(2)
            })), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) return null;
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            let resolver = null;
            if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) return null;
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new $43e733c7f2a529c1$export$8b4c839865b08288(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) return avatar.url;
                } catch (error) {
                    if (error.code !== (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION) throw error;
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = $43e733c7f2a529c1$var$_parseString((yield this.call({
                        to: resolverAddress,
                        data: "0x691f3431" + (0, $62768931dfa5f58f$export$91d651ee363e1209)(node).substring(2)
                    })), 0);
                    resolver = yield this.getResolver(name);
                } catch (error) {
                    if (error.code !== (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION) throw error;
                    return null;
                }
            } else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) return null;
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) return null;
            return avatar.url;
        });
    }
    perform(method, params) {
        return $43e733c7f2a529c1$var$logger.throwError(method + " not implemented", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
            operation: method
        });
    }
    _startEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _stopEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _addEventListener(eventName, listener, once) {
        const event = new $43e733c7f2a529c1$export$d61e24a684f9e51($43e733c7f2a529c1$var$getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag) return true;
            setTimeout(()=>{
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) return this._events.length;
        let eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
        return this._events.filter((event)=>{
            return event.tag === eventTag;
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) return this._events.map((event)=>event.listener);
        let eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
        return this._events.filter((event)=>event.tag === eventTag).map((event)=>event.listener);
    }
    off(eventName, listener) {
        if (listener == null) return this.removeAllListeners(eventName);
        const stopped = [];
        let found = false;
        let eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag || event.listener != listener) return true;
            if (found) return true;
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        } else {
            const eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
            this._events = this._events.filter((event)=>{
                if (event.tag !== eventTag) return true;
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
}

















"use strict";
var $e32f9441afb0a406$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $e32f9441afb0a406$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
const $e32f9441afb0a406$var$errorGas = [
    "call",
    "estimateGas"
];
function $e32f9441afb0a406$var$spelunk(value, requireData) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match("reverted")) {
        const data = (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value.data) ? value.data : null;
        if (!requireData || data) return {
            message: value.message,
            data: data
        };
    }
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $e32f9441afb0a406$var$spelunk(value[key], requireData);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $e32f9441afb0a406$var$spelunk(JSON.parse(value), requireData);
    } catch (error) {}
    return null;
}
function $e32f9441afb0a406$var$checkError(method, error, params) {
    const transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = $e32f9441afb0a406$var$spelunk(error, true);
        if (result) return result.data;
        // Nothing descriptive..
        $e32f9441afb0a406$var$logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
            data: "0x",
            transaction: transaction,
            error: error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        let result = $e32f9441afb0a406$var$spelunk(error.body, false);
        if (result == null) result = $e32f9441afb0a406$var$spelunk(error, false);
        // Found "reverted", this is a CALL_EXCEPTION
        if (result) $e32f9441afb0a406$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
            reason: result.message,
            method: method,
            transaction: transaction,
            error: error
        });
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) $e32f9441afb0a406$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) $e32f9441afb0a406$var$logger.throwError("nonce has already been used", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) $e32f9441afb0a406$var$logger.throwError("replacement fee too low", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) $e32f9441afb0a406$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($e32f9441afb0a406$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) $e32f9441afb0a406$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $e32f9441afb0a406$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $e32f9441afb0a406$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $e32f9441afb0a406$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
const $e32f9441afb0a406$var$_constructorGuard = {};
class $e32f9441afb0a406$export$5f7b5fca3508545a extends (0, $deb85df20e19ba32$export$fdf54fdde81cc9f0) {
    constructor(constructorGuard, provider, addressOrIndex){
        super();
        if (constructorGuard !== $e32f9441afb0a406$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_address", this.provider.formatter.address(addressOrIndex));
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_index", addressOrIndex);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_address", null);
        } else $e32f9441afb0a406$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
    }
    connect(provider) {
        return $e32f9441afb0a406$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new $e32f9441afb0a406$var$UncheckedJsonRpcSigner($e32f9441afb0a406$var$_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) return Promise.resolve(this._address);
        return this.provider.send("eth_accounts", []).then((accounts)=>{
            if (accounts.length <= this._index) $e32f9441afb0a406$var$logger.throwError("unknown account #" + this._index, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "getAddress"
            });
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(transaction);
        const fromAddress = this.getAddress().then((address)=>{
            if (address) address = address.toLowerCase();
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then((to)=>$e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
                if (to == null) return null;
                const address = yield this.provider.resolveName(to);
                if (address == null) $e32f9441afb0a406$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                return address;
            }));
        return (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
            tx: (0, $a463a6b5f08d6875$export$d503dd157d963b60)(transaction),
            sender: fromAddress
        }).then(({ tx: tx, sender: sender })=>{
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) $e32f9441afb0a406$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            } else tx.from = sender;
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, {
                from: true
            });
            return this.provider.send("eth_sendTransaction", [
                hexTx
            ]).then((hash)=>{
                return hash;
            }, (error)=>{
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $e32f9441afb0a406$var$logger.throwError("user rejected transaction", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "sendTransaction",
                    transaction: tx
                });
                return $e32f9441afb0a406$var$checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return $e32f9441afb0a406$var$logger.throwError("signing transactions is unsupported", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield (0, $4d026a5befa5b358$export$e0c10349b2c5e1d4)(()=>$e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
                        const tx = yield this.provider.getTransaction(hash);
                        if (tx === null) return undefined;
                        return this.provider._wrapTransaction(tx, hash, blockNumber);
                    }), {
                    oncePoll: this.provider
                });
            } catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(message) : message;
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("personal_sign", [
                    (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data),
                    address.toLowerCase()
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $e32f9441afb0a406$var$logger.throwError("user rejected signing", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "signMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _legacySignMessage(message) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(message) : message;
            const address = yield this.getAddress();
            try {
                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                return yield this.provider.send("eth_sign", [
                    address.toLowerCase(),
                    (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data)
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $e32f9441afb0a406$var$logger.throwError("user rejected signing", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "_legacySignMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _signTypedData(domain, types, value) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names (in-place)
            const populated = yield (0, $74ec091a01b8d3e1$export$458ab927ae635c3).resolveNames(domain, types, value, (name)=>{
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("eth_signTypedData_v4", [
                    address.toLowerCase(),
                    JSON.stringify((0, $74ec091a01b8d3e1$export$458ab927ae635c3).getPayload(populated.domain, types, populated.value))
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $e32f9441afb0a406$var$logger.throwError("user rejected signing", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "_signTypedData",
                    from: address,
                    messageData: {
                        domain: populated.domain,
                        types: types,
                        value: populated.value
                    }
                });
                throw error;
            }
        });
    }
    unlock(password) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [
                address.toLowerCase(),
                password,
                null
            ]);
        });
    }
}
class $e32f9441afb0a406$var$UncheckedJsonRpcSigner extends $e32f9441afb0a406$export$5f7b5fca3508545a {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash)=>{
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations)=>{
                    return this.provider.waitForTransaction(hash, confirmations);
                }
            };
        });
    }
}
const $e32f9441afb0a406$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
class $e32f9441afb0a406$export$da28308012bf6748 extends (0, $43e733c7f2a529c1$export$ff3f6dd83125ac45) {
    constructor(url, network){
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then((network)=>{
                    resolve(network);
                }, (error)=>{
                    reject(error);
                });
            }, 0);
        });
        super(networkOrReady);
        // Default URL
        if (!url) url = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "connection", Object.freeze({
            url: url
        }));
        else (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "connection", Object.freeze((0, $a463a6b5f08d6875$export$9c13236873b118a5)(url)));
        this._nextId = 42;
    }
    get _cache() {
        if (this._eventLoopCache == null) this._eventLoopCache = {};
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http://localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(()=>{
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            yield $e32f9441afb0a406$var$timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            } catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                } catch (error) {}
            }
            if (chainId != null) {
                const getNetwork = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "getNetwork");
                try {
                    return getNetwork((0, $0df4577496dcf693$export$d97aa349ed20696).from(chainId).toNumber());
                } catch (error) {
                    return $e32f9441afb0a406$var$logger.throwError("could not detect network", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return $e32f9441afb0a406$var$logger.throwError("could not detect network", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new $e32f9441afb0a406$export$5f7b5fca3508545a($e32f9441afb0a406$var$_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts)=>{
            return accounts.map((a)=>this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: (0, $a463a6b5f08d6875$export$6c40052bed430212)(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = [
            "eth_chainId",
            "eth_blockNumber"
        ].indexOf(method) >= 0;
        if (cache && this._cache[method]) return this._cache[method];
        const result = (0, $4d026a5befa5b358$export$6d71b655afe1638d)(this.connection, JSON.stringify(request), $e32f9441afb0a406$var$getResult).then((result)=>{
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(()=>{
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch(method){
            case "getBlockNumber":
                return [
                    "eth_blockNumber",
                    []
                ];
            case "getGasPrice":
                return [
                    "eth_gasPrice",
                    []
                ];
            case "getBalance":
                return [
                    "eth_getBalance",
                    [
                        $e32f9441afb0a406$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getTransactionCount":
                return [
                    "eth_getTransactionCount",
                    [
                        $e32f9441afb0a406$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getCode":
                return [
                    "eth_getCode",
                    [
                        $e32f9441afb0a406$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getStorageAt":
                return [
                    "eth_getStorageAt",
                    [
                        $e32f9441afb0a406$var$getLowerCase(params.address),
                        (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(params.position, 32),
                        params.blockTag
                    ]
                ];
            case "sendTransaction":
                return [
                    "eth_sendRawTransaction",
                    [
                        params.signedTransaction
                    ]
                ];
            case "getBlock":
                if (params.blockTag) return [
                    "eth_getBlockByNumber",
                    [
                        params.blockTag,
                        !!params.includeTransactions
                    ]
                ];
                else if (params.blockHash) return [
                    "eth_getBlockByHash",
                    [
                        params.blockHash,
                        !!params.includeTransactions
                    ]
                ];
                return null;
            case "getTransaction":
                return [
                    "eth_getTransactionByHash",
                    [
                        params.transactionHash
                    ]
                ];
            case "getTransactionReceipt":
                return [
                    "eth_getTransactionReceipt",
                    [
                        params.transactionHash
                    ]
                ];
            case "call":
                {
                    const hexlifyTransaction = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_call",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            }),
                            params.blockTag
                        ]
                    ];
                }
            case "estimateGas":
                {
                    const hexlifyTransaction = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_estimateGas",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            })
                        ]
                    ];
                }
            case "getLogs":
                if (params.filter && params.filter.address != null) params.filter.address = $e32f9441afb0a406$var$getLowerCase(params.filter.address);
                return [
                    "eth_getLogs",
                    [
                        params.filter
                    ]
                ];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && (0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.type).isZero()) // If there are no EIP-1559 properties, it might be non-EIP-1559
                {
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(params);
                            params.transaction = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) $e32f9441afb0a406$var$logger.throwError(method + " not implemented", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
                operation: method
            });
            try {
                return yield this.send(args[0], args[1]);
            } catch (error) {
                return $e32f9441afb0a406$var$checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") this._startPending();
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) return;
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function(filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [
                    filterId
                ]).then(function(hashes) {
                    if (self._pendingFilter != pendingFilter) return null;
                    let seq = Promise.resolve();
                    hashes.forEach(function(hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function() {
                            return self.getTransaction(hash).then(function(tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function() {
                        return $e32f9441afb0a406$var$timer(1000);
                    });
                }).then(function() {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [
                            filterId
                        ]);
                        return;
                    }
                    setTimeout(function() {
                        poll();
                    }, 0);
                    return null;
                }).catch((error)=>{});
            }
            poll();
            return filterId;
        }).catch((error)=>{});
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = (0, $a463a6b5f08d6875$export$9c13236873b118a5)($e32f9441afb0a406$var$allowedTransactionKeys);
        if (allowExtra) {
            for(const key in allowExtra)if (allowExtra[key]) allowed[key] = true;
        }
        (0, $a463a6b5f08d6875$export$ae5a316ba623b73a)(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            const value = (0, $7b88b6e03e4708f2$export$6916af760a341dd3)((0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction[key]));
            if (key === "gasLimit") key = "gas";
            result[key] = value;
        });
        [
            "from",
            "to",
            "data"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            result[key] = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(transaction[key]);
        });
        if (transaction.accessList) result["accessList"] = (0, $0a7021bc70fec74d$export$6c8662b1600dce2)(transaction.accessList);
        return result;
    }
}




"use strict";
let $c20588e763a5ccc3$export$3909fb301d3dc8c9 = null;
try {
    $c20588e763a5ccc3$export$3909fb301d3dc8c9 = WebSocket;
    if ($c20588e763a5ccc3$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    const logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
    $c20588e763a5ccc3$export$3909fb301d3dc8c9 = function() {
        logger.throwError("WebSockets not supported in this environment", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}




"use strict";
var $f2ba8b3ea7dcf3ca$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $f2ba8b3ea7dcf3ca$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ let $f2ba8b3ea7dcf3ca$var$NextId = 1;
class $f2ba8b3ea7dcf3ca$export$bfafe629242f30bd extends (0, $e32f9441afb0a406$export$da28308012bf6748) {
    constructor(url, network){
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $f2ba8b3ea7dcf3ca$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        if (typeof url === "string") super(url, network);
        else super("_websocket", network);
        this._pollingInterval = -1;
        this._wsReady = false;
        if (typeof url === "string") (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_websocket", new (0, $c20588e763a5ccc3$export$3909fb301d3dc8c9)(this.connection.url));
        else (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_websocket", url);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_requests", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_subs", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_subIds", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_detectNetwork", super.detectNetwork());
        // Stall sending requests until the socket is open...
        this.websocket.onopen = ()=>{
            this._wsReady = true;
            Object.keys(this._requests).forEach((id)=>{
                this.websocket.send(this._requests[id].payload);
            });
        };
        this.websocket.onmessage = (messageEvent)=>{
            const data = messageEvent.data;
            const result = JSON.parse(data);
            if (result.id != null) {
                const id = String(result.id);
                const request = this._requests[id];
                delete this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: this
                    });
                } else {
                    let error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $a463a6b5f08d6875$export$104236534534f9be)(error, "code", result.error.code || null);
                        (0, $a463a6b5f08d6875$export$104236534534f9be)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: this
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                const sub = this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        const fauxPoll = setInterval(()=>{
            this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
    }
    // Cannot narrow the type of _websocket, as that is not backwards compatible
    // so we add a getter and let the WebSocket be a public API.
    get websocket() {
        return this._websocket;
    }
    detectNetwork() {
        return this._detectNetwork;
    }
    get pollingInterval() {
        return 0;
    }
    resetEventsBlock(blockNumber) {
        $f2ba8b3ea7dcf3ca$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "resetEventBlock"
        });
    }
    set pollingInterval(value) {
        $f2ba8b3ea7dcf3ca$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "setPollingInterval"
        });
    }
    poll() {
        return $f2ba8b3ea7dcf3ca$var$__awaiter(this, void 0, void 0, function*() {
            return null;
        });
    }
    set polling(value) {
        if (!value) return;
        $f2ba8b3ea7dcf3ca$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "setPolling"
        });
    }
    send(method, params) {
        const rid = $f2ba8b3ea7dcf3ca$var$NextId++;
        return new Promise((resolve, reject)=>{
            function callback(error, result) {
                if (error) return reject(error);
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0"
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this
            });
            this._requests[String(rid)] = {
                callback: callback,
                payload: payload
            };
            if (this._wsReady) this.websocket.send(payload);
        });
    }
    static defaultUrl() {
        return "ws://localhost:8546";
    }
    _subscribe(tag, param, processFunc) {
        return $f2ba8b3ea7dcf3ca$var$__awaiter(this, void 0, void 0, function*() {
            let subIdPromise = this._subIds[tag];
            if (subIdPromise == null) {
                subIdPromise = Promise.all(param).then((param)=>{
                    return this.send("eth_subscribe", param);
                });
                this._subIds[tag] = subIdPromise;
            }
            const subId = yield subIdPromise;
            this._subs[subId] = {
                tag: tag,
                processFunc: processFunc
            };
        });
    }
    _startEvent(event) {
        switch(event.type){
            case "block":
                this._subscribe("block", [
                    "newHeads"
                ], (result)=>{
                    const blockNumber = (0, $0df4577496dcf693$export$d97aa349ed20696).from(result.number).toNumber();
                    this._emitted.block = blockNumber;
                    this.emit("block", blockNumber);
                });
                break;
            case "pending":
                this._subscribe("pending", [
                    "newPendingTransactions"
                ], (result)=>{
                    this.emit("pending", result);
                });
                break;
            case "filter":
                this._subscribe(event.tag, [
                    "logs",
                    this._getFilter(event.filter)
                ], (result)=>{
                    if (result.removed == null) result.removed = false;
                    this.emit(event.filter, this.formatter.filterLog(result));
                });
                break;
            case "tx":
                {
                    const emitReceipt = (event)=>{
                        const hash = event.hash;
                        this.getTransactionReceipt(hash).then((receipt)=>{
                            if (!receipt) return;
                            this.emit(hash, receipt);
                        });
                    };
                    // In case it is already mined
                    emitReceipt(event);
                    // To keep things simple, we start up a single newHeads subscription
                    // to keep an eye out for transactions we are watching for.
                    // Starting a subscription for an event (i.e. "tx") that is already
                    // running is (basically) a nop.
                    this._subscribe("tx", [
                        "newHeads"
                    ], (result)=>{
                        this._events.filter((e)=>e.type === "tx").forEach(emitReceipt);
                    });
                    break;
                }
            // Nothing is needed
            case "debug":
            case "poll":
            case "willPoll":
            case "didPoll":
            case "error":
                break;
            default:
                console.log("unhandled:", event);
                break;
        }
    }
    _stopEvent(event) {
        let tag = event.tag;
        if (event.type === "tx") {
            // There are remaining transaction event listeners
            if (this._events.filter((e)=>e.type === "tx").length) return;
            tag = "tx";
        } else if (this.listenerCount(event.event)) // There are remaining event listeners
        return;
        const subId = this._subIds[tag];
        if (!subId) return;
        delete this._subIds[tag];
        subId.then((subId)=>{
            if (!this._subs[subId]) return;
            delete this._subs[subId];
            this.send("eth_unsubscribe", [
                subId
            ]);
        });
    }
    destroy() {
        return $f2ba8b3ea7dcf3ca$var$__awaiter(this, void 0, void 0, function*() {
            // Wait until we have connected before trying to disconnect
            if (this.websocket.readyState === (0, $c20588e763a5ccc3$export$3909fb301d3dc8c9).CONNECTING) yield new Promise((resolve)=>{
                this.websocket.onopen = function() {
                    resolve(true);
                };
                this.websocket.onerror = function() {
                    resolve(false);
                };
            });
            // Hangup
            // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
            this.websocket.close(1000);
        });
    }
}








"use strict";
var $8044ebfe209f61e4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8044ebfe209f61e4$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
class $8044ebfe209f61e4$export$b3d647c1c29df44d extends (0, $e32f9441afb0a406$export$da28308012bf6748) {
    detectNetwork() {
        const _super = Object.create(null, {
            detectNetwork: {
                get: ()=>super.detectNetwork
            }
        });
        return $8044ebfe209f61e4$var$__awaiter(this, void 0, void 0, function*() {
            let network = this.network;
            if (network == null) {
                network = yield _super.detectNetwork.call(this);
                if (!network) $8044ebfe209f61e4$var$logger.throwError("no network detected", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {});
                // If still not set, set it
                if (this._network == null) {
                    // A static network does not support "any"
                    (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return network;
        });
    }
}
class $8044ebfe209f61e4$export$664128d6239ccf96 extends $8044ebfe209f61e4$export$b3d647c1c29df44d {
    constructor(network, apiKey){
        $8044ebfe209f61e4$var$logger.checkAbstract(new.target, $8044ebfe209f61e4$export$664128d6239ccf96);
        // Normalize the Network and API Key
        network = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getNetwork")(network);
        apiKey = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getApiKey")(apiKey);
        const connection = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getUrl")(network, apiKey);
        super(connection, network);
        if (typeof apiKey === "string") (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach((key)=>{
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, key, apiKey[key]);
        });
    }
    _startPending() {
        $8044ebfe209f61e4$var$logger.warn("WARNING: API provider does not support pending filters");
    }
    isCommunityResource() {
        return false;
    }
    getSigner(address) {
        return $8044ebfe209f61e4$var$logger.throwError("API provider does not support signing", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
        });
    }
    listAccounts() {
        return Promise.resolve([]);
    }
    // Return a defaultApiKey if null, otherwise validate the API key
    static getApiKey(apiKey) {
        return apiKey;
    }
    // Returns the url or connection for the given network and API key. The
    // API key will have been sanitized by the getApiKey first, so any validation
    // or transformations can be done there.
    static getUrl(network, apiKey) {
        return $8044ebfe209f61e4$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
            operation: "getUrl"
        });
    }
}


"use strict";
const $e94c62bb842b5925$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
const $e94c62bb842b5925$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class $e94c62bb842b5925$export$f6c13301c7b76371 extends (0, $f2ba8b3ea7dcf3ca$export$bfafe629242f30bd) {
    constructor(network, apiKey){
        const provider = new $e94c62bb842b5925$export$999cc40da3fbc6f(network, apiKey);
        const url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        super(url, provider.network);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "apiKey", provider.apiKey);
    }
    isCommunityResource() {
        return this.apiKey === $e94c62bb842b5925$var$defaultApiKey;
    }
}
class $e94c62bb842b5925$export$999cc40da3fbc6f extends (0, $8044ebfe209f61e4$export$664128d6239ccf96) {
    static getWebSocketProvider(network, apiKey) {
        return new $e94c62bb842b5925$export$f6c13301c7b76371(network, apiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $e94c62bb842b5925$var$defaultApiKey;
        if (apiKey && typeof apiKey !== "string") $e94c62bb842b5925$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "eth-mainnet.alchemyapi.io/v2/";
                break;
            case "goerli":
                host = "eth-goerli.g.alchemy.com/v2/";
                break;
            case "matic":
                host = "polygon-mainnet.g.alchemy.com/v2/";
                break;
            case "maticmum":
                host = "polygon-mumbai.g.alchemy.com/v2/";
                break;
            case "arbitrum":
                host = "arb-mainnet.g.alchemy.com/v2/";
                break;
            case "arbitrum-goerli":
                host = "arb-goerli.g.alchemy.com/v2/";
                break;
            case "optimism":
                host = "opt-mainnet.g.alchemy.com/v2/";
                break;
            case "optimism-goerli":
                host = "opt-goerli.g.alchemy.com/v2/";
                break;
            default:
                $e94c62bb842b5925$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return {
            allowGzip: true,
            url: "https://" + host + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey === $e94c62bb842b5925$var$defaultApiKey) (0, $dc6c759982861e14$export$4c41bd49e82e82ab)();
                return Promise.resolve(true);
            }
        };
    }
    isCommunityResource() {
        return this.apiKey === $e94c62bb842b5925$var$defaultApiKey;
    }
}






const $efd7dc521b26566c$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
const $efd7dc521b26566c$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $efd7dc521b26566c$var$getHost(name) {
    switch(name){
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return $efd7dc521b26566c$var$logger.throwArgumentError("unsupported network", "name", name);
}
class $efd7dc521b26566c$export$72783b2aefa72a45 extends (0, $8044ebfe209f61e4$export$664128d6239ccf96) {
    isCommunityResource() {
        return this.apiKey === $efd7dc521b26566c$var$defaultApiKey;
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $efd7dc521b26566c$var$defaultApiKey;
        return apiKey;
    }
    static getUrl(network, apiKey) {
        if (apiKey == null) apiKey = $efd7dc521b26566c$var$defaultApiKey;
        const connection = {
            allowGzip: true,
            url: "https://" + $efd7dc521b26566c$var$getHost(network.name) + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey.apiKey === $efd7dc521b26566c$var$defaultApiKey) (0, $dc6c759982861e14$export$4c41bd49e82e82ab)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
}





"use strict";
var $cdd214e3d1599302$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $cdd214e3d1599302$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
class $cdd214e3d1599302$export$7113381f8f264fc0 extends (0, $8044ebfe209f61e4$export$664128d6239ccf96) {
    static getApiKey(apiKey) {
        if (apiKey != null) $cdd214e3d1599302$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
        return null;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://cloudflare-eth.com/";
                break;
            default:
                $cdd214e3d1599302$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host;
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $cdd214e3d1599302$var$__awaiter(this, void 0, void 0, function*() {
            // The Cloudflare provider does not support eth_blockNumber,
            // so we get the latest block and pull it from that
            if (method === "getBlockNumber") {
                const block = yield _super.perform.call(this, "getBlock", {
                    blockTag: "latest"
                });
                return block.number;
            }
            return _super.perform.call(this, method, params);
        });
    }
}










"use strict";
var $d7687248e25a81ef$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d7687248e25a81ef$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
// The transaction has already been sanitized by the calls in Provider
function $d7687248e25a81ef$var$getTransactionPostData(transaction) {
    const result = {};
    for(let key in transaction){
        if (transaction[key] == null) continue;
        let value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $7b88b6e03e4708f2$export$6916af760a341dd3)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value));
        else if (key === "accessList") value = "[" + (0, $0a7021bc70fec74d$export$6c8662b1600dce2)(value).map((set)=>{
            return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
        }).join(",") + "]";
        else value = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value);
        result[key] = value;
    }
    return result;
}
function $d7687248e25a81ef$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || typeof result.message !== "string" || !result.message.match(/^OK/)) {
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $d7687248e25a81ef$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        const error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        throw error;
    }
    if (result.error) {
        // @TODO: not any
        const error = new Error(result.error.message || "unknown error");
        if (result.error.code) error.code = result.error.code;
        if (result.error.data) error.data = result.error.data;
        throw error;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $d7687248e25a81ef$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
function $d7687248e25a81ef$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR) {
        const e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            let data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(data)) return data;
            $d7687248e25a81ef$var$logger.throwError("missing revert data in call exception", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    let message = error.message;
    if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $d7687248e25a81ef$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $d7687248e25a81ef$var$logger.throwError("nonce has already been used", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $d7687248e25a81ef$var$logger.throwError("replacement fee too low", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $d7687248e25a81ef$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
class $d7687248e25a81ef$export$dd1d942a536c7912 extends (0, $43e733c7f2a529c1$export$ff3f6dd83125ac45) {
    constructor(network, apiKey){
        super(network);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "baseUrl", this.getBaseUrl());
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "apiKey", apiKey || null);
    }
    getBaseUrl() {
        switch(this.network ? this.network.name : "invalid"){
            case "homestead":
                return "https://api.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            case "sepolia":
                return "https://api-sepolia.etherscan.io";
            case "matic":
                return "https://api.polygonscan.com";
            case "maticmum":
                return "https://api-testnet.polygonscan.com";
            case "arbitrum":
                return "https://api.arbiscan.io";
            case "arbitrum-goerli":
                return "https://api-goerli.arbiscan.io";
            case "optimism":
                return "https://api-optimistic.etherscan.io";
            case "optimism-goerli":
                return "https://api-goerli-optimistic.etherscan.io";
            default:
        }
        return $d7687248e25a81ef$var$logger.throwArgumentError("unsupported network", "network", this.network.name);
    }
    getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.baseUrl}/api?module=${module}${query}${apiKey}`;
    }
    getPostUrl() {
        return `${this.baseUrl}/api`;
    }
    getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    fetch(module, params, post) {
        return $d7687248e25a81ef$var$__awaiter(this, void 0, void 0, function*() {
            const url = post ? this.getPostUrl() : this.getUrl(module, params);
            const payload = post ? this.getPostData(module, params) : null;
            const procFunc = module === "proxy" ? $d7687248e25a81ef$var$getJsonResult : $d7687248e25a81ef$var$getResult;
            this.emit("debug", {
                action: "request",
                request: url,
                provider: this
            });
            const connection = {
                url: url,
                throttleSlotInterval: 1000,
                throttleCallback: (attempt, url)=>{
                    if (this.isCommunityResource()) (0, $dc6c759982861e14$export$4c41bd49e82e82ab)();
                    return Promise.resolve(true);
                }
            };
            let payloadStr = null;
            if (payload) {
                connection.headers = {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                };
                payloadStr = Object.keys(payload).map((key)=>{
                    return `${key}=${payload[key]}`;
                }).join("&");
            }
            const result = yield (0, $4d026a5befa5b358$export$6d71b655afe1638d)(connection, payloadStr, procFunc || $d7687248e25a81ef$var$getJsonResult);
            this.emit("debug", {
                action: "response",
                request: url,
                response: (0, $a463a6b5f08d6875$export$6c40052bed430212)(result),
                provider: this
            });
            return result;
        });
    }
    detectNetwork() {
        return $d7687248e25a81ef$var$__awaiter(this, void 0, void 0, function*() {
            return this.network;
        });
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $d7687248e25a81ef$var$__awaiter(this, void 0, void 0, function*() {
            switch(method){
                case "getBlockNumber":
                    return this.fetch("proxy", {
                        action: "eth_blockNumber"
                    });
                case "getGasPrice":
                    return this.fetch("proxy", {
                        action: "eth_gasPrice"
                    });
                case "getBalance":
                    // Returns base-10 result
                    return this.fetch("account", {
                        action: "balance",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getTransactionCount":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionCount",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getCode":
                    return this.fetch("proxy", {
                        action: "eth_getCode",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getStorageAt":
                    return this.fetch("proxy", {
                        action: "eth_getStorageAt",
                        address: params.address,
                        position: params.position,
                        tag: params.blockTag
                    });
                case "sendTransaction":
                    return this.fetch("proxy", {
                        action: "eth_sendRawTransaction",
                        hex: params.signedTransaction
                    }, true).catch((error)=>{
                        return $d7687248e25a81ef$var$checkError("sendTransaction", error, params.signedTransaction);
                    });
                case "getBlock":
                    if (params.blockTag) return this.fetch("proxy", {
                        action: "eth_getBlockByNumber",
                        tag: params.blockTag,
                        boolean: params.includeTransactions ? "true" : "false"
                    });
                    throw new Error("getBlock by blockHash not implemented");
                case "getTransaction":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionByHash",
                        txhash: params.transactionHash
                    });
                case "getTransactionReceipt":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionReceipt",
                        txhash: params.transactionHash
                    });
                case "call":
                    {
                        if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                        const postData = $d7687248e25a81ef$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_call";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $d7687248e25a81ef$var$checkError("call", error, params.transaction);
                        }
                    }
                case "estimateGas":
                    {
                        const postData = $d7687248e25a81ef$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_estimateGas";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $d7687248e25a81ef$var$checkError("estimateGas", error, params.transaction);
                        }
                    }
                case "getLogs":
                    {
                        const args = {
                            action: "getLogs"
                        };
                        if (params.filter.fromBlock) args.fromBlock = $d7687248e25a81ef$var$checkLogTag(params.filter.fromBlock);
                        if (params.filter.toBlock) args.toBlock = $d7687248e25a81ef$var$checkLogTag(params.filter.toBlock);
                        if (params.filter.address) args.address = params.filter.address;
                        // @TODO: We can handle slightly more complicated logs using the logs API
                        if (params.filter.topics && params.filter.topics.length > 0) {
                            if (params.filter.topics.length > 1) $d7687248e25a81ef$var$logger.throwError("unsupported topic count", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                topics: params.filter.topics
                            });
                            if (params.filter.topics.length === 1) {
                                const topic0 = params.filter.topics[0];
                                if (typeof topic0 !== "string" || topic0.length !== 66) $d7687248e25a81ef$var$logger.throwError("unsupported topic format", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                    topic0: topic0
                                });
                                args.topic0 = topic0;
                            }
                        }
                        const logs = yield this.fetch("logs", args);
                        // Cache txHash => blockHash
                        let blocks = {};
                        // Add any missing blockHash to the logs
                        for(let i = 0; i < logs.length; i++){
                            const log = logs[i];
                            if (log.blockHash != null) continue;
                            if (blocks[log.blockNumber] == null) {
                                const block = yield this.getBlock(log.blockNumber);
                                if (block) blocks[log.blockNumber] = block.hash;
                            }
                            log.blockHash = blocks[log.blockNumber];
                        }
                        return logs;
                    }
                case "getEtherPrice":
                    if (this.network.name !== "homestead") return 0.0;
                    return parseFloat((yield this.fetch("stats", {
                        action: "ethprice"
                    })).ethusd);
                default:
                    break;
            }
            return _super.perform.call(this, method, params);
        });
    }
    // Note: The `page` page parameter only allows pagination within the
    //       10,000 window available without a page and offset parameter
    //       Error: Result window is too large, PageNo x Offset size must
    //              be less than or equal to 10000
    getHistory(addressOrName, startBlock, endBlock) {
        return $d7687248e25a81ef$var$__awaiter(this, void 0, void 0, function*() {
            const params = {
                action: "txlist",
                address: yield this.resolveName(addressOrName),
                startblock: startBlock == null ? 0 : startBlock,
                endblock: endBlock == null ? 99999999 : endBlock,
                sort: "asc"
            };
            const result = yield this.fetch("account", params);
            return result.map((tx)=>{
                [
                    "contractAddress",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == "") delete tx[key];
                });
                if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                const item = this.formatter.transactionResponse(tx);
                if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                return item;
            });
        });
    }
    isCommunityResource() {
        return this.apiKey == null;
    }
}






"use strict";
function $dc90334677e5edd7$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}







"use strict";
var $14eaab77c6d2e466$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $14eaab77c6d2e466$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
function $14eaab77c6d2e466$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $14eaab77c6d2e466$var$checkNetworks(networks) {
    let result = null;
    for(let i = 0; i < networks.length; i++){
        const network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $14eaab77c6d2e466$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $14eaab77c6d2e466$var$median(values, maxDelta) {
    values = values.slice().sort();
    const middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    const a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $14eaab77c6d2e466$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $0df4577496dcf693$export$d97aa349ed20696).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map((i)=>$14eaab77c6d2e466$var$serialize(i)));
    else if (typeof value === "object") {
        const keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map((key)=>{
            let v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $14eaab77c6d2e466$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + typeof value);
}
// Next request ID to use for emitting debug info
let $14eaab77c6d2e466$var$nextRid = 1;
function $14eaab77c6d2e466$var$stall(duration) {
    let cancel = null;
    let timer = null;
    let promise = new Promise((resolve)=>{
        cancel = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    const wait = (func)=>{
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
const $14eaab77c6d2e466$var$ForwardErrors = [
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION,
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS,
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NONCE_EXPIRED,
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED,
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT
];
const $14eaab77c6d2e466$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $14eaab77c6d2e466$var$exposeDebugConfig(config, now) {
    const result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: ()=>config.provider
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $14eaab77c6d2e466$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        const tally = {};
        configs.forEach((c)=>{
            const value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        const keys = Object.keys(tally);
        for(let i = 0; i < keys.length; i++){
            const check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $14eaab77c6d2e466$var$getProcessFunc(provider, method, params) {
    let normalize = $14eaab77c6d2e466$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                // Get the median block number
                let blockNumber = $14eaab77c6d2e466$var$median(configs.map((c)=>c.result), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $14eaab77c6d2e466$var$median(configs.map((c)=>c.result));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function(tx) {
                if (tx == null) return null;
                tx = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(tx);
                tx.confirmations = -1;
                return $14eaab77c6d2e466$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function(block) {
                if (block == null) return null;
                block = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(block);
                block.transactions = block.transactions.map((tx)=>{
                    tx = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $14eaab77c6d2e466$var$serialize(block);
            };
            else normalize = function(block) {
                if (block == null) return null;
                return $14eaab77c6d2e466$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $14eaab77c6d2e466$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $14eaab77c6d2e466$var$waitForSync(config, blockNumber) {
    return $14eaab77c6d2e466$var$__awaiter(this, void 0, void 0, function*() {
        const provider = config.provider;
        if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return provider;
        return (0, $4d026a5befa5b358$export$e0c10349b2c5e1d4)(()=>{
            return new Promise((resolve, reject)=>{
                setTimeout(function() {
                    // We are synced
                    if (provider.blockNumber >= blockNumber) return resolve(provider);
                    // We're done; just quit
                    if (config.cancelled) return resolve(null);
                    // Try again, next block
                    return resolve(undefined);
                }, 0);
            });
        }, {
            oncePoll: provider
        });
    });
}
function $14eaab77c6d2e466$var$getRunner(config, currentBlockNumber, method, params) {
    return $14eaab77c6d2e466$var$__awaiter(this, void 0, void 0, function*() {
        let provider = config.provider;
        switch(method){
            case "getBlockNumber":
            case "getGasPrice":
                return provider[method]();
            case "getEtherPrice":
                if (provider.getEtherPrice) return provider.getEtherPrice();
                break;
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
                if (params.blockTag && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.address, params.blockTag || "latest");
            case "getStorageAt":
                if (params.blockTag && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                return provider.getStorageAt(params.address, params.position, params.blockTag || "latest");
            case "getBlock":
                if (params.blockTag && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                return provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash);
            case "call":
            case "estimateGas":
                if (params.blockTag && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                if (method === "call" && params.blockTag) return provider[method](params.transaction, params.blockTag);
                return provider[method](params.transaction);
            case "getTransaction":
            case "getTransactionReceipt":
                return provider[method](params.transactionHash);
            case "getLogs":
                {
                    let filter = params.filter;
                    if (filter.fromBlock && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(filter.fromBlock) || filter.toBlock && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(filter.toBlock)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                    return provider.getLogs(filter);
                }
        }
        return $14eaab77c6d2e466$var$logger.throwError("unknown method error", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {
            method: method,
            params: params
        });
    });
}
class $14eaab77c6d2e466$export$cb1d0beacb55feb7 extends (0, $43e733c7f2a529c1$export$ff3f6dd83125ac45) {
    constructor(providers, quorum){
        if (providers.length === 0) $14eaab77c6d2e466$var$logger.throwArgumentError("missing providers", "providers", providers);
        const providerConfigs = providers.map((configOrProvider, index)=>{
            if ((0, $81658ac0a17fba50$export$2881499e37b75b9a).isProvider(configOrProvider)) {
                const stallTimeout = (0, $dc6c759982861e14$export$d93d5f61c2498b6)(configOrProvider) ? 2000 : 750;
                const priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            const config = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $dc6c759982861e14$export$d93d5f61c2498b6)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            const weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $14eaab77c6d2e466$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${index}].weight`, weight);
            return Object.freeze(config);
        });
        const total = providerConfigs.reduce((accum, c)=>accum + c.weight, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $14eaab77c6d2e466$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        let networkOrReady = $14eaab77c6d2e466$var$checkNetworks(providerConfigs.map((c)=>c.provider.network));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        super(networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "providerConfigs", Object.freeze(providerConfigs));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "quorum", quorum);
        this._highestBlockNumber = -1;
    }
    detectNetwork() {
        return $14eaab77c6d2e466$var$__awaiter(this, void 0, void 0, function*() {
            const networks = yield Promise.all(this.providerConfigs.map((c)=>c.provider.getNetwork()));
            return $14eaab77c6d2e466$var$checkNetworks(networks);
        });
    }
    perform(method, params) {
        return $14eaab77c6d2e466$var$__awaiter(this, void 0, void 0, function*() {
            // Sending transactions is special; always broadcast it to all backends
            if (method === "sendTransaction") {
                const results = yield Promise.all(this.providerConfigs.map((c)=>{
                    return c.provider.sendTransaction(params.signedTransaction).then((result)=>{
                        return result.hash;
                    }, (error)=>{
                        return error;
                    });
                }));
                // Any success is good enough (other errors are likely "already seen" errors
                for(let i = 0; i < results.length; i++){
                    const result = results[i];
                    if (typeof result === "string") return result;
                }
                // They were all an error; pick the first error
                throw results[0];
            }
            // We need to make sure we are in sync with our backends, so we need
            // to know this before we can make a lot of calls
            if (this._highestBlockNumber === -1 && method !== "getBlockNumber") yield this.getBlockNumber();
            const processFunc = $14eaab77c6d2e466$var$getProcessFunc(this, method, params);
            // Shuffle the providers and then sort them by their priority; we
            // shallowCopy them since we will store the result in them too
            const configs = (0, $dc90334677e5edd7$export$e6c7296801b9b341)(this.providerConfigs.map((0, $a463a6b5f08d6875$export$9c13236873b118a5)));
            configs.sort((a, b)=>a.priority - b.priority);
            const currentBlockNumber = this._highestBlockNumber;
            let i = 0;
            let first = true;
            while(true){
                const t0 = $14eaab77c6d2e466$var$now();
                // Compute the inflight weight (exclude anything past)
                let inflightWeight = configs.filter((c)=>c.runner && t0 - c.start < c.stallTimeout).reduce((accum, c)=>accum + c.weight, 0);
                // Start running enough to meet quorum
                while(inflightWeight < this.quorum && i < configs.length){
                    const config = configs[i++];
                    const rid = $14eaab77c6d2e466$var$nextRid++;
                    config.start = $14eaab77c6d2e466$var$now();
                    config.staller = $14eaab77c6d2e466$var$stall(config.stallTimeout);
                    config.staller.wait(()=>{
                        config.staller = null;
                    });
                    config.runner = $14eaab77c6d2e466$var$getRunner(config, currentBlockNumber, method, params).then((result)=>{
                        config.done = true;
                        config.result = result;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $14eaab77c6d2e466$var$exposeDebugConfig(config, $14eaab77c6d2e466$var$now()),
                            request: {
                                method: method,
                                params: (0, $a463a6b5f08d6875$export$6c40052bed430212)(params)
                            },
                            provider: this
                        });
                    }, (error)=>{
                        config.done = true;
                        config.error = error;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $14eaab77c6d2e466$var$exposeDebugConfig(config, $14eaab77c6d2e466$var$now()),
                            request: {
                                method: method,
                                params: (0, $a463a6b5f08d6875$export$6c40052bed430212)(params)
                            },
                            provider: this
                        });
                    });
                    if (this.listenerCount("debug")) this.emit("debug", {
                        action: "request",
                        rid: rid,
                        backend: $14eaab77c6d2e466$var$exposeDebugConfig(config, null),
                        request: {
                            method: method,
                            params: (0, $a463a6b5f08d6875$export$6c40052bed430212)(params)
                        },
                        provider: this
                    });
                    inflightWeight += config.weight;
                }
                // Wait for anything meaningful to finish or stall out
                const waiting = [];
                configs.forEach((c)=>{
                    if (c.done || !c.runner) return;
                    waiting.push(c.runner);
                    if (c.staller) waiting.push(c.staller.getPromise());
                });
                if (waiting.length) yield Promise.race(waiting);
                // Check the quorum and process the results; the process function
                // may additionally decide the quorum is not met
                const results = configs.filter((c)=>c.done && c.error == null);
                if (results.length >= this.quorum) {
                    const result = processFunc(results);
                    if (result !== undefined) {
                        // Shut down any stallers
                        configs.forEach((c)=>{
                            if (c.staller) c.staller.cancel();
                            c.cancelled = true;
                        });
                        return result;
                    }
                    if (!first) yield $14eaab77c6d2e466$var$stall(100).getPromise();
                    first = false;
                }
                // No result, check for errors that should be forwarded
                const errors = configs.reduce((accum, c)=>{
                    if (!c.done || c.error == null) return accum;
                    const code = c.error.code;
                    if ($14eaab77c6d2e466$var$ForwardErrors.indexOf(code) >= 0) {
                        if (!accum[code]) accum[code] = {
                            error: c.error,
                            weight: 0
                        };
                        accum[code].weight += c.weight;
                    }
                    return accum;
                }, {});
                Object.keys(errors).forEach((errorCode)=>{
                    const tally = errors[errorCode];
                    if (tally.weight < this.quorum) return;
                    // Shut down any stallers
                    configs.forEach((c)=>{
                        if (c.staller) c.staller.cancel();
                        c.cancelled = true;
                    });
                    const e = tally.error;
                    const props = {};
                    $14eaab77c6d2e466$var$ForwardProperties.forEach((name)=>{
                        if (e[name] == null) return;
                        props[name] = e[name];
                    });
                    $14eaab77c6d2e466$var$logger.throwError(e.reason || e.message, errorCode, props);
                });
                // All configs have run to completion; we will never get more data
                if (configs.filter((c)=>!c.done).length === 0) break;
            }
            // Shut down any stallers; shouldn't be any
            configs.forEach((c)=>{
                if (c.staller) c.staller.cancel();
                c.cancelled = true;
            });
            return $14eaab77c6d2e466$var$logger.throwError("failed to meet quorum", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                method: method,
                params: params,
                //results: configs.map((c) => c.result),
                //errors: configs.map((c) => c.error),
                results: configs.map((c)=>$14eaab77c6d2e466$var$exposeDebugConfig(c)),
                provider: this
            });
        });
    }
}


"use strict";
const $9b4b4c9da3406148$export$fbe151f90a1ece01 = null;








"use strict";
const $1be1b51d2ba5e5c5$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
const $1be1b51d2ba5e5c5$var$defaultProjectId = "84842078b09946638c03157f83405213";
class $1be1b51d2ba5e5c5$export$dd168a807d60da4f extends (0, $f2ba8b3ea7dcf3ca$export$bfafe629242f30bd) {
    constructor(network, apiKey){
        const provider = new $1be1b51d2ba5e5c5$export$60ff1a559b5c6ebd(network, apiKey);
        const connection = provider.connection;
        if (connection.password) $1be1b51d2ba5e5c5$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "apiKey", provider.projectId);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "projectId", provider.projectId);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "projectSecret", provider.projectSecret);
    }
    isCommunityResource() {
        return this.projectId === $1be1b51d2ba5e5c5$var$defaultProjectId;
    }
}
class $1be1b51d2ba5e5c5$export$60ff1a559b5c6ebd extends (0, $8044ebfe209f61e4$export$664128d6239ccf96) {
    static getWebSocketProvider(network, apiKey) {
        return new $1be1b51d2ba5e5c5$export$dd168a807d60da4f(network, apiKey);
    }
    static getApiKey(apiKey) {
        const apiKeyObj = {
            apiKey: $1be1b51d2ba5e5c5$var$defaultProjectId,
            projectId: $1be1b51d2ba5e5c5$var$defaultProjectId,
            projectSecret: null
        };
        if (apiKey == null) return apiKeyObj;
        if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
        else if (apiKey.projectSecret != null) {
            $1be1b51d2ba5e5c5$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
            $1be1b51d2ba5e5c5$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
            apiKeyObj.projectId = apiKey.projectId;
            apiKeyObj.projectSecret = apiKey.projectSecret;
        } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
        apiKeyObj.apiKey = apiKeyObj.projectId;
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "mainnet.infura.io";
                break;
            case "goerli":
                host = "goerli.infura.io";
                break;
            case "sepolia":
                host = "sepolia.infura.io";
                break;
            case "matic":
                host = "polygon-mainnet.infura.io";
                break;
            case "maticmum":
                host = "polygon-mumbai.infura.io";
                break;
            case "optimism":
                host = "optimism-mainnet.infura.io";
                break;
            case "optimism-goerli":
                host = "optimism-goerli.infura.io";
                break;
            case "arbitrum":
                host = "arbitrum-mainnet.infura.io";
                break;
            case "arbitrum-goerli":
                host = "arbitrum-goerli.infura.io";
                break;
            default:
                $1be1b51d2ba5e5c5$var$logger.throwError("unsupported network", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const connection = {
            allowGzip: true,
            url: "https://" + host + "/v3/" + apiKey.projectId,
            throttleCallback: (attempt, url)=>{
                if (apiKey.projectId === $1be1b51d2ba5e5c5$var$defaultProjectId) (0, $dc6c759982861e14$export$4c41bd49e82e82ab)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
    isCommunityResource() {
        return this.projectId === $1be1b51d2ba5e5c5$var$defaultProjectId;
    }
}






class $a926fa2c67f65d9a$export$5a16092bf20edf97 extends (0, $e32f9441afb0a406$export$da28308012bf6748) {
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        if (this._pendingBatch == null) this._pendingBatch = [];
        const inflightRequest = {
            request: request,
            resolve: null,
            reject: null
        };
        const promise = new Promise((resolve, reject)=>{
            inflightRequest.resolve = resolve;
            inflightRequest.reject = reject;
        });
        this._pendingBatch.push(inflightRequest);
        if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
        this._pendingBatchAggregator = setTimeout(()=>{
            // Get teh current batch and clear it, so new requests
            // go into the next batch
            const batch = this._pendingBatch;
            this._pendingBatch = null;
            this._pendingBatchAggregator = null;
            // Get the request as an array of requests
            const request = batch.map((inflight)=>inflight.request);
            this.emit("debug", {
                action: "requestBatch",
                request: (0, $a463a6b5f08d6875$export$6c40052bed430212)(request),
                provider: this
            });
            return (0, $4d026a5befa5b358$export$6d71b655afe1638d)(this.connection, JSON.stringify(request)).then((result)=>{
                this.emit("debug", {
                    action: "response",
                    request: request,
                    response: result,
                    provider: this
                });
                // For each result, feed it to the correct Promise, depending
                // on whether it was a success or error
                batch.forEach((inflightRequest, index)=>{
                    const payload = result[index];
                    if (payload.error) {
                        const error = new Error(payload.error.message);
                        error.code = payload.error.code;
                        error.data = payload.error.data;
                        inflightRequest.reject(error);
                    } else inflightRequest.resolve(payload.result);
                });
            }, (error)=>{
                this.emit("debug", {
                    action: "response",
                    error: error,
                    request: request,
                    provider: this
                });
                batch.forEach((inflightRequest)=>{
                    inflightRequest.reject(error);
                });
            });
        }, 10);
        return promise;
    }
}


/* istanbul ignore file */ 


"use strict";
const $dcb00489ffa41a84$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
// Special API key provided by Nodesmith for ethers.js
const $dcb00489ffa41a84$var$defaultApiKey = "ETHERS_JS_SHARED";
class $dcb00489ffa41a84$export$8235cbce3ce273bd extends (0, $8044ebfe209f61e4$export$664128d6239ccf96) {
    static getApiKey(apiKey) {
        if (apiKey && typeof apiKey !== "string") $dcb00489ffa41a84$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey || $dcb00489ffa41a84$var$defaultApiKey;
    }
    static getUrl(network, apiKey) {
        $dcb00489ffa41a84$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                break;
            case "ropsten":
                host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                break;
            case "rinkeby":
                host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                break;
            case "goerli":
                host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                break;
            case "kovan":
                host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                break;
            default:
                $dcb00489ffa41a84$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host + "?apiKey=" + apiKey;
    }
}





"use strict";
const $fbe10c5df3b2b203$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
const $fbe10c5df3b2b203$var$defaultApplicationId = "62e1ad51b37b8e00394bda3b";
class $fbe10c5df3b2b203$export$58bb47e42f6b092e extends (0, $8044ebfe209f61e4$export$664128d6239ccf96) {
    static getApiKey(apiKey) {
        const apiKeyObj = {
            applicationId: null,
            loadBalancer: true,
            applicationSecretKey: null
        };
        // Parse applicationId and applicationSecretKey
        if (apiKey == null) apiKeyObj.applicationId = $fbe10c5df3b2b203$var$defaultApplicationId;
        else if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
        else if (apiKey.applicationSecretKey != null) {
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
        } else if (apiKey.applicationId) apiKeyObj.applicationId = apiKey.applicationId;
        else $fbe10c5df3b2b203$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "goerli":
                host = "eth-goerli.gateway.pokt.network";
                break;
            case "homestead":
                host = "eth-mainnet.gateway.pokt.network";
                break;
            case "kovan":
                host = "poa-kovan.gateway.pokt.network";
                break;
            case "matic":
                host = "poly-mainnet.gateway.pokt.network";
                break;
            case "maticmum":
                host = "polygon-mumbai-rpc.gateway.pokt.network";
                break;
            case "rinkeby":
                host = "eth-rinkeby.gateway.pokt.network";
                break;
            case "ropsten":
                host = "eth-ropsten.gateway.pokt.network";
                break;
            default:
                $fbe10c5df3b2b203$var$logger.throwError("unsupported network", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const url = `https:/\/${host}/v1/lb/${apiKey.applicationId}`;
        const connection = {
            headers: {},
            url: url
        };
        if (apiKey.applicationSecretKey != null) {
            connection.user = "";
            connection.password = apiKey.applicationSecretKey;
        }
        return connection;
    }
    isCommunityResource() {
        return this.applicationId === $fbe10c5df3b2b203$var$defaultApplicationId;
    }
}







"use strict";
const $c7f9e560d629e6df$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
let $c7f9e560d629e6df$var$_nextId = 1;
function $c7f9e560d629e6df$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        const request = {
            method: method,
            params: params,
            id: $c7f9e560d629e6df$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject)=>{
            this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $a463a6b5f08d6875$export$6c40052bed430212)(request),
                provider: this
            });
            sendFunc(request, (error, response)=>{
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function $c7f9e560d629e6df$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        if (params == null) params = [];
        const request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $a463a6b5f08d6875$export$6c40052bed430212)(request),
            provider: this
        });
        return provider.request(request).then((response)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: this
            });
            return response;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: this
            });
            throw error;
        });
    };
}
class $c7f9e560d629e6df$export$d05096c9fd9d936d extends (0, $e32f9441afb0a406$export$da28308012bf6748) {
    constructor(provider, network){
        if (provider == null) $c7f9e560d629e6df$var$logger.throwArgumentError("missing provider", "provider", provider);
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $c7f9e560d629e6df$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $c7f9e560d629e6df$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $c7f9e560d629e6df$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $c7f9e560d629e6df$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        super(path, network);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", subprovider);
    }
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
}






"use strict";
const $859153647bbc688f$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
////////////////////////
// Helper Functions
function $859153647bbc688f$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        const match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1].toLowerCase()){
            case "http":
            case "https":
                return new (0, $e32f9441afb0a406$export$da28308012bf6748)(network);
            case "ws":
            case "wss":
                return new (0, $f2ba8b3ea7dcf3ca$export$bfafe629242f30bd)(network);
            default:
                $859153647bbc688f$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    const n = (0, $17c84d4c9be9446e$export$7de4970ebfd8206d)(network);
    if (!n || !n._defaultProvider) $859153647bbc688f$var$logger.throwError("unsupported getDefaultProvider network", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: $14eaab77c6d2e466$export$cb1d0beacb55feb7,
        AlchemyProvider: $e94c62bb842b5925$export$999cc40da3fbc6f,
        AnkrProvider: $efd7dc521b26566c$export$72783b2aefa72a45,
        CloudflareProvider: $cdd214e3d1599302$export$7113381f8f264fc0,
        EtherscanProvider: $d7687248e25a81ef$export$dd1d942a536c7912,
        InfuraProvider: $1be1b51d2ba5e5c5$export$60ff1a559b5c6ebd,
        JsonRpcProvider: $e32f9441afb0a406$export$da28308012bf6748,
        NodesmithProvider: $dcb00489ffa41a84$export$8235cbce3ce273bd,
        PocketProvider: $fbe10c5df3b2b203$export$58bb47e42f6b092e,
        Web3Provider: $c7f9e560d629e6df$export$d05096c9fd9d936d,
        IpcProvider: $9b4b4c9da3406148$export$fbe151f90a1ece01
    }, options);
}



var $0e788201f8a90b1e$exports = {};

$parcel$export($0e788201f8a90b1e$exports, "AbiCoder", () => $2f97e4c6f3904f5b$export$fe041e1a83d3efc6);
$parcel$export($0e788201f8a90b1e$exports, "defaultAbiCoder", () => $2f97e4c6f3904f5b$export$51d1cfcdb913adff);
$parcel$export($0e788201f8a90b1e$exports, "Fragment", () => $871a765ee5e657d2$export$ffb0004e005737fa);
$parcel$export($0e788201f8a90b1e$exports, "ConstructorFragment", () => $871a765ee5e657d2$export$3ac5c9504f801ea4);
$parcel$export($0e788201f8a90b1e$exports, "ErrorFragment", () => $871a765ee5e657d2$export$2c42c6d543aa9b59);
$parcel$export($0e788201f8a90b1e$exports, "EventFragment", () => $871a765ee5e657d2$export$958548f08bac2833);
$parcel$export($0e788201f8a90b1e$exports, "FunctionFragment", () => $871a765ee5e657d2$export$8d576c928b93668f);
$parcel$export($0e788201f8a90b1e$exports, "ParamType", () => $871a765ee5e657d2$export$426dc07f493a4c47);
$parcel$export($0e788201f8a90b1e$exports, "FormatTypes", () => $871a765ee5e657d2$export$f010f239efc4d445);
$parcel$export($0e788201f8a90b1e$exports, "checkResultErrors", () => $2c0f0ed4c5bed241$export$5546b9ec21157cc2);
$parcel$export($0e788201f8a90b1e$exports, "Logger", () => $97a8d5981d597bb7$export$efa9a398d6368992);
$parcel$export($0e788201f8a90b1e$exports, "RLP", () => $6ff2d0f6bfa15181$exports);
$parcel$export($0e788201f8a90b1e$exports, "_fetchData", () => $4d026a5befa5b358$export$e37fa27017c6c012);
$parcel$export($0e788201f8a90b1e$exports, "fetchJson", () => $4d026a5befa5b358$export$6d71b655afe1638d);
$parcel$export($0e788201f8a90b1e$exports, "poll", () => $4d026a5befa5b358$export$e0c10349b2c5e1d4);
$parcel$export($0e788201f8a90b1e$exports, "checkProperties", () => $a463a6b5f08d6875$export$ae5a316ba623b73a);
$parcel$export($0e788201f8a90b1e$exports, "deepCopy", () => $a463a6b5f08d6875$export$6c40052bed430212);
$parcel$export($0e788201f8a90b1e$exports, "defineReadOnly", () => $a463a6b5f08d6875$export$104236534534f9be);
$parcel$export($0e788201f8a90b1e$exports, "getStatic", () => $a463a6b5f08d6875$export$f695fbbf3cdaaf47);
$parcel$export($0e788201f8a90b1e$exports, "resolveProperties", () => $a463a6b5f08d6875$export$d503dd157d963b60);
$parcel$export($0e788201f8a90b1e$exports, "shallowCopy", () => $a463a6b5f08d6875$export$9c13236873b118a5);
$parcel$export($0e788201f8a90b1e$exports, "arrayify", () => $7b88b6e03e4708f2$export$3131421a7d01b4fb);
$parcel$export($0e788201f8a90b1e$exports, "concat", () => $7b88b6e03e4708f2$export$ee1b3e54f0441b22);
$parcel$export($0e788201f8a90b1e$exports, "stripZeros", () => $7b88b6e03e4708f2$export$a8f4574d0e56446c);
$parcel$export($0e788201f8a90b1e$exports, "zeroPad", () => $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d);
$parcel$export($0e788201f8a90b1e$exports, "isBytes", () => $7b88b6e03e4708f2$export$c6fabfbfd097fc30);
$parcel$export($0e788201f8a90b1e$exports, "isBytesLike", () => $7b88b6e03e4708f2$export$9a14abb1a440cd5e);
$parcel$export($0e788201f8a90b1e$exports, "defaultPath", () => $d830e21df8d45279$export$d48ad89f7e11a603);
$parcel$export($0e788201f8a90b1e$exports, "HDNode", () => $d830e21df8d45279$export$b68640c53e22b952);
$parcel$export($0e788201f8a90b1e$exports, "SigningKey", () => $ff9f75f56da7c459$export$21643ca94aed3e83);
$parcel$export($0e788201f8a90b1e$exports, "Interface", () => $ef97d5c3a9a93354$export$48cefb51a4e315b2);
$parcel$export($0e788201f8a90b1e$exports, "LogDescription", () => $ef97d5c3a9a93354$export$c2ab6499be98b3c5);
$parcel$export($0e788201f8a90b1e$exports, "TransactionDescription", () => $ef97d5c3a9a93354$export$7a3223b0fadb690b);
$parcel$export($0e788201f8a90b1e$exports, "base58", () => $3fca3a6183b20b71$export$45a587635c9954b2);
$parcel$export($0e788201f8a90b1e$exports, "base64", () => $aafe94bc1874bf9c$exports);
$parcel$export($0e788201f8a90b1e$exports, "hexlify", () => $7b88b6e03e4708f2$export$2b0d6b5fbe698c70);
$parcel$export($0e788201f8a90b1e$exports, "isHexString", () => $7b88b6e03e4708f2$export$b02a40aff8e4ad18);
$parcel$export($0e788201f8a90b1e$exports, "hexConcat", () => $7b88b6e03e4708f2$export$6d4b99629b38754a);
$parcel$export($0e788201f8a90b1e$exports, "hexStripZeros", () => $7b88b6e03e4708f2$export$967bc0082a978949);
$parcel$export($0e788201f8a90b1e$exports, "hexValue", () => $7b88b6e03e4708f2$export$6916af760a341dd3);
$parcel$export($0e788201f8a90b1e$exports, "hexZeroPad", () => $7b88b6e03e4708f2$export$e9c46a54370b47e8);
$parcel$export($0e788201f8a90b1e$exports, "hexDataLength", () => $7b88b6e03e4708f2$export$13882f896d3c0683);
$parcel$export($0e788201f8a90b1e$exports, "hexDataSlice", () => $7b88b6e03e4708f2$export$15da666eba198c18);
$parcel$export($0e788201f8a90b1e$exports, "nameprep", () => $9d6cc79a6dc289e5$export$94f0b6f93c619bc);
$parcel$export($0e788201f8a90b1e$exports, "_toEscapedUtf8String", () => $b2a54ce293d87a2e$export$a7a0ec15960b9055);
$parcel$export($0e788201f8a90b1e$exports, "toUtf8Bytes", () => $b2a54ce293d87a2e$export$8feeb310b4b4752f);
$parcel$export($0e788201f8a90b1e$exports, "toUtf8CodePoints", () => $b2a54ce293d87a2e$export$ae470a36a31b28c2);
$parcel$export($0e788201f8a90b1e$exports, "toUtf8String", () => $b2a54ce293d87a2e$export$7643a1dc2c38d5eb);
$parcel$export($0e788201f8a90b1e$exports, "Utf8ErrorFuncs", () => $b2a54ce293d87a2e$export$c6e2180c5bb5bc05);
$parcel$export($0e788201f8a90b1e$exports, "formatBytes32String", () => $df4edb3ed5b824a0$export$b97e949c0076e971);
$parcel$export($0e788201f8a90b1e$exports, "parseBytes32String", () => $df4edb3ed5b824a0$export$49340cb8f3954db8);
$parcel$export($0e788201f8a90b1e$exports, "dnsEncode", () => $62768931dfa5f58f$export$6c0a8cdae51cb512);
$parcel$export($0e788201f8a90b1e$exports, "hashMessage", () => $d83cea76876f8e45$export$d4c241cec96564c1);
$parcel$export($0e788201f8a90b1e$exports, "namehash", () => $62768931dfa5f58f$export$91d651ee363e1209);
$parcel$export($0e788201f8a90b1e$exports, "isValidName", () => $62768931dfa5f58f$export$cce2300886e7ace6);
$parcel$export($0e788201f8a90b1e$exports, "id", () => $7cd0a9996bd6b341$export$d560c7e4a29451c2);
$parcel$export($0e788201f8a90b1e$exports, "_TypedDataEncoder", () => $74ec091a01b8d3e1$export$458ab927ae635c3);
$parcel$export($0e788201f8a90b1e$exports, "getAddress", () => $8aee8aee2d40605d$export$88411125f012957a);
$parcel$export($0e788201f8a90b1e$exports, "getIcapAddress", () => $8aee8aee2d40605d$export$962c4ddada9f668f);
$parcel$export($0e788201f8a90b1e$exports, "getContractAddress", () => $8aee8aee2d40605d$export$b7fbffef12272e40);
$parcel$export($0e788201f8a90b1e$exports, "getCreate2Address", () => $8aee8aee2d40605d$export$e0b22d96621f73a2);
$parcel$export($0e788201f8a90b1e$exports, "isAddress", () => $8aee8aee2d40605d$export$977e255126d763d6);
$parcel$export($0e788201f8a90b1e$exports, "formatEther", () => $c043804acab33a9c$export$11bc63b4c03ea518);
$parcel$export($0e788201f8a90b1e$exports, "parseEther", () => $c043804acab33a9c$export$642c4e67bbdc0bc7);
$parcel$export($0e788201f8a90b1e$exports, "formatUnits", () => $c043804acab33a9c$export$bd39b96f71da1885);
$parcel$export($0e788201f8a90b1e$exports, "parseUnits", () => $c043804acab33a9c$export$203ae30b4f6490b3);
$parcel$export($0e788201f8a90b1e$exports, "commify", () => $c043804acab33a9c$export$de1294767e6ef661);
$parcel$export($0e788201f8a90b1e$exports, "computeHmac", () => $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff);
$parcel$export($0e788201f8a90b1e$exports, "keccak256", () => $1dbc6131e27af3ca$export$f8151fce47ad1c35);
$parcel$export($0e788201f8a90b1e$exports, "ripemd160", () => $bb82ee6f1acbd7c8$export$d1cea0ee4e3f0d3e);
$parcel$export($0e788201f8a90b1e$exports, "sha256", () => $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9);
$parcel$export($0e788201f8a90b1e$exports, "sha512", () => $bb82ee6f1acbd7c8$export$a888d2532e6dc7bb);
$parcel$export($0e788201f8a90b1e$exports, "randomBytes", () => $d0ff10d17aa2d59e$export$5f828d93ff035aa8);
$parcel$export($0e788201f8a90b1e$exports, "shuffled", () => $dc90334677e5edd7$export$e6c7296801b9b341);
$parcel$export($0e788201f8a90b1e$exports, "solidityPack", () => $dd0a1119d94e1d6f$export$2a703dbb0cb35339);
$parcel$export($0e788201f8a90b1e$exports, "solidityKeccak256", () => $dd0a1119d94e1d6f$export$f8151fce47ad1c35);
$parcel$export($0e788201f8a90b1e$exports, "soliditySha256", () => $dd0a1119d94e1d6f$export$bced8d2aada2d1c9);
$parcel$export($0e788201f8a90b1e$exports, "splitSignature", () => $7b88b6e03e4708f2$export$7fb170f1e457988f);
$parcel$export($0e788201f8a90b1e$exports, "joinSignature", () => $7b88b6e03e4708f2$export$71bb9d78a59bbe25);
$parcel$export($0e788201f8a90b1e$exports, "accessListify", () => $0a7021bc70fec74d$export$6c8662b1600dce2);
$parcel$export($0e788201f8a90b1e$exports, "parseTransaction", () => $0a7021bc70fec74d$export$98e6a39c04603d36);
$parcel$export($0e788201f8a90b1e$exports, "serializeTransaction", () => $0a7021bc70fec74d$export$dfdc1655ccc5b9cb);
$parcel$export($0e788201f8a90b1e$exports, "TransactionTypes", () => $0a7021bc70fec74d$export$80349e05e0724e11);
$parcel$export($0e788201f8a90b1e$exports, "getJsonWalletAddress", () => $e21ba517a486d299$export$9a68ee9f8f3afd38);
$parcel$export($0e788201f8a90b1e$exports, "computeAddress", () => $0a7021bc70fec74d$export$e67e2732ba9803f9);
$parcel$export($0e788201f8a90b1e$exports, "recoverAddress", () => $0a7021bc70fec74d$export$23cc18f96d8510e2);
$parcel$export($0e788201f8a90b1e$exports, "computePublicKey", () => $ff9f75f56da7c459$export$4a89473d39301224);
$parcel$export($0e788201f8a90b1e$exports, "recoverPublicKey", () => $ff9f75f56da7c459$export$952dd09fbe0232b7);
$parcel$export($0e788201f8a90b1e$exports, "verifyMessage", () => $3ff70163f9f2ebd5$export$228d0e772cc158cb);
$parcel$export($0e788201f8a90b1e$exports, "verifyTypedData", () => $3ff70163f9f2ebd5$export$3603b1c1bcd76798);
$parcel$export($0e788201f8a90b1e$exports, "getAccountPath", () => $d830e21df8d45279$export$22b80e4f9eff636d);
$parcel$export($0e788201f8a90b1e$exports, "mnemonicToEntropy", () => $d830e21df8d45279$export$135e090d58b310ca);
$parcel$export($0e788201f8a90b1e$exports, "entropyToMnemonic", () => $d830e21df8d45279$export$4becd65eb23312e6);
$parcel$export($0e788201f8a90b1e$exports, "isValidMnemonic", () => $d830e21df8d45279$export$5eea3393c6119c80);
$parcel$export($0e788201f8a90b1e$exports, "mnemonicToSeed", () => $d830e21df8d45279$export$3dee74f1204ab09f);
$parcel$export($0e788201f8a90b1e$exports, "SupportedAlgorithm", () => $da90616c06668669$export$d2a8849cfb277c);
$parcel$export($0e788201f8a90b1e$exports, "UnicodeNormalizationForm", () => $b2a54ce293d87a2e$export$c6986442964129f5);
$parcel$export($0e788201f8a90b1e$exports, "Utf8ErrorReason", () => $b2a54ce293d87a2e$export$c285fa6ac15ff6a6);
$parcel$export($0e788201f8a90b1e$exports, "Indexed", () => $ef97d5c3a9a93354$export$8ef99100a3c56f8c);


var $aafe94bc1874bf9c$exports = {};

$parcel$export($aafe94bc1874bf9c$exports, "decode", () => $1d2ab8f2156e640e$export$2f872c0f2117be69);
$parcel$export($aafe94bc1874bf9c$exports, "encode", () => $1d2ab8f2156e640e$export$c564cdbbe6da493);

"use strict";
















const $4fb643241867151c$export$83d89fbfd8236492 = "solidity/5.7.0";


"use strict";
const $dd0a1119d94e1d6f$var$regexBytes = new RegExp("^bytes([0-9]+)$");
const $dd0a1119d94e1d6f$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
const $dd0a1119d94e1d6f$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const $dd0a1119d94e1d6f$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
const $dd0a1119d94e1d6f$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $4fb643241867151c$export$83d89fbfd8236492));
function $dd0a1119d94e1d6f$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d)(value, 32);
            return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        case "string":
            return (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(value);
        case "bytes":
            return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d)(value, 32);
            return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
    }
    let match = type.match($dd0a1119d94e1d6f$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $dd0a1119d94e1d6f$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toTwos(size);
        return (0, $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d)(value, size / 8);
    }
    match = type.match($dd0a1119d94e1d6f$var$regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) $dd0a1119d94e1d6f$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value).byteLength !== size) $dd0a1119d94e1d6f$var$logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        if (isArray) return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((value + $dd0a1119d94e1d6f$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($dd0a1119d94e1d6f$var$regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) $dd0a1119d94e1d6f$var$logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        const result = [];
        value.forEach(function(value) {
            result.push($dd0a1119d94e1d6f$var$_pack(baseType, value, true));
        });
        return (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)(result);
    }
    return $dd0a1119d94e1d6f$var$logger.throwArgumentError("invalid type", "type", type);
}
function $dd0a1119d94e1d6f$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $dd0a1119d94e1d6f$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    const tight = [];
    types.forEach(function(type, index) {
        tight.push($dd0a1119d94e1d6f$var$_pack(type, values[index]));
    });
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)(tight));
}
function $dd0a1119d94e1d6f$export$f8151fce47ad1c35(types, values) {
    return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)($dd0a1119d94e1d6f$export$2a703dbb0cb35339(types, values));
}
function $dd0a1119d94e1d6f$export$bced8d2aada2d1c9(types, values) {
    return (0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)($dd0a1119d94e1d6f$export$2a703dbb0cb35339(types, values));
}









"use strict";
function $df4edb3ed5b824a0$export$b97e949c0076e971(text) {
    // Get the bytes
    const bytes = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        bytes,
        (0, $9b26373cc461c855$export$71c2e4e213dcb7f2)
    ]).slice(0, 32));
}
function $df4edb3ed5b824a0$export$49340cb8f3954db8(bytes) {
    const data = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    let length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(data.slice(0, length));
}


"use strict";
function $9d6cc79a6dc289e5$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    let result = [];
    for(let i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $9d6cc79a6dc289e5$var$createTable(data, func) {
    if (!func) func = function(value) {
        return [
            parseInt(value, 16)
        ];
    };
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair)=>{
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $9d6cc79a6dc289e5$var$createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v)=>{
        let comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $9d6cc79a6dc289e5$var$matchMap(value, ranges) {
    let lo = 0;
    for(let i = 0; i < ranges.length; i++){
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
const $9d6cc79a6dc289e5$var$Table_A_1_ranges = $9d6cc79a6dc289e5$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const $9d6cc79a6dc289e5$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v)=>parseInt(v, 16));
const $9d6cc79a6dc289e5$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
const $9d6cc79a6dc289e5$var$Table_B_2_lut_abs = $9d6cc79a6dc289e5$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const $9d6cc79a6dc289e5$var$Table_B_2_lut_rel = $9d6cc79a6dc289e5$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const $9d6cc79a6dc289e5$var$Table_B_2_complex = $9d6cc79a6dc289e5$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $9d6cc79a6dc289e5$var$bytes2);
const $9d6cc79a6dc289e5$var$Table_C_ranges = $9d6cc79a6dc289e5$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $9d6cc79a6dc289e5$var$flatten(values) {
    return values.reduce((accum, value)=>{
        value.forEach((value)=>{
            accum.push(value);
        });
        return accum;
    }, []);
}
function $9d6cc79a6dc289e5$export$d1ae0d802533bef0(codepoint) {
    return !!$9d6cc79a6dc289e5$var$matchMap(codepoint, $9d6cc79a6dc289e5$var$Table_A_1_ranges);
}
function $9d6cc79a6dc289e5$export$9630a1f26a43b76c(codepoint) {
    let range = $9d6cc79a6dc289e5$var$matchMap(codepoint, $9d6cc79a6dc289e5$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    let codes = $9d6cc79a6dc289e5$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    let shift = $9d6cc79a6dc289e5$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    let complex = $9d6cc79a6dc289e5$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $9d6cc79a6dc289e5$export$e07a548cae6d1553(codepoint) {
    return !!$9d6cc79a6dc289e5$var$matchMap(codepoint, $9d6cc79a6dc289e5$var$Table_C_ranges);
}
function $9d6cc79a6dc289e5$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    let codes = (0, $b2a54ce293d87a2e$export$ae470a36a31b28c2)(value);
    codes = $9d6cc79a6dc289e5$var$flatten(codes.map((code)=>{
        // Substitute Table B.1 (Maps to Nothing)
        if ($9d6cc79a6dc289e5$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = $9d6cc79a6dc289e5$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $b2a54ce293d87a2e$export$ae470a36a31b28c2)((0, $b2a54ce293d87a2e$export$232e1dab03132235)(codes), (0, $b2a54ce293d87a2e$export$c6986442964129f5).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code)=>{
        if ($9d6cc79a6dc289e5$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code)=>{
        if ($9d6cc79a6dc289e5$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    let name = (0, $b2a54ce293d87a2e$export$232e1dab03132235)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    return name;
}





const $18e24cde8c8cacf4$export$83d89fbfd8236492 = "units/5.7.0";


"use strict";
const $c043804acab33a9c$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $18e24cde8c8cacf4$export$83d89fbfd8236492));
const $c043804acab33a9c$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $c043804acab33a9c$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $c043804acab33a9c$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $c043804acab33a9c$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        const index = $c043804acab33a9c$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $bdc30db990c4b693$export$cc011b843b5d69f2)(value, unitName != null ? unitName : 18);
}
function $c043804acab33a9c$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $c043804acab33a9c$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        const index = $c043804acab33a9c$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $bdc30db990c4b693$export$1b039987e86d7269)(value, unitName != null ? unitName : 18);
}
function $c043804acab33a9c$export$11bc63b4c03ea518(wei) {
    return $c043804acab33a9c$export$bd39b96f71da1885(wei, 18);
}
function $c043804acab33a9c$export$642c4e67bbdc0bc7(ether) {
    return $c043804acab33a9c$export$203ae30b4f6490b3(ether, 18);
}




"use strict";



const $9f7bf65ddafc81a6$export$83d89fbfd8236492 = "ethers/5.7.2";


"use strict";
const $6c57cc56acea9c6c$export$af88d00dbe7f521 = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $9f7bf65ddafc81a6$export$83d89fbfd8236492));


"use strict";
try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) anyGlobal._ethers = $6c57cc56acea9c6c$exports;
} catch (error) {}


const $c0d5958e866e71f2$var$connectWallet = async ()=>{
    try {
        if (window.ethereum) {
            // console.log("MetaMask is available");
            const provider = new (0, $6c57cc56acea9c6c$exports).providers.Web3Provider(window.ethereum);
            // MetaMask requires requesting permission to connect users' accounts
            await window.ethereum.request({
                method: "eth_requestAccounts"
            });
            // console.log("Connected to MetaMask");
            return true;
        // Additional logic after successful connection, if needed
        } else // console.log("MetaMask not found. Please install MetaMask.");
        return false;
    } catch (error) {
    // console.error("Error connecting to MetaMask:", error);
    // Handle errors, e.g., user rejection or other issues
    }
};
var $c0d5958e866e71f2$export$2e2bcd8739ae039 = $c0d5958e866e71f2$var$connectWallet;


var $659a64d34e2c75cc$exports = {};
$659a64d34e2c75cc$exports = new URL("onlineConnected.6912a6ba.png", import.meta.url).toString();


function $bee863c90e0ad03d$export$2e2bcd8739ae039() {
    const [isConnected, setIsConnected] = (0, $acw62.useState)(false);
    const connect = async ()=>{
        const connected = await (0, $c0d5958e866e71f2$export$2e2bcd8739ae039)();
        if (connected) setIsConnected(true);
        else setIsConnected(false);
    };
    function Submit(e) {
        e.preventDefault();
        const formEle = document.querySelector("form");
        const formDatab = new FormData(formEle);
        fetch("https://script.google.com/macros/s/AKfycbwTajVy00E45EVwQH5SEOXAJUZFPZ-axFgJ0hqrMyu87GBYXs1a7_0XNAxlpocXAZrGzA/exec", {
            method: "POST",
            body: formDatab
        }).then((res)=>res.json()).then((data)=>{
        // console.log(data);
        }).catch((error)=>{
            console.log(error);
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "formWithDataBase",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "part1RegisterPage",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "headingTextForRegisterPage",
                        children: "Showcase your events in FluidPass Network"
                    }),
                    isConnected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "paragraph1TextForRegisterPage",
                                children: "Watch the video and connect your wallet to submit the form."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                width: "980",
                                height: "430",
                                src: "https://www.youtube.com/embed/4KLNw7OUTSk?si=FilB5NnTMf-mqu5a",
                                title: "YouTube video player",
                                frameborder: "0",
                                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                allowfullscreen: true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "part2RegisterPage",
                children: [
                    isConnected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "custom-btn btn-16 buttonContainer marBtn",
                        disable: true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "OnlineImg",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($659a64d34e2c75cc$exports))),
                                alt: "Successful, walled connected"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Wallet Connected"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "custom-btn btn-16 buttonContainer marBtn",
                        onClick: connect,
                        children: "Connect Wallet"
                    }),
                    isConnected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "paragraph2TextForRegisterPage",
                                children: "Fill the details and submit the form."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                className: "form",
                                onSubmit: (e)=>Submit(e),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "Your Name",
                                        name: "Name",
                                        type: "text"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "Your Email",
                                        name: "Email",
                                        type: "text"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "+91 XXXXXXXXXX",
                                        name: "Phone",
                                        type: "text"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "Need to register event",
                                        name: "Subject",
                                        type: "text"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "Your Message",
                                        name: "Message",
                                        type: "text"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        name: "Name",
                                        type: "submit"
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
}



const $0057e53b8130a065$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("footer", {
        className: "footerSection",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
            children: [
                " ",
                "Made with \u2764\uFE0F for the developers community |",
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: "https://linktr.ee/fluidpass",
                    target: "_blank",
                    className: "footerTextLink",
                    children: "FluidPass"
                })
            ]
        })
    });
};
var $0057e53b8130a065$export$2e2bcd8739ae039 = $0057e53b8130a065$var$Footer;


const $41c30f296cc10f61$var$RegisterEvent = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b15df6adfa52e3f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bee863c90e0ad03d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0057e53b8130a065$export$2e2bcd8739ae039), {})
        ]
    });
};
var $41c30f296cc10f61$export$2e2bcd8739ae039 = $41c30f296cc10f61$var$RegisterEvent;



parcelRequire("acw62");




const $dde09506a3a71a1f$export$ea86d35eea1f7f37 = [
    {
        attendeeinfo: {
            name: "Rahul",
            email: "rahul@xyz.com",
            message: "Excited"
        },
        eventInfo: {
            id: "000122",
            companyName: "Metaschool",
            name: "Road to Ai",
            date: "Feb 10, 2024",
            country: "Singapore",
            price: "$599",
            location: "Convention Center, Downtowm",
            description: "This event is related to the blockchain development. Web3 and more.",
            availableTickets: 500,
            ticketType: [
                "bronze",
                "silver",
                "gold"
            ],
            imageUrl: "https://images.pexels.com/photos/2747449/pexels-photo-2747449.jpeg?cs=srgb&dl=pexels-wolfgang-2747449.jpg&fm=jpg"
        }
    },
    {
        attendeeinfo: {
            name: "John",
            email: "johnl@xyz.com",
            message: "Neutral"
        },
        eventInfo: {
            id: "000111",
            companyName: "FluidPass",
            name: "Road to Event Management",
            date: "Jan 10, 2024",
            country: "India",
            price: "$1599",
            location: "Convention Center, Downtowm",
            description: "This event is related to the pass management and development. Web3 and more.",
            availableTickets: 300,
            ticketType: [
                "bronze",
                "silver",
                "gold"
            ],
            imageUrl: "https://images.pexels.com/photos/2747449/pexels-photo-2747449.jpeg?cs=srgb&dl=pexels-wolfgang-2747449.jpg&fm=jpg"
        }
    },
    {
        attendeeinfo: {
            name: "Rahul",
            email: "rahul@xyz.com",
            message: "Excited"
        },
        eventInfo: {
            id: "000122",
            companyName: "Metaschool",
            name: "Road to Ai",
            date: "Feb 10, 2024",
            country: "Singapore",
            price: "$599",
            location: "Convention Center, Downtowm",
            description: "This event is related to the blockchain development. Web3 and more.",
            availableTickets: 500,
            ticketType: [
                "bronze",
                "silver",
                "gold"
            ],
            imageUrl: "https://images.pexels.com/photos/2747449/pexels-photo-2747449.jpeg?cs=srgb&dl=pexels-wolfgang-2747449.jpg&fm=jpg"
        }
    },
    {
        attendeeinfo: {
            name: "John",
            email: "johnl@xyz.com",
            message: "Neutral"
        },
        eventInfo: {
            id: "000111",
            companyName: "FluidPass",
            name: "Road to Event Management",
            date: "Jan 10, 2024",
            country: "India",
            price: "$1599",
            location: "Convention Center, Downtowm",
            description: "This event is related to the pass management and development. Web3 and more.",
            availableTickets: 300,
            ticketType: [
                "bronze",
                "silver",
                "gold"
            ],
            imageUrl: "https://images.pexels.com/photos/2747449/pexels-photo-2747449.jpeg?cs=srgb&dl=pexels-wolfgang-2747449.jpg&fm=jpg"
        }
    },
    {
        attendeeinfo: {
            name: "Rahul",
            email: "rahul@xyz.com",
            message: "Excited"
        },
        eventInfo: {
            id: "000122",
            companyName: "Metaschool",
            name: "Road to AI",
            date: "Feb 10, 2024",
            country: "Singapore",
            price: "$599",
            location: "Convention Center, Downtowm",
            description: "This event is related to the blockchain development. Web3 and more.",
            availableTickets: 500,
            ticketType: [
                "bronze",
                "silver",
                "gold"
            ],
            imageUrl: "https://images.pexels.com/photos/2747449/pexels-photo-2747449.jpeg?cs=srgb&dl=pexels-wolfgang-2747449.jpg&fm=jpg"
        }
    },
    {
        attendeeinfo: {
            name: "John",
            email: "johnl@xyz.com",
            message: "Neutral"
        },
        eventInfo: {
            id: "000111",
            companyName: "FluidPass",
            name: "Road to Event Management",
            date: "Jan 10, 2024",
            country: "India",
            price: "$1599",
            location: "Convention Center, Downtowm",
            description: "This event is related to the pass management and development. Web3 and more.",
            availableTickets: 300,
            ticketType: [
                "bronze",
                "silver",
                "gold"
            ],
            imageUrl: "https://images.pexels.com/photos/2747449/pexels-photo-2747449.jpeg?cs=srgb&dl=pexels-wolfgang-2747449.jpg&fm=jpg"
        }
    },
    {
        attendeeinfo: {
            name: "Rahul",
            email: "rahul@xyz.com",
            message: "Excited"
        },
        eventInfo: {
            id: "000122",
            companyName: "Metaschool",
            name: "Road to Ai",
            date: "Feb 10, 2024",
            country: "Singapore",
            price: "$599",
            location: "Convention Center, Downtowm",
            description: "This event is related to the blockchain development. Web3 and more.",
            availableTickets: 500,
            ticketType: [
                "bronze",
                "silver",
                "gold"
            ],
            imageUrl: "https://images.pexels.com/photos/2747449/pexels-photo-2747449.jpeg?cs=srgb&dl=pexels-wolfgang-2747449.jpg&fm=jpg"
        }
    },
    {
        attendeeinfo: {
            name: "John",
            email: "johnl@xyz.com",
            message: "Neutral"
        },
        eventInfo: {
            id: "000111",
            companyName: "FluidPass",
            name: "Road to Event Management",
            date: "Jan 10, 2024",
            country: "India",
            price: "$1599",
            location: "Convention Center, Downtowm",
            description: "This event is related to the pass management and development. Web3 and more.",
            availableTickets: 300,
            ticketType: [
                "bronze",
                "silver",
                "gold"
            ],
            imageUrl: "https://images.pexels.com/photos/2747449/pexels-photo-2747449.jpeg?cs=srgb&dl=pexels-wolfgang-2747449.jpg&fm=jpg"
        }
    }
]; // const data = [
 // 	{
 // 		address: "0x1234567890123456789012345678901234567890",
 // 		transactions: {
 // 			hash: "0xabc123...",
 // 			from: "0x9876543210987654321098765432109876543210",
 // 			to: "0x1234567890123456789012345678901234567890",
 // 			value: "1000000000000000000",
 // 			timestamp: 1643565823,
 // 			status: "confirmed",
 // 		},
 // 		attendeeinfo: {
 // 			name: "Rahul",
 // 			email: "rahul@xyz.com",
 // 			message: "Excited",
 // 		},
 // 		eventInfo: {
 // 			companyName: "Metaschool",
 // 			name: "Road to AI",
 // 			date: "Feb 10, 2024",
 // 			country: "Singapore",
 // 			price: "$599",
 // 			location: "Convention Center, Downtowm",
 // 			description:
 // 				"This event is related to the blockchain development. Web3 and more.",
 // 			availableTickets: 500,
 // 			ticketType: ["bronze", "silver", "gold"],
 // 		},
 // 	},
 // 	{
 // 		address: "0x1234567890123456789012345678901234567890",
 // 		transactions: {
 // 			hash: "0xdef456...",
 // 			from: "0x5678901234567890123456789012345678901234",
 // 			to: "0x1234567890123456789012345678901234567890",
 // 			value: "500000000000000000",
 // 			timestamp: 1643565845,
 // 			status: "confirmed",
 // 		},
 // 	},
 // 	{
 // 		address: "0x1234567890123456789012345678901234567890",
 // 		transactions: {
 // 			hash: "0xghi789...",
 // 			from: "0x1234567890123456789012345678901234567890",
 // 			to: "0x3456789012345678901234567890123456789012",
 // 			value: "2000000000000000000",
 // 			timestamp: 1643565867,
 // 			status: "pending",
 // 		},
 // 	},
 // ];




const $6b4b0519a4d2031d$var$Card = (props)=>{
    const { imageUrl: imageUrl, companyName: companyName, country: country, date: date, description: description, location: location, name: name, price: price } = props.propsEventData.eventInfo;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
        to: "/register",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "card",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "cardImg",
                    src: imageUrl,
                    alt: "Image Event Page"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                    children: [
                        name,
                        " by ",
                        companyName
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "cardFeaturedSection",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                date,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                price,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                country,
                                " "
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: description
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: location
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: "/register",
                    className: "homeButton",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "custom-btn btn-16",
                        children: "Book Your Passes"
                    })
                })
            ]
        })
    });
};
var $6b4b0519a4d2031d$export$2e2bcd8739ae039 = $6b4b0519a4d2031d$var$Card;


const $45bac062bb840ed3$var$CardContainer = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "cardContainer",
        children: (0, $dde09506a3a71a1f$export$ea86d35eea1f7f37).map((element, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b4b0519a4d2031d$export$2e2bcd8739ae039), {
                propsEventData: element
            }, index + "eventInfo"))
    });
};
var $45bac062bb840ed3$export$2e2bcd8739ae039 = $45bac062bb840ed3$var$CardContainer;



const $cdfd7f03869f6175$var$CardHeadline = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "cardHeadline",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "cardHeadlinHeading",
                children: "Some Events Can Some Your Life"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "cardHeadlinDescription",
                children: "What are you waiting for? Discover Lifechanging Events..."
            })
        ]
    });
};
var $cdfd7f03869f6175$export$2e2bcd8739ae039 = $cdfd7f03869f6175$var$CardHeadline;


const $fbc695c6a248347e$var$EventPage = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "cardPage",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cdfd7f03869f6175$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45bac062bb840ed3$export$2e2bcd8739ae039), {})
        ]
    });
};
var $fbc695c6a248347e$export$2e2bcd8739ae039 = $fbc695c6a248347e$var$EventPage;



const $68cb735bcddac8f5$var$Events = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "containerSection",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b15df6adfa52e3f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbc695c6a248347e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0057e53b8130a065$export$2e2bcd8739ae039), {})
        ]
    });
};
var $68cb735bcddac8f5$export$2e2bcd8739ae039 = $68cb735bcddac8f5$var$Events;



parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");





/**
 * Credit of everything here goes to Redux Toolkit (RTK).
 */ const $84cbee41b67aefe0$var$commonProperties = [
    "name",
    "code",
    "message"
];
const $84cbee41b67aefe0$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $84cbee41b67aefe0$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};


const $ce3e8d521f64b0d2$var$errorTypeToTitleMap = new Map([
    [
        "FRAMEWORK_INITIALIZATION",
        "Framework Initialization"
    ],
    [
        "SUPERTOKEN_INITIALIZATION",
        "SuperToken Initialization"
    ],
    [
        "CREATE_SIGNER",
        "Create Signer"
    ],
    [
        "SUPERTOKEN_READ",
        "SuperToken Read"
    ],
    [
        "CFAV1_READ",
        "ConstantFlowAgreementV1 Read"
    ],
    [
        "IDAV1_READ",
        "InstantDistributionAgreementV1 Read"
    ],
    [
        "INVALID_ADDRESS",
        "Invalid Address"
    ],
    [
        "INVALID_OBJECT",
        "Invalid Object"
    ],
    [
        "UNSUPPORTED_OPERATION",
        "Unsupported Batch Call Operation"
    ],
    [
        "MISSING_TRANSACTION_PROPERTIES",
        "Missing Transaction Properties"
    ],
    [
        "BATCH_CALL_ERROR",
        "Batch Call"
    ],
    [
        "NETWORK_MISMATCH",
        "Network Mismatch"
    ],
    [
        "UNCLEAN_PERMISSIONS",
        "Unclean Permissions"
    ],
    [
        "NEGATIVE_FLOW_ALLOWANCE",
        "Negative Flow Rate Allowance"
    ]
]);
const $ce3e8d521f64b0d2$var$miniStringifyCause = (cause)=>{
    try {
        const serializedError = (0, $84cbee41b67aefe0$export$c97c53d0b2d5d81e)(cause);
        const stringifiedError = JSON.stringify(serializedError, null, 2);
        return stringifiedError.replace(/\\"/g, '"'); // Get rid of escaping of quotes.
    } catch  {
        // `miniSerializeError` is safe enough that this should never occur.
        console.error("SFError caused by: ", cause);
        return "[Couldn't serialize internal error. Error logged to console instead.]";
    }
};
class $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a extends Error {
    constructor({ type: type, message: message, cause: cause }){
        const fullMessage = `${$ce3e8d521f64b0d2$var$errorTypeToTitleMap.get(type)} Error: ${message}${cause ? `
Caused by: ${$ce3e8d521f64b0d2$var$miniStringifyCause(cause)}` : ""}`;
        super(fullMessage, cause ? {
            cause: cause
        } : {});
        // Fallback back environments where `Error.cause` is now yet natively supported
        if (cause && !this.cause) this.cause = cause;
        this.type = type;
        this.name = "SFError";
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
    }
}



function $e06b4ba471dee399$export$2e2bcd8739ae039(gasLimitish, multiplier) {
    const gasLimit = (0, $0df4577496dcf693$export$d97aa349ed20696).from(gasLimitish);
    // if gasLimit exists, an Overrides object has been passed or the user has explicitly set
    // NOTE: BigNumber doesn't support multiplication with decimals.
    const commonDenominator = 100;
    const multipliedGasLimit = multiplier === 1 // No need to modify gas limit when multiplier is 1.
     ? gasLimit : gasLimit.div(commonDenominator).mul(Math.round(multiplier * commonDenominator));
    return multipliedGasLimit;
}


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $01a11d2135fab358$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32"
            }
        ],
        name: "RoleAdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleGranted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleRevoked",
        type: "event"
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            }
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $01a11d2135fab358$export$f6cfb95b020c6526 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($01a11d2135fab358$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $01a11d2135fab358$var$_abi, signerOrProvider);
    }
}
$01a11d2135fab358$export$f6cfb95b020c6526.abi = $01a11d2135fab358$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $69c56a2a0b896e49$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32"
            }
        ],
        name: "RoleAdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleGranted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleRevoked",
        type: "event"
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            }
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            }
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            }
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $69c56a2a0b896e49$export$c46ed79fef5093a7 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($69c56a2a0b896e49$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $69c56a2a0b896e49$var$_abi, signerOrProvider);
    }
}
$69c56a2a0b896e49$export$c46ed79fef5093a7.abi = $69c56a2a0b896e49$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $53747f2d8e84e066$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32"
            }
        ],
        name: "RoleAdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleGranted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleRevoked",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            }
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $53747f2d8e84e066$export$d09aa57eafea5ff {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($53747f2d8e84e066$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $53747f2d8e84e066$var$_abi, signerOrProvider);
    }
}
$53747f2d8e84e066$export$d09aa57eafea5ff.abi = $53747f2d8e84e066$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $1a56cf52c239c300$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32"
            }
        ],
        name: "RoleAdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleGranted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleRevoked",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            }
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            }
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            }
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $1a56cf52c239c300$export$211ec959099baf2e {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($1a56cf52c239c300$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $1a56cf52c239c300$var$_abi, signerOrProvider);
    }
}
$1a56cf52c239c300$export$211ec959099baf2e.abi = $1a56cf52c239c300$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $578a0c394f47516d$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "OwnershipTransferred",
        type: "event"
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $578a0c394f47516d$export$ea955873d397d5b1 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($578a0c394f47516d$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $578a0c394f47516d$var$_abi, signerOrProvider);
    }
}
$578a0c394f47516d$export$ea955873d397d5b1.abi = $578a0c394f47516d$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $97efb1af515621d0$var$_abi = [
    {
        anonymous: false,
        inputs: [],
        name: "EIP712DomainChanged",
        type: "event"
    },
    {
        inputs: [],
        name: "eip712Domain",
        outputs: [
            {
                internalType: "bytes1",
                name: "fields",
                type: "bytes1"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "version",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "verifyingContract",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32"
            },
            {
                internalType: "uint256[]",
                name: "extensions",
                type: "uint256[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $97efb1af515621d0$export$4059189494dcd338 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($97efb1af515621d0$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $97efb1af515621d0$var$_abi, signerOrProvider);
    }
}
$97efb1af515621d0$export$4059189494dcd338.abi = $97efb1af515621d0$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $7b5786575d733599$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    }
];
class $7b5786575d733599$export$70e9cf49d3104494 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($7b5786575d733599$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $7b5786575d733599$var$_abi, signerOrProvider);
    }
}
$7b5786575d733599$export$70e9cf49d3104494.abi = $7b5786575d733599$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $decd8d3995f4a25a$var$_abi = [
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
class $decd8d3995f4a25a$export$475755c1a2fdfc44 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($decd8d3995f4a25a$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $decd8d3995f4a25a$var$_abi, signerOrProvider);
    }
}
$decd8d3995f4a25a$export$475755c1a2fdfc44.abi = $decd8d3995f4a25a$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $5bb6a889a6a00a0d$var$_abi = [
    {
        inputs: [],
        name: "InvalidShortString",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "str",
                type: "string"
            }
        ],
        name: "StringTooLong",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [],
        name: "EIP712DomainChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "eip712Domain",
        outputs: [
            {
                internalType: "bytes1",
                name: "fields",
                type: "bytes1"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "version",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "verifyingContract",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32"
            },
            {
                internalType: "uint256[]",
                name: "extensions",
                type: "uint256[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256"
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8"
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32"
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32"
            }
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $5bb6a889a6a00a0d$export$257675d8d9ed321d {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($5bb6a889a6a00a0d$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $5bb6a889a6a00a0d$var$_abi, signerOrProvider);
    }
}
$5bb6a889a6a00a0d$export$257675d8d9ed321d.abi = $5bb6a889a6a00a0d$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $38bf59142667d356$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $38bf59142667d356$export$99578399fa3f294d {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($38bf59142667d356$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $38bf59142667d356$var$_abi, signerOrProvider);
    }
}
$38bf59142667d356$export$99578399fa3f294d.abi = $38bf59142667d356$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $6cacdc94c4250797$var$_abi = [
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256"
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8"
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32"
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32"
            }
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $6cacdc94c4250797$export$304408e3aba291a8 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($6cacdc94c4250797$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $6cacdc94c4250797$var$_abi, signerOrProvider);
    }
}
$6cacdc94c4250797$export$304408e3aba291a8.abi = $6cacdc94c4250797$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $c6453d5cb5265be1$var$_abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name_",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $c6453d5cb5265be1$var$_bytecode = "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";
const $c6453d5cb5265be1$var$isSuperArgs = (xs)=>xs.length > 1;
class $c6453d5cb5265be1$export$58093157e65dc2e8 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($c6453d5cb5265be1$var$isSuperArgs(args)) super(...args);
        else super($c6453d5cb5265be1$var$_abi, $c6453d5cb5265be1$var$_bytecode, args[0]);
    }
    deploy(name_, symbol_, overrides) {
        return super.deploy(name_, symbol_, overrides || {});
    }
    getDeployTransaction(name_, symbol_, overrides) {
        return super.getDeployTransaction(name_, symbol_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($c6453d5cb5265be1$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $c6453d5cb5265be1$var$_abi, signerOrProvider);
    }
}
$c6453d5cb5265be1$export$58093157e65dc2e8.bytecode = $c6453d5cb5265be1$var$_bytecode;
$c6453d5cb5265be1$export$58093157e65dc2e8.abi = $c6453d5cb5265be1$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $6695fcec2b48648b$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $6695fcec2b48648b$export$d78f55477ff9aea9 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($6695fcec2b48648b$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $6695fcec2b48648b$var$_abi, signerOrProvider);
    }
}
$6695fcec2b48648b$export$d78f55477ff9aea9.abi = $6695fcec2b48648b$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $f967e1e623e83b57$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $f967e1e623e83b57$export$798794e52e66265a {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($f967e1e623e83b57$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $f967e1e623e83b57$var$_abi, signerOrProvider);
    }
}
$f967e1e623e83b57$export$798794e52e66265a.abi = $f967e1e623e83b57$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $b0550b7345486ea5$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $b0550b7345486ea5$export$cba133a6347a7b3f {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($b0550b7345486ea5$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $b0550b7345486ea5$var$_abi, signerOrProvider);
    }
}
$b0550b7345486ea5$export$cba133a6347a7b3f.abi = $b0550b7345486ea5$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $8f14bbe361cc72d5$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "AuthorizedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Burned",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Minted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "RevokedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Sent",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "authorizeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "defaultOperators",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "granularity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "isOperatorFor",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "revokeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $8f14bbe361cc72d5$export$fee658d7d21e3d4a {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($8f14bbe361cc72d5$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $8f14bbe361cc72d5$var$_abi, signerOrProvider);
    }
}
$8f14bbe361cc72d5$export$fee658d7d21e3d4a.abi = $8f14bbe361cc72d5$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $a1b37294ba84322e$var$_abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "tokensReceived",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $a1b37294ba84322e$export$5d7fb5749fa36027 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($a1b37294ba84322e$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $a1b37294ba84322e$var$_abi, signerOrProvider);
    }
}
$a1b37294ba84322e$export$5d7fb5749fa36027.abi = $a1b37294ba84322e$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $a03b142e1c562825$var$_abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "tokensToSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $a03b142e1c562825$export$1cb408e6c9df6904 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($a03b142e1c562825$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $a03b142e1c562825$var$_abi, signerOrProvider);
    }
}
$a03b142e1c562825$export$1cb408e6c9df6904.abi = $a03b142e1c562825$var$_abi;






/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $e39a3df59a42b96d$var$_abi = [
    {
        inputs: [],
        name: "InvalidShortString",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "str",
                type: "string"
            }
        ],
        name: "StringTooLong",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [],
        name: "EIP712DomainChanged",
        type: "event"
    },
    {
        inputs: [],
        name: "eip712Domain",
        outputs: [
            {
                internalType: "bytes1",
                name: "fields",
                type: "bytes1"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "version",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "verifyingContract",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32"
            },
            {
                internalType: "uint256[]",
                name: "extensions",
                type: "uint256[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $e39a3df59a42b96d$export$1e46aa6f2844df25 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($e39a3df59a42b96d$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $e39a3df59a42b96d$var$_abi, signerOrProvider);
    }
}
$e39a3df59a42b96d$export$1e46aa6f2844df25.abi = $e39a3df59a42b96d$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $2df48ef838fde4d4$var$_abi = [
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $2df48ef838fde4d4$export$f125213a47d13c0 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($2df48ef838fde4d4$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $2df48ef838fde4d4$var$_abi, signerOrProvider);
    }
}
$2df48ef838fde4d4$export$f125213a47d13c0.abi = $2df48ef838fde4d4$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $f3fdcb21cd21b4af$var$_abi = [
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "interfaceHash",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "canImplementInterfaceForAddress",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $f3fdcb21cd21b4af$var$_bytecode = "0x608060405234801561001057600080fd5b50610114806100206000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063249cb3fa14602d575b600080fd5b603c603836600460a4565b604e565b60405190815260200160405180910390f35b6000828152602081815260408083206001600160a01b038516845290915281205460ff16607b576000609d565b7fa2ef4600d742022d532d4747cb3547474667d6f13804902513b2ec01c848f4b45b9392505050565b6000806040838503121560b657600080fd5b8235915060208301356001600160a01b038116811460d357600080fd5b80915050925092905056fea264697066735822122006ff1b573197860a53ce71de2ccf4f76535fa2c003b79e61e97f91332c20a8a864736f6c63430008130033";
const $f3fdcb21cd21b4af$var$isSuperArgs = (xs)=>xs.length > 1;
class $f3fdcb21cd21b4af$export$e95d4df6ccf72165 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($f3fdcb21cd21b4af$var$isSuperArgs(args)) super(...args);
        else super($f3fdcb21cd21b4af$var$_abi, $f3fdcb21cd21b4af$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($f3fdcb21cd21b4af$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $f3fdcb21cd21b4af$var$_abi, signerOrProvider);
    }
}
$f3fdcb21cd21b4af$export$e95d4df6ccf72165.bytecode = $f3fdcb21cd21b4af$var$_bytecode;
$f3fdcb21cd21b4af$export$e95d4df6ccf72165.abi = $f3fdcb21cd21b4af$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $65c6677529c191db$var$_abi = [
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $65c6677529c191db$export$2f1906a7a213d13 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($65c6677529c191db$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $65c6677529c191db$var$_abi, signerOrProvider);
    }
}
$65c6677529c191db$export$2f1906a7a213d13.abi = $65c6677529c191db$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $26e88e2e1d7112b1$var$_abi = [
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "interfaceHash",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "canImplementInterfaceForAddress",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $26e88e2e1d7112b1$export$60af628a194d6736 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($26e88e2e1d7112b1$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $26e88e2e1d7112b1$var$_abi, signerOrProvider);
    }
}
$26e88e2e1d7112b1$export$60af628a194d6736.abi = $26e88e2e1d7112b1$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $5ded55d00f1755f7$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "interfaceHash",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "implementer",
                type: "address"
            }
        ],
        name: "InterfaceImplementerSet",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newManager",
                type: "address"
            }
        ],
        name: "ManagerChanged",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "_interfaceHash",
                type: "bytes32"
            }
        ],
        name: "getInterfaceImplementer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "implementsERC165Interface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "implementsERC165InterfaceNoCache",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "interfaceName",
                type: "string"
            }
        ],
        name: "interfaceHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "_interfaceHash",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "implementer",
                type: "address"
            }
        ],
        name: "setInterfaceImplementer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "newManager",
                type: "address"
            }
        ],
        name: "setManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "updateERC165Cache",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $5ded55d00f1755f7$export$e90111da4981d34f {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($5ded55d00f1755f7$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $5ded55d00f1755f7$var$_abi, signerOrProvider);
    }
}
$5ded55d00f1755f7$export$e90111da4981d34f.abi = $5ded55d00f1755f7$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $b20b49ab9a3ff980$var$_abi = [
    {
        inputs: [],
        name: "InvalidShortString",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "str",
                type: "string"
            }
        ],
        name: "StringTooLong",
        type: "error"
    }
];
const $b20b49ab9a3ff980$var$_bytecode = "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea264697066735822122061590f6cd635a06290c02b99def67baf87094bf1650d78eeb998755045f1522764736f6c63430008130033";
const $b20b49ab9a3ff980$var$isSuperArgs = (xs)=>xs.length > 1;
class $b20b49ab9a3ff980$export$1439ecf0c1634d79 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($b20b49ab9a3ff980$var$isSuperArgs(args)) super(...args);
        else super($b20b49ab9a3ff980$var$_abi, $b20b49ab9a3ff980$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($b20b49ab9a3ff980$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $b20b49ab9a3ff980$var$_abi, signerOrProvider);
    }
}
$b20b49ab9a3ff980$export$1439ecf0c1634d79.bytecode = $b20b49ab9a3ff980$var$_bytecode;
$b20b49ab9a3ff980$export$1439ecf0c1634d79.abi = $b20b49ab9a3ff980$var$_abi;








/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $46e3e261ad347377$var$_abi = [
    {
        inputs: [],
        name: "AGREEMENT_BASE_ONLY_HOST",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        inputs: [],
        name: "agreementType",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "time",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "dynamicBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $46e3e261ad347377$export$4a1822efa0e86af9 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($46e3e261ad347377$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $46e3e261ad347377$var$_abi, signerOrProvider);
    }
}
$46e3e261ad347377$export$4a1822efa0e86af9.abi = $46e3e261ad347377$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $55ad3ccbfefed53b$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "AGREEMENT_BASE_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_code",
                type: "uint256"
            }
        ],
        name: "APP_RULE",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_FLOW_RATE_ALLOWANCE_EXCEEDED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_NO_NEGATIVE_ALLOWANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_NO_SENDER_CREATE",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_NO_SENDER_FLOW_OPERATOR",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_NO_SENDER_UPDATE",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_OPERATOR_NO_CREATE_PERMISSIONS",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_OPERATOR_NO_DELETE_PERMISSIONS",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_OPERATOR_NO_UPDATE_PERMISSIONS",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_UNCLEAN_PERMISSIONS",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_DEPOSIT_TOO_BIG",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_FLOW_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_FLOW_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_FLOW_RATE_TOO_BIG",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_HOOK_OUT_OF_GAS",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_INVALID_FLOW_RATE",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NON_CRITICAL_SENDER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NO_SELF_FLOW",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ZERO_ADDRESS_RECEIVER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ZERO_ADDRESS_SENDER",
        type: "error"
    },
    {
        inputs: [],
        name: "OUT_OF_GAS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "permissions",
                type: "uint8"
            },
            {
                indexed: false,
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96"
            }
        ],
        name: "FlowOperatorUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                indexed: false,
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "totalSenderFlowRate",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "totalReceiverFlowRate",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "FlowUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            }
        ],
        name: "FlowUpdatedExtension",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        inputs: [],
        name: "CFA_HOOK_GAS_LIMIT",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_MINIMUM_DEPOSIT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "MAXIMUM_DEPOSIT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "MAXIMUM_FLOW_RATE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "existingPermissions",
                type: "uint8"
            },
            {
                internalType: "uint8",
                name: "permissionDelta",
                type: "uint8"
            }
        ],
        name: "addPermissions",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "agreementType",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "authorizeFlowOperatorWithFullControl",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "createFlow",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "createFlowByOperator",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "decreaseFlowRateAllowance",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "permissionsToRemove",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "decreaseFlowRateAllowanceWithPermissions",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "deleteFlow",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "deleteFlowByOperator",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountFlowInfo",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "getDepositRequiredForFlowRate",
        outputs: [
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getFlow",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "flowId",
                type: "bytes32"
            }
        ],
        name: "getFlowByID",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            }
        ],
        name: "getFlowOperatorData",
        outputs: [
            {
                internalType: "bytes32",
                name: "flowOperatorId",
                type: "bytes32"
            },
            {
                internalType: "uint8",
                name: "permissions",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "flowOperatorId",
                type: "bytes32"
            }
        ],
        name: "getFlowOperatorDataByID",
        outputs: [
            {
                internalType: "uint8",
                name: "permissions",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            }
        ],
        name: "getMaximumFlowRateFromDeposit",
        outputs: [
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getNetFlow",
        outputs: [
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "increaseFlowRateAllowance",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "permissionsToAdd",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "increaseFlowRateAllowanceWithPermissions",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isPatricianPeriod",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isPatricianPeriodNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCurrentlyPatricianPeriod",
                type: "bool"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "time",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "dynamicBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "existingPermissions",
                type: "uint8"
            },
            {
                internalType: "uint8",
                name: "permissionDelta",
                type: "uint8"
            }
        ],
        name: "removePermissions",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "revokeFlowOperatorWithFullControl",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "updateFlow",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "updateFlowByOperator",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "permissions",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "updateFlowOperatorPermissions",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $55ad3ccbfefed53b$var$_bytecode = "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";
const $55ad3ccbfefed53b$var$isSuperArgs = (xs)=>xs.length > 1;
class $55ad3ccbfefed53b$export$ce22caba4d9ebb7 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($55ad3ccbfefed53b$var$isSuperArgs(args)) super(...args);
        else super($55ad3ccbfefed53b$var$_abi, $55ad3ccbfefed53b$var$_bytecode, args[0]);
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($55ad3ccbfefed53b$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $55ad3ccbfefed53b$var$_abi, signerOrProvider);
    }
}
$55ad3ccbfefed53b$export$ce22caba4d9ebb7.bytecode = $55ad3ccbfefed53b$var$_bytecode;
$55ad3ccbfefed53b$export$ce22caba4d9ebb7.abi = $55ad3ccbfefed53b$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $fd58eb8ba0165eb0$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "AGREEMENT_BASE_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_INDEX_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_INDEX_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_INDEX_SHOULD_GROW",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_OPERATION_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_SUBSCRIPTION_ALREADY_APPROVED",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_SUBSCRIPTION_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_SUBSCRIPTION_IS_NOT_APPROVED",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_ZERO_ADDRESS_SUBSCRIBER",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "IndexCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "IndexDistributionClaimed",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "IndexSubscribed",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "IndexUnitsUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "IndexUnsubscribed",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "oldIndexValue",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "newIndexValue",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "totalUnitsPending",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "totalUnitsApproved",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "IndexUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "SubscriptionApproved",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "SubscriptionDistributionClaimed",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "SubscriptionRevoked",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "SubscriptionUnitsUpdated",
        type: "event"
    },
    {
        inputs: [],
        name: "MAX_NUM_SUBSCRIPTIONS",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "SLOTS_BITMAP_LIBRARY_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "agreementType",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "approveSubscription",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "calculateDistribution",
        outputs: [
            {
                internalType: "uint256",
                name: "actualAmount",
                type: "uint256"
            },
            {
                internalType: "uint128",
                name: "newIndexValue",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "claim",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "createIndex",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "deleteSubscription",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "distribute",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "getIndex",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsApproved",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsPending",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "getSubscription",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            }
        ],
        name: "getSubscriptionByID",
        outputs: [
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "listSubscriptions",
        outputs: [
            {
                internalType: "address[]",
                name: "publishers",
                type: "address[]"
            },
            {
                internalType: "uint32[]",
                name: "indexIds",
                type: "uint32[]"
            },
            {
                internalType: "uint128[]",
                name: "unitsList",
                type: "uint128[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "dynamicBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "revokeSubscription",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "updateIndex",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "updateSubscription",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $fd58eb8ba0165eb0$var$_bytecode = "0x60a06040523480156200001157600080fd5b506040516200531638038062005316833981016040819052620000349162000046565b6001600160a01b031660805262000078565b6000602082840312156200005957600080fd5b81516001600160a01b03811681146200007157600080fd5b9392505050565b6080516152826200009460003960006110f301526152826000f3fe608060405234801561001057600080fd5b50600436106101375760003560e01c80637fbc7639116100b8578063acafa1b81161007c578063acafa1b814610336578063acf4a6c214610349578063b6dacdb81461035c578063b96731c21461037e578063cd7245c514610391578063d787840a146103e957600080fd5b80637fbc76391461029f578063899baaec146102b25780639903ad38146102e25780639b2e48bc146102ea578063a5653ced1461031857600080fd5b806350d75d25116100ff57806350d75d251461020457806352d1902d1461020c5780635b534051146102225780636041ae96146102665780637730599e1461027957600080fd5b8063232d2b581461013c57806323fc23f3146101655780632e5e74c6146101a95780633fd4176a146101bc57806346951954146101ef575b600080fd5b61014f61014a3660046143b8565b6103fc565b60405161015c9190614493565b60405180910390f35b6101786101733660046144a6565b610b16565b6040805194151585526001600160801b0393841660208601529183169184019190915216606082015260800161015c565b61014f6101b73660046144f1565b610b81565b6101d773__$97ed594b3f931187fb739dcb88a7dff641$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$97ed594b3f931187fb739dcb88a7dff641$__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__$97ed594b3f931187fb739dcb88a7dff641$__6306967a8c85856000600160801b6040518563ffffffff1660e01b8152600401613c199493929190614b9a565b600060405180830381865af4158015613c36573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052613c5e91908101906150eb565b909250905060005b8151811015613cbf57613c9284838381518110613c8557613c85614b6e565b6020026020010151613fdf565b828281518110613ca457613ca4614b6e565b6020908102919091010152613cb8816151af565b9050613c66565b509250929050565b6000613cd16142a9565b604051636c2d9f2f60e01b815230600482015260248101849052600260448201526000906001600160a01b03861690636c2d9f2f90606401600060405180830381865afa158015613d26573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052613d4e9190810190614cc0565b9050600081600081518110613d6557613d65614b6e565b602002602001015160001c9050600082600181518110613d8757613d87614b6e565b602002602001015160001c905060008211945084156136a957606082811c60208087019190915283901c63ffffffff9081166040870152831685526001600160801b03821690850152608081811c908501525050509250929050565b600080836001600160a01b0316634b61cc33308564010000000060016040518563ffffffff1660e01b8152600401613e1e9493929190614b9a565b600060405180830381865afa158015613e3b573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052613e639190810190614cc0565b905080600081518110613e7857613e78614b6e565b602002602001015160001c91505092915050565b604051630a32470160e41b81526001600160a01b03808516600483015283166024820152600060448201819052600160801b6064830152608482018390529073__$97ed594b3f931187fb739dcb88a7dff641$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";
const $fd58eb8ba0165eb0$var$isSuperArgs = (xs)=>{
    return typeof xs[0] === "string" || Array.isArray(xs[0]) || "_isInterface" in xs[0];
};
class $fd58eb8ba0165eb0$export$c98541dc322440db extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($fd58eb8ba0165eb0$var$isSuperArgs(args)) super(...args);
        else {
            const [linkLibraryAddresses, signer] = args;
            super($fd58eb8ba0165eb0$var$_abi, $fd58eb8ba0165eb0$export$c98541dc322440db.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = $fd58eb8ba0165eb0$var$_bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$97ed594b3f931187fb739dcb88a7dff641\\$__", "g"), linkLibraryAddresses["contracts/libs/SlotsBitmapLibrary.sol:SlotsBitmapLibrary"].replace(/^0x/, "").toLowerCase());
        return linkedBytecode;
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($fd58eb8ba0165eb0$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $fd58eb8ba0165eb0$var$_abi, signerOrProvider);
    }
}
$fd58eb8ba0165eb0$export$c98541dc322440db.bytecode = $fd58eb8ba0165eb0$var$_bytecode;
$fd58eb8ba0165eb0$export$c98541dc322440db.abi = $fd58eb8ba0165eb0$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $82efd648cb00314c$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $82efd648cb00314c$export$d71dc453c253799c {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($82efd648cb00314c$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $82efd648cb00314c$var$_abi, signerOrProvider);
    }
}
$82efd648cb00314c$export$d71dc453c253799c.abi = $82efd648cb00314c$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $bf130b69574b9859$var$_abi = [
    {
        inputs: [],
        name: "NotAcceptedSuperToken",
        type: "error"
    },
    {
        inputs: [],
        name: "NotImplemented",
        type: "error"
    },
    {
        inputs: [],
        name: "UnauthorizedHost",
        type: "error"
    },
    {
        inputs: [],
        name: "CFAV1_TYPE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        name: "isAcceptedSuperToken",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $bf130b69574b9859$export$344bacd010de7617 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($bf130b69574b9859$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $bf130b69574b9859$var$_abi, signerOrProvider);
    }
}
$bf130b69574b9859$export$344bacd010de7617.abi = $bf130b69574b9859$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $8c2597a98843b126$var$_abi = [
    {
        inputs: [],
        name: "UnsupportedNetwork",
        type: "error"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $8c2597a98843b126$var$_bytecode = "0x6102cd61003a600b82828239805160001a60731461002d57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600436106100355760003560e01c806320bc44251461003a575b600080fd5b61004261005e565b6040516001600160a01b03909116815260200160405180910390f35b6000600146036100815750734e583d9390082b65bef884b629dfa426114ced6d90565b600a46036100a2575073567c4b141ed61923967ca25ef4906c8781069a1090565b603846036100c3575073d1e2cfb6441680002eb7a44223160ab9b67d7e6e90565b606446036100e45750732dfe937cd98ab92e59cf3139138f18c823a4efe790565b608946036101055750733e14dc1b13c488a8d5d310918780c983bd5982e790565b61a4b14603610127575073cf8acb4ef033eff16e8080aed4c7d5b9285d219290565b61a4ec4603610149575073a4ff07cf81c02cfd356184879d953970ca95758590565b61a86a460361016b57507360377c7016e4cdb03c87ef474896c11cb560752c90565b6005460361018c57507322ff293e14f1ec3a09b137e9e06084afd63addf990565b62066eed46036101af575073e40983c2476032a0915600b9472b3141aa5b5ba990565b6101a446036101d1575073e40983c2476032a0915600b9472b3141aa5b5ba990565b61a86946036101f357507385fe79b998509b77bf10a8bd4001d58475d2938690565b620138814603610216575073eb796bdb90ffa0f28255275e16936d25d341860390565b62aa36a74603610239575073109412e3c84f0539b43d39db691b08c90f58dc7c90565b62014a33460361025c575073507c3a7c6ccc253884a2e3a3ee2a211cc7e796a690565b6105a2460361027e575073e64f81d5ddda1c7172e5c6d964e8ef1bd82d870490565b604051633732a25760e11b815260040160405180910390fdfea2646970667358221220114465fd8371389b109b18e5e19f7e2c31b95dd500a0c97369fb43b1804da50064736f6c63430008130033";
const $8c2597a98843b126$var$isSuperArgs = (xs)=>xs.length > 1;
class $8c2597a98843b126$export$b661ac318d7b3e46 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($8c2597a98843b126$var$isSuperArgs(args)) super(...args);
        else super($8c2597a98843b126$var$_abi, $8c2597a98843b126$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($8c2597a98843b126$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $8c2597a98843b126$var$_abi, signerOrProvider);
    }
}
$8c2597a98843b126$export$b661ac318d7b3e46.bytecode = $8c2597a98843b126$var$_bytecode;
$8c2597a98843b126$export$b661ac318d7b3e46.abi = $8c2597a98843b126$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $7570d975954c793e$var$_abi = [
    {
        inputs: [],
        name: "SF_GOV_II_ONLY_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_GOV_INVALID_LIQUIDATION_OR_PATRICIAN_PERIOD",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_GOV_MUST_BE_CONTRACT",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "factory",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "authorized",
                type: "bool"
            }
        ],
        name: "AppFactoryAuthorizationChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                indexed: false,
                internalType: "string",
                name: "appRegistrationKey",
                type: "string"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "expirationTs",
                type: "uint256"
            }
        ],
        name: "AppRegistrationKeyChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            }
        ],
        name: "CFAv1LiquidationPeriodChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "ConfigChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "OwnershipTransferred",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            }
        ],
        name: "PPPConfigurationChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAddress",
                type: "address"
            }
        ],
        name: "RewardAddressChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "minimumDeposit",
                type: "uint256"
            }
        ],
        name: "SuperTokenMinimumDepositChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "address",
                name: "forwarder",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool"
            }
        ],
        name: "TrustedForwarderChanged",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "factory",
                type: "address"
            }
        ],
        name: "authorizeAppFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "token",
                type: "address[]"
            },
            {
                internalType: "address[]",
                name: "newAdmins",
                type: "address[]"
            }
        ],
        name: "batchChangeSuperTokenAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            }
        ],
        name: "batchUpdateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            },
            {
                internalType: "address[]",
                name: "tokenLogics",
                type: "address[]"
            }
        ],
        name: "batchUpdateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            },
            {
                internalType: "uint256[]",
                name: "minimumDeposits",
                type: "uint256[]"
            }
        ],
        name: "batchUpdateSuperTokenMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeSuperTokenAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        name: "clearAppRegistrationKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "clearConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "clearPPPConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "clearRewardAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "clearSuperTokenMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "disableTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "enableTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "getConfigAsAddress",
        outputs: [
            {
                internalType: "address",
                name: "value",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "getConfigAsUint256",
        outputs: [
            {
                internalType: "uint256",
                name: "period",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "getPPPConfig",
        outputs: [
            {
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "getRewardAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "getSuperTokenMinimumDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "factory",
                type: "address"
            }
        ],
        name: "isAuthorizedAppFactory",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "isTrustedForwarder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            }
        ],
        name: "registerAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "newGov",
                type: "address"
            }
        ],
        name: "replaceGovernance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "expirationTs",
                type: "uint256"
            }
        ],
        name: "setAppRegistrationKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "value",
                type: "address"
            }
        ],
        name: "setConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "setConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            }
        ],
        name: "setPPPConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "rewardAddress",
                type: "address"
            }
        ],
        name: "setRewardAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "setSuperTokenMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "factory",
                type: "address"
            }
        ],
        name: "unauthorizeAppFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "hostNewLogic",
                type: "address"
            },
            {
                internalType: "address[]",
                name: "agreementClassNewLogics",
                type: "address[]"
            },
            {
                internalType: "address",
                name: "superTokenFactoryNewLogic",
                type: "address"
            }
        ],
        name: "updateContracts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        name: "verifyAppRegistrationKey",
        outputs: [
            {
                internalType: "bool",
                name: "validNow",
                type: "bool"
            },
            {
                internalType: "uint256",
                name: "expirationTs",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $7570d975954c793e$var$_bytecode = "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";
const $7570d975954c793e$var$isSuperArgs = (xs)=>xs.length > 1;
class $7570d975954c793e$export$eaade2b72f505ed4 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($7570d975954c793e$var$isSuperArgs(args)) super(...args);
        else super($7570d975954c793e$var$_abi, $7570d975954c793e$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($7570d975954c793e$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $7570d975954c793e$var$_abi, signerOrProvider);
    }
}
$7570d975954c793e$export$eaade2b72f505ed4.bytecode = $7570d975954c793e$var$_bytecode;
$7570d975954c793e$export$eaade2b72f505ed4.abi = $7570d975954c793e$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $92cbad587d628c48$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "OwnershipTransferred",
        type: "event"
    },
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialAddress",
                type: "address"
            }
        ],
        name: "initializeProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
const $92cbad587d628c48$var$_bytecode = "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";
const $92cbad587d628c48$var$isSuperArgs = (xs)=>xs.length > 1;
class $92cbad587d628c48$export$60681155eec7d894 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($92cbad587d628c48$var$isSuperArgs(args)) super(...args);
        else super($92cbad587d628c48$var$_abi, $92cbad587d628c48$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($92cbad587d628c48$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $92cbad587d628c48$var$_abi, signerOrProvider);
    }
}
$92cbad587d628c48$export$60681155eec7d894.bytecode = $92cbad587d628c48$var$_bytecode;
$92cbad587d628c48$export$60681155eec7d894.abi = $92cbad587d628c48$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $030776657e8ce306$var$_abi = [
    {
        inputs: [],
        name: "SF_GOV_INVALID_LIQUIDATION_OR_PATRICIAN_PERIOD",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_GOV_MUST_BE_CONTRACT",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "factory",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "authorized",
                type: "bool"
            }
        ],
        name: "AppFactoryAuthorizationChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                indexed: false,
                internalType: "string",
                name: "appRegistrationKey",
                type: "string"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "expirationTs",
                type: "uint256"
            }
        ],
        name: "AppRegistrationKeyChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            }
        ],
        name: "CFAv1LiquidationPeriodChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "ConfigChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            }
        ],
        name: "PPPConfigurationChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAddress",
                type: "address"
            }
        ],
        name: "RewardAddressChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "minimumDeposit",
                type: "uint256"
            }
        ],
        name: "SuperTokenMinimumDepositChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "address",
                name: "forwarder",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool"
            }
        ],
        name: "TrustedForwarderChanged",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "factory",
                type: "address"
            }
        ],
        name: "authorizeAppFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "token",
                type: "address[]"
            },
            {
                internalType: "address[]",
                name: "newAdmins",
                type: "address[]"
            }
        ],
        name: "batchChangeSuperTokenAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            }
        ],
        name: "batchUpdateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            },
            {
                internalType: "address[]",
                name: "tokenLogics",
                type: "address[]"
            }
        ],
        name: "batchUpdateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            },
            {
                internalType: "uint256[]",
                name: "minimumDeposits",
                type: "uint256[]"
            }
        ],
        name: "batchUpdateSuperTokenMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeSuperTokenAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        name: "clearAppRegistrationKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "clearConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "clearPPPConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "clearRewardAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "clearSuperTokenMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "disableTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "enableTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "getConfigAsAddress",
        outputs: [
            {
                internalType: "address",
                name: "value",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "getConfigAsUint256",
        outputs: [
            {
                internalType: "uint256",
                name: "period",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "getPPPConfig",
        outputs: [
            {
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "getRewardAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "getSuperTokenMinimumDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "factory",
                type: "address"
            }
        ],
        name: "isAuthorizedAppFactory",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "isTrustedForwarder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            }
        ],
        name: "registerAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "newGov",
                type: "address"
            }
        ],
        name: "replaceGovernance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "expirationTs",
                type: "uint256"
            }
        ],
        name: "setAppRegistrationKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "value",
                type: "address"
            }
        ],
        name: "setConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "setConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            }
        ],
        name: "setPPPConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "rewardAddress",
                type: "address"
            }
        ],
        name: "setRewardAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "setSuperTokenMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "factory",
                type: "address"
            }
        ],
        name: "unauthorizeAppFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "hostNewLogic",
                type: "address"
            },
            {
                internalType: "address[]",
                name: "agreementClassNewLogics",
                type: "address[]"
            },
            {
                internalType: "address",
                name: "superTokenFactoryNewLogic",
                type: "address"
            }
        ],
        name: "updateContracts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        name: "verifyAppRegistrationKey",
        outputs: [
            {
                internalType: "bool",
                name: "validNow",
                type: "bool"
            },
            {
                internalType: "uint256",
                name: "expirationTs",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $030776657e8ce306$export$9dbf90902b5a74e0 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($030776657e8ce306$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $030776657e8ce306$var$_abi, signerOrProvider);
    }
}
$030776657e8ce306$export$9dbf90902b5a74e0.abi = $030776657e8ce306$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $81fa2b585dc580d7$var$_abi = [
    {
        inputs: [],
        name: "CFA_ACL_FLOW_RATE_ALLOWANCE_EXCEEDED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_NO_NEGATIVE_ALLOWANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_NO_SENDER_CREATE",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_NO_SENDER_FLOW_OPERATOR",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_NO_SENDER_UPDATE",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_OPERATOR_NO_CREATE_PERMISSIONS",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_OPERATOR_NO_DELETE_PERMISSIONS",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_OPERATOR_NO_UPDATE_PERMISSIONS",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ACL_UNCLEAN_PERMISSIONS",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_DEPOSIT_TOO_BIG",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_FLOW_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_FLOW_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_FLOW_RATE_TOO_BIG",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_HOOK_OUT_OF_GAS",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_INVALID_FLOW_RATE",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NON_CRITICAL_SENDER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NO_SELF_FLOW",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ZERO_ADDRESS_RECEIVER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ZERO_ADDRESS_SENDER",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "permissions",
                type: "uint8"
            },
            {
                indexed: false,
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96"
            }
        ],
        name: "FlowOperatorUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                indexed: false,
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "totalSenderFlowRate",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "totalReceiverFlowRate",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "FlowUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            }
        ],
        name: "FlowUpdatedExtension",
        type: "event"
    },
    {
        inputs: [],
        name: "agreementType",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "authorizeFlowOperatorWithFullControl",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "createFlow",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "createFlowByOperator",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "decreaseFlowRateAllowance",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "permissionsToRemove",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "decreaseFlowRateAllowanceWithPermissions",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "deleteFlow",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "deleteFlowByOperator",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountFlowInfo",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "getDepositRequiredForFlowRate",
        outputs: [
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getFlow",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            }
        ],
        name: "getFlowByID",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            }
        ],
        name: "getFlowOperatorData",
        outputs: [
            {
                internalType: "bytes32",
                name: "flowOperatorId",
                type: "bytes32"
            },
            {
                internalType: "uint8",
                name: "permissions",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "flowOperatorId",
                type: "bytes32"
            }
        ],
        name: "getFlowOperatorDataByID",
        outputs: [
            {
                internalType: "uint8",
                name: "permissions",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            }
        ],
        name: "getMaximumFlowRateFromDeposit",
        outputs: [
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getNetFlow",
        outputs: [
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "increaseFlowRateAllowance",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "permissionsToAdd",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "increaseFlowRateAllowanceWithPermissions",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isPatricianPeriod",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isPatricianPeriodNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCurrentlyPatricianPeriod",
                type: "bool"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "time",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "dynamicBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "revokeFlowOperatorWithFullControl",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "updateFlow",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "updateFlowByOperator",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "permissions",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "updateFlowOperatorPermissions",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $81fa2b585dc580d7$export$93a752d9b00820aa {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($81fa2b585dc580d7$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $81fa2b585dc580d7$var$_abi, signerOrProvider);
    }
}
$81fa2b585dc580d7$export$93a752d9b00820aa.abi = $81fa2b585dc580d7$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $9747b8919df0eef0$var$_abi = [
    {
        inputs: [],
        name: "IDA_INDEX_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_INDEX_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_INDEX_SHOULD_GROW",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_OPERATION_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_SUBSCRIPTION_ALREADY_APPROVED",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_SUBSCRIPTION_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_SUBSCRIPTION_IS_NOT_APPROVED",
        type: "error"
    },
    {
        inputs: [],
        name: "IDA_ZERO_ADDRESS_SUBSCRIBER",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "IndexCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "IndexDistributionClaimed",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "IndexSubscribed",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "IndexUnitsUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "IndexUnsubscribed",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "oldIndexValue",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "newIndexValue",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "totalUnitsPending",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "totalUnitsApproved",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "IndexUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "SubscriptionApproved",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "SubscriptionDistributionClaimed",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "SubscriptionRevoked",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "SubscriptionUnitsUpdated",
        type: "event"
    },
    {
        inputs: [],
        name: "agreementType",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "approveSubscription",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "calculateDistribution",
        outputs: [
            {
                internalType: "uint256",
                name: "actualAmount",
                type: "uint256"
            },
            {
                internalType: "uint128",
                name: "newIndexValue",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "claim",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "createIndex",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "deleteSubscription",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "distribute",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "getIndex",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsApproved",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsPending",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "getSubscription",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            }
        ],
        name: "getSubscriptionByID",
        outputs: [
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "listSubscriptions",
        outputs: [
            {
                internalType: "address[]",
                name: "publishers",
                type: "address[]"
            },
            {
                internalType: "uint32[]",
                name: "indexIds",
                type: "uint32[]"
            },
            {
                internalType: "uint128[]",
                name: "unitsList",
                type: "uint128[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "time",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "dynamicBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "revokeSubscription",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "updateIndex",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "updateSubscription",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $9747b8919df0eef0$export$572cca9965e684ae {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($9747b8919df0eef0$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $9747b8919df0eef0$var$_abi, signerOrProvider);
    }
}
$9747b8919df0eef0$export$572cca9965e684ae.abi = $9747b8919df0eef0$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $86498435f3d44d9c$var$_abi = [
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CALLER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CURRENT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_INVALID_TOKEN_ID",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_ONLY_SUPER_TOKEN_FACTORY",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_FROM_INCORRECT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_IS_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "CIF_NFT_ONLY_CONSTANT_OUTFLOW",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "MetadataUpdate",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "flowDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowSender",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowReceiver",
                        type: "address"
                    },
                    {
                        internalType: "uint32",
                        name: "flowStartDate",
                        type: "uint32"
                    }
                ],
                internalType: "struct IFlowNFTBase.FlowNFTData",
                name: "flowData",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "getTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "nftName",
                type: "string"
            },
            {
                internalType: "string",
                name: "nftSymbol",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "newTokenId",
                type: "uint256"
            }
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "triggerMetadataUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $86498435f3d44d9c$export$7a27a35a3fc4304 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($86498435f3d44d9c$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $86498435f3d44d9c$var$_abi, signerOrProvider);
    }
}
$86498435f3d44d9c$export$7a27a35a3fc4304.abi = $86498435f3d44d9c$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $374af535678b967a$var$_abi = [
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CALLER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CURRENT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_INVALID_TOKEN_ID",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_ONLY_SUPER_TOKEN_FACTORY",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_FROM_INCORRECT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_IS_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_INVALID_SUPER_TOKEN",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_MINT_TO_AND_FLOW_RECEIVER_SAME",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_MINT_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_ONLY_CONSTANT_INFLOW",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_ONLY_FLOW_AGREEMENTS",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_TOKEN_ALREADY_EXISTS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "MetadataUpdate",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "flowDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowSender",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowReceiver",
                        type: "address"
                    },
                    {
                        internalType: "uint32",
                        name: "flowStartDate",
                        type: "uint32"
                    }
                ],
                internalType: "struct IFlowNFTBase.FlowNFTData",
                name: "flowData",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "getTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "nftName",
                type: "string"
            },
            {
                internalType: "string",
                name: "nftSymbol",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "onCreate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "onDelete",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "onUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "triggerMetadataUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $374af535678b967a$export$e6980ce88a3c486f {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($374af535678b967a$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $374af535678b967a$var$_abi, signerOrProvider);
    }
}
$374af535678b967a$export$e6980ce88a3c486f.abi = $374af535678b967a$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $40e95a4eaf748586$var$_abi = [
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CALLER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CURRENT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_INVALID_TOKEN_ID",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_ONLY_SUPER_TOKEN_FACTORY",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_FROM_INCORRECT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_IS_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "MetadataUpdate",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "flowDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowSender",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowReceiver",
                        type: "address"
                    },
                    {
                        internalType: "uint32",
                        name: "flowStartDate",
                        type: "uint32"
                    }
                ],
                internalType: "struct IFlowNFTBase.FlowNFTData",
                name: "flowData",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "getTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "nftName",
                type: "string"
            },
            {
                internalType: "string",
                name: "nftSymbol",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "triggerMetadataUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $40e95a4eaf748586$export$140e776dcde757ed {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($40e95a4eaf748586$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $40e95a4eaf748586$var$_abi, signerOrProvider);
    }
}
$40e95a4eaf748586$export$140e776dcde757ed.abi = $40e95a4eaf748586$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $f01df73bdb9a44ab$var$_abi = [
    {
        inputs: [],
        name: "agreementType",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "time",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "dynamicBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $f01df73bdb9a44ab$export$938bfe135c73fe39 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($f01df73bdb9a44ab$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $f01df73bdb9a44ab$var$_abi, signerOrProvider);
    }
}
$f01df73bdb9a44ab$export$938bfe135c73fe39.abi = $f01df73bdb9a44ab$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $b45a425b34b625eb$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $b45a425b34b625eb$export$be73a785d547dea0 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($b45a425b34b625eb$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $b45a425b34b625eb$var$_abi, signerOrProvider);
    }
}
$b45a425b34b625eb$export$be73a785d547dea0.abi = $b45a425b34b625eb$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $5807054b8470dd5e$var$_abi = [
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_BURN_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_MOVE_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_BURN_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_CALLER_IS_NOT_OPERATOR_FOR_HOLDER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_INFLATIONARY_DEFLATIONARY_NOT_SUPPORTED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_MINT_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NFT_PROXY_ADDRESS_CHANGED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NOT_ERC777_TOKENS_RECIPIENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NO_UNDERLYING_TOKEN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_ADMIN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_GOV_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_SELF",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldAdmin",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "AdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "bondAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidatedBy",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAmountReceiver",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            }
        ],
        name: "AgreementLiquidatedV2",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            }
        ],
        name: "AgreementStateUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            }
        ],
        name: "AgreementTerminated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "AuthorizedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bailoutAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "Bailout",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Burned",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        name: "ConstantInflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            }
        ],
        name: "ConstantOutflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Minted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "RevokedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Sent",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenDowngraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenUpgraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "authorizeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "createAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "defaultOperators",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountActiveAgreements",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "activeAgreements",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementData",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementStateSlot",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingDecimals",
        outputs: [
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingToken",
        outputs: [
            {
                internalType: "address",
                name: "tokenAddr",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "granularity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "initializeWithAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountCritical",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountCriticalNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountSolvent",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountSolventNow",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "isOperatorFor",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            },
            {
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool"
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            }
        ],
        name: "makeLiquidationPayoutsV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationApprove",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "operationDecreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationDowngrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "operationIncreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "operationSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationUpgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "revokeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfApproveFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256"
            }
        ],
        name: "settleBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "terminateAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "toUnderlyingAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "underlyingAmount",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "adjustedAmount",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            }
        ],
        name: "transferAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementStateSlot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $5807054b8470dd5e$export$cb66d9a643e05307 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($5807054b8470dd5e$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $5807054b8470dd5e$var$_abi, signerOrProvider);
    }
}
$5807054b8470dd5e$export$cb66d9a643e05307.abi = $5807054b8470dd5e$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $fd62f3942b571916$var$_abi = [
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_NON_UPGRADEABLE_IS_DEPRECATED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_UNINITIALIZED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "CustomSuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "SuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "tokenLogic",
                type: "address"
            }
        ],
        name: "SuperTokenLogicCreated",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "computeCanonicalERC20WrapperAddress",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            },
            {
                internalType: "bool",
                name: "isDeployed",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "createCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingTokenAddress",
                type: "address"
            }
        ],
        name: "getCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenLogic",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "customSuperTokenProxy",
                type: "address"
            }
        ],
        name: "initializeCustomSuperToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $fd62f3942b571916$export$d4b2384fdcb58611 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($fd62f3942b571916$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $fd62f3942b571916$var$_abi, signerOrProvider);
    }
}
$fd62f3942b571916$export$d4b2384fdcb58611.abi = $fd62f3942b571916$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $7e066a4ac1ff6868$var$_abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_code",
                type: "uint256"
            }
        ],
        name: "APP_RULE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_ALREADY_REGISTERED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_CALLBACK_IS_NOT_ACTION",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_IS_NOT_REGISTERED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_CALL_AGREEMENT_WITH_CTX_FROM_WRONG_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_CALL_APP_ACTION_WITH_CTX_FROM_WRONG_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_CANNOT_DOWNGRADE_TO_NON_UPGRADEABLE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_INVALID_CONFIG_WORD",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_MAX_256_AGREEMENTS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_MUST_BE_CONTRACT",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NEED_MORE_GAS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NON_UPGRADEABLE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NON_ZERO_LENGTH_PLACEHOLDER_CTX",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NOT_A_SUPER_APP",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NO_APP_REGISTRATION_PERMISSION",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_ONLY_GOVERNANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_RECEIVER_IS_NOT_SUPER_APP",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SENDER_IS_NOT_SUPER_APP",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SOURCE_APP_NEEDS_HIGHER_APP_LEVEL",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SUPER_APP_ALREADY_REGISTERED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SUPER_APP_IS_JAILED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_UNKNOWN_BATCH_CALL_OPERATION_TYPE",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address"
            }
        ],
        name: "AgreementClassRegistered",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address"
            }
        ],
        name: "AgreementClassUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "AppRegistered",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ISuperfluidGovernance",
                name: "oldGov",
                type: "address"
            },
            {
                indexed: false,
                internalType: "contract ISuperfluidGovernance",
                name: "newGov",
                type: "address"
            }
        ],
        name: "GovernanceReplaced",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reason",
                type: "uint256"
            }
        ],
        name: "Jail",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ISuperTokenFactory",
                name: "newFactory",
                type: "address"
            }
        ],
        name: "SuperTokenFactoryUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address"
            }
        ],
        name: "SuperTokenLogicUpdated",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256"
            },
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "addToAgreementClassesBitmap",
        outputs: [
            {
                internalType: "uint256",
                name: "newBitmap",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "targetApp",
                type: "address"
            }
        ],
        name: "allowCompositeApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "int256",
                name: "appCreditUsedDelta",
                type: "int256"
            }
        ],
        name: "appCallbackPop",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "appCreditGranted",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "appCreditUsed",
                type: "int256"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "appCreditToken",
                type: "address"
            }
        ],
        name: "appCallbackPush",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "operationType",
                        type: "uint32"
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address"
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes"
                    }
                ],
                internalType: "struct ISuperfluid.Operation[]",
                name: "operations",
                type: "tuple[]"
            }
        ],
        name: "batchCall",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "callAgreement",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAgreementWithContext",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            }
        ],
        name: "callAppAction",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppActionWithContext",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bool",
                name: "isTermination",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppAfterCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bool",
                name: "isTermination",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppBeforeCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeSuperTokenAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "int256",
                name: "appCreditUsedMore",
                type: "int256"
            }
        ],
        name: "ctxUseCredit",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "decodeCtx",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "appCallbackLevel",
                        type: "uint8"
                    },
                    {
                        internalType: "uint8",
                        name: "callType",
                        type: "uint8"
                    },
                    {
                        internalType: "uint256",
                        name: "timestamp",
                        type: "uint256"
                    },
                    {
                        internalType: "address",
                        name: "msgSender",
                        type: "address"
                    },
                    {
                        internalType: "bytes4",
                        name: "agreementSelector",
                        type: "bytes4"
                    },
                    {
                        internalType: "bytes",
                        name: "userData",
                        type: "bytes"
                    },
                    {
                        internalType: "uint256",
                        name: "appCreditGranted",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "appCreditWantedDeprecated",
                        type: "uint256"
                    },
                    {
                        internalType: "int256",
                        name: "appCreditUsed",
                        type: "int256"
                    },
                    {
                        internalType: "address",
                        name: "appAddress",
                        type: "address"
                    },
                    {
                        internalType: "contract ISuperfluidToken",
                        name: "appCreditToken",
                        type: "address"
                    }
                ],
                internalType: "struct ISuperfluid.Context",
                name: "context",
                type: "tuple"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "operationType",
                        type: "uint32"
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address"
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes"
                    }
                ],
                internalType: "struct ISuperfluid.Operation[]",
                name: "operations",
                type: "tuple[]"
            }
        ],
        name: "forwardBatchCall",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "getAgreementClass",
        outputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "getAppCallbackLevel",
        outputs: [
            {
                internalType: "uint8",
                name: "appCallbackLevel",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "getAppManifest",
        outputs: [
            {
                internalType: "bool",
                name: "isSuperApp",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "isJailed",
                type: "bool"
            },
            {
                internalType: "uint256",
                name: "noopMask",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getGovernance",
        outputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "governance",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getNow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenFactory",
        outputs: [
            {
                internalType: "contract ISuperTokenFactory",
                name: "factory",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenFactoryLogic",
        outputs: [
            {
                internalType: "address",
                name: "logic",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            }
        ],
        name: "isAgreementClassListed",
        outputs: [
            {
                internalType: "bool",
                name: "yes",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "isAgreementTypeListed",
        outputs: [
            {
                internalType: "bool",
                name: "yes",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "isApp",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "isAppJailed",
        outputs: [
            {
                internalType: "bool",
                name: "isJail",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "contract ISuperApp",
                name: "targetApp",
                type: "address"
            }
        ],
        name: "isCompositeAppAllowed",
        outputs: [
            {
                internalType: "bool",
                name: "isAppAllowed",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "isCtxValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "reason",
                type: "uint256"
            }
        ],
        name: "jailApp",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256"
            }
        ],
        name: "mapAgreementClasses",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "agreementClasses",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClassLogic",
                type: "address"
            }
        ],
        name: "registerAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerAppByFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        name: "registerAppWithKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256"
            },
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "removeFromAgreementClassesBitmap",
        outputs: [
            {
                internalType: "uint256",
                name: "newBitmap",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "newGov",
                type: "address"
            }
        ],
        name: "replaceGovernance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClassLogic",
                type: "address"
            }
        ],
        name: "updateAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperTokenFactory",
                name: "newFactory",
                type: "address"
            }
        ],
        name: "updateSuperTokenFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "newLogicOverride",
                type: "address"
            }
        ],
        name: "updateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $7e066a4ac1ff6868$export$f0472b07293c0674 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($7e066a4ac1ff6868$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $7e066a4ac1ff6868$var$_abi, signerOrProvider);
    }
}
$7e066a4ac1ff6868$export$f0472b07293c0674.abi = $7e066a4ac1ff6868$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $61560836ac62a92b$var$_abi = [
    {
        inputs: [],
        name: "SF_GOV_INVALID_LIQUIDATION_OR_PATRICIAN_PERIOD",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_GOV_MUST_BE_CONTRACT",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            }
        ],
        name: "batchUpdateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            },
            {
                internalType: "address[]",
                name: "tokenLogics",
                type: "address[]"
            }
        ],
        name: "batchUpdateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "clearConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "getConfigAsAddress",
        outputs: [
            {
                internalType: "address",
                name: "value",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "getConfigAsUint256",
        outputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            }
        ],
        name: "registerAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "newGov",
                type: "address"
            }
        ],
        name: "replaceGovernance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "value",
                type: "address"
            }
        ],
        name: "setConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "setConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "hostNewLogic",
                type: "address"
            },
            {
                internalType: "address[]",
                name: "agreementClassNewLogics",
                type: "address[]"
            },
            {
                internalType: "address",
                name: "superTokenFactoryNewLogic",
                type: "address"
            }
        ],
        name: "updateContracts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $61560836ac62a92b$export$f4a2f6fb82da23e {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($61560836ac62a92b$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $61560836ac62a92b$var$_abi, signerOrProvider);
    }
}
$61560836ac62a92b$export$f4a2f6fb82da23e.abi = $61560836ac62a92b$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $08bbf9aa1edf321f$var$_abi = [
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_BURN_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_MOVE_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "bondAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidatedBy",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAmountReceiver",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            }
        ],
        name: "AgreementLiquidatedV2",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            }
        ],
        name: "AgreementStateUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            }
        ],
        name: "AgreementTerminated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bailoutAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "Bailout",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "createAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountActiveAgreements",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "activeAgreements",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementData",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementStateSlot",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountCritical",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountCriticalNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountSolvent",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountSolventNow",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            },
            {
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool"
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            }
        ],
        name: "makeLiquidationPayoutsV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256"
            }
        ],
        name: "settleBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "terminateAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementStateSlot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $08bbf9aa1edf321f$export$2a20330772749991 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($08bbf9aa1edf321f$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $08bbf9aa1edf321f$var$_abi, signerOrProvider);
    }
}
$08bbf9aa1edf321f$export$2a20330772749991.abi = $08bbf9aa1edf321f$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $f903780100ca1f0a$var$_abi = [
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_BURN_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_MOVE_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_BURN_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_CALLER_IS_NOT_OPERATOR_FOR_HOLDER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_INFLATIONARY_DEFLATIONARY_NOT_SUPPORTED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_MINT_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NFT_PROXY_ADDRESS_CHANGED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NOT_ERC777_TOKENS_RECIPIENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NO_UNDERLYING_TOKEN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_ADMIN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_GOV_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_SELF",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldAdmin",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "AdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "bondAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidatedBy",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAmountReceiver",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            }
        ],
        name: "AgreementLiquidatedV2",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            }
        ],
        name: "AgreementStateUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            }
        ],
        name: "AgreementTerminated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "AuthorizedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bailoutAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "Bailout",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Burned",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        name: "ConstantInflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            }
        ],
        name: "ConstantOutflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Minted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "RevokedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Sent",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenDowngraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenUpgraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "authorizeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "createAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "defaultOperators",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountActiveAgreements",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "activeAgreements",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementData",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementStateSlot",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingDecimals",
        outputs: [
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingToken",
        outputs: [
            {
                internalType: "address",
                name: "tokenAddr",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "granularity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "initialSupply",
                type: "uint256"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "initializeWithAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountCritical",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountCriticalNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountSolvent",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountSolventNow",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "isOperatorFor",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            },
            {
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool"
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            }
        ],
        name: "makeLiquidationPayoutsV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationApprove",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "operationDecreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationDowngrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "operationIncreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "operationSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationUpgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "revokeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfApproveFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256"
            }
        ],
        name: "settleBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "terminateAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "toUnderlyingAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "underlyingAmount",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "adjustedAmount",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            }
        ],
        name: "transferAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementStateSlot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $f903780100ca1f0a$export$3425bae74fcfd970 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($f903780100ca1f0a$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $f903780100ca1f0a$var$_abi, signerOrProvider);
    }
}
$f903780100ca1f0a$export$3425bae74fcfd970.abi = $f903780100ca1f0a$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $b33dd3028d62f0c9$var$_abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "initialSupply",
                type: "uint256"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $b33dd3028d62f0c9$export$2f45578201744a5d {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($b33dd3028d62f0c9$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $b33dd3028d62f0c9$var$_abi, signerOrProvider);
    }
}
$b33dd3028d62f0c9$export$2f45578201744a5d.abi = $b33dd3028d62f0c9$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $9790b5504bbc42fa$var$_abi = [
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_BURN_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_MOVE_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_BURN_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_CALLER_IS_NOT_OPERATOR_FOR_HOLDER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_INFLATIONARY_DEFLATIONARY_NOT_SUPPORTED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_MINT_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NFT_PROXY_ADDRESS_CHANGED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NOT_ERC777_TOKENS_RECIPIENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NO_UNDERLYING_TOKEN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_ADMIN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_GOV_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_SELF",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldAdmin",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "AdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "bondAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidatedBy",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAmountReceiver",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            }
        ],
        name: "AgreementLiquidatedV2",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            }
        ],
        name: "AgreementStateUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            }
        ],
        name: "AgreementTerminated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "AuthorizedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bailoutAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "Bailout",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Burned",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        name: "ConstantInflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            }
        ],
        name: "ConstantOutflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Minted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "RevokedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Sent",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenDowngraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenUpgraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "authorizeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "createAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "defaultOperators",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "wad",
                type: "uint256"
            }
        ],
        name: "downgradeToETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountActiveAgreements",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "activeAgreements",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementData",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementStateSlot",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingDecimals",
        outputs: [
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingToken",
        outputs: [
            {
                internalType: "address",
                name: "tokenAddr",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "granularity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "initializeWithAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountCritical",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountCriticalNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountSolvent",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountSolventNow",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "isOperatorFor",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            },
            {
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool"
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            }
        ],
        name: "makeLiquidationPayoutsV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationApprove",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "operationDecreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationDowngrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "operationIncreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "operationSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationUpgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "revokeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfApproveFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256"
            }
        ],
        name: "settleBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "terminateAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "toUnderlyingAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "underlyingAmount",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "adjustedAmount",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            }
        ],
        name: "transferAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementStateSlot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "upgradeByETH",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            }
        ],
        name: "upgradeByETHTo",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $9790b5504bbc42fa$export$e4ae7ea5e37d1039 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($9790b5504bbc42fa$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $9790b5504bbc42fa$var$_abi, signerOrProvider);
    }
}
$9790b5504bbc42fa$export$e4ae7ea5e37d1039.abi = $9790b5504bbc42fa$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $4b8b08967e285082$var$_abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "wad",
                type: "uint256"
            }
        ],
        name: "downgradeToETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "upgradeByETH",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            }
        ],
        name: "upgradeByETHTo",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    }
];
class $4b8b08967e285082$export$3a2bd84167c544b4 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($4b8b08967e285082$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $4b8b08967e285082$var$_abi, signerOrProvider);
    }
}
$4b8b08967e285082$export$3a2bd84167c544b4.abi = $4b8b08967e285082$var$_abi;






/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $0ece409f661bd10a$var$_abi = [
    {
        inputs: [],
        name: "required",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "destination",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "submitTransaction",
        outputs: [
            {
                internalType: "uint256",
                name: "transactionId",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $0ece409f661bd10a$export$2a51ea549c9b4b72 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($0ece409f661bd10a$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $0ece409f661bd10a$var$_abi, signerOrProvider);
    }
}
$0ece409f661bd10a$export$2a51ea549c9b4b72.abi = $0ece409f661bd10a$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $d43270c49d9f7f0a$var$_abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "isTrustedForwarder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "versionRecipient",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $d43270c49d9f7f0a$export$b87eb6f5ec0fb7b4 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($d43270c49d9f7f0a$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $d43270c49d9f7f0a$var$_abi, signerOrProvider);
    }
}
$d43270c49d9f7f0a$export$b87eb6f5ec0fb7b4.abi = $d43270c49d9f7f0a$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $5c4aea2874628082$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                indexed: false,
                internalType: "address",
                name: "target",
                type: "address"
            }
        ],
        name: "Set",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string"
            }
        ],
        name: "get",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "address",
                name: "target",
                type: "address"
            }
        ],
        name: "set",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $5c4aea2874628082$export$bd190928986c2831 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($5c4aea2874628082$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $5c4aea2874628082$var$_abi, signerOrProvider);
    }
}
$5c4aea2874628082$export$bd190928986c2831.abi = $5c4aea2874628082$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $d3d3e53d1229c858$var$_abi = [
    {
        inputs: [],
        name: "VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "uint8",
                name: "operation",
                type: "uint8"
            },
            {
                internalType: "uint256",
                name: "safeTxGas",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "baseGas",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "gasPrice",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "gasToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "refundReceiver",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256"
            }
        ],
        name: "getTransactionHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "nonce",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $d3d3e53d1229c858$export$e91fa28fb106919a {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($d3d3e53d1229c858$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $d3d3e53d1229c858$var$_abi, signerOrProvider);
    }
}
$d3d3e53d1229c858$export$e91fa28fb106919a.abi = $d3d3e53d1229c858$var$_abi;






/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $887aaeb430fe1f02$var$_abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "isTrustedForwarder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "versionRecipient",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $887aaeb430fe1f02$export$d4bd74d18c5a3e2 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($887aaeb430fe1f02$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $887aaeb430fe1f02$var$_abi, signerOrProvider);
    }
}
$887aaeb430fe1f02$export$d4bd74d18c5a3e2.abi = $887aaeb430fe1f02$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $8d6b5400dec102c2$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    }
];
const $8d6b5400dec102c2$var$_bytecode = "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220d4f035db208db60e270656614cb3fb29ef439bcb20f1d90af31ee90f27ac847364736f6c63430008130033";
const $8d6b5400dec102c2$var$isSuperArgs = (xs)=>xs.length > 1;
class $8d6b5400dec102c2$export$d192932ccf1673a extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($8d6b5400dec102c2$var$isSuperArgs(args)) super(...args);
        else super($8d6b5400dec102c2$var$_abi, $8d6b5400dec102c2$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($8d6b5400dec102c2$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $8d6b5400dec102c2$var$_abi, signerOrProvider);
    }
}
$8d6b5400dec102c2$export$d192932ccf1673a.bytecode = $8d6b5400dec102c2$var$_bytecode;
$8d6b5400dec102c2$export$d192932ccf1673a.abi = $8d6b5400dec102c2$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $628edfd3dbc44f4b$var$_abi = [
    {
        inputs: [],
        name: "OUT_OF_GAS",
        type: "error"
    }
];
const $628edfd3dbc44f4b$var$_bytecode = "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220784510cd69808ad2c4a5bcb1683a3accafb6358d6eec93735914640b5ca5986264736f6c63430008130033";
const $628edfd3dbc44f4b$var$isSuperArgs = (xs)=>xs.length > 1;
class $628edfd3dbc44f4b$export$a6c83210b8d878a5 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($628edfd3dbc44f4b$var$isSuperArgs(args)) super(...args);
        else super($628edfd3dbc44f4b$var$_abi, $628edfd3dbc44f4b$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($628edfd3dbc44f4b$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $628edfd3dbc44f4b$var$_abi, signerOrProvider);
    }
}
$628edfd3dbc44f4b$export$a6c83210b8d878a5.bytecode = $628edfd3dbc44f4b$var$_bytecode;
$628edfd3dbc44f4b$export$a6c83210b8d878a5.abi = $628edfd3dbc44f4b$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $ee613d70c6990317$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "ISuperfluidToken"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bitmapStateSlotId",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "dataStateSlotIDStart",
                type: "uint256"
            }
        ],
        name: "listData",
        outputs: [
            {
                internalType: "uint32[]",
                name: "slotIds",
                type: "uint32[]"
            },
            {
                internalType: "bytes32[]",
                name: "dataList",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $ee613d70c6990317$var$_bytecode = "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";
const $ee613d70c6990317$var$isSuperArgs = (xs)=>xs.length > 1;
class $ee613d70c6990317$export$36e000d85b98e78c extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($ee613d70c6990317$var$isSuperArgs(args)) super(...args);
        else super($ee613d70c6990317$var$_abi, $ee613d70c6990317$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($ee613d70c6990317$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $ee613d70c6990317$var$_abi, signerOrProvider);
    }
}
$ee613d70c6990317$export$36e000d85b98e78c.bytecode = $ee613d70c6990317$var$_bytecode;
$ee613d70c6990317$export$36e000d85b98e78c.abi = $ee613d70c6990317$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $870d40e528c9ab83$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "cfa",
                type: "address"
            },
            {
                internalType: "contract ISuperfluid",
                name: "superfluid",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $870d40e528c9ab83$var$_bytecode = "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";
const $870d40e528c9ab83$var$isSuperArgs = (xs)=>xs.length > 1;
class $870d40e528c9ab83$export$c7d87c1a6aca3a52 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($870d40e528c9ab83$var$isSuperArgs(args)) super(...args);
        else super($870d40e528c9ab83$var$_abi, $870d40e528c9ab83$var$_bytecode, args[0]);
    }
    deploy(cfa, superfluid, overrides) {
        return super.deploy(cfa, superfluid, overrides || {});
    }
    getDeployTransaction(cfa, superfluid, overrides) {
        return super.getDeployTransaction(cfa, superfluid, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($870d40e528c9ab83$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $870d40e528c9ab83$var$_abi, signerOrProvider);
    }
}
$870d40e528c9ab83$export$c7d87c1a6aca3a52.bytecode = $870d40e528c9ab83$var$_bytecode;
$870d40e528c9ab83$export$c7d87c1a6aca3a52.abi = $870d40e528c9ab83$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $a5c86f791064dcfd$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "cfa",
                type: "address"
            },
            {
                internalType: "contract ISuperfluid",
                name: "superfluid",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $a5c86f791064dcfd$var$_bytecode = "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";
const $a5c86f791064dcfd$var$isSuperArgs = (xs)=>xs.length > 1;
class $a5c86f791064dcfd$export$c2b6d5f63ddc53e6 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($a5c86f791064dcfd$var$isSuperArgs(args)) super(...args);
        else super($a5c86f791064dcfd$var$_abi, $a5c86f791064dcfd$var$_bytecode, args[0]);
    }
    deploy(cfa, superfluid, overrides) {
        return super.deploy(cfa, superfluid, overrides || {});
    }
    getDeployTransaction(cfa, superfluid, overrides) {
        return super.getDeployTransaction(cfa, superfluid, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($a5c86f791064dcfd$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $a5c86f791064dcfd$var$_abi, signerOrProvider);
    }
}
$a5c86f791064dcfd$export$c2b6d5f63ddc53e6.bytecode = $a5c86f791064dcfd$var$_bytecode;
$a5c86f791064dcfd$export$c2b6d5f63ddc53e6.abi = $a5c86f791064dcfd$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $8c1da40aabab6774$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "cfa",
                type: "address"
            },
            {
                internalType: "contract ISuperfluid",
                name: "superfluid",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "targetToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $8c1da40aabab6774$var$_bytecode = "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";
const $8c1da40aabab6774$var$isSuperArgs = (xs)=>xs.length > 1;
class $8c1da40aabab6774$export$fa2bded9913019a6 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($8c1da40aabab6774$var$isSuperArgs(args)) super(...args);
        else super($8c1da40aabab6774$var$_abi, $8c1da40aabab6774$var$_bytecode, args[0]);
    }
    deploy(cfa, superfluid, targetToken, overrides) {
        return super.deploy(cfa, superfluid, targetToken, overrides || {});
    }
    getDeployTransaction(cfa, superfluid, targetToken, overrides) {
        return super.getDeployTransaction(cfa, superfluid, targetToken, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($8c1da40aabab6774$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $8c1da40aabab6774$var$_abi, signerOrProvider);
    }
}
$8c1da40aabab6774$export$fa2bded9913019a6.bytecode = $8c1da40aabab6774$var$_bytecode;
$8c1da40aabab6774$export$fa2bded9913019a6.abi = $8c1da40aabab6774$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $070a2cda87b7f35f$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "cfa",
                type: "address"
            },
            {
                internalType: "contract ISuperfluid",
                name: "superfluid",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "setupOutflow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $070a2cda87b7f35f$var$_bytecode = "0x608060405234801561001057600080fd5b50604051610c2b380380610c2b83398101604081905261002f91610117565b6001600160a01b03821661004557610045610151565b6001600160a01b03811661005b5761005b610151565b600080546001600160a01b038085166001600160a01b03199283161790925560018054928416929091168217905560405163bd1c448b60e01b8152641f00000001919063bd1c448b906100c590849060040190815260406020820181905260009082015260600190565b600060405180830381600087803b1580156100df57600080fd5b505af11580156100f3573d6000803e3d6000fd5b50505050505050610167565b6001600160a01b038116811461011457600080fd5b50565b6000806040838503121561012a57600080fd5b8251610135816100ff565b6020840151909250610146816100ff565b809150509250929050565b634e487b7160e01b600052600160045260246000fd5b610ab5806101766000396000f3fe608060405234801561001057600080fd5b506004361061007d5760003560e01c80635f9e7d771161005b5780635f9e7d77146100d1578063884d1f40146100e4578063b9e1323d146100f7578063d86ed3e51461010c57600080fd5b8063230dbd291461008257806330d9c915146100ab57806353c11f99146100be575b600080fd5b6100956100903660046105ea565b61011f565b6040516100a29190610705565b60405180910390f35b6100956100b936600461071f565b610186565b6100956100cc3660046105ea565b6101e9565b6100956100df36600461071f565b61035c565b6100956100f236600461071f565b6103c3565b61010a6101053660046107be565b610426565b005b61009561011a3660046105ea565b610527565b60405162461bcd60e51b815260206004820152602e60248201527f556e737570706f727465642063616c6c6261636b202d2041667465722041677260448201526d19595b595b9d08155c19185d195960921b60648201526060906084015b60405180910390fd5b60405162461bcd60e51b815260206004820152602f60248201527f556e737570706f727465642063616c6c6261636b202d204265666f726520416760448201526e1c99595b595b9d0810dc99585d1959608a1b606482015260609060840161017d565b60606000806101fa888a018a610810565b90925090506001600160a01b038216301461021757610217610849565b6002546001600160a01b0382811691161461023457610234610849565b600080546002546001600160a01b03909116906362fc305e908f908590600160a01b9004600b0b856040519080825280601f01601f191660200182016040528015610286576020820181803683370190505b5060405160240161029a9493929190610875565b60408051601f198184030181529181526020820180516001600160e01b031660e09490941b939093179092526001546000549251634329d29360e01b81529194506001600160a01b039081169350634329d293926103039291169085908b908b906004016108b5565b6000604051808303816000875af1158015610322573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261034a91908101906109a8565b509d9c50505050505050505050505050565b60405162461bcd60e51b815260206004820152603360248201527f556e737570706f727465642063616c6c6261636b202d20204265666f7265204160448201527219dc99595b595b9d0815195c9b5a5b985d1959606a1b606482015260609060840161017d565b60405162461bcd60e51b815260206004820152602f60248201527f556e737570706f727465642063616c6c6261636b202d204265666f726520416760448201526e1c99595b595b9d081d5c19185d1959608a1b606482015260609060840161017d565b6001600160a01b03828116600160a01b6bffffffffffffffffffffffff841602176002556001546000805460408051928352602083019052918316926339255d5b92169081906362fc305e906104859089908990899060448101610875565b60408051601f19818403018152918152602080830180516001600160e01b031660e095861b179052815160008152908101918290529286901b6001600160e01b03191690526104da9392509060248101610a0c565b6000604051808303816000875af11580156104f9573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526105219190810190610a42565b50505050565b60405162461bcd60e51b815260206004820152602e60248201527f556e737570706f727465642063616c6c6261636b202d2041667465722041677260448201526d19595b595b9d0810dc99585d195960921b606482015260609060840161017d565b6001600160a01b038116811461059e57600080fd5b50565b60008083601f8401126105b357600080fd5b50813567ffffffffffffffff8111156105cb57600080fd5b6020830191508360208285010111156105e357600080fd5b9250929050565b600080600080600080600080600060c08a8c03121561060857600080fd5b893561061381610589565b985060208a013561062381610589565b975060408a0135965060608a013567ffffffffffffffff8082111561064757600080fd5b6106538d838e016105a1565b909850965060808c013591508082111561066c57600080fd5b6106788d838e016105a1565b909650945060a08c013591508082111561069157600080fd5b5061069e8c828d016105a1565b915080935050809150509295985092959850929598565b60005b838110156106d05781810151838201526020016106b8565b50506000910152565b600081518084526106f18160208601602086016106b5565b601f01601f19169290920160200192915050565b60208152600061071860208301846106d9565b9392505050565b600080600080600080600060a0888a03121561073a57600080fd5b873561074581610589565b9650602088013561075581610589565b955060408801359450606088013567ffffffffffffffff8082111561077957600080fd5b6107858b838c016105a1565b909650945060808a013591508082111561079e57600080fd5b506107ab8a828b016105a1565b989b979a50959850939692959293505050565b6000806000606084860312156107d357600080fd5b83356107de81610589565b925060208401356107ee81610589565b91506040840135600b81900b811461080557600080fd5b809150509250925092565b6000806040838503121561082357600080fd5b823561082e81610589565b9150602083013561083e81610589565b809150509250929050565b634e487b7160e01b600052600160045260246000fd5b634e487b7160e01b600052604160045260246000fd5b6001600160a01b03858116825284166020820152600b83900b60408201526080606082018190526000906108ab908301846106d9565b9695505050505050565b6001600160a01b03851681526080602082018190526000906108d9908301866106d9565b8281038060408501526002825261060f60f31b602083015260408101606085015250836040820152838560608301376000606085830101526060601f19601f86011682010191505095945050505050565b600082601f83011261093b57600080fd5b815167ffffffffffffffff808211156109565761095661085f565b604051601f8301601f19908116603f0116810190828211818310171561097e5761097e61085f565b8160405283815286602085880101111561099757600080fd5b6108ab8460208301602089016106b5565b600080604083850312156109bb57600080fd5b825167ffffffffffffffff808211156109d357600080fd5b6109df8683870161092a565b935060208501519150808211156109f557600080fd5b50610a028582860161092a565b9150509250929050565b6001600160a01b0384168152606060208201819052600090610a30908301856106d9565b82810360408401526108ab81856106d9565b600060208284031215610a5457600080fd5b815167ffffffffffffffff811115610a6b57600080fd5b610a778482850161092a565b94935050505056fea26469706673582212203c4d7103fda4d84b381050006bc4b88d658408024343753525850ce5d85e00f964736f6c63430008130033";
const $070a2cda87b7f35f$var$isSuperArgs = (xs)=>xs.length > 1;
class $070a2cda87b7f35f$export$a86fb68229e843e9 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($070a2cda87b7f35f$var$isSuperArgs(args)) super(...args);
        else super($070a2cda87b7f35f$var$_abi, $070a2cda87b7f35f$var$_bytecode, args[0]);
    }
    deploy(cfa, superfluid, overrides) {
        return super.deploy(cfa, superfluid, overrides || {});
    }
    getDeployTransaction(cfa, superfluid, overrides) {
        return super.getDeployTransaction(cfa, superfluid, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($070a2cda87b7f35f$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $070a2cda87b7f35f$var$_abi, signerOrProvider);
    }
}
$070a2cda87b7f35f$export$a86fb68229e843e9.bytecode = $070a2cda87b7f35f$var$_bytecode;
$070a2cda87b7f35f$export$a86fb68229e843e9.abi = $070a2cda87b7f35f$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $5baffea98ead6cc9$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "cfa",
                type: "address"
            },
            {
                internalType: "contract ISuperfluid",
                name: "superfluid",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $5baffea98ead6cc9$var$_bytecode = "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";
const $5baffea98ead6cc9$var$isSuperArgs = (xs)=>xs.length > 1;
class $5baffea98ead6cc9$export$94858c17dfa25bff extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($5baffea98ead6cc9$var$isSuperArgs(args)) super(...args);
        else super($5baffea98ead6cc9$var$_abi, $5baffea98ead6cc9$var$_bytecode, args[0]);
    }
    deploy(cfa, superfluid, overrides) {
        return super.deploy(cfa, superfluid, overrides || {});
    }
    getDeployTransaction(cfa, superfluid, overrides) {
        return super.getDeployTransaction(cfa, superfluid, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($5baffea98ead6cc9$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $5baffea98ead6cc9$var$_abi, signerOrProvider);
    }
}
$5baffea98ead6cc9$export$94858c17dfa25bff.bytecode = $5baffea98ead6cc9$var$_bytecode;
$5baffea98ead6cc9$export$94858c17dfa25bff.abi = $5baffea98ead6cc9$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $d696bf1027c4645c$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            }
        ],
        name: "authorizeFlowOperatorWithFullControlTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "cfaV1",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "cfa",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "createFlowByOperatorTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "createFlowTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            }
        ],
        name: "deleteFlowByOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "deleteFlowTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            }
        ],
        name: "revokeFlowOperatorWithFullControlTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "updateFlowByOperatorTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "permissions",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96"
            }
        ],
        name: "updateFlowOperatorPermissionsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "updateFlowTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $d696bf1027c4645c$var$_bytecode = "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";
const $d696bf1027c4645c$var$isSuperArgs = (xs)=>xs.length > 1;
class $d696bf1027c4645c$export$86c0f9444f70b664 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($d696bf1027c4645c$var$isSuperArgs(args)) super(...args);
        else super($d696bf1027c4645c$var$_abi, $d696bf1027c4645c$var$_bytecode, args[0]);
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($d696bf1027c4645c$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $d696bf1027c4645c$var$_abi, signerOrProvider);
    }
}
$d696bf1027c4645c$export$86c0f9444f70b664.bytecode = $d696bf1027c4645c$var$_bytecode;
$d696bf1027c4645c$export$86c0f9444f70b664.abi = $d696bf1027c4645c$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $3639779286e1e032$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "defaultSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "defaultReceiver",
                type: "address"
            },
            {
                internalType: "address",
                name: "defaultFlowOperator",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "authorizeFlowOperatorWithFullControl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "createFlow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $3639779286e1e032$var$_bytecode = "0x60e06040523480156200001157600080fd5b5060405162001ba938038062001ba98339810160408190526200003491620001b4565b6040805180820182526001600160a01b0386168082529151635b69006f60e11b81527fa9214cc96615e0085d3bb077758db69497dc2dce3b2b1e97bc93c3d18d83efd360048201529091602083019163b6d200de90602401602060405180830381865afa158015620000aa573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620000d091906200021c565b6001600160a01b039081169091528151600080549183166001600160a01b031992831617905560209092015160018054918316919093161790915583811660805282811660a05281811660c05260405163bd1c448b60e01b8152643d000000019186169063bd1c448b906200015c90849060040190815260406020820181905260009082015260600190565b600060405180830381600087803b1580156200017757600080fd5b505af11580156200018c573d6000803e3d6000fd5b50505050505050505062000243565b6001600160a01b0381168114620001b157600080fd5b50565b60008060008060808587031215620001cb57600080fd5b8451620001d8816200019b565b6020860151909450620001eb816200019b565b6040860151909350620001fe816200019b565b606086015190925062000211816200019b565b939692955090935050565b6000602082840312156200022f57600080fd5b81516200023c816200019b565b9392505050565b60805160a05160c0516118e9620002c06000396000818161030f01528181610844015281816108d6015261095e015260008181610273015281816104850152818161051d015281816105ae015281816106580152818161070901526107bb015260008181610637015281816106e8015261079a01526118e96000f3fe608060405234801561001057600080fd5b50600436106100885760003560e01c80635f9e7d771161005b5780635f9e7d77146100f15780637d5b08de14610104578063884d1f4014610117578063d86ed3e51461012a57600080fd5b8063230dbd291461008d57806330d9c915146100b657806353c11f99146100c9578063558aea25146100dc575b600080fd5b6100a061009b366004611245565b61013d565b6040516100ad9190611360565b60405180910390f35b6100a06100c436600461137a565b6101a4565b6100a06100d7366004611245565b610207565b6100ef6100ea366004611419565b61026c565b005b6100a06100ff36600461137a565b6102a1565b6100ef610112366004611419565b610308565b6100a061012536600461137a565b610338565b6100a0610138366004611245565b61039b565b60405162461bcd60e51b815260206004820152602e60248201527f556e737570706f727465642063616c6c6261636b202d2041667465722041677260448201526d19595b595b9d08155c19185d195960921b60648201526060906084015b60405180910390fd5b60405162461bcd60e51b815260206004820152602f60248201527f556e737570706f727465642063616c6c6261636b202d204265666f726520416760448201526e1c99595b595b9d0810dc99585d1959608a1b606482015260609060840161019b565b60405162461bcd60e51b815260206004820152603160248201527f556e737570706f727465642063616c6c6261636b202d2041667465722041677260448201527019595b595b9d0815195c9b5a5b985d1959607a1b606482015260609060840161019b565b61029e60007f00000000000000000000000000000000000000000000000000000000000000008364e8d4a510006109de565b50565b60405162461bcd60e51b815260206004820152603360248201527f556e737570706f727465642063616c6c6261636b202d20204265666f7265204160448201527219dc99595b595b9d0815195c9b5a5b985d1959606a1b606482015260609060840161019b565b61033460007f000000000000000000000000000000000000000000000000000000000000000083610a04565b5050565b60405162461bcd60e51b815260206004820152602f60248201527f556e737570706f727465642063616c6c6261636b202d204265666f726520416760448201526e1c99595b595b9d081d5c19185d1959608a1b606482015260609060840161019b565b60008054604051631fb6491d60e11b8152606092916001600160a01b031690633f6c923a906103d09087908790600401611436565b600060405180830381865afa1580156103ed573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610415919081019061155c565b60a0015190506000818060200190518101906104319190611663565b905060ff81166104c7576104be85858080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f820116905080830192505050505050507f00000000000000000000000000000000000000000000000000000000000000008e64e8d4a510006000610aef90949392919063ffffffff16565b925050506109d1565b60001960ff821601610557576104be85858080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f820116905080830192505050505050507f00000000000000000000000000000000000000000000000000000000000000008e6501d1a94a20006000610b1e90949392919063ffffffff16565b60011960ff8216016105e1576104be85858080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f82011690508083019250505050505050307f00000000000000000000000000000000000000000000000000000000000000008f6000610b4390949392919063ffffffff16565b60021960ff821601610692576104be85858080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f820116905080830192505050505050507f00000000000000000000000000000000000000000000000000000000000000007f00000000000000000000000000000000000000000000000000000000000000008f64e8d4a510006000610b689095949392919063ffffffff16565b60031960ff821601610744576104be85858080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f820116905080830192505050505050507f00000000000000000000000000000000000000000000000000000000000000007f00000000000000000000000000000000000000000000000000000000000000008f6501d1a94a20006000610bb09095949392919063ffffffff16565b60041960ff8216016107ee576104be85858080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f820116905080830192505050505050507f00000000000000000000000000000000000000000000000000000000000000007f00000000000000000000000000000000000000000000000000000000000000008f6000610bed90949392919063ffffffff16565b60051960ff821601610880576104be85858080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f820116905080830192505050505050507f00000000000000000000000000000000000000000000000000000000000000008e600764e8d4a510006000610c129095949392919063ffffffff16565b60061960ff821601610908576104be85858080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f820116905080830192505050505050507f00000000000000000000000000000000000000000000000000000000000000008e6000610d23909392919063ffffffff16565b60071960ff821601610990576104be85858080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f820116905080830192505050505050507f00000000000000000000000000000000000000000000000000000000000000008e6000610e2f909392919063ffffffff16565b60405162461bcd60e51b81526020600482015260166024820152750d2dcecc2d8d2c840cceadcc6e8d2dedc40d2dcc8caf60531b604482015260640161019b565b9998505050505050505050565b6040805160008152602081019091526109fe908590859085908590610e5b565b50505050565b825460018401546040805160008152602081019091526060926001600160a01b03908116926339255d5b9291169081906354b770e390610a4b9088908a906044810161167e565b60408051601f19818403018152918152602080830180516001600160e01b031660e095861b179052815160008152908101918290529286901b6001600160e01b0319169052610aa093925090602481016116b3565b6000604051808303816000875af1158015610abf573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610ae791908101906116e9565b949350505050565b604080516000815260208101909152606090610b149087908790879087908790610f3a565b9695505050505050565b604080516000815260208101909152606090610b149087908790879087908790610fee565b604080516000815260208101909152606090610b14908790879087908790879061101b565b6060610ba587878787878760006040519080825280601f01601f191660200182016040528015610b9f576020820181803683370190505b50611082565b979650505050505050565b6060610ba587878787878760006040519080825280601f01601f191660200182016040528015610be7576020820181803683370190505b5061118c565b604080516000815260208101909152606090610b1490879087908790879087906111ba565b855460018701546060916001600160a01b0390811691634329d29391168063811b3d40888a898960006040519080825280601f01601f191660200182016040528015610c65576020820181803683370190505b50604051602401610c7a95949392919061171e565b60408051601f19818403018152918152602080830180516001600160e01b031660e095861b179052815160008152908101918290529286901b6001600160e01b0319169052610cd0939250908b6024820161175d565b6000604051808303816000875af1158015610cef573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610d1791908101906117a7565b50979650505050505050565b835460018501546060916001600160a01b0390811691634329d2939116806354b770e3868860005b6040519080825280601f01601f191660200182016040528015610d75576020820181803683370190505b50604051602401610d889392919061167e565b60408051601f19818403018152918152602080830180516001600160e01b031660e095861b179052815160008152908101918290529286901b6001600160e01b0319169052610dde93925090896024820161175d565b6000604051808303816000875af1158015610dfd573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610e2591908101906117a7565b5095945050505050565b835460018501546060916001600160a01b0390811691634329d29391168063062e56ec86886000610d4b565b845460018601546040805160008152602081019091526001600160a01b03928316926339255d5b92169081906362fc305e90610ea09089908b908a906044810161180b565b60408051808303601f1901815291815260208201805160e094851b6001600160e01b03909116179052519185901b6001600160e01b0319168252610eeb9392509086906004016116b3565b6000604051808303816000875af1158015610f0a573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610f3291908101906116e9565b505050505050565b855460018701546060916001600160a01b0390811691634329d2939116806362fc305e888a8960005b6040519080825280601f01601f191660200182016040528015610f8d576020820181803683370190505b50604051602401610fa1949392919061180b565b60408051808303601f1901815291815260208201805160e094851b6001600160e01b03909116179052519185901b6001600160e01b0319168252610cd09392509087908c9060040161175d565b855460018701546060916001600160a01b0390811691634329d2939116806350209a62888a896000610f63565b855460018701546060916001600160a01b0390811691634329d29391168063b4b333c6878a8a60005b6040519080825280601f01601f19166020018201604052801561106e576020820181803683370190505b50604051602401610fa19493929190611841565b865460018801546060916001600160a01b0390811691634329d2939116806394229ecb888b8b8a60005b6040519080825280601f01601f1916602001820160405280156110d6576020820181803683370190505b506040516024016110eb959493929190611875565b60408051808303601f1901815291815260208201805160e094851b6001600160e01b03909116179052519185901b6001600160e01b03191682526111389392509087908d9060040161175d565b6000604051808303816000875af1158015611157573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261117f91908101906117a7565b5098975050505050505050565b865460018801546060916001600160a01b0390811691634329d29391168063354b9590888b8b8a60006110ac565b855460018701546060916001600160a01b0390811691634329d293911680634c8b181f878a8a6000611044565b6001600160a01b038116811461029e57600080fd5b60008083601f84011261120e57600080fd5b50813567ffffffffffffffff81111561122657600080fd5b60208301915083602082850101111561123e57600080fd5b9250929050565b600080600080600080600080600060c08a8c03121561126357600080fd5b893561126e816111e7565b985060208a013561127e816111e7565b975060408a0135965060608a013567ffffffffffffffff808211156112a257600080fd5b6112ae8d838e016111fc565b909850965060808c01359150808211156112c757600080fd5b6112d38d838e016111fc565b909650945060a08c01359150808211156112ec57600080fd5b506112f98c828d016111fc565b915080935050809150509295985092959850929598565b60005b8381101561132b578181015183820152602001611313565b50506000910152565b6000815180845261134c816020860160208601611310565b601f01601f19169290920160200192915050565b6020815260006113736020830184611334565b9392505050565b600080600080600080600060a0888a03121561139557600080fd5b87356113a0816111e7565b965060208801356113b0816111e7565b955060408801359450606088013567ffffffffffffffff808211156113d457600080fd5b6113e08b838c016111fc565b909650945060808a01359150808211156113f957600080fd5b506114068a828b016111fc565b989b979a50959850939692959293505050565b60006020828403121561142b57600080fd5b8135611373816111e7565b60208152816020820152818360408301376000818301604090810191909152601f909201601f19160101919050565b634e487b7160e01b600052604160045260246000fd5b604051610160810167ffffffffffffffff8111828210171561149f5761149f611465565b60405290565b805160ff811681146114b657600080fd5b919050565b80516114b6816111e7565b80516001600160e01b0319811681146114b657600080fd5b600082601f8301126114ef57600080fd5b815167ffffffffffffffff8082111561150a5761150a611465565b604051601f8301601f19908116603f0116810190828211818310171561153257611532611465565b8160405283815286602085880101111561154b57600080fd5b610b14846020830160208901611310565b60006020828403121561156e57600080fd5b815167ffffffffffffffff8082111561158657600080fd5b90830190610160828603121561159b57600080fd5b6115a361147b565b6115ac836114a5565b81526115ba602084016114a5565b6020820152604083015160408201526115d5606084016114bb565b60608201526115e6608084016114c6565b608082015260a0830151828111156115fd57600080fd5b611609878286016114de565b60a08301525060c083015160c082015260e083015160e08201526101009150818301518282015261012091506116408284016114bb565b8282015261014091506116548284016114bb565b91810191909152949350505050565b60006020828403121561167557600080fd5b611373826114a5565b6001600160a01b038481168252831660208201526060604082018190526000906116aa90830184611334565b95945050505050565b6001600160a01b03841681526060602082018190526000906116d790830185611334565b8281036040840152610b148185611334565b6000602082840312156116fb57600080fd5b815167ffffffffffffffff81111561171257600080fd5b610ae7848285016114de565b6001600160a01b0386811682528516602082015260ff84166040820152600b83900b606082015260a060808201819052600090610ba590830184611334565b6001600160a01b038516815260806020820181905260009061178190830186611334565b82810360408401526117938186611334565b90508281036060840152610ba58185611334565b600080604083850312156117ba57600080fd5b825167ffffffffffffffff808211156117d257600080fd5b6117de868387016114de565b935060208501519150808211156117f457600080fd5b50611801858286016114de565b9150509250929050565b6001600160a01b03858116825284166020820152600b83900b6040820152608060608201819052600090610b1490830184611334565b6001600160a01b038581168252848116602083015283166040820152608060608201819052600090610b1490830184611334565b6001600160a01b038681168252858116602083015284166040820152600b83900b606082015260a060808201819052600090610ba59083018461133456fea2646970667358221220e87dc7f9e6b3c16259823127e9f59d86c7369af2850d8e586a5b5745295d39bf64736f6c63430008130033";
const $3639779286e1e032$var$isSuperArgs = (xs)=>xs.length > 1;
class $3639779286e1e032$export$1d6442fac5eaa218 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($3639779286e1e032$var$isSuperArgs(args)) super(...args);
        else super($3639779286e1e032$var$_abi, $3639779286e1e032$var$_bytecode, args[0]);
    }
    deploy(host, defaultSender, defaultReceiver, defaultFlowOperator, overrides) {
        return super.deploy(host, defaultSender, defaultReceiver, defaultFlowOperator, overrides || {});
    }
    getDeployTransaction(host, defaultSender, defaultReceiver, defaultFlowOperator, overrides) {
        return super.getDeployTransaction(host, defaultSender, defaultReceiver, defaultFlowOperator, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($3639779286e1e032$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $3639779286e1e032$var$_abi, signerOrProvider);
    }
}
$3639779286e1e032$export$1d6442fac5eaa218.bytecode = $3639779286e1e032$var$_bytecode;
$3639779286e1e032$export$1d6442fac5eaa218.abi = $3639779286e1e032$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $79ce33a565f1f355$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CALLER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CURRENT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_INVALID_TOKEN_ID",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_ONLY_SUPER_TOKEN_FACTORY",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_FROM_INCORRECT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_IS_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "CIF_NFT_ONLY_CONSTANT_OUTFLOW",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "MetadataUpdate",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_FLOW_AGREEMENT_V1",
        outputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_BASE_URI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "flowDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowSender",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowReceiver",
                        type: "address"
                    },
                    {
                        internalType: "uint32",
                        name: "flowStartDate",
                        type: "uint32"
                    }
                ],
                internalType: "struct IFlowNFTBase.FlowNFTData",
                name: "flowData",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "nftName",
                type: "string"
            },
            {
                internalType: "string",
                name: "nftSymbol",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "newTokenId",
                type: "uint256"
            }
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "mockBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "mockFlowNFTDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowSender",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowReceiver",
                        type: "address"
                    },
                    {
                        internalType: "uint32",
                        name: "flowStartDate",
                        type: "uint32"
                    }
                ],
                internalType: "struct IFlowNFTBase.FlowNFTData",
                name: "flowData",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "mockGetApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "_newTokenId",
                type: "uint256"
            }
        ],
        name: "mockMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "mockOwnerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "triggerMetadataUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $79ce33a565f1f355$var$_bytecode = "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";
const $79ce33a565f1f355$var$isSuperArgs = (xs)=>xs.length > 1;
class $79ce33a565f1f355$export$981b8f4b6e7b7820 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($79ce33a565f1f355$var$isSuperArgs(args)) super(...args);
        else super($79ce33a565f1f355$var$_abi, $79ce33a565f1f355$var$_bytecode, args[0]);
    }
    deploy(host, constantOutflowNFT, overrides) {
        return super.deploy(host, constantOutflowNFT, overrides || {});
    }
    getDeployTransaction(host, constantOutflowNFT, overrides) {
        return super.getDeployTransaction(host, constantOutflowNFT, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($79ce33a565f1f355$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $79ce33a565f1f355$var$_abi, signerOrProvider);
    }
}
$79ce33a565f1f355$export$981b8f4b6e7b7820.bytecode = $79ce33a565f1f355$var$_bytecode;
$79ce33a565f1f355$export$981b8f4b6e7b7820.abi = $79ce33a565f1f355$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $6879a042e1103f52$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CALLER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CURRENT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_INVALID_TOKEN_ID",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_ONLY_SUPER_TOKEN_FACTORY",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_FROM_INCORRECT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_IS_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_INVALID_SUPER_TOKEN",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_MINT_TO_AND_FLOW_RECEIVER_SAME",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_MINT_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_ONLY_CONSTANT_INFLOW",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_ONLY_FLOW_AGREEMENTS",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_TOKEN_ALREADY_EXISTS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "MetadataUpdate",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_FLOW_AGREEMENT_V1",
        outputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_BASE_URI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "flowDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowSender",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowReceiver",
                        type: "address"
                    },
                    {
                        internalType: "uint32",
                        name: "flowStartDate",
                        type: "uint32"
                    }
                ],
                internalType: "struct IFlowNFTBase.FlowNFTData",
                name: "flowData",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "nftName",
                type: "string"
            },
            {
                internalType: "string",
                name: "nftSymbol",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "mockBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "mockGetApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "_to",
                type: "address"
            },
            {
                internalType: "address",
                name: "_flowReceiver",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "_newTokenId",
                type: "uint256"
            }
        ],
        name: "mockMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "mockOwnerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "onCreate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "onDelete",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "onUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "triggerMetadataUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $6879a042e1103f52$var$_bytecode = "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";
const $6879a042e1103f52$var$isSuperArgs = (xs)=>xs.length > 1;
class $6879a042e1103f52$export$652c03b3270b1f93 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($6879a042e1103f52$var$isSuperArgs(args)) super(...args);
        else super($6879a042e1103f52$var$_abi, $6879a042e1103f52$var$_bytecode, args[0]);
    }
    deploy(host, constantInflowNFT, overrides) {
        return super.deploy(host, constantInflowNFT, overrides || {});
    }
    getDeployTransaction(host, constantInflowNFT, overrides) {
        return super.getDeployTransaction(host, constantInflowNFT, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($6879a042e1103f52$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $6879a042e1103f52$var$_abi, signerOrProvider);
    }
}
$6879a042e1103f52$export$652c03b3270b1f93.bytecode = $6879a042e1103f52$var$_bytecode;
$6879a042e1103f52$export$652c03b3270b1f93.abi = $6879a042e1103f52$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $4420fe7aab04c13f$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_BURN_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_MOVE_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "bondAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidatedBy",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAmountReceiver",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            }
        ],
        name: "AgreementLiquidatedV2",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            }
        ],
        name: "AgreementStateUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            }
        ],
        name: "AgreementTerminated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bailoutAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "Bailout",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "createAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountActiveAgreements",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementData",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementStateSlot",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountCritical",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountCriticalNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountSolvent",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountSolventNow",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            },
            {
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool"
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            }
        ],
        name: "makeLiquidationPayoutsV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256"
            }
        ],
        name: "settleBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "terminateAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementStateSlot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $4420fe7aab04c13f$var$_bytecode = "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";
const $4420fe7aab04c13f$var$isSuperArgs = (xs)=>xs.length > 1;
class $4420fe7aab04c13f$export$450a2fd03615ef91 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($4420fe7aab04c13f$var$isSuperArgs(args)) super(...args);
        else super($4420fe7aab04c13f$var$_abi, $4420fe7aab04c13f$var$_bytecode, args[0]);
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($4420fe7aab04c13f$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $4420fe7aab04c13f$var$_abi, signerOrProvider);
    }
}
$4420fe7aab04c13f$export$450a2fd03615ef91.bytecode = $4420fe7aab04c13f$var$_bytecode;
$4420fe7aab04c13f$export$450a2fd03615ef91.abi = $4420fe7aab04c13f$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $66dfc85722e8ba32$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CALLER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CURRENT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_INVALID_TOKEN_ID",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_ONLY_SUPER_TOKEN_FACTORY",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_FROM_INCORRECT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_IS_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "CIF_NFT_ONLY_CONSTANT_OUTFLOW",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string"
            }
        ],
        name: "STORAGE_LOCATION_CHANGED",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "MetadataUpdate",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_FLOW_AGREEMENT_V1",
        outputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_BASE_URI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "flowDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowSender",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowReceiver",
                        type: "address"
                    },
                    {
                        internalType: "uint32",
                        name: "flowStartDate",
                        type: "uint32"
                    }
                ],
                internalType: "struct IFlowNFTBase.FlowNFTData",
                name: "flowData",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "nftName",
                type: "string"
            },
            {
                internalType: "string",
                name: "nftSymbol",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "newTokenId",
                type: "uint256"
            }
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "triggerMetadataUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "validateStorageLayout",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $66dfc85722e8ba32$var$_bytecode = "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";
const $66dfc85722e8ba32$var$isSuperArgs = (xs)=>xs.length > 1;
class $66dfc85722e8ba32$export$e7e8a5d825ab9d77 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($66dfc85722e8ba32$var$isSuperArgs(args)) super(...args);
        else super($66dfc85722e8ba32$var$_abi, $66dfc85722e8ba32$var$_bytecode, args[0]);
    }
    deploy(host, constantOutflowNFT, overrides) {
        return super.deploy(host, constantOutflowNFT, overrides || {});
    }
    getDeployTransaction(host, constantOutflowNFT, overrides) {
        return super.getDeployTransaction(host, constantOutflowNFT, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($66dfc85722e8ba32$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $66dfc85722e8ba32$var$_abi, signerOrProvider);
    }
}
$66dfc85722e8ba32$export$e7e8a5d825ab9d77.bytecode = $66dfc85722e8ba32$var$_bytecode;
$66dfc85722e8ba32$export$e7e8a5d825ab9d77.abi = $66dfc85722e8ba32$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $09c3ea5bb0ac53a9$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CALLER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CURRENT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_INVALID_TOKEN_ID",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_ONLY_SUPER_TOKEN_FACTORY",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_FROM_INCORRECT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_IS_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_INVALID_SUPER_TOKEN",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_MINT_TO_AND_FLOW_RECEIVER_SAME",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_MINT_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_ONLY_CONSTANT_INFLOW",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_ONLY_FLOW_AGREEMENTS",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_TOKEN_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string"
            }
        ],
        name: "STORAGE_LOCATION_CHANGED",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "MetadataUpdate",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_FLOW_AGREEMENT_V1",
        outputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_BASE_URI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "flowDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowSender",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowReceiver",
                        type: "address"
                    },
                    {
                        internalType: "uint32",
                        name: "flowStartDate",
                        type: "uint32"
                    }
                ],
                internalType: "struct IFlowNFTBase.FlowNFTData",
                name: "flowData",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "nftName",
                type: "string"
            },
            {
                internalType: "string",
                name: "nftSymbol",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "onCreate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "onDelete",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "onUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "triggerMetadataUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "validateStorageLayout",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $09c3ea5bb0ac53a9$var$_bytecode = "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";
const $09c3ea5bb0ac53a9$var$isSuperArgs = (xs)=>xs.length > 1;
class $09c3ea5bb0ac53a9$export$870f68b2aa2979ef extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($09c3ea5bb0ac53a9$var$isSuperArgs(args)) super(...args);
        else super($09c3ea5bb0ac53a9$var$_abi, $09c3ea5bb0ac53a9$var$_bytecode, args[0]);
    }
    deploy(host, constantInflowNFT, overrides) {
        return super.deploy(host, constantInflowNFT, overrides || {});
    }
    getDeployTransaction(host, constantInflowNFT, overrides) {
        return super.getDeployTransaction(host, constantInflowNFT, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($09c3ea5bb0ac53a9$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $09c3ea5bb0ac53a9$var$_abi, signerOrProvider);
    }
}
$09c3ea5bb0ac53a9$export$870f68b2aa2979ef.bytecode = $09c3ea5bb0ac53a9$var$_bytecode;
$09c3ea5bb0ac53a9$export$870f68b2aa2979ef.abi = $09c3ea5bb0ac53a9$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $92da67ddd3f17da0$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CALLER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CURRENT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_INVALID_TOKEN_ID",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_ONLY_SUPER_TOKEN_FACTORY",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_FROM_INCORRECT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_IS_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string"
            }
        ],
        name: "STORAGE_LOCATION_CHANGED",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "MetadataUpdate",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_FLOW_AGREEMENT_V1",
        outputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_BASE_URI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        name: "flowDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowSender",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowReceiver",
                        type: "address"
                    },
                    {
                        internalType: "uint32",
                        name: "flowStartDate",
                        type: "uint32"
                    }
                ],
                internalType: "struct IFlowNFTBase.FlowNFTData",
                name: "flowData",
                type: "tuple"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "nftName",
                type: "string"
            },
            {
                internalType: "string",
                name: "nftSymbol",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "triggerMetadataUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "validateStorageLayout",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $92da67ddd3f17da0$var$_bytecode = "0x60c060405234801561001057600080fd5b5060405161148e38038061148e83398101604081905261002f916100ea565b6001600160a01b03811660a0819052604051635b69006f60e11b81527fa9214cc96615e0085d3bb077758db69497dc2dce3b2b1e97bc93c3d18d83efd3600482015282919063b6d200de90602401602060405180830381865afa15801561009a573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906100be91906100ea565b6001600160a01b03166080525061010e9050565b6001600160a01b03811681146100e757600080fd5b50565b6000602082840312156100fc57600080fd5b8151610107816100d2565b9392505050565b60805160a05161135461013a60003960008181610288015261060e0152600061021501526113546000f3fe608060405234801561001057600080fd5b506004361061018e5760003560e01c80636352211e116100de5780639903ad3811610097578063b88d4fde11610071578063b88d4fde146103de578063c87b56dd146103f1578063e985e9c514610412578063f99a38c41461020e57600080fd5b80639903ad38146103bb578063a22cb465146103c3578063a497325b146103d657600080fd5b80636352211e146102f55780636c0360eb1461030857806370a082311461031057806389f71d2d146103245780638d47859e1461033757806395d89b41146103b357600080fd5b80632f3885601161014b57806349f289dc1161012557806349f289dc146102835780634cd88b76146102aa57806350d75d25146102bd57806352d1902d146102c557600080fd5b80632f3885601461024a57806342842e0e1461025d578063469519541461027057600080fd5b806301ffc9a71461019357806306fdde03146101bb578063081812fc146101d0578063095ea7b3146101fb578063181561011461021057806323b872dd14610237575b600080fd5b6101a66101a1366004610da7565b610425565b60405190151581526020015b60405180910390f35b6101c3610477565b6040516101b29190610dd8565b6101e36101de366004610e26565b610509565b6040516001600160a01b0390911681526020016101b2565b61020e610209366004610e54565b610530565b005b6101e37f000000000000000000000000000000000000000000000000000000000000000081565b61020e610245366004610e80565b6105bc565b61020e610258366004610e26565b6105e3565b61020e61026b366004610e80565b6105ef565b61020e61027e366004610ec1565b61060a565b6101e37f000000000000000000000000000000000000000000000000000000000000000081565b61020e6102b8366004610f8a565b6106c6565b6101e36107ac565b7fc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a4705b6040519081526020016101b2565b6101e3610303366004610e26565b6107db565b6101c36107f7565b6102e761031e366004610ec1565b50600190565b6102e7610332366004610fee565b610817565b61036d610345366004610e26565b5060408051608081018252600080825260208201819052918101829052606081019190915290565b6040805182516001600160a01b03908116825260208085015182169083015283830151169181019190915260609182015163ffffffff16918101919091526080016101b2565b6101c361086a565b61020e610879565b61020e6103d1366004611039565b61093b565b6101c3610946565b61020e6103ec366004611077565b610962565b6101c36103ff366004610e26565b5060408051602081019091526000815290565b6101a66104203660046110f7565b61099b565b60006301ffc9a760e01b6001600160e01b03198316148061045657506380ac58cd60e01b6001600160e01b03198316145b806104715750635b5e139f60e01b6001600160e01b03198316145b92915050565b60606001805461048690611125565b80601f01602080910402602001604051908101604052809291908181526020018280546104b290611125565b80156104ff5780601f106104d4576101008083540402835291602001916104ff565b820191906000526020600020905b8154815290600101906020018083116104e257829003601f168201915b5050505050905090565b6000610514826109c9565b506000908152600360205260409020546001600160a01b031690565b600061053b826107db565b9050806001600160a01b0316836001600160a01b03160361056f5760405163e4790b2560e01b815260040160405180910390fd5b336001600160a01b0382161480159061058f575061058d813361099b565b155b156105ad5760405163519a92c160e11b815260040160405180910390fd5b6105b783836109e2565b505050565b6105c63382610a3b565b6105b7576040516312a8eb0360e11b815260040160405180910390fd5b6105ec81610a99565b50565b6105b783838360405180602001604052806000815250610962565b60007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663731aed6e6040518163ffffffff1660e01b8152600401602060405180830381865afa15801561066a573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061068e919061115f565b9050336001600160a01b038216146106b95760405163ebb7505b60e01b815260040160405180910390fd5b6106c282610ac9565b5050565b600054610100900460ff16158080156106e65750600054600160ff909116105b806107005750303b158015610700575060005460ff166001145b6107255760405162461bcd60e51b815260040161071c9061117c565b60405180910390fd5b6000805460ff191660011790558015610748576000805461ff0019166101001790555b60016107548482611218565b5060026107618382611218565b5080156105b7576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a1505050565b60006107d67f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b905090565b60008060405163eab95e3b60e01b815260040160405180910390fd5b60606040518060600160405280602d81526020016112f2602d9139905090565b60408051466020808301919091526001600160a01b0380871683850152808616606084015284166080808401919091528351808403909101815260a090920190925280519101206000905b949350505050565b60606002805461048690611125565b600054610100900460ff16158080156108995750600054600160ff909116105b806108b35750303b1580156108b3575060005460ff166001145b6108cf5760405162461bcd60e51b815260040161071c9061117c565b6000805460ff1916600117905580156108f2576000805461ff0019166101001790555b80156105ec576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb3847402498906020015b60405180910390a150565b6106c2338383610d03565b6040518060600160405280602d81526020016112f2602d913981565b61096c3383610a3b565b610989576040516312a8eb0360e11b815260040160405180910390fd5b61099584848484610da2565b50505050565b6001600160a01b03918216600090815260046020908152604080832093909416825291909152205460ff1690565b60405163eab95e3b60e01b815260040160405180910390fd5b60008181526003602052604080822080546001600160a01b0319166001600160a01b03861690811790915590518392907f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925908290a45050565b600080610a47836107db565b9050806001600160a01b0316846001600160a01b03161480610a6e5750610a6e818561099b565b806108625750836001600160a01b0316610a8784610509565b6001600160a01b031614949350505050565b6040518181527ff8e1a15aba9398e019f0b49df1a4fde98ee17ae345cb5f6b5e2c27f5033e8ce790602001610930565b6000610af37f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b6001600160a01b031603610b495760405162461bcd60e51b815260206004820152601d60248201527f5555505350726f786961626c653a206e6f742075706772616461626c65000000604482015260640161071c565b806001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610b87573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610bab91906112d8565b7fc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a47014610c255760405162461bcd60e51b815260206004820152602360248201527f5555505350726f786961626c653a206e6f7420636f6d70617469626c65206c6f60448201526267696360e81b606482015260840161071c565b6001600160a01b0381163003610c7d5760405162461bcd60e51b815260206004820152601960248201527f5555505350726f786961626c653a2070726f7879206c6f6f7000000000000000604482015260640161071c565b610ca5817f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc55565b7fe011bc04c286c344a8fcbb8de77f953da762c3e25d8cdea984147fc4168a5dcc7fc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470604080519182526001600160a01b038416602083015201610930565b816001600160a01b0316836001600160a01b031603610d355760405163d3c7732960e01b815260040160405180910390fd5b6001600160a01b03838116600081815260046020908152604080832094871680845294825291829020805460ff191686151590811790915591519182527f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a3505050565b610995565b600060208284031215610db957600080fd5b81356001600160e01b031981168114610dd157600080fd5b9392505050565b600060208083528351808285015260005b81811015610e0557858101830151858201604001528201610de9565b506000604082860101526040601f19601f8301168501019250505092915050565b600060208284031215610e3857600080fd5b5035919050565b6001600160a01b03811681146105ec57600080fd5b60008060408385031215610e6757600080fd5b8235610e7281610e3f565b946020939093013593505050565b600080600060608486031215610e9557600080fd5b8335610ea081610e3f565b92506020840135610eb081610e3f565b929592945050506040919091013590565b600060208284031215610ed357600080fd5b8135610dd181610e3f565b634e487b7160e01b600052604160045260246000fd5b600067ffffffffffffffff80841115610f0f57610f0f610ede565b604051601f8501601f19908116603f01168101908282118183101715610f3757610f37610ede565b81604052809350858152868686011115610f5057600080fd5b858560208301376000602087830101525050509392505050565b600082601f830112610f7b57600080fd5b610dd183833560208501610ef4565b60008060408385031215610f9d57600080fd5b823567ffffffffffffffff80821115610fb557600080fd5b610fc186838701610f6a565b93506020850135915080821115610fd757600080fd5b50610fe485828601610f6a565b9150509250929050565b60008060006060848603121561100357600080fd5b833561100e81610e3f565b9250602084013561101e81610e3f565b9150604084013561102e81610e3f565b809150509250925092565b6000806040838503121561104c57600080fd5b823561105781610e3f565b91506020830135801515811461106c57600080fd5b809150509250929050565b6000806000806080858703121561108d57600080fd5b843561109881610e3f565b935060208501356110a881610e3f565b925060408501359150606085013567ffffffffffffffff8111156110cb57600080fd5b8501601f810187136110dc57600080fd5b6110eb87823560208401610ef4565b91505092959194509250565b6000806040838503121561110a57600080fd5b823561111581610e3f565b9150602083013561106c81610e3f565b600181811c9082168061113957607f821691505b60208210810361115957634e487b7160e01b600052602260045260246000fd5b50919050565b60006020828403121561117157600080fd5b8151610dd181610e3f565b6020808252602e908201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160408201526d191e481a5b9a5d1a585b1a5e995960921b606082015260800190565b601f8211156105b757600081815260208120601f850160051c810160208610156111f15750805b601f850160051c820191505b81811015611210578281556001016111fd565b505050505050565b815167ffffffffffffffff81111561123257611232610ede565b611246816112408454611125565b846111ca565b602080601f83116001811461127b57600084156112635750858301515b600019600386901b1c1916600185901b178555611210565b600085815260208120601f198616915b828110156112aa5788860151825594840194600190910190840161128b565b50858210156112c85787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b6000602082840312156112ea57600080fd5b505191905056fe68747470733a2f2f6e66742e7375706572666c7569642e66696e616e63652f6366612f76322f6765746d657461a2646970667358221220877a205347773f5fcc98d7d3586fe8459739e2a1b2347f0fc2ce37916edbb77864736f6c63430008130033";
const $92da67ddd3f17da0$var$isSuperArgs = (xs)=>xs.length > 1;
class $92da67ddd3f17da0$export$f07da44012d8a8db extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($92da67ddd3f17da0$var$isSuperArgs(args)) super(...args);
        else super($92da67ddd3f17da0$var$_abi, $92da67ddd3f17da0$var$_bytecode, args[0]);
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($92da67ddd3f17da0$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $92da67ddd3f17da0$var$_abi, signerOrProvider);
    }
}
$92da67ddd3f17da0$export$f07da44012d8a8db.bytecode = $92da67ddd3f17da0$var$_bytecode;
$92da67ddd3f17da0$export$f07da44012d8a8db.abi = $92da67ddd3f17da0$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $9fea9bf0f7651919$var$_abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string"
            }
        ],
        name: "STORAGE_LOCATION_CHANGED",
        type: "error"
    }
];
class $9fea9bf0f7651919$export$3ad503f5d4d76b05 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($9fea9bf0f7651919$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $9fea9bf0f7651919$var$_abi, signerOrProvider);
    }
}
$9fea9bf0f7651919$export$3ad503f5d4d76b05.abi = $9fea9bf0f7651919$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $422b63fc3b7ed2ef$var$_abi = [
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "callSelfApproveFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "callSelfBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "callSelfTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "getFirstCustomTokenStorageSlot",
        outputs: [
            {
                internalType: "uint256",
                name: "slot",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialAddress",
                type: "address"
            }
        ],
        name: "initializeProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
class $422b63fc3b7ed2ef$export$5b0fd381414d90ee {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($422b63fc3b7ed2ef$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $422b63fc3b7ed2ef$var$_abi, signerOrProvider);
    }
}
$422b63fc3b7ed2ef$export$5b0fd381414d90ee.abi = $422b63fc3b7ed2ef$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $3a4a9370ba2666a9$var$_abi = [
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_BURN_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_MOVE_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_BURN_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_CALLER_IS_NOT_OPERATOR_FOR_HOLDER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_INFLATIONARY_DEFLATIONARY_NOT_SUPPORTED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_MINT_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NFT_PROXY_ADDRESS_CHANGED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NOT_ERC777_TOKENS_RECIPIENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NO_UNDERLYING_TOKEN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_ADMIN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_GOV_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_SELF",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldAdmin",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "AdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "bondAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidatedBy",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAmountReceiver",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            }
        ],
        name: "AgreementLiquidatedV2",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            }
        ],
        name: "AgreementStateUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            }
        ],
        name: "AgreementTerminated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "AuthorizedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bailoutAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "Bailout",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Burned",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        name: "ConstantInflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            }
        ],
        name: "ConstantOutflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Minted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "RevokedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Sent",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenDowngraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenUpgraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "authorizeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "callSelfApproveFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "callSelfBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "callSelfTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "createAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "defaultOperators",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountActiveAgreements",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "activeAgreements",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementData",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementStateSlot",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getFirstCustomTokenStorageSlot",
        outputs: [
            {
                internalType: "uint256",
                name: "slot",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingDecimals",
        outputs: [
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingToken",
        outputs: [
            {
                internalType: "address",
                name: "tokenAddr",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "granularity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialAddress",
                type: "address"
            }
        ],
        name: "initializeProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "initializeWithAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountCritical",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountCriticalNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountSolvent",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountSolventNow",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "isOperatorFor",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            },
            {
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool"
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            }
        ],
        name: "makeLiquidationPayoutsV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationApprove",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "operationDecreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationDowngrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "operationIncreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "operationSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationUpgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "revokeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfApproveFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256"
            }
        ],
        name: "settleBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "terminateAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "toUnderlyingAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "underlyingAmount",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "adjustedAmount",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            }
        ],
        name: "transferAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementStateSlot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
class $3a4a9370ba2666a9$export$113b8797c5e36239 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($3a4a9370ba2666a9$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $3a4a9370ba2666a9$var$_abi, signerOrProvider);
    }
}
$3a4a9370ba2666a9$export$113b8797c5e36239.abi = $3a4a9370ba2666a9$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $903d6bdf018b7f48$var$_abi = [
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "callSelfApproveFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "callSelfBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "callSelfTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "delegatecallSelfMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "getFirstCustomTokenStorageSlot",
        outputs: [
            {
                internalType: "uint256",
                name: "slot",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialAddress",
                type: "address"
            }
        ],
        name: "initializeProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
const $903d6bdf018b7f48$var$_bytecode = "0x608060405234801561001057600080fd5b50610754806100206000396000f3fe6080604052600436106100745760003560e01c80634c6491d21161004e5780634c6491d2146100ec5780637549c15f1461010c578063c68d42831461012c578063e27c15861461014c57610083565b80633c5441aa1461008b57806347399a7f146100ab5780634a0687ef146100cc57610083565b366100835761008161016c565b005b61008161016c565b34801561009757600080fd5b506100816100a636600461050b565b61017e565b3480156100b757600080fd5b50602060405190815260200160405180910390f35b3480156100d857600080fd5b506100816100e73660046105d6565b61024a565b3480156100f857600080fd5b506100816101073660046105f8565b610350565b34801561011857600080fd5b5061008161012736600461050b565b6103c6565b34801561013857600080fd5b5061008161014736600461050b565b610424565b34801561015857600080fd5b50610081610167366004610643565b61044b565b61017c610177610486565b6104b5565b565b6000610188610486565b90506000816001600160a01b0316306001600160a01b031663c68d42838787876040516024016101ba939291906106a3565b60408051601f198184030181529181526020820180516001600160e01b031660e09490941b9390931790925290516101f292506106ec565b600060405180830381855af49150503d806000811461022d576040519150601f19603f3d011682016040523d82523d6000602084013e610232565b606091505b505090508061024357610243610708565b5050505050565b6001600160a01b0381166102a55760405162461bcd60e51b815260206004820152601760248201527f5555505350726f78793a207a65726f206164647265737300000000000000000060448201526064015b60405180910390fd5b60006102cf7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b6001600160a01b0316146103255760405162461bcd60e51b815260206004820152601e60248201527f5555505350726f78793a20616c726561647920696e697469616c697a65640000604482015260640161029c565b61034d817f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc55565b50565b6040516320db835f60e11b81526001600160a01b0380861660048301528085166024830152831660448201526064810182905230906341b706be90608401600060405180830381600087803b1580156103a857600080fd5b505af11580156103bc573d6000803e3d6000fd5b5050505050505050565b604051639d87674160e01b81523090639d876741906103ed908690869086906004016106a3565b600060405180830381600087803b15801561040757600080fd5b505af115801561041b573d6000803e3d6000fd5b50505050505050565b604051631e2a20d560e11b81523090633c5441aa906103ed908690869086906004016106a3565b60405163335097db60e11b81526001600160a01b038085166004830152831660248201526044810182905230906366a12fb6906064016103ed565b60006104b07f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b905090565b3660008037600080366000845af43d6000803e8080156104d4573d6000f35b3d6000fd5b80356001600160a01b03811681146104f057600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60008060006060848603121561052057600080fd5b610529846104d9565b925060208401359150604084013567ffffffffffffffff8082111561054d57600080fd5b818601915086601f83011261056157600080fd5b813581811115610573576105736104f5565b604051601f8201601f19908116603f0116810190838211818310171561059b5761059b6104f5565b816040528281528960208487010111156105b457600080fd5b8260208601602083013760006020848301015280955050505050509250925092565b6000602082840312156105e857600080fd5b6105f1826104d9565b9392505050565b6000806000806080858703121561060e57600080fd5b610617856104d9565b9350610625602086016104d9565b9250610633604086016104d9565b9396929550929360600135925050565b60008060006060848603121561065857600080fd5b610661846104d9565b925061066f602085016104d9565b9150604084013590509250925092565b60005b8381101561069a578181015183820152602001610682565b50506000910152565b60018060a01b038416815282602082015260606040820152600082518060608401526106d681608085016020870161067f565b601f01601f191691909101608001949350505050565b600082516106fe81846020870161067f565b9190910192915050565b634e487b7160e01b600052600160045260246000fdfea26469706673582212208bca18e0b1adbec045675907ebbf6ce932b3e517c88178623440e6f4ea3a7e9b64736f6c63430008130033";
const $903d6bdf018b7f48$var$isSuperArgs = (xs)=>xs.length > 1;
class $903d6bdf018b7f48$export$8529f11ee507fb26 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($903d6bdf018b7f48$var$isSuperArgs(args)) super(...args);
        else super($903d6bdf018b7f48$var$_abi, $903d6bdf018b7f48$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($903d6bdf018b7f48$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $903d6bdf018b7f48$var$_abi, signerOrProvider);
    }
}
$903d6bdf018b7f48$export$8529f11ee507fb26.bytecode = $903d6bdf018b7f48$var$_bytecode;
$903d6bdf018b7f48$export$8529f11ee507fb26.abi = $903d6bdf018b7f48$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $4c97bbb33c96ce1a$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "allowance",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "burned",
                type: "uint256"
            }
        ],
        name: "DrainedGas",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "interfaceHash",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "canImplementInterfaceForAddress",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "tokensReceived",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $4c97bbb33c96ce1a$var$_bytecode = "0x6080604052600160005534801561001557600080fd5b506102ed806100256000396000f3fe608060405234801561001057600080fd5b50600436106100355760003560e01c806223de291461003a578063249cb3fa1461004f575b600080fd5b61004d6100483660046101b9565b610074565b005b61006261005d366004610264565b6100e3565b60405190815260200160405180910390f35b60005a90505b6175305a111561009d5760008054908061009383610290565b919050555061007a565b7fe69a071efa597f7995dc49d165ad809dd15393f0b95e75d7089498028bb673d9815a6040805192835260208301919091520160405180910390a1505050505050505050565b60007fb281fc8c12954d22544db45de3159a39272895b169a852b314f9cc762e44c53b831461011357600061014d565b60405173455243313832305f4143434550545f4d4147494360601b6020820152603401604051602081830303815290604052805190602001205b9392505050565b80356001600160a01b038116811461016b57600080fd5b919050565b60008083601f84011261018257600080fd5b50813567ffffffffffffffff81111561019a57600080fd5b6020830191508360208285010111156101b257600080fd5b9250929050565b60008060008060008060008060c0898b0312156101d557600080fd5b6101de89610154565b97506101ec60208a01610154565b96506101fa60408a01610154565b955060608901359450608089013567ffffffffffffffff8082111561021e57600080fd5b61022a8c838d01610170565b909650945060a08b013591508082111561024357600080fd5b506102508b828c01610170565b999c989b5096995094979396929594505050565b6000806040838503121561027757600080fd5b8235915061028760208401610154565b90509250929050565b6000600182016102b057634e487b7160e01b600052601160045260246000fd5b506001019056fea2646970667358221220bbf1734aa4105c4cb158f777b37032af8260781e9bc8b53d2ceecc3f16a2afd064736f6c63430008130033";
const $4c97bbb33c96ce1a$var$isSuperArgs = (xs)=>xs.length > 1;
class $4c97bbb33c96ce1a$export$4d1e02acab224740 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($4c97bbb33c96ce1a$var$isSuperArgs(args)) super(...args);
        else super($4c97bbb33c96ce1a$var$_abi, $4c97bbb33c96ce1a$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($4c97bbb33c96ce1a$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $4c97bbb33c96ce1a$var$_abi, signerOrProvider);
    }
}
$4c97bbb33c96ce1a$export$4d1e02acab224740.bytecode = $4c97bbb33c96ce1a$var$_bytecode;
$4c97bbb33c96ce1a$export$4d1e02acab224740.abi = $4c97bbb33c96ce1a$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $49f4e42ed1f9a410$var$_abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "interfaceHash",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "canImplementInterfaceForAddress",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "tokensReceived",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    }
];
const $49f4e42ed1f9a410$var$_bytecode = "0x608060405234801561001057600080fd5b506040516329965a1d60e01b815230600482018190527fb281fc8c12954d22544db45de3159a39272895b169a852b314f9cc762e44c53b60248301526044820152731820a4b7618bde71dce8cdc73aab6c95905fad249081906329965a1d90606401600060405180830381600087803b15801561008c57600080fd5b505af11580156100a0573d6000803e3d6000fd5b5050505050610299806100b46000396000f3fe608060405234801561001057600080fd5b50600436106100355760003560e01c806223de291461003a578063249cb3fa1461004f575b600080fd5b61004d61004836600461018c565b610074565b005b61006261005d366004610237565b6100b6565b60405190815260200160405180910390f35b60405162461bcd60e51b815260206004820152601360248201527274686579207368616c6c206e6f74207061737360681b604482015260640160405180910390fd5b60007fb281fc8c12954d22544db45de3159a39272895b169a852b314f9cc762e44c53b83146100e6576000610120565b60405173455243313832305f4143434550545f4d4147494360601b6020820152603401604051602081830303815290604052805190602001205b9392505050565b80356001600160a01b038116811461013e57600080fd5b919050565b60008083601f84011261015557600080fd5b50813567ffffffffffffffff81111561016d57600080fd5b60208301915083602082850101111561018557600080fd5b9250929050565b60008060008060008060008060c0898b0312156101a857600080fd5b6101b189610127565b97506101bf60208a01610127565b96506101cd60408a01610127565b955060608901359450608089013567ffffffffffffffff808211156101f157600080fd5b6101fd8c838d01610143565b909650945060a08b013591508082111561021657600080fd5b506102238b828c01610143565b999c989b5096995094979396929594505050565b6000806040838503121561024a57600080fd5b8235915061025a60208401610127565b9050925092905056fea2646970667358221220a6fe74f6583b08380d0f3a05d022b49142e3edf619986f11030695aa0015cf7164736f6c63430008130033";
const $49f4e42ed1f9a410$var$isSuperArgs = (xs)=>xs.length > 1;
class $49f4e42ed1f9a410$export$627b53f9f443cff5 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($49f4e42ed1f9a410$var$isSuperArgs(args)) super(...args);
        else super($49f4e42ed1f9a410$var$_abi, $49f4e42ed1f9a410$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($49f4e42ed1f9a410$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $49f4e42ed1f9a410$var$_abi, signerOrProvider);
    }
}
$49f4e42ed1f9a410$export$627b53f9f443cff5.bytecode = $49f4e42ed1f9a410$var$_bytecode;
$49f4e42ed1f9a410$export$627b53f9f443cff5.abi = $49f4e42ed1f9a410$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $08011cf34032dbfa$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "fromBalance",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "toBalance",
                type: "uint256"
            }
        ],
        name: "TokensReceivedCalled",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "fromBalance",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "toBalance",
                type: "uint256"
            }
        ],
        name: "TokensToSendCalled",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "contract IERC777",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "interfaceHash",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "canImplementInterfaceForAddress",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "recipientFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            }
        ],
        name: "registerRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "registerSender",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC777",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "senderFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "shouldRevert",
                type: "bool"
            }
        ],
        name: "setShouldRevertReceive",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "shouldRevert",
                type: "bool"
            }
        ],
        name: "setShouldRevertSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "tokensReceived",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "tokensToSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "upgradeAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "upgradeAllToSelf",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $08011cf34032dbfa$var$_bytecode = "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";
const $08011cf34032dbfa$var$isSuperArgs = (xs)=>xs.length > 1;
class $08011cf34032dbfa$export$50a2d1b5064800f2 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($08011cf34032dbfa$var$isSuperArgs(args)) super(...args);
        else super($08011cf34032dbfa$var$_abi, $08011cf34032dbfa$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($08011cf34032dbfa$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $08011cf34032dbfa$var$_abi, signerOrProvider);
    }
}
$08011cf34032dbfa$export$50a2d1b5064800f2.bytecode = $08011cf34032dbfa$var$_bytecode;
$08011cf34032dbfa$export$50a2d1b5064800f2.abi = $08011cf34032dbfa$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $2467855c64cd3dd8$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "approveSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "approveSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "calculateDistributionTest",
        outputs: [
            {
                internalType: "uint256",
                name: "actualAmount",
                type: "uint256"
            },
            {
                internalType: "uint128",
                name: "newIndexValue",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "claimTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "claimWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "createIndexTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "createIndexWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "deleteSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "deleteSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "distributeTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "distributeWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "getIndexTest",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsApproved",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsPending",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            }
        ],
        name: "getSubscriptionByIDTest",
        outputs: [
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "getSubscriptionTest",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "listSubscriptionsTest",
        outputs: [
            {
                internalType: "address[]",
                name: "publishers",
                type: "address[]"
            },
            {
                internalType: "uint32[]",
                name: "indexIds",
                type: "uint32[]"
            },
            {
                internalType: "uint128[]",
                name: "unitsList",
                type: "uint128[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "revokeSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "revokeSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            }
        ],
        name: "updateIndexValueTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateIndexValueWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            }
        ],
        name: "updateSubscriptionUnitsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateSubscriptionUnitsWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $2467855c64cd3dd8$var$_bytecode = "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";
const $2467855c64cd3dd8$var$isSuperArgs = (xs)=>xs.length > 1;
class $2467855c64cd3dd8$export$5a1ccf62f118a0f6 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($2467855c64cd3dd8$var$isSuperArgs(args)) super(...args);
        else super($2467855c64cd3dd8$var$_abi, $2467855c64cd3dd8$var$_bytecode, args[0]);
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($2467855c64cd3dd8$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $2467855c64cd3dd8$var$_abi, signerOrProvider);
    }
}
$2467855c64cd3dd8$export$5a1ccf62f118a0f6.bytecode = $2467855c64cd3dd8$var$_bytecode;
$2467855c64cd3dd8$export$5a1ccf62f118a0f6.abi = $2467855c64cd3dd8$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $c81ae9fdd5c86fb9$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "approveSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "approveSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "calculateDistributionTest",
        outputs: [
            {
                internalType: "uint256",
                name: "actualAmount",
                type: "uint256"
            },
            {
                internalType: "uint128",
                name: "newIndexValue",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "claimTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "claimWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "createIndexTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "createIndexWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "deleteSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "deleteSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "distributeTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "distributeWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "getIndexTest",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsApproved",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsPending",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            }
        ],
        name: "getSubscriptionByIDTest",
        outputs: [
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "getSubscriptionTest",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "listSubscriptionsTest",
        outputs: [
            {
                internalType: "address[]",
                name: "publishers",
                type: "address[]"
            },
            {
                internalType: "uint32[]",
                name: "indexIds",
                type: "uint32[]"
            },
            {
                internalType: "uint128[]",
                name: "unitsList",
                type: "uint128[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "revokeSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "revokeSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            }
        ],
        name: "updateIndexValueTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateIndexValueWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            }
        ],
        name: "updateSubscriptionUnitsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateSubscriptionUnitsWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $c81ae9fdd5c86fb9$var$_bytecode = "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";
const $c81ae9fdd5c86fb9$var$isSuperArgs = (xs)=>xs.length > 1;
class $c81ae9fdd5c86fb9$export$3c8c3291ccf7bf99 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($c81ae9fdd5c86fb9$var$isSuperArgs(args)) super(...args);
        else super($c81ae9fdd5c86fb9$var$_abi, $c81ae9fdd5c86fb9$var$_bytecode, args[0]);
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($c81ae9fdd5c86fb9$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $c81ae9fdd5c86fb9$var$_abi, signerOrProvider);
    }
}
$c81ae9fdd5c86fb9$export$3c8c3291ccf7bf99.bytecode = $c81ae9fdd5c86fb9$var$_bytecode;
$c81ae9fdd5c86fb9$export$3c8c3291ccf7bf99.abi = $c81ae9fdd5c86fb9$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $5032b88ff8a21ba0$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerAppWithHost",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $5032b88ff8a21ba0$var$_bytecode = "0x608060405234801561001057600080fd5b5061012c806100206000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063ad88671d14602d575b600080fd5b603c603836600460ba565b603e565b005b6040516379b9982960e11b81526001600160a01b0383811660048301526024820183905284169063f373305290604401600060405180830381600087803b158015608757600080fd5b505af1158015609a573d6000803e3d6000fd5b50505050505050565b6001600160a01b038116811460b757600080fd5b50565b60008060006060848603121560ce57600080fd5b833560d78160a3565b9250602084013560e58160a3565b92959294505050604091909101359056fea26469706673582212209d1aa54def2a7911131c670eab564d0de4f81530d4ff9780c8d61da748c5019e64736f6c63430008130033";
const $5032b88ff8a21ba0$var$isSuperArgs = (xs)=>xs.length > 1;
class $5032b88ff8a21ba0$export$10695245f8d85fc6 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($5032b88ff8a21ba0$var$isSuperArgs(args)) super(...args);
        else super($5032b88ff8a21ba0$var$_abi, $5032b88ff8a21ba0$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($5032b88ff8a21ba0$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $5032b88ff8a21ba0$var$_abi, signerOrProvider);
    }
}
$5032b88ff8a21ba0$export$10695245f8d85fc6.bytecode = $5032b88ff8a21ba0$var$_bytecode;
$5032b88ff8a21ba0$export$10695245f8d85fc6.abi = $5032b88ff8a21ba0$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $d3f9b475589360c3$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            },
            {
                internalType: "bool",
                name: "doubleRegistration",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "appLevel",
                type: "uint8"
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "callType",
                type: "uint8"
            },
            {
                indexed: false,
                internalType: "bytes4",
                name: "agreementSelector",
                type: "bytes4"
            }
        ],
        name: "NoopEvent",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "contract AgreementMock",
                name: "agreement",
                type: "address"
            },
            {
                internalType: "string",
                name: "reason",
                type: "string"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionAgreementRevert",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionAlteringCtx",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionAssert",
        outputs: [],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionCallActionNoop",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionCallActionNoopThroughAux",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "reason",
                type: "string"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionCallActionRevert",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "reason",
                type: "string"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionCallActionWithInvalidCtx",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract AgreementMock",
                name: "agreement",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionCallAgreementWithInvalidCtx",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionCallAgreementWithoutCtx",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionCallAppActionWithoutCtx",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionCallBadAction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionCallPayable",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "expectedMsgSender",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionExpectMsgSender",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionNoop",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract AgreementMock",
                name: "agreement",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "ping",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionPingAgreement",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract AgreementMock",
                name: "agreement",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "ping",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionPingAgreementThroughAux",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionReturnEmptyCtx",
        outputs: [],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionRevert",
        outputs: [],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "reason",
                type: "string"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionRevertWithReason",
        outputs: [],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "target",
                type: "address"
            }
        ],
        name: "allowCompositeApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "enum SuperAppMock.NextCallbackActionType",
                name: "actionType",
                type: "uint8"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "setNextCallbackAction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "tryRegisterApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $d3f9b475589360c3$var$_bytecode = "0x60806040523480156200001157600080fd5b506040516200341d3803806200341d833981016040819052620000349162000190565b600080546001600160a01b0319166001600160a01b03851690811782556040805163bd1c448b60e01b815260048101869052602481019190915260448101929092529063bd1c448b90606401600060405180830381600087803b1580156200009b57600080fd5b505af1158015620000b0573d6000803e3d6000fd5b5050505080156200012c57600080546040805163bd1c448b60e01b815260048101869052602481019190915260448101929092526001600160a01b03169063bd1c448b90606401600060405180830381600087803b1580156200011257600080fd5b505af115801562000127573d6000803e3d6000fd5b505050505b6040516200013a9062000182565b604051809103906000f08015801562000157573d6000803e3d6000fd5b50600180546001600160a01b0319166001600160a01b039290921691909117905550620001e7915050565b6106478062002dd683390190565b600080600060608486031215620001a657600080fd5b83516001600160a01b0381168114620001be57600080fd5b6020850151604086015191945092508015158114620001dc57600080fd5b809150509250925092565b612bdf80620001f76000396000f3fe6080604052600436106101b75760003560e01c80636affc782116100ec578063b88bd14f1161008a578063dc1ce9cb11610064578063dc1ce9cb14610454578063e772ecc114610467578063ecdccfd914610487578063fe5f2b9b146104a757600080fd5b8063b88bd14f14610414578063bc90ea3c14610434578063d86ed3e51461025457600080fd5b8063884d1f40116100c6578063884d1f401461029457806390d4b672146103b4578063a6b71066146103d4578063b88a2483146103f457600080fd5b80636affc78214610354578063772ce847146103745780637a7675a01461039457600080fd5b80633b790ac81161015957806357121e0c1161013357806357121e0c146102f457806358b0d33d146103145780635f9e7d7714610294578063602e48cd1461033457600080fd5b80633b790ac8146102b45780633fc3b0f7146102d457806353c11f991461025457600080fd5b80630bfe0f20116101955780630bfe0f201461021e578063230dbd291461025457806328fd0b471461027457806330d9c9151461029457600080fd5b80630769a69b146101bc57806308c95b5d146101de5780630a00b52d146101fe575b600080fd5b3480156101c857600080fd5b506101dc6101d736600461203c565b6104c7565b005b3480156101ea57600080fd5b506101dc6101f9366004612095565b6105e7565b34801561020a57600080fd5b506101dc61021936600461203c565b6106e3565b34801561022a57600080fd5b5061023e6102393660046120f0565b610844565b60405161024b9190612194565b60405180910390f35b34801561026057600080fd5b5061023e61026f3660046121ae565b6109cc565b34801561028057600080fd5b506101dc61028f366004612278565b610aa4565b3480156102a057600080fd5b5061023e6102af366004612291565b610aff565b3480156102c057600080fd5b506101dc6102cf36600461203c565b610b9e565b3480156102e057600080fd5b5061023e6102ef36600461232f565b610c24565b34801561030057600080fd5b506101dc61030f36600461238e565b610d9d565b34801561032057600080fd5b506101dc61032f36600461203c565b610dcf565b34801561034057600080fd5b5061023e61034f3660046120f0565b610ec7565b34801561036057600080fd5b5061023e61036f36600461203c565b61106d565b34801561038057600080fd5b506101dc61038f3660046123ab565b61111b565b3480156103a057600080fd5b506101dc6103af36600461203c565b61114c565b3480156103c057600080fd5b5061023e6103cf3660046123cf565b6111d2565b3480156103e057600080fd5b5061023e6103ef366004612095565b611346565b34801561040057600080fd5b506101dc61040f36600461203c565b6114b9565b34801561042057600080fd5b506101dc61042f36600461203c565b61157d565b34801561044057600080fd5b5061023e61044f36600461203c565b61160b565b61023e61046236600461203c565b611769565b34801561047357600080fd5b5061023e61048236600461203c565b6117a9565b34801561049357600080fd5b5061023e6104a236600461232f565b611929565b3480156104b357600080fd5b506101dc6104c236600461232f565b611a3b565b604051632fd0a1cd60e21b815282908290339063bf428734906104f0908590859060040161247a565b602060405180830381865afa15801561050d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906105319190612496565b6105565760405162461bcd60e51b815260040161054d906124b8565b60405180910390fd5b600080546040805183815260208101848152818301928390526339255d5b60e01b9092526001600160a01b03909216926339255d5b926105999260448201612511565b6000604051808303816000875af11580156105b8573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526105e0919081019061260d565b5050505050565b604051632fd0a1cd60e21b815282908290339063bf42873490610610908590859060040161247a565b602060405180830381865afa15801561062d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106519190612496565b61066d5760405162461bcd60e51b815260040161054d906124b8565b600154600054604051630a1bcfa560e11b81526001600160a01b03928316926314379f4a926106a9929116908a908a908a908a90600401612641565b600060405180830381600087803b1580156106c357600080fd5b505af11580156106d7573d6000803e3d6000fd5b50505050505050505050565b604051632fd0a1cd60e21b815282908290339063bf4287349061070c908590859060040161247a565b602060405180830381865afa158015610729573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061074d9190612496565b6107695760405162461bcd60e51b815260040161054d906124b8565b60008054604080519283526020830190526001600160a01b03169063ba48b5f89030908190636affc782906107a19060448101612194565b60408051808303601f1901815291815260208201805160e094851b6001600160e01b03909116179052519185901b6001600160e01b03191682526107ee9392509089908990600401612675565b6000604051808303816000875af115801561080d573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610835919081019061260d565b5061083e6126ac565b50505050565b604051632fd0a1cd60e21b815260609083908390339063bf42873490610870908590859060040161247a565b602060405180830381865afa15801561088d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906108b19190612496565b6108cd5760405162461bcd60e51b815260040161054d906124b8565b60008054604080519283526020830190526001600160a01b0390811691634329d29391899190821690638e6b27499061090e903090602a90604481016126c2565b60408051601f19818403018152918152602080830180516001600160e01b031660e095861b1790528151600081529081018252602a8183015281518082038301815260608201928390529387901b6001600160e01b03191690915261097a9493509091606482016126e9565b6000604051808303816000875af1158015610999573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526109c19190810190612733565b509695505050505050565b604051632fd0a1cd60e21b815260609083908390339063bf428734906109f8908590859060040161247a565b602060405180830381865afa158015610a15573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a399190612496565b610a555760405162461bcd60e51b815260040161054d906124b8565b610a9485858080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250611add92505050565b9c9b505050505050505050505050565b6000546040516315a722b960e31b8152600481018390526001600160a01b039091169063ad3915c8906024015b600060405180830381600087803b158015610aeb57600080fd5b505af11580156105e0573d6000803e3d6000fd5b604051632fd0a1cd60e21b815260609083908390339063bf42873490610b2b908590859060040161247a565b602060405180830381865afa158015610b48573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b6c9190612496565b610b885760405162461bcd60e51b815260040161054d906124b8565b610b90611e33565b9a9950505050505050505050565b604051632fd0a1cd60e21b815282908290339063bf42873490610bc7908590859060040161247a565b602060405180830381865afa158015610be4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c089190612496565b61083e5760405162461bcd60e51b815260040161054d906124b8565b604051632fd0a1cd60e21b815260609083908390339063bf42873490610c50908590859060040161247a565b602060405180830381865afa158015610c6d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c919190612496565b610cad5760405162461bcd60e51b815260040161054d906124b8565b60008054604080519283526020830190526001600160a01b03169063ba48b5f8903090819063fe5f2b9b90610ce9908d908d9060448101612796565b60408051601f19818403018152918152602080830180516001600160e01b031660e095861b1790528151602a8183015282518082039092018252808301928390529387901b6001600160e01b031916909152610d4b9493509091604401612511565b6000604051808303816000875af1158015610d6a573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610d92919081019061260d565b979650505050505050565b6000546040516315c4878360e21b81526001600160a01b038381166004830152909116906357121e0c90602401610ad1565b604051632fd0a1cd60e21b815282908290339063bf42873490610df8908590859060040161247a565b602060405180830381865afa158015610e15573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e399190612496565b610e555760405162461bcd60e51b815260040161054d906124b8565b60015460005460405163131e7b7560e21b81526001600160a01b0392831692634c79edd492610e8f929116903090899089906004016127bc565b600060405180830381600087803b158015610ea957600080fd5b505af1158015610ebd573d6000803e3d6000fd5b5050505050505050565b604051632fd0a1cd60e21b815260609083908390339063bf42873490610ef3908590859060040161247a565b602060405180830381865afa158015610f10573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f349190612496565b610f505760405162461bcd60e51b815260040161054d906124b8565b604051631fb6491d60e11b81526000903390633f6c923a90610f78908990899060040161247a565b600060405180830381865afa158015610f95573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610fbd9190810190612822565b9050866001600160a01b031681606001516001600160a01b031614610fe457610fe46126ac565b7f5d497a0f141d2596bd23602421f1cc06c3b9ad6c29b51997cf62ca3f84754e1381600001518260200151836080015160405161102393929190612928565b60405180910390a185858080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250929a9950505050505050505050565b604051632fd0a1cd60e21b815260609083908390339063bf42873490611099908590859060040161247a565b602060405180830381865afa1580156110b6573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906110da9190612496565b6110f65760405162461bcd60e51b815260040161054d906124b8565b60408051602a6020820152016040516020818303038152906040529250505092915050565b6002805484919060ff1916600183600681111561113a5761113a61294f565b0217905550600361083e8284836129e7565b604051632fd0a1cd60e21b815282908290339063bf42873490611175908590859060040161247a565b602060405180830381865afa158015611192573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906111b69190612496565b6101b75760405162461bcd60e51b815260040161054d906124b8565b604051632fd0a1cd60e21b815260609083908390339063bf428734906111fe908590859060040161247a565b602060405180830381865afa15801561121b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061123f9190612496565b61125b5760405162461bcd60e51b815260040161054d906124b8565b60008054604080519283526020830190526001600160a01b0390811691634329d293918b919082169063edf02c4e9061129b908d908d9060448101612796565b60408051601f19818403018152918152602080830180516001600160e01b031660e095861b179052815160008152908101918290529286901b6001600160e01b03191690526112f2939250908a8a60248301612aa6565b6000604051808303816000875af1158015611311573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526113399190810190612733565b5098975050505050505050565b604051632fd0a1cd60e21b815260609083908390339063bf42873490611372908590859060040161247a565b602060405180830381865afa15801561138f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906113b39190612496565b6113cf5760405162461bcd60e51b815260040161054d906124b8565b60008054604080519283526020830190526001600160a01b0390811691634329d293918a9190821690638e6b27499061140f9030908d90604481016126c2565b60408051601f19818403018152918152602080830180516001600160e01b031660e095861b179052815160008152908101918290529286901b6001600160e01b0319169052611466939250908a8a60248301612aa6565b6000604051808303816000875af1158015611485573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526114ad9190810190612733565b50979650505050505050565b604051632fd0a1cd60e21b815282908290339063bf428734906114e2908590859060040161247a565b602060405180830381865afa1580156114ff573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906115239190612496565b61153f5760405162461bcd60e51b815260040161054d906124b8565b60008054604080518381526020810191829052631e855cf360e01b9091526001600160a01b0390911691631e855cf391610599919060248101612afd565b604051632fd0a1cd60e21b815282908290339063bf428734906115a6908590859060040161247a565b602060405180830381865afa1580156115c3573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906115e79190612496565b6116035760405162461bcd60e51b815260040161054d906124b8565b61083e6126ac565b604051632fd0a1cd60e21b815260609083908390339063bf42873490611637908590859060040161247a565b602060405180830381865afa158015611654573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116789190612496565b6116945760405162461bcd60e51b815260040161054d906124b8565b60008054604080519283526020830190526001600160a01b03169063ba48b5f8903090819063e772ecc1906116cc9060448101612194565b60408051808303601f1901815291815260208201805160e094851b6001600160e01b03909116179052519185901b6001600160e01b0319168252611719939250908a908a90600401612675565b6000604051808303816000875af1158015611738573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052611760919081019061260d565b95945050505050565b606082828080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250929695505050505050565b604051632fd0a1cd60e21b815260609083908390339063bf428734906117d5908590859060040161247a565b602060405180830381865afa1580156117f2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906118169190612496565b6118325760405162461bcd60e51b815260040161054d906124b8565b604051631fb6491d60e11b81526000903390633f6c923a9061185a908990899060040161247a565b600060405180830381865afa158015611877573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261189f9190810190612822565b90507f5d497a0f141d2596bd23602421f1cc06c3b9ad6c29b51997cf62ca3f84754e138160000151826020015183608001516040516118e093929190612928565b60405180910390a185858080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250929998505050505050505050565b604051632fd0a1cd60e21b815260609083908390339063bf42873490611955908590859060040161247a565b602060405180830381865afa158015611972573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906119969190612496565b6119b25760405162461bcd60e51b815260040161054d906124b8565b60008054604080519283526020830190526001600160a01b03169063ba48b5f8903090819063fe5f2b9b906119ee908d908d9060448101612796565b60408051808303601f1901815291815260208201805160e094851b6001600160e01b03909116179052519185901b6001600160e01b0319168252610d4b939250908a908a90600401612675565b604051632fd0a1cd60e21b815282908290339063bf42873490611a64908590859060040161247a565b602060405180830381865afa158015611a81573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611aa59190612496565b611ac15760405162461bcd60e51b815260040161054d906124b8565b858560405162461bcd60e51b815260040161054d92919061247a565b604051631fb6491d60e11b81526060906000903390633f6c923a90611b06908690600401612194565b600060405180830381865afa158015611b23573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052611b4b9190810190612822565b9050600060025460ff166006811115611b6657611b6661294f565b03611bb9577f5d497a0f141d2596bd23602421f1cc06c3b9ad6c29b51997cf62ca3f84754e13816000015182602001518360800151604051611baa93929190612928565b60405180910390a15090919050565b600160025460ff166006811115611bd257611bd261294f565b03611be457611bdf6126ac565b611e2d565b6002805460ff166006811115611bfc57611bfc61294f565b03611c0657600080fd5b600360025460ff166006811115611c1f57611c1f61294f565b03611cdb5760038054611c3190612965565b80601f0160208091040260200160405190810160405280929190818152602001828054611c5d90612965565b8015611caa5780601f10611c7f57610100808354040283529160200191611caa565b820191906000526020600020905b815481529060010190602001808311611c8d57829003601f168201915b5050505050806020019051810190611cc29190612b21565b60405162461bcd60e51b815260040161054d9190612194565b600460025460ff166006811115611cf457611cf461294f565b03611d2e57602a5b6040519080825280601f01601f191660200182016040528015611d26576020820181803683370190505b509392505050565b600560025460ff166006811115611d4757611d4761294f565b03611e0057600060026001018054611d5e90612965565b80601f0160208091040260200160405190810160405280929190818152602001828054611d8a90612965565b8015611dd75780601f10611dac57610100808354040283529160200191611dd7565b820191906000526020600020905b815481529060010190602001808311611dba57829003601f168201915b5050505050806020019051810190611def9190612b69565b9050611dfa81611fc0565b50611e2d565b600660025460ff166006811115611e1957611e1961294f565b03611e25576000611cfc565b611e2d6126ac565b50919050565b6060600060025460ff166006811115611e4e57611e4e61294f565b03611e72575060408051808201909152600481526304e6f6f760e41b602082015290565b600160025460ff166006811115611e8b57611e8b61294f565b03611e9b57611e986126ac565b90565b6002805460ff166006811115611eb357611eb361294f565b03611ebd57600080fd5b600360025460ff166006811115611ed657611ed661294f565b03611ee85760038054611c3190612965565b600560025460ff166006811115611f0157611f0161294f565b03611fb857600060026001018054611f1890612965565b80601f0160208091040260200160405190810160405280929190818152602001828054611f4490612965565b8015611f915780601f10611f6657610100808354040283529160200191611f91565b820191906000526020600020905b815481529060010190602001808311611f7457829003601f168201915b5050505050806020019051810190611fa99190612b69565b9050611fb481611fc0565b5090565b611e986126ac565b60005a905060005a90505b611fd76103e884612b82565b611fe18284612b82565b1015611fef575a9050611fcb565b505050565b60008083601f84011261200657600080fd5b5081356001600160401b0381111561201d57600080fd5b60208301915083602082850101111561203557600080fd5b9250929050565b6000806020838503121561204f57600080fd5b82356001600160401b0381111561206557600080fd5b61207185828601611ff4565b90969095509350505050565b6001600160a01b038116811461209257600080fd5b50565b600080600080606085870312156120ab57600080fd5b84356120b68161207d565b93506020850135925060408501356001600160401b038111156120d857600080fd5b6120e487828801611ff4565b95989497509550505050565b60008060006040848603121561210557600080fd5b83356121108161207d565b925060208401356001600160401b0381111561212b57600080fd5b61213786828701611ff4565b9497909650939450505050565b60005b8381101561215f578181015183820152602001612147565b50506000910152565b60008151808452612180816020860160208601612144565b601f01601f19169290920160200192915050565b6020815260006121a76020830184612168565b9392505050565b600080600080600080600080600060c08a8c0312156121cc57600080fd5b89356121d78161207d565b985060208a01356121e78161207d565b975060408a0135965060608a01356001600160401b038082111561220a57600080fd5b6122168d838e01611ff4565b909850965060808c013591508082111561222f57600080fd5b61223b8d838e01611ff4565b909650945060a08c013591508082111561225457600080fd5b506122618c828d01611ff4565b915080935050809150509295985092959850929598565b60006020828403121561228a57600080fd5b5035919050565b600080600080600080600060a0888a0312156122ac57600080fd5b87356122b78161207d565b965060208801356122c78161207d565b95506040880135945060608801356001600160401b03808211156122ea57600080fd5b6122f68b838c01611ff4565b909650945060808a013591508082111561230f57600080fd5b5061231c8a828b01611ff4565b989b979a50959850939692959293505050565b6000806000806040858703121561234557600080fd5b84356001600160401b038082111561235c57600080fd5b61236888838901611ff4565b9096509450602087013591508082111561238157600080fd5b506120e487828801611ff4565b6000602082840312156123a057600080fd5b81356121a78161207d565b6000806000604084860312156123c057600080fd5b83356007811061211057600080fd5b6000806000806000606086880312156123e757600080fd5b85356123f28161207d565b945060208601356001600160401b038082111561240e57600080fd5b61241a89838a01611ff4565b9096509450604088013591508082111561243357600080fd5b5061244088828901611ff4565b969995985093965092949392505050565b81835281816020850137506000828201602090810191909152601f909101601f19169091010190565b60208152600061248e602083018486612451565b949350505050565b6000602082840312156124a857600080fd5b815180151581146121a757600080fd5b60208082526023908201527f41677265656d656e744d6f636b3a20637478206e6f742076616c6964206265666040820152626f726560e81b606082015260800190565b634e487b7160e01b600052604160045260246000fd5b6001600160a01b038416815260606020820181905260009061253590830185612168565b82810360408401526125478185612168565b9695505050505050565b60405161016081016001600160401b0381118282101715612574576125746124fb565b60405290565b60006001600160401b0380841115612594576125946124fb565b604051601f8501601f19908116603f011681019082821181831017156125bc576125bc6124fb565b816040528093508581528686860111156125d557600080fd5b6125e3866020830187612144565b5050509392505050565b600082601f8301126125fe57600080fd5b6121a78383516020850161257a565b60006020828403121561261f57600080fd5b81516001600160401b0381111561263557600080fd5b61248e848285016125ed565b6001600160a01b0386811682528516602082015260408101849052608060608201819052600090610d929083018486612451565b6001600160a01b038516815260606020820181905260009061269990830186612168565b8281036040840152610d92818587612451565b634e487b7160e01b600052600160045260246000fd5b60018060a01b03841681528260208201526060604082015260006117606060830184612168565b6001600160a01b038516815260806020820181905260009061270d90830186612168565b828103604084015261271f8186612168565b90508281036060840152610d928185612168565b6000806040838503121561274657600080fd5b82516001600160401b038082111561275d57600080fd5b612769868387016125ed565b9350602085015191508082111561277f57600080fd5b5061278c858286016125ed565b9150509250929050565b6040815260006127aa604083018587612451565b82810360208401526125478185612168565b6001600160a01b038581168252841660208201526060604082018190526000906125479083018486612451565b805160ff811681146127fa57600080fd5b919050565b80516127fa8161207d565b80516001600160e01b0319811681146127fa57600080fd5b60006020828403121561283457600080fd5b81516001600160401b038082111561284b57600080fd5b90830190610160828603121561286057600080fd5b612868612551565b612871836127e9565b815261287f602084016127e9565b60208201526040830151604082015261289a606084016127ff565b60608201526128ab6080840161280a565b608082015260a0830151828111156128c257600080fd5b6128ce878286016125ed565b60a08301525060c083015160c082015260e083015160e08201526101009150818301518282015261012091506129058284016127ff565b8282015261014091506129198284016127ff565b91810191909152949350505050565b60ff93841681529190921660208201526001600160e01b0319909116604082015260600190565b634e487b7160e01b600052602160045260246000fd5b600181811c9082168061297957607f821691505b602082108103611e2d57634e487b7160e01b600052602260045260246000fd5b601f821115611fef57600081815260208120601f850160051c810160208610156129c05750805b601f850160051c820191505b818110156129df578281556001016129cc565b505050505050565b6001600160401b038311156129fe576129fe6124fb565b612a1283612a0c8354612965565b83612999565b6000601f841160018114612a465760008515612a2e5750838201355b600019600387901b1c1916600186901b1783556105e0565b600083815260209020601f19861690835b82811015612a775786850135825560209485019460019092019101612a57565b5086821015612a945760001960f88860031b161c19848701351681555b505060018560011b0183555050505050565b6001600160a01b0386168152608060208201819052600090612aca90830187612168565b8281036040840152612adc8187612168565b90508281036060840152612af1818587612451565b98975050505050505050565b6001600160a01b038316815260406020820181905260009061248e90830184612168565b600060208284031215612b3357600080fd5b81516001600160401b03811115612b4957600080fd5b8201601f81018413612b5a57600080fd5b61248e8482516020840161257a565b600060208284031215612b7b57600080fd5b5051919050565b81810381811115612ba357634e487b7160e01b600052601160045260246000fd5b9291505056fea2646970667358221220861a3043cdcfb5d426309395ff2d94b16d4c195da794639afcb11e88acac0d5e64736f6c63430008130033608060405234801561001057600080fd5b50610627806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c806314379f4a1461003b5780634c79edd414610050575b600080fd5b61004e61004936600461027e565b610063565b005b61004e61005e3660046102f1565b610148565b6040805160008152602081019091526001600160a01b0386811691634329d29391879190821690638e6b2749906100a19030908a90604481016103bc565b60408051601f19818403018152918152602080830180516001600160e01b031660e095861b179052815160008152908101918290529286901b6001600160e01b03191690526100f893925090878760248301610415565b6000604051808303816000875af1158015610117573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261013f91908101906104f4565b50505050505050565b6040805160008152602081019091526001600160a01b038581169163ba48b5f89186919082169063e772ecc1906101829060448101610558565b60408051808303601f1901815291815260208201805160e094851b6001600160e01b03909116179052519185901b6001600160e01b03191682526101cf9392509087908790600401610572565b6000604051808303816000875af11580156101ee573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261021691908101906105b4565b5050505050565b6001600160a01b038116811461023257600080fd5b50565b60008083601f84011261024757600080fd5b50813567ffffffffffffffff81111561025f57600080fd5b60208301915083602082850101111561027757600080fd5b9250929050565b60008060008060006080868803121561029657600080fd5b85356102a18161021d565b945060208601356102b18161021d565b935060408601359250606086013567ffffffffffffffff8111156102d457600080fd5b6102e088828901610235565b969995985093965092949392505050565b6000806000806060858703121561030757600080fd5b84356103128161021d565b935060208501356103228161021d565b9250604085013567ffffffffffffffff81111561033e57600080fd5b61034a87828801610235565b95989497509550505050565b634e487b7160e01b600052604160045260246000fd5b60005b8381101561038757818101518382015260200161036f565b50506000910152565b600081518084526103a881602086016020860161036c565b601f01601f19169290920160200192915050565b60018060a01b03841681528260208201526060604082015260006103e36060830184610390565b95945050505050565b81835281816020850137506000828201602090810191909152601f909101601f19169091010190565b6001600160a01b038616815260806020820181905260009061043990830187610390565b828103604084015261044b8187610390565b905082810360608401526104608185876103ec565b98975050505050505050565b600082601f83011261047d57600080fd5b815167ffffffffffffffff8082111561049857610498610356565b604051601f8301601f19908116603f011681019082821181831017156104c0576104c0610356565b816040528381528660208588010111156104d957600080fd5b6104ea84602083016020890161036c565b9695505050505050565b6000806040838503121561050757600080fd5b825167ffffffffffffffff8082111561051f57600080fd5b61052b8683870161046c565b9350602085015191508082111561054157600080fd5b5061054e8582860161046c565b9150509250929050565b60208152600061056b6020830184610390565b9392505050565b6001600160a01b038516815260606020820181905260009061059690830186610390565b82810360408401526105a98185876103ec565b979650505050505050565b6000602082840312156105c657600080fd5b815167ffffffffffffffff8111156105dd57600080fd5b6105e98482850161046c565b94935050505056fea2646970667358221220585666bf2941bbeb18a3d67d1bfbbc3898d9d4eeda51c346ccd255e8aa72138a64736f6c63430008130033";
const $d3f9b475589360c3$var$isSuperArgs = (xs)=>xs.length > 1;
class $d3f9b475589360c3$export$5a13f2a4441cb594 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($d3f9b475589360c3$var$isSuperArgs(args)) super(...args);
        else super($d3f9b475589360c3$var$_abi, $d3f9b475589360c3$var$_bytecode, args[0]);
    }
    deploy(host, configWord, doubleRegistration, overrides) {
        return super.deploy(host, configWord, doubleRegistration, overrides || {});
    }
    getDeployTransaction(host, configWord, doubleRegistration, overrides) {
        return super.getDeployTransaction(host, configWord, doubleRegistration, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($d3f9b475589360c3$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $d3f9b475589360c3$var$_abi, signerOrProvider);
    }
}
$d3f9b475589360c3$export$5a13f2a4441cb594.bytecode = $d3f9b475589360c3$var$_bytecode;
$d3f9b475589360c3$export$5a13f2a4441cb594.abi = $d3f9b475589360c3$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $8971a6987069b3f4$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract SuperAppMock",
                name: "app",
                type: "address"
            },
            {
                internalType: "contract AgreementMock",
                name: "agreement",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "allowCompositeApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $8971a6987069b3f4$var$_bytecode = "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";
const $8971a6987069b3f4$var$isSuperArgs = (xs)=>xs.length > 1;
class $8971a6987069b3f4$export$c870a404323e6a65 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($8971a6987069b3f4$var$isSuperArgs(args)) super(...args);
        else super($8971a6987069b3f4$var$_abi, $8971a6987069b3f4$var$_bytecode, args[0]);
    }
    deploy(host, app, agreement, overrides) {
        return super.deploy(host, app, agreement, overrides || {});
    }
    getDeployTransaction(host, app, agreement, overrides) {
        return super.getDeployTransaction(host, app, agreement, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($8971a6987069b3f4$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $8971a6987069b3f4$var$_abi, signerOrProvider);
    }
}
$8971a6987069b3f4$export$c870a404323e6a65.bytecode = $8971a6987069b3f4$var$_bytecode;
$8971a6987069b3f4$export$c870a404323e6a65.abi = $8971a6987069b3f4$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $b7733df5e2f3862f$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract SuperAppMock",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionCallActionNoop",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract AgreementMock",
                name: "agreement",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "ping",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "actionPingAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $b7733df5e2f3862f$var$_bytecode = "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";
const $b7733df5e2f3862f$var$isSuperArgs = (xs)=>xs.length > 1;
class $b7733df5e2f3862f$export$9d5f050d3217577a extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($b7733df5e2f3862f$var$isSuperArgs(args)) super(...args);
        else super($b7733df5e2f3862f$var$_abi, $b7733df5e2f3862f$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($b7733df5e2f3862f$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $b7733df5e2f3862f$var$_abi, signerOrProvider);
    }
}
$b7733df5e2f3862f$export$9d5f050d3217577a.bytecode = $b7733df5e2f3862f$var$_bytecode;
$b7733df5e2f3862f$export$9d5f050d3217577a.abi = $b7733df5e2f3862f$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $16e7d21163efebe4$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    }
];
const $16e7d21163efebe4$var$_bytecode = "0x608060405234801561001057600080fd5b5060405161037638038061037683398101604081905261002f916100b3565b600080546001600160a01b0319166001600160a01b03831690811782556040805163bd1c448b60e01b815260016004820152602481019190915260448101929092529063bd1c448b90606401600060405180830381600087803b15801561009557600080fd5b505af11580156100a9573d6000803e3d6000fd5b50505050506100e3565b6000602082840312156100c557600080fd5b81516001600160a01b03811681146100dc57600080fd5b9392505050565b610284806100f26000396000f3fe608060405234801561001057600080fd5b506004361061004c5760003560e01c806330d9c9151461005157806353c11f991461006a5780635f9e7d7714610051578063d86ed3e51461006a575b600080fd5b61006861005f3660046100e4565b50505050505050565b005b610068610078366004610183565b505050505050505050565b6001600160a01b038116811461009857600080fd5b50565b60008083601f8401126100ad57600080fd5b50813567ffffffffffffffff8111156100c557600080fd5b6020830191508360208285010111156100dd57600080fd5b9250929050565b600080600080600080600060a0888a0312156100ff57600080fd5b873561010a81610083565b9650602088013561011a81610083565b955060408801359450606088013567ffffffffffffffff8082111561013e57600080fd5b61014a8b838c0161009b565b909650945060808a013591508082111561016357600080fd5b506101708a828b0161009b565b989b979a50959850939692959293505050565b600080600080600080600080600060c08a8c0312156101a157600080fd5b89356101ac81610083565b985060208a01356101bc81610083565b975060408a0135965060608a013567ffffffffffffffff808211156101e057600080fd5b6101ec8d838e0161009b565b909850965060808c013591508082111561020557600080fd5b6102118d838e0161009b565b909650945060a08c013591508082111561022a57600080fd5b506102378c828d0161009b565b91508093505080915050929598509295985092959856fea2646970667358221220928d3badbea72c78d28879ab2e396b4d98d714f4a57f1a7baa30743d7073e67064736f6c63430008130033";
const $16e7d21163efebe4$var$isSuperArgs = (xs)=>xs.length > 1;
class $16e7d21163efebe4$export$9e98889b73b6cc09 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($16e7d21163efebe4$var$isSuperArgs(args)) super(...args);
        else super($16e7d21163efebe4$var$_abi, $16e7d21163efebe4$var$_bytecode, args[0]);
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($16e7d21163efebe4$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $16e7d21163efebe4$var$_abi, signerOrProvider);
    }
}
$16e7d21163efebe4$export$9e98889b73b6cc09.bytecode = $16e7d21163efebe4$var$_bytecode;
$16e7d21163efebe4$export$9e98889b73b6cc09.abi = $16e7d21163efebe4$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $d76e119dfe2b7063$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    }
];
const $d76e119dfe2b7063$var$_bytecode = "0x608060405234801561001057600080fd5b506040516102be3803806102be83398101604081905261002f916100b3565b600080546001600160a01b0319166001600160a01b03831690811782556040805163bd1c448b60e01b815260016004820152602481019190915260448101929092529063bd1c448b90606401600060405180830381600087803b15801561009557600080fd5b505af11580156100a9573d6000803e3d6000fd5b50505050506100e3565b6000602082840312156100c557600080fd5b81516001600160a01b03811681146100dc57600080fd5b9392505050565b6101cc806100f26000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c806353c11f991461003b578063d86ed3e51461003b575b600080fd5b6100586100493660046100cb565b602a9998505050505050505050565b60405190815260200160405180910390f35b6001600160a01b038116811461007f57600080fd5b50565b60008083601f84011261009457600080fd5b50813567ffffffffffffffff8111156100ac57600080fd5b6020830191508360208285010111156100c457600080fd5b9250929050565b600080600080600080600080600060c08a8c0312156100e957600080fd5b89356100f48161006a565b985060208a01356101048161006a565b975060408a0135965060608a013567ffffffffffffffff8082111561012857600080fd5b6101348d838e01610082565b909850965060808c013591508082111561014d57600080fd5b6101598d838e01610082565b909650945060a08c013591508082111561017257600080fd5b5061017f8c828d01610082565b91508093505080915050929598509295985092959856fea2646970667358221220ae9e55f1252767e4093061ca0d586a569800693cd0cb0a9b8cc24e52ff6990ff64736f6c63430008130033";
const $d76e119dfe2b7063$var$isSuperArgs = (xs)=>xs.length > 1;
class $d76e119dfe2b7063$export$a35de2637b105662 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($d76e119dfe2b7063$var$isSuperArgs(args)) super(...args);
        else super($d76e119dfe2b7063$var$_abi, $d76e119dfe2b7063$var$_bytecode, args[0]);
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($d76e119dfe2b7063$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $d76e119dfe2b7063$var$_abi, signerOrProvider);
    }
}
$d76e119dfe2b7063$export$a35de2637b105662.bytecode = $d76e119dfe2b7063$var$_bytecode;
$d76e119dfe2b7063$export$a35de2637b105662.abi = $d76e119dfe2b7063$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $f5c2499f44269420$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    }
];
const $f5c2499f44269420$var$_bytecode = "0x6080604052348015600f57600080fd5b5060405161010f38038061010f833981016040819052602c91608a565b6040516315a722b960e31b8152600481018290526001600160a01b0383169063ad3915c890602401600060405180830381600087803b158015606d57600080fd5b505af11580156080573d6000803e3d6000fd5b50505050505060c2565b60008060408385031215609c57600080fd5b82516001600160a01b038116811460b257600080fd5b6020939093015192949293505050565b603f806100d06000396000f3fe6080604052600080fdfea2646970667358221220237ff68f2012f03170d97fb09b28735389f67ff1d95f2e441d5041982818fc9764736f6c63430008130033";
const $f5c2499f44269420$var$isSuperArgs = (xs)=>xs.length > 1;
class $f5c2499f44269420$export$a75be8dc5b3e771b extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($f5c2499f44269420$var$isSuperArgs(args)) super(...args);
        else super($f5c2499f44269420$var$_abi, $f5c2499f44269420$var$_bytecode, args[0]);
    }
    deploy(host, configWord, overrides) {
        return super.deploy(host, configWord, overrides || {});
    }
    getDeployTransaction(host, configWord, overrides) {
        return super.getDeployTransaction(host, configWord, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($f5c2499f44269420$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $f5c2499f44269420$var$_abi, signerOrProvider);
    }
}
$f5c2499f44269420$export$a75be8dc5b3e771b.bytecode = $f5c2499f44269420$var$_bytecode;
$f5c2499f44269420$export$a75be8dc5b3e771b.abi = $f5c2499f44269420$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $ecf27277d078787b$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    }
];
const $ecf27277d078787b$var$_bytecode = "0x608060405234801561001057600080fd5b5060405161022f38038061022f83398101604081905261002f916100d1565b60405163bd1c448b60e01b81526001600160a01b0384169063bd1c448b9061005d90859085906004016101a8565b600060405180830381600087803b15801561007757600080fd5b505af115801561008b573d6000803e3d6000fd5b505050505050506101e2565b634e487b7160e01b600052604160045260246000fd5b60005b838110156100c85781810151838201526020016100b0565b50506000910152565b6000806000606084860312156100e657600080fd5b83516001600160a01b03811681146100fd57600080fd5b6020850151604086015191945092506001600160401b038082111561012157600080fd5b818601915086601f83011261013557600080fd5b81518181111561014757610147610097565b604051601f8201601f19908116603f0116810190838211818310171561016f5761016f610097565b8160405282815289602084870101111561018857600080fd5b6101998360208301602088016100ad565b80955050505050509250925092565b82815260406020820152600082518060408401526101cd8160608501602087016100ad565b601f01601f1916919091016060019392505050565b603f806101f06000396000f3fe6080604052600080fdfea26469706673582212201ec3435856d0aa036ac13fc39fc9f7f2c45e38e6f89ac6783597919f6a2a712664736f6c63430008130033";
const $ecf27277d078787b$var$isSuperArgs = (xs)=>xs.length > 1;
class $ecf27277d078787b$export$64e0e3c5400ad1b1 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($ecf27277d078787b$var$isSuperArgs(args)) super(...args);
        else super($ecf27277d078787b$var$_abi, $ecf27277d078787b$var$_bytecode, args[0]);
    }
    deploy(host, configWord, registrationKey, overrides) {
        return super.deploy(host, configWord, registrationKey, overrides || {});
    }
    getDeployTransaction(host, configWord, registrationKey, overrides) {
        return super.getDeployTransaction(host, configWord, registrationKey, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($ecf27277d078787b$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $ecf27277d078787b$var$_abi, signerOrProvider);
    }
}
$ecf27277d078787b$export$64e0e3c5400ad1b1.bytecode = $ecf27277d078787b$var$_bytecode;
$ecf27277d078787b$export$64e0e3c5400ad1b1.abi = $ecf27277d078787b$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $d823b5abf533ccf1$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "superTokenLogic",
                type: "address"
            },
            {
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            },
            {
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_NON_UPGRADEABLE_IS_DEPRECATED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_GOVERNANCE_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_UNINITIALIZED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "CustomSuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "SuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "tokenLogic",
                type: "address"
            }
        ],
        name: "SuperTokenLogicCreated",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT_LOGIC",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT_LOGIC",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "_SUPER_TOKEN_LOGIC",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "computeCanonicalERC20WrapperAddress",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            },
            {
                internalType: "bool",
                name: "isDeployed",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "createCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingTokenAddress",
                type: "address"
            }
        ],
        name: "getCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenLogic",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "underlyingToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    }
                ],
                internalType: "struct SuperTokenFactoryBase.InitializeData[]",
                name: "_data",
                type: "tuple[]"
            }
        ],
        name: "initializeCanonicalWrapperSuperTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "customSuperTokenProxy",
                type: "address"
            }
        ],
        name: "initializeCustomSuperToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $d823b5abf533ccf1$var$_bytecode = "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";
const $d823b5abf533ccf1$var$isSuperArgs = (xs)=>xs.length > 1;
class $d823b5abf533ccf1$export$273f4bc8ce03e6f8 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($d823b5abf533ccf1$var$isSuperArgs(args)) super(...args);
        else super($d823b5abf533ccf1$var$_abi, $d823b5abf533ccf1$var$_bytecode, args[0]);
    }
    deploy(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides) {
        return super.deploy(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides || {});
    }
    getDeployTransaction(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides) {
        return super.getDeployTransaction(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($d823b5abf533ccf1$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $d823b5abf533ccf1$var$_abi, signerOrProvider);
    }
}
$d823b5abf533ccf1$export$273f4bc8ce03e6f8.bytecode = $d823b5abf533ccf1$var$_bytecode;
$d823b5abf533ccf1$export$273f4bc8ce03e6f8.abi = $d823b5abf533ccf1$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $dde276cedb9300e3$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "superTokenLogic",
                type: "address"
            },
            {
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            },
            {
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_NON_UPGRADEABLE_IS_DEPRECATED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_GOVERNANCE_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_UNINITIALIZED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "CustomSuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "SuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "tokenLogic",
                type: "address"
            }
        ],
        name: "SuperTokenLogicCreated",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT_LOGIC",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT_LOGIC",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "_SUPER_TOKEN_LOGIC",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "computeCanonicalERC20WrapperAddress",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            },
            {
                internalType: "bool",
                name: "isDeployed",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "createCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingTokenAddress",
                type: "address"
            }
        ],
        name: "getCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenLogic",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "underlyingToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    }
                ],
                internalType: "struct SuperTokenFactoryBase.InitializeData[]",
                name: "_data",
                type: "tuple[]"
            }
        ],
        name: "initializeCanonicalWrapperSuperTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "customSuperTokenProxy",
                type: "address"
            }
        ],
        name: "initializeCustomSuperToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $dde276cedb9300e3$var$_bytecode = "0x6101006040523480156200001257600080fd5b506040516200221d3803806200221d833981016040819052620000359162000107565b6001600160a01b0380851660a052831660808190526040805163132075a760e31b81529051869286928692869291639903ad3891600480830192600092919082900301818387803b1580156200008a57600080fd5b505af19250505080156200009c575060015b506001600160a01b0380831660c05281811660e0526080516040519116907fc13fb19d60857980e565bf5dae406b8802d3c1cec50c6156b30b12b87402978390600090a250505050505050506200016f565b6001600160a01b03811681146200010457600080fd5b50565b600080600080608085870312156200011e57600080fd5b84516200012b81620000ee565b60208601519094506200013e81620000ee565b60408601519093506200015181620000ee565b60608601519092506200016481620000ee565b939692955090935050565b60805160a05160c05160e05161202e620001ef6000396000818161020601526109b40152600081816101df015261089b015260008181610158015281816107770152610c88015260008181610245015281816102c601528181610465015281816108ca015281816109e301528181610fc00152611115015261202e6000f3fe608060405234801561001057600080fd5b50600436106101215760003560e01c80638129fc1c116100ad578063bab74c8911610071578063bab74c891461028f578063cbf927b3146102c1578063d412d344146102e8578063e094be24146102fb578063eff0a89d1461030e57600080fd5b80638129fc1c1461023b5780639470a5b21461024357806397e011ed146102695780639903ad381461023b578063a6d0c5341461027c57600080fd5b806350d75d25116100f457806350d75d25146101a457806352d1902d146101ac5780635365d19f146101da5780635a7792df146102015780636c684bb01461022857600080fd5b8063151188dc1461012657806320bc442514610156578063431f14811461017c578063469519541461018f575b600080fd5b61013961013436600461151d565b61033a565b6040516001600160a01b0390911681526020015b60405180910390f35b7f0000000000000000000000000000000000000000000000000000000000000000610139565b61013961018a36600461159e565b6106ed565b6101a261019d36600461151d565b61076c565b005b610139610ac7565b6040517fb146a22bc9644a3313a7e28592f37d32718a2b618d3d136aa524b0d86b87b620815260200161014d565b6101397f000000000000000000000000000000000000000000000000000000000000000081565b6101397f000000000000000000000000000000000000000000000000000000000000000081565b610139610236366004611631565b610af6565b6101a2610b75565b7f0000000000000000000000000000000000000000000000000000000000000000610139565b6101a26102773660046116d8565b610c84565b61013961028a36600461175c565b610e93565b6102a261029d36600461151d565b610ea6565b604080516001600160a01b03909316835290151560208301520161014d565b6101397f000000000000000000000000000000000000000000000000000000000000000081565b6101a26102f636600461151d565b610fa9565b610139610309366004611802565b61105f565b61013961031c36600461151d565b6001600160a01b039081166000908152600160205260409020541690565b600080805260016020527fa6eef7e35abe7026729641147f7915573c7e97b47efa546f5f6e3230263bcb49546001600160a01b031661038c576040516306ce6e6d60e21b815260040160405180910390fd5b6001600160a01b0380831660009081526001602052604090205483911680156103c8576040516348eb3cb960e11b815260040160405180910390fd5b604080516001600160a01b038416602082015260009101604051602081830303815290604052805190602001209050600081604051610406906114ee565b8190604051809103906000f5905080158015610426573d6000803e3d6000fd5b506001600160a01b038581166000908152600160205260409081902080546001600160a01b0319168484169081179091559051634a0687ef60e01b81527f00000000000000000000000000000000000000000000000000000000000000009092166004830152919250634a0687ef90602401600060405180830381600087803b1580156104b257600080fd5b505af11580156104c6573d6000803e3d6000fd5b5050505060008190506000876001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa15801561050f573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061053391906118bb565b90506000886001600160a01b03166306fdde036040518163ffffffff1660e01b8152600401600060405180830381865afa158015610575573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261059d9190810190611912565b90506000896001600160a01b03166395d89b416040518163ffffffff1660e01b8152600401600060405180830381865afa1580156105df573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526106079190810190611912565b9050836001600160a01b03166342fe09808b858560405160200161062b91906119b4565b6040516020818303038152906040528560405160200161064b91906119e2565b6040516020818303038152906040526040518563ffffffff1660e01b81526004016106799493929190611a33565b600060405180830381600087803b15801561069357600080fd5b505af11580156106a7573d6000803e3d6000fd5b50506040516001600160a01b03871692507fb52c6d9d122e8c07769b96d7bb14e66db58ee03fdebaaa2f92547e9c7ef0e65f9150600090a2509198975050505050505050565b600061076187886001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa158015610731573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061075591906118bb565b8888888888600061105f565b979650505050505050565b336001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146107b55760405163478b8e8360e01b815260040160405180910390fd5b6107be816112b4565b60008190506000816001600160a01b0316635365d19f6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610803573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906108279190611a72565b90506000826001600160a01b0316635a7792df6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610869573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061088d9190611a72565b9050816001600160a01b03167f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316146109a8577f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663ef43d2c66040518163ffffffff1660e01b8152600401602060405180830381865afa158015610926573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061094a9190611a72565b6040516311a5465560e21b81526001600160a01b0384811660048301529190911690634695195490602401600060405180830381600087803b15801561098f57600080fd5b505af11580156109a3573d6000803e3d6000fd5b505050505b806001600160a01b03167f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031614610ac1577f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316634c5c0c856040518163ffffffff1660e01b8152600401602060405180830381865afa158015610a3f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a639190611a72565b6040516311a5465560e21b81526001600160a01b0383811660048301529190911690634695195490602401600060405180830381600087803b158015610aa857600080fd5b505af1158015610abc573d6000803e3d6000fd5b505050505b50505050565b6000610af17f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b905090565b6000610b6988896001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa158015610b3a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b5e91906118bb565b89898989898961105f565b98975050505050505050565b600054610100900460ff1615808015610b955750600054600160ff909116105b80610baf5750303b158015610baf575060005460ff166001145b610c175760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b60648201526084015b60405180910390fd5b6000805460ff191660011790558015610c3a576000805461ff0019166101001790555b8015610c81576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb3847402498906020015b60405180910390a15b50565b60007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663289b3c0d6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610ce4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d089190611a72565b9050806001600160a01b0316638da5cb5b6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610d48573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d6c9190611a72565b6001600160a01b0316336001600160a01b031614610d9d57604051632bf2a63360e21b815260040160405180910390fd5b6000805260016020527fa6eef7e35abe7026729641147f7915573c7e97b47efa546f5f6e3230263bcb49546001600160a01b031615610def576040516348eb3cb960e11b815260040160405180910390fd5b60005b82811015610ac157838382818110610e0c57610e0c611a8f565b9050604002016020016020810190610e24919061151d565b60016000868685818110610e3a57610e3a611a8f565b610e50926020604090920201908101915061151d565b6001600160a01b039081168252602082019290925260400160002080546001600160a01b0319169290911691909117905580610e8b81611aa5565b915050610df2565b6000610b6988888888888888600061105f565b6001600160a01b0380821660009081526001602052604081205490918291168015610ed75780925060019150610fa3565b600060405180602001610ee9906114ee565b601f1982820381018352601f9091011660408181526001600160a01b03881660208301529192506001600160f81b031991309101604051602081830303815290604052805190602001208380519060200120604051602001610f8294939291906001600160f81b031994909416845260609290921b6bffffffffffffffffffffffff191660018401526015830152603582015260550190565b6040516020818303038152906040528051906020012060001c935060009250505b50915091565b604051634a0687ef60e01b81526001600160a01b037f000000000000000000000000000000000000000000000000000000000000000081166004830152829190821690634a0687ef90602401600060405180830381600087803b15801561100f57600080fd5b505af1158015611023573d6000803e3d6000fd5b50506040516001600160a01b03851692507f437790724a6e97b75d23117f28cdd4b1beeafc34f7a0911ef256e9334f4369a59150600090a25050565b60006001600160a01b0389166110885760405163182e4f4160e11b815260040160405180910390fd5b600087600281111561109c5761109c611acc565b036110ba5760405163c4901a4360e01b815260040160405180910390fd5b60018760028111156110ce576110ce611acc565b036111865760006040516110e1906114ee565b604051809103906000f0801580156110fd573d6000803e3d6000fd5b50604051634a0687ef60e01b81526001600160a01b037f00000000000000000000000000000000000000000000000000000000000000008116600483015291925090821690634a0687ef90602401600060405180830381600087803b15801561116557600080fd5b505af1158015611179573d6000803e3d6000fd5b505050508091505061120a565b6000604051611194906114fb565b604051809103906000f0801580156111b0573d6000803e3d6000fd5b509050806001600160a01b0316638129fc1c6040518163ffffffff1660e01b8152600401600060405180830381600087803b1580156111ee57600080fd5b505af1158015611202573d6000803e3d6000fd5b509293505050505b60405163ec0d634360e01b81526001600160a01b0382169063ec0d634390611242908c908c908b908b908b908b908b90600401611b0b565b600060405180830381600087803b15801561125c57600080fd5b505af1158015611270573d6000803e3d6000fd5b50506040516001600160a01b03841692507fb52c6d9d122e8c07769b96d7bb14e66db58ee03fdebaaa2f92547e9c7ef0e65f9150600090a298975050505050505050565b60006112de7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b6001600160a01b0316036113345760405162461bcd60e51b815260206004820152601d60248201527f5555505350726f786961626c653a206e6f742075706772616461626c650000006044820152606401610c0e565b806001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611372573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906113969190611b62565b7fb146a22bc9644a3313a7e28592f37d32718a2b618d3d136aa524b0d86b87b620146114105760405162461bcd60e51b815260206004820152602360248201527f5555505350726f786961626c653a206e6f7420636f6d70617469626c65206c6f60448201526267696360e81b6064820152608401610c0e565b6001600160a01b03811630036114685760405162461bcd60e51b815260206004820152601960248201527f5555505350726f786961626c653a2070726f7879206c6f6f70000000000000006044820152606401610c0e565b611490817f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc55565b7fe011bc04c286c344a8fcbb8de77f953da762c3e25d8cdea984147fc4168a5dcc7fb146a22bc9644a3313a7e28592f37d32718a2b618d3d136aa524b0d86b87b620604080519182526001600160a01b038416602083015201610c78565b61024a80611b7c83390190565b61023380611dc683390190565b6001600160a01b0381168114610c8157600080fd5b60006020828403121561152f57600080fd5b813561153a81611508565b9392505050565b80356003811061155057600080fd5b919050565b60008083601f84011261156757600080fd5b50813567ffffffffffffffff81111561157f57600080fd5b60208301915083602082850101111561159757600080fd5b9250929050565b600080600080600080608087890312156115b757600080fd5b86356115c281611508565b95506115d060208801611541565b9450604087013567ffffffffffffffff808211156115ed57600080fd5b6115f98a838b01611555565b9096509450606089013591508082111561161257600080fd5b5061161f89828a01611555565b979a9699509497509295939492505050565b600080600080600080600060a0888a03121561164c57600080fd5b873561165781611508565b965061166560208901611541565b9550604088013567ffffffffffffffff8082111561168257600080fd5b61168e8b838c01611555565b909750955060608a01359150808211156116a757600080fd5b506116b48a828b01611555565b90945092505060808801356116c881611508565b8091505092959891949750929550565b600080602083850312156116eb57600080fd5b823567ffffffffffffffff8082111561170357600080fd5b818501915085601f83011261171757600080fd5b81358181111561172657600080fd5b8660208260061b850101111561173b57600080fd5b60209290920196919550909350505050565b60ff81168114610c8157600080fd5b600080600080600080600060a0888a03121561177757600080fd5b873561178281611508565b965060208801356117928161174d565b95506117a060408901611541565b9450606088013567ffffffffffffffff808211156117bd57600080fd5b6117c98b838c01611555565b909650945060808a01359150808211156117e257600080fd5b506117ef8a828b01611555565b989b979a50959850939692959293505050565b60008060008060008060008060c0898b03121561181e57600080fd5b883561182981611508565b975060208901356118398161174d565b965061184760408a01611541565b9550606089013567ffffffffffffffff8082111561186457600080fd5b6118708c838d01611555565b909750955060808b013591508082111561188957600080fd5b506118968b828c01611555565b90945092505060a08901356118aa81611508565b809150509295985092959890939650565b6000602082840312156118cd57600080fd5b815161153a8161174d565b634e487b7160e01b600052604160045260246000fd5b60005b838110156119095781810151838201526020016118f1565b50506000910152565b60006020828403121561192457600080fd5b815167ffffffffffffffff8082111561193c57600080fd5b818401915084601f83011261195057600080fd5b815181811115611962576119626118d8565b604051601f8201601f19908116603f0116810190838211818310171561198a5761198a6118d8565b816040528281528760208487010111156119a357600080fd5b6107618360208301602088016118ee565b65029bab832b9160d51b8152600082516119d58160068501602087016118ee565b9190910160060192915050565b600082516119f48184602087016118ee565b600f60fb1b920191825250600101919050565b60008151808452611a1f8160208601602086016118ee565b601f01601f19169290920160200192915050565b6001600160a01b038516815260ff84166020820152608060408201819052600090611a6090830185611a07565b82810360608401526107618185611a07565b600060208284031215611a8457600080fd5b815161153a81611508565b634e487b7160e01b600052603260045260246000fd5b600060018201611ac557634e487b7160e01b600052601160045260246000fd5b5060010190565b634e487b7160e01b600052602160045260246000fd5b81835281816020850137506000828201602090810191909152601f909101601f19169091010190565b600060018060a01b03808a16835260ff8916602084015260a06040840152611b3760a08401888a611ae2565b8381036060850152611b4a818789611ae2565b92505080841660808401525098975050505050505050565b600060208284031215611b7457600080fd5b505191905056fe608060405234801561001057600080fd5b5061022a806100206000396000f3fe6080604052600436106100225760003560e01c80634a0687ef1461003957610031565b366100315761002f610059565b005b61002f610059565b34801561004557600080fd5b5061002f6100543660046101c4565b61006b565b610069610064610171565b6101a0565b565b6001600160a01b0381166100c65760405162461bcd60e51b815260206004820152601760248201527f5555505350726f78793a207a65726f206164647265737300000000000000000060448201526064015b60405180910390fd5b60006100f07f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b6001600160a01b0316146101465760405162461bcd60e51b815260206004820152601e60248201527f5555505350726f78793a20616c726561647920696e697469616c697a6564000060448201526064016100bd565b61016e817f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc55565b50565b600061019b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b905090565b3660008037600080366000845af43d6000803e8080156101bf573d6000f35b3d6000fd5b6000602082840312156101d657600080fd5b81356001600160a01b03811681146101ed57600080fd5b939250505056fea264697066735822122093a2bbcf49dd2895177212eeb11e9921080374fd8cd93d5be93a80935603195a64736f6c63430008130033608060405234801561001057600080fd5b50610213806100206000396000f3fe6080604052600436106100225760003560e01c80638129fc1c1461003957610031565b366100315761002f61004e565b005b61002f61004e565b34801561004557600080fd5b5061002f610060565b61005e6100596100d0565b610173565b565b7fb8fcd5719b3ddf8626f3664705a89b7fc476129a58c1aa5eda57c600cc1821a0546001600160a01b038116156100aa576040516305c5d81960e01b815260040160405180910390fd5b50337fb8fcd5719b3ddf8626f3664705a89b7fc476129a58c1aa5eda57c600cc1821a055565b7fb8fcd5719b3ddf8626f3664705a89b7fc476129a58c1aa5eda57c600cc1821a0546000906001600160a01b03811661010b5761010b610197565b806001600160a01b0316639470a5b26040518163ffffffff1660e01b8152600401602060405180830381865afa158015610149573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061016d91906101ad565b91505090565b3660008037600080366000845af43d6000803e808015610192573d6000f35b3d6000fd5b634e487b7160e01b600052600160045260246000fd5b6000602082840312156101bf57600080fd5b81516001600160a01b03811681146101d657600080fd5b939250505056fea26469706673582212208aedd930463a9ef04ca914601becd18e8316234054a71d6de40ce23faac57e5064736f6c63430008130033a26469706673582212204f138a96d28f1d41cbdadb87e50a3bdf9f3df471e850dc0f9a46bc6396ee637364736f6c63430008130033";
const $dde276cedb9300e3$var$isSuperArgs = (xs)=>xs.length > 1;
class $dde276cedb9300e3$export$39f7858d3b8f07ec extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($dde276cedb9300e3$var$isSuperArgs(args)) super(...args);
        else super($dde276cedb9300e3$var$_abi, $dde276cedb9300e3$var$_bytecode, args[0]);
    }
    deploy(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides) {
        return super.deploy(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides || {});
    }
    getDeployTransaction(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides) {
        return super.getDeployTransaction(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($dde276cedb9300e3$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $dde276cedb9300e3$var$_abi, signerOrProvider);
    }
}
$dde276cedb9300e3$export$39f7858d3b8f07ec.bytecode = $dde276cedb9300e3$var$_bytecode;
$dde276cedb9300e3$export$39f7858d3b8f07ec.abi = $dde276cedb9300e3$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $8e5f2cd9396fbe8e$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "superTokenLogic",
                type: "address"
            },
            {
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            },
            {
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_NON_UPGRADEABLE_IS_DEPRECATED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_GOVERNANCE_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_UNINITIALIZED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "CustomSuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "SuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "tokenLogic",
                type: "address"
            }
        ],
        name: "SuperTokenLogicCreated",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT_LOGIC",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT_LOGIC",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "_SUPER_TOKEN_LOGIC",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "computeCanonicalERC20WrapperAddress",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            },
            {
                internalType: "bool",
                name: "isDeployed",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "createCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingTokenAddress",
                type: "address"
            }
        ],
        name: "getCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenLogic",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "underlyingToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    }
                ],
                internalType: "struct SuperTokenFactoryBase.InitializeData[]",
                name: "_data",
                type: "tuple[]"
            }
        ],
        name: "initializeCanonicalWrapperSuperTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "customSuperTokenProxy",
                type: "address"
            }
        ],
        name: "initializeCustomSuperToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "validateStorageLayout",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    }
];
const $8e5f2cd9396fbe8e$var$_bytecode = "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";
const $8e5f2cd9396fbe8e$var$isSuperArgs = (xs)=>xs.length > 1;
class $8e5f2cd9396fbe8e$export$f7811853fb3bb5a extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($8e5f2cd9396fbe8e$var$isSuperArgs(args)) super(...args);
        else super($8e5f2cd9396fbe8e$var$_abi, $8e5f2cd9396fbe8e$var$_bytecode, args[0]);
    }
    deploy(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides) {
        return super.deploy(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides || {});
    }
    getDeployTransaction(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides) {
        return super.getDeployTransaction(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($8e5f2cd9396fbe8e$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $8e5f2cd9396fbe8e$var$_abi, signerOrProvider);
    }
}
$8e5f2cd9396fbe8e$export$f7811853fb3bb5a.bytecode = $8e5f2cd9396fbe8e$var$_bytecode;
$8e5f2cd9396fbe8e$export$f7811853fb3bb5a.abi = $8e5f2cd9396fbe8e$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $ba329eeaf58dcd93$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "superTokenLogic",
                type: "address"
            },
            {
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            },
            {
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_NON_UPGRADEABLE_IS_DEPRECATED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_GOVERNANCE_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_UNINITIALIZED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "CustomSuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "SuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "tokenLogic",
                type: "address"
            }
        ],
        name: "SuperTokenLogicCreated",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT_LOGIC",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT_LOGIC",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "_SUPER_TOKEN_LOGIC",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "computeCanonicalERC20WrapperAddress",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            },
            {
                internalType: "bool",
                name: "isDeployed",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "createCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingTokenAddress",
                type: "address"
            }
        ],
        name: "getCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenLogic",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "underlyingToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    }
                ],
                internalType: "struct SuperTokenFactoryBase.InitializeData[]",
                name: "_data",
                type: "tuple[]"
            }
        ],
        name: "initializeCanonicalWrapperSuperTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "customSuperTokenProxy",
                type: "address"
            }
        ],
        name: "initializeCustomSuperToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "newVariable",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $ba329eeaf58dcd93$var$_bytecode = "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";
const $ba329eeaf58dcd93$var$isSuperArgs = (xs)=>xs.length > 1;
class $ba329eeaf58dcd93$export$1ec29e69ca76215f extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($ba329eeaf58dcd93$var$isSuperArgs(args)) super(...args);
        else super($ba329eeaf58dcd93$var$_abi, $ba329eeaf58dcd93$var$_bytecode, args[0]);
    }
    deploy(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides) {
        return super.deploy(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides || {});
    }
    getDeployTransaction(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides) {
        return super.getDeployTransaction(host, superTokenLogic, constantOutflowNFT, constantInflowNFT, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($ba329eeaf58dcd93$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $ba329eeaf58dcd93$var$_abi, signerOrProvider);
    }
}
$ba329eeaf58dcd93$export$1ec29e69ca76215f.bytecode = $ba329eeaf58dcd93$var$_bytecode;
$ba329eeaf58dcd93$export$1ec29e69ca76215f.abi = $ba329eeaf58dcd93$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $adefde405c0c88ad$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "createFlowFromTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "createFlowFromWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "createFlowTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "createFlowWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96"
            }
        ],
        name: "decreaseFlowRateAllowanceTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "permissionsToRemove",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96"
            }
        ],
        name: "decreaseFlowRateAllowanceWithPermissionsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "permissionsToRemove",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "decreaseFlowRateAllowanceWithPermissionsWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "decreaseFlowRateAllowanceWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "deleteFlowFromTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "deleteFlowFromWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "deleteFlowTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "deleteFlowWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "getBufferAmountByFlowRateTest",
        outputs: [
            {
                internalType: "uint256",
                name: "bufferAmount",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getFlowInfoTest",
        outputs: [
            {
                internalType: "uint256",
                name: "lastUpdated",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            }
        ],
        name: "getFlowPermissionsTest",
        outputs: [
            {
                internalType: "bool",
                name: "allowCreate",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "allowUpdate",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "allowDelete",
                type: "bool"
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getFlowRateTest",
        outputs: [
            {
                internalType: "int96",
                name: "rate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getNetFlowInfoTest",
        outputs: [
            {
                internalType: "uint256",
                name: "lastUpdated",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getNetFlowRateTest",
        outputs: [
            {
                internalType: "int96",
                name: "netFlowRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96"
            }
        ],
        name: "increaseFlowRateAllowanceTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "permissionsToAdd",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96"
            }
        ],
        name: "increaseFlowRateAllowanceWithPermissionsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "permissionsToAdd",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "increaseFlowRateAllowanceWithPermissionsWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "increaseFlowRateAllowanceWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "revokeFlowPermissionsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "allowCreate",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "allowUpdate",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "allowDelete",
                type: "bool"
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96"
            }
        ],
        name: "setFlowPermissionsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "setMaxFlowPermissionsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "updateFlowFromTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateFlowFromWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "updateFlowTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateFlowWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $adefde405c0c88ad$var$_bytecode = "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";
const $adefde405c0c88ad$var$isSuperArgs = (xs)=>xs.length > 1;
class $adefde405c0c88ad$export$3a4ff9a4ea8cea32 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($adefde405c0c88ad$var$isSuperArgs(args)) super(...args);
        else super($adefde405c0c88ad$var$_abi, $adefde405c0c88ad$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($adefde405c0c88ad$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $adefde405c0c88ad$var$_abi, signerOrProvider);
    }
}
$adefde405c0c88ad$export$3a4ff9a4ea8cea32.bytecode = $adefde405c0c88ad$var$_bytecode;
$adefde405c0c88ad$export$3a4ff9a4ea8cea32.abi = $adefde405c0c88ad$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $96b8edfd00db089a$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "_host",
                type: "address"
            },
            {
                internalType: "address",
                name: "defaultSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "defaultReceiver",
                type: "address"
            },
            {
                internalType: "address",
                name: "defaultFlowOperator",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "authorizeFlowOperatorWithFullControl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "createFlow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $96b8edfd00db089a$var$_bytecode = "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";
const $96b8edfd00db089a$var$isSuperArgs = (xs)=>xs.length > 1;
class $96b8edfd00db089a$export$d4230c178eaa4343 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($96b8edfd00db089a$var$isSuperArgs(args)) super(...args);
        else super($96b8edfd00db089a$var$_abi, $96b8edfd00db089a$var$_bytecode, args[0]);
    }
    deploy(_host, defaultSender, defaultReceiver, defaultFlowOperator, overrides) {
        return super.deploy(_host, defaultSender, defaultReceiver, defaultFlowOperator, overrides || {});
    }
    getDeployTransaction(_host, defaultSender, defaultReceiver, defaultFlowOperator, overrides) {
        return super.getDeployTransaction(_host, defaultSender, defaultReceiver, defaultFlowOperator, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($96b8edfd00db089a$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $96b8edfd00db089a$var$_abi, signerOrProvider);
    }
}
$96b8edfd00db089a$export$d4230c178eaa4343.bytecode = $96b8edfd00db089a$var$_bytecode;
$96b8edfd00db089a$export$d4230c178eaa4343.abi = $96b8edfd00db089a$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $d777a53b86b0aaff$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "approveSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "approveSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "calculateDistributionTest",
        outputs: [
            {
                internalType: "uint256",
                name: "actualAmount",
                type: "uint256"
            },
            {
                internalType: "uint128",
                name: "newIndexValue",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "claimTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "claimWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "createIndexTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "createIndexWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "deleteSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "deleteSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "distributeTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "distributeWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "getIndexTest",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsApproved",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsPending",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            }
        ],
        name: "getSubscriptionByIDTest",
        outputs: [
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "getSubscriptionTest",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "listSubscriptionsTest",
        outputs: [
            {
                internalType: "address[]",
                name: "publishers",
                type: "address[]"
            },
            {
                internalType: "uint32[]",
                name: "indexIds",
                type: "uint32[]"
            },
            {
                internalType: "uint128[]",
                name: "unitsList",
                type: "uint128[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "revokeSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "revokeSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            }
        ],
        name: "updateIndexValueTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateIndexValueWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            }
        ],
        name: "updateSubscriptionUnitsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateSubscriptionUnitsWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $d777a53b86b0aaff$var$_bytecode = "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";
const $d777a53b86b0aaff$var$isSuperArgs = (xs)=>xs.length > 1;
class $d777a53b86b0aaff$export$d7a7ae0b2cdeeec2 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($d777a53b86b0aaff$var$isSuperArgs(args)) super(...args);
        else super($d777a53b86b0aaff$var$_abi, $d777a53b86b0aaff$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($d777a53b86b0aaff$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $d777a53b86b0aaff$var$_abi, signerOrProvider);
    }
}
$d777a53b86b0aaff$export$d7a7ae0b2cdeeec2.bytecode = $d777a53b86b0aaff$var$_bytecode;
$d777a53b86b0aaff$export$d7a7ae0b2cdeeec2.abi = $d777a53b86b0aaff$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $5c89d0c16ea105df$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "_host",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "approveSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "approveSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "calculateDistributionTest",
        outputs: [
            {
                internalType: "uint256",
                name: "actualAmount",
                type: "uint256"
            },
            {
                internalType: "uint128",
                name: "newIndexValue",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "claimTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "claimWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "createIndexTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "createIndexWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "deleteSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "deleteSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "distributeTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "distributeWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "getIndexTest",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsApproved",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsPending",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            }
        ],
        name: "getSubscriptionByIDTest",
        outputs: [
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "getSubscriptionTest",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "listSubscriptionsTest",
        outputs: [
            {
                internalType: "address[]",
                name: "publishers",
                type: "address[]"
            },
            {
                internalType: "uint32[]",
                name: "indexIds",
                type: "uint32[]"
            },
            {
                internalType: "uint128[]",
                name: "unitsList",
                type: "uint128[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "revokeSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "revokeSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            }
        ],
        name: "updateIndexValueTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateIndexValueWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            }
        ],
        name: "updateSubscriptionUnitsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateSubscriptionUnitsWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $5c89d0c16ea105df$var$_bytecode = "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";
const $5c89d0c16ea105df$var$isSuperArgs = (xs)=>xs.length > 1;
class $5c89d0c16ea105df$export$d57bed15ab650312 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($5c89d0c16ea105df$var$isSuperArgs(args)) super(...args);
        else super($5c89d0c16ea105df$var$_abi, $5c89d0c16ea105df$var$_bytecode, args[0]);
    }
    deploy(_host, overrides) {
        return super.deploy(_host, overrides || {});
    }
    getDeployTransaction(_host, overrides) {
        return super.getDeployTransaction(_host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($5c89d0c16ea105df$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $5c89d0c16ea105df$var$_abi, signerOrProvider);
    }
}
$5c89d0c16ea105df$export$d57bed15ab650312.bytecode = $5c89d0c16ea105df$var$_bytecode;
$5c89d0c16ea105df$export$d57bed15ab650312.abi = $5c89d0c16ea105df$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $2681473716dd7eda$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "w",
                type: "uint256"
            },
            {
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFTProxy",
                type: "address"
            },
            {
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFTProxy",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_BURN_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_MOVE_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_BURN_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_CALLER_IS_NOT_OPERATOR_FOR_HOLDER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_INFLATIONARY_DEFLATIONARY_NOT_SUPPORTED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_MINT_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NFT_PROXY_ADDRESS_CHANGED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NOT_ERC777_TOKENS_RECIPIENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NO_UNDERLYING_TOKEN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_ADMIN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_GOV_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_SELF",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldAdmin",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "AdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "bondAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidatedBy",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAmountReceiver",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            }
        ],
        name: "AgreementLiquidatedV2",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            }
        ],
        name: "AgreementStateUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            }
        ],
        name: "AgreementTerminated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "AuthorizedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bailoutAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "Bailout",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Burned",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        name: "ConstantInflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            }
        ],
        name: "ConstantOutflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Minted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "RevokedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Sent",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenDowngraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenUpgraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "approveInternal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "authorizeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "createAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "defaultOperators",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountActiveAgreements",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementData",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementStateSlot",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingDecimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "granularity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "initializeWithAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountCritical",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountCriticalNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountSolvent",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountSolventNow",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "isOperatorFor",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            },
            {
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool"
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            }
        ],
        name: "makeLiquidationPayoutsV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "mintInternal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationApprove",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "operationDecreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationDowngrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "operationIncreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "operationSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationUpgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "revokeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfApproveFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256"
            }
        ],
        name: "settleBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "operators",
                type: "address[]"
            }
        ],
        name: "setupDefaultOperators",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "terminateAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "toUnderlyingAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "underlyingAmount",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "adjustedAmount",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            }
        ],
        name: "transferAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "transferInternal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementStateSlot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "waterMark",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $2681473716dd7eda$var$_bytecode = "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";
const $2681473716dd7eda$var$isSuperArgs = (xs)=>xs.length > 1;
class $2681473716dd7eda$export$c28bb7278b89e7bd extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($2681473716dd7eda$var$isSuperArgs(args)) super(...args);
        else super($2681473716dd7eda$var$_abi, $2681473716dd7eda$var$_bytecode, args[0]);
    }
    deploy(host, w, constantOutflowNFTProxy, constantInflowNFTProxy, overrides) {
        return super.deploy(host, w, constantOutflowNFTProxy, constantInflowNFTProxy, overrides || {});
    }
    getDeployTransaction(host, w, constantOutflowNFTProxy, constantInflowNFTProxy, overrides) {
        return super.getDeployTransaction(host, w, constantOutflowNFTProxy, constantInflowNFTProxy, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($2681473716dd7eda$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $2681473716dd7eda$var$_abi, signerOrProvider);
    }
}
$2681473716dd7eda$export$c28bb7278b89e7bd.bytecode = $2681473716dd7eda$var$_bytecode;
$2681473716dd7eda$export$c28bb7278b89e7bd.abi = $2681473716dd7eda$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $2c2f6f914a567dca$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFTProxy",
                type: "address"
            },
            {
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFTProxy",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_BURN_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_MOVE_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_BURN_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_CALLER_IS_NOT_OPERATOR_FOR_HOLDER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_INFLATIONARY_DEFLATIONARY_NOT_SUPPORTED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_MINT_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NFT_PROXY_ADDRESS_CHANGED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NOT_ERC777_TOKENS_RECIPIENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NO_UNDERLYING_TOKEN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_ADMIN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_GOV_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_SELF",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldAdmin",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "AdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "bondAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidatedBy",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAmountReceiver",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            }
        ],
        name: "AgreementLiquidatedV2",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            }
        ],
        name: "AgreementStateUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            }
        ],
        name: "AgreementTerminated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "AuthorizedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bailoutAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "Bailout",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Burned",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        name: "ConstantInflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            }
        ],
        name: "ConstantOutflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Minted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "RevokedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Sent",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenDowngraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenUpgraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "authorizeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "createAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "defaultOperators",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountActiveAgreements",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementData",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementStateSlot",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getLastSuperTokenStorageSlot",
        outputs: [
            {
                internalType: "uint256",
                name: "slot",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingDecimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "granularity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "initializeWithAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountCritical",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountCriticalNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountSolvent",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountSolventNow",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "isOperatorFor",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            },
            {
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool"
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            }
        ],
        name: "makeLiquidationPayoutsV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationApprove",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "operationDecreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationDowngrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "operationIncreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "operationSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationUpgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "revokeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfApproveFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256"
            }
        ],
        name: "settleBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "terminateAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "toUnderlyingAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "underlyingAmount",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "adjustedAmount",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            }
        ],
        name: "transferAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementStateSlot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "validateStorageLayout",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    }
];
const $2c2f6f914a567dca$var$_bytecode = "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";
const $2c2f6f914a567dca$var$isSuperArgs = (xs)=>xs.length > 1;
class $2c2f6f914a567dca$export$3ac2a165ff3a9b5a extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($2c2f6f914a567dca$var$isSuperArgs(args)) super(...args);
        else super($2c2f6f914a567dca$var$_abi, $2c2f6f914a567dca$var$_bytecode, args[0]);
    }
    deploy(host, constantOutflowNFTProxy, constantInflowNFTProxy, overrides) {
        return super.deploy(host, constantOutflowNFTProxy, constantInflowNFTProxy, overrides || {});
    }
    getDeployTransaction(host, constantOutflowNFTProxy, constantInflowNFTProxy, overrides) {
        return super.getDeployTransaction(host, constantOutflowNFTProxy, constantInflowNFTProxy, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($2c2f6f914a567dca$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $2c2f6f914a567dca$var$_abi, signerOrProvider);
    }
}
$2c2f6f914a567dca$export$3ac2a165ff3a9b5a.bytecode = $2c2f6f914a567dca$var$_bytecode;
$2c2f6f914a567dca$export$3ac2a165ff3a9b5a.abi = $2c2f6f914a567dca$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $5c9b3f7652135eee$var$_abi = [
    {
        inputs: [],
        name: "SF_GOV_II_ONLY_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_GOV_INVALID_LIQUIDATION_OR_PATRICIAN_PERIOD",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_GOV_MUST_BE_CONTRACT",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "factory",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "authorized",
                type: "bool"
            }
        ],
        name: "AppFactoryAuthorizationChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                indexed: false,
                internalType: "string",
                name: "appRegistrationKey",
                type: "string"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "expirationTs",
                type: "uint256"
            }
        ],
        name: "AppRegistrationKeyChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            }
        ],
        name: "CFAv1LiquidationPeriodChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "ConfigChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "OwnershipTransferred",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            }
        ],
        name: "PPPConfigurationChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAddress",
                type: "address"
            }
        ],
        name: "RewardAddressChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "minimumDeposit",
                type: "uint256"
            }
        ],
        name: "SuperTokenMinimumDepositChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "address",
                name: "forwarder",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool"
            }
        ],
        name: "TrustedForwarderChanged",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "factory",
                type: "address"
            }
        ],
        name: "authorizeAppFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "token",
                type: "address[]"
            },
            {
                internalType: "address[]",
                name: "newAdmins",
                type: "address[]"
            }
        ],
        name: "batchChangeSuperTokenAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            }
        ],
        name: "batchUpdateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            },
            {
                internalType: "address[]",
                name: "tokenLogics",
                type: "address[]"
            }
        ],
        name: "batchUpdateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            },
            {
                internalType: "uint256[]",
                name: "minimumDeposits",
                type: "uint256[]"
            }
        ],
        name: "batchUpdateSuperTokenMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeSuperTokenAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        name: "clearAppRegistrationKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "clearConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "clearPPPConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "clearRewardAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "clearSuperTokenMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "disableTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "enableTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "getConfigAsAddress",
        outputs: [
            {
                internalType: "address",
                name: "value",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "getConfigAsUint256",
        outputs: [
            {
                internalType: "uint256",
                name: "period",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "getPPPConfig",
        outputs: [
            {
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "getRewardAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "getSuperTokenMinimumDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "factory",
                type: "address"
            }
        ],
        name: "isAuthorizedAppFactory",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "isTrustedForwarder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            }
        ],
        name: "registerAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "newGov",
                type: "address"
            }
        ],
        name: "replaceGovernance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "expirationTs",
                type: "uint256"
            }
        ],
        name: "setAppRegistrationKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "value",
                type: "address"
            }
        ],
        name: "setConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "setConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            }
        ],
        name: "setPPPConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "rewardAddress",
                type: "address"
            }
        ],
        name: "setRewardAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "setSuperTokenMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "factory",
                type: "address"
            }
        ],
        name: "unauthorizeAppFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "hostNewLogic",
                type: "address"
            },
            {
                internalType: "address[]",
                name: "agreementClassNewLogics",
                type: "address[]"
            },
            {
                internalType: "address",
                name: "superTokenFactoryNewLogic",
                type: "address"
            }
        ],
        name: "updateContracts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "validateStorageLayout",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        name: "verifyAppRegistrationKey",
        outputs: [
            {
                internalType: "bool",
                name: "validNow",
                type: "bool"
            },
            {
                internalType: "uint256",
                name: "expirationTs",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $5c9b3f7652135eee$var$_bytecode = "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";
const $5c9b3f7652135eee$var$isSuperArgs = (xs)=>xs.length > 1;
class $5c9b3f7652135eee$export$51662c31e9cd494b extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($5c9b3f7652135eee$var$isSuperArgs(args)) super(...args);
        else super($5c9b3f7652135eee$var$_abi, $5c9b3f7652135eee$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($5c9b3f7652135eee$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $5c9b3f7652135eee$var$_abi, signerOrProvider);
    }
}
$5c9b3f7652135eee$export$51662c31e9cd494b.bytecode = $5c9b3f7652135eee$var$_bytecode;
$5c9b3f7652135eee$export$51662c31e9cd494b.abi = $5c9b3f7652135eee$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $092b45f28aa8dc04$var$_abi = [
    {
        inputs: [
            {
                internalType: "bool",
                name: "nonUpgradable",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "appWhiteListingEnabled",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_code",
                type: "uint256"
            }
        ],
        name: "APP_RULE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_ALREADY_REGISTERED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_CALLBACK_IS_NOT_ACTION",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_IS_NOT_REGISTERED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_CALL_AGREEMENT_WITH_CTX_FROM_WRONG_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_CALL_APP_ACTION_WITH_CTX_FROM_WRONG_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_CANNOT_DOWNGRADE_TO_NON_UPGRADEABLE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_INVALID_CONFIG_WORD",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_MAX_256_AGREEMENTS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_MUST_BE_CONTRACT",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NEED_MORE_GAS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NON_UPGRADEABLE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NON_ZERO_LENGTH_PLACEHOLDER_CTX",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NOT_A_SUPER_APP",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NO_APP_REGISTRATION_PERMISSION",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_ONLY_GOVERNANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_RECEIVER_IS_NOT_SUPER_APP",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SENDER_IS_NOT_SUPER_APP",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SOURCE_APP_NEEDS_HIGHER_APP_LEVEL",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SUPER_APP_ALREADY_REGISTERED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SUPER_APP_IS_JAILED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_UNKNOWN_BATCH_CALL_OPERATION_TYPE",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address"
            }
        ],
        name: "AgreementClassRegistered",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address"
            }
        ],
        name: "AgreementClassUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "AppRegistered",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ISuperfluidGovernance",
                name: "oldGov",
                type: "address"
            },
            {
                indexed: false,
                internalType: "contract ISuperfluidGovernance",
                name: "newGov",
                type: "address"
            }
        ],
        name: "GovernanceReplaced",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reason",
                type: "uint256"
            }
        ],
        name: "Jail",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ISuperTokenFactory",
                name: "newFactory",
                type: "address"
            }
        ],
        name: "SuperTokenFactoryUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address"
            }
        ],
        name: "SuperTokenLogicUpdated",
        type: "event"
    },
    {
        inputs: [],
        name: "APP_WHITE_LISTING_ENABLED",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CALLBACK_GAS_LIMIT",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "MAX_APP_CALLBACK_LEVEL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "MAX_NUM_AGREEMENTS",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "NON_UPGRADABLE_DEPLOYMENT",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256"
            },
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "addToAgreementClassesBitmap",
        outputs: [
            {
                internalType: "uint256",
                name: "newBitmap",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "targetApp",
                type: "address"
            }
        ],
        name: "allowCompositeApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "int256",
                name: "appCreditUsedDelta",
                type: "int256"
            }
        ],
        name: "appCallbackPop",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "appCreditGranted",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "appCreditUsed",
                type: "int256"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "appCreditToken",
                type: "address"
            }
        ],
        name: "appCallbackPush",
        outputs: [
            {
                internalType: "bytes",
                name: "appCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "operationType",
                        type: "uint32"
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address"
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes"
                    }
                ],
                internalType: "struct ISuperfluid.Operation[]",
                name: "operations",
                type: "tuple[]"
            }
        ],
        name: "batchCall",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "callAgreement",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAgreementWithContext",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            }
        ],
        name: "callAppAction",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppActionWithContext",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bool",
                name: "isTermination",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppAfterCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bool",
                name: "isTermination",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppBeforeCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeSuperTokenAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "n",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "ctxFunc1",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "ctxFunc2",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "int256",
                name: "appCreditUsedMore",
                type: "int256"
            }
        ],
        name: "ctxUseCredit",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "decodeCtx",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "appCallbackLevel",
                        type: "uint8"
                    },
                    {
                        internalType: "uint8",
                        name: "callType",
                        type: "uint8"
                    },
                    {
                        internalType: "uint256",
                        name: "timestamp",
                        type: "uint256"
                    },
                    {
                        internalType: "address",
                        name: "msgSender",
                        type: "address"
                    },
                    {
                        internalType: "bytes4",
                        name: "agreementSelector",
                        type: "bytes4"
                    },
                    {
                        internalType: "bytes",
                        name: "userData",
                        type: "bytes"
                    },
                    {
                        internalType: "uint256",
                        name: "appCreditGranted",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "appCreditWantedDeprecated",
                        type: "uint256"
                    },
                    {
                        internalType: "int256",
                        name: "appCreditUsed",
                        type: "int256"
                    },
                    {
                        internalType: "address",
                        name: "appAddress",
                        type: "address"
                    },
                    {
                        internalType: "contract ISuperfluidToken",
                        name: "appCreditToken",
                        type: "address"
                    }
                ],
                internalType: "struct ISuperfluid.Context",
                name: "context",
                type: "tuple"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "operationType",
                        type: "uint32"
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address"
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes"
                    }
                ],
                internalType: "struct ISuperfluid.Operation[]",
                name: "operations",
                type: "tuple[]"
            }
        ],
        name: "forwardBatchCall",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "getAgreementClass",
        outputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "appAddr",
                type: "address"
            }
        ],
        name: "getAppCallbackLevel",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "getAppManifest",
        outputs: [
            {
                internalType: "bool",
                name: "isSuperApp",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "isJailed",
                type: "bool"
            },
            {
                internalType: "uint256",
                name: "noopMask",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getGovernance",
        outputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getNow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenFactory",
        outputs: [
            {
                internalType: "contract ISuperTokenFactory",
                name: "factory",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenFactoryLogic",
        outputs: [
            {
                internalType: "address",
                name: "logic",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "gov",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            }
        ],
        name: "isAgreementClassListed",
        outputs: [
            {
                internalType: "bool",
                name: "yes",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "isAgreementTypeListed",
        outputs: [
            {
                internalType: "bool",
                name: "yes",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "isApp",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "isAppJailed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "contract ISuperApp",
                name: "targetApp",
                type: "address"
            }
        ],
        name: "isCompositeAppAllowed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "isCtxValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "isTrustedForwarder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "jailApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "reason",
                type: "uint256"
            }
        ],
        name: "jailApp",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256"
            }
        ],
        name: "mapAgreementClasses",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "agreementClasses",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClassLogic",
                type: "address"
            }
        ],
        name: "registerAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerAppByFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        name: "registerAppWithKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256"
            },
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "removeFromAgreementClassesBitmap",
        outputs: [
            {
                internalType: "uint256",
                name: "newBitmap",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "newGov",
                type: "address"
            }
        ],
        name: "replaceGovernance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "dataWithPlaceHolderCtx",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "testCtxFuncX",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClassLogic",
                type: "address"
            }
        ],
        name: "updateAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperTokenFactory",
                name: "newFactory",
                type: "address"
            }
        ],
        name: "updateSuperTokenFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "newLogicOverride",
                type: "address"
            }
        ],
        name: "updateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "versionRecipient",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "pure",
        type: "function"
    }
];
const $092b45f28aa8dc04$var$_bytecode = "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";
const $092b45f28aa8dc04$var$isSuperArgs = (xs)=>xs.length > 1;
class $092b45f28aa8dc04$export$4745d0174dab5deb extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($092b45f28aa8dc04$var$isSuperArgs(args)) super(...args);
        else super($092b45f28aa8dc04$var$_abi, $092b45f28aa8dc04$var$_bytecode, args[0]);
    }
    deploy(nonUpgradable, appWhiteListingEnabled, overrides) {
        return super.deploy(nonUpgradable, appWhiteListingEnabled, overrides || {});
    }
    getDeployTransaction(nonUpgradable, appWhiteListingEnabled, overrides) {
        return super.getDeployTransaction(nonUpgradable, appWhiteListingEnabled, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($092b45f28aa8dc04$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $092b45f28aa8dc04$var$_abi, signerOrProvider);
    }
}
$092b45f28aa8dc04$export$4745d0174dab5deb.bytecode = $092b45f28aa8dc04$var$_bytecode;
$092b45f28aa8dc04$export$4745d0174dab5deb.abi = $092b45f28aa8dc04$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $c5ec9f17f720808b$var$_abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_code",
                type: "uint256"
            }
        ],
        name: "APP_RULE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_ALREADY_REGISTERED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_CALLBACK_IS_NOT_ACTION",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_IS_NOT_REGISTERED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_CALL_AGREEMENT_WITH_CTX_FROM_WRONG_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_CALL_APP_ACTION_WITH_CTX_FROM_WRONG_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_CANNOT_DOWNGRADE_TO_NON_UPGRADEABLE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_INVALID_CONFIG_WORD",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_MAX_256_AGREEMENTS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_MUST_BE_CONTRACT",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NEED_MORE_GAS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NON_UPGRADEABLE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NON_ZERO_LENGTH_PLACEHOLDER_CTX",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NOT_A_SUPER_APP",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NO_APP_REGISTRATION_PERMISSION",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_ONLY_GOVERNANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_RECEIVER_IS_NOT_SUPER_APP",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SENDER_IS_NOT_SUPER_APP",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SOURCE_APP_NEEDS_HIGHER_APP_LEVEL",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SUPER_APP_ALREADY_REGISTERED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SUPER_APP_IS_JAILED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_UNKNOWN_BATCH_CALL_OPERATION_TYPE",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address"
            }
        ],
        name: "AgreementClassRegistered",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address"
            }
        ],
        name: "AgreementClassUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "AppRegistered",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ISuperfluidGovernance",
                name: "oldGov",
                type: "address"
            },
            {
                indexed: false,
                internalType: "contract ISuperfluidGovernance",
                name: "newGov",
                type: "address"
            }
        ],
        name: "GovernanceReplaced",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reason",
                type: "uint256"
            }
        ],
        name: "Jail",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ISuperTokenFactory",
                name: "newFactory",
                type: "address"
            }
        ],
        name: "SuperTokenFactoryUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address"
            }
        ],
        name: "SuperTokenLogicUpdated",
        type: "event"
    },
    {
        inputs: [],
        name: "APP_WHITE_LISTING_ENABLED",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CALLBACK_GAS_LIMIT",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "MAX_APP_CALLBACK_LEVEL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "MAX_NUM_AGREEMENTS",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "NON_UPGRADABLE_DEPLOYMENT",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256"
            },
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "addToAgreementClassesBitmap",
        outputs: [
            {
                internalType: "uint256",
                name: "newBitmap",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "targetApp",
                type: "address"
            }
        ],
        name: "allowCompositeApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "int256",
                name: "appCreditUsedDelta",
                type: "int256"
            }
        ],
        name: "appCallbackPop",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "appCreditGranted",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "appCreditUsed",
                type: "int256"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "appCreditToken",
                type: "address"
            }
        ],
        name: "appCallbackPush",
        outputs: [
            {
                internalType: "bytes",
                name: "appCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "operationType",
                        type: "uint32"
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address"
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes"
                    }
                ],
                internalType: "struct ISuperfluid.Operation[]",
                name: "operations",
                type: "tuple[]"
            }
        ],
        name: "batchCall",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "callAgreement",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAgreementWithContext",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            }
        ],
        name: "callAppAction",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppActionWithContext",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bool",
                name: "isTermination",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppAfterCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bool",
                name: "isTermination",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppBeforeCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeSuperTokenAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "int256",
                name: "appCreditUsedMore",
                type: "int256"
            }
        ],
        name: "ctxUseCredit",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "decodeCtx",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "appCallbackLevel",
                        type: "uint8"
                    },
                    {
                        internalType: "uint8",
                        name: "callType",
                        type: "uint8"
                    },
                    {
                        internalType: "uint256",
                        name: "timestamp",
                        type: "uint256"
                    },
                    {
                        internalType: "address",
                        name: "msgSender",
                        type: "address"
                    },
                    {
                        internalType: "bytes4",
                        name: "agreementSelector",
                        type: "bytes4"
                    },
                    {
                        internalType: "bytes",
                        name: "userData",
                        type: "bytes"
                    },
                    {
                        internalType: "uint256",
                        name: "appCreditGranted",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "appCreditWantedDeprecated",
                        type: "uint256"
                    },
                    {
                        internalType: "int256",
                        name: "appCreditUsed",
                        type: "int256"
                    },
                    {
                        internalType: "address",
                        name: "appAddress",
                        type: "address"
                    },
                    {
                        internalType: "contract ISuperfluidToken",
                        name: "appCreditToken",
                        type: "address"
                    }
                ],
                internalType: "struct ISuperfluid.Context",
                name: "context",
                type: "tuple"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "operationType",
                        type: "uint32"
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address"
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes"
                    }
                ],
                internalType: "struct ISuperfluid.Operation[]",
                name: "operations",
                type: "tuple[]"
            }
        ],
        name: "forwardBatchCall",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "getAgreementClass",
        outputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "appAddr",
                type: "address"
            }
        ],
        name: "getAppCallbackLevel",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "getAppManifest",
        outputs: [
            {
                internalType: "bool",
                name: "isSuperApp",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "isJailed",
                type: "bool"
            },
            {
                internalType: "uint256",
                name: "noopMask",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getGovernance",
        outputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getNow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenFactory",
        outputs: [
            {
                internalType: "contract ISuperTokenFactory",
                name: "factory",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenFactoryLogic",
        outputs: [
            {
                internalType: "address",
                name: "logic",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "gov",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            }
        ],
        name: "isAgreementClassListed",
        outputs: [
            {
                internalType: "bool",
                name: "yes",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "isAgreementTypeListed",
        outputs: [
            {
                internalType: "bool",
                name: "yes",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "isApp",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "isAppJailed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "contract ISuperApp",
                name: "targetApp",
                type: "address"
            }
        ],
        name: "isCompositeAppAllowed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "isCtxValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "isTrustedForwarder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "reason",
                type: "uint256"
            }
        ],
        name: "jailApp",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256"
            }
        ],
        name: "mapAgreementClasses",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "agreementClasses",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClassLogic",
                type: "address"
            }
        ],
        name: "registerAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerAppByFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        name: "registerAppWithKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256"
            },
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "removeFromAgreementClassesBitmap",
        outputs: [
            {
                internalType: "uint256",
                name: "newBitmap",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "newGov",
                type: "address"
            }
        ],
        name: "replaceGovernance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClassLogic",
                type: "address"
            }
        ],
        name: "updateAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperTokenFactory",
                name: "newFactory",
                type: "address"
            }
        ],
        name: "updateSuperTokenFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "newLogicOverride",
                type: "address"
            }
        ],
        name: "updateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "validateContextStructLayout",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "validateStorageLayout",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "versionRecipient",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "pure",
        type: "function"
    }
];
const $c5ec9f17f720808b$var$_bytecode = "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";
const $c5ec9f17f720808b$var$isSuperArgs = (xs)=>xs.length > 1;
class $c5ec9f17f720808b$export$b72c64679b15c79e extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($c5ec9f17f720808b$var$isSuperArgs(args)) super(...args);
        else super($c5ec9f17f720808b$var$_abi, $c5ec9f17f720808b$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($c5ec9f17f720808b$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $c5ec9f17f720808b$var$_abi, signerOrProvider);
    }
}
$c5ec9f17f720808b$export$b72c64679b15c79e.bytecode = $c5ec9f17f720808b$var$_bytecode;
$c5ec9f17f720808b$export$b72c64679b15c79e.abi = $c5ec9f17f720808b$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $d5cfa78f2ba3c077$var$_abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "t",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "v",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "AGREEMENT_BASE_ONLY_HOST",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "appLevel",
                type: "uint8"
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "callType",
                type: "uint8"
            },
            {
                indexed: false,
                internalType: "bytes4",
                name: "agreementSelector",
                type: "bytes4"
            }
        ],
        name: "AppAfterCallbackResult",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "appLevel",
                type: "uint8"
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "callType",
                type: "uint8"
            },
            {
                indexed: false,
                internalType: "bytes4",
                name: "agreementSelector",
                type: "bytes4"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            }
        ],
        name: "AppBeforeCallbackResult",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "ping",
                type: "uint256"
            }
        ],
        name: "Pong",
        type: "event"
    },
    {
        inputs: [],
        name: "agreementType",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppAfterAgreementCreatedCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppAfterAgreementTerminatedCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppAfterAgreementUpdatedCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppBeforeAgreementCreatedCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppBeforeAgreementTerminatedCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppBeforeAgreementUpdatedCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "createAgreementFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "reason",
                type: "string"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "doRevert",
        outputs: [],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool"
            },
            {
                internalType: "address",
                name: "liquidator",
                type: "address"
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            }
        ],
        name: "makeLiquidationPayoutsFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "expectedMsgSender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "ping",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "pingMe",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "dynamicBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "int256",
                name: "dynamicBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        name: "setRealtimeBalanceFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256"
            }
        ],
        name: "settleBalanceFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "terminateAgreementFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "tryAppCallbackPop",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperApp",
                name: "appMock",
                type: "address"
            },
            {
                internalType: "bool",
                name: "hackCtx",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "tryAppCallbackPush",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperApp",
                name: "appMock",
                type: "address"
            },
            {
                internalType: "bool",
                name: "hackCtx",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "tryCallAppAfterCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperApp",
                name: "appMock",
                type: "address"
            },
            {
                internalType: "bool",
                name: "hackCtx",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "tryCallAppBeforeCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "bool",
                name: "hackCtx",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "tryCtxUseCredit",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperApp",
                name: "appMock",
                type: "address"
            },
            {
                internalType: "bool",
                name: "hackCtx",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "tryJailApp",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementDataFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementStateSlotFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $d5cfa78f2ba3c077$var$_bytecode = "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";
const $d5cfa78f2ba3c077$var$isSuperArgs = (xs)=>xs.length > 1;
class $d5cfa78f2ba3c077$export$e6b5ef6540e32dc0 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($d5cfa78f2ba3c077$var$isSuperArgs(args)) super(...args);
        else super($d5cfa78f2ba3c077$var$_abi, $d5cfa78f2ba3c077$var$_bytecode, args[0]);
    }
    deploy(host, t, v, overrides) {
        return super.deploy(host, t, v, overrides || {});
    }
    getDeployTransaction(host, t, v, overrides) {
        return super.getDeployTransaction(host, t, v, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($d5cfa78f2ba3c077$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $d5cfa78f2ba3c077$var$_abi, signerOrProvider);
    }
}
$d5cfa78f2ba3c077$export$e6b5ef6540e32dc0.bytecode = $d5cfa78f2ba3c077$var$_bytecode;
$d5cfa78f2ba3c077$export$e6b5ef6540e32dc0.abi = $d5cfa78f2ba3c077$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $120e31257975ea30$var$_abi = [
    {
        inputs: [],
        name: "Custom",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        name: "CustomVal",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        name: "a",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "revertArrayAccess",
        outputs: [],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "revertAssert",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "revertBigArray",
        outputs: [
            {
                internalType: "uint8[]",
                name: "",
                type: "uint8[]"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "revertCustom",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "revertCustomVal",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "revertDivByZero",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "revertEmpty",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "revertEnum",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "revertOverflow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "revertPop",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "revertString",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "funcSig",
                type: "string"
            }
        ],
        name: "revertTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "revertZeroInitializedFunctionPointer",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    }
];
const $120e31257975ea30$var$_bytecode = "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";
const $120e31257975ea30$var$isSuperArgs = (xs)=>xs.length > 1;
class $120e31257975ea30$export$f0fe058a648b6f3e extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($120e31257975ea30$var$isSuperArgs(args)) super(...args);
        else super($120e31257975ea30$var$_abi, $120e31257975ea30$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($120e31257975ea30$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $120e31257975ea30$var$_abi, signerOrProvider);
    }
}
$120e31257975ea30$export$f0fe058a648b6f3e.bytecode = $120e31257975ea30$var$_bytecode;
$120e31257975ea30$export$f0fe058a648b6f3e.abi = $120e31257975ea30$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $04084f8eea02359b$var$_abi = [
    {
        inputs: [],
        name: "testIsValidAbiEncodedBytes",
        outputs: [],
        stateMutability: "pure",
        type: "function"
    }
];
const $04084f8eea02359b$var$_bytecode = "0x608060405234801561001057600080fd5b5061034a806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063ba89c9eb14610030575b600080fd5b61003861003a565b005b604080516001602082015260029181019190915260036060820152610071906080015b6040516020818303038152906040526101d1565b156100ae5760405162461bcd60e51b8152602060048201526008602482015267626164206461746160c01b60448201526064015b60405180910390fd5b6100ef60005b6040519080825280601f01601f1916602001820160405280156100de576020820181803683370190505b5060405160200161005d9190610264565b61011f5760405162461bcd60e51b81526020600482015260016024820152600360fc1b60448201526064016100a5565b61012960016100b4565b6101595760405162461bcd60e51b81526020600482015260016024820152603160f81b60448201526064016100a5565b61016360206100b4565b6101945760405162461bcd60e51b8152602060048201526002602482015261199960f11b60448201526064016100a5565b61019e60216100b4565b6101cf5760405162461bcd60e51b8152602060048201526002602482015261333360f01b60448201526064016100a5565b565b60006040825110156101e557506000919050565b6020828101519060009082146101ff575060009392505050565b50604083015161020e81610225565b6102199060406102c8565b84511492505050919050565b60008082601f161161023857600061023b565b60015b60ff166102496020846102db565b61025391906102c8565b61025e9060206102fd565b92915050565b600060208083528351808285015260005b8181101561029157858101830151858201604001528201610275565b506000604082860101526040601f19601f8301168501019250505092915050565b634e487b7160e01b600052601160045260246000fd5b8082018082111561025e5761025e6102b2565b6000826102f857634e487b7160e01b600052601260045260246000fd5b500490565b808202811582820484141761025e5761025e6102b256fea2646970667358221220a2c6922265b8f1de12deb5223703f02499897fc1ea252d88c05a9bb5bdddfec264736f6c63430008130033";
const $04084f8eea02359b$var$isSuperArgs = (xs)=>xs.length > 1;
class $04084f8eea02359b$export$a36c851f5135754 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($04084f8eea02359b$var$isSuperArgs(args)) super(...args);
        else super($04084f8eea02359b$var$_abi, $04084f8eea02359b$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($04084f8eea02359b$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $04084f8eea02359b$var$_abi, signerOrProvider);
    }
}
$04084f8eea02359b$export$a36c851f5135754.bytecode = $04084f8eea02359b$var$_bytecode;
$04084f8eea02359b$export$a36c851f5135754.abi = $04084f8eea02359b$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $497a8a2d26541cf7$var$_abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "agreement",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            }
        ],
        name: "callAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $497a8a2d26541cf7$var$_bytecode = "0x608060405234801561001057600080fd5b50610314806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c806361d164d314610030575b600080fd5b61004361003e3660046101d9565b610045565b005b60006060846001600160a01b0316848460405161006392919061026a565b6000604051808303816000865af19150503d80600081146100a0576040519150601f19603f3d011682016040523d82523d6000602084013e6100a5565b606091505b50909250905081156100b9576100b961027a565b6100c2816100c9565b5050505050565b6004815110156101205760405162461bcd60e51b815260206004820152601a60248201527f43616c6c5574696c733a2074617267657420726576657274282900000000000060448201526064015b60405180910390fd5b602081015163b1b7848f60e01b6001600160e01b03198216016101d05760408051808201825260208082527f43616c6c5574696c733a207461726765742070616e69636b65643a2030785f5f90820190815260248501517f43616c6c5574696c733a207461726765742070616e69636b65643a2030780000600482811c600f908116603090810160081b918516011791909117909252925162461bcd60e51b815291929161011791849101610290565b81518060208401fd5b6000806000604084860312156101ee57600080fd5b83356001600160a01b038116811461020557600080fd5b9250602084013567ffffffffffffffff8082111561022257600080fd5b818601915086601f83011261023657600080fd5b81358181111561024557600080fd5b87602082850101111561025757600080fd5b6020830194508093505050509250925092565b8183823760009101908152919050565b634e487b7160e01b600052600160045260246000fd5b600060208083528351808285015260005b818110156102bd578581018301518582016040015282016102a1565b506000604082860101526040601f19601f830116850101925050509291505056fea26469706673582212204471c8eb2da18277960e5528737335bea11819d256d7edc9d06bcbb6e555c6fb64736f6c63430008130033";
const $497a8a2d26541cf7$var$isSuperArgs = (xs)=>xs.length > 1;
class $497a8a2d26541cf7$export$49eca7ca2c4f50c4 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($497a8a2d26541cf7$var$isSuperArgs(args)) super(...args);
        else super($497a8a2d26541cf7$var$_abi, $497a8a2d26541cf7$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($497a8a2d26541cf7$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $497a8a2d26541cf7$var$_abi, signerOrProvider);
    }
}
$497a8a2d26541cf7$export$49eca7ca2c4f50c4.bytecode = $497a8a2d26541cf7$var$_bytecode;
$497a8a2d26541cf7$export$49eca7ca2c4f50c4.abi = $497a8a2d26541cf7$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $0902df8a3e971437$var$_abi = [
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "from",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "to",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "gas",
                        type: "uint256"
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes"
                    }
                ],
                internalType: "struct ForwarderMock.ForwardRequest",
                name: "req",
                type: "tuple"
            }
        ],
        name: "execute",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    }
];
const $0902df8a3e971437$var$_bytecode = "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";
const $0902df8a3e971437$var$isSuperArgs = (xs)=>xs.length > 1;
class $0902df8a3e971437$export$557640b2a43ea8f extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($0902df8a3e971437$var$isSuperArgs(args)) super(...args);
        else super($0902df8a3e971437$var$_abi, $0902df8a3e971437$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($0902df8a3e971437$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $0902df8a3e971437$var$_abi, signerOrProvider);
    }
}
$0902df8a3e971437$export$557640b2a43ea8f.bytecode = $0902df8a3e971437$var$_bytecode;
$0902df8a3e971437$export$557640b2a43ea8f.abi = $0902df8a3e971437$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $f133832eac42e763$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            },
            {
                internalType: "contract IInstantDistributionAgreementV1",
                name: "ida",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        name: "SubscriptionDataAfter",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        name: "SubscriptionDataBefore",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128"
            }
        ],
        name: "distribute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "setForceGetSubscriptionByID",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            }
        ],
        name: "updateSubscription",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $f133832eac42e763$var$_bytecode = "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";
const $f133832eac42e763$var$isSuperArgs = (xs)=>xs.length > 1;
class $f133832eac42e763$export$967294ff1ca95915 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($f133832eac42e763$var$isSuperArgs(args)) super(...args);
        else super($f133832eac42e763$var$_abi, $f133832eac42e763$var$_bytecode, args[0]);
    }
    deploy(host, configWord, ida, token, indexId, overrides) {
        return super.deploy(host, configWord, ida, token, indexId, overrides || {});
    }
    getDeployTransaction(host, configWord, ida, token, indexId, overrides) {
        return super.getDeployTransaction(host, configWord, ida, token, indexId, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($f133832eac42e763$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $f133832eac42e763$var$_abi, signerOrProvider);
    }
}
$f133832eac42e763$export$967294ff1ca95915.bytecode = $f133832eac42e763$var$_bytecode;
$f133832eac42e763$export$967294ff1ca95915.abi = $f133832eac42e763$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $842d0a952d8d5614$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approveTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "upgradeToTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $842d0a952d8d5614$var$_bytecode = "0x608060405234801561001057600080fd5b506102e6806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c80632ed8c4b91461003b578063eefa3cde14610050575b600080fd5b61004e61004936600461015f565b610063565b005b61004e61005e3660046101fe565b6100ce565b6040516316e7427360e21b81526001600160a01b03861690635b9d09cc9061009590879087908790879060040161023f565b600060405180830381600087803b1580156100af57600080fd5b505af11580156100c3573d6000803e3d6000fd5b505050505050505050565b60405163095ea7b360e01b81526001600160a01b0383811660048301526024820183905284169063095ea7b3906044016020604051808303816000875af115801561011d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906101419190610287565b50505050565b6001600160a01b038116811461015c57600080fd5b50565b60008060008060006080868803121561017757600080fd5b853561018281610147565b9450602086013561019281610147565b935060408601359250606086013567ffffffffffffffff808211156101b657600080fd5b818801915088601f8301126101ca57600080fd5b8135818111156101d957600080fd5b8960208285010111156101eb57600080fd5b9699959850939650602001949392505050565b60008060006060848603121561021357600080fd5b833561021e81610147565b9250602084013561022e81610147565b929592945050506040919091013590565b6001600160a01b0385168152602081018490526060604082018190528101829052818360808301376000818301608090810191909152601f909201601f191601019392505050565b60006020828403121561029957600080fd5b815180151581146102a957600080fd5b939250505056fea2646970667358221220437d2a2ccf4fedf160827a617f10e5dbb1434d06b461a94bcef8dd235be57a3e64736f6c63430008130033";
const $842d0a952d8d5614$var$isSuperArgs = (xs)=>xs.length > 1;
class $842d0a952d8d5614$export$ec502c9f81b1a9b1 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($842d0a952d8d5614$var$isSuperArgs(args)) super(...args);
        else super($842d0a952d8d5614$var$_abi, $842d0a952d8d5614$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($842d0a952d8d5614$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $842d0a952d8d5614$var$_abi, signerOrProvider);
    }
}
$842d0a952d8d5614$export$ec502c9f81b1a9b1.bytecode = $842d0a952d8d5614$var$_bytecode;
$842d0a952d8d5614$export$ec502c9f81b1a9b1.abi = $842d0a952d8d5614$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $819eaad957c900a6$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "cfa",
                type: "address"
            },
            {
                internalType: "contract ISuperfluid",
                name: "superfluid",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "createFlow",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $819eaad957c900a6$var$_bytecode = "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";
const $819eaad957c900a6$var$isSuperArgs = (xs)=>xs.length > 1;
class $819eaad957c900a6$export$e16483bb571cb9cd extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($819eaad957c900a6$var$isSuperArgs(args)) super(...args);
        else super($819eaad957c900a6$var$_abi, $819eaad957c900a6$var$_bytecode, args[0]);
    }
    deploy(cfa, superfluid, overrides) {
        return super.deploy(cfa, superfluid, overrides || {});
    }
    getDeployTransaction(cfa, superfluid, overrides) {
        return super.getDeployTransaction(cfa, superfluid, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($819eaad957c900a6$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $819eaad957c900a6$var$_abi, signerOrProvider);
    }
}
$819eaad957c900a6$export$e16483bb571cb9cd.bytecode = $819eaad957c900a6$var$_bytecode;
$819eaad957c900a6$export$e16483bb571cb9cd.abi = $819eaad957c900a6$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $ff08f889bd80dce5$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "_host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "_token",
                type: "address"
            },
            {
                internalType: "address",
                name: "_receiver",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "_appLevel",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "OnlyCFA",
        type: "error"
    },
    {
        inputs: [],
        name: "OnlyHost",
        type: "error"
    },
    {
        inputs: [],
        name: "UnsupportedToken",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "_superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "_agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "_ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "_superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "_agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "_ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_targetApp",
                type: "address"
            }
        ],
        name: "allowCompositeApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "cfaV1",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "cfa",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "host",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "receiver",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_originAccount",
                type: "address"
            },
            {
                internalType: "int96",
                name: "_flowRate",
                type: "int96"
            }
        ],
        name: "startStreamToSelf",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_superApp",
                type: "address"
            },
            {
                internalType: "int96",
                name: "_flowRate",
                type: "int96"
            }
        ],
        name: "startStreamToSuperApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_originAccount",
                type: "address"
            }
        ],
        name: "stopStreamToSelf",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "_receiver",
                type: "address"
            }
        ],
        name: "stopStreamToSuperApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $ff08f889bd80dce5$var$_bytecode = "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";
const $ff08f889bd80dce5$var$isSuperArgs = (xs)=>xs.length > 1;
class $ff08f889bd80dce5$export$ffc7b50416892da5 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($ff08f889bd80dce5$var$isSuperArgs(args)) super(...args);
        else super($ff08f889bd80dce5$var$_abi, $ff08f889bd80dce5$var$_bytecode, args[0]);
    }
    deploy(_host, _token, _receiver, _appLevel, overrides) {
        return super.deploy(_host, _token, _receiver, _appLevel, overrides || {});
    }
    getDeployTransaction(_host, _token, _receiver, _appLevel, overrides) {
        return super.getDeployTransaction(_host, _token, _receiver, _appLevel, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($ff08f889bd80dce5$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $ff08f889bd80dce5$var$_abi, signerOrProvider);
    }
}
$ff08f889bd80dce5$export$ffc7b50416892da5.bytecode = $ff08f889bd80dce5$var$_bytecode;
$ff08f889bd80dce5$export$ffc7b50416892da5.abi = $ff08f889bd80dce5$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $56ede37e701e297b$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "bool",
                name: "activateOnCreated",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "activateOnUpdated",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "activateOnDeleted",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "NotAcceptedSuperToken",
        type: "error"
    },
    {
        inputs: [],
        name: "NotImplemented",
        type: "error"
    },
    {
        inputs: [],
        name: "UnauthorizedHost",
        type: "error"
    },
    {
        inputs: [],
        name: "CFAV1_TYPE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "afterReceiverHolder",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "afterSenderHolder",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "isAcceptedSuperToken",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "lastUpdateHolder",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "oldFlowRateHolder",
        outputs: [
            {
                internalType: "int96",
                name: "",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "acceptedSuperToken",
                type: "address"
            },
            {
                internalType: "bool",
                name: "accepted",
                type: "bool"
            }
        ],
        name: "setAcceptedSuperToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96"
            }
        ],
        name: "startStream",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $56ede37e701e297b$var$_bytecode = "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";
const $56ede37e701e297b$var$isSuperArgs = (xs)=>xs.length > 1;
class $56ede37e701e297b$export$b1b3134abdebf217 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($56ede37e701e297b$var$isSuperArgs(args)) super(...args);
        else super($56ede37e701e297b$var$_abi, $56ede37e701e297b$var$_bytecode, args[0]);
    }
    deploy(host, activateOnCreated, activateOnUpdated, activateOnDeleted, overrides) {
        return super.deploy(host, activateOnCreated, activateOnUpdated, activateOnDeleted, overrides || {});
    }
    getDeployTransaction(host, activateOnCreated, activateOnUpdated, activateOnDeleted, overrides) {
        return super.getDeployTransaction(host, activateOnCreated, activateOnUpdated, activateOnDeleted, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($56ede37e701e297b$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $56ede37e701e297b$var$_abi, signerOrProvider);
    }
}
$56ede37e701e297b$export$b1b3134abdebf217.bytecode = $56ede37e701e297b$var$_bytecode;
$56ede37e701e297b$export$b1b3134abdebf217.abi = $56ede37e701e297b$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $3c9e2e3020a0b56e$var$_abi = [
    {
        stateMutability: "nonpayable",
        type: "fallback"
    },
    {
        inputs: [],
        name: "NON_UPGRADABLE_DEPLOYMENT",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $3c9e2e3020a0b56e$var$_bytecode = "0x60a06040526000608052348015601457600080fd5b50608051609c61002d600039600060300152609c6000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063cd312ec414602c575b6000ff5b60527f000000000000000000000000000000000000000000000000000000000000000081565b604051901515815260200160405180910390f3fea264697066735822122065028e6cc3a1447f60610dded44e58a413f3848e4b4a34b86a10c0987bdfac5764736f6c63430008130033";
const $3c9e2e3020a0b56e$var$isSuperArgs = (xs)=>xs.length > 1;
class $3c9e2e3020a0b56e$export$f060e15132f3e98e extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($3c9e2e3020a0b56e$var$isSuperArgs(args)) super(...args);
        else super($3c9e2e3020a0b56e$var$_abi, $3c9e2e3020a0b56e$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($3c9e2e3020a0b56e$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $3c9e2e3020a0b56e$var$_abi, signerOrProvider);
    }
}
$3c9e2e3020a0b56e$export$f060e15132f3e98e.bytecode = $3c9e2e3020a0b56e$var$_bytecode;
$3c9e2e3020a0b56e$export$f060e15132f3e98e.abi = $3c9e2e3020a0b56e$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $b99307be6c5d34cb$var$_abi = [
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "w",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "waterMark",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $b99307be6c5d34cb$var$_bytecode = "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";
const $b99307be6c5d34cb$var$isSuperArgs = (xs)=>xs.length > 1;
class $b99307be6c5d34cb$export$834f1160b24dbfc8 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($b99307be6c5d34cb$var$isSuperArgs(args)) super(...args);
        else super($b99307be6c5d34cb$var$_abi, $b99307be6c5d34cb$var$_bytecode, args[0]);
    }
    deploy(uuid, w, overrides) {
        return super.deploy(uuid, w, overrides || {});
    }
    getDeployTransaction(uuid, w, overrides) {
        return super.getDeployTransaction(uuid, w, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($b99307be6c5d34cb$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $b99307be6c5d34cb$var$_abi, signerOrProvider);
    }
}
$b99307be6c5d34cb$export$834f1160b24dbfc8.bytecode = $b99307be6c5d34cb$var$_bytecode;
$b99307be6c5d34cb$export$834f1160b24dbfc8.abi = $b99307be6c5d34cb$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $92dfed7b9d28405a$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "superTokenLogic",
                type: "address"
            },
            {
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFTLogic",
                type: "address"
            },
            {
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFTLogic",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_NON_UPGRADEABLE_IS_DEPRECATED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_GOVERNANCE_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_UNINITIALIZED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "CustomSuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "SuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "tokenLogic",
                type: "address"
            }
        ],
        name: "SuperTokenLogicCreated",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT_LOGIC",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT_LOGIC",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "_SUPER_TOKEN_LOGIC",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "computeCanonicalERC20WrapperAddress",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            },
            {
                internalType: "bool",
                name: "isDeployed",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "createCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingTokenAddress",
                type: "address"
            }
        ],
        name: "getCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenLogic",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "underlyingToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    }
                ],
                internalType: "struct SuperTokenFactoryBase.InitializeData[]",
                name: "_data",
                type: "tuple[]"
            }
        ],
        name: "initializeCanonicalWrapperSuperTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "customSuperTokenProxy",
                type: "address"
            }
        ],
        name: "initializeCustomSuperToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $92dfed7b9d28405a$var$_bytecode = "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";
const $92dfed7b9d28405a$var$isSuperArgs = (xs)=>xs.length > 1;
class $92dfed7b9d28405a$export$b10d953c9c2a296a extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($92dfed7b9d28405a$var$isSuperArgs(args)) super(...args);
        else super($92dfed7b9d28405a$var$_abi, $92dfed7b9d28405a$var$_bytecode, args[0]);
    }
    deploy(host, superTokenLogic, constantOutflowNFTLogic, constantInflowNFTLogic, overrides) {
        return super.deploy(host, superTokenLogic, constantOutflowNFTLogic, constantInflowNFTLogic, overrides || {});
    }
    getDeployTransaction(host, superTokenLogic, constantOutflowNFTLogic, constantInflowNFTLogic, overrides) {
        return super.getDeployTransaction(host, superTokenLogic, constantOutflowNFTLogic, constantInflowNFTLogic, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($92dfed7b9d28405a$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $92dfed7b9d28405a$var$_abi, signerOrProvider);
    }
}
$92dfed7b9d28405a$export$b10d953c9c2a296a.bytecode = $92dfed7b9d28405a$var$_bytecode;
$92dfed7b9d28405a$export$b10d953c9c2a296a.abi = $92dfed7b9d28405a$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $5c0104d089950ee4$var$_abi = [
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_NON_UPGRADEABLE_IS_DEPRECATED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_GOVERNANCE_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_UNINITIALIZED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_FACTORY_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "CustomSuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "SuperTokenCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "tokenLogic",
                type: "address"
            }
        ],
        name: "SuperTokenLogicCreated",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT_LOGIC",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT_LOGIC",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "_SUPER_TOKEN_LOGIC",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "computeCanonicalERC20WrapperAddress",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            },
            {
                internalType: "bool",
                name: "isDeployed",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "_underlyingToken",
                type: "address"
            }
        ],
        name: "createCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Metadata",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "enum ISuperTokenFactory.Upgradability",
                name: "upgradability",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "createERC20Wrapper",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_underlyingTokenAddress",
                type: "address"
            }
        ],
        name: "getCanonicalERC20Wrapper",
        outputs: [
            {
                internalType: "address",
                name: "superTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenLogic",
        outputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "underlyingToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    }
                ],
                internalType: "struct SuperTokenFactoryBase.InitializeData[]",
                name: "_data",
                type: "tuple[]"
            }
        ],
        name: "initializeCanonicalWrapperSuperTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "customSuperTokenProxy",
                type: "address"
            }
        ],
        name: "initializeCustomSuperToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $5c0104d089950ee4$export$f79b84d1a57fa8af {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($5c0104d089950ee4$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $5c0104d089950ee4$var$_abi, signerOrProvider);
    }
}
$5c0104d089950ee4$export$f79b84d1a57fa8af.abi = $5c0104d089950ee4$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $7e5a48aef91ca665$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CALLER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CURRENT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_INVALID_TOKEN_ID",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_ONLY_SUPER_TOKEN_FACTORY",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_FROM_INCORRECT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_IS_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "CIF_NFT_ONLY_CONSTANT_OUTFLOW",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "MetadataUpdate",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_FLOW_AGREEMENT_V1",
        outputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_BASE_URI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "flowDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowSender",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowReceiver",
                        type: "address"
                    },
                    {
                        internalType: "uint32",
                        name: "flowStartDate",
                        type: "uint32"
                    }
                ],
                internalType: "struct IFlowNFTBase.FlowNFTData",
                name: "flowData",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "nftName",
                type: "string"
            },
            {
                internalType: "string",
                name: "nftSymbol",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "newTokenId",
                type: "uint256"
            }
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "triggerMetadataUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $7e5a48aef91ca665$var$_bytecode = "0x60e06040523480156200001157600080fd5b50604051620021ae380380620021ae8339810160408190526200003491620000fd565b6001600160a01b03821660a0819052604051635b69006f60e11b81527fa9214cc96615e0085d3bb077758db69497dc2dce3b2b1e97bc93c3d18d83efd3600482015283919063b6d200de90602401602060405180830381865afa158015620000a0573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620000c691906200013c565b6001600160a01b039081166080529190911660c05250620001639050565b6001600160a01b0381168114620000fa57600080fd5b50565b600080604083850312156200011157600080fd5b82516200011e81620000e4565b60208401519092506200013181620000e4565b809150509250929050565b6000602082840312156200014f57600080fd5b81516200015c81620000e4565b9392505050565b60805160a05160c051611ff8620001b66000396000818161045501528181610657015281816106c901526109c30152600081816102e4015261071401526000818161024b01526110cf0152611ff86000f3fe608060405234801561001057600080fd5b50600436106101c45760003560e01c806352d1902d116100f95780639903ad3811610097578063b88d4fde11610071578063b88d4fde14610417578063c87b56dd1461042a578063e985e9c51461043d578063ef43d2c61461045057600080fd5b80639903ad38146103f4578063a22cb465146103fc578063a497325b1461040f57600080fd5b806370a08231116100d357806370a082311461036c57806389f71d2d146103805780638d47859e1461039357806395d89b41146103ec57600080fd5b806352d1902d146103215780636352211e146103515780636c0360eb1461036457600080fd5b806340c10f1911610166578063469519541161014057806346951954146102cc57806349f289dc146102df5780634cd88b761461030657806350d75d251461031957600080fd5b806340c10f191461029357806342842e0e146102a657806342966c68146102b957600080fd5b8063095ea7b3116101a2578063095ea7b314610231578063181561011461024657806323b872dd1461026d5780632f3885601461028057600080fd5b806301ffc9a7146101c957806306fdde03146101f1578063081812fc14610206575b600080fd5b6101dc6101d7366004611680565b610477565b60405190151581526020015b60405180910390f35b6101f96104c9565b6040516101e891906116ce565b610219610214366004611701565b61055b565b6040516001600160a01b0390911681526020016101e8565b61024461023f36600461172f565b610582565b005b6102197f000000000000000000000000000000000000000000000000000000000000000081565b61024461027b36600461175b565b61060e565b61024461028e366004611701565b610640565b6102446102a136600461172f565b61064c565b6102446102b436600461175b565b6106a3565b6102446102c7366004611701565b6106be565b6102446102da36600461179c565b610710565b6102197f000000000000000000000000000000000000000000000000000000000000000081565b610244610314366004611886565b6107c8565b6102196108ae565b7f9a61ea3469d742a522f41a67608e442d2c27902bed81123f00ba6d3e12e9871e5b6040519081526020016101e8565b61021961035f366004611701565b6108dd565b6101f9610912565b61034361037a36600461179c565b50600190565b61034361038e3660046118ea565b610932565b6103a66103a1366004611701565b610985565b6040805182516001600160a01b03908116825260208085015182169083015283830151169181019190915260609182015163ffffffff16918101919091526080016101e8565b6101f9610a2e565b610244610a3d565b61024461040a366004611935565b610aff565b6101f9610b0a565b610244610425366004611973565b610b26565b6101f9610438366004611701565b610b5f565b6101dc61044b3660046119f3565b610b6c565b6102197f000000000000000000000000000000000000000000000000000000000000000081565b60006301ffc9a760e01b6001600160e01b0319831614806104a857506380ac58cd60e01b6001600160e01b03198316145b806104c35750635b5e139f60e01b6001600160e01b03198316145b92915050565b6060600180546104d890611a21565b80601f016020809104026020016040519081016040528092919081815260200182805461050490611a21565b80156105515780601f1061052657610100808354040283529160200191610551565b820191906000526020600020905b81548152906001019060200180831161053457829003601f168201915b5050505050905090565b600061056682610b9a565b506000908152600360205260409020546001600160a01b031690565b600061058d826108dd565b9050806001600160a01b0316836001600160a01b0316036105c15760405163e4790b2560e01b815260040160405180910390fd5b336001600160a01b038216148015906105e157506105df8133610b6c565b155b156105ff5760405163519a92c160e11b815260040160405180910390fd5b6106098383610bc0565b505050565b6106183382610c2e565b610635576040516312a8eb0360e11b815260040160405180910390fd5b610609838383610c8c565b61064981610ca5565b50565b336001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146106955760405163740f7abd60e11b815260040160405180910390fd5b61069f8282610cd5565b5050565b61060983838360405180602001604052806000815250610b26565b336001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146107075760405163740f7abd60e11b815260040160405180910390fd5b61064981610d11565b60007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663731aed6e6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610770573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107949190611a5b565b9050336001600160a01b038216146107bf5760405163ebb7505b60e01b815260040160405180910390fd5b61069f82610d84565b600054610100900460ff16158080156107e85750600054600160ff909116105b806108025750303b158015610802575060005460ff166001145b6108275760405162461bcd60e51b815260040161081e90611a78565b60405180910390fd5b6000805460ff19166001179055801561084a576000805461ff0019166101001790555b60016108568482611b14565b5060026108638382611b14565b508015610609576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a1505050565b60006108d87f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b905090565b6000806108e983610fbe565b90506001600160a01b0381166104c35760405163eab95e3b60e01b815260040160405180910390fd5b60606040518060600160405280602d8152602001611f96602d9139905090565b60408051466020808301919091526001600160a01b0380871683850152808616606084015284166080808401919091528351808403909101815260a090920190925280519101206000905b949350505050565b60408051608081018252600080825260208201819052818301819052606082015290516346a3c2cf60e11b8152600481018390526001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001690638d47859e90602401608060405180830381865afa158015610a0a573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906104c39190611bd4565b6060600280546104d890611a21565b600054610100900460ff1615808015610a5d5750600054600160ff909116105b80610a775750303b158015610a77575060005460ff166001145b610a935760405162461bcd60e51b815260040161081e90611a78565b6000805460ff191660011790558015610ab6576000805461ff0019166101001790555b8015610649576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb3847402498906020015b60405180910390a150565b61069f338383610fd5565b6040518060600160405280602d8152602001611f96602d913981565b610b303383610c2e565b610b4d576040516312a8eb0360e11b815260040160405180910390fd5b610b5984848484611074565b50505050565b60606104c382600161107f565b6001600160a01b03918216600090815260046020908152604080832093909416825291909152205460ff1690565b610ba3816111da565b6106495760405163eab95e3b60e01b815260040160405180910390fd5b600081815260036020526040902080546001600160a01b0319166001600160a01b0384169081179091558190610bf582610fbe565b6001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560405160405180910390a45050565b600080610c3a836108dd565b9050806001600160a01b0316846001600160a01b03161480610c615750610c618185610b6c565b8061097d5750836001600160a01b0316610c7a8461055b565b6001600160a01b031614949350505050565b60405163553a3f6560e11b815260040160405180910390fd5b6040518181527ff8e1a15aba9398e019f0b49df1a4fde98ee17ae345cb5f6b5e2c27f5033e8ce790602001610af4565b60405181906001600160a01b038416906000907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908290a45050565b6000610d1c82610985565b600083815260036020526040902080546001600160a01b031916905590508160006001600160a01b031682604001516001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef60405160405180910390a45050565b6000610dae7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b6001600160a01b031603610e045760405162461bcd60e51b815260206004820152601d60248201527f5555505350726f786961626c653a206e6f742075706772616461626c65000000604482015260640161081e565b806001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610e42573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e669190611c62565b7f9a61ea3469d742a522f41a67608e442d2c27902bed81123f00ba6d3e12e9871e14610ee05760405162461bcd60e51b815260206004820152602360248201527f5555505350726f786961626c653a206e6f7420636f6d70617469626c65206c6f60448201526267696360e81b606482015260840161081e565b6001600160a01b0381163003610f385760405162461bcd60e51b815260206004820152601960248201527f5555505350726f786961626c653a2070726f7879206c6f6f7000000000000000604482015260640161081e565b610f60817f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc55565b7fe011bc04c286c344a8fcbb8de77f953da762c3e25d8cdea984147fc4168a5dcc7f9a61ea3469d742a522f41a67608e442d2c27902bed81123f00ba6d3e12e9871e604080519182526001600160a01b038416602083015201610af4565b600080610fca83610985565b604001519392505050565b816001600160a01b0316836001600160a01b0316036110075760405163d3c7732960e01b815260040160405180910390fd5b6001600160a01b03838116600081815260046020908152604080832094871680845294825291829020805460ff191686151590811790915591519182527f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a3505050565b610b59848484610c8c565b6060600061108c84610985565b805160208201516040808401519051631cd43d1160e31b81526001600160a01b0380851660048301529283166024820152908216604482015292935090916000917f0000000000000000000000000000000000000000000000000000000000000000169063e6a1e88890606401608060405180830381865afa158015611116573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061113a9190611c7b565b5050915050611147610912565b61115e826bffffffffffffffffffffffff166111f7565b8661118557604051806040016040528060048152602001637472756560e01b8152506111a4565b6040518060400160405280600581526020016466616c736560d81b8152505b6111ad8961128a565b6040516020016111c09493929190611cdb565b604051602081830303815290604052935050505092915050565b6000806111e683610fbe565b6001600160a01b0316141592915050565b6060600061120483611405565b600101905060008167ffffffffffffffff811115611224576112246117b9565b6040519080825280601f01601f19166020018201604052801561124e576020820181803683370190505b5090508181016020015b600019016f181899199a1a9b1b9c1cb0b131b232b360811b600a86061a8153600a850494508461125857509392505050565b6060600061129783610985565b90506112b181600001516001600160a01b031660146114dd565b6112ba466111f7565b82600001516001600160a01b03166395d89b416040518163ffffffff1660e01b8152600401600060405180830381865afa1580156112fc573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526113249190810190611d63565b61133c84602001516001600160a01b031660146114dd565b61135485604001516001600160a01b031660146114dd565b6113c586600001516001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa158015611399573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906113bd9190611dda565b60ff166111f7565b6113d8876060015163ffffffff166111f7565b6040516020016113ee9796959493929190611dfd565b604051602081830303815290604052915050919050565b60008072184f03e93ff9f4daa797ed6e38ed64bf6a1f0160401b83106114445772184f03e93ff9f4daa797ed6e38ed64bf6a1f0160401b830492506040015b6d04ee2d6d415b85acef81000000008310611470576d04ee2d6d415b85acef8100000000830492506020015b662386f26fc10000831061148e57662386f26fc10000830492506010015b6305f5e10083106114a6576305f5e100830492506008015b61271083106114ba57612710830492506004015b606483106114cc576064830492506002015b600a83106104c35760010192915050565b606060006114ec836002611f3e565b6114f7906002611f55565b67ffffffffffffffff81111561150f5761150f6117b9565b6040519080825280601f01601f191660200182016040528015611539576020820181803683370190505b509050600360fc1b8160008151811061155457611554611f68565b60200101906001600160f81b031916908160001a905350600f60fb1b8160018151811061158357611583611f68565b60200101906001600160f81b031916908160001a90535060006115a7846002611f3e565b6115b2906001611f55565b90505b600181111561162a576f181899199a1a9b1b9c1cb0b131b232b360811b85600f16601081106115e6576115e6611f68565b1a60f81b8282815181106115fc576115fc611f68565b60200101906001600160f81b031916908160001a90535060049490941c9361162381611f7e565b90506115b5565b5083156116795760405162461bcd60e51b815260206004820181905260248201527f537472696e67733a20686578206c656e67746820696e73756666696369656e74604482015260640161081e565b9392505050565b60006020828403121561169257600080fd5b81356001600160e01b03198116811461167957600080fd5b60005b838110156116c55781810151838201526020016116ad565b50506000910152565b60208152600082518060208401526116ed8160408501602087016116aa565b601f01601f19169190910160400192915050565b60006020828403121561171357600080fd5b5035919050565b6001600160a01b038116811461064957600080fd5b6000806040838503121561174257600080fd5b823561174d8161171a565b946020939093013593505050565b60008060006060848603121561177057600080fd5b833561177b8161171a565b9250602084013561178b8161171a565b929592945050506040919091013590565b6000602082840312156117ae57600080fd5b81356116798161171a565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f1916810167ffffffffffffffff811182821017156117f8576117f86117b9565b604052919050565b600067ffffffffffffffff82111561181a5761181a6117b9565b50601f01601f191660200190565b600061183b61183684611800565b6117cf565b905082815283838301111561184f57600080fd5b828260208301376000602084830101529392505050565b600082601f83011261187757600080fd5b61167983833560208501611828565b6000806040838503121561189957600080fd5b823567ffffffffffffffff808211156118b157600080fd5b6118bd86838701611866565b935060208501359150808211156118d357600080fd5b506118e085828601611866565b9150509250929050565b6000806000606084860312156118ff57600080fd5b833561190a8161171a565b9250602084013561191a8161171a565b9150604084013561192a8161171a565b809150509250925092565b6000806040838503121561194857600080fd5b82356119538161171a565b91506020830135801515811461196857600080fd5b809150509250929050565b6000806000806080858703121561198957600080fd5b84356119948161171a565b935060208501356119a48161171a565b925060408501359150606085013567ffffffffffffffff8111156119c757600080fd5b8501601f810187136119d857600080fd5b6119e787823560208401611828565b91505092959194509250565b60008060408385031215611a0657600080fd5b8235611a118161171a565b915060208301356119688161171a565b600181811c90821680611a3557607f821691505b602082108103611a5557634e487b7160e01b600052602260045260246000fd5b50919050565b600060208284031215611a6d57600080fd5b81516116798161171a565b6020808252602e908201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160408201526d191e481a5b9a5d1a585b1a5e995960921b606082015260800190565b601f82111561060957600081815260208120601f850160051c81016020861015611aed5750805b601f850160051c820191505b81811015611b0c57828155600101611af9565b505050505050565b815167ffffffffffffffff811115611b2e57611b2e6117b9565b611b4281611b3c8454611a21565b84611ac6565b602080601f831160018114611b775760008415611b5f5750858301515b600019600386901b1c1916600185901b178555611b0c565b600085815260208120601f198616915b82811015611ba657888601518255948401946001909101908401611b87565b5085821015611bc45787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b600060808284031215611be657600080fd5b6040516080810181811067ffffffffffffffff82111715611c0957611c096117b9565b6040528251611c178161171a565b81526020830151611c278161171a565b60208201526040830151611c3a8161171a565b6040820152606083015163ffffffff81168114611c5657600080fd5b60608201529392505050565b600060208284031215611c7457600080fd5b5051919050565b60008060008060808587031215611c9157600080fd5b84519350602085015180600b0b8114611ca957600080fd5b6040860151606090960151949790965092505050565b60008151611cd18185602086016116aa565b9290920192915050565b60008551611ced818460208a016116aa565b693f666c6f77526174653d60b01b9083019081528551611d1481600a840160208a016116aa565b69266f7574676f696e673d60b01b600a92909101918201528451611d3f8160148401602089016116aa565b8451910190611d558160148401602088016116aa565b016014019695505050505050565b600060208284031215611d7557600080fd5b815167ffffffffffffffff811115611d8c57600080fd5b8201601f81018413611d9d57600080fd5b8051611dab61183682611800565b818152856020838501011115611dc057600080fd5b611dd18260208301602086016116aa565b95945050505050565b600060208284031215611dec57600080fd5b815160ff8116811461167957600080fd5b6e26746f6b656e5f616464726573733d60881b815260008851611e2781600f850160208d016116aa565b6926636861696e5f69643d60b01b600f918401918201528851611e51816019840160208d016116aa565b6d26746f6b656e5f73796d626f6c3d60901b601992909101918201528751611e80816027840160208c016116aa565b672673656e6465723d60c01b602792909101918201528651611ea981602f840160208b016116aa565b692672656365697665723d60b01b602f9290910191820152611f1a611f14611efc611ef6611eda603986018b611cbf565b6f26746f6b656e5f646563696d616c733d60801b815260100190565b88611cbf565b6b2673746172745f646174653d60a01b8152600c0190565b85611cbf565b9a9950505050505050505050565b634e487b7160e01b600052601160045260246000fd5b80820281158282048414176104c3576104c3611f28565b808201808211156104c3576104c3611f28565b634e487b7160e01b600052603260045260246000fd5b600081611f8d57611f8d611f28565b50600019019056fe68747470733a2f2f6e66742e7375706572666c7569642e66696e616e63652f6366612f76322f6765746d657461a2646970667358221220b1712174b00d0496404090493c8a89e33bfa8a4ce567ae086415054ae915149b64736f6c63430008130033";
const $7e5a48aef91ca665$var$isSuperArgs = (xs)=>xs.length > 1;
class $7e5a48aef91ca665$export$eb7e5cf7b5e80c85 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($7e5a48aef91ca665$var$isSuperArgs(args)) super(...args);
        else super($7e5a48aef91ca665$var$_abi, $7e5a48aef91ca665$var$_bytecode, args[0]);
    }
    deploy(host, constantOutflowNFT, overrides) {
        return super.deploy(host, constantOutflowNFT, overrides || {});
    }
    getDeployTransaction(host, constantOutflowNFT, overrides) {
        return super.getDeployTransaction(host, constantOutflowNFT, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($7e5a48aef91ca665$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $7e5a48aef91ca665$var$_abi, signerOrProvider);
    }
}
$7e5a48aef91ca665$export$eb7e5cf7b5e80c85.bytecode = $7e5a48aef91ca665$var$_bytecode;
$7e5a48aef91ca665$export$eb7e5cf7b5e80c85.abi = $7e5a48aef91ca665$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $d31c46b1a94ce036$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CALLER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CURRENT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_INVALID_TOKEN_ID",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_ONLY_SUPER_TOKEN_FACTORY",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_FROM_INCORRECT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_IS_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_INVALID_SUPER_TOKEN",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_MINT_TO_AND_FLOW_RECEIVER_SAME",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_MINT_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_ONLY_CONSTANT_INFLOW",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_ONLY_FLOW_AGREEMENTS",
        type: "error"
    },
    {
        inputs: [],
        name: "COF_NFT_TOKEN_ALREADY_EXISTS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "MetadataUpdate",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_FLOW_AGREEMENT_V1",
        outputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_BASE_URI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "flowDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowSender",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowReceiver",
                        type: "address"
                    },
                    {
                        internalType: "uint32",
                        name: "flowStartDate",
                        type: "uint32"
                    }
                ],
                internalType: "struct IFlowNFTBase.FlowNFTData",
                name: "flowData",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "nftName",
                type: "string"
            },
            {
                internalType: "string",
                name: "nftSymbol",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "onCreate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "onDelete",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowSender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowReceiver",
                type: "address"
            }
        ],
        name: "onUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "triggerMetadataUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $d31c46b1a94ce036$var$_bytecode = "0x60e06040523480156200001157600080fd5b506040516200246f3803806200246f8339810160408190526200003491620000fd565b6001600160a01b03821660a0819052604051635b69006f60e11b81527fa9214cc96615e0085d3bb077758db69497dc2dce3b2b1e97bc93c3d18d83efd3600482015283919063b6d200de90602401602060405180830381865afa158015620000a0573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620000c691906200013c565b6001600160a01b039081166080529190911660c05250620001639050565b6001600160a01b0381168114620000fa57600080fd5b50565b600080604083850312156200011157600080fd5b82516200011e81620000e4565b60208401519092506200013181620000e4565b809150509250929050565b6000602082840312156200014f57600080fd5b81516200015c81620000e4565b9392505050565b60805160a05160c0516122a4620001cb600039600081816102f001528181610b4901528181610c430152610d5a0152600081816102c9015261068901526000818161025601528181610abc01528181610bbf01528181610cbb015261125201526122a46000f3fe608060405234801561001057600080fd5b50600436106101cf5760003560e01c80636352211e11610104578063a22cb465116100a2578063e985e9c511610071578063e985e9c514610449578063eb54a7ca1461045c578063ef1f02371461046f578063f7e3d9831461048257600080fd5b8063a22cb46514610408578063a497325b1461041b578063b88d4fde14610423578063c87b56dd1461043657600080fd5b806389f71d2d116100de57806389f71d2d1461038c5780638d47859e1461039f57806395d89b41146103f85780639903ad381461040057600080fd5b80636352211e1461035d5780636c0360eb1461037057806370a082311461037857600080fd5b806342842e0e116101715780634c5c0c851161014b5780634c5c0c85146102eb5780634cd88b761461031257806350d75d251461032557806352d1902d1461032d57600080fd5b806342842e0e1461029e57806346951954146102b157806349f289dc146102c457600080fd5b8063095ea7b3116101ad578063095ea7b31461023c578063181561011461025157806323b872dd146102785780632f3885601461028b57600080fd5b806301ffc9a7146101d457806306fdde03146101fc578063081812fc14610211575b600080fd5b6101e76101e23660046119a4565b610495565b60405190151581526020015b60405180910390f35b6102046104e7565b6040516101f391906119f2565b61022461021f366004611a25565b610579565b6040516001600160a01b0390911681526020016101f3565b61024f61024a366004611a53565b6105a0565b005b6102247f000000000000000000000000000000000000000000000000000000000000000081565b61024f610286366004611a7f565b61062c565b61024f610299366004611a25565b61065e565b61024f6102ac366004611a7f565b61066a565b61024f6102bf366004611ac0565b610685565b6102247f000000000000000000000000000000000000000000000000000000000000000081565b6102247f000000000000000000000000000000000000000000000000000000000000000081565b61024f610320366004611baa565b610741565b610224610827565b7f87e44dce6a0d65a5ccf441783661f5727c2624b1f0088bbe957ce2c95406b7845b6040519081526020016101f3565b61022461036b366004611a25565b610856565b61020461088f565b61034f610386366004611ac0565b50600190565b61034f61039a366004611c0e565b6108af565b6103b26103ad366004611a25565b6108c4565b6040805182516001600160a01b03908116825260208085015182169083015283830151169181019190915260609182015163ffffffff16918101919091526080016101f3565b610204610945565b61024f610954565b61024f610416366004611c59565b610a16565b610204610a21565b61024f610431366004611c97565b610a3d565b610204610444366004611a25565b610a76565b6101e7610457366004611d17565b610a83565b61024f61046a366004611c0e565b610ab1565b61024f61047d366004611c0e565b610bb4565b61024f610490366004611c0e565b610cb0565b60006301ffc9a760e01b6001600160e01b0319831614806104c657506380ac58cd60e01b6001600160e01b03198316145b806104e15750635b5e139f60e01b6001600160e01b03198316145b92915050565b6060600180546104f690611d45565b80601f016020809104026020016040519081016040528092919081815260200182805461052290611d45565b801561056f5780601f106105445761010080835404028352916020019161056f565b820191906000526020600020905b81548152906001019060200180831161055257829003601f168201915b5050505050905090565b600061058482610d89565b506000908152600360205260409020546001600160a01b031690565b60006105ab82610856565b9050806001600160a01b0316836001600160a01b0316036105df5760405163e4790b2560e01b815260040160405180910390fd5b336001600160a01b038216148015906105ff57506105fd8133610a83565b155b1561061d5760405163519a92c160e11b815260040160405180910390fd5b6106278383610dc1565b505050565b6106363382610e2b565b610653576040516312a8eb0360e11b815260040160405180910390fd5b610627838383610e89565b61066781610ea2565b50565b61062783838360405180602001604052806000815250610a3d565b60007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663731aed6e6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156106e5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107099190611d7f565b9050336001600160a01b038216146107345760405163ebb7505b60e01b815260040160405180910390fd5b61073d82610ed2565b5050565b600054610100900460ff16158080156107615750600054600160ff909116105b8061077b5750303b15801561077b575060005460ff166001145b6107a05760405162461bcd60e51b815260040161079790611d9c565b60405180910390fd5b6000805460ff1916600117905580156107c3576000805461ff0019166101001790555b60016107cf8482611e38565b5060026107dc8382611e38565b508015610627576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a1505050565b60006108517f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b905090565b6000818152601660205260408120600101546001600160a01b0316806104e15760405163eab95e3b60e01b815260040160405180910390fd5b60606040518060600160405280602d8152602001612242602d9139905090565b60006108bc84848461110c565b949350505050565b60408051608081018252600080825260208201819052918101829052606081019190915250600090815260166020908152604091829020825160808101845281546001600160a01b039081168252600183015481169382019390935260029091015491821692810192909252600160a01b900463ffffffff16606082015290565b6060600280546104f690611d45565b600054610100900460ff16158080156109745750600054600160ff909116105b8061098e5750303b15801561098e575060005460ff166001145b6109aa5760405162461bcd60e51b815260040161079790611d9c565b6000805460ff1916600117905580156109cd576000805461ff0019166101001790555b8015610667576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb3847402498906020015b60405180910390a150565b61073d338383611158565b6040518060600160405280602d8152602001612242602d913981565b610a473383610e2b565b610a64576040516312a8eb0360e11b815260040160405180910390fd5b610a70848484846111f7565b50505050565b60606104e1826000611202565b6001600160a01b03918216600090815260046020908152604080832093909416825291909152205460ff1690565b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610afa5760405163d367b64f60e01b815260040160405180910390fd5b6000610b0784848461110c565b6000818152601660205260409020600101549091506001600160a01b031615610a7057610b3381610ea2565b604051630179c42b60e51b8152600481018290527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031690632f388560906024015b600060405180830381600087803b158015610b9657600080fd5b505af1158015610baa573d6000803e3d6000fd5b5050505050505050565b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610bfd5760405163d367b64f60e01b815260040160405180910390fd5b6000610c0a84848461110c565b6000818152601660205260409020600101549091506001600160a01b031615610a7057604051630852cd8d60e31b8152600481018290527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906342966c6890602401600060405180830381600087803b158015610c8f57600080fd5b505af1158015610ca3573d6000803e3d6000fd5b50505050610a708161135d565b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610cf95760405163d367b64f60e01b815260040160405180910390fd5b6000610d0684848461110c565b6000818152601660205260409020600101549091506001600160a01b0316610a7057610d34848484846113ec565b6040516340c10f1960e01b81526001600160a01b038381166004830152602482018390527f000000000000000000000000000000000000000000000000000000000000000016906340c10f1990604401610b7c565b6000818152601660205260409020600101546001600160a01b03166106675760405163eab95e3b60e01b815260040160405180910390fd5b600081815260036020908152604080832080546001600160a01b0319166001600160a01b038781169182179092556016909352818420600101549151859492909116917f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92591a45050565b600080610e3783610856565b9050806001600160a01b0316846001600160a01b03161480610e5e5750610e5e8185610a83565b806108bc5750836001600160a01b0316610e7784610579565b6001600160a01b031614949350505050565b60405163553a3f6560e11b815260040160405180910390fd5b6040518181527ff8e1a15aba9398e019f0b49df1a4fde98ee17ae345cb5f6b5e2c27f5033e8ce790602001610a0b565b6000610efc7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b6001600160a01b031603610f525760405162461bcd60e51b815260206004820152601d60248201527f5555505350726f786961626c653a206e6f742075706772616461626c650000006044820152606401610797565b806001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610f90573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610fb49190611ef8565b7f87e44dce6a0d65a5ccf441783661f5727c2624b1f0088bbe957ce2c95406b7841461102e5760405162461bcd60e51b815260206004820152602360248201527f5555505350726f786961626c653a206e6f7420636f6d70617469626c65206c6f60448201526267696360e81b6064820152608401610797565b6001600160a01b03811630036110865760405162461bcd60e51b815260206004820152601960248201527f5555505350726f786961626c653a2070726f7879206c6f6f70000000000000006044820152606401610797565b6110ae817f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc55565b7fe011bc04c286c344a8fcbb8de77f953da762c3e25d8cdea984147fc4168a5dcc7f87e44dce6a0d65a5ccf441783661f5727c2624b1f0088bbe957ce2c95406b784604080519182526001600160a01b038416602083015201610a0b565b60408051466020808301919091526001600160a01b03958616828401529385166060820152919093166080808301919091528351808303909101815260a0909101909252815191012090565b816001600160a01b0316836001600160a01b03160361118a5760405163d3c7732960e01b815260040160405180910390fd5b6001600160a01b03838116600081815260046020908152604080832094871680845294825291829020805460ff191686151590811790915591519182527f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a3505050565b610a70848484610e89565b6060600061120f846108c4565b805160208201516040808401519051631cd43d1160e31b81526001600160a01b0380851660048301529283166024820152908216604482015292935090916000917f0000000000000000000000000000000000000000000000000000000000000000169063e6a1e88890606401608060405180830381865afa158015611299573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906112bd9190611f11565b50509150506112ca61088f565b6112e1826bffffffffffffffffffffffff1661151b565b8661130857604051806040016040528060048152602001637472756560e01b815250611327565b6040518060400160405280600581526020016466616c736560d81b8152505b611330896115ae565b6040516020016113439493929190611f71565b604051602081830303815290604052935050505092915050565b60008181526016602081815260408084206001810180546003855283872080546001600160a01b0319908116909155959094528154851682558054909416909355600290920180546001600160c01b031916905590516001600160a01b0390911691839183907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908390a45050565b6001600160a01b03831661140257611402611ff9565b816001600160a01b0316836001600160a01b03160361142357611423611ff9565b6000818152601660205260409020600101546001600160a01b03161561144b5761144b611ff9565b604080516080810182526001600160a01b038087168252858116602080840182815287841685870190815263ffffffff4281166060880190815260008a81526016909552888520975188549088166001600160a01b0319918216178955935160018901805491891691909516179093559051600290960180549251909116600160a01b026001600160c01b03199092169590941694909417939093179091559151839291907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908290a450505050565b6060600061152883611729565b600101905060008167ffffffffffffffff81111561154857611548611add565b6040519080825280601f01601f191660200182016040528015611572576020820181803683370190505b5090508181016020015b600019016f181899199a1a9b1b9c1cb0b131b232b360811b600a86061a8153600a850494508461157c57509392505050565b606060006115bb836108c4565b90506115d581600001516001600160a01b03166014611801565b6115de4661151b565b82600001516001600160a01b03166395d89b416040518163ffffffff1660e01b8152600401600060405180830381865afa158015611620573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052611648919081019061200f565b61166084602001516001600160a01b03166014611801565b61167885604001516001600160a01b03166014611801565b6116e986600001516001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa1580156116bd573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116e19190612086565b60ff1661151b565b6116fc876060015163ffffffff1661151b565b60405160200161171297969594939291906120a9565b604051602081830303815290604052915050919050565b60008072184f03e93ff9f4daa797ed6e38ed64bf6a1f0160401b83106117685772184f03e93ff9f4daa797ed6e38ed64bf6a1f0160401b830492506040015b6d04ee2d6d415b85acef81000000008310611794576d04ee2d6d415b85acef8100000000830492506020015b662386f26fc1000083106117b257662386f26fc10000830492506010015b6305f5e10083106117ca576305f5e100830492506008015b61271083106117de57612710830492506004015b606483106117f0576064830492506002015b600a83106104e15760010192915050565b606060006118108360026121ea565b61181b906002612201565b67ffffffffffffffff81111561183357611833611add565b6040519080825280601f01601f19166020018201604052801561185d576020820181803683370190505b509050600360fc1b8160008151811061187857611878612214565b60200101906001600160f81b031916908160001a905350600f60fb1b816001815181106118a7576118a7612214565b60200101906001600160f81b031916908160001a90535060006118cb8460026121ea565b6118d6906001612201565b90505b600181111561194e576f181899199a1a9b1b9c1cb0b131b232b360811b85600f166010811061190a5761190a612214565b1a60f81b82828151811061192057611920612214565b60200101906001600160f81b031916908160001a90535060049490941c936119478161222a565b90506118d9565b50831561199d5760405162461bcd60e51b815260206004820181905260248201527f537472696e67733a20686578206c656e67746820696e73756666696369656e746044820152606401610797565b9392505050565b6000602082840312156119b657600080fd5b81356001600160e01b03198116811461199d57600080fd5b60005b838110156119e95781810151838201526020016119d1565b50506000910152565b6020815260008251806020840152611a118160408501602087016119ce565b601f01601f19169190910160400192915050565b600060208284031215611a3757600080fd5b5035919050565b6001600160a01b038116811461066757600080fd5b60008060408385031215611a6657600080fd5b8235611a7181611a3e565b946020939093013593505050565b600080600060608486031215611a9457600080fd5b8335611a9f81611a3e565b92506020840135611aaf81611a3e565b929592945050506040919091013590565b600060208284031215611ad257600080fd5b813561199d81611a3e565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f1916810167ffffffffffffffff81118282101715611b1c57611b1c611add565b604052919050565b600067ffffffffffffffff821115611b3e57611b3e611add565b50601f01601f191660200190565b6000611b5f611b5a84611b24565b611af3565b9050828152838383011115611b7357600080fd5b828260208301376000602084830101529392505050565b600082601f830112611b9b57600080fd5b61199d83833560208501611b4c565b60008060408385031215611bbd57600080fd5b823567ffffffffffffffff80821115611bd557600080fd5b611be186838701611b8a565b93506020850135915080821115611bf757600080fd5b50611c0485828601611b8a565b9150509250929050565b600080600060608486031215611c2357600080fd5b8335611c2e81611a3e565b92506020840135611c3e81611a3e565b91506040840135611c4e81611a3e565b809150509250925092565b60008060408385031215611c6c57600080fd5b8235611c7781611a3e565b915060208301358015158114611c8c57600080fd5b809150509250929050565b60008060008060808587031215611cad57600080fd5b8435611cb881611a3e565b93506020850135611cc881611a3e565b925060408501359150606085013567ffffffffffffffff811115611ceb57600080fd5b8501601f81018713611cfc57600080fd5b611d0b87823560208401611b4c565b91505092959194509250565b60008060408385031215611d2a57600080fd5b8235611d3581611a3e565b91506020830135611c8c81611a3e565b600181811c90821680611d5957607f821691505b602082108103611d7957634e487b7160e01b600052602260045260246000fd5b50919050565b600060208284031215611d9157600080fd5b815161199d81611a3e565b6020808252602e908201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160408201526d191e481a5b9a5d1a585b1a5e995960921b606082015260800190565b601f82111561062757600081815260208120601f850160051c81016020861015611e115750805b601f850160051c820191505b81811015611e3057828155600101611e1d565b505050505050565b815167ffffffffffffffff811115611e5257611e52611add565b611e6681611e608454611d45565b84611dea565b602080601f831160018114611e9b5760008415611e835750858301515b600019600386901b1c1916600185901b178555611e30565b600085815260208120601f198616915b82811015611eca57888601518255948401946001909101908401611eab565b5085821015611ee85787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b600060208284031215611f0a57600080fd5b5051919050565b60008060008060808587031215611f2757600080fd5b84519350602085015180600b0b8114611f3f57600080fd5b6040860151606090960151949790965092505050565b60008151611f678185602086016119ce565b9290920192915050565b60008551611f83818460208a016119ce565b693f666c6f77526174653d60b01b9083019081528551611faa81600a840160208a016119ce565b69266f7574676f696e673d60b01b600a92909101918201528451611fd58160148401602089016119ce565b8451910190611feb8160148401602088016119ce565b016014019695505050505050565b634e487b7160e01b600052600160045260246000fd5b60006020828403121561202157600080fd5b815167ffffffffffffffff81111561203857600080fd5b8201601f8101841361204957600080fd5b8051612057611b5a82611b24565b81815285602083850101111561206c57600080fd5b61207d8260208301602086016119ce565b95945050505050565b60006020828403121561209857600080fd5b815160ff8116811461199d57600080fd5b6e26746f6b656e5f616464726573733d60881b8152600088516120d381600f850160208d016119ce565b6926636861696e5f69643d60b01b600f9184019182015288516120fd816019840160208d016119ce565b6d26746f6b656e5f73796d626f6c3d60901b60199290910191820152875161212c816027840160208c016119ce565b672673656e6465723d60c01b60279290910191820152865161215581602f840160208b016119ce565b692672656365697665723d60b01b602f92909101918201526121c66121c06121a86121a2612186603986018b611f55565b6f26746f6b656e5f646563696d616c733d60801b815260100190565b88611f55565b6b2673746172745f646174653d60a01b8152600c0190565b85611f55565b9a9950505050505050505050565b634e487b7160e01b600052601160045260246000fd5b80820281158282048414176104e1576104e16121d4565b808201808211156104e1576104e16121d4565b634e487b7160e01b600052603260045260246000fd5b600081612239576122396121d4565b50600019019056fe68747470733a2f2f6e66742e7375706572666c7569642e66696e616e63652f6366612f76322f6765746d657461a26469706673582212203b9dd6a02755f03637386b7713c3b09e3c44c27052a37308197045810e69bb5664736f6c63430008130033";
const $d31c46b1a94ce036$var$isSuperArgs = (xs)=>xs.length > 1;
class $d31c46b1a94ce036$export$5ca92c4e583d35e7 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($d31c46b1a94ce036$var$isSuperArgs(args)) super(...args);
        else super($d31c46b1a94ce036$var$_abi, $d31c46b1a94ce036$var$_bytecode, args[0]);
    }
    deploy(host, constantInflowNFT, overrides) {
        return super.deploy(host, constantInflowNFT, overrides || {});
    }
    getDeployTransaction(host, constantInflowNFT, overrides) {
        return super.getDeployTransaction(host, constantInflowNFT, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($d31c46b1a94ce036$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $d31c46b1a94ce036$var$_abi, signerOrProvider);
    }
}
$d31c46b1a94ce036$export$5ca92c4e583d35e7.bytecode = $d31c46b1a94ce036$var$_bytecode;
$d31c46b1a94ce036$export$5ca92c4e583d35e7.abi = $d31c46b1a94ce036$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $04ca30cd1ece7c89$var$_abi = [
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CALLER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_APPROVE_TO_CURRENT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_INVALID_TOKEN_ID",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_ONLY_SUPER_TOKEN_FACTORY",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_CALLER_NOT_OWNER_OR_APPROVED_FOR_ALL",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_FROM_INCORRECT_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_IS_NOT_ALLOWED",
        type: "error"
    },
    {
        inputs: [],
        name: "CFA_NFT_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "MetadataUpdate",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_FLOW_AGREEMENT_V1",
        outputs: [
            {
                internalType: "contract IConstantFlowAgreementV1",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_BASE_URI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "flowDataByTokenId",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "superToken",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowSender",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "flowReceiver",
                        type: "address"
                    },
                    {
                        internalType: "uint32",
                        name: "flowStartDate",
                        type: "uint32"
                    }
                ],
                internalType: "struct IFlowNFTBase.FlowNFTData",
                name: "flowData",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "nftName",
                type: "string"
            },
            {
                internalType: "string",
                name: "nftSymbol",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "triggerMetadataUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $04ca30cd1ece7c89$export$7209e4ca0b1d24ba {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($04ca30cd1ece7c89$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $04ca30cd1ece7c89$var$_abi, signerOrProvider);
    }
}
$04ca30cd1ece7c89$export$7209e4ca0b1d24ba.abi = $04ca30cd1ece7c89$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $4d311b503ec6dee4$var$_abi = [
    {
        inputs: [],
        name: "FUSTP_ALREADY_INITIALIZED",
        type: "error"
    },
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
const $4d311b503ec6dee4$var$_bytecode = "0x608060405234801561001057600080fd5b50610213806100206000396000f3fe6080604052600436106100225760003560e01c80638129fc1c1461003957610031565b366100315761002f61004e565b005b61002f61004e565b34801561004557600080fd5b5061002f610060565b61005e6100596100d0565b610173565b565b7fb8fcd5719b3ddf8626f3664705a89b7fc476129a58c1aa5eda57c600cc1821a0546001600160a01b038116156100aa576040516305c5d81960e01b815260040160405180910390fd5b50337fb8fcd5719b3ddf8626f3664705a89b7fc476129a58c1aa5eda57c600cc1821a055565b7fb8fcd5719b3ddf8626f3664705a89b7fc476129a58c1aa5eda57c600cc1821a0546000906001600160a01b03811661010b5761010b610197565b806001600160a01b0316639470a5b26040518163ffffffff1660e01b8152600401602060405180830381865afa158015610149573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061016d91906101ad565b91505090565b3660008037600080366000845af43d6000803e808015610192573d6000f35b3d6000fd5b634e487b7160e01b600052600160045260246000fd5b6000602082840312156101bf57600080fd5b81516001600160a01b03811681146101d657600080fd5b939250505056fea26469706673582212208aedd930463a9ef04ca914601becd18e8316234054a71d6de40ce23faac57e5064736f6c63430008130033";
const $4d311b503ec6dee4$var$isSuperArgs = (xs)=>xs.length > 1;
class $4d311b503ec6dee4$export$59b993bbffd0daa5 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($4d311b503ec6dee4$var$isSuperArgs(args)) super(...args);
        else super($4d311b503ec6dee4$var$_abi, $4d311b503ec6dee4$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($4d311b503ec6dee4$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $4d311b503ec6dee4$var$_abi, signerOrProvider);
    }
}
$4d311b503ec6dee4$export$59b993bbffd0daa5.bytecode = $4d311b503ec6dee4$var$_bytecode;
$4d311b503ec6dee4$export$59b993bbffd0daa5.abi = $4d311b503ec6dee4$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $1d464973a3dff103$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            },
            {
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_BURN_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_MOVE_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_APPROVE_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_BURN_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_CALLER_IS_NOT_OPERATOR_FOR_HOLDER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_INFLATIONARY_DEFLATIONARY_NOT_SUPPORTED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_MINT_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NFT_PROXY_ADDRESS_CHANGED",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NOT_ERC777_TOKENS_RECIPIENT",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_NO_UNDERLYING_TOKEN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_ADMIN",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_GOV_OWNER",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_ONLY_SELF",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_FROM_ZERO_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "SUPER_TOKEN_TRANSFER_TO_ZERO_ADDRESS",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldAdmin",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "AdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "bondAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidatedBy",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAmountReceiver",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            }
        ],
        name: "AgreementLiquidatedV2",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            }
        ],
        name: "AgreementStateUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            }
        ],
        name: "AgreementTerminated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "AuthorizedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bailoutAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "Bailout",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Burned",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantInflowNFT",
                name: "constantInflowNFT",
                type: "address"
            }
        ],
        name: "ConstantInflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IConstantOutflowNFT",
                name: "constantOutflowNFT",
                type: "address"
            }
        ],
        name: "ConstantOutflowNFTCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Minted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "RevokedOperator",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "Sent",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenDowngraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenUpgraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "CONSTANT_INFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantInflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CONSTANT_OUTFLOW_NFT",
        outputs: [
            {
                internalType: "contract IConstantOutflowNFT",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "authorizeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "createAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "defaultOperators",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "downgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountActiveAgreements",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementData",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementStateSlot",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingDecimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getUnderlyingToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "granularity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "underlyingDecimals",
                type: "uint8"
            },
            {
                internalType: "string",
                name: "n",
                type: "string"
            },
            {
                internalType: "string",
                name: "s",
                type: "string"
            },
            {
                internalType: "address",
                name: "admin",
                type: "address"
            }
        ],
        name: "initializeWithAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountCritical",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountCriticalNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountSolvent",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountSolventNow",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "address",
                name: "tokenHolder",
                type: "address"
            }
        ],
        name: "isOperatorFor",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            },
            {
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool"
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            }
        ],
        name: "makeLiquidationPayoutsV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationApprove",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "operationDecreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationDowngrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "operationIncreaseAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "operationSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "operationUpgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "operatorData",
                type: "bytes"
            }
        ],
        name: "operatorSend",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "revokeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfApproveFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfBurn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "selfMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "selfTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256"
            }
        ],
        name: "settleBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "terminateAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "toUnderlyingAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "underlyingAmount",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "adjustedAmount",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            }
        ],
        name: "transferAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementStateSlot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $1d464973a3dff103$var$_bytecode = "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";
const $1d464973a3dff103$var$isSuperArgs = (xs)=>xs.length > 1;
class $1d464973a3dff103$export$cbc22afec4cc8ef extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($1d464973a3dff103$var$isSuperArgs(args)) super(...args);
        else super($1d464973a3dff103$var$_abi, $1d464973a3dff103$var$_bytecode, args[0]);
    }
    deploy(host, constantOutflowNFT, constantInflowNFT, overrides) {
        return super.deploy(host, constantOutflowNFT, constantInflowNFT, overrides || {});
    }
    getDeployTransaction(host, constantOutflowNFT, constantInflowNFT, overrides) {
        return super.getDeployTransaction(host, constantOutflowNFT, constantInflowNFT, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($1d464973a3dff103$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $1d464973a3dff103$var$_abi, signerOrProvider);
    }
}
$1d464973a3dff103$export$cbc22afec4cc8ef.bytecode = $1d464973a3dff103$var$_bytecode;
$1d464973a3dff103$export$cbc22afec4cc8ef.abi = $1d464973a3dff103$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $40eed9bec2e63e98$var$_abi = [
    {
        inputs: [
            {
                internalType: "bool",
                name: "nonUpgradable",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "appWhiteListingEnabled",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_code",
                type: "uint256"
            }
        ],
        name: "APP_RULE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_ALREADY_REGISTERED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_CALLBACK_IS_NOT_ACTION",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_IS_NOT_REGISTERED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_CALL_AGREEMENT_WITH_CTX_FROM_WRONG_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_CALL_APP_ACTION_WITH_CTX_FROM_WRONG_ADDRESS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_CANNOT_DOWNGRADE_TO_NON_UPGRADEABLE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_INVALID_CONFIG_WORD",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_MAX_256_AGREEMENTS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_MUST_BE_CONTRACT",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NEED_MORE_GAS",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NON_UPGRADEABLE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NON_ZERO_LENGTH_PLACEHOLDER_CTX",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NOT_A_SUPER_APP",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_NO_APP_REGISTRATION_PERMISSION",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_ONLY_GOVERNANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_RECEIVER_IS_NOT_SUPER_APP",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SENDER_IS_NOT_SUPER_APP",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SOURCE_APP_NEEDS_HIGHER_APP_LEVEL",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SUPER_APP_ALREADY_REGISTERED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_SUPER_APP_IS_JAILED",
        type: "error"
    },
    {
        inputs: [],
        name: "HOST_UNKNOWN_BATCH_CALL_OPERATION_TYPE",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address"
            }
        ],
        name: "AgreementClassRegistered",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address"
            }
        ],
        name: "AgreementClassUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "AppRegistered",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ISuperfluidGovernance",
                name: "oldGov",
                type: "address"
            },
            {
                indexed: false,
                internalType: "contract ISuperfluidGovernance",
                name: "newGov",
                type: "address"
            }
        ],
        name: "GovernanceReplaced",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reason",
                type: "uint256"
            }
        ],
        name: "Jail",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ISuperTokenFactory",
                name: "newFactory",
                type: "address"
            }
        ],
        name: "SuperTokenFactoryUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address"
            }
        ],
        name: "SuperTokenLogicUpdated",
        type: "event"
    },
    {
        inputs: [],
        name: "APP_WHITE_LISTING_ENABLED",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "CALLBACK_GAS_LIMIT",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "MAX_APP_CALLBACK_LEVEL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "MAX_NUM_AGREEMENTS",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "NON_UPGRADABLE_DEPLOYMENT",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256"
            },
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "addToAgreementClassesBitmap",
        outputs: [
            {
                internalType: "uint256",
                name: "newBitmap",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "targetApp",
                type: "address"
            }
        ],
        name: "allowCompositeApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "int256",
                name: "appCreditUsedDelta",
                type: "int256"
            }
        ],
        name: "appCallbackPop",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "appCreditGranted",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "appCreditUsed",
                type: "int256"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "appCreditToken",
                type: "address"
            }
        ],
        name: "appCallbackPush",
        outputs: [
            {
                internalType: "bytes",
                name: "appCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "operationType",
                        type: "uint32"
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address"
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes"
                    }
                ],
                internalType: "struct ISuperfluid.Operation[]",
                name: "operations",
                type: "tuple[]"
            }
        ],
        name: "batchCall",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "callAgreement",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAgreementWithContext",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            }
        ],
        name: "callAppAction",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppActionWithContext",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bool",
                name: "isTermination",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppAfterCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes"
            },
            {
                internalType: "bool",
                name: "isTermination",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "callAppBeforeCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeSuperTokenAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "int256",
                name: "appCreditUsedMore",
                type: "int256"
            }
        ],
        name: "ctxUseCredit",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "decodeCtx",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "appCallbackLevel",
                        type: "uint8"
                    },
                    {
                        internalType: "uint8",
                        name: "callType",
                        type: "uint8"
                    },
                    {
                        internalType: "uint256",
                        name: "timestamp",
                        type: "uint256"
                    },
                    {
                        internalType: "address",
                        name: "msgSender",
                        type: "address"
                    },
                    {
                        internalType: "bytes4",
                        name: "agreementSelector",
                        type: "bytes4"
                    },
                    {
                        internalType: "bytes",
                        name: "userData",
                        type: "bytes"
                    },
                    {
                        internalType: "uint256",
                        name: "appCreditGranted",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "appCreditWantedDeprecated",
                        type: "uint256"
                    },
                    {
                        internalType: "int256",
                        name: "appCreditUsed",
                        type: "int256"
                    },
                    {
                        internalType: "address",
                        name: "appAddress",
                        type: "address"
                    },
                    {
                        internalType: "contract ISuperfluidToken",
                        name: "appCreditToken",
                        type: "address"
                    }
                ],
                internalType: "struct ISuperfluid.Context",
                name: "context",
                type: "tuple"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "operationType",
                        type: "uint32"
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address"
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes"
                    }
                ],
                internalType: "struct ISuperfluid.Operation[]",
                name: "operations",
                type: "tuple[]"
            }
        ],
        name: "forwardBatchCall",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "getAgreementClass",
        outputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "appAddr",
                type: "address"
            }
        ],
        name: "getAppCallbackLevel",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "getAppManifest",
        outputs: [
            {
                internalType: "bool",
                name: "isSuperApp",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "isJailed",
                type: "bool"
            },
            {
                internalType: "uint256",
                name: "noopMask",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getGovernance",
        outputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getNow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenFactory",
        outputs: [
            {
                internalType: "contract ISuperTokenFactory",
                name: "factory",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getSuperTokenFactoryLogic",
        outputs: [
            {
                internalType: "address",
                name: "logic",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "gov",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address"
            }
        ],
        name: "isAgreementClassListed",
        outputs: [
            {
                internalType: "bool",
                name: "yes",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "isAgreementTypeListed",
        outputs: [
            {
                internalType: "bool",
                name: "yes",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "isApp",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            }
        ],
        name: "isAppJailed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "contract ISuperApp",
                name: "targetApp",
                type: "address"
            }
        ],
        name: "isCompositeAppAllowed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            }
        ],
        name: "isCtxValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "isTrustedForwarder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes"
            },
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "reason",
                type: "uint256"
            }
        ],
        name: "jailApp",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256"
            }
        ],
        name: "mapAgreementClasses",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "agreementClasses",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClassLogic",
                type: "address"
            }
        ],
        name: "registerAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            }
        ],
        name: "registerAppByFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        name: "registerAppWithKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256"
            },
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32"
            }
        ],
        name: "removeFromAgreementClassesBitmap",
        outputs: [
            {
                internalType: "uint256",
                name: "newBitmap",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "newGov",
                type: "address"
            }
        ],
        name: "replaceGovernance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClassLogic",
                type: "address"
            }
        ],
        name: "updateAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperTokenFactory",
                name: "newFactory",
                type: "address"
            }
        ],
        name: "updateSuperTokenFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "newLogicOverride",
                type: "address"
            }
        ],
        name: "updateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "versionRecipient",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "pure",
        type: "function"
    }
];
const $40eed9bec2e63e98$var$_bytecode = "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";
const $40eed9bec2e63e98$var$isSuperArgs = (xs)=>xs.length > 1;
class $40eed9bec2e63e98$export$797d13a20ff60701 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($40eed9bec2e63e98$var$isSuperArgs(args)) super(...args);
        else super($40eed9bec2e63e98$var$_abi, $40eed9bec2e63e98$var$_bytecode, args[0]);
    }
    deploy(nonUpgradable, appWhiteListingEnabled, overrides) {
        return super.deploy(nonUpgradable, appWhiteListingEnabled, overrides || {});
    }
    getDeployTransaction(nonUpgradable, appWhiteListingEnabled, overrides) {
        return super.getDeployTransaction(nonUpgradable, appWhiteListingEnabled, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($40eed9bec2e63e98$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $40eed9bec2e63e98$var$_abi, signerOrProvider);
    }
}
$40eed9bec2e63e98$export$797d13a20ff60701.bytecode = $40eed9bec2e63e98$var$_bytecode;
$40eed9bec2e63e98$export$797d13a20ff60701.abi = $40eed9bec2e63e98$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $561ecb7d3c49fbcc$var$_abi = [
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_ALREADY_EXISTS",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_AGREEMENT_DOES_NOT_EXIST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_BURN_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_MOVE_INSUFFICIENT_BALANCE",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_HOST",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_TOKEN_ONLY_LISTED_AGREEMENT",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementCreated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "rewardAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "penaltyAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "bondAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "AgreementLiquidatedBy",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAmountReceiver",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            }
        ],
        name: "AgreementLiquidatedV2",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            }
        ],
        name: "AgreementStateUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            }
        ],
        name: "AgreementTerminated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "AgreementUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bailoutAccount",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bailoutAmount",
                type: "uint256"
            }
        ],
        name: "Bailout",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "createAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountActiveAgreements",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementData",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "getAgreementStateSlot",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getHost",
        outputs: [
            {
                internalType: "address",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountCritical",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountCriticalNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCritical",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "isAccountSolvent",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isAccountSolventNow",
        outputs: [
            {
                internalType: "bool",
                name: "isSolvent",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "liquidationTypeData",
                type: "bytes"
            },
            {
                internalType: "address",
                name: "liquidatorAccount",
                type: "address"
            },
            {
                internalType: "bool",
                name: "useDefaultRewardAccount",
                type: "bool"
            },
            {
                internalType: "address",
                name: "targetAccount",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256"
            },
            {
                internalType: "int256",
                name: "targetAccountBalanceDelta",
                type: "int256"
            }
        ],
        name: "makeLiquidationPayoutsV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "int256",
                name: "delta",
                type: "int256"
            }
        ],
        name: "settleBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256"
            }
        ],
        name: "terminateAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "data",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "slotId",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "slotData",
                type: "bytes32[]"
            }
        ],
        name: "updateAgreementStateSlot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $561ecb7d3c49fbcc$export$87d595716e2065e0 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($561ecb7d3c49fbcc$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $561ecb7d3c49fbcc$var$_abi, signerOrProvider);
    }
}
$561ecb7d3c49fbcc$export$87d595716e2065e0.abi = $561ecb7d3c49fbcc$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $280d10a0e7597608$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenDowngraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "TokenUpgraded",
        type: "event"
    },
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "wad",
                type: "uint256"
            }
        ],
        name: "downgradeToETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialAddress",
                type: "address"
            }
        ],
        name: "initializeProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "upgradeByETH",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            }
        ],
        name: "upgradeByETHTo",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
const $280d10a0e7597608$var$_bytecode = "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";
const $280d10a0e7597608$var$isSuperArgs = (xs)=>xs.length > 1;
class $280d10a0e7597608$export$ff870ba96dbf00f9 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($280d10a0e7597608$var$isSuperArgs(args)) super(...args);
        else super($280d10a0e7597608$var$_abi, $280d10a0e7597608$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($280d10a0e7597608$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $280d10a0e7597608$var$_abi, signerOrProvider);
    }
}
$280d10a0e7597608$export$ff870ba96dbf00f9.bytecode = $280d10a0e7597608$var$_bytecode;
$280d10a0e7597608$export$ff870ba96dbf00f9.abi = $280d10a0e7597608$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $6b8e190622ddc36e$var$_abi = [
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "initialSupply",
                type: "uint256"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialAddress",
                type: "address"
            }
        ],
        name: "initializeProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
const $6b8e190622ddc36e$var$_bytecode = "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";
const $6b8e190622ddc36e$var$isSuperArgs = (xs)=>xs.length > 1;
class $6b8e190622ddc36e$export$ab70eaa126277277 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($6b8e190622ddc36e$var$isSuperArgs(args)) super(...args);
        else super($6b8e190622ddc36e$var$_abi, $6b8e190622ddc36e$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($6b8e190622ddc36e$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $6b8e190622ddc36e$var$_abi, signerOrProvider);
    }
}
$6b8e190622ddc36e$export$ab70eaa126277277.bytecode = $6b8e190622ddc36e$var$_bytecode;
$6b8e190622ddc36e$export$ab70eaa126277277.abi = $6b8e190622ddc36e$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $7b25733162818003$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        name: "CodeUpdated",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address"
            }
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $7b25733162818003$export$85bf317f49d74e6b {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($7b25733162818003$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $7b25733162818003$var$_abi, signerOrProvider);
    }
}
$7b25733162818003$export$85bf317f49d74e6b.abi = $7b25733162818003$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $84b7fc4229b80b46$var$_abi = [
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialAddress",
                type: "address"
            }
        ],
        name: "initializeProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
const $84b7fc4229b80b46$var$_bytecode = "0x608060405234801561001057600080fd5b5061022a806100206000396000f3fe6080604052600436106100225760003560e01c80634a0687ef1461003957610031565b366100315761002f610059565b005b61002f610059565b34801561004557600080fd5b5061002f6100543660046101c4565b61006b565b610069610064610171565b6101a0565b565b6001600160a01b0381166100c65760405162461bcd60e51b815260206004820152601760248201527f5555505350726f78793a207a65726f206164647265737300000000000000000060448201526064015b60405180910390fd5b60006100f07f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b6001600160a01b0316146101465760405162461bcd60e51b815260206004820152601e60248201527f5555505350726f78793a20616c726561647920696e697469616c697a6564000060448201526064016100bd565b61016e817f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc55565b50565b600061019b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b905090565b3660008037600080366000845af43d6000803e8080156101bf573d6000f35b3d6000fd5b6000602082840312156101d657600080fd5b81356001600160a01b03811681146101ed57600080fd5b939250505056fea264697066735822122093a2bbcf49dd2895177212eeb11e9921080374fd8cd93d5be93a80935603195a64736f6c63430008130033";
const $84b7fc4229b80b46$var$isSuperArgs = (xs)=>xs.length > 1;
class $84b7fc4229b80b46$export$33d472f04da998d8 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($84b7fc4229b80b46$var$isSuperArgs(args)) super(...args);
        else super($84b7fc4229b80b46$var$_abi, $84b7fc4229b80b46$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($84b7fc4229b80b46$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $84b7fc4229b80b46$var$_abi, signerOrProvider);
    }
}
$84b7fc4229b80b46$export$33d472f04da998d8.bytecode = $84b7fc4229b80b46$var$_bytecode;
$84b7fc4229b80b46$export$33d472f04da998d8.abi = $84b7fc4229b80b46$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $55dea0fd53d7f0be$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        name: "ExitRateChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "pic",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bond",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        name: "NewPIC",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "int96",
                name: "newExitRate",
                type: "int96"
            }
        ],
        name: "changeExitRate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "getCurrentPIC",
        outputs: [
            {
                internalType: "address",
                name: "pic",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "getCurrentPICInfo",
        outputs: [
            {
                internalType: "address",
                name: "pic",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bond",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256"
            }
        ],
        name: "getDefaultExitRateFor",
        outputs: [
            {
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256"
            }
        ],
        name: "getMaxExitRateFor",
        outputs: [
            {
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $55dea0fd53d7f0be$export$4e2fbb6c36a92588 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($55dea0fd53d7f0be$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $55dea0fd53d7f0be$var$_abi, signerOrProvider);
    }
}
$55dea0fd53d7f0be$export$4e2fbb6c36a92588.abi = $55dea0fd53d7f0be$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $6094f7681bd664c5$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "additionalBond",
                type: "uint256"
            }
        ],
        name: "BondIncreased",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        name: "ExitRateChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "pic",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bond",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        name: "NewPIC",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "int96",
                name: "newExitRate",
                type: "int96"
            }
        ],
        name: "changeExitRate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "getCurrentPIC",
        outputs: [
            {
                internalType: "address",
                name: "pic",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "getCurrentPICInfo",
        outputs: [
            {
                internalType: "address",
                name: "pic",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bond",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256"
            }
        ],
        name: "getDefaultExitRateFor",
        outputs: [
            {
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256"
            }
        ],
        name: "getMaxExitRateFor",
        outputs: [
            {
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "withdrawFundsInCustody",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
class $6094f7681bd664c5$export$a3fad4618035ce0c {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($6094f7681bd664c5$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $6094f7681bd664c5$var$_abi, signerOrProvider);
    }
}
$6094f7681bd664c5$export$a3fad4618035ce0c.abi = $6094f7681bd664c5$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $5ab8a925a5e4a0a1$var$_abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "additionalBond",
                type: "uint256"
            }
        ],
        name: "BondIncreased",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        name: "ExitRateChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "pic",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bond",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        name: "NewPIC",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "int96",
                name: "newExitRate",
                type: "int96"
            }
        ],
        name: "changeExitRate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "getCurrentPIC",
        outputs: [
            {
                internalType: "address",
                name: "pic",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "getCurrentPICInfo",
        outputs: [
            {
                internalType: "address",
                name: "pic",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bond",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256"
            }
        ],
        name: "getDefaultExitRateFor",
        outputs: [
            {
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256"
            }
        ],
        name: "getMaxExitRateFor",
        outputs: [
            {
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
class $5ab8a925a5e4a0a1$export$4f3a8a748eb81062 {
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($5ab8a925a5e4a0a1$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $5ab8a925a5e4a0a1$var$_abi, signerOrProvider);
    }
}
$5ab8a925a5e4a0a1$export$4f3a8a748eb81062.abi = $5ab8a925a5e4a0a1$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $c8a37775c52277ad$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host_",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "minBondDuration_",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "additionalBond",
                type: "uint256"
            }
        ],
        name: "BondIncreased",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        name: "ExitRateChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "pic",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bond",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        name: "NewPIC",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "int96",
                name: "newExitRate",
                type: "int96"
            }
        ],
        name: "changeExitRate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "getCurrentPIC",
        outputs: [
            {
                internalType: "address",
                name: "pic",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            }
        ],
        name: "getCurrentPICInfo",
        outputs: [
            {
                internalType: "address",
                name: "pic",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bond",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256"
            }
        ],
        name: "getDefaultExitRateFor",
        outputs: [
            {
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256"
            }
        ],
        name: "getMaxExitRateFor",
        outputs: [
            {
                internalType: "int96",
                name: "exitRate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "minBondDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }
        ],
        name: "tokensReceived",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $c8a37775c52277ad$var$_bytecode = "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";
const $c8a37775c52277ad$var$isSuperArgs = (xs)=>xs.length > 1;
class $c8a37775c52277ad$export$18161a1c29f97770 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($c8a37775c52277ad$var$isSuperArgs(args)) super(...args);
        else super($c8a37775c52277ad$var$_abi, $c8a37775c52277ad$var$_bytecode, args[0]);
    }
    deploy(host_, minBondDuration_, overrides) {
        return super.deploy(host_, minBondDuration_, overrides || {});
    }
    getDeployTransaction(host_, minBondDuration_, overrides) {
        return super.getDeployTransaction(host_, minBondDuration_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($c8a37775c52277ad$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $c8a37775c52277ad$var$_abi, signerOrProvider);
    }
}
$c8a37775c52277ad$export$18161a1c29f97770.bytecode = $c8a37775c52277ad$var$_bytecode;
$c8a37775c52277ad$export$18161a1c29f97770.abi = $c8a37775c52277ad$var$_abi;




/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $31addb9f2fc2e525$var$_abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "host_",
                type: "address"
            },
            {
                internalType: "address",
                name: "cfa_",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "ARRAY_SIZES_DIFFERENT",
        type: "error"
    },
    {
        inputs: [],
        name: "cfa",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "deleteFlow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address[]",
                name: "senders",
                type: "address[]"
            },
            {
                internalType: "address[]",
                name: "receivers",
                type: "address[]"
            }
        ],
        name: "deleteFlows",
        outputs: [
            {
                internalType: "uint256",
                name: "nSuccess",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "host",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $31addb9f2fc2e525$var$_bytecode = "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";
const $31addb9f2fc2e525$var$isSuperArgs = (xs)=>xs.length > 1;
class $31addb9f2fc2e525$export$2eb5be5ceccaba9d extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($31addb9f2fc2e525$var$isSuperArgs(args)) super(...args);
        else super($31addb9f2fc2e525$var$_abi, $31addb9f2fc2e525$var$_bytecode, args[0]);
    }
    deploy(host_, cfa_, overrides) {
        return super.deploy(host_, cfa_, overrides || {});
    }
    getDeployTransaction(host_, cfa_, overrides) {
        return super.getDeployTransaction(host_, cfa_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($31addb9f2fc2e525$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $31addb9f2fc2e525$var$_abi, signerOrProvider);
    }
}
$31addb9f2fc2e525$export$2eb5be5ceccaba9d.bytecode = $31addb9f2fc2e525$var$_bytecode;
$31addb9f2fc2e525$export$2eb5be5ceccaba9d.abi = $31addb9f2fc2e525$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $bba15bd706dcb09f$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "CFA_FWD_INVALID_FLOW_RATE",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowrate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "createFlow",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "deleteFlow",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountFlowInfo",
        outputs: [
            {
                internalType: "uint256",
                name: "lastUpdated",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "flowrate",
                type: "int96"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "getAccountFlowrate",
        outputs: [
            {
                internalType: "int96",
                name: "flowrate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowrate",
                type: "int96"
            }
        ],
        name: "getBufferAmountByFlowrate",
        outputs: [
            {
                internalType: "uint256",
                name: "bufferAmount",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getFlowInfo",
        outputs: [
            {
                internalType: "uint256",
                name: "lastUpdated",
                type: "uint256"
            },
            {
                internalType: "int96",
                name: "flowrate",
                type: "int96"
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            }
        ],
        name: "getFlowOperatorPermissions",
        outputs: [
            {
                internalType: "uint8",
                name: "permissions",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "flowrateAllowance",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "getFlowrate",
        outputs: [
            {
                internalType: "int96",
                name: "flowrate",
                type: "int96"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            }
        ],
        name: "grantPermissions",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            }
        ],
        name: "revokePermissions",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowrate",
                type: "int96"
            }
        ],
        name: "setFlowrate",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowrate",
                type: "int96"
            }
        ],
        name: "setFlowrateFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            },
            {
                internalType: "int96",
                name: "flowrate",
                type: "int96"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateFlow",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "permissions",
                type: "uint8"
            },
            {
                internalType: "int96",
                name: "flowrateAllowance",
                type: "int96"
            }
        ],
        name: "updateFlowOperatorPermissions",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $bba15bd706dcb09f$var$_bytecode = "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";
const $bba15bd706dcb09f$var$isSuperArgs = (xs)=>xs.length > 1;
class $bba15bd706dcb09f$export$a2855e93a59184f0 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($bba15bd706dcb09f$var$isSuperArgs(args)) super(...args);
        else super($bba15bd706dcb09f$var$_abi, $bba15bd706dcb09f$var$_bytecode, args[0]);
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($bba15bd706dcb09f$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $bba15bd706dcb09f$var$_abi, signerOrProvider);
    }
}
$bba15bd706dcb09f$export$a2855e93a59184f0.bytecode = $bba15bd706dcb09f$var$_bytecode;
$bba15bd706dcb09f$export$a2855e93a59184f0.abi = $bba15bd706dcb09f$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $97e6036cb7945e3b$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "approveSubscription",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128"
            }
        ],
        name: "calculateDistribution",
        outputs: [
            {
                internalType: "uint256",
                name: "actualAmount",
                type: "uint256"
            },
            {
                internalType: "uint128",
                name: "newIndexValue",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "createIndex",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "deleteSubscription",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "distribute",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "getIndex",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsApproved",
                type: "uint128"
            },
            {
                internalType: "uint128",
                name: "totalUnitsPending",
                type: "uint128"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            }
        ],
        name: "getPublisherId",
        outputs: [
            {
                internalType: "bytes32",
                name: "publisherId",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "getSubscription",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "subscriptionId",
                type: "bytes32"
            }
        ],
        name: "getSubscriptionByID",
        outputs: [
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "publisherId",
                type: "bytes32"
            }
        ],
        name: "getSubscriptionId",
        outputs: [
            {
                internalType: "bytes32",
                name: "subscriptionId",
                type: "bytes32"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            }
        ],
        name: "listSubscriptions",
        outputs: [
            {
                internalType: "address[]",
                name: "publishers",
                type: "address[]"
            },
            {
                internalType: "uint32[]",
                name: "indexIds",
                type: "uint32[]"
            },
            {
                internalType: "uint128[]",
                name: "unitsList",
                type: "uint128[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "revokeSubscription",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateIndex",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32"
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address"
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128"
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes"
            }
        ],
        name: "updateSubscriptionUnits",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $97e6036cb7945e3b$var$_bytecode = "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";
const $97e6036cb7945e3b$var$isSuperArgs = (xs)=>xs.length > 1;
class $97e6036cb7945e3b$export$51f73308176f8660 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($97e6036cb7945e3b$var$isSuperArgs(args)) super(...args);
        else super($97e6036cb7945e3b$var$_abi, $97e6036cb7945e3b$var$_bytecode, args[0]);
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($97e6036cb7945e3b$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $97e6036cb7945e3b$var$_abi, signerOrProvider);
    }
}
$97e6036cb7945e3b$export$51f73308176f8660.bytecode = $97e6036cb7945e3b$var$_bytecode;
$97e6036cb7945e3b$export$51f73308176f8660.abi = $97e6036cb7945e3b$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $560dc15c6d1f868e$var$_abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32"
            }
        ],
        name: "RoleAdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleGranted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleRevoked",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                indexed: false,
                internalType: "address",
                name: "target",
                type: "address"
            }
        ],
        name: "Set",
        type: "event"
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string"
            }
        ],
        name: "get",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            }
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            }
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            }
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "address",
                name: "target",
                type: "address"
            }
        ],
        name: "set",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $560dc15c6d1f868e$var$_bytecode = "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";
const $560dc15c6d1f868e$var$isSuperArgs = (xs)=>xs.length > 1;
class $560dc15c6d1f868e$export$d5298427584c1f4b extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($560dc15c6d1f868e$var$isSuperArgs(args)) super(...args);
        else super($560dc15c6d1f868e$var$_abi, $560dc15c6d1f868e$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($560dc15c6d1f868e$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $560dc15c6d1f868e$var$_abi, signerOrProvider);
    }
}
$560dc15c6d1f868e$export$d5298427584c1f4b.bytecode = $560dc15c6d1f868e$var$_bytecode;
$560dc15c6d1f868e$export$d5298427584c1f4b.abi = $560dc15c6d1f868e$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $88f6ef635bf0d51f$var$_abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "adminRole",
                type: "address"
            },
            {
                internalType: "address[]",
                name: "backendAddr",
                type: "address[]"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "OptinAutoUpgrade",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "OptoutAutoUpgrade",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32"
            }
        ],
        name: "RoleAdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleGranted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleRevoked",
        type: "event"
    },
    {
        inputs: [],
        name: "BACKEND_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getBackendAgents",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            }
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            }
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            }
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "grantBackendAgent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "isBackendAgent",
        outputs: [
            {
                internalType: "bool",
                name: "yes",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "optinAutoUpgrades",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "optoutAutoUpgrades",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "revokeBackendAgent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superTokenAddr",
                type: "address"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $88f6ef635bf0d51f$var$_bytecode = "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";
const $88f6ef635bf0d51f$var$isSuperArgs = (xs)=>xs.length > 1;
class $88f6ef635bf0d51f$export$a301df9ed7d37c1e extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($88f6ef635bf0d51f$var$isSuperArgs(args)) super(...args);
        else super($88f6ef635bf0d51f$var$_abi, $88f6ef635bf0d51f$var$_bytecode, args[0]);
    }
    deploy(adminRole, backendAddr, overrides) {
        return super.deploy(adminRole, backendAddr, overrides || {});
    }
    getDeployTransaction(adminRole, backendAddr, overrides) {
        return super.getDeployTransaction(adminRole, backendAddr, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($88f6ef635bf0d51f$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $88f6ef635bf0d51f$var$_abi, signerOrProvider);
    }
}
$88f6ef635bf0d51f$export$a301df9ed7d37c1e.bytecode = $88f6ef635bf0d51f$var$_bytecode;
$88f6ef635bf0d51f$export$a301df9ed7d37c1e.abi = $88f6ef635bf0d51f$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $deb78e172c5382ae$var$_abi = [
    {
        inputs: [],
        name: "DEPLOY_AGREEMENTS_REQUIRES_DEPLOY_CORE",
        type: "error"
    },
    {
        inputs: [],
        name: "DEPLOY_PERIPHERALS_REQUIRES_DEPLOY_AGREEMENTS",
        type: "error"
    },
    {
        inputs: [],
        name: "DEPLOY_PERIPHERALS_REQUIRES_DEPLOY_CORE",
        type: "error"
    },
    {
        inputs: [],
        name: "DEPLOY_SUPER_TOKEN_CONTRACTS_REQUIRES_DEPLOY_CORE",
        type: "error"
    },
    {
        inputs: [],
        name: "DEPLOY_SUPER_TOKEN_REQUIRES_1820",
        type: "error"
    },
    {
        inputs: [],
        name: "DEPLOY_SUPER_TOKEN_REQUIRES_DEPLOY_SUPER_TOKEN_CONTRACTS",
        type: "error"
    },
    {
        inputs: [],
        name: "DEPLOY_TOGA_REQUIRES_1820",
        type: "error"
    },
    {
        inputs: [],
        name: "RESOLVER_LIST_REQUIRES_DEPLOY_PERIPHERALS",
        type: "error"
    },
    {
        inputs: [],
        name: "DEFAULT_APP_WHITELISTING_ENABLED",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_LIQUIDATION_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_NON_UPGRADEABLE",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_PATRICIAN_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_REWARD_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_TOGA_MIN_BOND_DURATION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        name: "DEFAULT_TRUSTED_FORWARDERS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "RESOLVER_BASE_SUPER_TOKEN_KEY",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "RESOLVER_BASE_TOKEN_KEY",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "deployAgreementContracts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "deployCoreContracts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "nonUpgradeable",
                        type: "bool"
                    },
                    {
                        internalType: "bool",
                        name: "appWhitelistingEnabled",
                        type: "bool"
                    },
                    {
                        internalType: "address[]",
                        name: "trustedForwarders",
                        type: "address[]"
                    },
                    {
                        internalType: "address",
                        name: "defaultRewardAddress",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "liquidationPeriod",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "patricianPeriod",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "minBondDuration",
                        type: "uint256"
                    }
                ],
                internalType: "struct SuperfluidFrameworkDeployer.TestFrameworkConfigs",
                name: "configs",
                type: "tuple"
            }
        ],
        name: "deployCoreContracts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string"
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string"
            }
        ],
        name: "deployNativeAssetSuperToken",
        outputs: [
            {
                internalType: "contract ISETH",
                name: "nativeAssetSuperToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "deployPeripheralContracts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "nonUpgradeable",
                        type: "bool"
                    },
                    {
                        internalType: "bool",
                        name: "appWhitelistingEnabled",
                        type: "bool"
                    },
                    {
                        internalType: "address[]",
                        name: "trustedForwarders",
                        type: "address[]"
                    },
                    {
                        internalType: "address",
                        name: "defaultRewardAddress",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "liquidationPeriod",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "patricianPeriod",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "minBondDuration",
                        type: "uint256"
                    }
                ],
                internalType: "struct SuperfluidFrameworkDeployer.TestFrameworkConfigs",
                name: "configs",
                type: "tuple"
            }
        ],
        name: "deployPeripheralContracts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string"
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "_initialSupply",
                type: "uint256"
            }
        ],
        name: "deployPureSuperToken",
        outputs: [
            {
                internalType: "contract IPureSuperToken",
                name: "pureSuperToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "deploySuperTokenContracts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "deployTestFramework",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_underlyingName",
                type: "string"
            },
            {
                internalType: "string",
                name: "_underlyingSymbol",
                type: "string"
            },
            {
                internalType: "uint8",
                name: "_decimals",
                type: "uint8"
            },
            {
                internalType: "uint256",
                name: "_mintLimit",
                type: "uint256"
            }
        ],
        name: "deployWrapperSuperToken",
        outputs: [
            {
                internalType: "contract TestToken",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "contract SuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_underlyingName",
                type: "string"
            },
            {
                internalType: "string",
                name: "_underlyingSymbol",
                type: "string"
            },
            {
                internalType: "uint8",
                name: "_decimals",
                type: "uint8"
            },
            {
                internalType: "uint256",
                name: "_mintLimit",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "_admin",
                type: "address"
            }
        ],
        name: "deployWrapperSuperToken",
        outputs: [
            {
                internalType: "contract TestToken",
                name: "underlyingToken",
                type: "address"
            },
            {
                internalType: "contract SuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "step",
                type: "uint8"
            }
        ],
        name: "executeStep",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "getFramework",
        outputs: [
            {
                components: [
                    {
                        internalType: "contract TestGovernance",
                        name: "governance",
                        type: "address"
                    },
                    {
                        internalType: "contract Superfluid",
                        name: "host",
                        type: "address"
                    },
                    {
                        internalType: "contract ConstantFlowAgreementV1",
                        name: "cfa",
                        type: "address"
                    },
                    {
                        components: [
                            {
                                internalType: "contract ISuperfluid",
                                name: "host",
                                type: "address"
                            },
                            {
                                internalType: "contract IConstantFlowAgreementV1",
                                name: "cfa",
                                type: "address"
                            }
                        ],
                        internalType: "struct CFAv1Library.InitData",
                        name: "cfaLib",
                        type: "tuple"
                    },
                    {
                        internalType: "contract InstantDistributionAgreementV1",
                        name: "ida",
                        type: "address"
                    },
                    {
                        components: [
                            {
                                internalType: "contract ISuperfluid",
                                name: "host",
                                type: "address"
                            },
                            {
                                internalType: "contract IInstantDistributionAgreementV1",
                                name: "ida",
                                type: "address"
                            }
                        ],
                        internalType: "struct IDAv1Library.InitData",
                        name: "idaLib",
                        type: "tuple"
                    },
                    {
                        internalType: "contract SuperTokenFactory",
                        name: "superTokenFactory",
                        type: "address"
                    },
                    {
                        internalType: "contract ISuperToken",
                        name: "superTokenLogic",
                        type: "address"
                    },
                    {
                        internalType: "contract ConstantOutflowNFT",
                        name: "constantOutflowNFT",
                        type: "address"
                    },
                    {
                        internalType: "contract ConstantInflowNFT",
                        name: "constantInflowNFT",
                        type: "address"
                    },
                    {
                        internalType: "contract TestResolver",
                        name: "resolver",
                        type: "address"
                    },
                    {
                        internalType: "contract SuperfluidLoader",
                        name: "superfluidLoader",
                        type: "address"
                    },
                    {
                        internalType: "contract CFAv1Forwarder",
                        name: "cfaV1Forwarder",
                        type: "address"
                    },
                    {
                        internalType: "contract IDAv1Forwarder",
                        name: "idaV1Forwarder",
                        type: "address"
                    },
                    {
                        internalType: "contract TOGA",
                        name: "toga",
                        type: "address"
                    }
                ],
                internalType: "struct SuperfluidFrameworkDeploymentSteps.Framework",
                name: "sf",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getNumSteps",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $deb78e172c5382ae$var$_bytecode = "0x6000608081905260a060408190526200001a9190816200002f565b503480156200002857600080fd5b50620000b0565b82805482825590600052602060002090810192821562000087579160200282015b828111156200008757825182546001600160a01b0319166001600160a01b0390911617825560209092019160019091019062000050565b506200009592915062000099565b5090565b5b808211156200009557600081556001016200009a565b61590780620000c06000396000f3fe60806040523480156200001157600080fd5b5060043610620001755760003560e01c80637dc2dc1211620000d3578063c8c25ad51162000086578063c8c25ad5146200031c578063cbcd7449146200032c578063dac4ea821462000343578063dfa98ad5146200035a578063f2fde38b14620004db578063fa0215fc14620004f257600080fd5b80637dc2dc1214620002a2578063888a37b114620002da57806393786bf014620002e5578063acbeaa0714620002ee578063ad6eb4991462000305578063b3083cf8146200023157600080fd5b80634d59c136116200012c5780634d59c1361462000227578063520994701462000231578063547047c7146200024b57806362a32e1e14620002555780637296cb5a146200028157806376f30be8146200029857600080fd5b806305bfa3e0146200017a57806306e8358614620001975780631903410d14620001a35780632a49664814620001d357806338bc37a414620001dd5780633df285fe14620001e7575b600080fd5b6200018461070881565b6040519081526020015b60405180910390f35b620001a162000509565b005b620001ba620001b436600462002b1b565b62000515565b6040516001600160a01b0390911681526020016200018e565b620001a162000540565b620001a16200054a565b620002186040518060400160405280601181526020017039bab832b93a37b5b2b739973a32b9ba1760791b81525081565b6040516200018e919062002b89565b6200018461384081565b6200023a600081565b60405190151581526020016200018e565b620001a16200056d565b620002186040518060400160405280600c81526020016b3a37b5b2b739973a32b9ba1760a11b81525081565b620001a16200029236600462002cf3565b6200058b565b620001a162000596565b620002b9620002b336600462002e1e565b62000637565b604080516001600160a01b039384168152929091166020830152016200018e565b6200018462093a8081565b620001ba604581565b620001a1620002ff36600462002eb3565b620006ba565b620001a16200031636600462002cf3565b620006c5565b604051600881526020016200018e565b620001ba6200033d36600462002ed3565b620006d0565b620002b96200035436600462002f46565b620008e0565b620004cc604080516101e08101825260008082526020808301829052828401829052835180850185528281528082018390526060840152608083018290528351808501909452818452830181905260a082019290925260c0810182905260e08101829052610100810182905261012081018290526101408101829052610160810182905261018081018290526101a081018290526101c081019190915250604080516101e0810182526001546001600160a01b03610100918290048116835260025481166020808501829052600354831685870181905286518088018852838152808301919091526060860152600554831660808601819052865180880190975291865285015260a0830193909352600c54831660c0830152600b54831660e0830152600954831690820152600a548216610120820152600e548216610140820152600f548216610160820152601054821661018082015260115482166101a08201526013549091166101c082015290565b6040516200018e919062002ff1565b620001a1620004ec36600462003199565b62000963565b620001ba62000503366004620031b9565b620009cd565b6200051362000c4a565b565b600081815481106200052657600080fd5b6000918252602090912001546001600160a01b0316905081565b6200051362000c88565b6200055462002ab5565b60018152600060208201526200056a8162000cd0565b50565b6200057762002ab5565b62093a8060c08201526200056a8162000cef565b6200056a8162000cef565b6040805160e08101825260008082526020808301829052815484518183028101830186528181529294840192918591908301828280156200060157602002820191906000526020600020905b81546001600160a01b03168152600190910190602001808311620005e2575b5050509183525050604560208201526138406040820152610708606082015262093a8060809091015290506200056a8162000de4565b600c5460009081906001600160a01b03166200066657604051635006ee6d60e11b815260040160405180910390fd5b731820a4b7618bde71dce8cdc73aab6c95905fad243b6200069957604051622b682760e71b815260040160405180910390fd5b620006ab888888888888600062000e68565b91509150965096945050505050565b6200056a81620011d1565b6200056a8162000cd0565b600c546000906001600160a01b0316620006fd57604051635006ee6d60e11b815260040160405180910390fd5b731820a4b7618bde71dce8cdc73aab6c95905fad243b6200073057604051622b682760e71b815260040160405180910390fd5b600073__$e670fb80a00d783cff26adce1c19b32070$__63f7c3bdc96040518163ffffffff1660e01b8152600401602060405180830381865af41580156200077c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620007a2919062003234565b600c54604051633504b4d160e21b81526001600160a01b03808416600483015292945084935091169063d412d34490602401600060405180830381600087803b158015620007ef57600080fd5b505af115801562000804573d6000803e3d6000fd5b50506040516285fc1360e71b81526001600160a01b03851692506342fe0980915062000841906000906012908b908b908b908b906004016200327d565b600060405180830381600087803b1580156200085c57600080fd5b505af115801562000871573d6000803e3d6000fd5b5050505060006040518060400160405280601181526020017039bab832b93a37b5b2b739973a32b9ba1760791b8152508585604051602001620008b793929190620032cf565b6040516020818303038152906040529050620008d660018285620013a9565b5050949350505050565b600c5460009081906001600160a01b03166200090f57604051635006ee6d60e11b815260040160405180910390fd5b731820a4b7618bde71dce8cdc73aab6c95905fad243b6200094257604051622b682760e71b815260040160405180910390fd5b620009538989898989898962000e68565b9150915097509795505050505050565b60015460405163f2fde38b60e01b81526001600160a01b0383811660048301526101009092049091169063f2fde38b90602401600060405180830381600087803b158015620009b157600080fd5b505af1158015620009c6573d6000803e3d6000fd5b5050505050565b600c546000906001600160a01b0316620009fa57604051635006ee6d60e11b815260040160405180910390fd5b731820a4b7618bde71dce8cdc73aab6c95905fad243b62000a2d57604051622b682760e71b815260040160405180910390fd5b600073__$e670fb80a00d783cff26adce1c19b32070$__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__$e670fb80a00d783cff26adce1c19b32070$__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__$a470d8d3eff4182c9809d6de570cdeeec8$__90631b7577fe90602401602060405180830381865af4158015620014a5573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620014cb919062003234565b600480546001600160a01b0319166001600160a01b0392909216919091179055565b600254604051630cce0ce360e31b81526001600160a01b03909116600482015273__$0e33a7228bbdb017aebe2f2bed0910defa$__90636670671890602401602060405180830381865af41580156200154a573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062001570919062003234565b600680546001600160a01b0319166001600160a01b0392909216919091179055565b600073__$587c1447ad460e9b007894b8b359c425ea$__63c465e06c6040518163ffffffff1660e01b8152600401602060405180830381865af4158015620015de573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062001604919062003234565b9050600073__$587c1447ad460e9b007894b8b359c425ea$__63c465e06c6040518163ffffffff1660e01b8152600401602060405180830381865af415801562001652573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062001678919062003234565b600254604051635e1673bb60e11b81526001600160a01b039182166004820152908216602482015290915073__$342a172af7bf09406042436203b53e0416$__9063bc2ce77690604401602060405180830381865af4158015620016e0573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062001706919062003234565b600780546001600160a01b0319166001600160a01b039290921691821790556040805163132075a760e31b81529051639903ad389160048082019260009290919082900301818387803b1580156200175d57600080fd5b505af115801562001772573d6000803e3d6000fd5b50506002546040516326c043d360e11b81526001600160a01b039182166004820152908516602482015273__$342a172af7bf09406042436203b53e0416$__9250634d8087a69150604401602060405180830381865af4158015620017db573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062001801919062003234565b600880546001600160a01b0319166001600160a01b039290921691821790556040805163132075a760e31b81529051639903ad389160048082019260009290919082900301818387803b1580156200185857600080fd5b505af11580156200186d573d6000803e3d6000fd5b5050600754604051634a0687ef60e01b81526001600160a01b0391821660048201529085169250634a0687ef9150602401600060405180830381600087803b158015620018b957600080fd5b505af1158015620018ce573d6000803e3d6000fd5b5050600854604051634a0687ef60e01b81526001600160a01b0391821660048201529084169250634a0687ef9150602401600060405180830381600087803b1580156200191a57600080fd5b505af11580156200192f573d6000803e3d6000fd5b50506040805163266c45bb60e11b81526004810191909152601460448201527310dbdb9cdd185b9d0813dd5d199b1bddc813919560621b606482015260806024820152600360848201526221a7a360e91b60a48201526001600160a01b0385169250634cd88b76915060c401600060405180830381600087803b158015620019b657600080fd5b505af1158015620019cb573d6000803e3d6000fd5b50506040805163266c45bb60e11b81526004810191909152601360448201527210dbdb9cdd185b9d08125b999b1bddc8139195606a1b606482015260806024820152600360848201526221a4a360e91b60a48201526001600160a01b0384169250634cd88b76915060c401600060405180830381600087803b15801562001a5157600080fd5b505af115801562001a66573d6000803e3d6000fd5b5050600980546001600160a01b039586166001600160a01b031991821617909155600a8054949095169316929092179092555050565b600254600954600a54604051630e07777960e31b81526001600160a01b039384166004820152918316602483015291909116604482015273__$bd96dfe50c329cee8e313709d3c94b8122$__9063703bbbc890606401602060405180830381865af415801562001b10573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062001b36919062003234565b600b80546001600160a01b0319166001600160a01b0392909216919091179055565b600254600b54600754600854604051630243059d60e01b81526001600160a01b0394851660048201529284166024840152908316604483015291909116606482015273__$859a28afbbc8e5bf0b546dc5c4495c32e6$__90630243059d90608401602060405180830381865af415801562001bd7573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062001bfd919062003234565b600d80546001600160a01b0319166001600160a01b0392909216919091179055565b73__$02c95dd9d7be6f60f760f29aee4bb17ffc$__63c3acf1b36040518163ffffffff1660e01b8152600401602060405180830381865af415801562001c69573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062001c8f919062003234565b60018054610100600160a81b0319166101006001600160a01b0393841681029190911791829055604051633f5b172b60e11b8152910482166004820152908216602482015273__$02c95dd9d7be6f60f760f29aee4bb17ffc$__90637eb62e569060440160006040518083038186803b15801562001d0c57600080fd5b505af4158015620009c6573d6000803e3d6000fd5b604051638a25422160e01b81528215156004820152811515602482015273__$ad779358bf46e2140b9444ea344feed6e1$__90638a25422190604401602060405180830381865af415801562001d7b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062001da1919062003234565b600280546001600160a01b0319166001600160a01b03929092169190911790555050565b604051632f0f279d60e01b81526001600160a01b038216600482015273__$859a28afbbc8e5bf0b546dc5c4495c32e6$__90632f0f279d90602401602060405180830381865af415801562001e1e573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062001e44919062003234565b600e80546001600160a01b0319166001600160a01b039290921691909117905550565b600e54604051630b5bd8c560e01b81526001600160a01b03909116600482015273__$51a374af64471c67800fb4db73e0bb3f61$__90630b5bd8c590602401602060405180830381865af415801562001ec4573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062001eea919062003234565b600f80546001600160a01b0319166001600160a01b0392909216919091179055565b60025460405163269c683160e11b81526001600160a01b03909116600482015273__$62fc974fc919b81fb994c71922b697bf1a$__90634d38d06290602401602060405180830381865af415801562001f69573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062001f8f919062003234565b601080546001600160a01b0319166001600160a01b0392909216919091179055565b600254604051623b2bcd60e01b81526001600160a01b03909116600482015273__$a8b7c5720cdda94a7f5cdf662a74179e74$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";
const $deb78e172c5382ae$var$isSuperArgs = (xs)=>{
    return typeof xs[0] === "string" || Array.isArray(xs[0]) || "_isInterface" in xs[0];
};
class $deb78e172c5382ae$export$f6b8ea7785aac5ea extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($deb78e172c5382ae$var$isSuperArgs(args)) super(...args);
        else {
            const [linkLibraryAddresses, signer] = args;
            super($deb78e172c5382ae$var$_abi, $deb78e172c5382ae$export$f6b8ea7785aac5ea.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = $deb78e172c5382ae$var$_bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$e670fb80a00d783cff26adce1c19b32070\\$__", "g"), linkLibraryAddresses["contracts/utils/SuperfluidFrameworkDeploymentSteps.sol:TokenDeployerLibrary"].replace(/^0x/, "").toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$a470d8d3eff4182c9809d6de570cdeeec8\\$__", "g"), linkLibraryAddresses["contracts/utils/SuperfluidFrameworkDeploymentSteps.sol:SuperfluidCFAv1DeployerLibrary"].replace(/^0x/, "").toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$0e33a7228bbdb017aebe2f2bed0910defa\\$__", "g"), linkLibraryAddresses["contracts/utils/SuperfluidFrameworkDeploymentSteps.sol:SuperfluidIDAv1DeployerLibrary"].replace(/^0x/, "").toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$587c1447ad460e9b007894b8b359c425ea\\$__", "g"), linkLibraryAddresses["contracts/utils/SuperfluidFrameworkDeploymentSteps.sol:ProxyDeployerLibrary"].replace(/^0x/, "").toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$342a172af7bf09406042436203b53e0416\\$__", "g"), linkLibraryAddresses["contracts/utils/SuperfluidFrameworkDeploymentSteps.sol:SuperfluidNFTLogicDeployerLibrary"].replace(/^0x/, "").toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$bd96dfe50c329cee8e313709d3c94b8122\\$__", "g"), linkLibraryAddresses["contracts/utils/SuperfluidFrameworkDeploymentSteps.sol:SuperTokenDeployerLibrary"].replace(/^0x/, "").toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$859a28afbbc8e5bf0b546dc5c4495c32e6\\$__", "g"), linkLibraryAddresses["contracts/utils/SuperfluidFrameworkDeploymentSteps.sol:SuperfluidPeripheryDeployerLibrary"].replace(/^0x/, "").toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$02c95dd9d7be6f60f760f29aee4bb17ffc\\$__", "g"), linkLibraryAddresses["contracts/utils/SuperfluidFrameworkDeploymentSteps.sol:SuperfluidGovDeployerLibrary"].replace(/^0x/, "").toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$ad779358bf46e2140b9444ea344feed6e1\\$__", "g"), linkLibraryAddresses["contracts/utils/SuperfluidFrameworkDeploymentSteps.sol:SuperfluidHostDeployerLibrary"].replace(/^0x/, "").toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$51a374af64471c67800fb4db73e0bb3f61\\$__", "g"), linkLibraryAddresses["contracts/utils/SuperfluidFrameworkDeploymentSteps.sol:SuperfluidLoaderDeployerLibrary"].replace(/^0x/, "").toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$62fc974fc919b81fb994c71922b697bf1a\\$__", "g"), linkLibraryAddresses["contracts/utils/SuperfluidFrameworkDeploymentSteps.sol:CFAv1ForwarderDeployerLibrary"].replace(/^0x/, "").toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$a8b7c5720cdda94a7f5cdf662a74179e74\\$__", "g"), linkLibraryAddresses["contracts/utils/SuperfluidFrameworkDeploymentSteps.sol:IDAv1ForwarderDeployerLibrary"].replace(/^0x/, "").toLowerCase());
        return linkedBytecode;
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($deb78e172c5382ae$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $deb78e172c5382ae$var$_abi, signerOrProvider);
    }
}
$deb78e172c5382ae$export$f6b8ea7785aac5ea.bytecode = $deb78e172c5382ae$var$_bytecode;
$deb78e172c5382ae$export$f6b8ea7785aac5ea.abi = $deb78e172c5382ae$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $5d7f7981843ab6c1$var$_abi = [
    {
        inputs: [],
        name: "DEFAULT_APP_WHITELISTING_ENABLED",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_LIQUIDATION_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_NON_UPGRADEABLE",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_PATRICIAN_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_REWARD_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "DEFAULT_TOGA_MIN_BOND_DURATION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        name: "DEFAULT_TRUSTED_FORWARDERS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "RESOLVER_BASE_SUPER_TOKEN_KEY",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "RESOLVER_BASE_TOKEN_KEY",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getFramework",
        outputs: [
            {
                components: [
                    {
                        internalType: "contract TestGovernance",
                        name: "governance",
                        type: "address"
                    },
                    {
                        internalType: "contract Superfluid",
                        name: "host",
                        type: "address"
                    },
                    {
                        internalType: "contract ConstantFlowAgreementV1",
                        name: "cfa",
                        type: "address"
                    },
                    {
                        components: [
                            {
                                internalType: "contract ISuperfluid",
                                name: "host",
                                type: "address"
                            },
                            {
                                internalType: "contract IConstantFlowAgreementV1",
                                name: "cfa",
                                type: "address"
                            }
                        ],
                        internalType: "struct CFAv1Library.InitData",
                        name: "cfaLib",
                        type: "tuple"
                    },
                    {
                        internalType: "contract InstantDistributionAgreementV1",
                        name: "ida",
                        type: "address"
                    },
                    {
                        components: [
                            {
                                internalType: "contract ISuperfluid",
                                name: "host",
                                type: "address"
                            },
                            {
                                internalType: "contract IInstantDistributionAgreementV1",
                                name: "ida",
                                type: "address"
                            }
                        ],
                        internalType: "struct IDAv1Library.InitData",
                        name: "idaLib",
                        type: "tuple"
                    },
                    {
                        internalType: "contract SuperTokenFactory",
                        name: "superTokenFactory",
                        type: "address"
                    },
                    {
                        internalType: "contract ISuperToken",
                        name: "superTokenLogic",
                        type: "address"
                    },
                    {
                        internalType: "contract ConstantOutflowNFT",
                        name: "constantOutflowNFT",
                        type: "address"
                    },
                    {
                        internalType: "contract ConstantInflowNFT",
                        name: "constantInflowNFT",
                        type: "address"
                    },
                    {
                        internalType: "contract TestResolver",
                        name: "resolver",
                        type: "address"
                    },
                    {
                        internalType: "contract SuperfluidLoader",
                        name: "superfluidLoader",
                        type: "address"
                    },
                    {
                        internalType: "contract CFAv1Forwarder",
                        name: "cfaV1Forwarder",
                        type: "address"
                    },
                    {
                        internalType: "contract IDAv1Forwarder",
                        name: "idaV1Forwarder",
                        type: "address"
                    },
                    {
                        internalType: "contract TOGA",
                        name: "toga",
                        type: "address"
                    }
                ],
                internalType: "struct SuperfluidFrameworkDeploymentSteps.Framework",
                name: "sf",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $5d7f7981843ab6c1$var$_bytecode = "0x6000608081905260a0604081905261001891908161002b565b5034801561002557600080fd5b506100a5565b828054828255906000526020600020908101928215610080579160200282015b8281111561008057825182546001600160a01b0319166001600160a01b0390911617825560209092019160019091019061004b565b5061008c929150610090565b5090565b5b8082111561008c5760008155600101610091565b610620806100b46000396000f3fe608060405234801561001057600080fd5b50600436106100a95760003560e01c806362a32e1e1161007157806362a32e1e14610153578063888a37b11461017e57806393786bf014610188578063b3083cf81461013b578063dfa98ad514610190578063f2fde38b1461030e57600080fd5b806305bfa3e0146100ae5780631903410d146100ca5780633df285fe146100f55780634d59c13614610132578063520994701461013b575b600080fd5b6100b761070881565b6040519081526020015b60405180910390f35b6100dd6100d83660046103b5565b610323565b6040516001600160a01b0390911681526020016100c1565b6101256040518060400160405280601181526020017039bab832b93a37b5b2b739973a32b9ba1760791b81525081565b6040516100c191906103ce565b6100b761384081565b610143600081565b60405190151581526020016100c1565b6101256040518060400160405280600c81526020016b3a37b5b2b739973a32b9ba1760a11b81525081565b6100b762093a8081565b6100dd604581565b610301604080516101e08101825260008082526020808301829052828401829052835180850185528281528082018390526060840152608083018290528351808501909452818452830181905260a082019290925260c0810182905260e08101829052610100810182905261012081018290526101408101829052610160810182905261018081018290526101a081018290526101c081019190915250604080516101e0810182526001546001600160a01b03610100918290048116835260025481166020808501829052600354831685870181905286518088018852838152808301919091526060860152600554831660808601819052865180880190975291865285015260a0830193909352600c54831660c0830152600b54831660e0830152600954831690820152600a548216610120820152600e548216610140820152600f548216610160820152601054821661018082015260115482166101a08201526013549091166101c082015290565b6040516100c1919061041c565b61032161031c3660046105ba565b61034d565b005b6000818154811061033357600080fd5b6000918252602090912001546001600160a01b0316905081565b60015460405163f2fde38b60e01b81526001600160a01b0383811660048301526101009092049091169063f2fde38b90602401600060405180830381600087803b15801561039a57600080fd5b505af11580156103ae573d6000803e3d6000fd5b5050505050565b6000602082840312156103c757600080fd5b5035919050565b600060208083528351808285015260005b818110156103fb578581018301518582016040015282016103df565b506000604082860101526040601f19601f8301168501019250505092915050565b81516001600160a01b031681526102208101602083015161044860208401826001600160a01b03169052565b50604083015161046360408401826001600160a01b03169052565b50606083015161048c606084018280516001600160a01b03908116835260209182015116910152565b5060808301516001600160a01b03811660a08401525060a083015180516001600160a01b0390811660c085015260208201511660e08401525060c08301516101006104e1818501836001600160a01b03169052565b60e085015191506101206104ff818601846001600160a01b03169052565b9085015191506101409061051d858301846001600160a01b03169052565b8501519150610160610539858201846001600160a01b03169052565b90850151915061018090610557858301846001600160a01b03169052565b85015191506101a0610573858201846001600160a01b03169052565b9085015191506101c090610591858301846001600160a01b03169052565b8501516001600160a01b039081166101e086015294015190931661020090920191909152919050565b6000602082840312156105cc57600080fd5b81356001600160a01b03811681146105e357600080fd5b939250505056fea264697066735822122071b2b79ff7318d4bc50209fd9141f9b9fabff2849178bfdd08e9c51a7735c87164736f6c63430008130033";
const $5d7f7981843ab6c1$var$isSuperArgs = (xs)=>xs.length > 1;
class $5d7f7981843ab6c1$export$be2d872d74813e8b extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($5d7f7981843ab6c1$var$isSuperArgs(args)) super(...args);
        else super($5d7f7981843ab6c1$var$_abi, $5d7f7981843ab6c1$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($5d7f7981843ab6c1$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $5d7f7981843ab6c1$var$_abi, signerOrProvider);
    }
}
$5d7f7981843ab6c1$export$be2d872d74813e8b.bytecode = $5d7f7981843ab6c1$var$_bytecode;
$5d7f7981843ab6c1$export$be2d872d74813e8b.abi = $5d7f7981843ab6c1$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $2b004edc6bca4d22$var$_abi = [
    {
        inputs: [
            {
                internalType: "contract IResolver",
                name: "resolver",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "releaseVersion",
                type: "string"
            }
        ],
        name: "loadFramework",
        outputs: [
            {
                components: [
                    {
                        internalType: "contract ISuperfluid",
                        name: "superfluid",
                        type: "address"
                    },
                    {
                        internalType: "contract ISuperTokenFactory",
                        name: "superTokenFactory",
                        type: "address"
                    },
                    {
                        internalType: "contract ISuperAgreement",
                        name: "agreementCFAv1",
                        type: "address"
                    },
                    {
                        internalType: "contract ISuperAgreement",
                        name: "agreementIDAv1",
                        type: "address"
                    }
                ],
                internalType: "struct SuperfluidLoader.Framework",
                name: "result",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $2b004edc6bca4d22$var$_bytecode = "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";
const $2b004edc6bca4d22$var$isSuperArgs = (xs)=>xs.length > 1;
class $2b004edc6bca4d22$export$c5b358a80319e471 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($2b004edc6bca4d22$var$isSuperArgs(args)) super(...args);
        else super($2b004edc6bca4d22$var$_abi, $2b004edc6bca4d22$var$_bytecode, args[0]);
    }
    deploy(resolver, overrides) {
        return super.deploy(resolver, overrides || {});
    }
    getDeployTransaction(resolver, overrides) {
        return super.getDeployTransaction(resolver, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($2b004edc6bca4d22$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $2b004edc6bca4d22$var$_abi, signerOrProvider);
    }
}
$2b004edc6bca4d22$export$c5b358a80319e471.bytecode = $2b004edc6bca4d22$var$_bytecode;
$2b004edc6bca4d22$export$c5b358a80319e471.abi = $2b004edc6bca4d22$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $cb8c07d3b963fe65$var$_abi = [
    {
        inputs: [],
        name: "SF_GOV_INVALID_LIQUIDATION_OR_PATRICIAN_PERIOD",
        type: "error"
    },
    {
        inputs: [],
        name: "SF_GOV_MUST_BE_CONTRACT",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "factory",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "authorized",
                type: "bool"
            }
        ],
        name: "AppFactoryAuthorizationChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                indexed: false,
                internalType: "string",
                name: "appRegistrationKey",
                type: "string"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "expirationTs",
                type: "uint256"
            }
        ],
        name: "AppRegistrationKeyChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            }
        ],
        name: "CFAv1LiquidationPeriodChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "ConfigChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "OwnershipTransferred",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            }
        ],
        name: "PPPConfigurationChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "address",
                name: "rewardAddress",
                type: "address"
            }
        ],
        name: "RewardAddressChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "minimumDeposit",
                type: "uint256"
            }
        ],
        name: "SuperTokenMinimumDepositChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isKeySet",
                type: "bool"
            },
            {
                indexed: false,
                internalType: "address",
                name: "forwarder",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool"
            }
        ],
        name: "TrustedForwarderChanged",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "factory",
                type: "address"
            }
        ],
        name: "authorizeAppFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "token",
                type: "address[]"
            },
            {
                internalType: "address[]",
                name: "newAdmins",
                type: "address[]"
            }
        ],
        name: "batchChangeSuperTokenAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            }
        ],
        name: "batchUpdateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            },
            {
                internalType: "address[]",
                name: "tokenLogics",
                type: "address[]"
            }
        ],
        name: "batchUpdateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken[]",
                name: "tokens",
                type: "address[]"
            },
            {
                internalType: "uint256[]",
                name: "minimumDeposits",
                type: "uint256[]"
            }
        ],
        name: "batchUpdateSuperTokenMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address"
            },
            {
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "changeSuperTokenAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        name: "clearAppRegistrationKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "clearConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "clearPPPConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "clearRewardAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "clearSuperTokenMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "disableTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "enableTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "getConfigAsAddress",
        outputs: [
            {
                internalType: "address",
                name: "value",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            }
        ],
        name: "getConfigAsUint256",
        outputs: [
            {
                internalType: "uint256",
                name: "period",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "getPPPConfig",
        outputs: [
            {
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "getRewardAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            }
        ],
        name: "getSuperTokenMinimumDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "rewardAddress",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            },
            {
                internalType: "address[]",
                name: "trustedForwarders",
                type: "address[]"
            }
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "factory",
                type: "address"
            }
        ],
        name: "isAuthorizedAppFactory",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "forwarder",
                type: "address"
            }
        ],
        name: "isTrustedForwarder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address"
            }
        ],
        name: "registerAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "newGov",
                type: "address"
            }
        ],
        name: "replaceGovernance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "expirationTs",
                type: "uint256"
            }
        ],
        name: "setAppRegistrationKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "value",
                type: "address"
            }
        ],
        name: "setConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "setConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "liquidationPeriod",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "patricianPeriod",
                type: "uint256"
            }
        ],
        name: "setPPPConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "address",
                name: "rewardAddress",
                type: "address"
            }
        ],
        name: "setRewardAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "setSuperTokenMinimumDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "factory",
                type: "address"
            }
        ],
        name: "unauthorizeAppFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "hostNewLogic",
                type: "address"
            },
            {
                internalType: "address[]",
                name: "agreementClassNewLogics",
                type: "address[]"
            },
            {
                internalType: "address",
                name: "superTokenFactoryNewLogic",
                type: "address"
            }
        ],
        name: "updateContracts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address"
            },
            {
                internalType: "address",
                name: "deployer",
                type: "address"
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string"
            }
        ],
        name: "verifyAppRegistrationKey",
        outputs: [
            {
                internalType: "bool",
                name: "validNow",
                type: "bool"
            },
            {
                internalType: "uint256",
                name: "expirationTs",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $cb8c07d3b963fe65$var$_bytecode = "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";
const $cb8c07d3b963fe65$var$isSuperArgs = (xs)=>xs.length > 1;
class $cb8c07d3b963fe65$export$4f298d2859475694 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($cb8c07d3b963fe65$var$isSuperArgs(args)) super(...args);
        else super($cb8c07d3b963fe65$var$_abi, $cb8c07d3b963fe65$var$_bytecode, args[0]);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($cb8c07d3b963fe65$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $cb8c07d3b963fe65$var$_abi, signerOrProvider);
    }
}
$cb8c07d3b963fe65$export$4f298d2859475694.bytecode = $cb8c07d3b963fe65$var$_bytecode;
$cb8c07d3b963fe65$export$4f298d2859475694.abi = $cb8c07d3b963fe65$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $1ca1615624944c1f$var$_abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_additionalAdmin",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32"
            }
        ],
        name: "RoleAdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleGranted",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "RoleRevoked",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                indexed: false,
                internalType: "address",
                name: "target",
                type: "address"
            }
        ],
        name: "Set",
        type: "event"
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_additionalAdmin",
                type: "address"
            }
        ],
        name: "addAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string"
            }
        ],
        name: "get",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            }
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            }
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            }
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32"
            },
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "address",
                name: "target",
                type: "address"
            }
        ],
        name: "set",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $1ca1615624944c1f$var$_bytecode = "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";
const $1ca1615624944c1f$var$isSuperArgs = (xs)=>xs.length > 1;
class $1ca1615624944c1f$export$2a0dba090510fac6 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($1ca1615624944c1f$var$isSuperArgs(args)) super(...args);
        else super($1ca1615624944c1f$var$_abi, $1ca1615624944c1f$var$_bytecode, args[0]);
    }
    deploy(_additionalAdmin, overrides) {
        return super.deploy(_additionalAdmin, overrides || {});
    }
    getDeployTransaction(_additionalAdmin, overrides) {
        return super.getDeployTransaction(_additionalAdmin, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($1ca1615624944c1f$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $1ca1615624944c1f$var$_abi, signerOrProvider);
    }
}
$1ca1615624944c1f$export$2a0dba090510fac6.bytecode = $1ca1615624944c1f$var$_bytecode;
$1ca1615624944c1f$export$2a0dba090510fac6.abi = $1ca1615624944c1f$var$_abi;


/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ 
const $fa0a31ad7f56f963$var$_abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "uint8",
                name: "initDecimals",
                type: "uint8"
            },
            {
                internalType: "uint256",
                name: "mintLimit",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "InvalidShortString",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "str",
                type: "string"
            }
        ],
        name: "StringTooLong",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [],
        name: "EIP712DomainChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "eip712Domain",
        outputs: [
            {
                internalType: "bytes1",
                name: "fields",
                type: "bytes1"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "version",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "verifyingContract",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32"
            },
            {
                internalType: "uint256[]",
                name: "extensions",
                type: "uint256[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "mint",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256"
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8"
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32"
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32"
            }
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
const $fa0a31ad7f56f963$var$_bytecode = "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";
const $fa0a31ad7f56f963$var$isSuperArgs = (xs)=>xs.length > 1;
class $fa0a31ad7f56f963$export$51519634c3e5a6c9 extends (0, $b84bae218d85c3ca$export$505569a6bf584fd9) {
    constructor(...args){
        if ($fa0a31ad7f56f963$var$isSuperArgs(args)) super(...args);
        else super($fa0a31ad7f56f963$var$_abi, $fa0a31ad7f56f963$var$_bytecode, args[0]);
    }
    deploy(name, symbol, initDecimals, mintLimit, overrides) {
        return super.deploy(name, symbol, initDecimals, mintLimit, overrides || {});
    }
    getDeployTransaction(name, symbol, initDecimals, mintLimit, overrides) {
        return super.getDeployTransaction(name, symbol, initDecimals, mintLimit, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new (0, $0e788201f8a90b1e$exports).Interface($fa0a31ad7f56f963$var$_abi);
    }
    static connect(address, signerOrProvider) {
        return new (0, $b84bae218d85c3ca$export$8517d80acf00e19a)(address, $fa0a31ad7f56f963$var$_abi, signerOrProvider);
    }
}
$fa0a31ad7f56f963$export$51519634c3e5a6c9.bytecode = $fa0a31ad7f56f963$var$_bytecode;
$fa0a31ad7f56f963$export$51519634c3e5a6c9.abi = $fa0a31ad7f56f963$var$_abi;

























































































































































/* eslint-disable */ var $e3914ff439c443e6$export$2e2bcd8739ae039 = [
    {
        "name": "eth-goerli",
        "isTestnet": true,
        "networkId": 5,
        "chainId": 5,
        "sfId": 101,
        "shortName": "goerli",
        "uppercaseName": "ETH_GOERLI",
        "humanReadableName": "Goerli",
        "nativeTokenSymbol": "ETH",
        "nativeTokenWrapper": "0x5943f705abb6834cad767e6e4bb258bc48d9c947",
        "contractsV1": {
            "resolver": "0x3710AB3fDE2B61736B8BB0CE845D6c61F667a78E",
            "host": "0x22ff293e14F1EC3A09B137e9e06084AFd63adDF9",
            "governance": "0x3a648764a6d66440ca096343937c711a7ac1b1e9",
            "cfaV1": "0xEd6BcbF6907D4feEEe8a8875543249bEa9D308E8",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0xfDdcdac21D64B639546f3Ce2868C7EF06036990c",
            "gdaV1": "0x3dB8Abd8B696F6c4150212A85961f954825Dd4B9",
            "superTokenFactory": "0x94f26B4c8AD12B18c12f38E878618f7664bdcCE2",
            "constantOutflowNFT": "0xB18cbFeA12b5CB2626C74c94920dB1B37Ae91506",
            "constantInflowNFT": "0xF07df8b66ed80399B1E00981D61aD34EB4293032",
            "superfluidLoader": "0x74d860243Ff08A243d5485899f343117EbDa6eA8",
            "toga": "0xa54FC15FC75693447d70a57262F37a70B614721b",
            "flowScheduler": "0xf428308b426D7cD7Ad8eBE549d750f31C8E060Ca",
            "vestingScheduler": "0xF9240F930d847F70ad900aBEE8949F25649Bf24a",
            "autowrap": {
                "manager": "0x0B82D14E9616ca4d260E77454834AdCf5887595F",
                "wrapStrategy": "0xea49af829d3e28d3ec49e0e0a0ba1e7860a56f60"
            },
            "existentialNFTCloneFactory": "0x3e5e8449477F80a3Dc0bA394882AeAB300c7F807"
        },
        "startBlockV1": 3550000,
        "logsQueryRange": 10000,
        "explorer": "https://goerli.etherscan.io",
        "subgraphV1": {
            "name": "protocol-v1-goerli",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-goerli"
        },
        "subgraphVesting": {
            "name": "vesting-v1-eth-goerli",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/vesting-v1-eth-goerli"
        },
        "subgraphFlowScheduler": {
            "name": "scheduling-v1-eth-goerli",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/scheduling-v1-eth-goerli"
        },
        "subgraphAutoWrap": {
            "name": "auto-wrap-v1-eth-goerli",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/auto-wrap-v1-eth-goerli"
        },
        "publicRPCs": [
            "https://rpc.ankr.com/eth_goerli",
            "https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"
        ],
        "trustedForwarders": [
            "0xE041608922d06a4F26C0d4c27d8bCD01daf1f792",
            "0xb539068872230f20456CF38EC52EF2f91AF4AE49",
            "0xd8253782c45a12053594b9deB72d8e8aB2Fca54c"
        ]
    },
    {
        "name": "polygon-mumbai",
        "isTestnet": true,
        "networkId": 80001,
        "chainId": 80001,
        "sfId": 102,
        "shortName": "mumbai",
        "uppercaseName": "POLYGON_MUMBAI",
        "humanReadableName": "Polygon Mumbai",
        "nativeTokenSymbol": "MATIC",
        "nativeTokenWrapper": "0x96B82B65ACF7072eFEb00502F45757F254c2a0D4",
        "contractsV1": {
            "resolver": "0x8C54C83FbDe3C59e59dd6E324531FB93d4F504d3",
            "host": "0xEB796bdb90fFA0f28255275e16936D25d3418603",
            "cfaV1": "0x49e565Ed1bdc17F3d220f72DF0857C26FA83F873",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0x804348D4960a61f2d5F9ce9103027A3E849E09b8",
            "gdaV1": "0x63ab406B6eF6c8be732c1edbd15464de16a8F46D",
            "superTokenFactory": "0xB798553db6EB3D3C56912378409370145E97324B",
            "constantOutflowNFT": "0x502CC982947216C0f94e433BC78c413806301C07",
            "constantInflowNFT": "0x9906A7e948C642B6bc74b9A5EAfCddB3580b44e0",
            "superfluidLoader": "0x0d56ED56b63382B0FC964490feB9AE438B6B4b79",
            "toga": "0x38DD80876DBA048d0050D28828522c313967D073",
            "superSpreader": "0x74CDF863b00789c29734F8dFd9F83423Bc55E4cE",
            "flowScheduler": "0x59A3Ba9d34c387FB70b4f4e4Fbc9eD7519194139",
            "vestingScheduler": "0x3962EE56c9f7176215D149938BA685F91aBB633B",
            "autowrap": {
                "manager": "0x3eAB3c6207F488E475b7955B631B564F0E6317B9",
                "wrapStrategy": "0x544728AFDBeEafBeC9e1329031788edb53017bC4"
            },
            "existentialNFTCloneFactory": "0xfC4E49AfcDDDcc2B90794DC214cc324d17B15619"
        },
        "startBlockV1": 8100000,
        "logsQueryRange": 10000,
        "explorer": "https://mumbai.polygonscan.com",
        "subgraphV1": {
            "name": "protocol-v1-mumbai",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-mumbai"
        },
        "subgraphVesting": {
            "name": "vesting-v1-polygon-mumbai",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/vesting-v1-polygon-mumbai"
        },
        "subgraphFlowScheduler": {
            "name": "scheduling-v1-polygon-mumbai",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/scheduling-v1-polygon-mumbai"
        },
        "subgraphAutoWrap": {
            "name": "auto-wrap-v1-polygon-mumbai",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/auto-wrap-v1-polygon-mumbai"
        },
        "publicRPCs": [
            "https://rpc.ankr.com/polygon_mumbai",
            "https://matic-mumbai.chainstacklabs.com"
        ],
        "trustedForwarders": [
            "0x9399bb24dbb5c4b782c70c2969f58716ebbd6a3b",
            "0x69015912AA33720b842dCD6aC059Ed623F28d9f7",
            "0xb539068872230f20456CF38EC52EF2f91AF4AE49",
            "0xd8253782c45a12053594b9deB72d8e8aB2Fca54c"
        ]
    },
    {
        "name": "optimism-goerli",
        "isTestnet": true,
        "networkId": 420,
        "chainId": 420,
        "sfId": 103,
        "shortName": "opgoerli",
        "uppercaseName": "OPTIMISM_GOERLI",
        "humanReadableName": "Optimism Goerli",
        "nativeTokenSymbol": "ETH",
        "nativeTokenWrapper": "0xE01F8743677Da897F4e7De9073b57Bf034FC2433",
        "contractsV1": {
            "resolver": "0x21d4E9fbB9DB742E6ef4f29d189a7C18B0b59136",
            "host": "0xE40983C2476032A0915600b9472B3141aA5B5Ba9",
            "cfaV1": "0xff48668fa670A85e55A7a822b352d5ccF3E7b18C",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0x96215257F2FcbB00135578f766c0449d239bd92F",
            "gdaV1": "0xe87F46A15C410F151309Bf7516e130087Fc6a5E5",
            "superTokenFactory": "0xfafe31cf998Df4e5D8310B03EBa8fb5bF327Eaf5",
            "constantOutflowNFT": "0xDF874BA132D8C68FEb5De513790f7612Fe20dDbd",
            "constantInflowNFT": "0xf88dd7208438Fdc5Ad05857eA701b7b51cdae0a9",
            "superfluidLoader": "0x5Bb5908dcCC9Bb0fC39a78CfDf9e47B4C08E9521",
            "existentialNFTCloneFactory": "0xFCb633f4ff90241391aD92E4678eC2a11a94a990"
        },
        "startBlockV1": 340000,
        "logsQueryRange": 50000,
        "explorer": "https://goerli-optimism.etherscan.io",
        "subgraphV1": {
            "name": "protocol-v1-optimism-goerli",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-optimism-goerli"
        },
        "publicRPCs": [
            "https://goerli.optimism.io",
            "https://opt-goerli.g.alchemy.com/v2/demo"
        ],
        "trustedForwarders": [
            "0x9C73373C70F23920EA54F7883dCB1F85b162Df40",
            "0xb539068872230f20456CF38EC52EF2f91AF4AE49",
            "0xd8253782c45a12053594b9deB72d8e8aB2Fca54c"
        ]
    },
    {
        "name": "arbitrum-goerli",
        "isTestnet": true,
        "networkId": 421613,
        "chainId": 421613,
        "sfId": 104,
        "shortName": "arbgoerli",
        "uppercaseName": "ARBITRUM_GOERLI",
        "humanReadableName": "Arbitrum Goerli",
        "nativeTokenSymbol": "ETH",
        "nativeTokenWrapper": "0xE01F8743677Da897F4e7De9073b57Bf034FC2433",
        "contractsV1": {
            "resolver": "0x21d4E9fbB9DB742E6ef4f29d189a7C18B0b59136",
            "host": "0xE40983C2476032A0915600b9472B3141aA5B5Ba9",
            "cfaV1": "0xff48668fa670A85e55A7a822b352d5ccF3E7b18C",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0x96215257F2FcbB00135578f766c0449d239bd92F",
            "gdaV1": "0xe87F46A15C410F151309Bf7516e130087Fc6a5E5",
            "superTokenFactory": "0xfafe31cf998Df4e5D8310B03EBa8fb5bF327Eaf5",
            "constantOutflowNFT": "0xDF874BA132D8C68FEb5De513790f7612Fe20dDbd",
            "constantInflowNFT": "0xf88dd7208438Fdc5Ad05857eA701b7b51cdae0a9",
            "superfluidLoader": "0x5Bb5908dcCC9Bb0fC39a78CfDf9e47B4C08E9521",
            "existentialNFTCloneFactory": "0x22f391AB6755F0A8986AFD543289C43701beaCAa"
        },
        "startBlockV1": 93000,
        "logsQueryRange": 50000,
        "explorer": "https://goerli.arbiscan.io",
        "subgraphV1": {
            "name": "protocol-v1-arbitrum-goerli",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-arbitrum-goerli"
        },
        "publicRPCs": [
            "https://goerli-rollup.arbitrum.io/rpc",
            "https://arb-goerli.g.alchemy.com/v2/demo"
        ],
        "trustedForwarders": [
            "0xb539068872230f20456CF38EC52EF2f91AF4AE49",
            "0xd8253782c45a12053594b9deB72d8e8aB2Fca54c"
        ]
    },
    {
        "name": "avalanche-fuji",
        "isTestnet": true,
        "networkId": 43113,
        "chainId": 43113,
        "sfId": 105,
        "shortName": "fuji",
        "uppercaseName": "AVALANCHE_FUJI",
        "humanReadableName": "Avalanche Fuji",
        "nativeTokenSymbol": "AVAX",
        "nativeTokenWrapper": "0xfFD0f6d73ee52c68BF1b01C8AfA2529C97ca17F3",
        "contractsV1": {
            "resolver": "0xf0ec6A8842Ca72Aec8A4D4573E731242389e18A8",
            "host": "0x85Fe79b998509B77BF10A8BD4001D58475D29386",
            "cfaV1": "0x16843ac25Ccc58Aa7960ba05f61cBB17b36b130A",
            "cfaV1Forwarder": "0x2CDd45c5182602a36d391F7F16DD9f8386C3bD8D",
            "idaV1": "0xA44dEC7A0Dde1a56AeDe4143C1ef89cf5d956782",
            "gdaV1": "0x51f571D934C59185f13d17301a36c07A2268B814",
            "superTokenFactory": "0x1C92042426B6bAAe497bEf461B6d8342D03aEc92",
            "constantOutflowNFT": "0x49583f57EFeBe733EC872c5d5437116085a3eE3c",
            "constantInflowNFT": "0x67d0Efab10b390206b356BA7FB453Ab56AAB7480",
            "superfluidLoader": "0x96C3C2d23d143301cF363a02cB7fe3596d2834d7",
            "autowrap": {
                "manager": "0x30aE282CF477E2eF28B14d0125aCEAd57Fe1d7a1",
                "wrapStrategy": "0x1D65c6d3AD39d454Ea8F682c49aE7744706eA96d"
            },
            "existentialNFTCloneFactory": "0xF76529ddEE7AA7890323eCa40C212758DD93B888"
        },
        "startBlockV1": 3220000,
        "logsQueryRange": 50000,
        "explorer": "https://testnet.snowtrace.io",
        "subgraphV1": {
            "name": "protocol-v1-avalanche-fuji",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-avalanche-fuji"
        },
        "publicRPCs": [
            "https://api.avax-test.network/ext/bc/C/rpc",
            "https://avalanche-fuji-c-chain.publicnode.com"
        ],
        "trustedForwarders": [
            "0x6271Ca63D30507f2Dcbf99B52787032506D75BBF",
            "0xb539068872230f20456CF38EC52EF2f91AF4AE49",
            "0xd8253782c45a12053594b9deB72d8e8aB2Fca54c"
        ]
    },
    {
        "name": "eth-sepolia",
        "isTestnet": true,
        "networkId": 11155111,
        "chainId": 11155111,
        "sfId": 106,
        "shortName": "sepolia",
        "uppercaseName": "ETH_SEPOLIA",
        "humanReadableName": "Sepolia",
        "nativeTokenSymbol": "ETH",
        "nativeTokenWrapper": "0x30a6933Ca9230361972E413a15dC8114c952414e",
        "contractsV1": {
            "resolver": "0x6813edE4E78ecb830d380d0F7F684c12aAc95F02",
            "host": "0x109412E3C84f0539b43d39dB691B08c90f58dC7c",
            "cfaV1": "0x6836F23d6171D74Ef62FcF776655aBcD2bcd62Ef",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0x9358C7dCCc6B8CA6F526311e8ac266F8C861B7ea",
            "superTokenFactory": "0x254C2e152E8602839D288A7bccdf3d0974597193",
            "constantOutflowNFT": "0xfBE332e001D6b54e1F4B63c2343B8E7746d99Ece",
            "constantInflowNFT": "0xC95346B7394009ccEfaA62Eca28797804B2bCF1C",
            "superfluidLoader": "0x554c06487bEc8c890A0345eb05a5292C1b1017Bd",
            "existentialNFTCloneFactory": "0x0D1F0d4629B722b4dFabd195c14F12f2095418d9"
        },
        "startBlockV1": 3322400,
        "logsQueryRange": 10000,
        "explorer": "https://sepolia.etherscan.io",
        "subgraphV1": {
            "name": "protocol-v1-eth-sepolia",
            "satsumaEndpoint": "https://subgraph.satsuma-prod.com/c5br3jaVlJI6/superfluid/eth-sepolia/api"
        },
        "publicRPCs": [
            "https://rpc.sepolia.org",
            "https://ethereum-sepolia.blockpi.network/v1/rpc/public"
        ]
    },
    {
        "name": "base-goerli",
        "isTestnet": true,
        "networkId": 84531,
        "chainId": 84531,
        "sfId": 107,
        "shortName": "bgoerli",
        "uppercaseName": "BASE_GOERLI",
        "humanReadableName": "Base Goerli",
        "nativeTokenSymbol": "ETH",
        "nativeTokenWrapper": "0x7fFCE315B2014546bA461d54eDed7AAc70DF4f53",
        "contractsV1": {
            "resolver": "0x598D5dB9902cbBd6e8Ee9CDb3A231377cdA2f018",
            "host": "0x507c3a7C6Ccc253884A2e3a3ee2A211cC7E796a6",
            "cfaV1": "0x4C476F2Fb27272680F2f6f2592E94d9e704691bC",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0xaa4FCc799B8857FA87b2945Dc6572D5d76b35485",
            "superTokenFactory": "0x1015BE31D7711D95d2c3444708FB53cC851ba856",
            "constantOutflowNFT": "0x4E89088Cd14064f38E5B2F309cFaB9C864F9a8e6",
            "constantInflowNFT": "0xda6db863cb2EE39b196edB8159c38A1ed5c55344",
            "superfluidLoader": "0x15F0Ca26781C3852f8166eD2ebce5D18265cceb7",
            "existentialNFTCloneFactory": "0x42B332F56BCD15F0D7cd523E5eC26Cd0734621eD"
        },
        "startBlockV1": 5249500,
        "logsQueryRange": 10000,
        "explorer": "https://goerli.basescan.org/",
        "subgraphV1": {
            "name": "protocol-v1-base-goerli"
        },
        "publicRPCs": [
            "https://goerli.base.org",
            "https://base-goerli.public.blastapi.io"
        ],
        "trustedForwarders": [
            "0xb539068872230f20456CF38EC52EF2f91AF4AE49",
            "0xd8253782c45a12053594b9deB72d8e8aB2Fca54c"
        ]
    },
    {
        "name": "polygon-zkevm-testnet",
        "isTestnet": true,
        "networkId": 1442,
        "chainId": 1442,
        "sfId": 108,
        "shortName": "pzkevmtest",
        "uppercaseName": "POLYGON_ZKEVM_TESTNET",
        "humanReadableName": "Polygon zkEVM Testnet",
        "nativeTokenSymbol": "ETH",
        "nativeTokenWrapper": "0x6345Aa6cec42a85160CF436810F97661e28c1876",
        "contractsV1": {
            "resolver": "0x642332562BC60a4Bd9681E7bb1588f7456A497aC",
            "host": "0xe64f81d5dDdA1c7172e5C6d964E8ef1BD82D8704",
            "cfaV1": "0x1EAa5ceA064aab2692AF257FB31f5291fdA3Cdee",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0xBf22019a4A4430bA67D3B0c8B4d5Edc48F913301",
            "superTokenFactory": "0x0F3B163623F05b2BfF42956f7C7bd31456bd83a2",
            "constantOutflowNFT": "0xDBD6f113E46A99D7BF95edfa47390c0c8127E922",
            "constantInflowNFT": "0xcb05535bd212eCFC4B7b9db81d6C2C768b726776",
            "superfluidLoader": "0xda6db863cb2EE39b196edB8159c38A1ed5c55344",
            "existentialNFTCloneFactory": "0x70bbB7a057A13070dF11d533e8f299357D778637"
        },
        "startBlockV1": 726000,
        "logsQueryRange": 20000,
        "explorer": "https://testnet-zkevm.polygonscan.org/",
        "subgraphV1": {
            "name": "protocol-v1-polygon-zkevm-testnet"
        },
        "publicRPCs": [
            "https://rpc.public.zkevm-test.net"
        ],
        "trustedForwarders": [
            "0xb539068872230f20456CF38EC52EF2f91AF4AE49",
            "0xd8253782c45a12053594b9deB72d8e8aB2Fca54c"
        ]
    },
    {
        "name": "xdai-mainnet",
        "isTestnet": false,
        "networkId": 100,
        "chainId": 100,
        "sfId": 1,
        "shortName": "xdai",
        "uppercaseName": "XDAI_MAINNET",
        "humanReadableName": "Gnosis Chain",
        "nativeTokenSymbol": "xDAI",
        "nativeTokenWrapper": "0x59988e47A3503AaFaA0368b9deF095c818Fdca01",
        "contractsV1": {
            "resolver": "0xD2009765189164b495c110D61e4D301729079911",
            "host": "0x2dFe937cD98Ab92e59cF3139138f18c823a4efE7",
            "governance": "0xaCc7380323681fdb8a0B9F2FE7d69dDFf0664478",
            "cfaV1": "0xEbdA4ceF883A7B12c4E669Ebc58927FBa8447C7D",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0x7888ac96F987Eb10E291F34851ae0266eF912081",
            "superTokenFactory": "0x23410e2659380784498509698ed70E414D384880",
            "constantOutflowNFT": "0xfC00dEE8a980110c5608A823a5B3af3872635456",
            "constantInflowNFT": "0x1497440B4E92DC4ca0F76223b28C20Cb9cB8a0f1",
            "superfluidLoader": "0x21d4E9fbB9DB742E6ef4f29d189a7C18B0b59136",
            "toga": "0xb7DE52F4281a7a276E18C40F94cd93159C4A2d22",
            "batchLiquidator": "0x27636F8E129cdd4ccA0F30E2b4C116DDaC773bE5",
            "superSpreader": "0x74CDF863b00789c29734F8dFd9F83423Bc55E4cE",
            "flowScheduler": "0x9cC7fc484fF588926149577e9330fA5b2cA74336",
            "vestingScheduler": "0x0170FFCC75d178d426EBad5b1a31451d00Ddbd0D",
            "wrapManager": "0x7a2899D179a8F205C8EDAd2e52954cA5f6d48D1A",
            "autowrap": {
                "manager": "0x8082e58681350876aFe8f52d3Bf8672034A03Db0",
                "wrapStrategy": "0x51FBAbD31A615E14b1bC12E9d887f60997264a4E"
            },
            "existentialNFTCloneFactory": "0xCd67c5bC1dfA3FF7d86b5ABc62A65C912Cbd2DA7"
        },
        "startBlockV1": 14820000,
        "logsQueryRange": 20000,
        "explorer": "https://gnosisscan.io",
        "subgraphV1": {
            "name": "protocol-v1-xdai",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-xdai",
            "satsumaEndpoint": "https://subgraph.satsuma-prod.com/c5br3jaVlJI6/superfluid/xdai/api"
        },
        "subgraphVesting": {
            "name": "vesting-v1-xdai-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/vesting-v1-xdai-mainnet"
        },
        "subgraphFlowScheduler": {
            "name": "scheduling-v1-xdai-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/scheduling-v1-xdai-mainnet"
        },
        "subgraphAutoWrap": {
            "name": "auto-wrap-v1-xdai-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/auto-wrap-v1-xdai-mainnet"
        },
        "publicRPCs": [
            "https://rpc.gnosischain.com",
            "https://gnosischain-rpc.gateway.pokt.network"
        ],
        "coinGeckoId": "xdai"
    },
    {
        "name": "polygon-mainnet",
        "isTestnet": false,
        "networkId": 137,
        "chainId": 137,
        "sfId": 2,
        "shortName": "matic",
        "uppercaseName": "POLYGON_MAINNET",
        "humanReadableName": "Polygon",
        "nativeTokenSymbol": "MATIC",
        "nativeTokenWrapper": "0x3aD736904E9e65189c3000c7DD2c8AC8bB7cD4e3",
        "contractsV1": {
            "resolver": "0xE0cc76334405EE8b39213E620587d815967af39C",
            "host": "0x3E14dC1b13c488a8d5D310918780c983bD5982E7",
            "governance": "0x3AD3f7A0965Ce6f9358AD5CCE86Bc2b05F1EE087",
            "cfaV1": "0x6EeE6060f715257b970700bc2656De21dEdF074C",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0xB0aABBA4B2783A72C52956CDEF62d438ecA2d7a1",
            "superTokenFactory": "0x2C90719f25B10Fc5646c82DA3240C76Fa5BcCF34",
            "constantOutflowNFT": "0x554e2bbaCF43FD87417b7201A9F1649a3ED89d68",
            "constantInflowNFT": "0x55909bB8cd8276887Aae35118d60b19755201c68",
            "superfluidLoader": "0x15F0Ca26781C3852f8166eD2ebce5D18265cceb7",
            "toga": "0x6AEAeE5Fd4D05A741723D752D30EE4D72690A8f7",
            "batchLiquidator": "0xA6Cdb472e7E22Bf30ae6fB752E4a13eBF3c12165",
            "flowScheduler": "0x55F7758dd99d5e185f4CC08d4Ad95B71f598264D",
            "vestingScheduler": "0xcFE6382B33F2AdaFbE46e6A26A88E0182ae32b0c",
            "autowrap": {
                "manager": "0x2581c27E7f6D6AF452E63fCe884EDE3EDd716b32",
                "wrapStrategy": "0xb4afa36BAd8c76976Dc77a21c9Ad711EF720eE4b"
            },
            "existentialNFTCloneFactory": "0x497aa106Da00BFa8f8BC266EF0793131930Fa630"
        },
        "startBlockV1": 11650500,
        "logsQueryRange": 10000,
        "explorer": "https://polygonscan.com",
        "subgraphV1": {
            "name": "protocol-v1-matic",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-matic",
            "satsumaEndpoint": "https://subgraph.satsuma-prod.com/c5br3jaVlJI6/superfluid/matic/api"
        },
        "subgraphVesting": {
            "name": "vesting-v1-polygon-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/vesting-v1-polygon-mainnet"
        },
        "subgraphFlowScheduler": {
            "name": "scheduling-v1-polygon-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/scheduling-v1-polygon-mainnet"
        },
        "subgraphAutoWrap": {
            "name": "auto-wrap-v1-polygon-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/auto-wrap-v1-polygon-mainnet"
        },
        "publicRPCs": [
            "https://polygon-rpc.com",
            "https://poly-rpc.gateway.pokt.network"
        ],
        "coinGeckoId": "polygon-pos"
    },
    {
        "name": "optimism-mainnet",
        "isTestnet": false,
        "networkId": 10,
        "chainId": 10,
        "sfId": 3,
        "shortName": "optimism",
        "uppercaseName": "OPTIMISM_MAINNET",
        "humanReadableName": "Optimism",
        "nativeTokenSymbol": "ETH",
        "nativeTokenWrapper": "0x4ac8bD1bDaE47beeF2D1c6Aa62229509b962Aa0d",
        "contractsV1": {
            "resolver": "0x743B5f46BC86caF41bE4956d9275721E0531B186",
            "host": "0x567c4B141ED61923967cA25Ef4906C8781069a10",
            "governance": "0x0170FFCC75d178d426EBad5b1a31451d00Ddbd0D",
            "cfaV1": "0x204C6f131bb7F258b2Ea1593f5309911d8E458eD",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0xc4ce5118C3B20950ee288f086cb7FC166d222D4c",
            "superTokenFactory": "0x8276469A443D5C6B7146BED45e2abCaD3B6adad9",
            "constantOutflowNFT": "0xFb2b126660BE2fdEBa254b1F6e4348644E8482e7",
            "constantInflowNFT": "0x0C6D90a98426bfD572a5c5Be572a7f6Bd1C5ED76",
            "superfluidLoader": "0x8E310ce29Ab7Fa2878944A65BB0eaF97B1853d40",
            "toga": "0xA3c8502187fD7a7118eAD59dc811281448946C8f",
            "batchLiquidator": "0x36Df169DBf5CE3c6f58D46f0addeF58F01381232",
            "flowScheduler": "0x55c8fc400833eEa791087cF343Ff2409A39DeBcC",
            "vestingScheduler": "0x65377d4dfE9c01639A41952B5083D58964782892",
            "autowrap": {
                "manager": "0x1fA76f2Cd0C3fe6c399A80111408d9C42C0CAC23",
                "wrapStrategy": "0x0Cf060a501c0040e9CCC708eFE94079F501c6Bb4"
            },
            "existentialNFTCloneFactory": "0xCb0Ff4D0cA186f0Fc0301258066Fe3fA258417a6"
        },
        "startBlockV1": 4300000,
        "logsQueryRange": 50000,
        "explorer": "https://optimistic.etherscan.io",
        "subgraphV1": {
            "name": "protocol-v1-optimism-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-optimism-mainnet"
        },
        "subgraphVesting": {
            "name": "vesting-v1-optimism-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/vesting-v1-optimism-mainnet"
        },
        "subgraphFlowScheduler": {
            "name": "scheduling-v1-optimism-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/scheduling-v1-optimism-mainnet"
        },
        "subgraphAutoWrap": {
            "name": "auto-wrap-v1-optimism-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/auto-wrap-v1-optimism-mainnet"
        },
        "publicRPCs": [
            "https://mainnet.optimism.io",
            "https://rpc.ankr.com/optimism"
        ],
        "coinGeckoId": "optimistic-ethereum"
    },
    {
        "name": "arbitrum-one",
        "isTestnet": false,
        "networkId": 42161,
        "chainId": 42161,
        "sfId": 4,
        "shortName": "arbone",
        "uppercaseName": "ARBITRUM_ONE",
        "humanReadableName": "Arbitrum One",
        "nativeTokenSymbol": "ETH",
        "nativeTokenWrapper": "0xe6C8d111337D0052b9D88BF5d7D55B7f8385ACd3",
        "contractsV1": {
            "resolver": "0x609b9d9d6Ee9C3200745A79B9d3398DBd63d509F",
            "host": "0xCf8Acb4eF033efF16E8080aed4c7D5B9285D2192",
            "governance": "0x0170FFCC75d178d426EBad5b1a31451d00Ddbd0D",
            "cfaV1": "0x731FdBB12944973B500518aea61942381d7e240D",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0x2319C7e07EB063340D2a0E36709B0D65fda75986",
            "superTokenFactory": "0x1C21Ead77fd45C84a4c916Db7A6635D0C6FF09D6",
            "constantOutflowNFT": "0x051e766e2d8dc65ae2bFCF084A50AD0447634227",
            "constantInflowNFT": "0x0043d7c85C8b96a49A72A92C0B48CdC4720437d7",
            "superfluidLoader": "0xB99cA401e10D277345BcFb281AC148a2e16Db466",
            "toga": "0xFC63B7C762B10670Eda15cF3ca3970bCDB28C9eF",
            "batchLiquidator": "0x6C66e5c5D201A753ff497F2e9eC5D545631854d0",
            "flowScheduler": "0x3fA8B653F9abf91428800C0ba0F8D145a71F97A1",
            "vestingScheduler": "0x55c8fc400833eEa791087cF343Ff2409A39DeBcC",
            "autowrap": {
                "manager": "0xf01825eAFAe5CD1Dab5593EFAF218efC8968D272",
                "wrapStrategy": "0x342076aA957B0ec8bC1d3893af719b288eA31e61"
            },
            "existentialNFTCloneFactory": "0xF353978890204756fc5fa6dfbD16a91eac9E6f4d"
        },
        "startBlockV1": 7600000,
        "logsQueryRange": 50000,
        "explorer": "https://arbiscan.io",
        "subgraphV1": {
            "name": "protocol-v1-arbitrum-one",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-arbitrum-one"
        },
        "subgraphVesting": {
            "name": "vesting-v1-arbitrum-one",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/vesting-v1-arbitrum-one"
        },
        "subgraphFlowScheduler": {
            "name": "scheduling-v1-arbitrum-one",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/scheduling-v1-arbitrum-one"
        },
        "subgraphAutoWrap": {
            "name": "auto-wrap-v1-arbitrum-one",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/auto-wrap-v1-arbitrum-one"
        },
        "publicRPCs": [
            "https://arb1.arbitrum.io/rpc",
            "https://arbitrum.blockpi.network/v1/rpc/public"
        ],
        "coinGeckoId": "arbitrum-one"
    },
    {
        "name": "avalanche-c",
        "isTestnet": false,
        "networkId": 43114,
        "chainId": 43114,
        "sfId": 5,
        "shortName": "avalanche",
        "uppercaseName": "AVALANCHE_C",
        "humanReadableName": "Avalanche C",
        "nativeTokenSymbol": "AVAX",
        "nativeTokenWrapper": "0xBE916845D8678b5d2F7aD79525A62D7c08ABba7e",
        "contractsV1": {
            "resolver": "0x24a3F04F70B7f07B9673EadD3e146391BcfEa5c1",
            "host": "0x60377C7016E4cdB03C87EF474896C11cB560752C",
            "governance": "0xF74390BabA510ec2fE196c2e02B037380d7a6F12",
            "cfaV1": "0x6946c5B38Ffea373b0a2340b4AEf0De8F6782e58",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0x1fA9fFe8Db73F701454B195151Db4Abb18423cf2",
            "superTokenFactory": "0x464AADdBB2B80f3Cb666522EB7381bE610F638b4",
            "constantOutflowNFT": "0x4247bA6C3658Fa5C0F523BAcea8D0b97aF1a175e",
            "constantInflowNFT": "0x82b9D8A91A5b333b5A6e78439551ea0E7da153E3",
            "superfluidLoader": "0x2601E69a2D16C8Ccc8aEe8cE9F59d24a59986B9E",
            "toga": "0x3D9A67D5ec1E72CEcA8157e028855056786b6159",
            "batchLiquidator": "0xdddaD64A9Fe7709A729C4a5428617e369278e0b6",
            "flowScheduler": "0xF7AfF590E9DE493D7ACb421Fca7f1E35C1ad4Ce5",
            "vestingScheduler": "0x3fA8B653F9abf91428800C0ba0F8D145a71F97A1",
            "autowrap": {
                "manager": "0x8082e58681350876aFe8f52d3Bf8672034A03Db0",
                "wrapStrategy": "0x51FBAbD31A615E14b1bC12E9d887f60997264a4E"
            },
            "existentialNFTCloneFactory": "0x94aE5f52E401A5766b0877d2f030cFb9C3792BD7"
        },
        "startBlockV1": 14700000,
        "logsQueryRange": 50000,
        "explorer": "https://snowtrace.io",
        "subgraphV1": {
            "name": "protocol-v1-avalanche-c",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-avalanche-c"
        },
        "subgraphVesting": {
            "name": "vesting-v1-avalanche-c",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/vesting-v1-avalanche-c"
        },
        "subgraphFlowScheduler": {
            "name": "scheduling-v1-avalanche-c",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/scheduling-v1-avalanche-c"
        },
        "subgraphAutoWrap": {
            "name": "auto-wrap-v1-avalanche-c",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/auto-wrap-v1-avalanche-c"
        },
        "publicRPCs": [
            "https://api.avax.network/ext/bc/C/rpc",
            "https://rpc.ankr.com/avalanche"
        ],
        "coinGeckoId": "avalanche"
    },
    {
        "name": "bsc-mainnet",
        "isTestnet": false,
        "networkId": 56,
        "chainId": 56,
        "sfId": 5,
        "shortName": "bsc",
        "uppercaseName": "BSC_MAINNET",
        "humanReadableName": "BNB Smart Chain",
        "nativeTokenSymbol": "BNB",
        "nativeTokenWrapper": "0x529A4116F160c833c61311569D6B33dFF41fD657",
        "contractsV1": {
            "resolver": "0x69604aA4e9e8BF44A73C680997205Edb03A92E41",
            "host": "0xd1e2cFb6441680002Eb7A44223160aB9B67d7E6E",
            "governance": "0xee07D9fce4Cf2a891BC979E9d365929506C2982f",
            "cfaV1": "0x49c38108870e74Cb9420C0991a85D3edd6363F75",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0x594ed9Cd773584B645aC1F5B11020d3b32cDF07d",
            "superTokenFactory": "0x8bde47397301F0Cd31b9000032fD517a39c946Eb",
            "constantOutflowNFT": "0xcb05535bd212eCFC4B7b9db81d6C2C768b726776",
            "constantInflowNFT": "0xbF7BCcE8D60A9C3F6bFaEc9346Aa85B9f781a4e9",
            "superfluidLoader": "0x3C26e5bEbc68EaAf4efcd88F8E5A6Aeb77b65579",
            "toga": "0xFCD84210f5d51Cd40a30443d44d6A5500d5D10dF",
            "batchLiquidator": "0x5487d078CA8933e83d91d5E7AFBe3A7bfC3412d6",
            "flowScheduler": "0x2f9e2A2A59405682d4F86779275CF5525AD7eC2B",
            "vestingScheduler": "0x9B91c27f78376383003C6A12Ad12B341d016C5b9",
            "autowrap": {
                "manager": "0x2AcdD61ac1EFFe1535109449c31889bdE8d7f325",
                "wrapStrategy": "0x9e308cb079ae130790F604b1030cDf386670f199"
            },
            "existentialNFTCloneFactory": "0xe9F27eb8cdAaA0B01a4034e109496C3026b01bd9"
        },
        "startBlockV1": 18800000,
        "logsQueryRange": 5000,
        "explorer": "https://bscscan.com",
        "subgraphV1": {
            "name": "protocol-v1-bsc-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-bsc-mainnet"
        },
        "subgraphVesting": {
            "name": "vesting-v1-bsc-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/vesting-v1-bsc-mainnet"
        },
        "subgraphFlowScheduler": {
            "name": "scheduling-v1-bsc-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/scheduling-v1-bsc-mainnet"
        },
        "subgraphAutoWrap": {
            "name": "auto-wrap-v1-bsc-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/auto-wrap-v1-bsc-mainnet"
        },
        "publicRPCs": [
            "https://bscrpc.com",
            "https://bsc-dataseed.binance.org"
        ],
        "coinGeckoId": "binance-smart-chain"
    },
    {
        "name": "eth-mainnet",
        "isTestnet": false,
        "networkId": 1,
        "chainId": 1,
        "sfId": 6,
        "shortName": "mainnet",
        "uppercaseName": "ETH_MAINNET",
        "humanReadableName": "Ethereum",
        "nativeTokenSymbol": "ETH",
        "nativeTokenWrapper": "0xC22BeA0Be9872d8B7B3933CEc70Ece4D53A900da",
        "contractsV1": {
            "resolver": "0xeE4cD028f5fdaAdeA99f8fc38e8bA8A57c90Be53",
            "host": "0x4E583d9390082B65Bef884b629DFA426114CED6d",
            "governance": "0xe2E14e2C4518cB06c32Cd0818B4C01f53E1Ba653",
            "cfaV1": "0x2844c1BBdA121E9E43105630b9C8310e5c72744b",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0xbCF9cfA8Da20B591790dF27DE65C1254Bf91563d",
            "superTokenFactory": "0x0422689cc4087b6B7280e0a7e7F655200ec86Ae1",
            "superfluidLoader": "0x9775EEBdfF8AE845e7Ad3d1D04B85e6c6d284aCB",
            "toga": "0x8B5a2CF69a56d7F8Fa027edcA23594cdDF544dDc",
            "batchLiquidator": "0x554c06487bEc8c890A0345eb05a5292C1b1017Bd",
            "flowScheduler": "0xAA0cD305eD020137E302CeCede7b18c0A05aCCDA",
            "vestingScheduler": "0x39D5cBBa9adEBc25085a3918d36D5325546C001B",
            "autowrap": {
                "manager": "0x30aE282CF477E2eF28B14d0125aCEAd57Fe1d7a1",
                "wrapStrategy": "0x1D65c6d3AD39d454Ea8F682c49aE7744706eA96d"
            }
        },
        "startBlockV1": 15870000,
        "logsQueryRange": 10000,
        "explorer": "https://etherscan.io",
        "subgraphV1": {
            "name": "protocol-v1-eth-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-eth-mainnet",
            "satsumaEndpoint": "https://subgraph.satsuma-prod.com/c5br3jaVlJI6/superfluid/eth-mainnet/api"
        },
        "subgraphVesting": {
            "name": "vesting-v1-eth-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/vesting-v1-eth-mainnet"
        },
        "subgraphFlowScheduler": {
            "name": "scheduling-v1-eth-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/scheduling-v1-eth-mainnet"
        },
        "subgraphAutoWrap": {
            "name": "auto-wrap-v1-eth-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/auto-wrap-v1-eth-mainnet"
        },
        "publicRPCs": [
            "https://cloudflare-eth.com",
            "https://eth-rpc.gateway.pokt.network"
        ],
        "coinGeckoId": "ethereum"
    },
    {
        "name": "celo-mainnet",
        "isTestnet": false,
        "networkId": 42220,
        "chainId": 42220,
        "sfId": 7,
        "shortName": "celo",
        "uppercaseName": "CELO_MAINNET",
        "humanReadableName": "Celo",
        "nativeTokenSymbol": "CELO",
        "nativeTokenWrapper": "0x671425Ae1f272Bc6F79beC3ed5C4b00e9c628240",
        "contractsV1": {
            "resolver": "0x05eE721BD4D803d6d477Aa7607395452B65373FF",
            "host": "0xA4Ff07cF81C02CFD356184879D953970cA957585",
            "governance": "0x0170FFCC75d178d426EBad5b1a31451d00Ddbd0D",
            "cfaV1": "0x9d369e78e1a682cE0F8d9aD849BeA4FE1c3bD3Ad",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0x26747Fe93fAC8bF28E1e24A558a2bC7E4d9846cA",
            "superTokenFactory": "0x36be86dEe6BC726Ed0Cbd170ccD2F21760BC73D9",
            "constantOutflowNFT": "0xbe49ac1EadAc65dccf204D4Df81d650B50122aB2",
            "constantInflowNFT": "0x0FB7694c990CF19001127391Dbe53924dd7a61c7",
            "superfluidLoader": "0xAd6e6849d8eEa62AF9271808afb726610fB451a6",
            "toga": "0x9bCa3a623e7b2e248510d88B2894F54898d88F91",
            "batchLiquidator": "0x21d4E9fbB9DB742E6ef4f29d189a7C18B0b59136",
            "existentialNFTCloneFactory": "0x051e766e2d8dc65ae2bFCF084A50AD0447634227"
        },
        "startBlockV1": 16393000,
        "logsQueryRange": 20000,
        "explorer": "https://celoscan.io",
        "subgraphV1": {
            "name": "protocol-v1-celo-mainnet",
            "hostedEndpoint": "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-v1-celo-mainnet"
        },
        "publicRPCs": [
            "https://forno.celo.org",
            "https://rpc.ankr.com/celo"
        ],
        "coinGeckoId": "celo"
    },
    {
        "name": "base-mainnet",
        "isTestnet": false,
        "networkId": 8453,
        "chainId": 8453,
        "sfId": 8,
        "shortName": "base",
        "uppercaseName": "BASE_MAINNET",
        "humanReadableName": "Base",
        "nativeTokenSymbol": "ETH",
        "nativeTokenWrapper": "0x46fd5cfB4c12D87acD3a13e92BAa53240C661D93",
        "contractsV1": {
            "resolver": "0x6a214c324553F96F04eFBDd66908685525Da0E0d",
            "host": "0x4C073B3baB6d8826b8C5b229f3cfdC1eC6E47E74",
            "governance": "0x55F7758dd99d5e185f4CC08d4Ad95B71f598264D",
            "cfaV1": "0x19ba78B9cDB05A877718841c574325fdB53601bb",
            "cfaV1Forwarder": "0xcfA132E353cB4E398080B9700609bb008eceB125",
            "idaV1": "0x66DF3f8e14CF870361378d8F61356D15d9F425C4",
            "superTokenFactory": "0xe20B9a38E0c96F61d1bA6b42a61512D56Fea1Eb3",
            "constantOutflowNFT": "0xD3C78bb5a16Ea4ab584844eeb8F90Ac710c16355",
            "constantInflowNFT": "0x2d51962A9EE4D3C2819EF585eab7412c2a2C31Ac",
            "superfluidLoader": "0x6B24A6F34ab96267Fef9F8AC9fe6CC104C228127",
            "toga": "0xA87F76e99f6C8Ff8996d14f550ceF47f193D9A09",
            "batchLiquidator": "0x889ebeCaD5F8C34Fd96023456d0fC5cE54eb74Cb",
            "existentialNFTCloneFactory": "0x642332562BC60a4Bd9681E7bb1588f7456A497aC"
        },
        "startBlockV1": 1000000,
        "logsQueryRange": 20000,
        "explorer": "https://basescan.org",
        "subgraphV1": {
            "name": "protocol-v1-base-mainnet"
        },
        "publicRPCs": [
            "https://developer-access-mainnet.base.org"
        ],
        "coinGeckoId": "base"
    }
];


var $5a57af13913ce8c6$export$2e2bcd8739ae039 = {
    networks: (0, $e3914ff439c443e6$export$2e2bcd8739ae039),
    mainnets: (0, $e3914ff439c443e6$export$2e2bcd8739ae039).filter((e)=>!e.isTestnet),
    testnets: (0, $e3914ff439c443e6$export$2e2bcd8739ae039).filter((e)=>e.isTestnet),
    getNetworkByChainId: function(chainId) {
        return this.networks.filter((n)=>n.chainId === chainId)[0];
    },
    getNetworkByName: function(name) {
        return this.networks.filter((n)=>n.name === name)[0];
    },
    getNetworkByShortName: function(shortName) {
        return this.networks.filter((n)=>n.shortName === shortName)[0];
    }
};


var $4b15284363dd1a68$export$2e2bcd8739ae039 = {
    ...(0, $5a57af13913ce8c6$export$2e2bcd8739ae039)
};


var $dd05ce1f4643958c$exports = {};
$dd05ce1f4643958c$exports = JSON.parse('{"value":"v1"}');


const $de1415f96fbf6fc0$export$9e714d42906a764a = 12;
const $de1415f96fbf6fc0$export$b4d184521631cb01 = 30;
const $de1415f96fbf6fc0$export$854c589ed459efcb = 7;
const $de1415f96fbf6fc0$export$ef44e06190391e3d = 24;
const $de1415f96fbf6fc0$export$a4982fdb1458274 = 60;
const $de1415f96fbf6fc0$export$500e09b309e74106 = 60;
const $de1415f96fbf6fc0$export$fe2a770cf7c4a740 = $de1415f96fbf6fc0$export$500e09b309e74106 * $de1415f96fbf6fc0$export$a4982fdb1458274;
const $de1415f96fbf6fc0$export$312207fa781057d8 = $de1415f96fbf6fc0$export$fe2a770cf7c4a740 * $de1415f96fbf6fc0$export$ef44e06190391e3d;
const $de1415f96fbf6fc0$export$5fb354d094a77c4b = $de1415f96fbf6fc0$export$312207fa781057d8 * $de1415f96fbf6fc0$export$854c589ed459efcb;
const $de1415f96fbf6fc0$export$2e4945e5825cf7e1 = $de1415f96fbf6fc0$export$312207fa781057d8 * $de1415f96fbf6fc0$export$b4d184521631cb01;
const $de1415f96fbf6fc0$export$c5989a6c1689be6e = $de1415f96fbf6fc0$export$2e4945e5825cf7e1 * $de1415f96fbf6fc0$export$9e714d42906a764a; // NOTE: Is 360 days (misses 5-6 days)
const $de1415f96fbf6fc0$export$74a3a088f6bef62c = 1e18;
const $de1415f96fbf6fc0$export$11b439decfc92c38 = (0, $4b15284363dd1a68$export$2e2bcd8739ae039).networks.map((x)=>x.chainId);
const $de1415f96fbf6fc0$export$1a7eb0e6f4c943b7 = 1;
const $de1415f96fbf6fc0$export$938b30893926ec5a = 2;
const $de1415f96fbf6fc0$export$40a3b13e808b3579 = 4;
const $de1415f96fbf6fc0$export$605d246a74176afd = $de1415f96fbf6fc0$export$1a7eb0e6f4c943b7 | $de1415f96fbf6fc0$export$938b30893926ec5a | $de1415f96fbf6fc0$export$40a3b13e808b3579;
const $de1415f96fbf6fc0$var$subgraphReleaseTag = globalThis.process && globalThis.process.env.SUBGRAPH_RELEASE_TAG || (0, (/*@__PURE__*/$parcel$interopDefault($dd05ce1f4643958c$exports))).value;
const $de1415f96fbf6fc0$var$getAddressesData = (chainId)=>{
    const networkData = (0, $4b15284363dd1a68$export$2e2bcd8739ae039).networks.find((x)=>x.chainId === chainId);
    if (!networkData) return null;
    const subgraphEndpoint = networkData.subgraphV1.hostedEndpoint != null ? networkData.subgraphV1.hostedEndpoint : networkData.subgraphV1.satsumaEndpoint != null ? networkData.subgraphV1.satsumaEndpoint : // this should never happen and this endpoint is unused in initialization anyways
    "";
    const subgraphAPIEndpoint = $de1415f96fbf6fc0$var$subgraphReleaseTag ? subgraphEndpoint.replace("v1", $de1415f96fbf6fc0$var$subgraphReleaseTag) : subgraphEndpoint;
    return {
        subgraphAPIEndpoint: subgraphAPIEndpoint,
        networkName: networkData.name,
        nativeTokenSymbol: networkData.nativeTokenSymbol,
        addresses: networkData.contractsV1
    };
};
const $de1415f96fbf6fc0$export$cdfdd3b5e96b5891 = new Map((0, $4b15284363dd1a68$export$2e2bcd8739ae039).networks.map((x)=>[
        x.chainId,
        $de1415f96fbf6fc0$var$getAddressesData(x.chainId)
    ]));
const $de1415f96fbf6fc0$export$7402563b8142db51 = new Map((0, $4b15284363dd1a68$export$2e2bcd8739ae039).networks.map((x)=>[
        x.name,
        x.chainId
    ]));


const $f456740ea8874244$var$EMPTY = "0x";
const $f456740ea8874244$export$3d645f8d0edc7ea2 = (address)=>{
    if (!address) return "";
    if ((0, $6c57cc56acea9c6c$exports).utils.isAddress(address) === false) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
        type: "INVALID_ADDRESS",
        message: "The address you have entered is not a valid ethereum address"
    });
    return address.toLowerCase();
};
const $f456740ea8874244$export$d81f7ffd7d512c0 = (permissions)=>{
    return (permissions & ~((0, $de1415f96fbf6fc0$export$1a7eb0e6f4c943b7) | (0, $de1415f96fbf6fc0$export$938b30893926ec5a) | (0, $de1415f96fbf6fc0$export$40a3b13e808b3579))) === 0;
};
const $f456740ea8874244$export$28e22090f800957f = (oldPermissions, permissionsDelta)=>{
    return oldPermissions | permissionsDelta;
};
const $f456740ea8874244$export$a614071096c5b98b = (oldPermissions, permissionsDelta)=>{
    return oldPermissions & ~permissionsDelta;
};
const $f456740ea8874244$export$c8733ae29fb53302 = (str)=>{
    return str == null || str === "";
};
function $f456740ea8874244$export$9c7ed43387941990(num) {
    return (0, $6c57cc56acea9c6c$exports).BigNumber.from(num);
}
const $f456740ea8874244$export$66f7d64ca376c16a = (callData)=>$f456740ea8874244$var$EMPTY.concat(callData.slice(10));
const $f456740ea8874244$export$bd905a50dac0c5e8 = (fragments, data, value)=>{
    const iface = new (0, $6c57cc56acea9c6c$exports).utils.Interface(fragments);
    const txnDescription = iface.parseTransaction({
        data: data,
        value: value
    });
    return txnDescription;
};
const $f456740ea8874244$export$d504805a2e80df54 = (amountPerYear)=>{
    return Math.round(Number(amountPerYear) / (0, $de1415f96fbf6fc0$export$c5989a6c1689be6e) * (0, $de1415f96fbf6fc0$export$74a3a088f6bef62c)).toString();
};
const $f456740ea8874244$export$5808bb1dfc25150c = (amountPerMonth)=>{
    return Math.round(Number(amountPerMonth) / (0, $de1415f96fbf6fc0$export$2e4945e5825cf7e1) * (0, $de1415f96fbf6fc0$export$74a3a088f6bef62c)).toString();
};
const $f456740ea8874244$export$eb817e10b39c81aa = (amountPerWeek)=>{
    return Math.round(Number(amountPerWeek) / (0, $de1415f96fbf6fc0$export$5fb354d094a77c4b) * (0, $de1415f96fbf6fc0$export$74a3a088f6bef62c)).toString();
};
const $f456740ea8874244$export$5bd614b9939f2816 = (amountPerDay)=>{
    return Math.round(Number(amountPerDay) / (0, $de1415f96fbf6fc0$export$312207fa781057d8) * (0, $de1415f96fbf6fc0$export$74a3a088f6bef62c)).toString();
};
const $f456740ea8874244$export$190b9b23d83f0726 = (perSecondFlowRate)=>{
    const decimalFlowRate = Number(perSecondFlowRate) / (0, $de1415f96fbf6fc0$export$74a3a088f6bef62c);
    return {
        daily: Math.round(decimalFlowRate * (0, $de1415f96fbf6fc0$export$312207fa781057d8)).toString(),
        weekly: Math.round(decimalFlowRate * (0, $de1415f96fbf6fc0$export$5fb354d094a77c4b)).toString(),
        monthly: Math.round(decimalFlowRate * (0, $de1415f96fbf6fc0$export$2e4945e5825cf7e1)).toString(),
        yearly: Math.round(decimalFlowRate * (0, $de1415f96fbf6fc0$export$c5989a6c1689be6e)).toString()
    };
};
const $f456740ea8874244$export$e16a717943dd6a27 = ({ netFlowRate: netFlowRate, currentTimestamp: currentTimestamp, updatedAtTimestamp: updatedAtTimestamp })=>{
    return $f456740ea8874244$export$9c7ed43387941990(currentTimestamp).sub($f456740ea8874244$export$9c7ed43387941990(updatedAtTimestamp)).mul($f456740ea8874244$export$9c7ed43387941990(netFlowRate));
};
const $f456740ea8874244$export$7ddbaf5bfe19ae3c = (indexSubscriptions)=>{
    return indexSubscriptions.reduce((x, y)=>$f456740ea8874244$export$9c7ed43387941990(x).add($f456740ea8874244$export$9c7ed43387941990(y.index.indexValue).sub($f456740ea8874244$export$9c7ed43387941990(y.indexValueUntilUpdatedAt))).mul($f456740ea8874244$export$9c7ed43387941990(y.units)), $f456740ea8874244$export$9c7ed43387941990(0));
};
const $f456740ea8874244$export$b09a5685f520c22 = (indexSubscriptions)=>{
    return indexSubscriptions.filter((x)=>x.approved).reduce((x, y)=>$f456740ea8874244$export$9c7ed43387941990(x).add($f456740ea8874244$export$9c7ed43387941990(y.index.indexValue).sub($f456740ea8874244$export$9c7ed43387941990(y.indexValueUntilUpdatedAt))).mul($f456740ea8874244$export$9c7ed43387941990(y.units)), $f456740ea8874244$export$9c7ed43387941990(0));
};
const $f456740ea8874244$export$151f73d6b994af2e = (indexSubscriptions)=>{
    return $f456740ea8874244$export$7ddbaf5bfe19ae3c(indexSubscriptions).sub($f456740ea8874244$export$b09a5685f520c22(indexSubscriptions));
};
const $f456740ea8874244$export$d9ae0e7e07ff24d7 = ()=>Math.floor(new Date().getTime() / 1000);
const $f456740ea8874244$export$f07c840af7d4309b = (timestamp)=>new Date(Number(timestamp.toString()) * 1000);
const $f456740ea8874244$export$e6e5492073560896 = ({ currentBalance: currentBalance, netFlowRate: netFlowRate, currentTimestamp: currentTimestamp, updatedAtTimestamp: updatedAtTimestamp, indexSubscriptions: indexSubscriptions })=>{
    return $f456740ea8874244$export$9c7ed43387941990(currentBalance).add($f456740ea8874244$export$e16a717943dd6a27({
        netFlowRate: netFlowRate,
        currentTimestamp: currentTimestamp,
        updatedAtTimestamp: updatedAtTimestamp
    })).add($f456740ea8874244$export$b09a5685f520c22(indexSubscriptions));
};
const $f456740ea8874244$export$61f7c8a61ef4e707 = (provider)=>!!provider.getNetwork;
const $f456740ea8874244$export$314a627d755b9798 = (provider)=>!!provider.currentProvider;
const $f456740ea8874244$export$7243d1368899a7fd = (provider)=>!!provider.provider;
const $f456740ea8874244$export$f62628bb56170863 = (obj)=>obj;
const $f456740ea8874244$export$4951cf43f6b0a8b = (sender, flowOperator)=>{
    const encoder = (0, $6c57cc56acea9c6c$exports).utils.defaultAbiCoder;
    const encodedData = encoder.encode([
        "string",
        "address",
        "address"
    ], [
        "flowOperator",
        sender,
        flowOperator
    ]);
    return (0, $6c57cc56acea9c6c$exports).utils.keccak256(encodedData);
};
const $f456740ea8874244$export$fd71f273ad8186ce = (deposit, roundingDown = false)=>{
    // last 32 bits of the deposit (96 bits) is clipped off
    const rounding = roundingDown ? 0 : deposit.and($f456740ea8874244$export$9c7ed43387941990(0xffffffff)).isZero() ? 0 : 1;
    return deposit.shr(32).add($f456740ea8874244$export$9c7ed43387941990(rounding)).shl(32);
};
async function $f456740ea8874244$export$cbfb09d10d5691cd(somePromise, defaultReturnValue) {
    try {
        return await somePromise;
    } catch  {
        return defaultReturnValue;
    }
}


class $940c1805c1ccfafd$export$2e2bcd8739ae039 {
    constructor(txn, type, forwarderPopulatedPromise){
        /**
         * Executes the operation via the provided signer.
         * @description Populates all fields of the transaction, signs it and sends it to the network.
         * @param signer The signer of the transaction
         * @param gasLimitMultiplier A multiplier to provide gasLimit buffer on top of the estimated gas limit (1.2x is the default)
         * @returns {ethers.providers.TransactionResponse} A TransactionResponse object which can be awaited
         */ this.exec = async (signer, gasLimitMultiplier = 1.2)=>{
            const populatedTransaction = await this.getPopulatedTransactionRequest(signer, gasLimitMultiplier);
            return await signer.sendTransaction(populatedTransaction);
        };
        /**
         * Get the populated transaction by awaiting `populateTransactionPromise`.
         * `providerOrSigner` is used for gas estimation if necessary.
         * NOTE: we use the forwarder populated promise if this exists
         */ this.getPopulatedTransactionRequest = async (providerOrSigner, gasLimitMultiplier = 1.2)=>{
            const populatedTransaction = this.forwarderPopulatedPromise ? await this.forwarderPopulatedPromise : await this.populateTransactionPromise;
            // if gasLimit exists, an Overrides object has been passed or the user has explicitly set
            // a gasLimit for their transaction prior to execution and so we keep it as is else we apply
            // a specified or the default (1.2) multiplier on the gas limit.
            if (!populatedTransaction.gasLimit) {
                const estimatedGasLimit = await providerOrSigner.estimateGas(populatedTransaction);
                populatedTransaction.gasLimit = (0, $e06b4ba471dee399$export$2e2bcd8739ae039)(estimatedGasLimit, gasLimitMultiplier);
            }
            return populatedTransaction;
        };
        /**
         * Signs the populated transaction via the provided signer (what you intend on sending to the network).
         * @param signer The signer of the transaction
         * @returns {Promise<string>} Fully serialized, signed transaction
         */ this.getSignedTransaction = async (signer, gasLimitMultiplier = 1.2)=>{
            const populatedTransaction = await this.getPopulatedTransactionRequest(signer, gasLimitMultiplier);
            const signerPopulatedTransaction = await signer.populateTransaction(populatedTransaction);
            const signedTransaction = await signer.signTransaction(signerPopulatedTransaction);
            return signedTransaction;
        };
        /**
         * Gets the transaction hash of the transaction.
         * @description Calculates this by getting the keccak256 hash of the signedTxn.
         * @param signer The signer of the transaction
         * @returns {Promise<string>} The transaction hash of the transaction
         */ this.getTransactionHash = async (signer)=>{
            const signedTxn = await this.getSignedTransaction(signer);
            return (0, $6c57cc56acea9c6c$exports).utils.keccak256(signedTxn);
        };
        /**
         * Gets the `OperationStruct` object.
         * @param operation an `Operation` object
         * @param index the index of the `Operation` in the batchCall
         * @returns {Promise<OperationStruct>} OperationStruct object for batchCall
         */ this.toOperationStruct = async (index)=>{
            const batchOperationType = (0, $e74e0a88b9636687$export$ac966037f6fabd0f).get(this.type);
            const populatedTransaction = await this.populateTransactionPromise;
            if (!batchOperationType) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                type: "UNSUPPORTED_OPERATION",
                message: "The operation at index " + index + " is unsupported."
            });
            /* istanbul ignore next */ if (!populatedTransaction.to || !populatedTransaction.data) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                type: "MISSING_TRANSACTION_PROPERTIES",
                message: "The transaction is missing the to or data property."
            });
            const encoder = (0, $6c57cc56acea9c6c$exports).utils.defaultAbiCoder;
            // Handles Superfluid.callAgreement
            if (this.type === "SUPERFLUID_CALL_AGREEMENT") {
                const functionArgs = (0, $e74e0a88b9636687$export$c13c7ff2f2853bb9)((0, $40eed9bec2e63e98$export$797d13a20ff60701).abi, populatedTransaction.data);
                const data = encoder.encode([
                    "bytes",
                    "bytes"
                ], [
                    functionArgs["callData"],
                    functionArgs["userData"]
                ]);
                return {
                    operationType: batchOperationType,
                    target: functionArgs["agreementClass"],
                    data: data
                };
            }
            // Handles Superfluid.callAppAction
            if (this.type === "CALL_APP_ACTION") {
                const functionArgs = (0, $e74e0a88b9636687$export$c13c7ff2f2853bb9)((0, $40eed9bec2e63e98$export$797d13a20ff60701).abi, populatedTransaction.data);
                return {
                    operationType: batchOperationType,
                    target: functionArgs["app"],
                    data: functionArgs["callData"]
                };
            }
            // Handles remaining ERC20/ERC777/SuperToken Operations
            return {
                operationType: batchOperationType,
                target: populatedTransaction.to,
                data: (0, $f456740ea8874244$export$66f7d64ca376c16a)(populatedTransaction.data)
            };
        };
        this.populateTransactionPromise = txn;
        this.type = type;
        this.forwarderPopulatedPromise = forwarderPopulatedPromise;
    }
}



class $aa8d7ced1bddb8e4$export$2e2bcd8739ae039 {
    constructor(hostAddress){
        /**
         * Creates an Operation of the `callAgreement` function on the host contract.
         * @param agreementAddress the agreement address (cfa or ida address)
         * @param callData the encoded callData for the function
         * @param userData any additional user data
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} an `Operation` class
         */ this.callAgreement = (agreementAddress, callData, userData, overrides)=>{
            const txn = this.contract.populateTransaction.callAgreement(agreementAddress, callData, userData || "0x", overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "SUPERFLUID_CALL_AGREEMENT");
        };
        /**
         * Creates an Operation of the `callAppAction` function on the host contract.
         * @param app the address of the Super App you are calling
         * @param callData the encoded callData for the function
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} an `Operation` class
         */ this.callAppAction = (app, callData, overrides)=>{
            const txn = this.contract.populateTransaction.callAppAction(app, callData, overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "CALL_APP_ACTION");
        };
        this.contract = new (0, $6c57cc56acea9c6c$exports).Contract(hostAddress, (0, $40eed9bec2e63e98$export$797d13a20ff60701).abi);
    }
}





const $e74e0a88b9636687$export$ac966037f6fabd0f = new Map([
    [
        "ERC20_APPROVE",
        1
    ],
    [
        "ERC20_TRANSFER_FROM",
        2
    ],
    [
        "ERC777_SEND",
        3
    ],
    [
        "ERC20_INCREASE_ALLOWANCE",
        4
    ],
    [
        "ERC20_DECREASE_ALLOWANCE",
        5
    ],
    [
        "SUPERTOKEN_UPGRADE",
        101
    ],
    [
        "SUPERTOKEN_DOWNGRADE",
        102
    ],
    [
        "SUPERFLUID_CALL_AGREEMENT",
        201
    ],
    [
        "CALL_APP_ACTION",
        202
    ]
]);
const $e74e0a88b9636687$export$c13c7ff2f2853bb9 = (abi, callData)=>(0, $f456740ea8874244$export$bd905a50dac0c5e8)(abi, callData).args;
class $e74e0a88b9636687$export$2e2bcd8739ae039 {
    constructor(options){
        this.getCallDataFunctionArgs = $e74e0a88b9636687$export$c13c7ff2f2853bb9;
        /**
         * Given an `Operation` object, gets the `OperationStruct` object.
         * @param operation an `Operation` object
         * @param index the index of the `Operation` in the batchCall
         * @returns {Promise<OperationStruct>} OperationStruct object for batchCall
         */ this.getOperationStruct = async (operation, index)=>operation.toOperationStruct(index);
        /**
         * Executes a batch call given the operations on this class.
         * @param signer the signer of the transaction
         * @param gasLimitMultiplier A multiplier to provide gasLimit buffer on top of the estimated gas limit (1.2x is the default)
         * @returns {Promise<ethers.ContractTransaction>} ContractTransaction object
         */ this.exec = async (signer, gasLimitMultiplier = 1.2)=>{
            const operation = await this.toOperation();
            return await operation.exec(signer, gasLimitMultiplier);
        };
        /* istanbul ignore next */ // TODO: user signs the transaction they'd like to execute and gives
        // this data to the trusted forwarder to sign
        /**
         * Executes a forward batch call given the operations on this class.
         * @param signer the signer of the transaction
         * @returns {Promise<ethers.ContractTransaction>} ContractTransaction object
         */ this.execForward = async (signer)=>{
            if (this.getOperationStructArrayPromises.length === 0) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                type: "BATCH_CALL_ERROR",
                message: "There are no operations to execute in the batch."
            });
            const operationStructArray = await Promise.all(this.getOperationStructArrayPromises);
            return await this.host.contract.connect(signer).forwardBatchCall(operationStructArray);
        };
        this.options = options;
        this.host = new (0, $aa8d7ced1bddb8e4$export$2e2bcd8739ae039)(options.hostAddress);
    }
    /**
     * Gets an array of `OperationStruct` objects to be passed to batchCall.
     * @returns {Promise<OperationStruct>[]} array of operation struct promises
     */ get getOperationStructArrayPromises() {
        return this.options.operations.map((x, i)=>this.getOperationStruct(x, i));
    }
    async toOperation() {
        if (this.getOperationStructArrayPromises.length === 0) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
            type: "BATCH_CALL_ERROR",
            message: "There are no operations to execute in the batch."
        });
        const operationStructArray = await Promise.all(this.getOperationStructArrayPromises);
        const tx = this.host.contract.populateTransaction.batchCall(operationStructArray);
        return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(tx, "UNSUPPORTED");
    }
}








const $6a091f8fcf7efe91$var$cfaInterface = (0, $81fa2b585dc580d7$export$93a752d9b00820aa).createInterface();
class $6a091f8fcf7efe91$export$2e2bcd8739ae039 {
    constructor(hostAddress, cfaV1Address, cfaV1ForwarderAddress){
        /** ### CFA Read Functions ### */ /**
         * Get the details of a flow.
         * @param superToken the superToken of the agreement
         * @param sender the sender of the flow
         * @param receiver the receiver of the flow
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3FlowInfo>} Web3 Flow info object
         */ this.getFlow = async (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedSender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.sender);
            const normalizedReceiver = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.receiver);
            try {
                const flowData = await this.contract.connect(params.providerOrSigner).getFlow(normalizedToken, normalizedSender, normalizedReceiver);
                return this._sanitizeFlowInfo(flowData);
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "CFAV1_READ",
                    message: "There was an error getting the flow",
                    cause: err
                });
            }
        };
        /**
         * Get the flow info of an account (net flow).
         * @param superToken the superToken of the agreement
         * @param account the account we're querying
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3FlowInfo>} Web3 Flow info object
         */ this.getAccountFlowInfo = async (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedAccount = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.account);
            try {
                const flowData = await this.contract.connect(params.providerOrSigner).getAccountFlowInfo(normalizedToken, normalizedAccount);
                return this._sanitizeFlowInfo(flowData);
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "CFAV1_READ",
                    message: "There was an error getting the account flow information",
                    cause: err
                });
            }
        };
        /**
         * Get the net flow of an account.
         * @param superToken the superToken of the agreement
         * @param account the account we're querying
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<string>} Web3 Flow info object
         */ this.getNetFlow = async (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedAccount = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.account);
            try {
                return (await this.contract.connect(params.providerOrSigner).getNetFlow(normalizedToken, normalizedAccount)).toString();
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "CFAV1_READ",
                    message: "There was an error getting net flow",
                    cause: err
                });
            }
        };
        /**
         * Get flow operator data.
         * @param superToken the superToken of the agreement
         * @param sender the sender
         * @param flowOperator the flowOperator
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3FlowOperatorData>} Web3 Flow info object
         */ this.getFlowOperatorData = async (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedSender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.sender);
            const normalizedFlowOperator = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.flowOperator);
            try {
                const flowOperatorData = await this.contract.connect(params.providerOrSigner).getFlowOperatorData(normalizedToken, normalizedSender, normalizedFlowOperator);
                return this._sanitizeFlowOperatorData(flowOperatorData);
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "CFAV1_READ",
                    message: "There was an error getting flow operator data",
                    cause: err
                });
            }
        };
        /**
         * Get flow operator data using the flowOperatorId.
         * @param superToken the superToken of the agreement
         * @param flowOperatorId The keccak256 hash of encoded string "flowOperator", sender and flowOperator
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3FlowOperatorData>} Web3 Flow info object
         */ this.getFlowOperatorDataByID = async (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            try {
                const flowOperatorData = await this.contract.connect(params.providerOrSigner).getFlowOperatorDataByID(normalizedToken, params.flowOperatorId);
                return this._sanitizeFlowOperatorData({
                    ...flowOperatorData,
                    flowOperatorId: params.flowOperatorId
                });
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "CFAV1_READ",
                    message: "There was an error getting flow operator data",
                    cause: err
                });
            }
        };
        /** ### CFA Write Functions ### */ /**
         * Create a flow.
         * @param flowRate The specified flow rate.
         * @param sender The sender of the flow
         * @param receiver The receiver of the flow.
         * @param superToken The token to be flowed.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @param shouldUseCallAgreement Whether to use callAgreement, or the CFAv1Forwarder
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.createFlow = (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedReceiver = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.receiver);
            const normalizedSender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.sender);
            const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("createFlow", [
                normalizedToken,
                normalizedReceiver,
                params.flowRate,
                "0x"
            ]);
            const callAgreementOperation = this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
            const forwarderPopulatedTxnPromise = this.forwarder.populateTransaction.createFlow(normalizedToken, normalizedSender, normalizedReceiver, params.flowRate, params.userData || "0x", params.overrides || {});
            return this._getCallAgreementOperation(callAgreementOperation, forwarderPopulatedTxnPromise, params.shouldUseCallAgreement || normalizedSender === "");
        };
        /**
         * Update a flow.
         * @param flowRate The specified flow rate.
         * @param sender The sender of the flow
         * @param receiver The receiver of the flow.
         * @param superToken The token to be flowed.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.updateFlow = (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedReceiver = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.receiver);
            const normalizedSender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.sender);
            const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("updateFlow", [
                normalizedToken,
                normalizedReceiver,
                params.flowRate,
                "0x"
            ]);
            const callAgreementOperation = this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
            const forwarderPopulatedTxnPromise = this.forwarder.populateTransaction.updateFlow(normalizedToken, normalizedSender, normalizedReceiver, params.flowRate, params.userData || "0x", params.overrides || {});
            return this._getCallAgreementOperation(callAgreementOperation, forwarderPopulatedTxnPromise, params.shouldUseCallAgreement || normalizedSender === "");
        };
        /**
         * Delete a flow.
         * @param superToken The token to be flowed.
         * @param sender The sender of the flow.
         * @param receiver The receiver of the flow.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.deleteFlow = (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedSender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.sender);
            const normalizedReceiver = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.receiver);
            const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("deleteFlow", [
                normalizedToken,
                normalizedSender,
                normalizedReceiver,
                "0x"
            ]);
            const callAgreementOperation = this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
            const forwarderPopulatedTxnPromise = this.forwarder.populateTransaction.deleteFlow(normalizedToken, normalizedSender, normalizedReceiver, params.userData || "0x", params.overrides || {});
            return this._getCallAgreementOperation(callAgreementOperation, forwarderPopulatedTxnPromise, params.shouldUseCallAgreement || normalizedSender === "");
        };
        /**
         * Create a flow as an operator
         * @param flowRate The specified flow rate.
         * @param sender The sender of the flow.
         * @param receiver The receiver of the flow.
         * @param superToken The token to be flowed.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.createFlowByOperator = (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedReceiver = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.receiver);
            const normalizedSender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.sender);
            const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("createFlowByOperator", [
                normalizedToken,
                normalizedSender,
                normalizedReceiver,
                params.flowRate,
                "0x"
            ]);
            const callAgreementOperation = this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
            const createFlowOperation = this.createFlow(params);
            return this._getCallAgreementOperation(callAgreementOperation, createFlowOperation.forwarderPopulatedPromise, params.shouldUseCallAgreement || normalizedSender === "");
        };
        /**
         * Update a flow as an operator.
         * @param flowRate The specified flow rate.
         * @param sender The sender of the flow.
         * @param receiver The receiver of the flow.
         * @param superToken The token to be flowed.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.updateFlowByOperator = (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedSender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.sender);
            const normalizedReceiver = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.receiver);
            const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("updateFlowByOperator", [
                normalizedToken,
                normalizedSender,
                normalizedReceiver,
                params.flowRate,
                "0x"
            ]);
            const callAgreementOperation = this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
            const updateFlowOperation = this.updateFlow(params);
            return this._getCallAgreementOperation(callAgreementOperation, updateFlowOperation.forwarderPopulatedPromise, params.shouldUseCallAgreement || normalizedSender === "");
        };
        /**
         * Delete a flow as an operator.
         * @param sender The sender of the flow.
         * @param receiver The receiver of the flow.
         * @param superToken The token to be flowed.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.deleteFlowByOperator = (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedSender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.sender);
            const normalizedReceiver = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.receiver);
            const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("deleteFlowByOperator", [
                normalizedToken,
                normalizedSender,
                normalizedReceiver,
                "0x"
            ]);
            const callAgreementOperation = this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
            const deleteFlowOperation = this.deleteFlow(params);
            return this._getCallAgreementOperation(callAgreementOperation, deleteFlowOperation.forwarderPopulatedPromise, params.shouldUseCallAgreement || normalizedSender === "");
        };
        /** ### Internal Helper Functions ### */ /**
         * Returns the desired Operation based on shouldUseCallAgreement.
         * @param shouldUseCallAgreement whether or not to use host.callAgreement
         * @param callAgreementOperation the host.callAgreement created Operation
         * @param forwarderPopulatedTransactionPromise the populated forwarder transaction promise
         */ this._getCallAgreementOperation = (callAgreementOperation, forwarderPopulatedTransactionPromise, shouldUseCallAgreement)=>{
            return shouldUseCallAgreement ? callAgreementOperation : new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(callAgreementOperation.populateTransactionPromise, callAgreementOperation.type, forwarderPopulatedTransactionPromise);
        };
        /**
         * Sanitizes flow info, converting BigNumber to string.
         * @param timestamp last updated timestamp of flow
         * @param flowRate the current flow rate
         * @param deposit the deposit amount
         * @param owedDeposit any owed deposit
         * @returns {IWeb3FlowInfo} sanitized web3 flow info
         */ this._sanitizeFlowInfo = (params)=>{
            return {
                timestamp: (0, $f456740ea8874244$export$f07c840af7d4309b)(params.timestamp),
                flowRate: params.flowRate.toString(),
                deposit: params.deposit.toString(),
                owedDeposit: params.owedDeposit.toString()
            };
        };
        /**
         * Sanitizes flow operator data, converting BigNumber to string.
         * @param flowOperatorId The keccak256 hash of encoded string "flowOperator", sender and flowOperator
         * @param permissions the permissions
         * @param flowRateAllowance the flow rate allowance granted to the flow operator
         * @returns {IWeb3FlowOperatorData} sanitized web3 flow info
         */ this._sanitizeFlowOperatorData = (params)=>{
            return {
                flowOperatorId: params.flowOperatorId,
                permissions: params.permissions.toString(),
                flowRateAllowance: params.flowRateAllowance.toString()
            };
        };
        this.host = new (0, $aa8d7ced1bddb8e4$export$2e2bcd8739ae039)(hostAddress);
        this.contract = new (0, $6c57cc56acea9c6c$exports).Contract(cfaV1Address, (0, $81fa2b585dc580d7$export$93a752d9b00820aa).abi);
        this.forwarder = new (0, $6c57cc56acea9c6c$exports).Contract(cfaV1ForwarderAddress, (0, $bba15bd706dcb09f$export$a2855e93a59184f0).abi);
    }
    /** ### CFA ACL Write Functions (byOperator) ### */ /**
     * Increase the flow rate allowance for an ACL operator.
     * @param superToken The token to be flowed.
     * @param flowOperator The operator of the flow.
     * @param flowRateAllowanceDelta The amount to increase the flow rate allowance by.
     * @param userData Extra user data provided.
     * @param overrides ethers overrides object for more control over the transaction sent.
     * @returns {Operation} An instance of Operation which can be executed or batched.
     */ increaseFlowRateAllowance(params) {
        const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
        const normalizedFlowOperator = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.flowOperator);
        const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("increaseFlowRateAllowance", [
            normalizedToken,
            normalizedFlowOperator,
            params.flowRateAllowanceDelta,
            "0x"
        ]);
        return this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
    }
    /**
     * Decrease the flow rate allowance for an ACL operator.
     * @param superToken The token to be flowed.
     * @param flowOperator The operator of the flow.
     * @param flowRateAllowanceDelta The amount to decrease the flow rate allowance by.
     * @param userData Extra user data provided.
     * @param overrides ethers overrides object for more control over the transaction sent.
     * @returns {Operation} An instance of Operation which can be executed or batched.
     */ decreaseFlowRateAllowance(params) {
        const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
        const normalizedFlowOperator = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.flowOperator);
        const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("decreaseFlowRateAllowance", [
            normalizedToken,
            normalizedFlowOperator,
            params.flowRateAllowanceDelta,
            "0x"
        ]);
        return this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
    }
    /**
     * Increase the flow rate allowance and sets permissions for an ACL operator.
     * @param superToken The token to be flowed.
     * @param flowOperator The operator of the flow.
     * @param permissionsDelta The permissions to be add for the operator.
     * @param flowRateAllowanceDelta The amount to increase the flow rate allowance by.
     * @param userData Extra user data provided.
     * @param overrides ethers overrides object for more control over the transaction sent.
     * @returns {Operation} An instance of Operation which can be executed or batched.
     */ increaseFlowRateAllowanceWithPermissions(params) {
        const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
        const normalizedFlowOperator = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.flowOperator);
        if (!(0, $f456740ea8874244$export$d81f7ffd7d512c0)(params.permissionsDelta)) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
            type: "UNCLEAN_PERMISSIONS",
            message: "The desired permissions are unclean"
        });
        const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("increaseFlowRateAllowanceWithPermissions", [
            normalizedToken,
            normalizedFlowOperator,
            params.permissionsDelta,
            params.flowRateAllowanceDelta,
            "0x"
        ]);
        return this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
    }
    /**
     * Decrease the flow rate allowance and sets permissions for an ACL operator.
     * @param superToken The token to be flowed.
     * @param flowOperator The operator of the flow.
     * @param permissionsDelta The permissions to be remove from the operator.
     * @param flowRateAllowanceDelta The amount to decrease the flow rate allowance by.
     * @param userData Extra user data provided.
     * @param overrides ethers overrides object for more control over the transaction sent.
     * @returns {Operation} An instance of Operation which can be executed or batched.
     */ decreaseFlowRateAllowanceWithPermissions(params) {
        const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
        const normalizedFlowOperator = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.flowOperator);
        if (!(0, $f456740ea8874244$export$d81f7ffd7d512c0)(params.permissionsDelta)) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
            type: "UNCLEAN_PERMISSIONS",
            message: "The desired permissions are unclean"
        });
        const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("decreaseFlowRateAllowanceWithPermissions", [
            normalizedToken,
            normalizedFlowOperator,
            params.permissionsDelta,
            params.flowRateAllowanceDelta,
            "0x"
        ]);
        return this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
    }
    /**
     * Update permissions for a flow operator as a sender.
     * @param superToken The token to be flowed.
     * @param flowOperator The permission grantee address
     * @param permission The permissions to set.
     * @param flowRateAllowance The flowRateAllowance granted to the flow operator.
     * @param userData Extra user data provided.
     * @param overrides ethers overrides object for more control over the transaction sent.
     * @returns {Operation} An instance of Operation which can be executed or batched.
     */ updateFlowOperatorPermissions(params) {
        const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
        const normalizedFlowOperator = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.flowOperator);
        if (!(0, $f456740ea8874244$export$d81f7ffd7d512c0)(params.permissions)) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
            type: "UNCLEAN_PERMISSIONS",
            message: "The desired permissions are unclean"
        });
        if (Number(params.flowRateAllowance) < 0) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
            type: "NEGATIVE_FLOW_ALLOWANCE",
            message: "No negative flow allowance allowed"
        });
        const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("updateFlowOperatorPermissions", [
            normalizedToken,
            normalizedFlowOperator,
            params.permissions,
            params.flowRateAllowance,
            "0x"
        ]);
        const callAgreementOperation = this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
        const forwarderPopulatedTxnPromise = this.forwarder.populateTransaction.updateFlowOperatorPermissions(normalizedToken, normalizedFlowOperator, params.permissions, params.flowRateAllowance, params.overrides || {});
        return this._getCallAgreementOperation(callAgreementOperation, forwarderPopulatedTxnPromise, params.shouldUseCallAgreement);
    }
    /**
     * Give flow operator full control - max flow rate and create/update/delete permissions.
     * @param superToken The token to be flowed.
     * @param flowOperator The permission grantee address
     * @param userData Extra user data provided.
     * @param overrides ethers overrides object for more control over the transaction sent.
     */ authorizeFlowOperatorWithFullControl(params) {
        const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
        const normalizedFlowOperator = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.flowOperator);
        const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("authorizeFlowOperatorWithFullControl", [
            normalizedToken,
            normalizedFlowOperator,
            "0x"
        ]);
        const callAgreementOperation = this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
        const forwarderPopulatedTxnPromise = this.forwarder.populateTransaction.grantPermissions(normalizedToken, normalizedFlowOperator, params.overrides || {});
        return this._getCallAgreementOperation(callAgreementOperation, forwarderPopulatedTxnPromise, params.shouldUseCallAgreement);
    }
    /**
     * Revoke flow operator control - set flow rate to 0 with no permissions.
     * @param superToken The token to be flowed.
     * @param flowOperator The permission grantee address
     * @param userData Extra user data provided.
     * @param overrides ethers overrides object for more control over the transaction sent.
     */ revokeFlowOperatorWithFullControl(params) {
        const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
        const normalizedFlowOperator = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.flowOperator);
        const callData = $6a091f8fcf7efe91$var$cfaInterface.encodeFunctionData("revokeFlowOperatorWithFullControl", [
            normalizedToken,
            normalizedFlowOperator,
            "0x"
        ]);
        const callAgreementOperation = this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
        const forwarderPopulatedTxnPromise = this.forwarder.populateTransaction.revokePermissions(normalizedToken, normalizedFlowOperator, params.overrides || {});
        return this._getCallAgreementOperation(callAgreementOperation, forwarderPopulatedTxnPromise, params.shouldUseCallAgreement);
    }
}







class $3de228b7e6630b4a$export$2e2bcd8739ae039 {
    constructor(address){
        /** ### ERC20 Token Contract Read Functions ### */ /**
         * Returns the allowance the `owner` has granted the `spender`.
         * @param owner the owner who has allotted the allowance
         * @param spender the spender who has received the allowance
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {Promise<string>} the allowance amount
         */ this.allowance = async ({ owner: owner, spender: spender, providerOrSigner: providerOrSigner })=>{
            const normalizedOwner = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(owner);
            const normalizedSpender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(spender);
            try {
                const allowance = await this.contract.connect(providerOrSigner).allowance(normalizedOwner, normalizedSpender);
                return allowance.toString();
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "SUPERTOKEN_READ",
                    message: "There was an error getting allowance",
                    cause: err
                });
            }
        };
        /**
         * Returns the ERC20 balanceOf the `account`, this can't be negative and will just display 0.
         * @param account the account you would like to query
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {Promise<string>} the token balance of `account`
         */ this.balanceOf = async ({ account: account, providerOrSigner: providerOrSigner })=>{
            try {
                const normalizedAccount = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(account);
                const balanceOf = await this.contract.connect(providerOrSigner).balanceOf(normalizedAccount);
                return balanceOf.toString();
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "SUPERTOKEN_READ",
                    message: "There was an error getting balanceOf",
                    cause: err
                });
            }
        };
        /**
         * Returns the token name
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {string} the token name
         */ this.name = async ({ providerOrSigner: providerOrSigner })=>{
            try {
                const name = await this.contract.connect(providerOrSigner).name();
                return name;
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "SUPERTOKEN_READ",
                    message: "There was an error getting name",
                    cause: err
                });
            }
        };
        /**
         * Returns the token symbol
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {string} the token symbol
         */ this.symbol = async ({ providerOrSigner: providerOrSigner })=>{
            try {
                const symbol = await this.contract.connect(providerOrSigner).symbol();
                return symbol;
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "SUPERTOKEN_READ",
                    message: "There was an error getting symbol",
                    cause: err
                });
            }
        };
        /**
         * Returns the total supply of the token.
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {Promise<string>} the total supply of the token
         */ this.totalSupply = async ({ providerOrSigner: providerOrSigner })=>{
            try {
                const totalSupply = await this.contract.connect(providerOrSigner).totalSupply();
                return totalSupply.toString();
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "SUPERTOKEN_READ",
                    message: "There was an error getting totalSupply",
                    cause: err
                });
            }
        };
        /** ### ERC20 Token Contract Write Functions ### */ /**
         * Approve `receiver` to spend `amount` tokens.
         * @param receiver The receiver approved.
         * @param amount The amount approved.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.approve = (params)=>{
            const normalizedReceiver = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.receiver);
            const txn = this.contract.populateTransaction.approve(normalizedReceiver, params.amount, params.overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "ERC20_APPROVE");
        };
        /**
         * Transfer `receiver` `amount` tokens.
         * @param receiver The receiver of the transfer.
         * @param amount The amount to be transferred.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.transfer = (params)=>{
            const normalizedReceiver = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.receiver);
            const txn = this.contract.populateTransaction.transfer(normalizedReceiver, params.amount, params.overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "UNSUPPORTED");
        };
        /**
         * Transfer from `sender` to `receiver` `amount` tokens.
         * @param sender The sender of the transfer.
         * @param receiver The receiver of the transfer.
         * @param amount The amount to be transferred.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.transferFrom = (params)=>{
            const normalizedSender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.sender);
            const normalizedReceiver = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.receiver);
            const txn = this.contract.populateTransaction.transferFrom(normalizedSender, normalizedReceiver, params.amount, params.overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "ERC20_TRANSFER_FROM");
        };
        this.address = address;
        this.contract = new (0, $6c57cc56acea9c6c$exports).Contract(address, (0, $38bf59142667d356$export$99578399fa3f294d).abi);
    }
}







class $044854795bf8e8dd$export$2e2bcd8739ae039 {
    constructor(hostAddress, governanceAddress){
        /**
         * Returns the 3Ps config for the specified token (or default) - the liquidation period and patrician period
         * @see https://docs.superfluid.finance/superfluid/sentinels/liquidations-and-toga
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @param token specified governance parameter token
         * @returns {Object} liquidationPeriod and patricianPeriod as strings
         */ this.getPPPConfig = async ({ providerOrSigner: providerOrSigner, token: token = (0, $6c57cc56acea9c6c$exports).constants.AddressZero })=>{
            const { liquidationPeriod: liquidationPeriod, patricianPeriod: patricianPeriod } = await this.contract.connect(providerOrSigner).getPPPConfig(this.hostAddress, token);
            return {
                liquidationPeriod: liquidationPeriod.toString(),
                patricianPeriod: patricianPeriod.toString()
            };
        };
        /**
         * Returns the reward address for the specified token (or default)
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @param token specified governance parameter token
         * @returns {string} the reward address
         */ this.getRewardAddress = async ({ providerOrSigner: providerOrSigner, token: token = (0, $6c57cc56acea9c6c$exports).constants.AddressZero })=>{
            return await this.contract.connect(providerOrSigner).getRewardAddress(this.hostAddress, token);
        };
        /**
         * Returns the minimum deposit for the specified token (or default)
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @param token specified governance parameter token
         * @returns {string} minimum deposit
         */ this.getMinimumDeposit = async ({ providerOrSigner: providerOrSigner, token: token = (0, $6c57cc56acea9c6c$exports).constants.AddressZero })=>{
            const superTokenMinimumDeposit = await this.contract.connect(providerOrSigner).getSuperTokenMinimumDeposit(this.hostAddress, token);
            return superTokenMinimumDeposit.toString();
        };
        /**
         * Returns the relevant governance parameters
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @param token specified governance parameter token
         * @returns {Object} liquidationPeriod, patricianPeriod, rewardAddress and minimumDeposit
         */ this.getGovernanceParameters = async ({ providerOrSigner: providerOrSigner, token: token = (0, $6c57cc56acea9c6c$exports).constants.AddressZero })=>{
            const pppPromise = this.getPPPConfig({
                providerOrSigner: providerOrSigner,
                token: token
            });
            const rewardPromise = this.getRewardAddress({
                providerOrSigner: providerOrSigner,
                token: token
            });
            const minimumDepositPromise = this.getMinimumDeposit({
                providerOrSigner: providerOrSigner,
                token: token
            });
            const data = await Promise.all([
                pppPromise,
                rewardPromise,
                minimumDepositPromise
            ]);
            return {
                liquidationPeriod: data[0].liquidationPeriod,
                patricianPeriod: data[0].patricianPeriod,
                rewardAddress: data[1],
                minimumDeposit: data[2]
            };
        };
        this.contract = new (0, $6c57cc56acea9c6c$exports).Contract(governanceAddress, (0, $7570d975954c793e$export$eaade2b72f505ed4).abi);
        this.hostAddress = hostAddress;
    }
}








const $421b609ee3c4a2a5$var$idaInterface = (0, $9747b8919df0eef0$export$572cca9965e684ae).createInterface();
class $421b609ee3c4a2a5$export$2e2bcd8739ae039 {
    constructor(hostAddress, idaV1Address){
        /** ### IDA Read Functions ### */ /**
         * Get the details of a `Subscription`.
         * @param superToken the superToken of the agreement
         * @param publisher the address of the publisher of the index
         * @param indexId the index id
         * @param subscriber the subscriber's address
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3Subscription>} Web3 Subscription object
         */ this.getSubscription = async (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedPublisher = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.publisher);
            const normalizedSubscriber = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.subscriber);
            try {
                const subscription = await this.contract.connect(params.providerOrSigner).getSubscription(normalizedToken, normalizedPublisher, params.indexId, normalizedSubscriber);
                return {
                    exist: subscription.exist,
                    approved: subscription.approved,
                    units: subscription.units.toString(),
                    pendingDistribution: subscription.pendingDistribution.toString()
                };
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "IDAV1_READ",
                    message: "There was an error getting the subscription",
                    cause: err
                });
            }
        };
        /**
         * Get the details of an `Index`.
         * @param superToken the superToken of the agreement
         * @param publisher the address of the publisher of the index
         * @param indexId the index id
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3Index>} Web3 Index object
         */ this.getIndex = async (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedPublisher = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.publisher);
            try {
                const index = await this.contract.connect(params.providerOrSigner).getIndex(normalizedToken, normalizedPublisher, params.indexId);
                return {
                    exist: index.exist,
                    indexValue: index.indexValue.toString(),
                    totalUnitsApproved: index.totalUnitsApproved.toString(),
                    totalUnitsPending: index.totalUnitsPending.toString()
                };
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "IDAV1_READ",
                    message: "There was an error getting the index",
                    cause: err
                });
            }
        };
        /** ### IDA Write Functions ### */ /**
         * Creates an IDA Index.
         * @param indexId The id of the index.
         * @param superToken The address of the `index` superToken.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.createIndex = (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const callData = $421b609ee3c4a2a5$var$idaInterface.encodeFunctionData("createIndex", [
                normalizedToken,
                params.indexId,
                "0x"
            ]);
            return this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
        };
        /**
         * Distributes `amount` of `superToken` to an index
         * @param indexId The id of the index.
         * @param amount The amount of `superToken` to be distributed.
         * @param superToken The superToken to be distributed.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.distribute = (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const callData = $421b609ee3c4a2a5$var$idaInterface.encodeFunctionData("distribute", [
                normalizedToken,
                params.indexId,
                params.amount,
                "0x"
            ]);
            return this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
        };
        /**
         * Updates the `indexValue` of an index.
         * @description NOTE: It has the same effect as `distribute`, but is closer to the low level data structure of the index.
         * @param indexId The id of the index.
         * @param indexValue The new indexValue.
         * @param superToken The superToken to be distributed.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.updateIndexValue = (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const callData = $421b609ee3c4a2a5$var$idaInterface.encodeFunctionData("updateIndex", [
                normalizedToken,
                params.indexId,
                params.indexValue,
                "0x"
            ]);
            return this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
        };
        /**
         * Updates the `units` allocated to a Subscription.
         * @param indexId The id of the index.
         * @param superToken The superToken of the index.
         * @param subscriber The subscriber address whose units you want to update.
         * @param units The amount of units you want to update to.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.updateSubscriptionUnits = (params)=>{
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedSubscriber = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.subscriber);
            const callData = $421b609ee3c4a2a5$var$idaInterface.encodeFunctionData("updateSubscription", [
                normalizedToken,
                params.indexId,
                normalizedSubscriber,
                params.units,
                "0x"
            ]);
            return this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
        };
        /**
         * Approves a Subscription, so the Subscriber won't need to claim tokens when the Publisher distributes.
         * @param indexId The id of the index.
         * @param superToken The superToken of the index.
         * @param publisher The publisher of the index you want to approve.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.approveSubscription = (params)=>{
            const normalizedPublisher = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.publisher);
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const callData = $421b609ee3c4a2a5$var$idaInterface.encodeFunctionData("approveSubscription", [
                normalizedToken,
                normalizedPublisher,
                params.indexId,
                "0x"
            ]);
            return this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
        };
        /**
         * Revokes a Subscription, so the Subscriber will need to claim tokens when the Publisher distributes.
         * @param indexId The id of the index.
         * @param superToken The superToken of the index.
         * @param subscriber The subscriber address whose subscription you want to revoke.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.revokeSubscription = (params)=>{
            const normalizedPublisher = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.publisher);
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const callData = $421b609ee3c4a2a5$var$idaInterface.encodeFunctionData("revokeSubscription", [
                normalizedToken,
                normalizedPublisher,
                params.indexId,
                "0x"
            ]);
            return this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
        };
        /**
         * Deletes a Subscription by setting the `units` allocated to the Subscriber to 0.
         * @param indexId The id of the index.
         * @param superToken The superToken of the index.
         * @param subscriber The subscriber address whose subscription you want to delete.
         * @param publisher The publisher address of the index you are targeting.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.deleteSubscription = (params)=>{
            const normalizedPublisher = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.publisher);
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedSubscriber = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.subscriber);
            const callData = $421b609ee3c4a2a5$var$idaInterface.encodeFunctionData("deleteSubscription", [
                normalizedToken,
                normalizedPublisher,
                params.indexId,
                normalizedSubscriber,
                "0x"
            ]);
            return this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
        };
        /**
         * Claims any pending tokens allocated to the Subscription (unapproved).
         * @param indexId The id of the index.
         * @param superToken The superToken of the index.
         * @param subscriber The subscriber address whose subscription you want to delete.
         * @param publisher The publisher address of the index you are targeting.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.claim = (params)=>{
            const normalizedPublisher = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.publisher);
            const normalizedToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.superToken);
            const normalizedSubscriber = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.subscriber);
            const callData = $421b609ee3c4a2a5$var$idaInterface.encodeFunctionData("claim", [
                normalizedToken,
                normalizedPublisher,
                params.indexId,
                normalizedSubscriber,
                "0x"
            ]);
            return this.host.callAgreement(this.contract.address, callData, params.userData, params.overrides);
        };
        this.host = new (0, $aa8d7ced1bddb8e4$export$2e2bcd8739ae039)(hostAddress);
        this.contract = new (0, $6c57cc56acea9c6c$exports).Contract(idaV1Address, (0, $9747b8919df0eef0$export$572cca9965e684ae).abi);
    }
}




var $f1q41 = parcelRequire("f1q41");
"use strict";
const $73255e22f3dfe257$export$9674531571d48800 = $73255e22f3dfe257$var$validate10;
const $73255e22f3dfe257$var$schema11 = {
    "$id": "validateSuperTokenRequest",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "isListed": {
            "type": "boolean",
            "nullable": true
        }
    }
};
function $73255e22f3dfe257$var$validate10(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == "object" && !Array.isArray(data)) {
            const _errs1 = errors;
            for(const key0 in data)if (!(key0 === "isListed")) {
                $73255e22f3dfe257$var$validate10.errors = [
                    {
                        instancePath: instancePath,
                        schemaPath: "#/additionalProperties",
                        keyword: "additionalProperties",
                        params: {
                            additionalProperty: key0
                        },
                        message: "must NOT have additional properties"
                    }
                ];
                return false;
            }
            if (_errs1 === errors) {
                if (data.isListed !== undefined) {
                    let data0 = data.isListed;
                    if (typeof data0 !== "boolean" && data0 !== null) {
                        $73255e22f3dfe257$var$validate10.errors = [
                            {
                                instancePath: instancePath + "/isListed",
                                schemaPath: "#/properties/isListed/type",
                                keyword: "type",
                                params: {
                                    type: "boolean"
                                },
                                message: "must be boolean"
                            }
                        ];
                        return false;
                    }
                }
            }
        } else {
            $73255e22f3dfe257$var$validate10.errors = [
                {
                    instancePath: instancePath,
                    schemaPath: "#/type",
                    keyword: "type",
                    params: {
                        type: "object"
                    },
                    message: "must be object"
                }
            ];
            return false;
        }
    }
    $73255e22f3dfe257$var$validate10.errors = vErrors;
    return errors === 0;
}
const $73255e22f3dfe257$export$8026d379bc83f3cc = $73255e22f3dfe257$var$validate11;
const $73255e22f3dfe257$var$schema12 = {
    "$id": "validateEventRequest",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "account": {
            "type": "string",
            "format": "addressOrEmpty",
            "nullable": true
        },
        "timestamp_gt": {
            "type": "number",
            "nullable": true
        }
    }
};
const $73255e22f3dfe257$var$formats0 = /(^(0x)?[0-9a-fA-F]{40}$)?/;
function $73255e22f3dfe257$var$validate11(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == "object" && !Array.isArray(data)) {
            const _errs1 = errors;
            for(const key0 in data)if (!(key0 === "account" || key0 === "timestamp_gt")) {
                $73255e22f3dfe257$var$validate11.errors = [
                    {
                        instancePath: instancePath,
                        schemaPath: "#/additionalProperties",
                        keyword: "additionalProperties",
                        params: {
                            additionalProperty: key0
                        },
                        message: "must NOT have additional properties"
                    }
                ];
                return false;
            }
            if (_errs1 === errors) {
                if (data.account !== undefined) {
                    let data0 = data.account;
                    const _errs2 = errors;
                    if (typeof data0 !== "string" && data0 !== null) {
                        $73255e22f3dfe257$var$validate11.errors = [
                            {
                                instancePath: instancePath + "/account",
                                schemaPath: "#/properties/account/type",
                                keyword: "type",
                                params: {
                                    type: "string"
                                },
                                message: "must be string"
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs2) {
                        if (errors === _errs2) {
                            if (typeof data0 === "string") {
                                if (!$73255e22f3dfe257$var$formats0.test(data0)) {
                                    $73255e22f3dfe257$var$validate11.errors = [
                                        {
                                            instancePath: instancePath + "/account",
                                            schemaPath: "#/properties/account/format",
                                            keyword: "format",
                                            params: {
                                                format: "addressOrEmpty"
                                            },
                                            message: 'must match format "addressOrEmpty"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                    var valid0 = _errs2 === errors;
                } else var valid0 = true;
                if (valid0) {
                    if (data.timestamp_gt !== undefined) {
                        let data1 = data.timestamp_gt;
                        const _errs5 = errors;
                        if (!(typeof data1 == "number" && isFinite(data1)) && data1 !== null) {
                            $73255e22f3dfe257$var$validate11.errors = [
                                {
                                    instancePath: instancePath + "/timestamp_gt",
                                    schemaPath: "#/properties/timestamp_gt/type",
                                    keyword: "type",
                                    params: {
                                        type: "number"
                                    },
                                    message: "must be number"
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    } else var valid0 = true;
                }
            }
        } else {
            $73255e22f3dfe257$var$validate11.errors = [
                {
                    instancePath: instancePath,
                    schemaPath: "#/type",
                    keyword: "type",
                    params: {
                        type: "object"
                    },
                    message: "must be object"
                }
            ];
            return false;
        }
    }
    $73255e22f3dfe257$var$validate11.errors = vErrors;
    return errors === 0;
}
const $73255e22f3dfe257$export$8d59a7504d31605a = $73255e22f3dfe257$var$validate12;
const $73255e22f3dfe257$var$schema13 = {
    "$id": "validateIndexRequest",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "indexId": {
            "type": "string",
            "format": "stringInteger",
            "nullable": true
        },
        "publisher": {
            "type": "string",
            "format": "addressOrEmpty",
            "nullable": true
        },
        "token": {
            "type": "string",
            "format": "addressOrEmpty",
            "nullable": true
        }
    }
};
const $73255e22f3dfe257$var$formats2 = /\d+/;
function $73255e22f3dfe257$var$validate12(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == "object" && !Array.isArray(data)) {
            const _errs1 = errors;
            for(const key0 in data)if (!(key0 === "indexId" || key0 === "publisher" || key0 === "token")) {
                $73255e22f3dfe257$var$validate12.errors = [
                    {
                        instancePath: instancePath,
                        schemaPath: "#/additionalProperties",
                        keyword: "additionalProperties",
                        params: {
                            additionalProperty: key0
                        },
                        message: "must NOT have additional properties"
                    }
                ];
                return false;
            }
            if (_errs1 === errors) {
                if (data.indexId !== undefined) {
                    let data0 = data.indexId;
                    const _errs2 = errors;
                    if (typeof data0 !== "string" && data0 !== null) {
                        $73255e22f3dfe257$var$validate12.errors = [
                            {
                                instancePath: instancePath + "/indexId",
                                schemaPath: "#/properties/indexId/type",
                                keyword: "type",
                                params: {
                                    type: "string"
                                },
                                message: "must be string"
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs2) {
                        if (errors === _errs2) {
                            if (typeof data0 === "string") {
                                if (!$73255e22f3dfe257$var$formats2.test(data0)) {
                                    $73255e22f3dfe257$var$validate12.errors = [
                                        {
                                            instancePath: instancePath + "/indexId",
                                            schemaPath: "#/properties/indexId/format",
                                            keyword: "format",
                                            params: {
                                                format: "stringInteger"
                                            },
                                            message: 'must match format "stringInteger"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                    var valid0 = _errs2 === errors;
                } else var valid0 = true;
                if (valid0) {
                    if (data.publisher !== undefined) {
                        let data1 = data.publisher;
                        const _errs5 = errors;
                        if (typeof data1 !== "string" && data1 !== null) {
                            $73255e22f3dfe257$var$validate12.errors = [
                                {
                                    instancePath: instancePath + "/publisher",
                                    schemaPath: "#/properties/publisher/type",
                                    keyword: "type",
                                    params: {
                                        type: "string"
                                    },
                                    message: "must be string"
                                }
                            ];
                            return false;
                        }
                        if (errors === _errs5) {
                            if (errors === _errs5) {
                                if (typeof data1 === "string") {
                                    if (!$73255e22f3dfe257$var$formats0.test(data1)) {
                                        $73255e22f3dfe257$var$validate12.errors = [
                                            {
                                                instancePath: instancePath + "/publisher",
                                                schemaPath: "#/properties/publisher/format",
                                                keyword: "format",
                                                params: {
                                                    format: "addressOrEmpty"
                                                },
                                                message: 'must match format "addressOrEmpty"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        var valid0 = _errs5 === errors;
                    } else var valid0 = true;
                    if (valid0) {
                        if (data.token !== undefined) {
                            let data2 = data.token;
                            const _errs8 = errors;
                            if (typeof data2 !== "string" && data2 !== null) {
                                $73255e22f3dfe257$var$validate12.errors = [
                                    {
                                        instancePath: instancePath + "/token",
                                        schemaPath: "#/properties/token/type",
                                        keyword: "type",
                                        params: {
                                            type: "string"
                                        },
                                        message: "must be string"
                                    }
                                ];
                                return false;
                            }
                            if (errors === _errs8) {
                                if (errors === _errs8) {
                                    if (typeof data2 === "string") {
                                        if (!$73255e22f3dfe257$var$formats0.test(data2)) {
                                            $73255e22f3dfe257$var$validate12.errors = [
                                                {
                                                    instancePath: instancePath + "/token",
                                                    schemaPath: "#/properties/token/format",
                                                    keyword: "format",
                                                    params: {
                                                        format: "addressOrEmpty"
                                                    },
                                                    message: 'must match format "addressOrEmpty"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            var valid0 = _errs8 === errors;
                        } else var valid0 = true;
                    }
                }
            }
        } else {
            $73255e22f3dfe257$var$validate12.errors = [
                {
                    instancePath: instancePath,
                    schemaPath: "#/type",
                    keyword: "type",
                    params: {
                        type: "object"
                    },
                    message: "must be object"
                }
            ];
            return false;
        }
    }
    $73255e22f3dfe257$var$validate12.errors = vErrors;
    return errors === 0;
}
const $73255e22f3dfe257$export$94a00fa1a6802143 = $73255e22f3dfe257$var$validate13;
const $73255e22f3dfe257$var$schema14 = {
    "$id": "validateAccountTokenSnapshotRequest",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "account": {
            "type": "string",
            "format": "addressOrEmpty",
            "nullable": true
        },
        "token": {
            "type": "string",
            "format": "addressOrEmpty",
            "nullable": true
        }
    }
};
function $73255e22f3dfe257$var$validate13(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == "object" && !Array.isArray(data)) {
            const _errs1 = errors;
            for(const key0 in data)if (!(key0 === "account" || key0 === "token")) {
                $73255e22f3dfe257$var$validate13.errors = [
                    {
                        instancePath: instancePath,
                        schemaPath: "#/additionalProperties",
                        keyword: "additionalProperties",
                        params: {
                            additionalProperty: key0
                        },
                        message: "must NOT have additional properties"
                    }
                ];
                return false;
            }
            if (_errs1 === errors) {
                if (data.account !== undefined) {
                    let data0 = data.account;
                    const _errs2 = errors;
                    if (typeof data0 !== "string" && data0 !== null) {
                        $73255e22f3dfe257$var$validate13.errors = [
                            {
                                instancePath: instancePath + "/account",
                                schemaPath: "#/properties/account/type",
                                keyword: "type",
                                params: {
                                    type: "string"
                                },
                                message: "must be string"
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs2) {
                        if (errors === _errs2) {
                            if (typeof data0 === "string") {
                                if (!$73255e22f3dfe257$var$formats0.test(data0)) {
                                    $73255e22f3dfe257$var$validate13.errors = [
                                        {
                                            instancePath: instancePath + "/account",
                                            schemaPath: "#/properties/account/format",
                                            keyword: "format",
                                            params: {
                                                format: "addressOrEmpty"
                                            },
                                            message: 'must match format "addressOrEmpty"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                    var valid0 = _errs2 === errors;
                } else var valid0 = true;
                if (valid0) {
                    if (data.token !== undefined) {
                        let data1 = data.token;
                        const _errs5 = errors;
                        if (typeof data1 !== "string" && data1 !== null) {
                            $73255e22f3dfe257$var$validate13.errors = [
                                {
                                    instancePath: instancePath + "/token",
                                    schemaPath: "#/properties/token/type",
                                    keyword: "type",
                                    params: {
                                        type: "string"
                                    },
                                    message: "must be string"
                                }
                            ];
                            return false;
                        }
                        if (errors === _errs5) {
                            if (errors === _errs5) {
                                if (typeof data1 === "string") {
                                    if (!$73255e22f3dfe257$var$formats0.test(data1)) {
                                        $73255e22f3dfe257$var$validate13.errors = [
                                            {
                                                instancePath: instancePath + "/token",
                                                schemaPath: "#/properties/token/format",
                                                keyword: "format",
                                                params: {
                                                    format: "addressOrEmpty"
                                                },
                                                message: 'must match format "addressOrEmpty"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        var valid0 = _errs5 === errors;
                    } else var valid0 = true;
                }
            }
        } else {
            $73255e22f3dfe257$var$validate13.errors = [
                {
                    instancePath: instancePath,
                    schemaPath: "#/type",
                    keyword: "type",
                    params: {
                        type: "object"
                    },
                    message: "must be object"
                }
            ];
            return false;
        }
    }
    $73255e22f3dfe257$var$validate13.errors = vErrors;
    return errors === 0;
}
const $73255e22f3dfe257$export$caf71e03dd6766e2 = $73255e22f3dfe257$var$validate14;
const $73255e22f3dfe257$var$schema15 = {
    "$id": "validateIndexSubscriptionRequest",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "subscriber": {
            "type": "string",
            "format": "stringInteger",
            "nullable": true
        },
        "approved": {
            "type": "boolean",
            "nullable": true
        }
    }
};
function $73255e22f3dfe257$var$validate14(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == "object" && !Array.isArray(data)) {
            const _errs1 = errors;
            for(const key0 in data)if (!(key0 === "subscriber" || key0 === "approved")) {
                $73255e22f3dfe257$var$validate14.errors = [
                    {
                        instancePath: instancePath,
                        schemaPath: "#/additionalProperties",
                        keyword: "additionalProperties",
                        params: {
                            additionalProperty: key0
                        },
                        message: "must NOT have additional properties"
                    }
                ];
                return false;
            }
            if (_errs1 === errors) {
                if (data.subscriber !== undefined) {
                    let data0 = data.subscriber;
                    const _errs2 = errors;
                    if (typeof data0 !== "string" && data0 !== null) {
                        $73255e22f3dfe257$var$validate14.errors = [
                            {
                                instancePath: instancePath + "/subscriber",
                                schemaPath: "#/properties/subscriber/type",
                                keyword: "type",
                                params: {
                                    type: "string"
                                },
                                message: "must be string"
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs2) {
                        if (errors === _errs2) {
                            if (typeof data0 === "string") {
                                if (!$73255e22f3dfe257$var$formats2.test(data0)) {
                                    $73255e22f3dfe257$var$validate14.errors = [
                                        {
                                            instancePath: instancePath + "/subscriber",
                                            schemaPath: "#/properties/subscriber/format",
                                            keyword: "format",
                                            params: {
                                                format: "stringInteger"
                                            },
                                            message: 'must match format "stringInteger"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                    var valid0 = _errs2 === errors;
                } else var valid0 = true;
                if (valid0) {
                    if (data.approved !== undefined) {
                        let data1 = data.approved;
                        const _errs5 = errors;
                        if (typeof data1 !== "boolean" && data1 !== null) {
                            $73255e22f3dfe257$var$validate14.errors = [
                                {
                                    instancePath: instancePath + "/approved",
                                    schemaPath: "#/properties/approved/type",
                                    keyword: "type",
                                    params: {
                                        type: "boolean"
                                    },
                                    message: "must be boolean"
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    } else var valid0 = true;
                }
            }
        } else {
            $73255e22f3dfe257$var$validate14.errors = [
                {
                    instancePath: instancePath,
                    schemaPath: "#/type",
                    keyword: "type",
                    params: {
                        type: "object"
                    },
                    message: "must be object"
                }
            ];
            return false;
        }
    }
    $73255e22f3dfe257$var$validate14.errors = vErrors;
    return errors === 0;
}
const $73255e22f3dfe257$export$c139794b81d01b07 = $73255e22f3dfe257$var$validate15;
const $73255e22f3dfe257$var$schema16 = {
    "$id": "validateStreamRequest",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "sender": {
            "type": "string",
            "format": "addressOrEmpty",
            "nullable": true
        },
        "receiver": {
            "type": "string",
            "format": "addressOrEmpty",
            "nullable": true
        },
        "token": {
            "type": "string",
            "format": "addressOrEmpty",
            "nullable": true
        }
    }
};
function $73255e22f3dfe257$var$validate15(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == "object" && !Array.isArray(data)) {
            const _errs1 = errors;
            for(const key0 in data)if (!(key0 === "sender" || key0 === "receiver" || key0 === "token")) {
                $73255e22f3dfe257$var$validate15.errors = [
                    {
                        instancePath: instancePath,
                        schemaPath: "#/additionalProperties",
                        keyword: "additionalProperties",
                        params: {
                            additionalProperty: key0
                        },
                        message: "must NOT have additional properties"
                    }
                ];
                return false;
            }
            if (_errs1 === errors) {
                if (data.sender !== undefined) {
                    let data0 = data.sender;
                    const _errs2 = errors;
                    if (typeof data0 !== "string" && data0 !== null) {
                        $73255e22f3dfe257$var$validate15.errors = [
                            {
                                instancePath: instancePath + "/sender",
                                schemaPath: "#/properties/sender/type",
                                keyword: "type",
                                params: {
                                    type: "string"
                                },
                                message: "must be string"
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs2) {
                        if (errors === _errs2) {
                            if (typeof data0 === "string") {
                                if (!$73255e22f3dfe257$var$formats0.test(data0)) {
                                    $73255e22f3dfe257$var$validate15.errors = [
                                        {
                                            instancePath: instancePath + "/sender",
                                            schemaPath: "#/properties/sender/format",
                                            keyword: "format",
                                            params: {
                                                format: "addressOrEmpty"
                                            },
                                            message: 'must match format "addressOrEmpty"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                    var valid0 = _errs2 === errors;
                } else var valid0 = true;
                if (valid0) {
                    if (data.receiver !== undefined) {
                        let data1 = data.receiver;
                        const _errs5 = errors;
                        if (typeof data1 !== "string" && data1 !== null) {
                            $73255e22f3dfe257$var$validate15.errors = [
                                {
                                    instancePath: instancePath + "/receiver",
                                    schemaPath: "#/properties/receiver/type",
                                    keyword: "type",
                                    params: {
                                        type: "string"
                                    },
                                    message: "must be string"
                                }
                            ];
                            return false;
                        }
                        if (errors === _errs5) {
                            if (errors === _errs5) {
                                if (typeof data1 === "string") {
                                    if (!$73255e22f3dfe257$var$formats0.test(data1)) {
                                        $73255e22f3dfe257$var$validate15.errors = [
                                            {
                                                instancePath: instancePath + "/receiver",
                                                schemaPath: "#/properties/receiver/format",
                                                keyword: "format",
                                                params: {
                                                    format: "addressOrEmpty"
                                                },
                                                message: 'must match format "addressOrEmpty"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        var valid0 = _errs5 === errors;
                    } else var valid0 = true;
                    if (valid0) {
                        if (data.token !== undefined) {
                            let data2 = data.token;
                            const _errs8 = errors;
                            if (typeof data2 !== "string" && data2 !== null) {
                                $73255e22f3dfe257$var$validate15.errors = [
                                    {
                                        instancePath: instancePath + "/token",
                                        schemaPath: "#/properties/token/type",
                                        keyword: "type",
                                        params: {
                                            type: "string"
                                        },
                                        message: "must be string"
                                    }
                                ];
                                return false;
                            }
                            if (errors === _errs8) {
                                if (errors === _errs8) {
                                    if (typeof data2 === "string") {
                                        if (!$73255e22f3dfe257$var$formats0.test(data2)) {
                                            $73255e22f3dfe257$var$validate15.errors = [
                                                {
                                                    instancePath: instancePath + "/token",
                                                    schemaPath: "#/properties/token/format",
                                                    keyword: "format",
                                                    params: {
                                                        format: "addressOrEmpty"
                                                    },
                                                    message: 'must match format "addressOrEmpty"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            var valid0 = _errs8 === errors;
                        } else var valid0 = true;
                    }
                }
            }
        } else {
            $73255e22f3dfe257$var$validate15.errors = [
                {
                    instancePath: instancePath,
                    schemaPath: "#/type",
                    keyword: "type",
                    params: {
                        type: "object"
                    },
                    message: "must be object"
                }
            ];
            return false;
        }
    }
    $73255e22f3dfe257$var$validate15.errors = vErrors;
    return errors === 0;
}


var $e55ac4bd8e7db28b$export$bab1dcc0a69bea6c;
(function(FlowUpdateType) {
    FlowUpdateType[FlowUpdateType["Create"] = 0] = "Create";
    FlowUpdateType[FlowUpdateType["Update"] = 1] = "Update";
    FlowUpdateType[FlowUpdateType["Terminate"] = 2] = "Terminate";
})($e55ac4bd8e7db28b$export$bab1dcc0a69bea6c || ($e55ac4bd8e7db28b$export$bab1dcc0a69bea6c = {}));



const $05c2b66738aae405$export$7af0467e7a486478 = (queryEvents)=>{
    return queryEvents.map((x)=>{
        switch(x.__typename){
            case "AppRegisteredEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "AppRegistered",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    app: x.app
                });
            case "AgreementClassRegisteredEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "AgreementClassRegistered",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    agreementType: x.agreementType,
                    code: x.code
                });
            case "AgreementClassUpdatedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "AgreementClassUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    agreementType: x.agreementType,
                    code: x.code
                });
            case "AgreementLiquidatedByEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "AgreementLiquidatedBy",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    agreementClass: x.agreementClass,
                    agreementId: x.agreementId,
                    bailoutAmount: x.bailoutAmount,
                    bondAccount: x.bondAccount,
                    liquidatorAccount: x.liquidatorAccount,
                    penaltyAccount: x.penaltyAccount,
                    rewardAmount: x.rewardAmount,
                    token: x.token
                });
            case "AgreementLiquidatedV2Event":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "AgreementLiquidatedV2",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    liquidatorAccount: x.liquidatorAccount,
                    agreementClass: x.agreementClass,
                    agreementId: x.agreementId,
                    targetAccount: x.targetAccount,
                    rewardAmountReceiver: x.rewardAmountReceiver,
                    rewardAmount: x.rewardAmount,
                    targetAccountBalanceDelta: x.targetAccountBalanceDelta,
                    version: x.version,
                    liquidationType: x.liquidationType,
                    // TO BE DEPRECATED in v2 endpoint - use rewardAmountReceiver instead
                    rewardAccount: x.rewardAccount
                });
            case "BurnedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "Burned",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    amount: x.amount,
                    data: x.data,
                    from: x.from,
                    operator: x.operator,
                    token: x.token,
                    operatorData: x.operatorData
                });
            case "CFAv1LiquidationPeriodChangedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "CFAv1LiquidationPeriodChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    host: x.host,
                    governanceAddress: x.governanceAddress,
                    isKeySet: x.isKeySet,
                    liquidationPeriod: Number(x.liquidationPeriod),
                    superToken: x.superToken
                });
            case "ConfigChangedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "ConfigChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    host: x.host,
                    governanceAddress: x.governanceAddress,
                    isKeySet: x.isKeySet,
                    key: x.key,
                    superToken: x.superToken,
                    value: x.value
                });
            case "CustomSuperTokenCreatedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "CustomSuperTokenCreated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token
                });
            case "FlowUpdatedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "FlowUpdated",
                    type: $05c2b66738aae405$var$mapNumberToFlowUpdateType(x.type),
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    flowRate: x.flowRate,
                    receiver: x.receiver,
                    sender: x.sender,
                    flowOperator: x.flowOperator,
                    deposit: x.deposit,
                    streamId: x.stream.id
                });
            case "FlowOperatorUpdatedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "FlowOperatorUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    sender: x.sender,
                    permissions: x.permissions,
                    flowRateAllowance: x.flowRateAllowance
                });
            case "GovernanceReplacedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "GovernanceReplaced",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    oldGovernance: x.oldGovernance,
                    newGovernance: x.newGovernance
                });
            case "IndexCreatedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "IndexCreated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    index: x.index.id,
                    indexId: x.indexId,
                    publisher: x.publisher,
                    userData: x.userData
                });
            case "IndexDistributionClaimedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "IndexDistributionClaimed",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    amount: x.amount,
                    index: x.index.id,
                    indexId: x.indexId,
                    publisher: x.publisher,
                    subscriber: x.subscriber
                });
            case "IndexSubscribedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "IndexSubscribed",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    index: x.index.id,
                    indexId: x.indexId,
                    publisher: x.publisher,
                    subscriber: x.subscriber
                });
            case "IndexUnitsUpdatedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "IndexUnitsUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    index: x.index.id,
                    indexId: x.indexId,
                    publisher: x.publisher,
                    subscriber: x.subscriber,
                    units: x.units,
                    oldUnits: x.oldUnits,
                    userData: x.userData
                });
            case "IndexUnsubscribedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "IndexUnsubscribed",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    index: x.index.id,
                    indexId: x.indexId,
                    publisher: x.publisher,
                    subscriber: x.subscriber,
                    userData: x.userData
                });
            case "IndexUpdatedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "IndexUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    index: x.index.id,
                    indexId: x.indexId,
                    newIndexValue: x.newIndexValue,
                    oldIndexValue: x.oldIndexValue,
                    publisher: x.publisher,
                    totalUnitsApproved: x.totalUnitsApproved,
                    totalUnitsPending: x.totalUnitsPending,
                    userData: x.userData
                });
            case "JailEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "Jail",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    app: x.app,
                    reason: x.reason
                });
            case "MintedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "Minted",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    operator: x.operator,
                    to: x.to,
                    amount: x.amount,
                    data: x.data,
                    token: x.token,
                    operatorData: x.operatorData
                });
            case "RewardAddressChangedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "RewardAddressChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    host: x.host,
                    governanceAddress: x.governanceAddress,
                    superToken: x.superToken,
                    isKeySet: x.isKeySet,
                    rewardAddress: x.rewardAddress
                });
            case "RoleAdminChangedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "RoleAdminChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    role: x.role,
                    previousAdminRole: x.previousAdminRole,
                    newAdminRole: x.newAdminRole
                });
            case "RoleGrantedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "RoleGranted",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    role: x.role,
                    account: x.account,
                    sender: x.sender
                });
            case "RoleRevokedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "RoleRevoked",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    role: x.role,
                    account: x.account,
                    sender: x.sender
                });
            case "SetEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "Set",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    hashedName: x.hashedName,
                    targetAddress: x.target,
                    resolverEntry: x.resolverEntry.id
                });
            case "SentEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "Sent",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    operator: x.operator,
                    to: x.to,
                    amount: x.amount,
                    data: x.data,
                    token: x.token,
                    operatorData: x.operatorData
                });
            case "SubscriptionApprovedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "SubscriptionApproved",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    subscriber: x.subscriber,
                    publisher: x.publisher,
                    indexId: x.indexId,
                    userData: x.userData,
                    subscription: x.subscription.id
                });
            case "SubscriptionDistributionClaimedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "SubscriptionDistributionClaimed",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    subscriber: x.subscriber,
                    publisher: x.publisher,
                    indexId: x.indexId,
                    amount: x.amount,
                    subscription: x.subscription.id
                });
            case "SubscriptionRevokedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "SubscriptionRevoked",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    subscriber: x.subscriber,
                    publisher: x.publisher,
                    indexId: x.indexId,
                    userData: x.userData,
                    subscription: x.subscription.id
                });
            case "SubscriptionUnitsUpdatedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "SubscriptionUnitsUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    subscriber: x.subscriber,
                    publisher: x.publisher,
                    indexId: x.indexId,
                    units: x.units,
                    userData: x.userData,
                    subscription: x.subscription.id
                });
            case "SuperTokenCreatedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "SuperTokenCreated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token
                });
            case "SuperTokenFactoryUpdatedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "SuperTokenFactoryUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    newFactory: x.newFactory
                });
            case "SuperTokenLogicCreatedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "SuperTokenLogicCreated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    tokenLogic: x.tokenLogic
                });
            case "SuperTokenLogicUpdatedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "SuperTokenLogicUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    code: x.code
                });
            case "PPPConfigurationChangedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "PPPConfigurationChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    host: x.host,
                    governanceAddress: x.governanceAddress,
                    superToken: x.superToken,
                    isKeySet: x.isKeySet,
                    liquidationPeriod: x.liquidationPeriod,
                    patricianPeriod: x.patricianPeriod
                });
            case "TokenDowngradedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "TokenDowngraded",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    amount: x.amount,
                    token: x.token,
                    account: x.account.id
                });
            case "TokenUpgradedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "TokenUpgraded",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    amount: x.amount,
                    token: x.token,
                    account: x.account.id
                });
            case "TransferEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "Transfer",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    from: x.from.id,
                    to: x.to.id,
                    token: x.token,
                    value: x.value
                });
            case "TrustedForwarderChangedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "TrustedForwarderChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    host: x.host,
                    governanceAddress: x.governanceAddress,
                    superToken: x.superToken,
                    isKeySet: x.isKeySet,
                    forwarder: x.forwarder,
                    enabled: x.enabled
                });
            case "SuperTokenMinimumDepositChangedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "SuperTokenMinimumDepositChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    host: x.host,
                    governanceAddress: x.governanceAddress,
                    superToken: x.superToken,
                    isKeySet: x.isKeySet,
                    minimumDeposit: x.minimumDeposit
                });
            case "NewPICEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "NewPIC",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    pic: x.pic,
                    bond: x.bond,
                    exitRate: x.exitRate
                });
            case "ExitRateChangedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "ExitRateChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    exitRate: x.exitRate
                });
            case "BondIncreasedEvent":
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "BondIncreased",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: Number(x.order),
                    timestamp: Number(x.timestamp),
                    logIndex: Number(x.logIndex),
                    token: x.token,
                    additionalBond: x.additionalBond
                });
            default:
                console.warn("An unknown event was detected which couldn't be mapped. Please update to the latest version of @superfluid-finance/sdk-core.");
                return (0, $f456740ea8874244$export$f62628bb56170863)({
                    name: "_Unknown",
                    id: x.id,
                    blockNumber: x.blockNumber,
                    transactionHash: x.transactionHash,
                    gasPrice: x.gasPrice,
                    order: x.order,
                    timestamp: x.timestamp,
                    logIndex: x.logIndex
                });
        }
    });
};
const $05c2b66738aae405$var$mapNumberToFlowUpdateType = (type)=>{
    if (type === 0) return $e55ac4bd8e7db28b$export$bab1dcc0a69bea6c.Create;
    else if (type === 1) return $e55ac4bd8e7db28b$export$bab1dcc0a69bea6c.Update;
    else if (type === 2) return $e55ac4bd8e7db28b$export$bab1dcc0a69bea6c.Terminate;
    else throw Error(`Mapping error: unknown flow update type ([${type}]).`);
};


/**
 * Factory function to create a {@link PagedResult}.
 * @param dataPlusOne Subgraph queries are executed with one extra result to get which is over the {@link Paging} `take` amount.
 * @param paging
 */ const $e9fa3bd1f0f40070$export$ed1321ad5ca95972 = (dataPlusOne, paging)=>{
    var _a;
    const hasNextPage = dataPlusOne.length > paging.take;
    const data = dataPlusOne.slice(0, paging.take);
    const lastId = (_a = data.slice(-1)[0]) === null || _a === void 0 ? void 0 : _a.id;
    return {
        paging: {
            skip: paging.skip,
            take: paging.take
        },
        nextPaging: hasNextPage ? $e9fa3bd1f0f40070$export$7431a735a90e5b99(paging) ? $e9fa3bd1f0f40070$export$f72f6b95085dec99(paging) : $e9fa3bd1f0f40070$export$b3bf1c48ccc75249(paging) ? $e9fa3bd1f0f40070$export$7b6409e6565ad2bb(paging, lastId) : $e9fa3bd1f0f40070$export$80fe49a6bffac98c(paging) ? $e9fa3bd1f0f40070$export$70166206719ce9d1(paging) : undefined : undefined,
        data: data,
        items: data
    };
};
function $e9fa3bd1f0f40070$export$7431a735a90e5b99(paging) {
    return (paging === null || paging === void 0 ? void 0 : paging.skip) !== undefined;
}
function $e9fa3bd1f0f40070$export$80fe49a6bffac98c(paging) {
    return (paging === null || paging === void 0 ? void 0 : paging.pageNumber) !== undefined;
}
function $e9fa3bd1f0f40070$export$b3bf1c48ccc75249(paging) {
    return (paging === null || paging === void 0 ? void 0 : paging.lastId) !== undefined;
}
function $e9fa3bd1f0f40070$export$3cdc042667879bc1(paging) {
    return paging !== undefined && paging.skip === undefined && paging.lastId === undefined && paging.take === Infinity;
}
const $e9fa3bd1f0f40070$export$51fe14f826d94a33 = ({ skip: skip = 0, take: take = 100 } = {})=>({
        skip: skip,
        take: take
    });
const $e9fa3bd1f0f40070$export$d44f482e74966269 = ({ pageNumber: pageNumber = 1, take: take = 100 } = {})=>({
        take: take,
        pageNumber: pageNumber
    });
const $e9fa3bd1f0f40070$export$e5a659d88c9ba001 = ({ lastId: lastId = "", take: take = 100 } = {})=>({
        take: take,
        lastId: lastId
    });
const $e9fa3bd1f0f40070$export$f72f6b95085dec99 = (paging)=>({
        skip: paging.skip + paging.take,
        take: paging.take
    });
const $e9fa3bd1f0f40070$export$70166206719ce9d1 = (paging)=>({
        pageNumber: paging.pageNumber + 1,
        take: paging.take
    });
const $e9fa3bd1f0f40070$export$7b6409e6565ad2bb = (paging, nextLastId)=>({
        take: paging.take,
        lastId: nextLastId
    });
const $e9fa3bd1f0f40070$export$5ba852834ab142d0 = (paging)=>{
    return paging.take + 1;
};


var $c1f86eaa549c814d$exports = {};
"use strict";
var $c1f86eaa549c814d$var$__createBinding = $c1f86eaa549c814d$exports && $c1f86eaa549c814d$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c1f86eaa549c814d$var$__setModuleDefault = $c1f86eaa549c814d$exports && $c1f86eaa549c814d$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c1f86eaa549c814d$var$__importStar = $c1f86eaa549c814d$exports && $c1f86eaa549c814d$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c1f86eaa549c814d$var$__createBinding(result, mod, k);
    }
    $c1f86eaa549c814d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c1f86eaa549c814d$exports, "__esModule", {
    value: true
});
$c1f86eaa549c814d$exports.request = $c1f86eaa549c814d$exports.rawRequest = $c1f86eaa549c814d$exports.GraphQLClient = $c1f86eaa549c814d$exports.ClientError = $c1f86eaa549c814d$exports.batchRequests = $c1f86eaa549c814d$exports.resolveRequestDocument = $c1f86eaa549c814d$exports.GraphQLWebSocketClient = $c1f86eaa549c814d$exports.gql = void 0;
var $b5d06f785ca72eac$exports = {};
"use strict";
Object.defineProperty($b5d06f785ca72eac$exports, "__esModule", {
    value: true
});
$b5d06f785ca72eac$exports.defaultJsonSerializer = void 0;
$b5d06f785ca72eac$exports.defaultJsonSerializer = JSON;


var $d66afb9c573fca88$exports = {};
"use strict";
Object.defineProperty($d66afb9c573fca88$exports, "__esModule", {
    value: true
});
$d66afb9c573fca88$exports.HeadersInstanceToPlainObject = $d66afb9c573fca88$exports.uppercase = void 0;
const $d66afb9c573fca88$var$uppercase = (str)=>str.toUpperCase();
$d66afb9c573fca88$exports.uppercase = $d66afb9c573fca88$var$uppercase;
/**
 * Convert Headers instance into regular object
 */ const $d66afb9c573fca88$var$HeadersInstanceToPlainObject = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};
$d66afb9c573fca88$exports.HeadersInstanceToPlainObject = $d66afb9c573fca88$var$HeadersInstanceToPlainObject;


var $e8402b3d0ff642e7$exports = {};
"use strict";
Object.defineProperty($e8402b3d0ff642e7$exports, "__esModule", {
    value: true
});
$e8402b3d0ff642e7$exports.parseRawRequestExtendedArgs = $e8402b3d0ff642e7$exports.parseRequestExtendedArgs = $e8402b3d0ff642e7$exports.parseBatchRequestArgs = $e8402b3d0ff642e7$exports.parseRawRequestArgs = $e8402b3d0ff642e7$exports.parseRequestArgs = void 0;
const $e8402b3d0ff642e7$var$parseRequestArgs = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$e8402b3d0ff642e7$exports.parseRequestArgs = $e8402b3d0ff642e7$var$parseRequestArgs;
const $e8402b3d0ff642e7$var$parseRawRequestArgs = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$e8402b3d0ff642e7$exports.parseRawRequestArgs = $e8402b3d0ff642e7$var$parseRawRequestArgs;
const $e8402b3d0ff642e7$var$parseBatchRequestArgs = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$e8402b3d0ff642e7$exports.parseBatchRequestArgs = $e8402b3d0ff642e7$var$parseBatchRequestArgs;
const $e8402b3d0ff642e7$var$parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$e8402b3d0ff642e7$exports.parseRequestExtendedArgs = $e8402b3d0ff642e7$var$parseRequestExtendedArgs;
const $e8402b3d0ff642e7$var$parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$e8402b3d0ff642e7$exports.parseRawRequestExtendedArgs = $e8402b3d0ff642e7$var$parseRawRequestExtendedArgs;


var $1e225eee6088265b$exports = {};
"use strict";
Object.defineProperty($1e225eee6088265b$exports, "__esModule", {
    value: true
});
$1e225eee6088265b$exports.resolveRequestDocument = void 0;
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $f419306d4be7fb23$export$c10d0b04eaa80a43(value) {
    return typeof value == "object" && value !== null;
}


function $0989dd6156f69013$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}


const $151337c9f32f7005$var$LineRegExp = /\r\n|[\n\r]/g;
function $151337c9f32f7005$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($151337c9f32f7005$var$LineRegExp)){
        typeof match.index === "number" || (0, $0989dd6156f69013$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $a45c53fbf464b798$export$96a9681e539deed(location) {
    return $a45c53fbf464b798$export$867940333fd9f869(location.source, (0, $151337c9f32f7005$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $a45c53fbf464b798$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = "".padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    "|",
                    subLine
                ]),
            [
                "|",
                "^".padStart(subLineColumnNum)
            ],
            [
                "|",
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            "|",
            "^".padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $a45c53fbf464b798$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}


function $52f13d37c0305dc6$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || "kind" in firstArg || "length" in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $52f13d37c0305dc6$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $52f13d37c0305dc6$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = "GraphQLError";
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $52f13d37c0305dc6$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $52f13d37c0305dc6$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $151337c9f32f7005$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $151337c9f32f7005$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $f419306d4be7fb23$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $52f13d37c0305dc6$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += "\n\n" + (0, $a45c53fbf464b798$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += "\n\n" + (0, $a45c53fbf464b798$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $52f13d37c0305dc6$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $52f13d37c0305dc6$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $52f13d37c0305dc6$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $ddf6b9f696b0d6b2$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $52f13d37c0305dc6$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $11b06753ce50693f$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $11b06753ce50693f$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $11b06753ce50693f$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
const $11b06753ce50693f$var$kindValues = new Set(Object.keys($11b06753ce50693f$export$4fcd777a40ccf407));
function $11b06753ce50693f$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $11b06753ce50693f$var$kindValues.has(maybeKind);
}
/** Name */ var $11b06753ce50693f$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($11b06753ce50693f$export$f58c50edb4aef9d4 || ($11b06753ce50693f$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed directive location values.
 */ var $289bf729a82494c6$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation["QUERY"] = "QUERY";
    DirectiveLocation["MUTATION"] = "MUTATION";
    DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
    DirectiveLocation["FIELD"] = "FIELD";
    DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
    DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
    DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
    DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
    DirectiveLocation["SCHEMA"] = "SCHEMA";
    DirectiveLocation["SCALAR"] = "SCALAR";
    DirectiveLocation["OBJECT"] = "OBJECT";
    DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
    DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
    DirectiveLocation["INTERFACE"] = "INTERFACE";
    DirectiveLocation["UNION"] = "UNION";
    DirectiveLocation["ENUM"] = "ENUM";
    DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
    DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
    DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})($289bf729a82494c6$export$b45ffd2948484c41 || ($289bf729a82494c6$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 

/**
 * The set of allowed kind values for AST nodes.
 */ var $b7b8db97a7d116fe$export$a84bdc57c5122798;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($b7b8db97a7d116fe$export$a84bdc57c5122798 || ($b7b8db97a7d116fe$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $876b79dde797933a$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $876b79dde797933a$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $876b79dde797933a$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $876b79dde797933a$export$45a677ea7cb6d5c8(code) {
    return $876b79dde797933a$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $876b79dde797933a$export$d3f406ff46035894(code) {
    return $876b79dde797933a$export$79c5d5217943d6a7(code) || $876b79dde797933a$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $a51b3e37e1f6e888$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $a51b3e37e1f6e888$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $a51b3e37e1f6e888$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $876b79dde797933a$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $a51b3e37e1f6e888$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $a51b3e37e1f6e888$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $876b79dde797933a$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $876b79dde797933a$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}



/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $ac240aaa94caf15d$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["SOF"] = "<SOF>";
    TokenKind["EOF"] = "<EOF>";
    TokenKind["BANG"] = "!";
    TokenKind["DOLLAR"] = "$";
    TokenKind["AMP"] = "&";
    TokenKind["PAREN_L"] = "(";
    TokenKind["PAREN_R"] = ")";
    TokenKind["SPREAD"] = "...";
    TokenKind["COLON"] = ":";
    TokenKind["EQUALS"] = "=";
    TokenKind["AT"] = "@";
    TokenKind["BRACKET_L"] = "[";
    TokenKind["BRACKET_R"] = "]";
    TokenKind["BRACE_L"] = "{";
    TokenKind["PIPE"] = "|";
    TokenKind["BRACE_R"] = "}";
    TokenKind["NAME"] = "Name";
    TokenKind["INT"] = "Int";
    TokenKind["FLOAT"] = "Float";
    TokenKind["STRING"] = "String";
    TokenKind["BLOCK_STRING"] = "BlockString";
    TokenKind["COMMENT"] = "Comment";
})($ac240aaa94caf15d$export$8b9d26ab11394711 || ($ac240aaa94caf15d$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $971bc50063303b32$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return "Lexer";
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $971bc50063303b32$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $971bc50063303b32$export$59ac0f4da287406a(kind) {
    return kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BANG || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $971bc50063303b32$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $971bc50063303b32$var$isSupplementaryCodePoint(body, location) {
    return $971bc50063303b32$var$isLeadingSurrogate(body.charCodeAt(location)) && $971bc50063303b32$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $971bc50063303b32$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $971bc50063303b32$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $971bc50063303b32$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
 * Create a token with line and column location information.
 */ function $971bc50063303b32$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $11b06753ce50693f$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $971bc50063303b32$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $971bc50063303b32$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $971bc50063303b32$var$readBlockString(lexer, position);
                return $971bc50063303b32$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $876b79dde797933a$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $971bc50063303b32$var$readNumber(lexer, position, code);
         // Name
        if ((0, $876b79dde797933a$export$45a677ea7cb6d5c8)(code)) return $971bc50063303b32$var$readName(lexer, position);
        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : $971bc50063303b32$var$isUnicodeScalarValue(code) || $971bc50063303b32$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    }
    return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $971bc50063303b32$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($971bc50063303b32$var$isUnicodeScalarValue(code)) ++position;
        else if ($971bc50063303b32$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $971bc50063303b32$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $876b79dde797933a$export$727d9dbc4fbb948f)(code)) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $971bc50063303b32$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $876b79dde797933a$export$45a677ea7cb6d5c8)(code)) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    return $971bc50063303b32$var$createToken(lexer, isFloat ? (0, $ac240aaa94caf15d$export$8b9d26ab11394711).FLOAT : (0, $ac240aaa94caf15d$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $971bc50063303b32$var$readDigits(lexer, start, firstCode) {
    if (!(0, $876b79dde797933a$export$727d9dbc4fbb948f)(firstCode)) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$971bc50063303b32$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $876b79dde797933a$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $971bc50063303b32$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = "";
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $971bc50063303b32$var$readEscapedUnicodeVariableWidth(lexer, position) : $971bc50063303b32$var$readEscapedUnicodeFixedWidth(lexer, position) : $971bc50063303b32$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($971bc50063303b32$var$isUnicodeScalarValue(code)) ++position;
        else if ($971bc50063303b32$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, "Unterminated string.");
} // The string value and lexed size of an escape sequence.
function $971bc50063303b32$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$971bc50063303b32$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $971bc50063303b32$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $971bc50063303b32$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $971bc50063303b32$var$read16BitHexCode(body, position + 2);
    if ($971bc50063303b32$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($971bc50063303b32$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $971bc50063303b32$var$read16BitHexCode(body, position + 8);
            if ($971bc50063303b32$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $971bc50063303b32$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $971bc50063303b32$var$readHexDigit(body.charCodeAt(position)) << 12 | $971bc50063303b32$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $971bc50063303b32$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $971bc50063303b32$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $971bc50063303b32$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $971bc50063303b32$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '"',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: "\\",
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: "/",
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: "\b",
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: "\f",
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: "\n",
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: "\r",
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: "	",
                size: 2
            };
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $971bc50063303b32$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = "";
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $a51b3e37e1f6e888$export$d5ee19b441e8d2ae)(blockLines).join("\n"));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = "";
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($971bc50063303b32$var$isUnicodeScalarValue(code)) ++position;
        else if ($971bc50063303b32$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, "Unterminated string.");
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $971bc50063303b32$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $876b79dde797933a$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}


function $8beb5260c793fc92$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $9541a54af6a37409$var$MAX_ARRAY_LENGTH = 10;
const $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH = 2;
function $9541a54af6a37409$export$9dec5d1b3b6a130d(value) {
    return $9541a54af6a37409$var$formatValue(value, []);
}
function $9541a54af6a37409$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $9541a54af6a37409$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $9541a54af6a37409$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($9541a54af6a37409$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $9541a54af6a37409$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $9541a54af6a37409$var$formatArray(value, seenValues);
    return $9541a54af6a37409$var$formatObject(value, seenValues);
}
function $9541a54af6a37409$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $9541a54af6a37409$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return "[" + $9541a54af6a37409$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $9541a54af6a37409$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $9541a54af6a37409$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($9541a54af6a37409$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($9541a54af6a37409$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $9541a54af6a37409$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}



const $c44107310810d751$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === "object" && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $9541a54af6a37409$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $1ff584847d3a412c$export$1d2df86270c81ecb {
    constructor(body, name = "GraphQL request", locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === "string" || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $9541a54af6a37409$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
    get [Symbol.toStringTag]() {
        return "Source";
    }
}
function $1ff584847d3a412c$export$75135ee9ed6e435b(source) {
    return (0, $c44107310810d751$export$ca03416d6c9e029e)(source, $1ff584847d3a412c$export$1d2df86270c81ecb);
}



function $0013c7ab45cf197d$export$98e6a39c04603d36(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $0013c7ab45cf197d$export$5303528d1070ff6f(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF);
    return value;
}
function $0013c7ab45cf197d$export$e14c466bd0916f7a(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF);
    return value;
}
function $0013c7ab45cf197d$export$28b8f402ccc88182(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF);
    return type;
}
class $0013c7ab45cf197d$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $1ff584847d3a412c$export$75135ee9ed6e435b)(source) ? source : new (0, $1ff584847d3a412c$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $971bc50063303b32$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case "schema":
                    return this.parseSchemaDefinition();
                case "scalar":
                    return this.parseScalarTypeDefinition();
                case "type":
                    return this.parseObjectTypeDefinition();
                case "interface":
                    return this.parseInterfaceTypeDefinition();
                case "union":
                    return this.parseUnionTypeDefinition();
                case "enum":
                    return this.parseEnumTypeDefinition();
                case "input":
                    return this.parseInputObjectTypeDefinition();
                case "directive":
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
            switch(keywordToken.value){
                case "query":
                case "mutation":
                case "subscription":
                    return this.parseOperationDefinition();
                case "fragment":
                    return this.parseFragmentDefinition();
                case "extend":
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $11b06753ce50693f$export$f58c50edb4aef9d4).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case "query":
                return (0, $11b06753ce50693f$export$f58c50edb4aef9d4).QUERY;
            case "mutation":
                return (0, $11b06753ce50693f$export$f58c50edb4aef9d4).MUTATION;
            case "subscription":
                return (0, $11b06753ce50693f$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, item, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword("fragment"); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).STRING:
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case "true":
                        return this.node(token, {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case "false":
                        return this.node(token, {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case "null":
                        return this.node(token, {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST,
            values: this.any((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L, item, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, item, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).STRING) || this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword("implements") ? this.delimitedMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$0013c7ab45cf197d$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $289bf729a82494c6$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $11b06753ce50693f$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$0013c7ab45cf197d$var$getTokenKindDesc(kind)}, found ${$0013c7ab45cf197d$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$0013c7ab45cf197d$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$0013c7ab45cf197d$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenDesc(token) {
    const value = token.value;
    return $0013c7ab45cf197d$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenKindDesc(kind) {
    return (0, $971bc50063303b32$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $670ab209adef6fbd$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($670ab209adef6fbd$var$escapedRegExp, $670ab209adef6fbd$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $670ab209adef6fbd$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $670ab209adef6fbd$var$escapedReplacer(str) {
    return $670ab209adef6fbd$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $670ab209adef6fbd$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];






const $78b48476e314521e$export$a89c95c098ac2a58 = Object.freeze({});
function $78b48476e314521e$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $11b06753ce50693f$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $b7b8db97a7d116fe$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $78b48476e314521e$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $11b06753ce50693f$export$8ee0fc9ee280b4ee)(node) || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $9541a54af6a37409$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $78b48476e314521e$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $11b06753ce50693f$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $78b48476e314521e$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $b7b8db97a7d116fe$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $78b48476e314521e$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $78b48476e314521e$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $78b48476e314521e$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $78b48476e314521e$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $e6602c9cee6df4a2$export$c2d084dc44961371(ast) {
    return (0, $78b48476e314521e$export$bf638b60ea8b89b7)(ast, $e6602c9cee6df4a2$var$printDocASTReducer);
}
const $e6602c9cee6df4a2$var$MAX_LINE_LENGTH = 80;
const $e6602c9cee6df4a2$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$e6602c9cee6df4a2$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $e6602c9cee6df4a2$var$join([
                node.operation,
                $e6602c9cee6df4a2$var$join([
                    node.name,
                    varDefs
                ]),
                $e6602c9cee6df4a2$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ": " + type + $e6602c9cee6df4a2$var$wrap(" = ", defaultValue) + $e6602c9cee6df4a2$var$wrap(" ", $e6602c9cee6df4a2$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$e6602c9cee6df4a2$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $e6602c9cee6df4a2$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")");
            if (argsLine.length > $e6602c9cee6df4a2$var$MAX_LINE_LENGTH) argsLine = prefix + $e6602c9cee6df4a2$var$wrap("(\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, "\n")), "\n)");
            return $e6602c9cee6df4a2$var$join([
                argsLine,
                $e6602c9cee6df4a2$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>"..." + name + $e6602c9cee6df4a2$var$wrap(" ", $e6602c9cee6df4a2$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$e6602c9cee6df4a2$var$join([
                "...",
                $e6602c9cee6df4a2$var$wrap("on ", typeCondition),
                $e6602c9cee6df4a2$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$e6602c9cee6df4a2$var$wrap("", $e6602c9cee6df4a2$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $a51b3e37e1f6e888$export$adb6ca997eeb1f45)(value) : (0, $670ab209adef6fbd$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>"[" + $e6602c9cee6df4a2$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields })=>"{" + $e6602c9cee6df4a2$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>"@" + name + $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "schema",
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "scalar",
                name,
                $e6602c9cee6df4a2$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "type",
                name,
                $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap("(\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, "\n")), "\n)") : $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")")) + ": " + type + $e6602c9cee6df4a2$var$wrap(" ", $e6602c9cee6df4a2$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                name + ": " + type,
                $e6602c9cee6df4a2$var$wrap("= ", defaultValue),
                $e6602c9cee6df4a2$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "interface",
                name,
                $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "union",
                name,
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$wrap("= ", $e6602c9cee6df4a2$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "enum",
                name,
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                name,
                $e6602c9cee6df4a2$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "input",
                name,
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + "directive @" + name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap("(\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, "\n")), "\n)") : $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $e6602c9cee6df4a2$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$e6602c9cee6df4a2$var$join([
                "extend schema",
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$e6602c9cee6df4a2$var$join([
                "extend scalar",
                name,
                $e6602c9cee6df4a2$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                "extend type",
                name,
                $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                "extend interface",
                name,
                $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$e6602c9cee6df4a2$var$join([
                "extend union",
                name,
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$wrap("= ", $e6602c9cee6df4a2$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$e6602c9cee6df4a2$var$join([
                "extend enum",
                name,
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                "extend input",
                name,
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $e6602c9cee6df4a2$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $e6602c9cee6df4a2$var$block(array) {
    return $e6602c9cee6df4a2$var$wrap("{\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $e6602c9cee6df4a2$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $e6602c9cee6df4a2$var$indent(str) {
    return $e6602c9cee6df4a2$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $e6602c9cee6df4a2$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}


/**
 * helpers
 */ const $1e225eee6088265b$var$extractOperationName = (document)=>{
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = operationDefinitions[0]?.name?.value;
    return operationName;
};
const $1e225eee6088265b$var$resolveRequestDocument = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $0013c7ab45cf197d$export$98e6a39c04603d36)(document);
            operationName = $1e225eee6088265b$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $1e225eee6088265b$var$extractOperationName(document);
    return {
        query: (0, $e6602c9cee6df4a2$export$c2d084dc44961371)(document),
        operationName: operationName
    };
};
$1e225eee6088265b$exports.resolveRequestDocument = $1e225eee6088265b$var$resolveRequestDocument;


var $2c0ba6522e307530$exports = {};
"use strict";
Object.defineProperty($2c0ba6522e307530$exports, "__esModule", {
    value: true
});
$2c0ba6522e307530$exports.ClientError = void 0;
class $2c0ba6522e307530$var$ClientError extends Error {
    constructor(response, request){
        const message = `${$2c0ba6522e307530$var$ClientError.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $2c0ba6522e307530$var$ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $2c0ba6522e307530$var$ClientError);
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}
$2c0ba6522e307530$exports.ClientError = $2c0ba6522e307530$var$ClientError;


Object.defineProperty($c1f86eaa549c814d$exports, "ClientError", {
    enumerable: true,
    get: function() {
        return $2c0ba6522e307530$exports.ClientError;
    }
});

const $c1f86eaa549c814d$var$cross_fetch_1 = $c1f86eaa549c814d$var$__importStar((parcelRequire("R5nvG"))), $c1f86eaa549c814d$var$CrossFetch = $c1f86eaa549c814d$var$cross_fetch_1;
/**
 * Convert the given headers configuration into a plain object.
 */ const $c1f86eaa549c814d$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $c1f86eaa549c814d$var$CrossFetch && $c1f86eaa549c814d$var$CrossFetch.Headers && headers instanceof $c1f86eaa549c814d$var$CrossFetch.Headers) oHeaders = (0, $d66afb9c573fca88$exports.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $c1f86eaa549c814d$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $c1f86eaa549c814d$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($c1f86eaa549c814d$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $c1f86eaa549c814d$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $c1f86eaa549c814d$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = {
            ...params.headers
        };
        let queryParams = ``;
        let body = undefined;
        if (method === `POST`) {
            body = $c1f86eaa549c814d$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $c1f86eaa549c814d$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? $b5d06f785ca72eac$exports.defaultJsonSerializer
        });
        const init = {
            method: method,
            headers: headers,
            body: body,
            ...fetchOptions
        };
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware({
                ...init,
                url: url,
                operationName: operationName,
                variables: variables
            }));
            const { url: urlNew, ...initNew } = result;
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $c1f86eaa549c814d$var$GraphQLClient {
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $e8402b3d0ff642e7$exports.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers: headers, fetch: fetch = $c1f86eaa549c814d$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $1e225eee6088265b$exports.resolveRequestDocument)(rawRequestOptions.query);
            return $c1f86eaa549c814d$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...$c1f86eaa549c814d$var$resolveHeaders($c1f86eaa549c814d$var$callOrIdentity(headers)),
                    ...$c1f86eaa549c814d$var$resolveHeaders(rawRequestOptions.requestHeaders)
                },
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $e8402b3d0ff642e7$exports.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers: headers, fetch: fetch = $c1f86eaa549c814d$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $1e225eee6088265b$exports.resolveRequestDocument)(requestOptions.document);
        return $c1f86eaa549c814d$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: {
                ...$c1f86eaa549c814d$var$resolveHeaders($c1f86eaa549c814d$var$callOrIdentity(headers)),
                ...$c1f86eaa549c814d$var$resolveHeaders(requestOptions.requestHeaders)
            },
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $e8402b3d0ff642e7$exports.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers: headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $1e225eee6088265b$exports.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        return $c1f86eaa549c814d$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...$c1f86eaa549c814d$var$resolveHeaders($c1f86eaa549c814d$var$callOrIdentity(headers)),
                ...$c1f86eaa549c814d$var$resolveHeaders(batchRequestOptions.requestHeaders)
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? $c1f86eaa549c814d$var$cross_fetch_1.default,
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
}
$c1f86eaa549c814d$exports.GraphQLClient = $c1f86eaa549c814d$var$GraphQLClient;
const $c1f86eaa549c814d$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    const fetcher = $c1f86eaa549c814d$var$createHttpMethodFetcher((0, $d66afb9c573fca88$exports.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await $c1f86eaa549c814d$var$getResult(response, fetchOptions.jsonSerializer ?? $b5d06f785ca72eac$exports.defaultJsonSerializer);
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status
        };
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new $2c0ba6522e307530$exports.ClientError(// @ts-expect-error TODO
        {
            ...errorResult,
            status: response.status,
            headers: response.headers
        }, {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $c1f86eaa549c814d$var$rawRequest = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $e8402b3d0ff642e7$exports.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $c1f86eaa549c814d$var$GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions
    });
};
$c1f86eaa549c814d$exports.rawRequest = $c1f86eaa549c814d$var$rawRequest;
// prettier-ignore
// eslint-disable-next-line
async function $c1f86eaa549c814d$var$request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $e8402b3d0ff642e7$exports.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $c1f86eaa549c814d$var$GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions
    });
}
$c1f86eaa549c814d$exports.request = $c1f86eaa549c814d$var$request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $c1f86eaa549c814d$var$batchRequests = async (...args)=>{
    const params = $c1f86eaa549c814d$var$parseBatchRequestsArgsExtended(args);
    const client = new $c1f86eaa549c814d$var$GraphQLClient(params.url);
    return client.batchRequests(params);
};
$c1f86eaa549c814d$exports.batchRequests = $c1f86eaa549c814d$var$batchRequests;
const $c1f86eaa549c814d$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $c1f86eaa549c814d$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer ?? $b5d06f785ca72eac$exports.defaultJsonSerializer;
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $c1f86eaa549c814d$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $c1f86eaa549c814d$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 * ```
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */ const $c1f86eaa549c814d$var$gql = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
$c1f86eaa549c814d$exports.gql = $c1f86eaa549c814d$var$gql;
var $3417ea4ea4c7088a$exports = {};
"use strict";
Object.defineProperty($3417ea4ea4c7088a$exports, "__esModule", {
    value: true
});
$3417ea4ea4c7088a$exports.GraphQLWebSocketClient = void 0;


// import type WebSocket from 'ws'
const $3417ea4ea4c7088a$var$CONNECTION_INIT = `connection_init`;
const $3417ea4ea4c7088a$var$CONNECTION_ACK = `connection_ack`;
const $3417ea4ea4c7088a$var$PING = `ping`;
const $3417ea4ea4c7088a$var$PONG = `pong`;
const $3417ea4ea4c7088a$var$SUBSCRIBE = `subscribe`;
const $3417ea4ea4c7088a$var$NEXT = `next`;
const $3417ea4ea4c7088a$var$ERROR = `error`;
const $3417ea4ea4c7088a$var$COMPLETE = `complete`;
class $3417ea4ea4c7088a$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $3417ea4ea4c7088a$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class $3417ea4ea4c7088a$var$GraphQLWebSocketClient {
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($3417ea4ea4c7088a$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $3417ea4ea4c7088a$var$parseMessage(e.data);
                switch(message.type){
                    case $3417ea4ea4c7088a$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $3417ea4ea4c7088a$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($3417ea4ea4c7088a$var$Pong(r).text));
                        else socket.send($3417ea4ea4c7088a$var$Pong(null).text);
                        return;
                    case $3417ea4ea4c7088a$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $3417ea4ea4c7088a$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new $2c0ba6522e307530$exports.ClientError({
                            ...message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $3417ea4ea4c7088a$var$ERROR:
                        subscriber.error && subscriber.error(new $2c0ba6522e307530$exports.ClientError({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $3417ea4ea4c7088a$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($3417ea4ea4c7088a$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($3417ea4ea4c7088a$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $1e225eee6088265b$exports.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($3417ea4ea4c7088a$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
$3417ea4ea4c7088a$var$GraphQLWebSocketClient.PROTOCOL = `graphql-transport-ws`;
$3417ea4ea4c7088a$exports.GraphQLWebSocketClient = $3417ea4ea4c7088a$var$GraphQLWebSocketClient;
// Helper functions
function $3417ea4ea4c7088a$var$parseMessage(data, f = (a)=>a) {
    const m = $3417ea4ea4c7088a$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $3417ea4ea4c7088a$var$ConnectionInit(payload) {
    return new $3417ea4ea4c7088a$var$GraphQLWebSocketMessage($3417ea4ea4c7088a$var$CONNECTION_INIT, payload);
}
function $3417ea4ea4c7088a$var$Ping(payload) {
    return new $3417ea4ea4c7088a$var$GraphQLWebSocketMessage($3417ea4ea4c7088a$var$PING, payload, undefined);
}
function $3417ea4ea4c7088a$var$Pong(payload) {
    return new $3417ea4ea4c7088a$var$GraphQLWebSocketMessage($3417ea4ea4c7088a$var$PONG, payload, undefined);
}
function $3417ea4ea4c7088a$var$Subscribe(id, payload) {
    return new $3417ea4ea4c7088a$var$GraphQLWebSocketMessage($3417ea4ea4c7088a$var$SUBSCRIBE, payload, id);
}
function $3417ea4ea4c7088a$var$Complete(id) {
    return new $3417ea4ea4c7088a$var$GraphQLWebSocketMessage($3417ea4ea4c7088a$var$COMPLETE, undefined, id);
}


Object.defineProperty($c1f86eaa549c814d$exports, "GraphQLWebSocketClient", {
    enumerable: true,
    get: function() {
        return $3417ea4ea4c7088a$exports.GraphQLWebSocketClient;
    }
});

Object.defineProperty($c1f86eaa549c814d$exports, "resolveRequestDocument", {
    enumerable: true,
    get: function() {
        return $1e225eee6088265b$exports.resolveRequestDocument;
    }
});
$c1f86eaa549c814d$exports.default = $c1f86eaa549c814d$var$request;


class $d141334e669a2024$export$8555c4bd7f7d43ce {
    constructor(subgraphUrl){
        this.subgraphUrl = subgraphUrl;
    }
    async request(document, variables) {
        return await (0, $c1f86eaa549c814d$exports.request)({
            url: this.subgraphUrl,
            document: document,
            variables: variables ? $d141334e669a2024$var$cleanVariables(variables) : undefined
        });
    }
}
// Inspired by: https://stackoverflow.com/a/38340730
// Remove properties with null, undefined, empty string values.
function $d141334e669a2024$var$cleanVariables(variables) {
    return Object.fromEntries(Object.entries(variables).filter(([, value])=>value !== "" && value !== null && value !== undefined).map(([key, value])=>[
            key,
            value === Object(value) && !Array.isArray(value) ? $d141334e669a2024$var$cleanVariables(value) : value
        ]));
}


const $d3c69d8e8e1e69f5$export$6cf9065a4a10af61 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "getAccountTokenSnapshots"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "AccountTokenSnapshot_filter"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "AccountTokenSnapshot_orderBy"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "OrderDirection"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "alias": {
                            "kind": "Name",
                            "value": "result"
                        },
                        "name": {
                            "kind": "Name",
                            "value": "accountTokenSnapshots"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfActiveStreams"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "activeOutgoingStreamCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "activeIncomingStreamCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfClosedStreams"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "inactiveOutgoingStreamCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "inactiveIncomingStreamCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalSubscriptionsWithUnits"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalApprovedSubscriptions"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNetFlowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalInflowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalOutflowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountStreamedUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountTransferredUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "account"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "createdAtTimestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "createdAtBlockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "symbol"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isListed"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isNativeAssetSuperToken"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "underlyingAddress"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


const $758aac3ae880615e$export$b02e6c10e95202d8 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "getAllEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Event_filter"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Event_orderBy"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "OrderDirection"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "events"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "FlowUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "type"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sender"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "receiver"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "flowRate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "flowOperator"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "deposit"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "stream"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "FlowOperatorUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sender"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "permissions"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "flowRateAllowance"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "IndexCreatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "index"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "IndexDistributionClaimedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "index"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "IndexUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "totalUnitsPending"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "totalUnitsApproved"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "oldIndexValue"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "newIndexValue"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "index"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "IndexSubscribedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "index"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "IndexUnitsUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "units"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "oldUnits"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "index"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "IndexUnsubscribedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "index"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SubscriptionApprovedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscription"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SubscriptionDistributionClaimedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscription"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SubscriptionRevokedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscription"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SubscriptionUnitsUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "units"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscription"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "oldUnits"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "TransferEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "value"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "to"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "from"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "TokenUpgradedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "account"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "TokenDowngradedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "account"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "AgreementClassRegisteredEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "code"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "agreementType"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "AgreementClassUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "code"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "agreementType"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "AppRegisteredEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "app"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "GovernanceReplacedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "oldGovernance"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "newGovernance"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "JailEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "reason"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "app"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SuperTokenFactoryUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "newFactory"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SuperTokenLogicUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "code"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "RoleAdminChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "role"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "previousAdminRole"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "newAdminRole"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "RoleGrantedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sender"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "role"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "account"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "RoleRevokedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sender"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "role"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "account"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SetEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "hashedName"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "target"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "resolverEntry"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CFAv1LiquidationPeriodChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "superToken"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "host"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "governanceAddress"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "liquidationPeriod"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isKeySet"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "ConfigChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "value"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "superToken"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "key"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isKeySet"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "host"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "governanceAddress"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "RewardAddressChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "superToken"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rewardAddress"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isKeySet"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "host"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "governanceAddress"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "PPPConfigurationChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "host"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "governanceAddress"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "superToken"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isKeySet"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "liquidationPeriod"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "patricianPeriod"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "TrustedForwarderChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isKeySet"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "host"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "governanceAddress"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "forwarder"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "enabled"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "superToken"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SuperTokenMinimumDepositChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isKeySet"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "host"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "governanceAddress"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "minimumDeposit"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "superToken"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "AgreementLiquidatedByEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rewardAmount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "penaltyAccount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "liquidatorAccount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bondAccount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bailoutAmount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "agreementId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "agreementClass"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "AgreementLiquidatedV2Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "liquidatorAccount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "agreementClass"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "agreementId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "targetAccount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rewardAmountReceiver"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rewardAmount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "targetAccountBalanceDelta"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "version"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "liquidationType"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rewardAccount"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "BurnedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "operatorData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "operator"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "from"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "data"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "MintedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "operatorData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "operator"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "data"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "to"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SentEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "to"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "operatorData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "operator"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "data"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CustomSuperTokenCreatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SuperTokenCreatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SuperTokenLogicCreatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "tokenLogic"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "NewPICEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "pic"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bond"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "exitRate"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "ExitRateChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "exitRate"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "BondIncreasedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "additionalBond"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "blockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "transactionHash"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "timestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


const $717c9bd0837933e1$export$3c87596342fc1c0b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "getIndexSubscriptions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "IndexSubscription_filter"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "IndexSubscription_orderBy"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "OrderDirection"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "alias": {
                            "kind": "Name",
                            "value": "result"
                        },
                        "name": {
                            "kind": "Name",
                            "value": "indexSubscriptions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscriber"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "approved"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "units"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountReceivedUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexValueUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "index"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexValue"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "createdAtTimestamp"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "createdAtBlockNumber"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "name"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "symbol"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "isListed"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "isNativeAssetSuperToken"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "underlyingAddress"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


const $4c7bbe33a5595903$export$fbf36fa4332ed937 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "getIndexes"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Index_filter"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Index_orderBy"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "OrderDirection"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "alias": {
                            "kind": "Name",
                            "value": "result"
                        },
                        "name": {
                            "kind": "Name",
                            "value": "indexes"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexValue"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalSubscriptionsWithUnits"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalUnitsPending"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalUnitsApproved"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalUnits"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountDistributedUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "createdAtTimestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "createdAtBlockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "symbol"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isListed"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isNativeAssetSuperToken"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "underlyingAddress"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "publisher"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


const $57f44661d9d34a70$export$6df34d6145ea81d4 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "getStreams"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Stream_filter"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Stream_orderBy"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "OrderDirection"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "alias": {
                            "kind": "Name",
                            "value": "result"
                        },
                        "name": {
                            "kind": "Name",
                            "value": "streams"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currentFlowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "streamedUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "createdAtTimestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "createdAtBlockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "symbol"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isListed"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isNativeAssetSuperToken"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "underlyingAddress"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sender"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "receiver"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flowUpdatedEvents"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "orderBy"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "timestamp"
                                            }
                                        },
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "orderDirection"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "asc"
                                            }
                                        }
                                    ],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sender"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "receiver"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "flowRate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "totalSenderFlowRate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "totalReceiverFlowRate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "oldFlowRate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "type"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "totalAmountStreamedUntilTimestamp"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


const $dccc91d4f9e5ca1b$export$4bb56c143417adcc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "getTokens"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Token_filter"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Token_orderBy"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "OrderDirection"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "alias": {
                            "kind": "Name",
                            "value": "result"
                        },
                        "name": {
                            "kind": "Name",
                            "value": "tokens"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "symbol"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isListed"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isNativeAssetSuperToken"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "underlyingAddress"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};



class $39575766490db638$export$2e2bcd8739ae039 {
    constructor(options){
        this.listAllSuperTokens = async (filter, paging = (0, $e9fa3bd1f0f40070$export$51fe14f826d94a33)(), ordering = {
            orderBy: "createdAtBlockNumber",
            orderDirection: "desc"
        })=>{
            (0, $73255e22f3dfe257$export$9674531571d48800)(filter);
            const response = await this.subgraphClient.request((0, $dccc91d4f9e5ca1b$export$4bb56c143417adcc), {
                where: {
                    isListed: filter.isListed,
                    isSuperToken: true,
                    id_gt: paging.lastId
                },
                orderBy: ordering === null || ordering === void 0 ? void 0 : ordering.orderBy,
                orderDirection: ordering === null || ordering === void 0 ? void 0 : ordering.orderDirection,
                first: (0, $e9fa3bd1f0f40070$export$5ba852834ab142d0)(paging),
                skip: paging.skip
            });
            const mappedResult = response.result.map((x)=>(0, $f456740ea8874244$export$f62628bb56170863)({
                    ...x,
                    createdAtTimestamp: Number(x.createdAtTimestamp),
                    createdAtBlockNumber: Number(x.createdAtBlockNumber)
                }));
            return (0, $e9fa3bd1f0f40070$export$ed1321ad5ca95972)(mappedResult, paging);
        };
        this.listIndexes = async (filter, paging = (0, $e9fa3bd1f0f40070$export$51fe14f826d94a33)(), ordering = {
            orderBy: "createdAtBlockNumber",
            orderDirection: "desc"
        })=>{
            var _a, _b;
            (0, $73255e22f3dfe257$export$8d59a7504d31605a)(filter);
            const response = await this.subgraphClient.request((0, $4c7bbe33a5595903$export$fbf36fa4332ed937), {
                where: {
                    indexId: filter.indexId,
                    publisher: (_a = filter.publisher) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                    token: (_b = filter.token) === null || _b === void 0 ? void 0 : _b.toLowerCase(),
                    id_gt: paging.lastId
                },
                orderBy: ordering === null || ordering === void 0 ? void 0 : ordering.orderBy,
                orderDirection: ordering === null || ordering === void 0 ? void 0 : ordering.orderDirection,
                first: (0, $e9fa3bd1f0f40070$export$5ba852834ab142d0)(paging),
                skip: paging.skip
            });
            const mappedResult = response.result.map((x)=>(0, $f456740ea8874244$export$f62628bb56170863)({
                    ...x,
                    publisher: x.publisher.id,
                    createdAtTimestamp: Number(x.createdAtTimestamp),
                    createdAtBlockNumber: Number(x.createdAtBlockNumber),
                    updatedAtTimestamp: Number(x.updatedAtTimestamp),
                    updatedAtBlockNumber: Number(x.updatedAtBlockNumber),
                    token: {
                        ...x.token,
                        createdAtTimestamp: Number(x.token.createdAtTimestamp),
                        createdAtBlockNumber: Number(x.token.createdAtBlockNumber)
                    }
                }));
            return (0, $e9fa3bd1f0f40070$export$ed1321ad5ca95972)(mappedResult, paging);
        };
        this.listIndexSubscriptions = async (filter, paging = (0, $e9fa3bd1f0f40070$export$51fe14f826d94a33)(), ordering = {
            orderBy: "createdAtBlockNumber",
            orderDirection: "desc"
        })=>{
            var _a;
            (0, $73255e22f3dfe257$export$caf71e03dd6766e2)(filter);
            const response = await this.subgraphClient.request((0, $717c9bd0837933e1$export$3c87596342fc1c0b), {
                where: {
                    subscriber: (_a = filter.subscriber) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                    approved: filter.approved,
                    id_gt: paging.lastId
                },
                orderBy: ordering === null || ordering === void 0 ? void 0 : ordering.orderBy,
                orderDirection: ordering === null || ordering === void 0 ? void 0 : ordering.orderDirection,
                first: (0, $e9fa3bd1f0f40070$export$5ba852834ab142d0)(paging),
                skip: paging.skip
            });
            const mappedResult = response.result.map((x)=>(0, $f456740ea8874244$export$f62628bb56170863)({
                    ...x,
                    subscriber: x.subscriber.id,
                    createdAtTimestamp: Number(x.createdAtTimestamp),
                    createdAtBlockNumber: Number(x.createdAtBlockNumber),
                    updatedAtTimestamp: Number(x.updatedAtTimestamp),
                    updatedAtBlockNumber: Number(x.updatedAtBlockNumber),
                    index: {
                        ...x.index,
                        token: {
                            ...x.index.token,
                            createdAtTimestamp: Number(x.index.token.createdAtTimestamp),
                            createdAtBlockNumber: Number(x.index.token.createdAtBlockNumber)
                        }
                    }
                }));
            return (0, $e9fa3bd1f0f40070$export$ed1321ad5ca95972)(mappedResult, paging);
        };
        this.listStreams = async (filter, paging = (0, $e9fa3bd1f0f40070$export$51fe14f826d94a33)(), ordering = {
            orderBy: "createdAtBlockNumber",
            orderDirection: "desc"
        })=>{
            var _a, _b, _c;
            (0, $73255e22f3dfe257$export$c139794b81d01b07)(filter);
            const response = await this.subgraphClient.request((0, $57f44661d9d34a70$export$6df34d6145ea81d4), {
                where: {
                    sender: (_a = filter.sender) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                    receiver: (_b = filter.receiver) === null || _b === void 0 ? void 0 : _b.toLowerCase(),
                    token: (_c = filter.token) === null || _c === void 0 ? void 0 : _c.toLowerCase(),
                    id_gt: paging.lastId
                },
                orderBy: ordering === null || ordering === void 0 ? void 0 : ordering.orderBy,
                orderDirection: ordering === null || ordering === void 0 ? void 0 : ordering.orderDirection,
                first: (0, $e9fa3bd1f0f40070$export$5ba852834ab142d0)(paging),
                skip: paging.skip
            });
            const mappedResult = response.result.map((x)=>(0, $f456740ea8874244$export$f62628bb56170863)({
                    ...x,
                    sender: x.sender.id,
                    receiver: x.receiver.id,
                    createdAtTimestamp: Number(x.createdAtTimestamp),
                    createdAtBlockNumber: Number(x.createdAtBlockNumber),
                    updatedAtTimestamp: Number(x.updatedAtTimestamp),
                    updatedAtBlockNumber: Number(x.updatedAtBlockNumber),
                    token: {
                        ...x.token,
                        createdAtTimestamp: Number(x.token.createdAtTimestamp),
                        createdAtBlockNumber: Number(x.token.createdAtBlockNumber)
                    },
                    flowUpdatedEvents: x.flowUpdatedEvents.map((y)=>({
                            ...y,
                            blockNumber: Number(y.blockNumber),
                            timestamp: Number(y.timestamp)
                        }))
                }));
            return (0, $e9fa3bd1f0f40070$export$ed1321ad5ca95972)(mappedResult, paging);
        };
        this.listUserInteractedSuperTokens = async (filter, paging = (0, $e9fa3bd1f0f40070$export$51fe14f826d94a33)(), ordering = {
            orderBy: "updatedAtBlockNumber",
            orderDirection: "desc"
        })=>{
            var _a, _b;
            (0, $73255e22f3dfe257$export$94a00fa1a6802143)(filter);
            const response = await this.subgraphClient.request((0, $d3c69d8e8e1e69f5$export$6cf9065a4a10af61), {
                where: {
                    account: (_a = filter.account) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                    token: (_b = filter.token) === null || _b === void 0 ? void 0 : _b.toLowerCase(),
                    id_gt: paging.lastId
                },
                orderBy: ordering === null || ordering === void 0 ? void 0 : ordering.orderBy,
                orderDirection: ordering === null || ordering === void 0 ? void 0 : ordering.orderDirection,
                first: (0, $e9fa3bd1f0f40070$export$5ba852834ab142d0)(paging),
                skip: paging.skip
            });
            const mappedResult = response.result.map((x)=>(0, $f456740ea8874244$export$f62628bb56170863)({
                    ...x,
                    account: x.account.id,
                    updatedAtTimestamp: Number(x.updatedAtTimestamp),
                    updatedAtBlockNumber: Number(x.updatedAtBlockNumber),
                    token: {
                        ...x.token,
                        createdAtTimestamp: Number(x.token.createdAtTimestamp),
                        createdAtBlockNumber: Number(x.token.createdAtBlockNumber)
                    }
                }));
            return (0, $e9fa3bd1f0f40070$export$ed1321ad5ca95972)(mappedResult, paging);
        };
        this.listEvents = async (filter, paging = (0, $e9fa3bd1f0f40070$export$51fe14f826d94a33)(), ordering = {
            orderBy: "blockNumber",
            orderDirection: "desc"
        })=>{
            var _a, _b;
            (0, $73255e22f3dfe257$export$8026d379bc83f3cc)(filter);
            const response = await this.subgraphClient.request((0, $758aac3ae880615e$export$b02e6c10e95202d8), {
                orderBy: ordering === null || ordering === void 0 ? void 0 : ordering.orderBy,
                orderDirection: ordering === null || ordering === void 0 ? void 0 : ordering.orderDirection,
                where: {
                    addresses_contains: filter.account ? [
                        (_a = filter.account) === null || _a === void 0 ? void 0 : _a.toLowerCase()
                    ] : undefined,
                    timestamp_gt: (_b = filter.timestamp_gt) === null || _b === void 0 ? void 0 : _b.toString(),
                    id_gt: paging.lastId
                },
                first: (0, $e9fa3bd1f0f40070$export$5ba852834ab142d0)(paging),
                skip: paging.skip
            });
            return (0, $e9fa3bd1f0f40070$export$ed1321ad5ca95972)((0, $05c2b66738aae405$export$7af0467e7a486478)(response.events), paging);
        };
        this.options = options;
        this.subgraphClient = new (0, $d141334e669a2024$export$8555c4bd7f7d43ce)(this.options.customSubgraphQueriesEndpoint);
    }
    // TODO(KK): error callback?
    // TODO(KK): retries?
    // TODO(KK): tests
    on(callback, ms, account, timeout) {
        if (ms < 1000) throw Error("Let's not go crazy with the queries...");
        // Account for the fact that Subgraph has lag and will insert events with the timestamp of the event from blockchain.
        const clockSkew = 25000;
        // Convert millisecond-based time to second-based time (which Subgraph uses).
        let eventQueryTimestamp = Math.floor((new Date().getTime() - clockSkew) / 1000);
        let isUnsubscribed = false;
        const unsubscribe = ()=>{
            isUnsubscribed = true;
        };
        const pollingStep = async ()=>{
            if (isUnsubscribed) return;
            const allEvents = await $39575766490db638$export$6d656913aad83206((paging)=>this.listEvents({
                    account: account,
                    timestamp_gt: eventQueryTimestamp
                }, paging, {
                    orderBy: "timestamp",
                    orderDirection: "asc"
                }));
            // Filter next events by last timestamp of an event.
            // NOTE: Make sure to order events by timestamp in ascending order.
            const lastEvent = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).last(allEvents);
            if (lastEvent) {
                callback(allEvents, unsubscribe);
                // Next event polling is done for events that have a timestamp later than the current latest event.
                eventQueryTimestamp = lastEvent.timestamp;
            }
            // This solution sets the interval based on last query returning, opposed to not taking request-response cycles into account at all.
            // This solution is more friendly to the Subgraph & more effective resource-wise with slow internet.
            return setTimeout(()=>{
                // Fire and forget
                pollingStep();
            }, ms);
        };
        if (timeout) setTimeout(()=>{
            unsubscribe();
        }, timeout);
        // Fire and forget
        pollingStep();
        return unsubscribe;
    }
}
const $39575766490db638$export$6d656913aad83206 = async (pagedQuery)=>{
    const listAllRecursively = async (paging)=>{
        const pagedResult = await pagedQuery(paging);
        if (!pagedResult.nextPaging) return pagedResult.data;
        const nextResults = await listAllRecursively(pagedResult.nextPaging);
        return pagedResult.data.concat(nextResults);
    };
    return listAllRecursively((0, $e9fa3bd1f0f40070$export$e5a659d88c9ba001)({
        take: 999
    }));
};












class $aca87b7974a1320f$export$2e2bcd8739ae039 {
    constructor(address){
        /** ### ERC721 Token Contract Read Functions ### */ /**
         * Returns the ERC721 balanceOf the `owner`.
         * @param owner the owner you would like to query
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {Promise<string>} the token balance of `owner`
         */ this.balanceOf = async (params)=>{
            try {
                const normalizedOwner = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.owner);
                const balanceOf = await this.contract.connect(params.providerOrSigner).balanceOf(normalizedOwner);
                return balanceOf.toString();
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "NFT_READ",
                    message: "There was an error getting balanceOf",
                    cause: err
                });
            }
        };
        /**
         * Returns the owner of the NFT specified by `tokenId`.
         * NOTE: Throws if `tokenId` is not a valid NFT.
         * @param tokenId the token id
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {string} the address of the owner of the NFT
         */ this.ownerOf = async (params)=>{
            try {
                const ownerOf = await this.contract.connect(params.providerOrSigner).ownerOf(params.tokenId);
                return ownerOf.toString();
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "NFT_READ",
                    message: "There was an error getting ownerOf",
                    cause: err
                });
            }
        };
        /**
         * Returns the approved address for a single NFT, or the zero address if there is none.
         * @param tokenId the token id
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {string} the approved address for this NFT, or the zero address if there is none
         */ this.getApproved = async (params)=>{
            try {
                const approved = await this.contract.connect(params.providerOrSigner).getApproved(params.tokenId);
                return approved;
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "NFT_READ",
                    message: "There was an error getting getApproved",
                    cause: err
                });
            }
        };
        /**
         * Returns whether `operator` is approved for all of `owner`'s NFTs.
         * @param owner the owner of NFTs
         * @param operator an operator for the owner's NFTs
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {bool}
         */ this.isApprovedForAll = async (params)=>{
            try {
                const normalizedOwner = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.owner);
                const normalizedOperator = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.operator);
                const approved = await this.contract.connect(params.providerOrSigner).isApprovedForAll(normalizedOwner, normalizedOperator);
                return approved;
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "NFT_READ",
                    message: "There was an error getting isApprovedForAll",
                    cause: err
                });
            }
        };
        /**
         * Returns the token name
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {string} the token name
         */ this.name = async ({ providerOrSigner: providerOrSigner })=>{
            try {
                const name = await this.contract.connect(providerOrSigner).name();
                return name;
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "NFT_READ",
                    message: "There was an error getting name",
                    cause: err
                });
            }
        };
        /**
         * Returns the token symbol
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {string} the token symbol
         */ this.symbol = async ({ providerOrSigner: providerOrSigner })=>{
            try {
                const symbol = await this.contract.connect(providerOrSigner).symbol();
                return symbol;
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "NFT_READ",
                    message: "There was an error getting symbol",
                    cause: err
                });
            }
        };
        /**
         * Returns the token URI
         * @param tokenId the token id
         * @returns {string}
         */ this.tokenURI = async (params)=>{
            try {
                const uri = await this.contract.connect(params.providerOrSigner).tokenURI(params.tokenId);
                return uri;
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "NFT_READ",
                    message: "There was an error getting tokenURI",
                    cause: err
                });
            }
        };
        /** ### ERC721 Token Contract Write Functions ### */ /**
         * Approve `approved` to spend `tokenId` NFT.
         * @param approved The receiver approved.
         * @param tokenId The tokenId approved.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed.
         */ this.approve = (params)=>{
            const normalizedReceiver = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.approved);
            const txn = this.contract.populateTransaction.approve(normalizedReceiver, params.tokenId, params.overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "UNSUPPORTED");
        };
        /**
         * Approve `operator` to spend all NFTs of the signer (`msg.sender`).
         * @param operator The operator approved.
         * @param approved The approved status.
         * @returns {Operation} An instance of Operation which can be executed.
         */ this.setApprovalForAll = (params)=>{
            const normalizedOperator = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.operator);
            const txn = this.contract.populateTransaction.setApprovalForAll(normalizedOperator, params.approved, params.overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "UNSUPPORTED");
        };
        /**
         * Transfer `tokenId` from `from` to `to` .
         * @param from The owner of the NFT.
         * @param to The receiver of the NFT.
         * @param tokenId The token to be transferred.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed.
         */ this.transferFrom = (params)=>{
            const normalizedFrom = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.from);
            const normalizedTo = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.to);
            const txn = this.contract.populateTransaction.transferFrom(normalizedFrom, normalizedTo, params.tokenId, params.overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "UNSUPPORTED");
        };
        /**
         * Safe transfer `tokenId` from `from` to `to` (see IERC721.sol OZ Natspec for more details).
         * Data is empty in this version of safeTransferFrom.
         * @param from The owner of the NFT.
         * @param to The receiver of the NFT.
         * @param tokenId The token to be transferred.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed.
         */ this.safeTransferFrom = (params)=>{
            const normalizedFrom = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.from);
            const normalizedTo = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.to);
            const txn = this.contract.populateTransaction["safeTransferFrom(address,address,uint256)"](normalizedFrom, normalizedTo, params.tokenId, params.overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "UNSUPPORTED");
        };
        /**
         * Safe transfer `tokenId` from `from` to `to` with `data`.
         * @param from The owner of the NFT.
         * @param to The receiver of the NFT.
         * @param tokenId The token to be transferred.
         * @param data The data to be sent with the safe transfer check.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed.
         */ this.safeTransferFromWithData = (params)=>{
            const normalizedFrom = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.from);
            const normalizedTo = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.to);
            const txn = this.contract.populateTransaction["safeTransferFrom(address,address,uint256,bytes)"](normalizedFrom, normalizedTo, params.tokenId, params.data, params.overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "UNSUPPORTED");
        };
        /**
         * Sanitizes NFTFlowData, converting number to Date.
         * @param params NFTFlowData
         * @returns {NFTFlowData} sanitized NFTFlowData
         */ this._sanitizeNFTFlowData = (params)=>{
            return {
                flowSender: params.flowSender,
                flowStartDate: (0, $f456740ea8874244$export$f07c840af7d4309b)(params.flowStartDate),
                flowReceiver: params.flowReceiver
            };
        };
        this.address = address;
        this.contract = new (0, $6c57cc56acea9c6c$exports).Contract(address, (0, $f967e1e623e83b57$export$798794e52e66265a).abi);
    }
}





class $5d7fab4d96297da1$export$2e2bcd8739ae039 extends (0, $aca87b7974a1320f$export$2e2bcd8739ae039) {
    constructor(address){
        super(address);
        /** ### ConstantInflowNFT Contract Read Functions ### */ /**
         * Returns the computed `tokenId` of a flow NFT given a sender and receiver.
         * @param sender the flow sender
         * @param receiver the flow receiver
         * @returns
         */ this.getTokenId = async ({ superToken: superToken, sender: sender, receiver: receiver, providerOrSigner: providerOrSigner })=>{
            const normalizedSuperToken = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(superToken);
            const normalizedSender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(sender);
            const normalizedReceiver = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(receiver);
            try {
                const tokenId = await this.contract.connect(providerOrSigner).getTokenId(normalizedSuperToken, normalizedSender, normalizedReceiver);
                return tokenId.toString();
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "NFT_READ",
                    message: "There was an error getting token id",
                    cause: err
                });
            }
        };
        /**
         * Returns the NFT flow data of the NFT with `tokenId`.
         * @param tokenId the token id
         * @returns {NFTFlowData} the NFT flow data
         */ this.flowDataByTokenId = async ({ tokenId: tokenId, providerOrSigner: providerOrSigner })=>{
            try {
                const flowData = await this.contract.connect(providerOrSigner).flowDataByTokenId(tokenId);
                return this._sanitizeNFTFlowData(flowData);
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "NFT_READ",
                    message: "There was an error getting flow data by token id",
                    cause: err
                });
            }
        };
        this.contract = new (0, $6c57cc56acea9c6c$exports).Contract(address, (0, $04ca30cd1ece7c89$export$7209e4ca0b1d24ba).abi);
    }
}



class $49b3a29b1174dda2$export$2e2bcd8739ae039 extends (0, $5d7fab4d96297da1$export$2e2bcd8739ae039) {
    constructor(address){
        super(address);
        this.contract = new (0, $6c57cc56acea9c6c$exports).Contract(address, (0, $7e5a48aef91ca665$export$eb7e5cf7b5e80c85).abi);
    }
}





class $ee728930ca27787d$export$2e2bcd8739ae039 extends (0, $5d7fab4d96297da1$export$2e2bcd8739ae039) {
    constructor(address){
        super(address);
        this.contract = new (0, $6c57cc56acea9c6c$exports).Contract(address, (0, $d31c46b1a94ce036$export$5ca92c4e583d35e7).abi);
    }
}











const $c8f208e9593adf37$export$ff892c7aa164b666 = (options)=>{
    if (!options.chainId) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
        type: "FRAMEWORK_INITIALIZATION",
        message: "You must input chainId."
    });
    if (!options.provider) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
        type: "FRAMEWORK_INITIALIZATION",
        message: "You must pass in a provider, an injected web3.js or ethers.js instance when initializing the framework."
    });
    // if the user inputs a chainId that isn't part of the resolver
    // that is, an unsupported network/chain
    if (options.chainId != null && !(0, $de1415f96fbf6fc0$export$11b439decfc92c38).includes(options.chainId)) {
        if ((0, $f456740ea8874244$export$c8733ae29fb53302)(options.resolverAddress)) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
            type: "FRAMEWORK_INITIALIZATION",
            message: "You must input your own resolver address if you use an unsupported network."
        });
    }
};
const $c8f208e9593adf37$export$c31f1ace548c01ea = (options)=>{
    const resolverData = options.chainId ? (0, $de1415f96fbf6fc0$export$cdfdd3b5e96b5891).get(options.chainId) : null;
    if (resolverData) return resolverData.subgraphAPIEndpoint;
    return ""; // return empty string
};
const $c8f208e9593adf37$export$806e39a4e7106096 = (options)=>{
    var _a;
    return (options.chainId ? (_a = (0, $de1415f96fbf6fc0$export$cdfdd3b5e96b5891).get(options.chainId)) === null || _a === void 0 ? void 0 : _a.networkName : undefined) || "custom";
};




var $7dd3270ed4bc5e47$var$_a;
/**
 * SuperToken Helper Class
 * @description A helper class to create `SuperToken` objects which can interact with the `SuperToken` contract as well as the CFAV1 and IDAV1 contracts of the desired `SuperToken`.
 * @see https://www.notion.so/superfluidhq/Classification-of-Super-Tokens-5beace780b5c4d09a5752a3677da3dc0 for further details on naming classification and underlying implementation.
 */ class $7dd3270ed4bc5e47$var$SuperToken extends (0, $3de228b7e6630b4a$export$2e2bcd8739ae039) {
    constructor(options, settings){
        // initialize ERC20 token functions here
        super(settings.address);
        /** ### ERC777 Token Write Functions ### */ /**
         * Send `amount` tokens to `recipient` from transaction signer.
         * @param recipient the recipient of the tokens
         * @param amount the amount of tokens to send
         * @param userData Extra user data provided.
         */ this.send = (params)=>{
            const recipient = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.recipient);
            const txn = this.contract.populateTransaction.send(recipient, params.amount, params.userData || "0x", params.overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "ERC777_SEND");
        };
        /** ### SuperToken Contract Read Functions ### */ /**
         * Returns the real time balance of `address`.
         * @param account the target address
         * @param timestamp the timestamp you'd like to see the data
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {Promise<IWeb3RealTimeBalanceOf>} real time balance of data
         */ this.realtimeBalanceOf = async ({ providerOrSigner: providerOrSigner, account: account, timestamp: timestamp = (0, $f456740ea8874244$export$d9ae0e7e07ff24d7)() })=>{
            const normalizedAccount = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(account);
            try {
                const realtimeBalanceOf = await this.contract.connect(providerOrSigner).realtimeBalanceOf(normalizedAccount, timestamp);
                return {
                    availableBalance: realtimeBalanceOf.availableBalance.toString(),
                    deposit: realtimeBalanceOf.deposit.toString(),
                    owedDeposit: realtimeBalanceOf.owedDeposit.toString(),
                    timestamp: (0, $f456740ea8874244$export$f07c840af7d4309b)(timestamp)
                };
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "SUPERTOKEN_READ",
                    message: "There was an error getting realtimeBalanceOf",
                    cause: err
                });
            }
        };
        /** ### CFA Read Functions ### */ /**
         * Get the details of a flow.
         * @param sender the sender of the flow
         * @param receiver the receiver of the flow
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3FlowInfo>} Web3 Flow info object
         */ this.getFlow = async (params)=>{
            return await this.cfaV1.getFlow({
                superToken: this.settings.address,
                sender: params.sender,
                receiver: params.receiver,
                providerOrSigner: params.providerOrSigner
            });
        };
        /**
         * Get the flow info of an account (net flow).
         * @param account the account we're querying
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3FlowInfo>} Web3 Flow info object
         */ this.getAccountFlowInfo = async (params)=>{
            return await this.cfaV1.getAccountFlowInfo({
                superToken: this.settings.address,
                account: params.account,
                providerOrSigner: params.providerOrSigner
            });
        };
        /**
         * Get the net flow of an account.
         * @param account the account we're querying
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<string>} Web3 Flow info object
         */ this.getNetFlow = async (params)=>{
            return await this.cfaV1.getNetFlow({
                superToken: this.settings.address,
                account: params.account,
                providerOrSigner: params.providerOrSigner
            });
        };
        /**
         * Get flow operator data.
         * @param sender the sender
         * @param flowOperator the flowOperator
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3FlowOperatorData>} Web3 Flow info object
         */ this.getFlowOperatorData = async (params)=>{
            const normalizedSender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.sender);
            const normalizedFlowOperator = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.flowOperator);
            return await this.cfaV1.getFlowOperatorData({
                superToken: this.settings.address,
                sender: normalizedSender,
                flowOperator: normalizedFlowOperator,
                providerOrSigner: params.providerOrSigner
            });
        };
        /**
         * Get flow operator data using the flowOperatorId.
         * @param flowOperatorId The keccak256 hash of encoded string "flowOperator", sender and flowOperator
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3FlowOperatorData>} Web3 Flow info object
         */ this.getFlowOperatorDataByID = async (params)=>{
            return await this.cfaV1.getFlowOperatorDataByID({
                superToken: this.settings.address,
                flowOperatorId: params.flowOperatorId,
                providerOrSigner: params.providerOrSigner
            });
        };
        /** ### ERC20 Write Functions ### */ /**
         * Increases the allowance of `spender` by `amount`.
         * @param spender the spender
         * @param amount the amount to increase the allowance by
         * @returns {Operation}  An instance of Operation which can be executed or batched.
         */ this.increaseAllowance = (params)=>{
            const spender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.spender);
            const txn = this.contract.populateTransaction.increaseAllowance(spender, params.amount, params.overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "ERC20_INCREASE_ALLOWANCE");
        };
        /**
         * Decreases the allowance of `spender` by `amount`.
         * @param spender the spender
         * @param amount the amount to decrease the allowance by
         * @returns {Operation}  An instance of Operation which can be executed or batched.
         */ this.decreaseAllowance = (params)=>{
            const spender = (0, $f456740ea8874244$export$3d645f8d0edc7ea2)(params.spender);
            const txn = this.contract.populateTransaction.decreaseAllowance(spender, params.amount, params.overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "ERC20_DECREASE_ALLOWANCE");
        };
        /** ### CFA Write Functions ### */ /**
         * Create a flow of the token of this class.
         * @param receiver The receiver of the flow.
         * @param flowRate The specified flow rate.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.createFlow = (params)=>{
            return this.cfaV1.createFlow({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Update a flow of the token of this class.
         * @param receiver The receiver of the flow.
         * @param flowRate The specified flow rate.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.updateFlow = (params)=>{
            return this.cfaV1.updateFlow({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Delete a flow of the token of this class.
         * @param sender The sender of the flow.
         * @param receiver The receiver of the flow.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.deleteFlow = (params)=>{
            return this.cfaV1.deleteFlow({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Create a flow as an operator
         * @param flowRate The specified flow rate.
         * @param sender The sender of the flow.
         * @param receiver The receiver of the flow.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.createFlowByOperator = (params)=>{
            return this.cfaV1.createFlowByOperator({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Update a flow as an operator.
         * @param flowRate The specified flow rate.
         * @param sender The sender of the flow.
         * @param receiver The receiver of the flow.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.updateFlowByOperator = (params)=>{
            return this.cfaV1.updateFlowByOperator({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Delete a flow as an operator.
         * @param sender The sender of the flow.
         * @param receiver The receiver of the flow.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.deleteFlowByOperator = (params)=>{
            return this.cfaV1.deleteFlowByOperator({
                superToken: this.settings.address,
                ...params
            });
        };
        /** ### IDA Read Functions ### */ /**
         * Get the details of a `Subscription`.
         * @param publisher the address of the publisher of the index
         * @param indexId the index id
         * @param subscriber the subscriber's address
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3Subscription>} Web3 Subscription object
         */ this.getSubscription = async (params)=>{
            return await this.idaV1.getSubscription({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Get the details of an `Index`.
         * @param publisher the address of the publisher of the index
         * @param indexId the index id
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3Index>} Web3 Index object
         */ this.getIndex = async (params)=>{
            return await this.idaV1.getIndex({
                superToken: this.settings.address,
                ...params
            });
        };
        /** ### IDA Write Functions ### */ /**
         * Creates an IDA Index.
         * @param indexId The id of the index.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.createIndex = (params)=>{
            return this.idaV1.createIndex({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Distributes `amount` of token to an index
         * @param indexId The id of the index.
         * @param amount The amount of tokens to be distributed.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.distribute = (params)=>{
            return this.idaV1.distribute({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Updates the `IndexValue` field of an index.
         * @param indexId The id of the index.
         * @param indexValue The new indexValue.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         *
         * NOTE: It has the same effect as `distribute`, but is closer to the low level data structure of the index.
         */ this.updateIndexValue = (params)=>{
            return this.idaV1.updateIndexValue({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Updates the `units` allocated to a Subscription.
         * @param indexId The id of the index.
         * @param subscriber The subscriber address whose units you want to update.
         * @param units The amount of units you want to update to.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.updateSubscriptionUnits = (params)=>{
            return this.idaV1.updateSubscriptionUnits({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Approves a Subscription, so the Subscriber won't need to claim tokens when the Publisher distributes.
         * @param indexId The id of the index.
         * @param publisher The publisher address whose subscription you want to approve.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.approveSubscription = (params)=>{
            return this.idaV1.approveSubscription({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Revokes a Subscription, so the Subscriber will need to claim tokens when the Publisher distributes.
         * @param indexId The id of the index.
         * @param publisher The index publisher address you want to revoke for the subscriber.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.revokeSubscription = (params)=>{
            return this.idaV1.revokeSubscription({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Deletes a Subscription by setting the `units` allocated to the Subscriber to 0.
         * @param indexId The id of the index.
         * @param subscriber The subscriber address whose subscription you want to delete.
         * @param publisher The publisher address of the index you are targeting.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.deleteSubscription = (params)=>{
            return this.idaV1.deleteSubscription({
                superToken: this.settings.address,
                ...params
            });
        };
        /**
         * Claims any pending tokens allocated to the Subscription (unapproved).
         * @param indexId The id of the index.
         * @param subscriber The subscriber address who you are claiming for.
         * @param publisher The publisher address of the index you are targeting.
         * @param userData Extra user data provided.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.claim = (params)=>{
            return this.idaV1.claim({
                superToken: this.settings.address,
                ...params
            });
        };
        /** ### Governance Read Functions ### */ this.getGovernanceParameters = async (providerOrSigner)=>{
            return this.governance.getGovernanceParameters({
                providerOrSigner: providerOrSigner,
                token: this.settings.address
            });
        };
        this.options = options;
        this.settings = settings;
        this.cfaV1 = new (0, $6a091f8fcf7efe91$export$2e2bcd8739ae039)(settings.config.hostAddress, settings.config.cfaV1Address, settings.config.cfaV1ForwarderAddress);
        this.idaV1 = new (0, $421b609ee3c4a2a5$export$2e2bcd8739ae039)(settings.config.hostAddress, settings.config.idaV1Address);
        this.governance = new (0, $044854795bf8e8dd$export$2e2bcd8739ae039)(settings.config.hostAddress, settings.config.governanceAddress);
        this.contract = new (0, $6c57cc56acea9c6c$exports).Contract(settings.address, (0, $5807054b8470dd5e$export$cb66d9a643e05307).abi);
    }
    /** ### CFA ACL Write Functions (byOperator) ### */ /**
     * Increase the flow rate allowance for an ACL operator.
     * @param flowOperator The operator of the flow.
     * @param flowRateAllowanceDelta The amount to increase the flow rate allowance by.
     * @param userData Extra user data provided.
     * @returns {Operation} An instance of Operation which can be executed or batched.
     */ increaseFlowRateAllowance(params) {
        return this.cfaV1.increaseFlowRateAllowance({
            superToken: this.settings.address,
            ...params
        });
    }
    /**
     * Decrease the flow rate allowance for an ACL operator.
     * @param flowOperator The operator of the flow.
     * @param flowRateAllowanceDelta The amount to decrease the flow rate allowance by.
     * @param userData Extra user data provided.
     * @returns {Operation} An instance of Operation which can be executed or batched.
     */ decreaseFlowRateAllowance(params) {
        return this.cfaV1.decreaseFlowRateAllowance({
            superToken: this.settings.address,
            ...params
        });
    }
    /**
     * Increase the flow rate allowance and sets permissions for an ACL operator.
     * @param flowOperator The permission grantee address
     * @param permission The permissions to set.
     * @param flowRateAllowance The amount to increase the flow rate allowance by.
     * @param userData Extra user data provided.
     * @param overrides ethers overrides object for more control over the transaction sent.
     *
     * @returns {Operation} An instance of Operation which can be executed or batched.
     */ increaseFlowRateAllowanceWithPermissions(params) {
        return this.cfaV1.increaseFlowRateAllowanceWithPermissions({
            superToken: this.settings.address,
            ...params
        });
    }
    /**
     * Decrease the flow rate allowance and sets permissions for an ACL operator.
     * @param flowOperator The permission grantee address
     * @param permission The permissions to set.
     * @param flowRateAllowance The amount to decrease the flow rate allowance by.
     * @param userData Extra user data provided.
     * @param overrides ethers overrides object for more control over the transaction sent.
     *
     * @returns {Operation} An instance of Operation which can be executed or batched.
     */ decreaseFlowRateAllowanceWithPermissions(params) {
        return this.cfaV1.decreaseFlowRateAllowanceWithPermissions({
            superToken: this.settings.address,
            ...params
        });
    }
    /**
     * Update permissions for a flow operator as a sender.
     * @param flowOperator The permission grantee address
     * @param permission The permissions to set.
     * @param flowRateAllowance The flowRateAllowance granted to the flow operator.
     * @param userData Extra user data provided.
     * @param overrides ethers overrides object for more control over the transaction sent.
     * @returns {Operation} An instance of Operation which can be executed or batched.
     */ updateFlowOperatorPermissions(params) {
        return this.cfaV1.updateFlowOperatorPermissions({
            superToken: this.settings.address,
            ...params
        });
    }
    /**
     * Give flow operator full control - max flow rate and create/update/delete permissions.
     * @param flowOperator The permission grantee address
     * @param userData Extra user data provided.
     * @param overrides ethers overrides object for more control over the transaction sent.
     */ authorizeFlowOperatorWithFullControl(params) {
        return this.cfaV1.authorizeFlowOperatorWithFullControl({
            superToken: this.settings.address,
            ...params
        });
    }
    /**
     * Revoke flow operator control - set flow rate to 0 with no permissions.
     * @param flowOperator The permission grantee address
     * @param userData Extra user data provided.
     * @param overrides ethers overrides object for more control over the transaction sent.
     */ revokeFlowOperatorWithFullControl(params) {
        return this.cfaV1.revokeFlowOperatorWithFullControl({
            superToken: this.settings.address,
            ...params
        });
    }
}
$7dd3270ed4bc5e47$var$_a = $7dd3270ed4bc5e47$var$SuperToken;
$7dd3270ed4bc5e47$var$SuperToken.create = async (options)=>{
    if (!options.chainId && !options.networkName) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
        type: "SUPERTOKEN_INITIALIZATION",
        message: "You must input chainId or networkName."
    });
    const networkName = (0, $c8f208e9593adf37$export$806e39a4e7106096)(options);
    const chainId = options.chainId || (0, $de1415f96fbf6fc0$export$7402563b8142db51).get(networkName);
    try {
        const superToken = (0, $5807054b8470dd5e$export$cb66d9a643e05307).connect(options.address, options.provider);
        const getUnderlyingTokenPromise = superToken.connect(options.provider).getUnderlyingToken();
        const underlyingTokenAddress = await (0, $f456740ea8874244$export$cbfb09d10d5691cd)(getUnderlyingTokenPromise, (0, $6c57cc56acea9c6c$exports).constants.AddressZero);
        const settings = {
            address: options.address,
            config: options.config,
            chainId: chainId,
            networkName: networkName
        };
        const tokenSymbol = await superToken.connect(options.provider).symbol();
        const resolverData = (0, $de1415f96fbf6fc0$export$cdfdd3b5e96b5891).get(chainId) || {
            subgraphAPIEndpoint: "",
            resolverAddress: "",
            networkName: "",
            nativeTokenSymbol: ""
        };
        const nativeTokenSymbol = resolverData.nativeTokenSymbol || "ETH";
        const nativeSuperTokenSymbol = nativeTokenSymbol + "x";
        // @note This is tech debt and should be reverted once GoodDollar upgrades their token contract
        // @note We are using tryGet here just to handle GoodDollar not having
        // CONSTANT_OUTFLOW_NFT in its SuperToken implementation.
        let constantOutflowNFTProxy = await (0, $f456740ea8874244$export$cbfb09d10d5691cd)(superToken.CONSTANT_OUTFLOW_NFT(), (0, $6c57cc56acea9c6c$exports).constants.AddressZero);
        let constantInflowNFTProxy = await (0, $f456740ea8874244$export$cbfb09d10d5691cd)(superToken.CONSTANT_INFLOW_NFT(), (0, $6c57cc56acea9c6c$exports).constants.AddressZero);
        // @note We only want to run this bit of code for GoodDollar SuperTokens
        // (dev and mainnet)
        const GOOD_DOLLAR_SYMBOL = "G$";
        if (tokenSymbol === GOOD_DOLLAR_SYMBOL) {
            // @note we need to create a new interface for the old GoodDollar SuperToken
            // which contains the functions for constantInflowNFT and constantOutflowNFT
            const oldSuperTokenInterface = new (0, $6c57cc56acea9c6c$exports).utils.Interface([
                "function constantInflowNFT() view returns (address)",
                "function constantOutflowNFT() view returns (address)"
            ]);
            const goodDollarSpecificToken = new (0, $6c57cc56acea9c6c$exports).Contract(superToken.address, oldSuperTokenInterface);
            // @note we attempt to get the constantInflowNFT and constantOutflowNFT
            if (constantOutflowNFTProxy === (0, $6c57cc56acea9c6c$exports).constants.AddressZero) constantOutflowNFTProxy = await (0, $f456740ea8874244$export$cbfb09d10d5691cd)(goodDollarSpecificToken.constantOutflowNFT(), (0, $6c57cc56acea9c6c$exports).constants.AddressZero);
            if (constantInflowNFTProxy === (0, $6c57cc56acea9c6c$exports).constants.AddressZero) constantInflowNFTProxy = await (0, $f456740ea8874244$export$cbfb09d10d5691cd)(goodDollarSpecificToken.constantInflowNFT(), (0, $6c57cc56acea9c6c$exports).constants.AddressZero);
        }
        const nftAddresses = {
            constantOutflowNFTProxy: constantOutflowNFTProxy,
            constantInflowNFTProxy: constantInflowNFTProxy
        };
        if (nativeSuperTokenSymbol === tokenSymbol) return new $7dd3270ed4bc5e47$export$e4e3d45f6c9cb641(options, settings, nativeTokenSymbol, nftAddresses);
        if (underlyingTokenAddress !== (0, $6c57cc56acea9c6c$exports).constants.AddressZero) return new $7dd3270ed4bc5e47$export$5c8ef8979916036e(options, {
            ...settings,
            underlyingTokenAddress: underlyingTokenAddress
        }, nftAddresses);
        return new $7dd3270ed4bc5e47$export$bb8ad93dd6c58f8(options, settings, nftAddresses);
    } catch (err) {
        throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
            type: "SUPERTOKEN_INITIALIZATION",
            message: "There was an error initializing the SuperToken",
            cause: err
        });
    }
};
var $7dd3270ed4bc5e47$export$2e2bcd8739ae039 = $7dd3270ed4bc5e47$var$SuperToken;
class $7dd3270ed4bc5e47$export$5c8ef8979916036e extends $7dd3270ed4bc5e47$var$SuperToken {
    constructor(options, settings, nftAddresses){
        super(options, settings);
        /** ### WrapperSuperToken Contract Write Functions ### */ /**
         * Downgrade `amount` SuperToken's.
         * @param amount The amount to be downgraded.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.downgrade = ({ amount: amount, overrides: overrides })=>{
            const txn = this.contract.populateTransaction.downgrade(amount, overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "SUPERTOKEN_DOWNGRADE");
        };
        /**
         * Downgrade `amount` of an ERC20 token to its SuperToken to `to` address.
         * @param amount The amount to be downgraded.
         * @param to The destination of the downgraded ERC20 token.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed.
         */ this.downgradeTo = ({ amount: amount, to: to, overrides: overrides })=>{
            const txn = this.contract.populateTransaction.downgradeTo(to, amount, {
                ...overrides
            });
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "UNSUPPORTED");
        };
        /**
         * Upgrade `amount` SuperToken's.
         * @param amount The amount to be upgraded.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */ this.upgrade = ({ amount: amount, overrides: overrides })=>{
            const txn = this.contract.populateTransaction.upgrade(amount, overrides || {});
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "SUPERTOKEN_UPGRADE");
        };
        /**
         * Upgrade `amount` of an ERC20 token to its SuperToken to `to` address.
         * @param amount The amount to be upgraded.
         * @param to The destination of the upgraded wrapper super tokens.
         * @param data Bytes userData
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed.
         */ this.upgradeTo = ({ amount: amount, to: to, data: data = "0x", overrides: overrides })=>{
            const txn = this.contract.populateTransaction.upgradeTo(to, amount, data, {
                ...overrides
            });
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "UNSUPPORTED");
        };
        this.underlyingToken = new (0, $3de228b7e6630b4a$export$2e2bcd8739ae039)(settings.underlyingTokenAddress);
        this.constantInflowNFTProxy = new (0, $49b3a29b1174dda2$export$2e2bcd8739ae039)(nftAddresses.constantInflowNFTProxy);
        this.constantOutflowNFTProxy = new (0, $ee728930ca27787d$export$2e2bcd8739ae039)(nftAddresses.constantOutflowNFTProxy);
    }
}
class $7dd3270ed4bc5e47$export$bb8ad93dd6c58f8 extends $7dd3270ed4bc5e47$var$SuperToken {
    constructor(options, settings, nftAddresses){
        super(options, settings);
        this.constantInflowNFTProxy = new (0, $49b3a29b1174dda2$export$2e2bcd8739ae039)(nftAddresses.constantInflowNFTProxy);
        this.constantOutflowNFTProxy = new (0, $ee728930ca27787d$export$2e2bcd8739ae039)(nftAddresses.constantOutflowNFTProxy);
    }
}
class $7dd3270ed4bc5e47$export$e4e3d45f6c9cb641 extends $7dd3270ed4bc5e47$var$SuperToken {
    constructor(options, settings, nativeTokenSymbol, nftAddresses){
        super(options, settings);
        /**
         * Upgrade `amount` of a network's native asset to its SuperToken.
         * @param amount The amount to be upgraded.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed.
         */ this.upgrade = ({ amount: amount, overrides: overrides })=>{
            const txn = this.nativeAssetContract.populateTransaction.upgradeByETH({
                ...overrides,
                value: amount
            });
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "UNSUPPORTED");
        };
        /**
         * Upgrade `amount` of a network's native asset to its SuperToken to `to` address.
         * @param amount The amount to be upgraded.
         * @param to The destination of the upgraded native asset super tokens.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed.
         */ this.upgradeTo = ({ amount: amount, to: to, overrides: overrides })=>{
            const txn = this.nativeAssetContract.populateTransaction.upgradeByETHTo(to, {
                ...overrides,
                value: amount
            });
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "UNSUPPORTED");
        };
        /**
         * Downgrade `amount` of a native asset super token to the underlying native asset.
         * @param amount The amount to be upgraded.
         * @param overrides ethers overrides object for more control over the transaction sent.
         * @returns {Operation} An instance of Operation which can be executed.
         */ this.downgrade = ({ amount: amount, overrides: overrides })=>{
            const txn = this.nativeAssetContract.populateTransaction.downgradeToETH(amount, {
                ...overrides
            });
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, "UNSUPPORTED");
        };
        this.nativeTokenSymbol = nativeTokenSymbol;
        this.constantInflowNFTProxy = new (0, $49b3a29b1174dda2$export$2e2bcd8739ae039)(nftAddresses.constantInflowNFTProxy);
        this.constantOutflowNFTProxy = new (0, $ee728930ca27787d$export$2e2bcd8739ae039)(nftAddresses.constantOutflowNFTProxy);
    }
    get nativeAssetContract() {
        return new (0, $6c57cc56acea9c6c$exports).Contract(this.settings.address, (0, $9790b5504bbc42fa$export$e4ae7ea5e37d1039).abi);
    }
}






var $ad9ef6f4a144bd14$var$_a;
const $ad9ef6f4a144bd14$var$V1 = "v1";
/**
 * Superfluid Framework Class
 * @description The entrypoint for the SDK-core, `create` an instance of this for full functionality.
 */ class $ad9ef6f4a144bd14$var$Framework {
    constructor(options, settings){
        /**
         * Create a signer which can be used to sign transactions.
         * @param options.web3Provider a Web3Provider object (e.g. client side - metamask, web3modal)
         * @param options.provider an ethers Provider object (e.g. via Hardhat ethers)
         * @param options.privateKey a test account private key
         * @param options.signer a signer object (e.g. ethers.Wallet instance)
         * @returns `ethers.Signer` object
         */ this.createSigner = (options)=>{
            if (!options.privateKey && !options.provider && !options.signer && !options.web3Provider) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                type: "CREATE_SIGNER",
                message: "You must pass in a private key, provider or signer."
            });
            /* istanbul ignore else  */ if (options.privateKey) {
                if (!options.provider) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "CREATE_SIGNER",
                    message: "You must pass in a provider with your private key."
                });
                return new (0, $6c57cc56acea9c6c$exports).Wallet(options.privateKey, options.provider);
            } else if (options.signer) return options.signer;
            else if (options.web3Provider) return options.web3Provider.getSigner();
            /* istanbul ignore next */ throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                type: "CREATE_SIGNER",
                message: "Something went wrong, this should never occur."
            });
        };
        /**
         * Create a `BatchCall` class from the `Framework`.
         * @param operations the list of operations to execute
         * @returns `BatchCall` class
         */ this.batchCall = (operations)=>{
            return new (0, $e74e0a88b9636687$export$2e2bcd8739ae039)({
                operations: operations,
                hostAddress: this.settings.config.hostAddress
            });
        };
        /**
         * Create an `Operation` class from the `Framework`.
         * @param txn the populated transaction to execute
         * @param type the operation type
         * @returns `Operation` class
         */ this.operation = (txn, type)=>{
            return new (0, $940c1805c1ccfafd$export$2e2bcd8739ae039)(txn, type);
        };
        /**
         * Loads `NativeAssetSuperToken` class from the `Framework`. Will throw if token is not NativeAssetSuperToken.
         * @param tokenAddressOrSymbol
         * @returns `NativeAssetSuperToken` class
         */ this.loadNativeAssetSuperToken = async (tokenAddressOrSymbol)=>{
            const superToken = await this.loadSuperToken(tokenAddressOrSymbol);
            // The NativeAssetSuperToken class should have the nativeTokenSymbol property
            const isNativeAssetSuperToken = !!superToken.nativeTokenSymbol;
            if (!isNativeAssetSuperToken) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                type: "SUPERTOKEN_INITIALIZATION",
                message: "The token is not a native asset supertoken."
            });
            return superToken;
        };
        /**
         * Loads `PureSuperToken` class from the `Framework`. Will throw if token is not PureSuperToken.
         * @param tokenAddressOrSymbol
         * @returns `PureSuperToken` class
         */ this.loadPureSuperToken = async (tokenAddressOrSymbol)=>{
            const superToken = await this.loadSuperToken(tokenAddressOrSymbol);
            // The PureSuperToken class should not have the downgrade (and upgrade) function
            // we can just check if downgrade doesn't exist
            const isPureSuperToken = !!superToken.downgrade === false;
            if (!isPureSuperToken) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                type: "SUPERTOKEN_INITIALIZATION",
                message: "The token is not a pure supertoken."
            });
            return superToken;
        };
        /**
         * Loads `WrapperSuperToken` class from the `Framework`. Will throw if token is not WrapperSuperToken.
         * @param tokenAddressOrSymbol
         * @returns `WrapperSuperToken` class
         */ this.loadWrapperSuperToken = async (tokenAddressOrSymbol)=>{
            const superToken = await this.loadSuperToken(tokenAddressOrSymbol);
            // The WrapperSuperToken class should have the underlyingToken property
            const isWrapperSuperToken = !!superToken.underlyingToken;
            if (!isWrapperSuperToken) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                type: "SUPERTOKEN_INITIALIZATION",
                message: "The token is not a wrapper supertoken."
            });
            return superToken;
        };
        /**
         * Loads `SuperToken` class from the `Framework`. Use this when you're unsure of the token type.
         * @param tokenAddressOrSymbol the `SuperToken` address or symbol (if symbol, it must be on the resolver)
         * @returns `SuperToken` class
         */ this.loadSuperToken = async (tokenAddressOrSymbol)=>{
            const address = await this._tryGetTokenAddress(tokenAddressOrSymbol);
            return await (0, $7dd3270ed4bc5e47$export$2e2bcd8739ae039).create({
                ...this.settings,
                address: address
            });
        };
        /**
         * Try to get the token address given an address (returns if valid) or the token symbol via the resolver.
         * @param tokenAddressOrSymbol
         * @returns token address
         */ this._tryGetTokenAddress = async (tokenAddressOrSymbol)=>{
            const isInputValidAddress = (0, $6c57cc56acea9c6c$exports).utils.isAddress(tokenAddressOrSymbol);
            if (isInputValidAddress) return tokenAddressOrSymbol;
            else try {
                const superTokenKey = "supertokens." + this.settings.protocolReleaseVersion + "." + tokenAddressOrSymbol;
                const resolver = (0, $560dc15c6d1f868e$export$d5298427584c1f4b).connect(this.settings.config.resolverAddress, this.settings.provider);
                return await resolver.get(superTokenKey);
            } catch (err) {
                throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
                    type: "SUPERTOKEN_INITIALIZATION",
                    message: "There was an error with loading the SuperToken with symbol: " + tokenAddressOrSymbol + " with the resolver.",
                    cause: err
                });
            }
        };
        this.userInputOptions = options;
        this.settings = settings;
        this.cfaV1 = new (0, $6a091f8fcf7efe91$export$2e2bcd8739ae039)(settings.config.hostAddress, settings.config.cfaV1Address, settings.config.cfaV1ForwarderAddress);
        this.governance = new (0, $044854795bf8e8dd$export$2e2bcd8739ae039)(settings.config.hostAddress, settings.config.governanceAddress);
        this.host = new (0, $aa8d7ced1bddb8e4$export$2e2bcd8739ae039)(settings.config.hostAddress);
        this.idaV1 = new (0, $421b609ee3c4a2a5$export$2e2bcd8739ae039)(settings.config.hostAddress, settings.config.idaV1Address);
        this.query = new (0, $39575766490db638$export$2e2bcd8739ae039)(settings);
        const resolver = new (0, $6c57cc56acea9c6c$exports).Contract(settings.config.resolverAddress, (0, $560dc15c6d1f868e$export$d5298427584c1f4b).abi);
        this.contracts = {
            cfaV1: this.cfaV1.contract,
            governance: this.governance.contract,
            host: this.host.contract,
            idaV1: this.idaV1.contract,
            resolver: resolver
        };
    }
}
$ad9ef6f4a144bd14$var$_a = $ad9ef6f4a144bd14$var$Framework;
/**
 * Creates the Framework object based on user provided `options`.
 * @param options.chainId the chainId of your desired network (e.g. 137 = matic)
 * @param options.customSubgraphQueriesEndpoint your custom subgraph endpoint
 * @param options.resolverAddress a custom resolver address (advanced use for testing)
 * @param options.protocolReleaseVersion a custom release version (advanced use for testing)
 * @param options.provider a provider object (injected web3, injected ethers, ethers provider) necessary for initializing the framework
 * @returns `Framework` class
 */ $ad9ef6f4a144bd14$var$Framework.create = async (options)=>{
    (0, $c8f208e9593adf37$export$ff892c7aa164b666)({
        ...options,
        protocolReleaseVersion: options.protocolReleaseVersion || $ad9ef6f4a144bd14$var$V1
    });
    const networkName = (0, $c8f208e9593adf37$export$806e39a4e7106096)(options);
    const chainId = options.chainId || (0, $de1415f96fbf6fc0$export$7402563b8142db51).get(networkName);
    const releaseVersion = options.protocolReleaseVersion || $ad9ef6f4a144bd14$var$V1;
    const customSubgraphQueriesEndpoint = options.customSubgraphQueriesEndpoint || (0, $c8f208e9593adf37$export$c31f1ace548c01ea)(options);
    const provider = (0, $f456740ea8874244$export$61f7c8a61ef4e707)(options.provider) ? options.provider : (0, $f456740ea8874244$export$314a627d755b9798)(options.provider) ? // ethers.providers.Web3Provider doesn't like
    // the type passed.
    new (0, $6c57cc56acea9c6c$exports).providers.Web3Provider(options.provider.currentProvider) : options.provider.provider;
    const network = await provider.getNetwork();
    if (network.chainId !== chainId && chainId != null) throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
        type: "NETWORK_MISMATCH",
        message: "Your provider network chainId is: " + network.chainId + " whereas your desired chainId is: " + chainId
    });
    try {
        const networkData = (0, $de1415f96fbf6fc0$export$cdfdd3b5e96b5891).get(chainId);
        const resolverAddress = options.resolverAddress ? options.resolverAddress : networkData ? networkData.addresses.resolver : (0, $6c57cc56acea9c6c$exports).constants.AddressZero;
        const resolver = (0, $560dc15c6d1f868e$export$d5298427584c1f4b).connect(resolverAddress, provider);
        const baseSettings = {
            chainId: chainId,
            customSubgraphQueriesEndpoint: customSubgraphQueriesEndpoint,
            protocolReleaseVersion: options.protocolReleaseVersion || $ad9ef6f4a144bd14$var$V1,
            provider: provider,
            networkName: networkName
        };
        // supported networks scenario
        if (networkData && baseSettings.protocolReleaseVersion === $ad9ef6f4a144bd14$var$V1) {
            const governanceAddress = networkData.addresses.governance ? networkData.addresses.governance : await (0, $40eed9bec2e63e98$export$797d13a20ff60701).connect(networkData.addresses.host, provider).getGovernance();
            const settings = {
                ...baseSettings,
                config: {
                    resolverAddress: resolverAddress,
                    hostAddress: networkData.addresses.host,
                    cfaV1Address: networkData.addresses.cfaV1,
                    idaV1Address: networkData.addresses.idaV1,
                    governanceAddress: governanceAddress,
                    cfaV1ForwarderAddress: networkData.addresses.cfaV1Forwarder
                }
            };
            return new $ad9ef6f4a144bd14$var$_a(options, settings);
        } else {
            // unsupported networks scenario (e.g. local testing)
            const superfluidLoaderAddress = await resolver.get("SuperfluidLoader-v1");
            const cfaV1ForwarderAddress = await resolver.get("CFAv1Forwarder");
            const superfluidLoader = (0, $2b004edc6bca4d22$export$c5b358a80319e471).connect(superfluidLoaderAddress, provider);
            const framework = await superfluidLoader.loadFramework(releaseVersion);
            const governanceAddress = await (0, $40eed9bec2e63e98$export$797d13a20ff60701).connect(framework.superfluid, provider).getGovernance();
            const settings = {
                ...baseSettings,
                config: {
                    resolverAddress: resolverAddress,
                    hostAddress: framework.superfluid,
                    cfaV1Address: framework.agreementCFAv1,
                    idaV1Address: framework.agreementIDAv1,
                    governanceAddress: governanceAddress,
                    cfaV1ForwarderAddress: cfaV1ForwarderAddress
                }
            };
            return new $ad9ef6f4a144bd14$var$_a(options, settings);
        }
    } catch (err) {
        throw new (0, $ce3e8d521f64b0d2$export$4413fbdda3c0fc5a)({
            type: "FRAMEWORK_INITIALIZATION",
            message: "There was an error initializing the framework",
            cause: err
        });
    }
};
var $ad9ef6f4a144bd14$export$2e2bcd8739ae039 = $ad9ef6f4a144bd14$var$Framework;




















var $f1q41 = parcelRequire("f1q41");



const $e6f6f8c5debd9201$export$f739a383a4e42f8 = (value)=>{
    return Object.keys(value).sort().reduce((acc, key)=>{
        acc[key] = $e6f6f8c5debd9201$export$ef6b0b53bfb13f27(value[key]);
        return acc;
    }, {});
};
/**
 * NOTE: Regex taken from Ethers.
 */ const $e6f6f8c5debd9201$var$isAddressRegex = /^(0x)?[0-9a-fA-F]{40}$/;
const $e6f6f8c5debd9201$export$ef6b0b53bfb13f27 = (value)=>$e6f6f8c5debd9201$var$lowerCaseIfAddress($e6f6f8c5debd9201$var$undefinedIfEmpty(value));
const $e6f6f8c5debd9201$var$undefinedIfEmpty = (value)=>{
    if (value === "") return undefined;
    return value;
};
const $e6f6f8c5debd9201$var$lowerCaseIfAddress = (value)=>{
    if (typeof value === "string") {
        if (value.match($e6f6f8c5debd9201$var$isAddressRegex)) return value.toLowerCase();
    }
    if (Array.isArray(value)) return value.map((x)=>$e6f6f8c5debd9201$var$lowerCaseIfAddress(x));
    return value;
};


class $229cc8eb976572e2$export$d25b5cc092362619 {
    constructor(){
        /**
         * For every primary address field key there are more fields generated which it should look for addresses.
         * NOTE: The implementation is a bit "magical" but it rids of a bunch of boilerplate and creates a single point for editing.
         */ this.getRelevantAddressesFromFilterByAddressFieldKeys = (filter, addressFieldKeys)=>addressFieldKeys.map((key)=>[
                    filter[key],
                    filter[`${String(key)}_in`],
                    filter[`${String(key)}_not`],
                    filter[`${String(key)}_not_in`]
                ].filter((x)=>typeof x !== "undefined").flat().filter((x)=>!!x)).flat();
    }
    getRelevantAddressesFromFilter(filter) {
        if (!filter) return {
            tokens: [],
            accounts: []
        };
        const addressFieldKeys = this.getAddressFieldKeysFromFilter();
        const tokenAddresses = this.getRelevantAddressesFromFilterByAddressFieldKeys(filter, addressFieldKeys.tokenKeys);
        const accountAddresses = this.getRelevantAddressesFromFilterByAddressFieldKeys(filter, addressFieldKeys.accountKeys);
        return {
            tokens: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(tokenAddresses),
            accounts: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(accountAddresses)
        };
    }
    getRelevantAddressesFromResult(result) {
        if (!result) return {
            tokens: [],
            accounts: []
        };
        const intermediate = this.getRelevantAddressesFromResultCore(result);
        return {
            tokens: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(intermediate.tokens.flat().filter((x)=>!!x)),
            accounts: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(intermediate.accounts.flat().filter((x)=>!!x))
        };
    }
    async get(subgraphClient, query) {
        var _a;
        if (!query.id) return null;
        const response = await this.querySubgraph(subgraphClient, {
            where: {
                id: query.id.toLowerCase()
            },
            skip: 0,
            take: 1,
            block: query.block
        });
        return (_a = this.mapFromSubgraphResponse(response)[0]) !== null && _a !== void 0 ? _a : null;
    }
    async list(subgraphClient, query) {
        var _a;
        // Note: Could possibly optimize here to not create a new internal function every time.
        const queryFunction = async (paging)=>{
            var _a, _b, _c;
            const subgraphFilter = (0, $f456740ea8874244$export$f62628bb56170863)((0, $e6f6f8c5debd9201$export$f739a383a4e42f8)({
                ...(_a = query.filter) !== null && _a !== void 0 ? _a : {},
                id_gt: paging.lastId
            }));
            const subgraphQueryVariables = (0, $f456740ea8874244$export$f62628bb56170863)({
                where: (0, $e6f6f8c5debd9201$export$f739a383a4e42f8)(subgraphFilter),
                orderBy: (_b = query.order) === null || _b === void 0 ? void 0 : _b.orderBy,
                orderDirection: (_c = query.order) === null || _c === void 0 ? void 0 : _c.orderDirection,
                first: (0, $e9fa3bd1f0f40070$export$5ba852834ab142d0)(paging),
                skip: (0, $e9fa3bd1f0f40070$export$80fe49a6bffac98c)(paging) ? (paging.pageNumber - 1) * paging.take : paging.skip,
                block: query.block
            });
            const subgraphResponse = await this.querySubgraph(subgraphClient, subgraphQueryVariables);
            const mappedResult = this.mapFromSubgraphResponse(subgraphResponse);
            return (0, $e9fa3bd1f0f40070$export$ed1321ad5ca95972)(mappedResult, paging);
        };
        if ((0, $e9fa3bd1f0f40070$export$3cdc042667879bc1)(query.pagination)) return (0, $e9fa3bd1f0f40070$export$ed1321ad5ca95972)(await (0, $39575766490db638$export$6d656913aad83206)(queryFunction), query.pagination);
        else return queryFunction((_a = query.pagination) !== null && _a !== void 0 ? _a : (0, $e9fa3bd1f0f40070$export$51fe14f826d94a33)());
    }
    async querySubgraph(subgraphClient, variables) {
        return await subgraphClient.request(this.requestDocument, variables);
    }
}


const $4a0df5c3f7f6afc7$export$27b40c0bd08a4292 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "accounts"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Account_orderBy"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Account_filter"
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accounts"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isSuperApp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtTimestamp"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $a0d3c39cbee5f00f$export$fa279cbf5c7924f3 extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "id"
                ],
                tokenKeys: []
            });
        this.getRelevantAddressesFromResultCore = (result)=>({
                accounts: [
                    result.id
                ],
                tokens: []
            });
        this.mapFromSubgraphResponse = (response)=>response.accounts.map((x)=>({
                    ...x,
                    createdAtTimestamp: Number(x.createdAtTimestamp),
                    createdAtBlockNumber: Number(x.createdAtBlockNumber),
                    updatedAtTimestamp: Number(x.updatedAtTimestamp),
                    updatedAtBlockNumber: Number(x.updatedAtBlockNumber)
                }));
        this.requestDocument = (0, $4a0df5c3f7f6afc7$export$27b40c0bd08a4292);
    }
}



const $8fd8040916c85b9a$export$13fa577c32992b99 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "accountTokenSnapshots"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "AccountTokenSnapshot_orderBy"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "AccountTokenSnapshot_filter"
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountTokenSnapshots"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "account"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balanceUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "symbol"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountStreamedUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountStreamedInUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountStreamedOutUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountTransferredUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalInflowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalApprovedSubscriptions"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNetFlowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfActiveStreams"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "activeOutgoingStreamCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "activeIncomingStreamCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalOutflowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfClosedStreams"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "inactiveOutgoingStreamCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "inactiveIncomingStreamCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalSubscriptionsWithUnits"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "maybeCriticalAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isLiquidationEstimateOptimistic"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $acc939a03d443bd7$export$ff76fb95eda63b3 extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "account"
                ],
                tokenKeys: [
                    "token"
                ]
            });
        this.getRelevantAddressesFromResultCore = (result)=>({
                tokens: [
                    result.token
                ],
                accounts: [
                    result.account
                ]
            });
        this.mapFromSubgraphResponse = (response)=>response.accountTokenSnapshots.map((x)=>({
                    ...x,
                    account: x.account.id,
                    token: x.token.id,
                    tokenSymbol: x.token.symbol,
                    maybeCriticalAtTimestamp: x.maybeCriticalAtTimestamp != null ? Number(x.maybeCriticalAtTimestamp) : null,
                    updatedAtBlockNumber: Number(x.updatedAtBlockNumber),
                    updatedAtTimestamp: Number(x.updatedAtTimestamp),
                    activeIncomingStreamCount: Number(x.activeIncomingStreamCount),
                    activeOutgoingStreamCount: Number(x.activeOutgoingStreamCount),
                    inactiveIncomingStreamCount: Number(x.inactiveIncomingStreamCount),
                    inactiveOutgoingStreamCount: Number(x.inactiveOutgoingStreamCount)
                }));
        this.requestDocument = (0, $8fd8040916c85b9a$export$13fa577c32992b99);
    }
}



const $6598ddbcf01df8db$export$a2b046863caf3de0 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "accountTokenSnapshotLogs"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "AccountTokenSnapshotLog_orderBy"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "AccountTokenSnapshotLog_filter"
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "accountTokenSnapshotLogs"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "order"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logIndex"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "blockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "balance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "maybeCriticalAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountStreamed"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountStreamedIn"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountStreamedOut"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountTransferred"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalApprovedSubscriptions"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalDeposit"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalInflowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNetFlowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfActiveStreams"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "activeOutgoingStreamCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "activeIncomingStreamCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfClosedStreams"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "inactiveOutgoingStreamCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "inactiveIncomingStreamCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalSubscriptionsWithUnits"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalOutflowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionHash"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "triggeredByEventName"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "account"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "symbol"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $497f63fde62c96db$export$5ebd2019cbd48973 extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "account"
                ],
                tokenKeys: [
                    "token"
                ]
            });
        this.getRelevantAddressesFromResultCore = (result)=>({
                tokens: [
                    result.token
                ],
                accounts: [
                    result.account
                ]
            });
        this.mapFromSubgraphResponse = (response)=>response.accountTokenSnapshotLogs.map((x)=>({
                    ...x,
                    account: x.account.id,
                    token: x.token.id,
                    tokenSymbol: x.token.symbol,
                    maybeCriticalAtTimestamp: x.maybeCriticalAtTimestamp != null ? Number(x.maybeCriticalAtTimestamp) : null,
                    blockNumber: Number(x.blockNumber),
                    timestamp: Number(x.timestamp),
                    order: Number(x.order),
                    logIndex: Number(x.logIndex)
                }));
        this.requestDocument = (0, $6598ddbcf01df8db$export$a2b046863caf3de0);
    }
}



const $8da8417b3dee7411$export$4a4dfdf57d35eb12 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "indexes"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Index_orderBy"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Index_filter"
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "indexes"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexCreatedEvent"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexValue"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "publisher"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "symbol"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountDistributedUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalSubscriptionsWithUnits"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalUnits"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalUnitsApproved"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalUnitsPending"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtTimestamp"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $7a129ef679676cbd$export$e9a1be37cf413409 extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "publisher"
                ],
                tokenKeys: [
                    "token"
                ]
            });
        this.getRelevantAddressesFromResultCore = (result)=>({
                tokens: [
                    result.token
                ],
                accounts: [
                    result.publisher
                ]
            });
        this.mapFromSubgraphResponse = (response)=>response.indexes.map((x)=>({
                    ...x,
                    createdAtTimestamp: Number(x.createdAtTimestamp),
                    createdAtBlockNumber: Number(x.createdAtBlockNumber),
                    updatedAtTimestamp: Number(x.updatedAtTimestamp),
                    updatedAtBlockNumber: Number(x.updatedAtBlockNumber),
                    indexCreatedEvent: x.indexCreatedEvent.id,
                    publisher: x.publisher.id,
                    token: x.token.id,
                    tokenSymbol: x.token.symbol
                }));
        this.requestDocument = (0, $8da8417b3dee7411$export$4a4dfdf57d35eb12);
    }
}



const $9c4f6dd6eb5d5eaa$export$6372b5edc7530b54 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "indexSubscriptions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexSubscription_orderBy"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexSubscription_filter"
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "indexSubscriptions"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "approved"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "index"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexValue"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "totalUnits"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "symbol"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexValueUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscriber"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountReceivedUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "units"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtTimestamp"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $fbd91496fe1f5030$export$dd8907fbad60a7dc extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "subscriber"
                ],
                tokenKeys: []
            });
        this.getRelevantAddressesFromResultCore = (result)=>({
                tokens: [
                    result.token
                ],
                accounts: [
                    result.subscriber,
                    result.publisher
                ]
            });
        this.mapFromSubgraphResponse = (response)=>response.indexSubscriptions.map((x)=>({
                    ...x,
                    subscriber: x.subscriber.id,
                    createdAtTimestamp: Number(x.createdAtTimestamp),
                    createdAtBlockNumber: Number(x.createdAtBlockNumber),
                    updatedAtTimestamp: Number(x.updatedAtTimestamp),
                    updatedAtBlockNumber: Number(x.updatedAtBlockNumber),
                    index: x.index.id,
                    indexId: x.index.indexId,
                    indexValueCurrent: x.index.indexValue,
                    indexTotalUnits: x.index.totalUnits,
                    token: x.index.token.id,
                    tokenSymbol: x.index.token.symbol,
                    publisher: x.index.publisher.id
                }));
        this.requestDocument = (0, $9c4f6dd6eb5d5eaa$export$6372b5edc7530b54);
    }
}



const $1e35d19fb6f48870$export$329bbcc2038b4582 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "streams"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Stream_orderBy"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Stream_filter"
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "streams"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currentFlowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "receiver"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sender"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "streamedUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "symbol"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "deposit"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userData"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $fb2913945fffa08b$export$4ef81ef218c57fc2 extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "sender",
                    "receiver"
                ],
                tokenKeys: [
                    "token"
                ]
            });
        this.getRelevantAddressesFromResultCore = (result)=>({
                tokens: [
                    result.token
                ],
                accounts: [
                    result.sender,
                    result.receiver
                ]
            });
        this.mapFromSubgraphResponse = (response)=>response.streams.map((x)=>({
                    ...x,
                    createdAtTimestamp: Number(x.createdAtTimestamp),
                    createdAtBlockNumber: Number(x.createdAtBlockNumber),
                    updatedAtTimestamp: Number(x.updatedAtTimestamp),
                    updatedAtBlockNumber: Number(x.updatedAtBlockNumber),
                    receiver: x.receiver.id,
                    token: x.token.id,
                    tokenSymbol: x.token.symbol,
                    sender: x.sender.id
                }));
        this.requestDocument = (0, $1e35d19fb6f48870$export$329bbcc2038b4582);
    }
}



const $67cd85bf30ac83f2$export$bf61734c473bd068 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "streamPeriods"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "StreamPeriod_filter"
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "StreamPeriod_orderBy"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "streamPeriods"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startedAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startedAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "stoppedAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "stoppedAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountStreamed"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "symbol"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "stream"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sender"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "receiver"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "stoppedAtEvent"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "startedAtEvent"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $ae3b3e22adf02003$export$8604a430e781a93e extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "sender",
                    "receiver"
                ],
                tokenKeys: [
                    "token"
                ]
            });
        this.getRelevantAddressesFromResultCore = (result)=>({
                tokens: [
                    result.token
                ],
                accounts: [
                    result.sender,
                    result.receiver
                ]
            });
        this.mapFromSubgraphResponse = (response)=>response.streamPeriods.map((x)=>{
                var _a;
                return {
                    ...x,
                    stream: x.stream.id,
                    token: x.token.id,
                    tokenSymbol: x.token.symbol,
                    sender: x.sender.id,
                    receiver: x.receiver.id,
                    startedAtEvent: x.startedAtEvent.id,
                    stoppedAtEvent: (_a = x.stoppedAtEvent) === null || _a === void 0 ? void 0 : _a.id,
                    startedAtBlockNumber: Number(x.startedAtBlockNumber),
                    stoppedAtBlockNumber: Number(x.stoppedAtBlockNumber),
                    startedAtTimestamp: Number(x.startedAtTimestamp),
                    stoppedAtTimestamp: Number(x.stoppedAtTimestamp)
                };
            });
        this.requestDocument = (0, $67cd85bf30ac83f2$export$bf61734c473bd068);
    }
}



const $11f2d35aee0cb787$export$3e45e4f61a10e29e = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "tokens"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Token_orderBy"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Token_filter"
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tokens"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "decimals"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isListed"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isNativeAssetSuperToken"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isSuperToken"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "symbol"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "underlyingAddress"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $3283ff513382b6cb$export$eab2b82d37414e9 extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [],
                tokenKeys: [
                    "id",
                    "underlyingToken",
                    "underlyingAddress"
                ]
            });
        this.getRelevantAddressesFromResultCore = (result)=>({
                tokens: [
                    result.underlyingAddress,
                    result.id
                ],
                accounts: []
            });
        this.mapFromSubgraphResponse = (response)=>response.tokens.map((x)=>({
                    ...x,
                    createdAtBlockNumber: Number(x.createdAtBlockNumber),
                    createdAtTimestamp: Number(x.createdAtTimestamp)
                }));
        this.requestDocument = (0, $11f2d35aee0cb787$export$3e45e4f61a10e29e);
    }
}



const $af4e5f83e45e2268$export$f2b52303e3788008 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "tokenStatistics"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TokenStatistic_orderBy"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TokenStatistic_filter"
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tokenStatistics"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountDistributedUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountStreamedUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountTransferredUntilUpdatedAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalApprovedSubscriptions"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfActiveIndexes"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfActiveStreams"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfIndexes"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfClosedStreams"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalOutflowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalSubscriptionsWithUnits"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalSupply"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtBlockNumber"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $c153b36920b217e6$export$1e4ff653a83f415a extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [],
                tokenKeys: [
                    "id",
                    "token"
                ]
            });
        this.getRelevantAddressesFromResultCore = (result)=>({
                tokens: [
                    result.id
                ],
                accounts: []
            });
        this.mapFromSubgraphResponse = (response)=>response.tokenStatistics.map((x)=>({
                    ...x,
                    updatedAtBlockNumber: Number(x.updatedAtBlockNumber),
                    updatedAtTimestamp: Number(x.updatedAtTimestamp)
                }));
        this.requestDocument = (0, $af4e5f83e45e2268$export$f2b52303e3788008);
    }
}



const $00132c3fec1abc37$export$bfda32a2dc67aec4 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "tokenStatisticLogs"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TokenStatisticLog_orderBy"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TokenStatisticLog_filter"
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tokenStatisticLogs"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "blockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionHash"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "logIndex"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "order"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "triggeredByEventName"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfActiveStreams"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfClosedStreams"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfIndexes"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNumberOfActiveIndexes"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalSubscriptionsWithUnits"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalApprovedSubscriptions"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalDeposit"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalOutflowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountStreamed"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountTransferred"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalAmountDistributed"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalSupply"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "symbol"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $d7d189a87226d17d$export$2e8a87ec72df524 extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [],
                tokenKeys: [
                    "token"
                ]
            });
        this.getRelevantAddressesFromResultCore = (result)=>({
                tokens: [
                    result.token
                ],
                accounts: []
            });
        this.mapFromSubgraphResponse = (response)=>response.tokenStatisticLogs.map((x)=>({
                    ...x,
                    blockNumber: Number(x.blockNumber),
                    timestamp: Number(x.timestamp),
                    token: x.token.id
                }));
        this.requestDocument = (0, $00132c3fec1abc37$export$bfda32a2dc67aec4);
    }
}



const $eae8f5ad35bf6f5a$export$af49a882a97518bd = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "flowOperators"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "FlowOperator_orderBy"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "FlowOperator_filter"
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "flowOperators"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtBlockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "updatedAtTimestamp"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flowOperator"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sender"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flowRateAllowanceRemaining"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "permissions"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "allowance"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $a6d1ad602c47338e$export$d4ff7be5979377c1 extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "sender",
                    "flowOperator"
                ],
                tokenKeys: [
                    "token"
                ]
            });
        this.getRelevantAddressesFromResultCore = (result)=>({
                accounts: [
                    result.sender,
                    result.flowOperator
                ],
                tokens: [
                    result.token
                ]
            });
        this.mapFromSubgraphResponse = (response)=>response.flowOperators.map((x)=>({
                    ...x,
                    sender: x.sender.id,
                    token: x.token.id,
                    createdAtTimestamp: Number(x.createdAtTimestamp),
                    createdAtBlockNumber: Number(x.createdAtBlockNumber),
                    updatedAtTimestamp: Number(x.updatedAtTimestamp),
                    updatedAtBlockNumber: Number(x.updatedAtBlockNumber)
                }));
        this.requestDocument = (0, $eae8f5ad35bf6f5a$export$af49a882a97518bd);
    }
}




const $99b8af86c01b0578$export$95edaf541d9bbd21 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "flowUpdatedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "FlowUpdatedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "FlowUpdatedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "flowUpdatedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sender"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "receiver"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flowRate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flowOperator"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "deposit"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "stream"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$a6a1b331c1fdc6ea = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "flowOperatorUpdatedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "FlowOperatorUpdatedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "FlowOperatorUpdatedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "flowOperatorUpdatedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sender"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "permissions"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flowRateAllowance"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$de8eee2894f1d9e = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "indexCreatedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexCreatedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexCreatedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "indexCreatedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "publisher"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "index"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$f9236ad5582d42f3 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "indexDistributionClaimedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexDistributionClaimedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexDistributionClaimedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "indexDistributionClaimedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscriber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "publisher"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "index"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$6f4e42a8537d8c33 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "indexUpdatedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexUpdatedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexUpdatedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "indexUpdatedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalUnitsPending"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalUnitsApproved"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "publisher"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "oldIndexValue"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "newIndexValue"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "index"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$5458b26129b54ee2 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "indexSubscribedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexSubscribedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexSubscribedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "indexSubscribedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscriber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "publisher"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "index"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$aeffbc3e7e9f549c = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "indexUnitsUpdatedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexUnitsUpdatedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexUnitsUpdatedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "indexUnitsUpdatedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "units"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscriber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "publisher"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "oldUnits"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "index"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$be386c78bab01422 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "indexUnsubscribedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexUnsubscribedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "IndexUnsubscribedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "indexUnsubscribedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscriber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "publisher"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "index"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$202fae29c9c41fb4 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "subscriptionApprovedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SubscriptionApprovedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SubscriptionApprovedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscriptionApprovedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscription"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscriber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "publisher"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexId"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$26d3b6eaa67f588b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "subscriptionDistributionClaimedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SubscriptionDistributionClaimedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SubscriptionDistributionClaimedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscriptionDistributionClaimedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscription"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscriber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "publisher"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$b918bc089ad5cb12 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "subscriptionRevokedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SubscriptionRevokedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SubscriptionRevokedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscriptionRevokedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscription"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscriber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "publisher"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$28ad06ce708b1091 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "subscriptionUnitsUpdatedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SubscriptionUnitsUpdatedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SubscriptionUnitsUpdatedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscriptionUnitsUpdatedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "units"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscription"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscriber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "publisher"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "oldUnits"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "indexId"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$5043e412cc635215 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "transferEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TransferEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TransferEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transferEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "to"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "from"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$4bca30220541cd18 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "tokenUpgradedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TokenUpgradedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TokenUpgradedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tokenUpgradedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "account"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$8fe1096801538953 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "tokenDowngradedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TokenDowngradedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TokenDowngradedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tokenDowngradedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "blockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "account"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$7866dd54145ed46b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "agreementClassRegisteredEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "AgreementClassRegisteredEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "AgreementClassRegisteredEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "agreementClassRegisteredEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "code"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "agreementType"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$137e7f76e0ed8067 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "agreementClassUpdatedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "AgreementClassUpdatedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "AgreementClassUpdatedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "agreementClassUpdatedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "code"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "agreementType"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$2b875eeaed711950 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "appRegisteredEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "AppRegisteredEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "AppRegisteredEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "appRegisteredEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "blockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "app"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$5482e9b4f9f047c8 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "governanceReplacedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "GovernanceReplacedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "GovernanceReplacedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "governanceReplacedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "oldGovernance"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "newGovernance"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$4e887de25704ac40 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "jailEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "JailEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "JailEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "jailEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reason"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "app"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$32eda4833b8e7c26 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "superTokenFactoryUpdatedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SuperTokenFactoryUpdatedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SuperTokenFactoryUpdatedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "superTokenFactoryUpdatedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "newFactory"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$5aa16e8c4e30e69f = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "superTokenLogicUpdatedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SuperTokenLogicUpdatedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SuperTokenLogicUpdatedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "superTokenLogicUpdatedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "code"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$5510149000ea1d00 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "roleAdminChangedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "RoleAdminChangedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "RoleAdminChangedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "roleAdminChangedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "role"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "previousAdminRole"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "newAdminRole"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$962b78d118f19c3d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "roleGrantedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "RoleGrantedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "RoleGrantedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "roleGrantedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sender"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "role"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "account"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$9e11a2676adecf4a = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "roleRevokedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "RoleRevokedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "RoleRevokedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "roleRevokedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sender"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "role"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "account"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$802fc38ea27a1074 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "setEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SetEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SetEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "setEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "hashedName"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "target"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "resolverEntry"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$61bc651e34b8c907 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "cfaV1LiquidationPeriodChangedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "CFAv1LiquidationPeriodChangedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "CFAv1LiquidationPeriodChangedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cfav1LiquidationPeriodChangedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "superToken"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "host"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "governanceAddress"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "liquidationPeriod"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isKeySet"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$eb68059fc57ac671 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "configChangedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "ConfigChangedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "ConfigChangedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "configChangedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "superToken"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "key"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isKeySet"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "host"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "governanceAddress"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$ceeba3d2fac8e4d2 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "rewardAddressChangedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "RewardAddressChangedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "RewardAddressChangedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rewardAddressChangedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "superToken"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rewardAddress"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isKeySet"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "host"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "governanceAddress"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$11ee55a283cb164f = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "superTokenMinimumDepositChangedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SuperTokenMinimumDepositChangedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SuperTokenMinimumDepositChangedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "superTokenMinimumDepositChangedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "superToken"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "minimumDeposit"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isKeySet"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "host"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "governanceAddress"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$919bbf47958e3147 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "trustedForwarderChangedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TrustedForwarderChangedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "TrustedForwarderChangedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "trustedForwarderChangedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isKeySet"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "host"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "governanceAddress"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "forwarder"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "enabled"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "superToken"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$4aed926bf973d360 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "agreementLiquidatedByEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "AgreementLiquidatedByEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "AgreementLiquidatedByEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "agreementLiquidatedByEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rewardAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "penaltyAccount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "liquidatorAccount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "bondAccount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "bailoutAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "agreementId"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "agreementClass"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$f9ab28507992d95b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "burnedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "BurnedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "BurnedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "burnedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "operatorData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "operator"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "from"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$740b168d4ba446bb = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "mintedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "MintedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "MintedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "mintedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "operatorData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "operator"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "to"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$c681ded0fceae4f = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "sentEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SentEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SentEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "sentEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "to"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "operatorData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "operator"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$1d97b604fbb1c0e = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "customSuperTokenCreatedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "CustomSuperTokenCreatedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "CustomSuperTokenCreatedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "customSuperTokenCreatedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$85098e99570bf4e = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "superTokenCreatedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SuperTokenCreatedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SuperTokenCreatedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "superTokenCreatedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$a22e35239ca34801 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "superTokenLogicCreatedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SuperTokenLogicCreatedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "SuperTokenLogicCreatedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "superTokenLogicCreatedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "tokenLogic"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$4ff62ed2df8ea5cc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "newPICEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "NewPICEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "NewPICEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "newPICEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "pic"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "bond"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "exitRate"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$cb2e5188bd9dd6b4 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "exitRateChangedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "ExitRateChangedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "ExitRateChangedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "exitRateChangedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "exitRate"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$2da55cd704f5752b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "bondIncreasedEvents"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "BondIncreasedEvent_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "BondIncreasedEvent_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "bondIncreasedEvents"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "token"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "additionalBond"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "__typename"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "blockNumber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "transactionHash"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "gasPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "order"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timestamp"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "logIndex"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $99b8af86c01b0578$export$573ba9c2cbf31e2d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "events"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Event_filter"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "ObjectValue",
                        "fields": []
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "0"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "IntValue",
                        "value": "10"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Event_orderBy"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "id"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "OrderDirection"
                            }
                        }
                    },
                    "defaultValue": {
                        "kind": "EnumValue",
                        "value": "asc"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "events"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "blockNumber"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "transactionHash"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "FlowUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "type"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sender"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "receiver"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "flowRate"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "flowOperator"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "deposit"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "stream"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "FlowOperatorUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sender"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "permissions"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "flowRateAllowance"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "IndexCreatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "index"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "IndexDistributionClaimedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "index"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "IndexUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "totalUnitsPending"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "totalUnitsApproved"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "oldIndexValue"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "newIndexValue"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "index"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "IndexSubscribedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "index"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "IndexUnitsUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "units"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "oldUnits"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "index"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "IndexUnsubscribedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "index"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SubscriptionApprovedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscription"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SubscriptionDistributionClaimedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscription"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SubscriptionRevokedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscription"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SubscriptionUnitsUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "units"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscription"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscriber"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "publisher"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "oldUnits"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "indexId"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "TransferEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "value"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "to"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "from"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "TokenUpgradedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "account"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "TokenDowngradedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "account"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "AgreementClassRegisteredEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "code"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "agreementType"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "AgreementClassUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "code"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "agreementType"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "AppRegisteredEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "app"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "GovernanceReplacedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "oldGovernance"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "newGovernance"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "JailEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "reason"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "app"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SuperTokenFactoryUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "newFactory"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SuperTokenLogicUpdatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "code"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "RoleAdminChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "role"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "previousAdminRole"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "newAdminRole"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "RoleGrantedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sender"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "role"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "account"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "RoleRevokedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sender"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "role"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "account"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SetEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "hashedName"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "target"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "resolverEntry"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CFAv1LiquidationPeriodChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "superToken"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "host"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "governanceAddress"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "liquidationPeriod"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isKeySet"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "ConfigChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "value"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "superToken"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "key"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isKeySet"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "host"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "governanceAddress"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "RewardAddressChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "superToken"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rewardAddress"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isKeySet"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "host"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "governanceAddress"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SuperTokenMinimumDepositChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "superToken"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "minimumDeposit"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isKeySet"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "host"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "governanceAddress"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "TrustedForwarderChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isKeySet"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "host"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "governanceAddress"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "forwarder"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "enabled"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "superToken"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "AgreementLiquidatedByEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rewardAmount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "penaltyAccount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "liquidatorAccount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bondAccount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bailoutAmount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "agreementId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "agreementClass"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "AgreementLiquidatedV2Event"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "liquidatorAccount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "agreementClass"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "agreementId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "targetAccount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rewardAmountReceiver"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rewardAmount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "targetAccountBalanceDelta"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "version"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "liquidationType"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "rewardAccount"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "PPPConfigurationChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "host"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "governanceAddress"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "superToken"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isKeySet"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "liquidationPeriod"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "patricianPeriod"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "BurnedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "operatorData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "operator"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "from"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "data"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "MintedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "operatorData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "operator"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "data"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "to"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SentEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "to"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "operatorData"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "operator"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "data"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "CustomSuperTokenCreatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SuperTokenCreatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "SuperTokenLogicCreatedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "tokenLogic"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "NewPICEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "pic"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bond"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "exitRate"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "ExitRateChangedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "exitRate"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "BondIncreasedEvent"
                                        }
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "token"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "additionalBond"
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "Event"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "__typename"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "gasPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "order"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "logIndex"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $2f2ea2ee91749fd7$export$7d9b99083aea276c extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "addresses"
                ],
                tokenKeys: []
            });
        this.requestDocument = (0, $99b8af86c01b0578$export$573ba9c2cbf31e2d);
    }
    getRelevantAddressesFromResultCore() {
        return {
            accounts: [],
            tokens: []
        };
    }
    mapFromSubgraphResponse(response) {
        return (0, $05c2b66738aae405$export$7af0467e7a486478)(response.events);
    }
}





class $87b1dd3d35b6227c$export$ec2164c582c91348 extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "sender",
                    "receiver",
                    "flowOperator"
                ],
                tokenKeys: [
                    "token"
                ]
            });
        this.requestDocument = (0, $99b8af86c01b0578$export$95edaf541d9bbd21);
    }
    getRelevantAddressesFromResultCore(result) {
        return {
            accounts: [
                result.sender,
                result.receiver
            ],
            tokens: [
                result.token
            ]
        };
    }
    mapFromSubgraphResponse(response) {
        return (0, $05c2b66738aae405$export$7af0467e7a486478)(response.flowUpdatedEvents);
    }
}





class $f74638f1c34d33fa$export$64b2c4f3273aaacc extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "publisher"
                ],
                tokenKeys: [
                    "token"
                ]
            });
        this.requestDocument = (0, $99b8af86c01b0578$export$6f4e42a8537d8c33);
    }
    getRelevantAddressesFromResultCore(result) {
        return {
            accounts: [
                result.publisher
            ],
            tokens: [
                result.token
            ]
        };
    }
    mapFromSubgraphResponse(response) {
        return (0, $05c2b66738aae405$export$7af0467e7a486478)(response.indexUpdatedEvents);
    }
}





class $f4288043db3de436$export$b6288432856a6997 extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "publisher",
                    "subscriber"
                ],
                tokenKeys: [
                    "token"
                ]
            });
        this.requestDocument = (0, $99b8af86c01b0578$export$28ad06ce708b1091);
    }
    getRelevantAddressesFromResultCore(result) {
        return {
            accounts: [
                result.publisher,
                result.subscriber
            ],
            tokens: [
                result.token
            ]
        };
    }
    mapFromSubgraphResponse(response) {
        return (0, $05c2b66738aae405$export$7af0467e7a486478)(response.subscriptionUnitsUpdatedEvents);
    }
}





class $17ac1bde5b3b8296$export$62c6f192d3473ce9 extends (0, $229cc8eb976572e2$export$d25b5cc092362619) {
    constructor(){
        super(...arguments);
        this.getAddressFieldKeysFromFilter = ()=>({
                accountKeys: [
                    "from",
                    "to"
                ],
                tokenKeys: [
                    "token"
                ]
            });
        this.requestDocument = (0, $99b8af86c01b0578$export$5043e412cc635215);
    }
    getRelevantAddressesFromResultCore(result) {
        return {
            accounts: [
                result.from,
                result.to
            ],
            tokens: [
                result.token
            ]
        };
    }
    mapFromSubgraphResponse(response) {
        return (0, $05c2b66738aae405$export$7af0467e7a486478)(response.transferEvents);
    }
}


const $1beb01149e3aeb6f$export$208f737c3e5a199b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "meta"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "block"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Block_height"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "_meta"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "block"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "block"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "number"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "hash"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "deployment"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "hasIndexingErrors"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


class $59b5c837db0d186d$export$99e57e44166a7ef9 {
    async get(subgraphClient, query) {
        const response = await subgraphClient.request((0, $1beb01149e3aeb6f$export$208f737c3e5a199b), query);
        if (!response._meta) return null;
        return {
            blockNumber: response._meta.block.number,
            blockHash: response._meta.block.hash,
            deployment: response._meta.deployment,
            hasIndexingErrors: response._meta.hasIndexingErrors
        };
    }
}


// TODO(KK): Add comments







let $87f8fa8903809305$var$account;
async function $87f8fa8903809305$export$2e2bcd8739ae039() {
    const provider = new (0, $6c57cc56acea9c6c$exports).providers.Web3Provider(window.ethereum);
    await provider.send("eth_requestAccounts", []);
    const signer = provider.getSigner();
    const chainId = await window.ethereum.request({
        method: "eth_chainId"
    });
    const sf = await (0, $ad9ef6f4a144bd14$export$2e2bcd8739ae039).create({
        chainId: Number(chainId),
        provider: provider
    });
    const superSigner = sf.createSigner({
        signer: signer
    });
    let sender = await superSigner.getAddress();
    console.log("signer", signer);
    console.log("signer", await superSigner.getAddress());
    const daix = await sf.loadSuperToken("fDAIx");
    console.log(daix);
    try {
        const deleteFlowOperation = daix.deleteFlow({
            sender: await signer.getAddress(),
            receiver: "0x03905E154e6F499F99DDa452502aDfbC4842aD4F"
        });
        console.log(deleteFlowOperation);
        console.log("Deleting your stream...");
        const result = await deleteFlowOperation.exec(superSigner);
        console.log(result);
        console.log(`Congrats - you've just updated a money stream!
    `);
        console.log(`https://console.superfluid.finance/goerli/accounts/${sender}?tab=tokens`);
        return true;
    } catch (error) {
        console.log("Hmmm, your transaction threw an error. Make sure that this stream does not already exist, and that you've entered a valid Ethereum address!");
        console.error(error);
        return false;
    }
} // export const DeleteFlow = () => {
 //   const [recipient, setRecipient] = useState("");
 //   const [isButtonLoading, setIsButtonLoading] = useState(false);
 //   const [currentAccount, setCurrentAccount] = useState("");
 //   const connectWallet = async () => {
 //     try {
 //       const { ethereum } = window;
 //       if (!ethereum) {
 //         alert("Get MetaMask!");
 //         return;
 //       }
 //       const accounts = await ethereum.request({
 //         method: "eth_requestAccounts"
 //       });
 //       console.log("Connected", accounts[0]);
 //       setCurrentAccount(accounts[0]);
 //       account = currentAccount;
 //       // Setup listener! This is for the case where a user comes to our site
 //       // and connected their wallet for the first time.
 //       // setupEventListener()
 //     } catch (error) {
 //       console.log(error);
 //     }
 //   };
 //   const checkIfWalletIsConnected = async () => {
 //     console.log("runs");
 //     const { ethereum } = window;
 //     if (!ethereum) {
 //       console.log("Make sure you have metamask!");
 //       return;
 //     } else {
 //       console.log("We have the ethereum object", ethereum);
 //     }
 //     const accounts = await window.ethereum.request({ method: "eth_accounts" });
 //     const chain = await window.ethereum.request({ method: "eth_chainId" });
 //     let chainId = chain;
 //     console.log("chain ID:", chain);
 //     console.log("global Chain Id:", chainId);
 //     if (accounts.length !== 0) {
 //       account = accounts[0];
 //       console.log("Found an authorized account:", account);
 //       setCurrentAccount(account);
 //       // Setup listener! This is for the case where a user comes to our site
 //       // and ALREADY had their wallet connected + authorized.
 //       // setupEventListener()
 //     } else {
 //       console.log("No authorized account found");
 //     }
 //   };
 //   useEffect(() => {
 //     checkIfWalletIsConnected();
 //   }, []);
 //   function calculateFlowRate(amount) {
 //     if (typeof Number(amount) !== "number" || isNaN(Number(amount)) === true) {
 //       alert("You can only calculate a flowRate based on a number");
 //       return;
 //     } else if (typeof Number(amount) === "number") {
 //       if (Number(amount) === 0) {
 //         return 0;
 //       }
 //       const amountInWei = ethers.BigNumber.from(amount);
 //       const monthlyAmount = ethers.utils.formatEther(amountInWei.toString());
 //       const calculatedFlowRate = monthlyAmount * 3600 * 24 * 30;
 //       return calculatedFlowRate;
 //     }
 //   }
 //   function DeleteButton({ isLoading, children, ...props }) {
 //     return (
 //       <Button variant="success" className="button" {...props}>
 //         {isButtonLoading ? <Spinner animation="border" /> : children}
 //       </Button>
 //     );
 //   }
 //   const handleRecipientChange = (e) => {
 //     setRecipient(() => ([e.target.name] = e.target.value));
 //   };
 //   return (
 //     <div>
 //       <h2>Delete a Flow</h2>
 //       {currentAccount === "" ? (
 //         <button id="connectWallet" className="button" onClick={connectWallet}>
 //           Connect Wallet
 //         </button>
 //       ) : (
 //         <Card className="connectedWallet">
 //           {`${currentAccount.substring(0, 4)}...${currentAccount.substring(
 //             38
 //           )}`}
 //         </Card>
 //       )}
 //       <Form>
 //         <FormGroup className="mb-3">
 //           <FormControl
 //             name="recipient"
 //             value={recipient}
 //             onChange={handleRecipientChange}
 //             placeholder="Enter recipient address"
 //           ></FormControl>
 //         </FormGroup>
 //         <FormGroup className="mb-3"></FormGroup>
 //         <DeleteButton
 //           onClick={() => {
 //             setIsButtonLoading(true);
 //             deleteExistingFlow(recipient);
 //             setTimeout(() => {
 //               setIsButtonLoading(false);
 //             }, 1000);
 //           }}
 //         >
 //           Click to Create Your Stream
 //         </DeleteButton>
 //       </Form>
 //       <div className="description">
 //         <p>
 //           Go to the DeleteFlow.js component and look at the <b>deleteFlow() </b>
 //           function to see under the hood
 //         </p>
 //       </div>
 //     </div>
 //   );
 // };






const $2ea0ceb4cb58ae14$var$BookCustomCard = (props)=>{
    const { imageUrl: imageUrl, companyName: companyName, country: country, date: date, description: description, location: location, name: name, price: price } = props.propsEventData.eventInfo;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "cardImg",
                src: imageUrl,
                alt: "Image Event Page"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                children: [
                    name,
                    " by ",
                    companyName
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "cardFeaturedSection",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            date,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            price,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            country,
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: description
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: location
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: "/booktickets",
                className: "homeButton",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "custom-btn btn-16",
                    children: "(Sold out)"
                })
            })
        ]
    });
};
var $2ea0ceb4cb58ae14$export$2e2bcd8739ae039 = $2ea0ceb4cb58ae14$var$BookCustomCard;


const $c5ff20eebfb368bf$var$BookCustomContainer = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "cardContainer",
        children: (0, $dde09506a3a71a1f$export$ea86d35eea1f7f37).map((element, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ea0ceb4cb58ae14$export$2e2bcd8739ae039), {
                propsEventData: element
            }, index + "eventInfo"))
    });
};
var $c5ff20eebfb368bf$export$2e2bcd8739ae039 = $c5ff20eebfb368bf$var$BookCustomContainer;




var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


"use client";
const $ad26fe773541dcd3$var$c = (e)=>"number" == typeof e && !isNaN(e), $ad26fe773541dcd3$var$d = (e)=>"string" == typeof e, $ad26fe773541dcd3$var$u = (e)=>"function" == typeof e, $ad26fe773541dcd3$var$p = (e)=>$ad26fe773541dcd3$var$d(e) || $ad26fe773541dcd3$var$u(e) ? e : null, $ad26fe773541dcd3$var$m = (e)=>(0, $acw62.isValidElement)(e) || $ad26fe773541dcd3$var$d(e) || $ad26fe773541dcd3$var$u(e) || $ad26fe773541dcd3$var$c(e);
function $ad26fe773541dcd3$export$184cca501f1aed7f(e, t, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = e;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(t, n);
        });
    });
}
function $ad26fe773541dcd3$export$3ff7dc44d332d222(t) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = t;
    return function(t) {
        let { children: d, position: u, preventExitTransition: p, done: m, nodeRef: g, isIn: y, playToast: v } = t;
        const h = i ? `${a}--${u}` : a, T = i ? `${r}--${u}` : r, E = (0, $acw62.useRef)(0);
        return (0, $acw62.useLayoutEffect)(()=>{
            const e = g.current, t = h.split(" "), n = (o)=>{
                o.target === g.current && (v(), e.removeEventListener("animationend", n), e.removeEventListener("animationcancel", n), 0 === E.current && "animationcancel" !== o.type && e.classList.remove(...t));
            };
            e.classList.add(...t), e.addEventListener("animationend", n), e.addEventListener("animationcancel", n);
        }, []), (0, $acw62.useEffect)(()=>{
            const e = g.current, t = ()=>{
                e.removeEventListener("animationend", t), l ? $ad26fe773541dcd3$export$184cca501f1aed7f(e, m, c) : m();
            };
            y || (p ? t() : (E.current = 1, e.className += ` ${T}`, e.addEventListener("animationend", t)));
        }, [
            y
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, d);
    };
}
function $ad26fe773541dcd3$var$y(e, t) {
    return null != e ? {
        content: e.content,
        containerId: e.props.containerId,
        id: e.props.toastId,
        theme: e.props.theme,
        type: e.props.type,
        data: e.props.data || {},
        isLoading: e.props.isLoading,
        icon: e.props.icon,
        status: t
    } : {};
}
const $ad26fe773541dcd3$var$v = new Map;
let $ad26fe773541dcd3$var$h = [];
const $ad26fe773541dcd3$var$T = new Set, $ad26fe773541dcd3$var$E = (e)=>$ad26fe773541dcd3$var$T.forEach((t)=>t(e)), $ad26fe773541dcd3$var$b = ()=>$ad26fe773541dcd3$var$v.size > 0;
function $ad26fe773541dcd3$var$I(e, t) {
    var n;
    if (t) return !(null == (n = $ad26fe773541dcd3$var$v.get(t)) || !n.isToastActive(e));
    let o = !1;
    return $ad26fe773541dcd3$var$v.forEach((t)=>{
        t.isToastActive(e) && (o = !0);
    }), o;
}
function $ad26fe773541dcd3$var$_(e, t) {
    $ad26fe773541dcd3$var$m(e) && ($ad26fe773541dcd3$var$b() || $ad26fe773541dcd3$var$h.push({
        content: e,
        options: t
    }), $ad26fe773541dcd3$var$v.forEach((n)=>{
        n.buildToast(e, t);
    }));
}
function $ad26fe773541dcd3$var$C(e, t) {
    $ad26fe773541dcd3$var$v.forEach((n)=>{
        null != t && null != t && t.containerId ? (null == t ? void 0 : t.containerId) === n.id && n.toggle(e, null == t ? void 0 : t.id) : n.toggle(e, null == t ? void 0 : t.id);
    });
}
function $ad26fe773541dcd3$export$b262e13ca2dd2381(e) {
    const { subscribe: o, getSnapshot: s, setProps: i } = (0, $acw62.useRef)(function(e) {
        const n = e.containerId || 1;
        return {
            subscribe (o) {
                const s = function(e, n, o) {
                    let s = 1, r = 0, i = [], l = [], f = [], g = n;
                    const v = new Map, h = new Set, T = ()=>{
                        f = Array.from(v.values()), h.forEach((e)=>e());
                    }, E = (e)=>{
                        l = null == e ? [] : l.filter((t)=>t !== e), T();
                    }, b = (e)=>{
                        const { toastId: n, onOpen: s, updateId: a, children: r } = e.props, i = null == a;
                        e.staleId && v.delete(e.staleId), v.set(n, e), l = [
                            ...l,
                            e.props.toastId
                        ].filter((t)=>t !== e.staleId), T(), o($ad26fe773541dcd3$var$y(e, i ? "added" : "updated")), i && $ad26fe773541dcd3$var$u(s) && s((0, $acw62.isValidElement)(r) && r.props);
                    };
                    return {
                        id: e,
                        props: g,
                        observe: (e)=>(h.add(e), ()=>h.delete(e)),
                        toggle: (e, t)=>{
                            v.forEach((n)=>{
                                null != t && t !== n.props.toastId || $ad26fe773541dcd3$var$u(n.toggle) && n.toggle(e);
                            });
                        },
                        removeToast: E,
                        toasts: v,
                        clearQueue: ()=>{
                            r -= i.length, i = [];
                        },
                        buildToast: (n, l)=>{
                            if (((t)=>{
                                let { containerId: n, toastId: o, updateId: s } = t;
                                const a = n ? n !== e : 1 !== e, r = v.has(o) && null == s;
                                return a || r;
                            })(l)) return;
                            const { toastId: f, updateId: h, data: I, staleId: _, delay: C } = l, L = ()=>{
                                E(f);
                            }, N = null == h;
                            N && r++;
                            const $ = {
                                ...g,
                                style: g.toastStyle,
                                key: s++,
                                ...Object.fromEntries(Object.entries(l).filter((e)=>{
                                    let [t, n] = e;
                                    return null != n;
                                })),
                                toastId: f,
                                updateId: h,
                                data: I,
                                closeToast: L,
                                isIn: !1,
                                className: $ad26fe773541dcd3$var$p(l.className || g.toastClassName),
                                bodyClassName: $ad26fe773541dcd3$var$p(l.bodyClassName || g.bodyClassName),
                                progressClassName: $ad26fe773541dcd3$var$p(l.progressClassName || g.progressClassName),
                                autoClose: !l.isLoading && (w = l.autoClose, k = g.autoClose, !1 === w || $ad26fe773541dcd3$var$c(w) && w > 0 ? w : k),
                                deleteToast () {
                                    const e = v.get(f), { onClose: n, children: s } = e.props;
                                    $ad26fe773541dcd3$var$u(n) && n((0, $acw62.isValidElement)(s) && s.props), o($ad26fe773541dcd3$var$y(e, "removed")), v.delete(f), r--, r < 0 && (r = 0), i.length > 0 ? b(i.shift()) : T();
                                }
                            };
                            var w, k;
                            $.closeButton = g.closeButton, !1 === l.closeButton || $ad26fe773541dcd3$var$m(l.closeButton) ? $.closeButton = l.closeButton : !0 === l.closeButton && ($.closeButton = !$ad26fe773541dcd3$var$m(g.closeButton) || g.closeButton);
                            let P = n;
                            (0, $acw62.isValidElement)(n) && !$ad26fe773541dcd3$var$d(n.type) ? P = (0, $acw62.cloneElement)(n, {
                                closeToast: L,
                                toastProps: $,
                                data: I
                            }) : $ad26fe773541dcd3$var$u(n) && (P = n({
                                closeToast: L,
                                toastProps: $,
                                data: I
                            }));
                            const M = {
                                content: P,
                                props: $,
                                staleId: _
                            };
                            g.limit && g.limit > 0 && r > g.limit && N ? i.push(M) : $ad26fe773541dcd3$var$c(C) ? setTimeout(()=>{
                                b(M);
                            }, C) : b(M);
                        },
                        setProps (e) {
                            g = e;
                        },
                        setToggle: (e, t)=>{
                            v.get(e).toggle = t;
                        },
                        isToastActive: (e)=>l.some((t)=>t === e),
                        getSnapshot: ()=>g.newestOnTop ? f.reverse() : f
                    };
                }(n, e, $ad26fe773541dcd3$var$E);
                $ad26fe773541dcd3$var$v.set(n, s);
                const r = s.observe(o);
                return $ad26fe773541dcd3$var$h.forEach((e)=>$ad26fe773541dcd3$var$_(e.content, e.options)), $ad26fe773541dcd3$var$h = [], ()=>{
                    r(), $ad26fe773541dcd3$var$v.delete(n);
                };
            },
            setProps (e) {
                var t;
                null == (t = $ad26fe773541dcd3$var$v.get(n)) || t.setProps(e);
            },
            getSnapshot () {
                var e;
                return null == (e = $ad26fe773541dcd3$var$v.get(n)) ? void 0 : e.getSnapshot();
            }
        };
    }(e)).current;
    i(e);
    const l = (0, $acw62.useSyncExternalStore)(o, s, s);
    return {
        getToastToRender: function(e) {
            if (!l) return [];
            const t = new Map;
            return l.forEach((e)=>{
                const { position: n } = e.props;
                t.has(n) || t.set(n, []), t.get(n).push(e);
            }), Array.from(t, (t)=>e(t[0], t[1]));
        },
        isToastActive: $ad26fe773541dcd3$var$I,
        count: null == l ? void 0 : l.length
    };
}
function $ad26fe773541dcd3$export$a407b657d3044108(e) {
    const [t, o] = (0, $acw62.useState)(!1), [a, r] = (0, $acw62.useState)(!1), l = (0, $acw62.useRef)(null), c = (0, $acw62.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: u, closeToast: p, onClick: m, closeOnClick: f } = e;
    var g, y;
    function h() {
        o(!0);
    }
    function T() {
        o(!1);
    }
    function E(n) {
        const o = l.current;
        c.canDrag && o && (c.didMove = !0, t && T(), c.delta = "x" === e.draggableDirection ? n.clientX - c.start : n.clientY - c.start, c.start !== n.clientX && (c.canCloseOnClick = !1), o.style.transform = `translate3d(${"x" === e.draggableDirection ? `${c.delta}px, var(--y)` : `0, calc(${c.delta}px + var(--y))`},0)`, o.style.opacity = "" + (1 - Math.abs(c.delta / c.removalDistance)));
    }
    function b() {
        document.removeEventListener("pointermove", E), document.removeEventListener("pointerup", b);
        const t = l.current;
        if (c.canDrag && c.didMove && t) {
            if (c.canDrag = !1, Math.abs(c.delta) > c.removalDistance) return r(!0), e.closeToast(), void e.collapseAll();
            t.style.transition = "transform 0.2s, opacity 0.2s", t.style.removeProperty("transform"), t.style.removeProperty("opacity");
        }
    }
    null == (y = $ad26fe773541dcd3$var$v.get((g = {
        id: e.toastId,
        containerId: e.containerId,
        fn: o
    }).containerId || 1)) || y.setToggle(g.id, g.fn), (0, $acw62.useEffect)(()=>{
        if (e.pauseOnFocusLoss) return document.hasFocus() || T(), window.addEventListener("focus", h), window.addEventListener("blur", T), ()=>{
            window.removeEventListener("focus", h), window.removeEventListener("blur", T);
        };
    }, [
        e.pauseOnFocusLoss
    ]);
    const I = {
        onPointerDown: function(t) {
            if (!0 === e.draggable || e.draggable === t.pointerType) {
                c.didMove = !1, document.addEventListener("pointermove", E), document.addEventListener("pointerup", b);
                const n = l.current;
                c.canCloseOnClick = !0, c.canDrag = !0, n.style.transition = "none", "x" === e.draggableDirection ? (c.start = t.clientX, c.removalDistance = n.offsetWidth * (e.draggablePercent / 100)) : (c.start = t.clientY, c.removalDistance = n.offsetHeight * (80 === e.draggablePercent ? 1.5 * e.draggablePercent : e.draggablePercent) / 100);
            }
        },
        onPointerUp: function(t) {
            const { top: n, bottom: o, left: s, right: a } = l.current.getBoundingClientRect();
            "touchend" !== t.nativeEvent.type && e.pauseOnHover && t.clientX >= s && t.clientX <= a && t.clientY >= n && t.clientY <= o ? T() : h();
        }
    };
    return d && u && (I.onMouseEnter = T, e.stacked || (I.onMouseLeave = h)), f && (I.onClick = (e)=>{
        m && m(e), c.canCloseOnClick && p();
    }), {
        playToast: h,
        pauseToast: T,
        isRunning: t,
        preventExitTransition: a,
        toastRef: l,
        eventHandlers: I
    };
}
function $ad26fe773541dcd3$var$$(t) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: c, controlledProgress: d, progress: p, rtl: m, isIn: f, theme: g } = t;
    const y = r || d && 0 === p, v = {
        ...c,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    d && (v.transform = `scaleX(${p})`);
    const h = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__progress-bar", d ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $ad26fe773541dcd3$var$u(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: h
    }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(h, i), E = {
        [d && p >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: d && p < 1 ? null : ()=>{
            f && s();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${a}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "progressbar",
        "aria-hidden": y ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: v,
        ...E
    }));
}
let $ad26fe773541dcd3$var$w = 1;
const $ad26fe773541dcd3$var$k = ()=>"" + $ad26fe773541dcd3$var$w++;
function $ad26fe773541dcd3$var$P(e) {
    return e && ($ad26fe773541dcd3$var$d(e.toastId) || $ad26fe773541dcd3$var$c(e.toastId)) ? e.toastId : $ad26fe773541dcd3$var$k();
}
function $ad26fe773541dcd3$var$M(e, t) {
    return $ad26fe773541dcd3$var$_(e, t), t.toastId;
}
function $ad26fe773541dcd3$var$x(e, t) {
    return {
        ...t,
        type: t && t.type || e,
        toastId: $ad26fe773541dcd3$var$P(t)
    };
}
function $ad26fe773541dcd3$var$A(e) {
    return (t, n)=>$ad26fe773541dcd3$var$M(t, $ad26fe773541dcd3$var$x(e, n));
}
function $ad26fe773541dcd3$export$b410431fab84fa58(e, t) {
    return $ad26fe773541dcd3$var$M(e, $ad26fe773541dcd3$var$x("default", t));
}
$ad26fe773541dcd3$export$b410431fab84fa58.loading = (e, t)=>$ad26fe773541dcd3$var$M(e, $ad26fe773541dcd3$var$x("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...t
    })), $ad26fe773541dcd3$export$b410431fab84fa58.promise = function(e, t, n) {
    let o, { pending: s, error: a, success: r } = t;
    s && (o = $ad26fe773541dcd3$var$d(s) ? $ad26fe773541dcd3$export$b410431fab84fa58.loading(s, n) : $ad26fe773541dcd3$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (e, t, s)=>{
        if (null == t) return void $ad26fe773541dcd3$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: e,
            ...i,
            ...n,
            data: s
        }, r = $ad26fe773541dcd3$var$d(t) ? {
            render: t
        } : t;
        return o ? $ad26fe773541dcd3$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $ad26fe773541dcd3$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $ad26fe773541dcd3$var$u(e) ? e() : e;
    return c.then((e)=>l("success", r, e)).catch((e)=>l("error", a, e)), c;
}, $ad26fe773541dcd3$export$b410431fab84fa58.success = $ad26fe773541dcd3$var$A("success"), $ad26fe773541dcd3$export$b410431fab84fa58.info = $ad26fe773541dcd3$var$A("info"), $ad26fe773541dcd3$export$b410431fab84fa58.error = $ad26fe773541dcd3$var$A("error"), $ad26fe773541dcd3$export$b410431fab84fa58.warning = $ad26fe773541dcd3$var$A("warning"), $ad26fe773541dcd3$export$b410431fab84fa58.warn = $ad26fe773541dcd3$export$b410431fab84fa58.warning, $ad26fe773541dcd3$export$b410431fab84fa58.dark = (e, t)=>$ad26fe773541dcd3$var$M(e, $ad26fe773541dcd3$var$x("default", {
        theme: "dark",
        ...t
    })), $ad26fe773541dcd3$export$b410431fab84fa58.dismiss = function(e) {
    !function(e) {
        var t;
        if ($ad26fe773541dcd3$var$b()) {
            if (null == e || $ad26fe773541dcd3$var$d(t = e) || $ad26fe773541dcd3$var$c(t)) $ad26fe773541dcd3$var$v.forEach((t)=>{
                t.removeToast(e);
            });
            else if (e && ("containerId" in e || "id" in e)) {
                var n;
                (null == (n = $ad26fe773541dcd3$var$v.get(e.containerId)) ? void 0 : n.removeToast(e.id)) || $ad26fe773541dcd3$var$v.forEach((t)=>{
                    t.removeToast(e.id);
                });
            }
        } else $ad26fe773541dcd3$var$h = $ad26fe773541dcd3$var$h.filter((t)=>null != e && t.options.toastId !== e);
    }(e);
}, $ad26fe773541dcd3$export$b410431fab84fa58.clearWaitingQueue = function(e) {
    void 0 === e && (e = {}), $ad26fe773541dcd3$var$v.forEach((t)=>{
        !t.props.limit || e.containerId && t.id !== e.containerId || t.clearQueue();
    });
}, $ad26fe773541dcd3$export$b410431fab84fa58.isActive = $ad26fe773541dcd3$var$I, $ad26fe773541dcd3$export$b410431fab84fa58.update = function(e, t) {
    void 0 === t && (t = {});
    const n = ((e, t)=>{
        var n;
        let { containerId: o } = t;
        return null == (n = $ad26fe773541dcd3$var$v.get(o || 1)) ? void 0 : n.toasts.get(e);
    })(e, t);
    if (n) {
        const { props: o, content: s } = n, a = {
            delay: 100,
            ...o,
            ...t,
            toastId: t.toastId || e,
            updateId: $ad26fe773541dcd3$var$k()
        };
        a.toastId !== e && (a.staleId = e);
        const r = a.render || s;
        delete a.render, $ad26fe773541dcd3$var$M(r, a);
    }
}, $ad26fe773541dcd3$export$b410431fab84fa58.done = (e)=>{
    $ad26fe773541dcd3$export$b410431fab84fa58.update(e, {
        progress: 1
    });
}, $ad26fe773541dcd3$export$b410431fab84fa58.onChange = function(e) {
    return $ad26fe773541dcd3$var$T.add(e), ()=>{
        $ad26fe773541dcd3$var$T.delete(e);
    };
}, $ad26fe773541dcd3$export$b410431fab84fa58.play = (e)=>$ad26fe773541dcd3$var$C(!0, e), $ad26fe773541dcd3$export$b410431fab84fa58.pause = (e)=>$ad26fe773541dcd3$var$C(!1, e);
const $ad26fe773541dcd3$var$O = "undefined" != typeof window ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect), $ad26fe773541dcd3$var$D = (t)=>{
    let { theme: n, type: o, isLoading: s, ...a } = t;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...a
    });
}, $ad26fe773541dcd3$export$4f13f83fd8bb1dac = {
    info: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
}, $ad26fe773541dcd3$var$R = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i, playToast: c } = $ad26fe773541dcd3$export$a407b657d3044108(n), { closeButton: d, children: p, autoClose: m, onClick: f, type: g, hideProgressBar: y, closeToast: v, transition: h, position: T, className: E, style: b, bodyClassName: I, bodyStyle: _, progressClassName: C, progressStyle: L, updateId: w, role: k, progress: P, rtl: M, toastId: x, deleteToast: A, isIn: B, isLoading: O, closeOnClick: D, theme: R } = n, S = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${R}`, `Toastify__toast--${g}`, {
        "Toastify__toast--rtl": M
    }, {
        "Toastify__toast--close-on-click": D
    }), H = $ad26fe773541dcd3$var$u(E) ? E({
        rtl: M,
        position: T,
        type: g,
        defaultClassName: S
    }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(S, E), F = function(e) {
        let { theme: n, type: o, isLoading: s, icon: r } = e, i = null;
        const l = {
            theme: n,
            type: o
        };
        return !1 === r || ($ad26fe773541dcd3$var$u(r) ? i = r({
            ...l,
            isLoading: s
        }) : (0, $acw62.isValidElement)(r) ? i = (0, $acw62.cloneElement)(r, l) : s ? i = $ad26fe773541dcd3$export$4f13f83fd8bb1dac.spinner() : ((e)=>e in $ad26fe773541dcd3$export$4f13f83fd8bb1dac)(o) && (i = $ad26fe773541dcd3$export$4f13f83fd8bb1dac[o](l))), i;
    }(n), X = !!P || !m, Y = {
        closeToast: v,
        type: g,
        theme: R
    };
    let q = null;
    return !1 === d || (q = $ad26fe773541dcd3$var$u(d) ? d(Y) : (0, $acw62.isValidElement)(d) ? (0, $acw62.cloneElement)(d, Y) : function(t) {
        let { closeToast: n, theme: o, ariaLabel: s = "close" } = t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            className: `Toastify__close-button Toastify__close-button--${o}`,
            type: "button",
            onClick: (e)=>{
                e.stopPropagation(), n(e);
            },
            "aria-label": s
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 14 16"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            fillRule: "evenodd",
            d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
        })));
    }(Y)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(h, {
        isIn: B,
        done: A,
        position: T,
        preventExitTransition: s,
        nodeRef: r,
        playToast: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: x,
        onClick: f,
        "data-in": B,
        className: H,
        ...i,
        style: b,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...B && {
            role: k
        },
        className: $ad26fe773541dcd3$var$u(I) ? I({
            type: g
        }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-body", I),
        style: _
    }, null != F && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !O
        })
    }, F), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, p)), q, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$$, {
        ...w && !X ? {
            key: `pb-${w}`
        } : {},
        rtl: M,
        theme: R,
        delay: m,
        isRunning: o,
        isIn: B,
        closeToast: v,
        hide: y,
        type: g,
        style: L,
        className: C,
        controlledProgress: X,
        progress: P || 0
    })));
}, $ad26fe773541dcd3$var$S = function(e, t) {
    return void 0 === t && (t = !1), {
        enter: `Toastify--animate Toastify__${e}-enter`,
        exit: `Toastify--animate Toastify__${e}-exit`,
        appendPosition: t
    };
}, $ad26fe773541dcd3$export$d20e79fdc3899e95 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$S("bounce", !0)), $ad26fe773541dcd3$export$d8dc01b5c85a37b9 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$S("slide", !0)), $ad26fe773541dcd3$export$65cfd44a2050f99 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$S("zoom")), $ad26fe773541dcd3$export$4d2fae537bd90431 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$S("flip")), $ad26fe773541dcd3$var$q = {
    position: "top-right",
    transition: $ad26fe773541dcd3$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
function $ad26fe773541dcd3$export$f2815235e76a62b9(t) {
    let o = {
        ...$ad26fe773541dcd3$var$q,
        ...t
    };
    const s = t.stacked, [a, r] = (0, $acw62.useState)(!0), c = (0, $acw62.useRef)(null), { getToastToRender: d, isToastActive: m, count: f } = $ad26fe773541dcd3$export$b262e13ca2dd2381(o), { className: g, style: y, rtl: v, containerId: h } = o;
    function T(e) {
        const t = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${e}`, {
            "Toastify__toast-container--rtl": v
        });
        return $ad26fe773541dcd3$var$u(g) ? g({
            position: e,
            rtl: v,
            defaultClassName: t
        }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(t, $ad26fe773541dcd3$var$p(g));
    }
    function E() {
        s && (r(!0), $ad26fe773541dcd3$export$b410431fab84fa58.play());
    }
    return $ad26fe773541dcd3$var$O(()=>{
        if (s) {
            var e;
            const t = c.current.querySelectorAll('[data-in="true"]'), n = 12, s = null == (e = o.position) ? void 0 : e.includes("top");
            let r = 0, i = 0;
            Array.from(t).reverse().forEach((e, t)=>{
                const o = e;
                o.classList.add("Toastify__toast--stacked"), t > 0 && (o.dataset.collapsed = `${a}`), o.dataset.pos || (o.dataset.pos = s ? "top" : "bot");
                const l = r * (a ? .2 : 1) + (a ? 0 : n * t);
                o.style.setProperty("--y", `${s ? l : -1 * l}px`), o.style.setProperty("--g", `${n}`), o.style.setProperty("--s", "" + (1 - (a ? i : 0))), r += o.offsetHeight, i += .025;
            });
        }
    }, [
        a,
        f,
        s
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: c,
        className: "Toastify",
        id: h,
        onMouseEnter: ()=>{
            s && (r(!1), $ad26fe773541dcd3$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E
    }, d((t, n)=>{
        const o = n.length ? {
            ...y
        } : {
            ...y,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: T(t),
            style: o,
            key: `container-${t}`
        }, n.map((t)=>{
            let { content: n, props: o } = t;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$R, {
                ...o,
                stacked: s,
                collapseAll: E,
                isIn: m(o.toastId, o.containerId),
                style: o.style,
                key: `toast-${o.key}`
            }, n);
        }));
    }));
}



var $05e1a2fa90190dfd$exports = {};
$05e1a2fa90190dfd$exports = new URL("homeButton.398fe35a.png", import.meta.url).toString();


var $1e874b509a8fd72b$exports = {};
$1e874b509a8fd72b$exports = new URL("cancelButton.8f7500f1.png", import.meta.url).toString();


var $2968ead58e3d80b4$exports = {};
$2968ead58e3d80b4$exports = new URL("dollarButton.e9055d96.png", import.meta.url).toString();


const $3892ae1ab7b9e0c2$var$BookCustomEvents = ()=>{
    const [isCanceled, setIsCanceled] = (0, $acw62.useState)(false);
    const leaveEvent = async ()=>{
        const isStarted = await (0, $87f8fa8903809305$export$2e2bcd8739ae039)();
        // const isStarted = true;
        if (isStarted) {
            setIsCanceled(true);
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).success("You left the event, redirecting to homepage");
        } else {
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Failed to leave the event");
            setIsCanceled(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "cardPage",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad26fe773541dcd3$export$f2815235e76a62b9), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "cardHeadline",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "cardHeadlinHeadingRed",
                        children: "Checkout Our Live Events"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "cardHeadlinDescription",
                        children: "What are you waiting for? Discover Lifechanging Events..."
                    })
                ]
            }),
            isCanceled ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "youtubeVideoContainer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                    width: "980",
                    height: "430",
                    src: "https://www.youtube.com/embed/4KLNw7OUTSk?si=FilB5NnTMf-mqu5a",
                    title: "YouTube video player",
                    frameborder: "0",
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                    allowfullscreen: true
                })
            }),
            isCanceled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: "custom-btn btn-16 marginForEventPageButton buttonContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "joinEvent",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($05e1a2fa90190dfd$exports))),
                        alt: "Home"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "Return to Home"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "buttonContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "custom-btn btn-16 marginForEventPageButton buttonContainer",
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "joinEvent",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($2968ead58e3d80b4$exports))),
                                alt: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://console.superfluid.finance/mumbai/supertokens/0x5d8b4c2554aeb7e86f387b4d6c00ac33499ed01f?tab=streams",
                                        target: "_blank",
                                        children: "Live Money Stream"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "joinEvent",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($2968ead58e3d80b4$exports))),
                                alt: "Cancel"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "custom-btn btn-16 marginForEventPageButton buttonContainer",
                        type: "button",
                        onClick: leaveEvent,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "joinEvent",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($1e874b509a8fd72b$exports))),
                                alt: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "Cancel Streaming"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "joinEvent",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($1e874b509a8fd72b$exports))),
                                alt: "Cancel"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c5ff20eebfb368bf$export$2e2bcd8739ae039), {})
        ]
    });
};
var $3892ae1ab7b9e0c2$export$2e2bcd8739ae039 = $3892ae1ab7b9e0c2$var$BookCustomEvents;


const $e65c9e6d71c3bc23$var$BookTickets = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "containerSection",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b15df6adfa52e3f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3892ae1ab7b9e0c2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0057e53b8130a065$export$2e2bcd8739ae039), {})
        ]
    });
};
var $e65c9e6d71c3bc23$export$2e2bcd8739ae039 = $e65c9e6d71c3bc23$var$BookTickets;



parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");


let $57cda08b0812fd03$var$account;
async function $57cda08b0812fd03$export$2e2bcd8739ae039() {
    const provider = new (0, $6c57cc56acea9c6c$exports).providers.Web3Provider(window.ethereum);
    await provider.send("eth_requestAccounts", []);
    const signer = provider.getSigner();
    const chainId = await window.ethereum.request({
        method: "eth_chainId"
    });
    const sf = await (0, $ad9ef6f4a144bd14$export$2e2bcd8739ae039).create({
        chainId: Number(chainId),
        provider: provider
    });
    const superSigner = sf.createSigner({
        signer: signer
    });
    // console.log(signer);
    // console.log(await superSigner.getAddress());
    const daix = await sf.loadSuperToken("fDAIx");
    // console.log(daix);
    try {
        const createFlowOperation = daix.createFlow({
            sender: await superSigner.getAddress(),
            receiver: "0x03905E154e6F499F99DDa452502aDfbC4842aD4F",
            flowRate: 10000
        });
        // console.log(createFlowOperation);
        // console.log("Creating your stream...");
        const result = await createFlowOperation.exec(superSigner);
        // console.log(result);
        // console.log(`Congrats - you've just created a money stream!`);
        let sender = await superSigner.getAddress();
        // let gasReceiver = "0x03905E154e6F499F99DDa452502aDfbC4842aD4F";
        // console.log(`https://console.superfluid.finance/mumbai/streams/${sender}-${gasReceiver}-0x5d8b4c2554aeb7e86f387b4d6c00ac33499ed01f-8.0`);
        // console.log(`https://console.superfluid.finance/goerli/accounts/${sender}?tab=tokens`)
        // console.log(`https://console.superfluid.finance/goerli/accounts/${sender}?tab=tokens`)
        return true;
    } catch (error) {
        // console.log(
        //   "Hmmm, your transaction threw an error. Make sure that this stream does not already exist, and that you've entered a valid Ethereum address!"
        // );
        console.error(error);
        return false;
    }
} // export const CreateFlow = () => {
 //   const [recipient, setRecipient] = useState("");
 //   const [isButtonLoading, setIsButtonLoading] = useState(false);
 //   const [flowRate, setFlowRate] = useState("");
 //   const [flowRateDisplay, setFlowRateDisplay] = useState("");
 //   const [currentAccount, setCurrentAccount] = useState("");
 //   const connectWallet = async () => {
 //     try {
 //       const { ethereum } = window;
 //       if (!ethereum) {
 //         alert("Get MetaMask!");
 //         return;
 //       }
 //       const accounts = await ethereum.request({
 //         method: "eth_requestAccounts"
 //       });
 //       console.log("Connected", accounts[0]);
 //       setCurrentAccount(accounts[0]);
 //       account = currentAccount;
 //       // Setup listener! This is for the case where a user comes to our site
 //       // and connected their wallet for the first time.
 //       // setupEventListener()
 //     } catch (error) {
 //       console.log(error);
 //     }
 //   };
 //   const checkIfWalletIsConnected = async () => {
 //     console.log("runs");
 //     const { ethereum } = window;
 //     if (!ethereum) {
 //       console.log("Make sure you have metamask!");
 //       return;
 //     } else {
 //       console.log("We have the ethereum object", ethereum);
 //     }
 //     const accounts = await window.ethereum.request({ method: "eth_accounts" });
 //     const chain = await window.ethereum.request({ method: "eth_chainId" });
 //     let chainId = chain;
 //     console.log("chain ID:", chain);
 //     console.log("global Chain Id:", chainId);
 //     if (accounts.length !== 0) {
 //       account = accounts[0];
 //       console.log("Found an authorized account:", account);
 //       setCurrentAccount(account);
 //       // Setup listener! This is for the case where a user comes to our site
 //       // and ALREADY had their wallet connected + authorized.
 //       // setupEventListener()
 //     } else {
 //       console.log("No authorized account found");
 //     }
 //   };
 //   useEffect(() => {
 //     checkIfWalletIsConnected();
 //   }, []);
 //   function calculateFlowRate(amount) {
 //     if (typeof Number(amount) !== "number" || isNaN(Number(amount)) === true) {
 //       alert("You can only calculate a flowRate based on a number");
 //       return;
 //     } else if (typeof Number(amount) === "number") {
 //       if (Number(amount) === 0) {
 //         return 0;
 //       }
 //       const amountInWei = ethers.BigNumber.from(amount);
 //       const monthlyAmount = ethers.utils.formatEther(amountInWei.toString());
 //       const calculatedFlowRate = monthlyAmount * 3600 * 24 * 30;
 //       return calculatedFlowRate;
 //     }
 //   }
 //   function CreateButton({ isLoading, children, ...props }) {
 //     return (
 //       <Button variant="success" className="button" {...props}>
 //         {isButtonLoading ? <Spinner animation="border" /> : children}
 //       </Button>
 //     );
 //   }
 //   const handleRecipientChange = (e) => {
 //     setRecipient(() => ([e.target.name] = e.target.value));
 //   };
 //   const handleFlowRateChange = (e) => {
 //     setFlowRate(() => ([e.target.name] = e.target.value));
 //     let newFlowRateDisplay = calculateFlowRate(e.target.value);
 //     setFlowRateDisplay(newFlowRateDisplay.toString());
 //   };
 //   return (
 //     <div>
 //       <h2>Create a Flow</h2>
 //       {currentAccount === "" ? (
 //         <button id="connectWallet" className="button" onClick={connectWallet}>
 //           Connect Wallet
 //         </button>
 //       ) : (
 //         <Card className="connectedWallet">
 //           {`${currentAccount.substring(0, 4)}...${currentAccount.substring(
 //             38
 //           )}`}
 //         </Card>
 //       )}
 //       <Form>
 //         <FormGroup className="mb-3">
 //           <FormControl
 //             name="flowRate"
 //             value={flowRate}
 //             onChange={handleFlowRateChange}
 //             placeholder="Enter a flowRate in wei/second"
 //           ></FormControl>
 //         </FormGroup>
 //         <CreateButton
 //           onClick={() => {
 //             setIsButtonLoading(true);
 //             createNewFlow(recipient, flowRate);
 //             setTimeout(() => {
 //               setIsButtonLoading(false);
 //             }, 1000);
 //           }}
 //         >
 //           Click to Create Your Stream
 //         </CreateButton>
 //       </Form>
 //       <div className="description">
 //         <p>
 //           Go to the CreateFlow.js component and look at the <b>createFlow() </b>
 //           function to see under the hood
 //         </p>
 //         <div className="calculation">
 //           <p>Your flow will be equal to:</p>
 //           <p>
 //             <b>${flowRateDisplay !== " " ? flowRateDisplay : 0}</b> DAIx/month
 //           </p>
 //         </div>
 //       </div>
 //     </div>
 //   );
 // };





var $fda7b807d087d6fd$exports = {};
$fda7b807d087d6fd$exports = new URL("joinEventPng.33507170.png", import.meta.url).toString();


const $97e9528facd45826$var$SingleCompanyCard = ()=>{
    const [isConnected, setIsConnected] = (0, $acw62.useState)(false);
    const [isJoined, setIsJoined] = (0, $acw62.useState)(false);
    const connect = async ()=>{
        const connected = await (0, $c0d5958e866e71f2$export$2e2bcd8739ae039)();
        if (connected) setIsConnected(true);
        else setIsConnected(false);
    };
    const joinEvent = async ()=>{
        const isStarted = await (0, $57cda08b0812fd03$export$2e2bcd8739ae039)();
        // const isStarted = true;
        if (isStarted) {
            setIsJoined(true);
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).success("Registration Successful, Money Is Streaming!");
        } else {
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Failed to join the event");
            setIsJoined(false);
        }
    };
    const { imageUrl: imageUrl, companyName: companyName, country: country, date: date, description: description, location: location, name: name, price: price } = (0, $dde09506a3a71a1f$export$ea86d35eea1f7f37)[0].eventInfo;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "singleCompanyCardContainer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad26fe773541dcd3$export$f2815235e76a62b9), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "card-custom singleCompanyCard",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "cardImg",
                        src: imageUrl,
                        alt: "Image Event Page"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                        children: [
                            name,
                            " by ",
                            companyName
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "cardFeaturedSection",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    date,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    price,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    country,
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: description
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: location
                    }),
                    isConnected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "metamaskButtonContainer",
                        children: [
                            isJoined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/booktickets",
                                className: "homeButton",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "custom-btn btn-16 buttonContainer",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            className: "joinEvent",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fda7b807d087d6fd$exports))),
                                            alt: "Join now! Event is live"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Enter Into Event"
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "custom-btn btn-16",
                                onClick: joinEvent,
                                children: "Book Your Pass"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: "custom-btn btn-16 buttonContainer",
                                disable: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "OnlineImg",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($659a64d34e2c75cc$exports))),
                                        alt: "Successful, walled connected"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Wallet Connected"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "custom-btn btn-16",
                        onClick: connect,
                        children: "Connect Wallet"
                    })
                ]
            }),
            isConnected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "card-custom singleCompanyCardCenter",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "cardFeaturedSection",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        date,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        price,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        country,
                                        " "
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                            children: [
                                "Register For the Event ",
                                name
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                className: "form",
                                onSubmit: (e)=>Submit(e),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "Your Name",
                                        name: "Name",
                                        type: "text"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "Your Email",
                                        name: "Email",
                                        type: "text"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "+91 XXXXXXXXXX",
                                        name: "Phone",
                                        type: "text"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "Need Help",
                                        name: "Subject",
                                        type: "text"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        placeholder: "Your Message",
                                        name: "Message",
                                        type: "text"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        name: "Name",
                                        type: "submit",
                                        value: "Book Your Pass"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }) : null
        ]
    });
};
var $97e9528facd45826$export$2e2bcd8739ae039 = $97e9528facd45826$var$SingleCompanyCard;



const $10fb487340a2c2fa$var$Events = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "containerSection",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b15df6adfa52e3f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $97e9528facd45826$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0057e53b8130a065$export$2e2bcd8739ae039), {})
        ]
    });
};
var $10fb487340a2c2fa$export$2e2bcd8739ae039 = $10fb487340a2c2fa$var$Events;


const $dad545c909cfec2d$var$router = (0, $040dbb9c344a508d$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed3c4341f3b46b4a$export$2e2bcd8739ae039), {})
    },
    {
        path: "registerevent",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41c30f296cc10f61$export$2e2bcd8739ae039), {})
    },
    {
        path: "events",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68cb735bcddac8f5$export$2e2bcd8739ae039), {})
    },
    {
        path: "booktickets",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e65c9e6d71c3bc23$export$2e2bcd8739ae039), {})
    },
    {
        path: "register",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10fb487340a2c2fa$export$2e2bcd8739ae039), {})
    }
]);
const $dad545c909cfec2d$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById("root"));
$dad545c909cfec2d$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$323e4fc2fa4753fb), {
    router: $dad545c909cfec2d$var$router
}));


//# sourceMappingURL=index.3b61dc6d.js.map
